(function() {
  'use strict';

  var app = angular.module('eventmap', [
    'ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',

    'LocalStorageModule',

    'monospaced.qrcode',
    'chart.js',

    'ui.router',
    'ui.bootstrap',
    'ui.mask',
    'ui.select',

    'textAngular',

    'ui-notification',

    'slickCarousel',

    'validation.match',
    'color.picker',

    'ui.ace',
    'pascalprecht.translate'
  ]);

  var $injector = angular.injector(['ng']);
  var $q = $injector.get('$q');
  var $http = $injector.get('$http');

  var API_CONFIG = '../api-config.json';

  fetchApiConfig()
    .then(function(resolve){
      var API_PATH = resolve.API_PATH;
      var APP_PATH = resolve.APP_PATH;
      var APP_MANAGER = resolve.APP_MANAGER;
      var APP_TYPE = resolve.APP_TYPE;

      var hostname = window.location.hostname;
      var query = parseInt(getParameterByName('event_id'));

      if ( query ) {
        getEventById(API_PATH, query)
          .then(
            function(response) {
              var data = response.data;
              if ( data.length !== 0 ) {
                bootstraping(API_PATH, APP_PATH, APP_MANAGER, APP_TYPE, data);
              } else {
                setTimeout(function(){
                  redirectToManagerURL(APP_MANAGER);
                }, 500);
              }
            }
          );
      } else {
        getEventByDomain(API_PATH, hostname)
          .then(
            function(response) {
              var data = response.data;
              if ( data.length !== 0 ) {
                bootstraping(API_PATH, APP_PATH, APP_MANAGER, APP_TYPE, data[0]);
              } else {
                setTimeout(function(){
                  redirectToManagerURL(APP_MANAGER);
                }, 500);
              }
            }
          );
      }
    })
    .catch(function(){
      appendEventNotFound('File "{ api-config.json }" not found');
    });

  function fetchApiConfig() {
    var defer = $q.defer();
    $http.get(API_CONFIG)
      .success(function(data){
        defer.resolve(data);
      })
      .error(function(data, status){
        defer.reject(status);
      });
    return defer.promise;
  }

  function getEventById(API, id) {
    return $http.get(API + '/events/' + id);
  }

  function getEventByDomain(API, domain) {
    var params = { domain: domain, status: 'draft,published' };
    var req = {
      url: API + '/events',
      method: 'GET',
      params: params
    };
    var currentTime = new Date().getTime();
    var token = localStorage.getItem('auth_token');
    var expiresTime = localStorage.getItem('auth_expires_in');
    if ( token && currentTime < expiresTime ) {
      req['headers'] = {
          'X-Auth-Token': localStorage.getItem('auth_token')
      }
    }
    return $http(req);
  }

  function bootstraping(API, APP, MANAGER, TYPE, event) {
    var preferences = event.preferences;

    var metaTags = preferences.metaTags;
    var participantModule = preferences.participantModule || {};
    var vendorModule = preferences.vendorModule || {};
    var volunteerModule = preferences.volunteerModule || {};
    var sponsorModule = preferences.sponsorModule || {};
    var scheduleModule = preferences.scheduleModule || {};
    var homePageButtonsModule = preferences.homePageButtonsModule || {};

    event.preferences = {
      // Home page buttons
      homePageButtonsModule: {
        enableEventMap: typeof homePageButtonsModule.enableEventMap !== 'undefined' ? homePageButtonsModule.enableEventMap : true,
        labelEventMap: typeof homePageButtonsModule.labelEventMap !== 'undefined' ? homePageButtonsModule.labelEventMap : 'Event map',
        labelSchedule: typeof homePageButtonsModule.labelSchedule !== 'undefined' ? homePageButtonsModule.labelSchedule : 'Schedule',
        labelDonate: typeof homePageButtonsModule.labelDonate !== 'undefined' ? homePageButtonsModule.labelDonate : 'Donation',
        labelVendorEvent: typeof homePageButtonsModule.labelVendorEvent !== 'undefined' ? homePageButtonsModule.labelVendorEvent : 'Event vendor',
      },
      grayscaleBooths: typeof preferences.grayscaleBooths !== 'undefined' ? preferences.grayscaleBooths : false,
      // Schedule module
      scheduleModule: {
        enabled: typeof scheduleModule.enabled !== 'undefined' ? scheduleModule.enabled : true,
        groupByLocation: typeof scheduleModule.groupByLocation !== 'undefined' ? scheduleModule.groupByLocation : true
      },
      // Meta tags
      metaTags: {
        title: (metaTags && metaTags.title || ''),
        description: (metaTags && metaTags.description || ''),
        keywords: (metaTags && metaTags.keywords || ''),
        searchEnginePrivacy: (metaTags && metaTags.searchEnginePrivacy || false)
      },
      // Vendor modules
      vendorModule: {
        label: (vendorModule && vendorModule.label || 'Vendors'),
        enableRegister: (vendorModule && typeof vendorModule.enableRegister !== 'undefined' ? vendorModule.enableRegister : true),
        button: (vendorModule && vendorModule.button || false),
        buttonLabel: (vendorModule && vendorModule.buttonLabel || 'Event vendors'),
        requestDescriptionRequired: (vendorModule && vendorModule.requestDescriptionRequired || false),
        requestImageRequired: typeof vendorModule.requestImageRequired !== 'undefined' ? vendorModule.requestImageRequired : true,
        requestFeaturedItemsRequired: (vendorModule && vendorModule.requestFeaturedItemsRequired || false),
        enableUserTypeSchedule: typeof vendorModule.enableUserTypeSchedule !== 'undefined' ? vendorModule.enableUserTypeSchedule : false,
      },
      // Volunteer modules
      volunteerModule: {
        label: (volunteerModule && volunteerModule.label || 'Volunteers'),
        enableRegister: (volunteerModule && typeof volunteerModule.enableRegister !== 'undefined' ? volunteerModule.enableRegister : true),
        instruction: ( volunteerModule && volunteerModule.instruction ? volunteerModule.instruction : '' ),
        enableUserTypeSchedule: typeof volunteerModule.enableUserTypeSchedule !== 'undefined' ? volunteerModule.enableUserTypeSchedule : false,
      },
      // Participant module
      participantModule: {
        enableRegister: (participantModule && participantModule.enableRegister || false),
        scavengerHunt: typeof participantModule.scavengerHunt !== 'undefined' ? participantModule.scavengerHunt : false,
        hideEventMap: typeof participantModule.hideEventMap !== 'undefined' ? participantModule.hideEventMap : false,
        label: (participantModule && participantModule.label || 'Participants'),
        cashPayment: (participantModule && participantModule.cashPayment || false),
        cardPayment: (participantModule && participantModule.cardPayment || false),
        waiverEnabled: (participantModule && participantModule.waiverEnabled || false),
        enableUserTypeSchedule: typeof participantModule.enableUserTypeSchedule !== 'undefined' ? participantModule.enableUserTypeSchedule : false,
        buttonLabelPayCash: (participantModule && participantModule.buttonLabelPayCash ? participantModule.buttonLabelPayCash : 'Pay cash/check'),
        buttonLabelPayCard: (participantModule && participantModule.buttonLabelPayCard ? participantModule.buttonLabelPayCard : 'Pay credit card')
      },
      // Sponsor module
      sponsorModule: {
        enableRegister: (sponsorModule && sponsorModule.enableRegister || false),
        label: (sponsorModule && sponsorModule.label || 'Sponsors'),
        primaryLabel: (sponsorModule && sponsorModule.primaryLabel || 'Headline sponsors'),
        secondaryLabel: (sponsorModule && sponsorModule.secondaryLabel || 'Secondary sponsors'),
        cashPayment: (sponsorModule && sponsorModule.cashPayment || false),
        cardPayment: (sponsorModule && sponsorModule.cardPayment || false),
        enableUserTypeSchedule: typeof sponsorModule.enableUserTypeSchedule !== 'undefined' ? sponsorModule.enableUserTypeSchedule : false,
        buttonLabelPayCash: (sponsorModule && sponsorModule.buttonLabelPayCash ? sponsorModule.buttonLabelPayCash : 'Pay cash/check'),
        buttonLabelPayCard: (sponsorModule && sponsorModule.buttonLabelPayCard ? sponsorModule.buttonLabelPayCard : 'Pay credit card')
      },
      showCustomHomePage: preferences && typeof preferences.showCustomHomePage !== 'undefined' ? preferences.showCustomHomePage : false,
      showEventStartEndDate: preferences && typeof preferences.showEventStartEndDate !== 'undefined' ? preferences.showEventStartEndDate : true,
      // Style/Script fields
      descriptionStyles: preferences && preferences.descriptionStyles ? preferences.descriptionStyles : '',
      descriptionScripts: preferences && preferences.descriptionScripts ? preferences.descriptionScripts : '',
      // Scheme
      colorScheme: preferences && preferences.colorScheme ? preferences.colorScheme : { id: 1, name: 'kumquat', hexCode: '#B25500' },
      logo: {
        id: ( preferences && preferences.logo && preferences.logo.id ? preferences.logo.id : '' ),
        link: ( preferences && preferences.logo && preferences.logo.link ? preferences.logo.link : '' )
      },
      favicon: {
        id: ( preferences && preferences.favicon && preferences.favicon.id ? preferences.favicon.id : '' ),
        link: ( preferences && preferences.favicon && preferences.favicon.link ? preferences.favicon.link : '' )
      },
      backgroundImage: {
        id: ( preferences && preferences.backgroundImage && preferences.backgroundImage.id ? preferences.backgroundImage.id : '' ),
        link: ( preferences && preferences.backgroundImage && preferences.backgroundImage.link ? preferences.backgroundImage.link : '' )
      },
      confirmationDocument: confirmationDocument(preferences),
      customDomain: preferences && preferences.customDomain,

      countdownClock: ( preferences && preferences.countdownClock ? preferences.countdownClock : false ),
      disableTextEditorSanitize: ( preferences && preferences.disableTextEditorSanitize ? preferences.disableTextEditorSanitize : false ),
      enableReservationAvailability: ( preferences && preferences.enableReservationAvailability ? preferences.enableReservationAvailability : false ),
      enableDonations: ( preferences && preferences.enableDonations ? preferences.enableDonations : false ),

      itemsPerPage: ( preferences && preferences.itemsPerPage ? preferences.itemsPerPage : 5 ),

      measurementSystem: ( preferences && preferences.measurementSystem ? preferences.measurementSystem : 'imperial' ),
      eventBoxSize: ( preferences && preferences.eventBoxSize ? preferences.eventBoxSize : 'sm' )
    }

    var head = document.head || document.getElementsByTagName('head')[0];

    if ( preferences.disableTextEditorSanitize ){
      if ( preferences.descriptionStyles !== '' ){
        var style = document.createElement('style');
        style.type = 'text/css';
        if ( style.styleSheet ){
          style.styleSheet.cssText = preferences.descriptionStyles;
        } else {
          style.appendChild(document.createTextNode(preferences.descriptionStyles))
        }
        head.appendChild(style);
      }
      if ( preferences.descriptionScripts !== '' ){
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.text = preferences.descriptionScripts;
        head.appendChild(script);
      }
    }

    var metaTags = preferences.metaTags;

    var metaTitle = document.createElement('meta');
    metaTitle.name = 'title';
    metaTitle.content = metaTags && metaTags.title ? metaTags.title : '';
    var metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = metaTags && metaTags.description ? metaTags.description : '';
    var metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    metaKeywords.content = metaTags && metaTags.keywords ? metaTags.keywords : '';

    head.appendChild(metaTitle);
    head.appendChild(metaDescription);
    head.appendChild(metaKeywords);

    var countryPhones = [
      { value: 'US', code: '+1', label: 'US +1', pattern: '## ###-###-####' }
    ];

    if ( TYPE === 'QA' ){
      countryPhones.push({
        value: 'UA', code: '+38', label: 'UA +38', pattern: '### ###-###-####'
      });
    }

    app.value('CurrentEvent', event);
    app
      .constant('API_PATH', API)
      .constant('APP_PATH', APP)
      .constant('APP_MANAGER', MANAGER)
      .constant('EVENT_STATUS', event.status)
      .constant('EVENT_ID', event.id)
      .constant('TEXT_EDITOR_SANITIZE', event.preferences.disableTextEditorSanitize)
      .constant('COUNTRY_PHONES', countryPhones)

    angular.element(document).ready(function(){
      angular.bootstrap(document, ['eventmap']);
    });
  }

  function confirmationDocument(pref){
    if ( pref && pref.confirmationDocument === null ) {
      return null;
    } else if ( pref && pref.confirmationDocument ) {
      return {
        id: pref.confirmationDocument.id,
        link: pref.confirmationDocument.link
      }
    }
  }

  function appendEventNotFound(msg) {
    var body = document.body;
    var wrapper = document.createElement('div');
    wrapper.className = 'wrapper-not-found';

    var container = document.createElement('div');
    container.className = 'container';

    var area = document.createElement('div');
    area.className = 'area area-not-found';

    var content = document.createElement('div');
    content.className = 'area-content';

    var subtitle = document.createElement('h3');
    subtitle.className = 'area-subtitle';
    subtitle.innerText = msg;
    content.appendChild(subtitle);

    area.appendChild(content);
    container.appendChild(area);
    wrapper.appendChild(container);

    body.appendChild(wrapper);
  }

  function redirectToManagerURL(url) {
    var ff = navigator.userAgent.search('Firefox');
    if ( ff > -1 ) {
      window.location.assign(url);
    } else {
      var meta = document.createElement('meta');
      meta.httpEquiv = 'refresh';
      meta.content = '0; URL='+ url;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('BoothAssignmentsCtrl', BoothAssignmentsCtrl);
  
  BoothAssignmentsCtrl.$inject = ['$scope', 'moment', '$uibModalInstance', 'user'];


  function BoothAssignmentsCtrl($scope, moment, $uibModalInstance, user){
    var vm = this;

    $scope.user = angular.copy(user);
    $scope.assignment = {};

    $scope.showNotes = user.request.volunteer ? false : true;

    angular.extend($scope, {
      onInit: function(){
        $scope.assignment['notes'] = user.notes || '';
        if ( user.from && user.to ){
          $scope.assignment['startDate'] = moment(moment.utc($scope.user.from)).local().toDate();
          $scope.assignment['startTime'] = moment(moment.utc($scope.user.from)).local();
          $scope.assignment['endDate'] = moment(moment.utc($scope.user.to)).local().toDate();
          $scope.assignment['endTime'] = moment(moment.utc($scope.user.to)).local();
        }
        if ( user.request ){
          $scope.assignment['user'] = user.request.volunteer ? user.request.volunteer : user.request.user;
        } else {
          $scope.assignment['user'] = user.user;
        }

      },
      onSave: function(){
        if (
          $scope.assignment.startDate && $scope.assignment.endDate &&
          $scope.assignment.startTime && $scope.assignment.endTime
        ) {
          var from = moment($scope.assignment.startDate).set({
            hour: moment($scope.assignment.startTime).hour(),
            minute: moment($scope.assignment.startTime).minute()
          }).local();
          var to = moment($scope.assignment.endDate).set({
            hour: moment($scope.assignment.endTime).hour(),
            minute: moment($scope.assignment.endTime).minute()
          }).local();

          $scope.user['from'] = from;
          $scope.user['to'] = to;
        }
        if ( $scope.showNotes ){
          $scope.user['notes'] = $scope.assignment.notes;
        }
        $uibModalInstance.close($scope.user);
      },
      onCancel: function(){
        $uibModalInstance.dismiss('cancel');
      }
    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerVolunteerFormLogController', OrganizerVolunteerFormLogController);
  
  OrganizerVolunteerFormLogController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModalInstance',
    'Notification',
    'ActivityLogService',
    'VolunteerService',
    'resolveLog',
    'resolveAcceptedRequest',
    'resolveRequired'
  ];

  function OrganizerVolunteerFormLogController(
    $rootScope,
    $scope,
    $uibModalInstance,
    Notification,
    ActivityLogService,
    VolunteerService,
    resolveLog,
    resolveAcceptedRequest,
    resolveRequired
  ){
    var vm = this;
    $scope.resolveRequired = resolveRequired;
    $scope.resolveAcceptedRequest = resolveAcceptedRequest;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    $scope.isEndDateRequired = true;
    $scope.modalLabel = resolveLog && resolveLog.id ? 'Update log' : 'Create log';
    // $scope.modalLoading = true;
    $scope.log = {
      // volunteerRequest: resolveAcceptedRequest ? resolveAcceptedRequest : null,
    };
    $scope.resolveLog = resolveLog || {
      volunteerRequest: null,
      start: null,
      end: null,
      comment: ''
    };

    $scope.checkInDateIsGreaterThanCheckOut = false;
    $scope.checkInTimeIsGreaterThanCheckOut = false;

    angular.extend($scope, {
      onInit: function(){
        if ( resolveLog && resolveLog.id ){
          var start = resolveLog.checkInDate ? resolveLog.checkInDate : resolveLog.start;
          var end;
          if ( resolveLog.checkOutDate ){
            end = resolveLog.checkOutDate;
          }
          if ( resolveLog.end ){
            end = resolveLog.end;
          }

          $scope.log['checkInDate'] = moment(moment.utc(start)).local().toDate();
          $scope.log['checkInTime'] = moment(moment.utc(start)).local();

          if ( end ){
            $scope.log['checkOutDate'] = moment(moment.utc(end)).local().toDate();
            $scope.log['checkOutTime'] = moment(moment.utc(end)).local();
          }
        } else {
          if ( !resolveAcceptedRequest ){
            VolunteerService.getRequestByStatus('accepted')
              .then(function(response){
                $scope.volunteerRequests = response.data;
              })
              .catch(function(err){
                console.log(err);
              })
          }
        }
      },
      handleSubmit: function(){
        $scope.formSubmitted = true;
        var form = $scope.form;

        if ( form.$valid && !$scope.isDisabled() ){
          $scope.formLoading = true;

          $scope.resolveLog.start = moment($scope.log.checkInDate).set({
            hour: moment($scope.log.checkInTime).hour(),
            minute: moment($scope.log.checkInTime).minute()
          }).local();

          if ( $scope.log.checkOutDate && $scope.log.checkOutTime ){
            $scope.resolveLog.end = moment($scope.log.checkOutDate).set({
              hour: moment($scope.log.checkOutTime).hour(),
              minute: moment($scope.log.checkOutTime).minute()
            }).local();
          } else {
            delete $scope.resolveLog['comment'];
          }

          if ( $scope.resolveLog && $scope.resolveLog.id ){
            ActivityLogService.update($scope.resolveLog)
              .then(function(response){
                // $scope.modalLoading = false;
                Notification.success('Activity log was updated');
                $uibModalInstance.close(response.data);
              })
              .catch(function(err){
                console.error(err);
                $scope.formLoading = false;
              })
          } else {
            if ( $scope.resolveAcceptedRequest ){
              $scope.resolveLog['requestId'] = $scope.resolveAcceptedRequest.id;
            } else {
              if ( $scope.log.volunteerRequest && $scope.log.volunteerRequest.id ){
                $scope.resolveLog['requestId'] = $scope.log.volunteerRequest.id;
              }
            }
            ActivityLogService.create($scope.resolveLog)
              .then(function(response){
                // $scope.modalLoading = false;
                Notification.success('Activity log was created');
                $uibModalInstance.close(response.data);
              })
              .catch(function(err){
                console.error(err);
                $scope.formLoading = false;
              });
          }

        }
      },
      handleCancel: function(){
        $uibModalInstance.dismiss('cancel');
      },
      isDisabled: function(){
        var result = false;
        if ( !$scope.checkInDateIsGreaterThanCheckOut ){
          result = false
        } else {
          return true;
        }
        if ( !$scope.checkInTimeIsGreaterThanCheckOut ){
          result = false;
        } else {
          return true;
        }
        return result;
      },

      checkCommentField: function(checkOutDate, checkOutTime){
        if ( $scope.resolveRequired ) return true;
        return checkOutDate && checkOutTime;
      }
    });



    // Date range
    angular.extend($scope, {
      datepickerFormat: 'MMMM dd, yyyy',
      checkInOutDateOptions: {
        dateDisabled: false,
        // minDate: new Date(),
        formatYear: 'yy',
        startingDay: 1
      },
      popup1: {
        opened: false
      },
      popup2: {
        opened: false
      },
      onPopup1Open: function(){
        $scope.popup1.opened = true;
      },
      onPopup2Open: function(){
        $scope.popup2.opened = true;
      }
    });

    $scope.handleCheckInOut = function(checkInDate, checkOutDate, checkInTime, checkOutTime){
      $scope.checkInDateIsGreaterThanCheckOut = false;
      $scope.checkInTimeIsGreaterThanCheckOut = false;

      if ( checkOutDate ){
        if ( moment(checkInDate).isAfter(checkOutDate) ){
          if ( !moment(checkInDate).isSame(checkOutDate, 'day') ){
            $scope.checkInDateIsGreaterThanCheckOut = true;
          }
        }

        var from = moment(checkInDate).set({
          hour: moment(checkInTime).hour(),
          minute: moment(checkInTime).minute()
        });
        var to = moment(checkOutDate).set({
          hour: moment(checkOutTime).hour(),
          minute: moment(checkOutTime).minute()
        });

        if ( !$scope.checkInDateIsGreaterThanCheckOut ){
          if ( !moment(from, 'h:mma').isBefore(to, 'h:mma') ){
            $scope.checkInTimeIsGreaterThanCheckOut = true;
          }
        }
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerScavengerHuntCheckinPointsFormCtrl', OrganizerScavengerHuntCheckinPointsFormCtrl);
  
  OrganizerScavengerHuntCheckinPointsFormCtrl.$inject = [
    '$scope',
    '$uibModalInstance',
    '$document',
    'ScavengerHuntService',
    'Notification',
    'point',
    'checkinPoints'
  ];
  
  function OrganizerScavengerHuntCheckinPointsFormCtrl(
    $scope,
    $uibModalInstance,
    $document,
    ScavengerHuntService,
    Notification,
    point,
    checkinPoints
  ) {
    var vm = this;
    $scope.point = {}

    var bounds = new google.maps.LatLngBounds();
    var map;
    var marker;

    angular.extend($scope, {
      onInit: function(){
        if ( !checkinPoints && point && point.id ){
          $scope.point = point;
        }

        $scope.buildMap($scope.point, function(){
          if ( navigator.geolocation ){
            navigator.geolocation.getCurrentPosition(
              function(position){
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
  
                if ((!point || !point.lat) && (!checkinPoints || ( checkinPoints && checkinPoints.length === 0 )) ){
                  map.setCenter({
                    lat: lat,
                    lng: lng
                  });
                }
              }, function(err){
                console.log(err);
              }
            )
          }
        });
      },

      buildMap: function(point, cb){
        var mapSelector = $document[0].getElementById('scavengerHuntMapForm');

        var lat = 27.942749279781406;
        var lng = -82.45903329675298;

        var p;
        var skipMarker = false;
        if ( checkinPoints && checkinPoints.length > 0 ){
          p = checkinPoints.reduce(function(prev, curr){
            return prev.order > curr.order ? prev : curr
          });
        }else if(point && point.lat && point.lng){
          p = point;
        }else{
          skipMarker = true;
        }

        var center = {
          lat: typeof p !== 'undefined' ? p.lat : $scope.lat ? $scope.lat : lat,
          lng: typeof p !== 'undefined' ? p.lng : $scope.lng ? $scope.lng : lng
        };

        map = new google.maps.Map(mapSelector, {
          zoom: 16,
          maxZoom: 20,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          clickableIcons: false,
          streetViewControl: false,
          fullscreenControl: false,
          center: center,
          gestureHandling: 'greedy',
          styles: [{
            featureType: 'poi',
            stylers: [
              { visibility: 'off' }
            ],
          },{
            featureType: 'transit',
            stylers: [
              { visibility: 'off' }
            ]
          }]
        });

        if(!skipMarker){
          $scope.buildMarker(new google.maps.LatLng(center.lat, center.lng));
        }

        map.addListener('click', function(evt){
          var latLng = new google.maps.LatLng(evt.latLng.lat(), evt.latLng.lng());
          $scope.buildMarker(latLng);
        });

        $scope.buildMapField(map);

        if ( cb ) cb();
      },

      buildMarker: function(latLng){
        if ( marker ){
          marker.setMap(null);
        }

        marker = new google.maps.Marker();
        marker.setPosition(latLng);
        marker.setMap(map);

        bounds = new google.maps.LatLngBounds();
        bounds.extend(latLng);

        $scope.setLatLng(latLng.lat(), latLng.lng());

        map.fitBounds(bounds);
      },
      
      buildMapField: function(map){
        var field = $document[0].getElementById('scavengerHuntFieldLocationForm');
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(field);
        var location = new google.maps.places.SearchBox(field);

        map.addListener('bounds_changed', function() {
          location.setBounds(map.getBounds());
        });

        location.addListener('places_changed', function() {
          var places = location.getPlaces();
          if ( places.length == 0 ) return;
          var boundss = new google.maps.LatLngBounds();
          angular.forEach(places, function(place) {
            ( place.geometry.viewport ) ? boundss.union(place.geometry.viewport) : boundss.extend(place.geometry.location);
          });
          map.fitBounds(boundss);
        });
      },

      setLatLng: function(lat, lng){
        // ToDO should be fixed
        setTimeout(function(){
          $scope.point['lat'] = lat;
          $scope.point['lng'] = lng;
          $scope.$apply();
        }, 500);
      },

      onSubmit: function(){
        var form = $scope.form;

        if ( form.$invalid ) return;

        if ( $scope.point && $scope.point.id ){
          ScavengerHuntService.updatePoint($scope.point)
            .then(function(response){
              Notification.success('Check-in point was updated');
              $uibModalInstance.close(response.data);
            })
            .catch(function(err){
              console.error(err);
              Notification.error(err.data.message);
            });
        } else {
          ScavengerHuntService.createPoint($scope.point)
            .then(function(response){
              Notification.success('Check-in point was created');
              $uibModalInstance.close(response.data);
            })
            .catch(function(err){
              console.error(err);
              Notification.error(err.data.message);
            });
        }
      },

      onCancel: function(){
        $uibModalInstance.dismiss('Cancel');
      }
    });
  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('RouteController', RouteController);
  
  function RouteController(
    $rootScope,
    $scope,
    $timeout,
    IndoorService,
    OutdoorService
  ){
    var vm = this;
    var activeService = IndoorService.isServiceActive() ? IndoorService : OutdoorService;

    $scope.selectedItem = null
    $scope.selectedItemColor = null;

    angular.extend($scope, {
      routeLoading: true,
      onInit: function(){
        $timeout(function(){
          $scope.selectedItem = activeService.getSelectedItem();
          $scope.selectedItemColor = $scope.selectedItem.strokeColor;

          $scope.routeLoading = false;
          $scope.$apply();

          if ( activeService.getType() === 'outdoor' ){
            var routeDistance = 0;
            var step = 3.28084;
            var route = $scope.selectedItem;
            var path = route.polyline.getPath();

            if ( $rootScope.currentEvent.preferences.measurementSystem === 'imperial' ) {
              routeDistance = (route.getPolylineDistance(path) * step).toFixed(0);
            } else {
              routeDistance = (route.getPolylineDistance(path)).toFixed(0);
            }

            $rootScope.selectedItemDistance = routeDistance;
          }
        }, 300);
      },
      // Change overlay color
      onChangeSelectedItemColor: activeService.changeSelectedItemColor
    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('ResponsibilityZoneController', ResponsibilityZoneController);
  
  function ResponsibilityZoneController(
    $scope,
    $timeout,
    $uibModal,
    IndoorService,
    OutdoorService,
    ToolsResponsibilityZone
  ){
    var vm = this;
    var activeService = IndoorService.isServiceActive() ? IndoorService : OutdoorService;;

    $scope.selectedItem = null
    $scope.selectedItemColor = null;

    angular.extend($scope, {
      zoneLoading: true,
      onInit: function(){
        $timeout(function(){
          // Replace this sh*t in feature
          $scope.volunteerRequests = $scope.$parent.$parent.$parent.volunteerRequests;

          $scope.selectedItem = activeService.getSelectedItem();
          $scope.selectedItemColor = $scope.selectedItem.fillColor;

          ToolsResponsibilityZone.onInitZone($scope.selectedItem, $scope.volunteerRequests);

          $scope.zoneLoading = false;
          $scope.$apply();
        }, 300);
      },
      // Change overlay color
      onChangeSelectedItemColor: activeService.changeSelectedItemColor
    });

    $scope.onAddVolunteerAssignmentsRequests = function(){
      var zone = $scope.selectedItem;
      var volunteerData = zone.volunteerData;

      $scope.isSubmited = true;

      if ( volunteerData && volunteerData.request ){
        var volunteerObj = {
          volunteerRequestId: volunteerData.request.id
        };
        var assignObj = {
          request: volunteerData.request
        };

        if ( volunteerData.startDate && volunteerData.endDate && volunteerData.startTime && volunteerData.endTime ){
          var from = moment(volunteerData.startDate).set({
            hour: moment(volunteerData.startTime).hour(),
            minute: moment(volunteerData.startTime).minute()
          }).local();
          var to = moment(volunteerData.endDate).set({
            hour: moment(volunteerData.endTime).hour(),
            minute: moment(volunteerData.endTime).minute()
          }).local();

          volunteerObj.from = from;
          volunteerObj.to = to;

          assignObj.from = from
          assignObj.to = to
        }

        zone.volunteerAssignments.push(volunteerObj);
        zone.volunteerAssignmentsRequests.push(assignObj);

        volunteerData.request = null;
        volunteerData.startDate = null;
        volunteerData.endDate = null;
        volunteerData.startTime = null;
        volunteerData.endTime = null;

        $scope.isSubmited = false;
      }
    }

    $scope.onRemoveAssignmetVolunteer = function(volunteer){
      var zone = $scope.selectedItem;
      var idx = zone.volunteerAssignmentsRequests.indexOf(volunteer);
      if ( idx !== -1 ){
        zone.volunteerAssignmentsRequests.splice(idx, 1);
        for ( var i in zone.volunteerAssignments ){
          var assigned = zone.volunteerAssignments[i];
          if ( assigned.volunteerRequestId === volunteer.request.id ){
            var id = zone.volunteerAssignments.indexOf(assigned);
            zone.volunteerAssignments.splice(id, 1);
          }
        }
      }
    }

    $scope.onEditAssignments = function(user, assignments){
      console.log($scope.selectedItem.volunteerAssignmentsRequests);
      var modal = $uibModal.open({
        size: 'md',
        templateUrl: 'app/users/organizer/map/constructor/booth/modal-assignments/modal-assignments.html',
        controller: 'BoothAssignmentsCtrl',
        resolve: {
          user: function(){
            return user
          }
        }
      });
      modal.result.then(
        function(result){
          var zone = $scope.selectedItem;
          var idx = assignments.indexOf(user);
          assignments[idx] = result;
          for ( var i in zone.volunteerAssignments ){
            var kk = zone.volunteerAssignments[i];
            if (
              kk.volunteerRequestId === result.request.id
            ){
              kk['from'] = result.from;
              kk['to'] = result.to;
            }
          }
        },
        function(err){
          console.log(err);
        }
      )
    }

  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OverlayController', OverlayController);
  
  function OverlayController(
    $scope,
    $timeout,
    IndoorService,
    FileService
  ){
    var vm = this;
    $scope.selectedItem = null
    $scope.selectedItemColor = null;

    angular.extend($scope, {
      overlayLoading: true,
      onInit: function(){
        $timeout(function(){
          $scope.selectedItem = IndoorService.getSelectedItem();
          $scope.selectedItemColor = $scope.selectedItem.fillColor;

          $scope.overlayLoading = false;
          $scope.$apply();
        }, 300);
      },
      // Change overlay color
      onChangeSelectedItemColor: IndoorService.changeSelectedItemColor
    });

    // Change background image
    $scope.onChangeBackgroundImage = function(event){
      if ( $scope.selectedItem && $scope.selectedItem.kind === $scope.drawTypeOverlay ){
        var file = event.target.files[0];
        $scope.spinerLoader = true;
        FileService.onAdd(file)
          .then(
            function(response){
              var data = response.data;
              var fileData = {
                id: data.id,
                link: data.link
              };
              if (
                $scope.selectedItem.backgroundImage &&
                $scope.selectedItem.backgroundImage.id
              ) {
                FileService.onDelete($scope.selectedItem.backgroundImage.id)
                  .then(
                    function(){
                      $scope.spinerLoader = false;
                      $scope.selectedItem.backgroundImage = fileData;
                      $scope.selectedItem.setImage();
                    },
                    function(err){
                      $scope.spinerLoader = false;
                      $scope.selectedItem.backgroundImage = fileData;
                      $scope.selectedItem.setImage();
                    }
                  )
              } else {
                $scope.spinerLoader = false;
                $scope.selectedItem.backgroundImage = fileData;
                $scope.selectedItem.setImage();
              }
            },
            function(err){
              $scope.spinerLoader = false;
              console.log(err);
            }
          );
      }
    };
    // Remove background image
    $scope.onRemoveBackgroundImage = function(backgroundImage){
      if ( $scope.selectedItem && $scope.selectedItem.kind === $scope.drawTypeOverlay ){
        FileService.onDelete(backgroundImage.id)
          .then(
            function(){
              $scope.selectedItem.removeImage();
              document.getElementById('backgroundImage').value = '';
            },
            function(err){
              console.log(err);
            }
          );
      }
    }
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('EventZoneController', EventZoneController);
  
  function EventZoneController(
    $scope,
    $timeout,
    IndoorService,
    OutdoorService
  ){
    var vm = this;
    var activeService = IndoorService.isServiceActive() ? IndoorService : OutdoorService;;

    $scope.selectedItem = null
    $scope.selectedItemColor = null;

    angular.extend($scope, {
      zoneLoading: true,
      onInit: function(){
        $timeout(function(){
          $scope.selectedItem = activeService.getSelectedItem();
          $scope.selectedItemColor = $scope.selectedItem.fillColor;

          $scope.zoneLoading = false;
          $scope.$apply();
        }, 300)
      },
      // Change overlay color
      onChangeSelectedItemColor: activeService.changeSelectedItemColor
    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('BoothController', BoothController);
  
  function BoothController(
    $rootScope,
    $scope,
    $timeout,
    $uibModal,
    moment,
    IndoorService,
    OutdoorService,
    ToolsBooth
  ){
    var vm = this;
    var activeService = IndoorService.isServiceActive() ? IndoorService : OutdoorService;

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.vendorModule = $scope.currentEvent.preferences.vendorModule;
    $scope.participantModule = $scope.currentEvent.preferences.participantModule;
    $scope.volunteerModule = $scope.currentEvent.preferences.volunteerModule;
    $scope.sponsorModule = $scope.currentEvent.preferences.sponsorModule;

    $scope.selectedItem = null
    $scope.selectedItemColor = null;

    $scope.unlinkedUsers = [];

    $scope.userType = function(type){
      if ( type.toLowerCase() === 'vendor' ) return $scope.vendorModule.label;
      if ( type.toLowerCase() === 'participant' ) return $scope.participantModule.label;
      if ( type.toLowerCase() === 'sponsor' ) return $scope.sponsorModule.label;
      if ( type.toLowerCase() === 'volunteer' ) return $scope.volunteerModule.label;
      return type;
    };

    angular.extend($scope, {
      moment: moment,
      boothLoading: true,
      onInit: function(){
        $timeout(function(){
          // Replace this sh*t in feature
          $scope.userCommercialAssignments = $scope.$parent.$parent.$parent.userCommercialAssignments;
          $scope.userNonCommercialAssignments = $scope.$parent.$parent.$parent.userNonCommercialAssignments;
          $scope.indoorMaps = $scope.$parent.$parent.$parent.indoorMaps;

          $scope.routes = $scope.$parent.$parent.$parent.routes;

          $scope.setUnlinkedRequest = $scope.$parent.$parent.$parent.setUnlinkedRequest;
          $scope.deleteUnlinkedRequest = $scope.$parent.$parent.$parent.deleteUnlinkedRequest;

          $scope.selectedItem = activeService.getSelectedItem();
          $scope.selectedItemColor = $scope.selectedItem.fillColor;

          ToolsBooth.onInitBooth($scope.selectedItem, $scope.routes, $scope.indoorMaps, $scope.userCommercialAssignments, $scope.userNonCommercialAssignments);

          $scope.unlinkedUsers = $scope.getUnlinkedUsers($scope.selectedItem);

          $scope.boothLoading = false;

          $scope.$apply();
        }, 300);
      },
      // Change booth color
      onChangeSelectedItemColor: activeService.changeSelectedItemColor,

      onAddRoute: ToolsBooth.addRoute,
      onRemoveRoute: ToolsBooth.removeRoute
    });

    $scope.onChangeBoothType = function(boothType){
      ToolsBooth.changeBoothType($scope.selectedItem, boothType);

      $scope.selectedItemColor = $scope.selectedItem.fillColor;

      $scope.selectedItem.setColor($scope.selectedItemColor);

      $scope.onChangeSelectedItemColor($scope.selectedItemColor);

      if ( $scope.selectedItem._type === 'fixed' ){
        $scope.selectedItem.setImage();
        $scope.selectedItem.resize();
      }

      // FIx this sh*t in feature
      $scope.$parent.$parent.$parent.isCreatedNewMapItem = $scope.selectedItem.boothTypeId ? false : true;
    };

    $scope.handleBoothRotate = function(direction){
      $scope.selectedItem.rotate(direction);
    };

    // 
    // ************************************************
    // Unlinked booth user
    // ************************************************
    $scope.getUnlinkedUsers = function(booth){
      var result = [];
      if ( booth && booth.id ){
        if ( $scope.userNonCommercialAssignments && $scope.userNonCommercialAssignments.length ){
          for ( var i in $scope.userNonCommercialAssignments ){
            var skipToPush = false;
            var assign = $scope.userNonCommercialAssignments[i];
  
            if ( booth.userNonCommercialAssignments && booth.userNonCommercialAssignments.length ){
              for ( var j in booth.userNonCommercialAssignments ){
                var assignR = booth.userNonCommercialAssignments[j];
                if (
                  assign.id === assignR.userId &&
                  assign.type === assignR.userType &&
                  !assignR.from && !assignR.to
                ){
                  skipToPush = true;
                  break;
                }
              }
            }
  
            if ( !skipToPush ){
              result.push(assign);
            }
          }
        }
      }

      return result;
    };
    $scope.setUnlinkedUser = function(data){
      if ( !data.from && !data.to ){
        var user = data.user;
        if ( $scope.unlinkedUsers && $scope.unlinkedUsers.length ){
          for ( var i in $scope.unlinkedUsers ){
            var unlinked = $scope.unlinkedUsers[i];
            if (
              unlinked.id === user.id &&
              unlinked.type === user.type
            ){
              $scope.unlinkedUsers.splice(i, 1);
            }
          }
        }
      }
    };
    $scope.deleteUnlinkedUser = function(data){
      if ( !data.from && !data.to ){
        $scope.unlinkedUsers.push(data.user);
      }
    };

    $scope.onEditAssignments = function(user, assignments, type){
      var modal = $uibModal.open({
        size: 'md',
        templateUrl: 'app/users/organizer/map/constructor/booth/modal-assignments/modal-assignments.html',
        controller: 'BoothAssignmentsCtrl',
        resolve: {
          user: function(){
            return user
          }
        }
      });
      modal.result.then(
        function(result){
          var booth = $scope.selectedItem;
          var idx = assignments.indexOf(user);
          assignments[idx] = result;
          if ( type === 'commercial' ){
            for ( var i in booth.userCommercialAssignments ){
              var kk = booth.userCommercialAssignments[i];
              if ( kk.eventRequestId === result.request.id && kk.userType === result.request.user.type ){
                kk['notes'] = result.notes;
                kk['from'] = result.from;
                kk['to'] = result.to;
              }
            }
          }
          if ( type === 'nonCommercial' ){
            for ( var i in booth.userNonCommercialAssignments ){
              var kk = booth.userNonCommercialAssignments[i];
              if ( kk.userId === result.user.id && kk.userType === result.user.type ){
                kk['notes'] = result.notes;
                kk['from'] = result.from;
                kk['to'] = result.to;
              }
            }
          }
        },
        function(err){
          console.log(err);
        }
      )
    }

    // 
    // Commercial
    // 
    $scope.onChangeCommercialAssignments = function(){
    };
    $scope.onAddCommercialAssignments = function(){
      var booth = $scope.selectedItem;
      var commercialData = booth.commercialData;

      $scope.isCommercialSubmitted = true;

      if ( commercialData && commercialData.request ){
        var request = commercialData.request;
        var data = {
          notes: commercialData.notes || ''
        };
        if (
          commercialData.startDate && commercialData.endDate &&
          commercialData.startTime && commercialData.endTime
        ) {
          var from = moment(commercialData.startDate).set({
            hour: moment(commercialData.startTime).hour(),
            minute: moment(commercialData.startTime).minute()
          }).local();
          var to = moment(commercialData.endDate).set({
            hour: moment(commercialData.endTime).hour(),
            minute: moment(commercialData.endTime).minute()
          }).local();

          data.from = from;
          data.to = to;
        }
        booth.userCommercialAssignments = booth.userCommercialAssignments || [];
        booth.userCommercialAssignments.push($.extend({}, data, {
          eventRequestId: request.id,
          userType: request.user.type
        }));

        booth.commercialList.push($.extend({}, data, {
          request: request
        }));

        // Clear
        commercialData.request = null;
        commercialData.startDate = null;
        commercialData.endDate = null;
        commercialData.startTime = null;
        commercialData.endTime = null;
        commercialData.notes = '';

        $scope.isCommercialSubmitted = false;

        // Set unlinked request
        $scope.setUnlinkedRequest($.extend({}, data, {
          request: request
        }));
      }
    };
    $scope.onRemoveCommercialAssignments = function(commercial){
      var booth = $scope.selectedItem;

      var idx = booth.commercialList.indexOf(commercial);
      booth.commercialList.splice(idx, 1);

      for ( var i in booth.userCommercialAssignments ){
        var assign = booth.userCommercialAssignments[i];
        if ( assign.eventRequestId === commercial.request.id ){
          var idxA = booth.userCommercialAssignments.indexOf(assign);
          booth.userCommercialAssignments.splice(idxA, 1);
        }
      }

      // Delete unlinked request
      $scope.deleteUnlinkedRequest(commercial);
    };
    // 
    // Non Commercial
    // 
    $scope.onChangeNonCommercialAssignments = function(){
    };
    $scope.onAddNonCommercialAssignments = function(){
      var booth = $scope.selectedItem;
      var nonCommercialData = booth.nonCommercialData;

      $scope.isNonCommercialSubmitted = true;

      if ( nonCommercialData && nonCommercialData.user ){
        var user = nonCommercialData.user;
        var data = {
          notes: nonCommercialData.notes || ''
        };
        if (
          nonCommercialData.startDate && nonCommercialData.endDate &&
          nonCommercialData.startTime && nonCommercialData.endTime
        ) {
          var from = moment(nonCommercialData.startDate).set({
            hour: moment(nonCommercialData.startTime).hour(),
            minute: moment(nonCommercialData.startTime).minute()
          }).local();
          var to = moment(nonCommercialData.endDate).set({
            hour: moment(nonCommercialData.endTime).hour(),
            minute: moment(nonCommercialData.endTime).minute()
          }).local();

          data.from = from;
          data.to = to;
        }
        booth.userNonCommercialAssignments = booth.userNonCommercialAssignments || [];
        booth.userNonCommercialAssignments.push($.extend({}, data, {
          userId: user.id,
          userType: user.type
        }));

        booth.nonCommercialList.push($.extend({}, data, {
          user: user
        }));

        // Clear
        nonCommercialData.user = null;
        nonCommercialData.startDate = null;
        nonCommercialData.endDate = null;
        nonCommercialData.startTime = null;
        nonCommercialData.endTime = null;
        nonCommercialData.notes = '';

        $scope.isNonCommercialSubmitted = false;

        // Set unlinked user for booth
        $scope.setUnlinkedUser($.extend({}, data, {
          user: user
        }));
      }
    };
    $scope.onRemoveNonCommercialAssignments = function(nonCommercial){
      var booth = $scope.selectedItem;

      var idx = booth.nonCommercialList.indexOf(nonCommercial);
      booth.nonCommercialList.splice(idx, 1);

      for ( var i in booth.userNonCommercialAssignments ){
        var assign = booth.userNonCommercialAssignments[i];
        if ( assign.userId === nonCommercial.user.id ){
          var idxA = booth.userNonCommercialAssignments.indexOf(assign);
          booth.userNonCommercialAssignments.splice(idxA, 1);
        }
      }

      // Delete unlinked users
      $scope.deleteUnlinkedUser(nonCommercial);
    };


    $scope.handlePreview = function(media){
      if ( media && media.id ){
        $uibModal.open({
          templateUrl: 'app/users/organizer/event/media-gallery/360-modal.html',
          controller: 'MediaGallery360Controller as vm',
          backdrop: 'static',
          resolve: {
            resolveMedia: function(){
              return media;
            }
          }
        });
      }
    };


    // Add media
    $scope.addMedia = function(){
      var booth = $scope.selectedItem;

      var modal = $uibModal.open({
        templateUrl: 'app/directives/text-editor-gallery/media-modal.html',
        controller: 'MediaModalController',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          boothPhotos: function(){
            return booth.photos;
          },
          isTextEditor: function(){
            return false;
          }
        }
      });

      modal.result
        .then(
          function(result){
            if ( result.length ){
              for ( var i in result ){
                var r = result[i];
                booth.photos.push({
                  id: r.id,
                  link: r.link,
                  type: r.type
                });
              }
            }
          },
          function(cancel){
          }
        );
    },

    $scope.removeMedia = function(photo){
      if ( photo && photo.id ){
        var idx = $scope.selectedItem.photos.indexOf(photo);
        if ( idx > -1 ){
          $scope.selectedItem.photos.splice(idx, 1);
        }
      }
    }
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerEventVolunteerAssignmentsController', OrganizerEventVolunteerAssignmentsController)
    .filter('FilterVolunteerAssignmentsSearch', FilterVolunteerAssignmentsSearch)

  function FilterVolunteerAssignmentsSearch(){
    return function(items, query){
      if ( items ){
        if ( query ){
          var result = [];
          for ( var i in items ){
            if (
              items[i].request.volunteer.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              items[i].request.volunteer.email.toLowerCase().indexOf(query.toLowerCase()) > -1
            ){
              result.push(items[i]);
            }
          }
          return result;
        }
      }
      return items;
    }
  }

  function OrganizerEventVolunteerAssignmentsController(
    $rootScope,
    $scope,
    $uibModal,
    moment,
    MapService,
    VolunteerService,
    MapCommon
  ) {

    var vm = this;

    angular.extend($scope, {
      moment: moment,

      zoneNames: [],

      handleClickZone: function(value){
        var idx = $scope.zoneNames.indexOf(value);
        idx > -1 ? $scope.zoneNames.splice(idx, 1) : $scope.zoneNames.push(value);
      },

      filterVolunteerAssignmentsZone: function(data){
        if ( $scope.zoneNames.length ){
          return (
            $scope.zoneNames.indexOf(data.zone.name) !== -1 ||
            typeof data.id === 'undefined'
          )
        }
        return data;
      },

      onInit: function(){

        $scope.event = $rootScope.currentEvent;

        MapService.getResponsibilityZones()
          .then(function(response){
            $scope.responseZones = response.data;
            $scope.zones = [{
              volunteerAssignments: []
            }].concat(response.data);
            return VolunteerService.getRequestByStatus('accepted');
          })
          .then(function(response){
            $scope.requests = response.data;
            $scope.build();
          })
          .catch(function(err){
            console.error(err);
          });

      },

      buildDateRange: function(startDate, endDate){
        var result = [];
        var start = moment(startDate).set({
          hours: 0, minutes: 0, seconds: 0
        });
        var end = moment(endDate).set({
          hours: 0, minutes: 0, seconds: 0
        });
        while (start <= end) {
          result.push(moment(start).format('MMMM DD, YYYY'));
          start = moment(start).add(1, 'd');
        }
        return result;
      },

      vColors: [],

      build: function(){
        var earlies = [];
        var latest = [];

        var ids = [];
        var days = [];

        if ( $scope.zones.length ){
          for ( var i in $scope.zones ){
            var zone = $scope.zones[i];
            if ( zone.volunteerAssignments.length ){
              for ( var j in zone.volunteerAssignments ){
                var assignment = zone.volunteerAssignments[j];

                if ( ids.indexOf(assignment.volunteerRequestId) === -1 ){
                  $scope.vColors.push({ id: assignment.volunteerRequestId, color: MapCommon.randomHexColor() });
                }

                assignment && assignment.from ? earlies.push( moment(moment.utc(assignment.from).toDate()) ) : earlies.push(moment(moment.utc($scope.event.start).toDate()));
                assignment && assignment.to ? latest.push (moment(moment.utc(assignment.to).toDate()) ) : latest.push(moment(moment.utc($scope.event.end).toDate()));
              }
            }
          }
        }

        var startDate;
        var endDate;

        if ( earlies.length && latest.length ){
          startDate = earlies.reduce(function(pre, cur){
            return Date.parse(pre) > Date.parse(cur) ? cur : pre;
          });
          endDate = latest.reduce(function(pre, cur){
            return Date.parse(pre) < Date.parse(cur) ? cur : pre;
          });
          days = $scope.buildDateRange(startDate, endDate);
        }

        $scope.zoneAssignments = $scope.zones.map(function(zone){
          var result = {
            zone: zone,
            color: ((zone.preferences && zone.preferences.fillColor) ? zone.preferences.fillColor : ''),
            days: days.map(function(day){
              return {
                date: day,
                volunteers: volunteerPerDay(zone, day)
              }
            })
          };
          if ( zone.id ) result['id'] = zone.id;

          return result;
        });
      },

      handleClick: function(zone, assignment){
        $uibModal.open({
          templateUrl: "app/users/organizer/volunteers/volunteer-assignments/modal.html",
          controller: "EoVolunteerAssignmentsForm as vm",
          resolve: {
            resolveZone: function(){
              return zone;
            },
            resolveAssignment: function(){
              return assignment;
            },
            resolveRequest: function(){
              return $scope.requests.find(function(request){
                return request.id === assignment.volunteerRequestId;
              });
            }
          }
        }).result.then(
          function(result){
            var idx = $scope.zones.indexOf(zone);
            $scope.zones[idx] = result;

            $scope.build();
          },
          function(err){
            $scope.build();
          }
        )
      }
    })

    function volunteerPerDay(zone, day){
      var result = [];

      if ( zone.volunteerAssignments.length ){
        for ( var i in zone.volunteerAssignments ){
          var assignment = zone.volunteerAssignments[i];

          if ( assignment && !assignment.from && !assignment.to ){
            assignment.from = $scope.event.start;
            assignment.to = $scope.event.end;
          }

          var from = moment(moment.utc(assignment.from).toDate());
          var to = moment(moment.utc(assignment.to).toDate());

          var dateRange = $scope.buildDateRange(from, to);

          if ( dateRange.length ){
            for ( var j in dateRange ){
              if ( moment(dateRange[j]).isSame(day, 'day') ){
                var dimmension = toDimmension(from, to, day);
                result.push({
                  total: dateRange.length,
                  id: assignment.volunteerRequestId,
                  assignment: assignment,
                  request: $scope.requests.find(function(item){
                    return item.id === assignment.volunteerRequestId
                  }),
                  date: {
                    from: from.format('MMMM DD, YYYY'),
                    to: to.format('MMMM DD, YYYY'),
                  },
                  time: {
                    from: from.format('hh:mm a'),
                    to: to.format('hh:mm a'),
                  },
                  left: dimmension.left,
                  width: dimmension.width,
                  color: $scope.vColors.find(function(item){
                    return item.id === assignment.volunteerRequestId;
                  }).color
                });
              }
            }
          }
        }
      }

      return result;
    }

    function toLeft(start){
      var h = moment(start).hours();
      var m = moment(start).minutes();
      return (h * 20) + Math.floor(m/3);
    }

    function toDimmension(start, end, day){
      var from = null;
      var to = null;

      if (
        moment(start).isSame(day, 'day')
      ) {
        from = toLeft(start);
        if ( moment(end).isSame(day, 'day') ){
          to = toLeft(end);
        } else {
          to = 480;
        }
      } else if ( moment(start).isBefore(day) ) {
        from = 0;
        if ( moment(end).isSame(day, 'day') ){
          to = toLeft(end);
        } else {
          to = 480;
        }
      }

      return {
        left: from,
        width: to - from - (2)
      };
    }

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('EoVolunteerAssignmentsForm', EoVolunteerAssignmentsForm);
  
  EoVolunteerAssignmentsForm.$inject = [
    '$scope',
    'moment',
    '$uibModalInstance',
    'Notification',
    'MapService',
    'VolunteerService',
    'resolveZone',
    'resolveAssignment',
    'resolveRequest'
  ];

  function EoVolunteerAssignmentsForm(
    $scope,
    moment,
    $uibModalInstance,
    Notification,
    MapService,
    VolunteerService,
    resolveZone,
    resolveAssignment,
    resolveRequest
  ){
    var vm = this;

    $scope.request = resolveRequest;
    $scope.zone = resolveZone;

    $scope.assignment = {};

    angular.extend($scope, {
      onInit: function(){
        if ( resolveAssignment.from && resolveAssignment.to ){
          $scope.assignment['startDate'] = moment(moment.utc(resolveAssignment.from)).local().toDate();
          $scope.assignment['startTime'] = moment(moment.utc(resolveAssignment.from)).local();
          $scope.assignment['endDate'] = moment(moment.utc(resolveAssignment.to)).local().toDate();
          $scope.assignment['endTime'] = moment(moment.utc(resolveAssignment.to)).local();
        }
      },
      handleCheckin: function(){
        VolunteerService.checkIn($scope.request.id, $scope.request)
          .then(function(response){
            // $scope.request = response.data;
            Notification.success('Request was checked in');
            $scope.request['checkedIn'] = true;
          })
          .catch(function(err){
            console.log(err);
          })
      },
      handleCheckout: function(){
        VolunteerService.checkOut($scope.request.id, $scope.request)
          .then(function(response){
            // $scope.request = response.data;
            Notification.success('Request was checked out');
            $scope.request['checkedIn'] = false;
          })
          .catch(function(err){
            console.log(err);
          })
      },
      handleSave: function(){
        if (
          $scope.assignment.startDate && $scope.assignment.endDate &&
          $scope.assignment.startTime && $scope.assignment.endTime
        ) {
          var from = moment($scope.assignment.startDate).set({
            hour: moment($scope.assignment.startTime).hour(),
            minute: moment($scope.assignment.startTime).minute()
          }).local();
          var to = moment($scope.assignment.endDate).set({
            hour: moment($scope.assignment.endTime).hour(),
            minute: moment($scope.assignment.endTime).minute()
          }).local();

          var assign = $scope.zone.volunteerAssignments.find(function(item){
            return item.volunteerRequestId === resolveAssignment.volunteerRequestId;
          });
          var idx = $scope.zone.volunteerAssignments.indexOf(assign);

          $scope.zone.volunteerAssignments[idx]['from'] = from;
          $scope.zone.volunteerAssignments[idx]['to'] = to;

          MapService.updateResponsibilityZone($scope.zone)
            .then(function(response){
              // console.log(response);
              Notification.success('Assignments was updated');
              $uibModalInstance.close(response.data);
            })
            .catch(function(err){
              console.log(err);
            });
        }
      },
      handleCancel: function(){
        $uibModalInstance.dismiss('cancel');
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVolunteersRequestsController', OrganizerVolunteersRequestsController);
  
  OrganizerVolunteersRequestsController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'moment',
    // 'MapService',
    'ActivityLogService',
    'VolunteerService',
    'ViewService',
    'STATUSES'
  ];

  function OrganizerVolunteersRequestsController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    moment,
    // MapService,
    ActivityLogService,
    VolunteerService,
    __view,
    STATUSES
  ) {
    var vm = this;
    vm.responsibilityZones = [];

    angular.extend($scope, {
      moment: moment,
      statuses: STATUSES.volunteer
    });

    angular.extend($scope, {
      onInit: function() {
        vm.currentPage = 1;
        vm.appView = localStorage.getItem('app_view');

        // MapService.getResponsibilityZones()
        //   .then(function(response){
        //     console.log(response);
        //     vm.responsibilityZones = response.data;
        VolunteerService.getRequests(true)
          // })
          .then(function(response){
            vm.requests = VolunteerService.requests(response.data);
          })
          .catch(function(err){
            console.log(err);
          })
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        __view.setView(type);
      },

      handleCheckOutAll: function(){
        var modal = checkInOutComment('Check Out All');
        modal.result
          .then(
            function(result){
              VolunteerService.checkOutAll({comment: result})
                .then(
                  function(response){
                    if ( vm.requests.length ){
                      for ( var i in vm.requests ){
                        var request = vm.requests[i];
                        if ( request.status === 'accepted' && request.checkedIn ){
                          request.checkedIn = false;
                        }
                      }
                    }
                    Notification.success('All volunteer requests were checked out');
                  },
                  $scope.handleError
                );
            },
            function() {
              console.log('Cancelled');
            }
          );
      },

      handleAccept: function(request) {
        if ( request && request.id ) {
          VolunteerService.onAccept(request.id)
            .then(
              function(response){
                Notification.success('Volunteer request was accepted');
                VolunteerService.update(response.data);
              },
              $scope.handleError
            );
        }
      },

      handleDecline: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Volunteer is currently {{request.status}}. By clicking the "Decline" button, you will remove Volunteer from the event.\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDecline()">Decline</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, request){
              $scope.request = request;
              $scope.handleDecline = function(){
                $uibModalInstance.close(request);
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(result){
                VolunteerService.onDecline(result.id)
                  .then(
                    function(response){
                      Notification.success('Volunteer request was declined');
                      VolunteerService.update(response.data);
                    },
                    $scope.handleError
                  );
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleCheckIn: function(request){
        if ( request && request.id ) {
          // var modal = checkInOutComment('Check In');
          // modal.result
          //   .then(
          //     function(result){
          VolunteerService.checkIn(request.id, {})
            .then(
              function(response){
                Notification.success('Volunteer request was checked in');
                var idx = vm.requests.indexOf(request);
                vm.requests[idx].checkedIn = true;
              },
              $scope.handleError
            );
            //   },
            //   function() {
            //     console.log('Cancelled');
            //   }
            // );
        }
      },

      handleCheckOut: function(request){
        if ( request && request.id ){
          var modal = checkInOutComment('Check Out');
          modal.result
            .then(
              function(result){
                VolunteerService.checkOut(request.id, {comment: result})
                  .then(
                    function(){
                      Notification.success('Volunteer request was checked out');
                      var idx = vm.requests.indexOf(request);
                      vm.requests[idx].checkedIn = false;
                    },
                    $scope.handleError
                  );
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleLog: function(request){
        ActivityLogService.fetchAll(request.volunteer.id, request.id)
          .then(function(response){
            $uibModal.open({
              template: '\
                <div class="modal-header"><h3 class="modal-title">Log</h3></div>\
                <div class="modal-body">\
                  <ul class="log-list" ng-if="logs.length">\
                    <li ng-repeat="log in logs">\
                      <h4 ng-if="log.comment !== \'\'" ng-bind="log.comment"></h4>\
                      <div ng-if="log.checkInDate && !log.checkOutDate">\
                        <span class="created-on"><b>Check-in date: </b>{{log.checkInDate | dateFormated}}</span>\
                        <span ng-if="log.status === \'confirmed\'" class="table-group-value {{log.status}}" ng-bind="\'Checked In\'"></span>\
                        <span style="text-transform: capitalize" ng-if="log.status === \'draft\' || log.status === \'declined\'" class="table-group-value {{log.status}}" ng-bind="log.status"></span>\
                      </div>\
                      <div ng-if="log.checkInDate && log.checkOutDate">\
                        <span class="created-on"><b>Check-in date: </b>{{log.checkInDate | dateFormated}}</span>\
                        <span class="created-on"><b>Check-out date: </b>{{log.checkOutDate | dateFormated}}</span>\
                        <span ng-if="log.status == \'confirmed\'" class="table-group-value {{log.status}}" ng-bind="\'Checked Out\'"></span>\
                        <span style="text-transform: capitalize" ng-if="log.status === \'draft\' || log.status === \'declined\'" class="table-group-value {{log.status}}" ng-bind="log.status"></span>\
                      </div>\
                    </li>\
                  </ul>\
                  <div class="no-message" ng-if="logs.length === 0">\
                    <i class="fa fa-list-alt" aria-hidden="true"></i>\
                    <h3>No logs</h3>\
                  </div>\
                </div>\
                <div class="modal-footer">\
                  <button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>\
                </div>\
              ',
              controller: function($scope, $uibModalInstance, logs){
                $scope.logs = logs;
                $scope.handleClose = function(){
                  $uibModalInstance.dismiss('closed');
                }
              },
              resolve: {
                logs: function(){
                  return response.data;
                }
              }
            });
          });
      },

      requestVolunteer: function(request) {
        if ( $scope.volunteerRequestValue && $scope.volunteerRequestValue !== '' ) {
          return (
            request.volunteer.name.toLowerCase().indexOf($scope.volunteerRequestValue.toLowerCase()) > -1 ||
            request.volunteer.username.toLowerCase().indexOf($scope.volunteerRequestValue.toLowerCase()) > -1 ||
            request.volunteer.email.toLowerCase().indexOf($scope.volunteerRequestValue.toLowerCase()) > -1
          );
        }
        return request;
      },

      onChangeItemsOf: function() {
        var total = vm.filterVolunteers.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      }
    });

    function checkInOutComment(btnLabel){
      return $uibModal.open({
        template: '\
          <div class="modal-header"><h3 class="modal-title">Comment</h3></div>\
          <div class="modal-body">\
            <div class="form-group">\
              <label for="checkInOutComment">Comment</label>\
              <textarea class="form-control" name="checkInOutComment" id="checkInOutComment" ng-model="checkInOutComment" rows="5" />\
            </div>\
          </div>\
          <div class="modal-footer">\
            <button class="btn btn-primary" type="button" ng-click="handleCheckInOut()" ng-bind="btnLabel"></button>\
            <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
          </div>\
        ',
        controller: function($scope, $uibModalInstance, btnLabel){
          $scope.btnLabel = btnLabel;
          $scope.checkInOutComment = '';

          $scope.handleCheckInOut = function(){
            $uibModalInstance.close($scope.checkInOutComment);
          }
          $scope.handleCancel = function(){
            $uibModalInstance.dismiss('cancel');
          }
        },
        resolve: {
          btnLabel: function(){
            return btnLabel;
          }
        }
      })
    }

  }
})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerLogBookController', OrganizerLogBookController)
         .filter('FilterCheckInOutDate', FilterCheckInOutDate)

  function FilterCheckInOutDate(){
    return function(items, checkInDate, checkOutDate){
      if ( items ){
        var result = [];

        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();

        var start_date = (checkInDate && !isNaN(Date.parse(checkInDate))) ? Date.parse(checkInDate) : 0;
        var end_date = (checkOutDate && !isNaN(Date.parse(checkOutDate))) ? Date.parse(checkOutDate) : new Date(year + 99, month, day).getTime();

        $.each(items, function(index, item){
          var start = new Date(item.checkInDate);
          var end;
          if ( !item.checkOutDate ){
            var dt = new Date(item.checkInDate);
            end = dt.setDate(dt.getDate() - 1);
          } else {
            var dt = new Date(item.checkOutDate);
            end = dt.setDate(dt.getDate() - 1);
          }
          if ( start >= start_date && end < end_date ){
            result.push(item);
          }
        });

        return result;
      }
      return items;
    }
  }

  OrganizerLogBookController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'moment',
    'Notification',
    'ApproveService',
    'EventService',
    'ActivityLogService',
    'UserGroupsService',
    'ViewService'
  ];

  function OrganizerLogBookController(
    $rootScope,
    $scope,
    $uibModal,
    moment,
    Notification,
    ApproveService,
    EventService,
    ActivityLogService,
    UserGroupsService,
    ViewService
  ){
    var vm = this;
    $scope.currentEvent = $rootScope.currentEvent;

    $scope.groups = [];
    vm.userGroups = [];

    $scope.loading = true;
    $scope.loadingFile = false;

    $scope.searchByVolunteerName = '';

    angular.extend($scope, {
      datepickerFormat: 'MMMM dd, yyyy',
      dateOptions: {
        dateDisabled: false,
        formatYear: 'yy',
        startingDay: 1
      },
      popup1: {
        opened: false
      },
      popup2: {
        opened: false
      },
      onPopup1Open: function(){
        $scope.popup1.opened = true;
      },
      onPopup2Open: function(){
        $scope.popup2.opened = true;
      },
      onInit: function(){
        vm.currentPage = 1;
        vm.appView = localStorage.getItem('app_view');

        vm.volunteerModule = $scope.currentEvent.preferences.volunteerModule;

        UserGroupsService.getGroups(true)
          .then(function(response){
            $scope.groups = response.data;
            return ActivityLogService.fetchReport()
          })
          .then(function(response){
            var data = response.data;
            var result = [];
            var groups = [];
            if ( data.length ){
              for ( var i in data ){
                var log = data[i];
                log['userGroups'] = [];

                if ( $scope.groups.length ){
                  for ( var j in $scope.groups ){
                    var group = $scope.groups[j];
                    if ( group.userIds && group.userIds.length ){
                      if ( group.userIds.indexOf(log.userId) !== -1 ){
                        if ( groups.indexOf(group) === -1 ){
                          groups.push(group);
                        }

                        if ( log['userGroups'].indexOf(group.name) == -1 ){
                          log['userGroups'].push(group.name);
                        }

                      }
                    }
                  }
                }
                result.push(log);
              }
            }
            $scope.userGroups = groups;

            $scope.logs = result || [];
            $scope.loading = false;

            $scope.calcTotalTimeSpent($scope.logs);
          })
          .catch(function(err){
            console.error(err);
          });

      },

      onViewSwitch: function(type) {
        vm.appView = type;
        ViewService.setView(type);
      },

      calcTotalTimeSpent: function(logs){
        var total = 0;

        if ( logs.length ){
          for ( var i in logs ){
            var log = logs[i];
            if ( log.status === 'confirmed' && log.timeSpentMin ){
              total += log.timeSpentMin;
            }
          }
        }

        $scope.totalTimeSpent = $scope.totalTime(total);
      },

      handleConfirm: function(log){
        if ( log && log.id ){
          ApproveService(
            'Are you sure you want to confirm activity log?',
            'Confirm',
            function(){
              return ActivityLogService.confirm(log.id)
            }
          ).result.then(
            function(result){
              var idx = $scope.logs.indexOf(log);
              $scope.logs[idx] = result.data;
              Notification.success('Activity log was confirmed');

              $scope.calcTotalTimeSpent($scope.logs);
            },
            function(err){
              console.log('Cancel');
            }
          );
        }
      },

      handleDecline: function(log){
        if ( log && log.id ){
          ApproveService(
            'Are you sure you want to decline activity log?',
            'Decline',
            function(){
              return ActivityLogService.decline(log.id)
            }
          ).result.then(
            function(result){
              var idx = $scope.logs.indexOf(log);
              $scope.logs[idx] = result.data;
              Notification.success('Activity log was declined');

              $scope.calcTotalTimeSpent($scope.logs);
            },
            function(err){
              console.log('Cancel');
            }
          );
        }
      },

      handleCreate: function(){
        $uibModal.open({
          templateUrl: 'app/users/organizer/volunteers/log-book/form/form.html',
          controller: 'OrganizerVolunteerFormLogController',
          resolve: {
            resolveLog: function(){
              return null;
            },
            resolveAcceptedRequest: function(){
              return null;
            },
            resolveRequired: function(){
              return false;
            }
          }
        }).result.then(
          function(result){
            $scope.logs.push(result);

            $scope.calcTotalTimeSpent($scope.logs);
          },
          function(err){
            console.error(err);
          }
        )
      },

      handleEdit: function(log){
        if ( log ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/volunteers/log-book/form/form.html',
            controller: 'OrganizerVolunteerFormLogController',
            resolve: {
              resolveLog: function(){
                return log;
              },
              resolveAcceptedRequest: function(){
                return null;
              },
              resolveRequired: function(){
                return false;
              }
            }
          }).result.then(
            function(result){
              var idx = $scope.logs.indexOf(log);
              $scope.logs[idx] = result;

              $scope.calcTotalTimeSpent($scope.logs);
            },
            function(err){
              console.error(err);
            }
          )
        }
      },

      handleDelete: function(log) {
        if ( log && log.id ){
          ApproveService(
            'Are you sure you want to completely delete log ?',
            'Delete',
            function(){
              return ActivityLogService.delete(log.id)
            }
          ).result.then(
            function(){
              var idx = $scope.logs.indexOf(log);
              $scope.logs.splice(idx, 1);

              Notification.success('Activity log was removed');
              $scope.currentPage = $scope.navigatePagination($scope.logs);

              $scope.calcTotalTimeSpent($scope.logs);
            },
            function(err){
              console.log('Cancel');
            }
          );
        }
      },

      onChangeSearch: function(query){
        $scope.searchByVolunteerName = query;
      },

      filterVolunteerName: function(log){
        if ( $scope.searchByVolunteerName && $scope.searchByVolunteerName !== '' ){
          return (
            log.userName.toLowerCase().indexOf($scope.searchByVolunteerName.toLowerCase()) > -1
          )
        }
        return log;
      },

      totalTime: function(m){
        var timeToShow = '';

        var hoursPerDay = 24;
        var minutesPerDay = 1440;

        var days = null;

        if ( m >= minutesPerDay ){
          days = Math.floor(m/minutesPerDay);
          if ( days !== 1 ){
            m = (m - (minutesPerDay*days));
          }
        }

        var hours = moment.duration(m, 'm').hours();
        var minutes = moment.duration(m, 'm').minutes();

        if ( days !== null ){
          timeToShow += hours + (days*hoursPerDay) +'h'
        } else {
          if ( hours !== 0 ){
            timeToShow += hours +'h'
          }
        }
        if (minutes !== 0){
          timeToShow += (timeToShow ? ' ' : '') + minutes +'m'
        }
        if (minutes == 0 && hours == 0 && days == 0){
          timeToShow = '0m'
        }
        return timeToShow || '0';
      },

      handleDownload: function(){
        $scope.loadingFile = true;
        var ids = vm.filterLogs.map(function(item){
          return item.userId;
        });
        ActivityLogService.exportReport(ids.join(','))
          .then(function(response){
            var id = response.data.id +'.csv';
            return EventService.getCsvFile(id);
          })
          .then(function(response){
            var url = URL.createObjectURL(new Blob([response.data]));
            var a = document.createElement('a');
            a.href = url;
            a.download = moment().format('YYYYMMDDHHmm') +'-log-book.csv';
            a.target = '_blank';
            // Need for ff
            document.body.appendChild(a);
            a.click();
            a.remove();

            $scope.loadingFile = false;
          })
          .catch(function(err){
            $scope.loadingFile = false;
            console.err(err);
          });
      },

      onChangeItemsOf: function() {
        var total = vm.filterLogs.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = $scope.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVolunteerBulkRegisterController', OrganizerVolunteerBulkRegisterController)
  
  OrganizerVolunteerBulkRegisterController.$inject = [
    '$scope'
  ];

  function OrganizerVolunteerBulkRegisterController(
    $scope
  ){
    angular.extend($scope, {
      onInit: function() {}
    });
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVolunteerAssignmentsController', OrganizerVolunteerAssignmentsController);

  function OrganizerVolunteerAssignmentsController(
    $scope,
    $uibModalInstance,
    moment,
    MapItemsService,
    volunteer
  ) {
    var vm = this;
    vm.isLoading = true;
    vm.assignments = [];

    angular.extend($scope, {
      onInit: function(){

        MapItemsService.getVolunteerZoneAssignments(volunteer.id)
          .then(
            function(response){
              vm.assignments = response.data;
              vm.isLoading = false;
            },
            function(err){
              console.log(err);
            }
          );

      },
      onClose: function(){
        $uibModalInstance.dismiss('cancel');
      },
      isSameDay: function(from, to){
        return moment(from).isSame(to, 'day');
      }
    });
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVolunteersAllController', OrganizerVolunteersAllController);

  OrganizerVolunteersAllController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'moment',
    'Notification',
    'EventService',
    'MapService',
    'VolunteerService',
    'UserGroupsService',
    'ViewService'
  ];

  function OrganizerVolunteersAllController(
    $rootScope,
    $scope,
    $uibModal,
    moment,
    Notification,

    EventService,
    MapService,
    VolunteerService,
    UserGroupsService,
    ViewService
  ) {
    var vm = this;
    $scope.currentEvent = $rootScope.currentEvent;

    $scope.groups = [];
    vm.userGroups = [];

    $scope.userGroupsSearch = '';

    $scope.sortDate = function(user){
      var date = new Date(user.createdOn);
      return date;
    }

    angular.extend($scope, {
      loadingFile: false,
      onInit: function() {
        vm.currentPage = 1;
        vm.appView = localStorage.getItem('app_view');

        VolunteerService.getRequests()
          .then(function(response) {
            vm.requests = response.data
            return MapService.getResponsibilityZones();
          })
          .then(function(response){
            vm.respZones = response.data;
            return UserGroupsService.getGroups(true)
          })
          .then(function(response){
            $scope.groups = response.data;
            return EventService.getVolunteers();
          })
          .then(function(response){
            var data = response.data.map(function(item){
              return $.extend({}, item, {
                status: $scope.onStatus(item) ? 'declined' : 'confirmed'
              });
            });
            var result = [];
            var groups = [];
            if ( data.length ){
              for ( var i in data ){
                var user = data[i];
                user['userGroups'] = [];
                if ( $scope.groups.length ){
                  for ( var j in $scope.groups ){
                    var group = $scope.groups[j];
                    if ( group.userIds && group.userIds.length ){
                      if ( group.userIds.indexOf(user.id) !== -1 ){

                        if ( groups.indexOf(group) === -1 ){
                          groups.push(group);
                        }

                        if ( user['userGroups'].indexOf(group.name) == -1 ){
                          user['userGroups'].push(group.name);
                        }

                      }
                    }
                  }
                }
                result.push(user);
              }
            }
            vm.userGroups = groups;
            vm.volunteers = VolunteerService.requests(result);
          })
          .catch($scope.handleError);

      },

      onViewSwitch: function(type) {
        vm.appView = type;
        ViewService.setView(type);
      },

      handleLoginAs: function(user) {
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/login-as/login-as.html',
          controller: 'OrganizerLoginAsController',
          resolve: {
            loginAs: function(){
              return user;
            }
          }
        });
      },

      onStatus: function(volunteer) {
        var result = true;
        if ( vm.requests && vm.requests.length !== 0 ) {
          var requestPresent = false;
          angular.forEach(vm.requests, function(request){
            var id = request.volunteer.id;
            var status = request.status;
            if ( volunteer.id === id ) {
              requestPresent = true;
              result = result && ( status !== 'accepted' && status !== 'pending');
            }
          });
          result = result || !requestPresent;
        }
        return result;
      },

      handleParticipation: function(event, volunteer) {
        if ( volunteer && volunteer.id ) {
          VolunteerService.onParticipated(volunteer.id)
            .then(
              function(response){
                Notification.success('Volunteer accepted');
                var data = response.data;
                for ( var i in vm.volunteers ) {
                  var item = vm.volunteers[i];
                  if ( item.id === data.volunteer.id ) {
                    var index = vm.volunteers.indexOf(item);
                    vm.volunteers[index] = $.extend({}, volunteer, { status: 'confirmed' });
                  }
                }
              },
              $scope.handleError
            );
        }
      },

      handleEditProfile: function(volunteer){
        if ( volunteer && volunteer.id ){
          var modal = $uibModal.open({
            size: 'md',
            templateUrl: 'app/users/organizer/profile/profile.html',
            controller: 'OrganizerUserProfileFormController',
            controllerAs: 'vm',
            resolve: {
              userProfile: function(){
                return volunteer;
              }
            }
          });
          modal.result
            .then(
              function(result){
                for ( var i in vm.volunteers ){
                  var volunteer = vm.volunteers[i];
                  if ( volunteer.id === result.id ){
                    var idx = vm.volunteers.indexOf(volunteer);
                    vm.volunteers[idx] = result;
                  }
                }
                Notification.success('Volunteer profile was updated');
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleDeleteUser: function(volunteer) {
        var modal = $uibModal.open({
          size: 'md',
          template: '\
            <div class="modal-header">\
              <h4 class="modal-title text-danger" style="text-align: center;">\
                Are you sure you want to completely delete <b>{{volunteer.username}}</b> ({{volunteer.name}}/{{volunteer.email}}) volunteer user account?<p>It will remove all the user data and operation can`t be undone</p>\
              </h4>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
              </button>\
              <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance, volunteer, AuthService){
            $scope.volunteer = volunteer;
            $scope.loading = false;
            
            $scope.handleConfirm = function(){
              $scope.loading = true;
              AuthService.onDelete(volunteer.id)
                .then(
                  function(response){
                    $uibModalInstance.close(volunteer);
                    $scope.loading = false;
                  },
                  function(err){
                    $uibModalInstance.dismiss('cancel');
                    $scope.loading = false;
                    Notification.error(err.data.message);
                  }
                );
            }

            $scope.handleCancel = function(){
              $uibModalInstance.dismiss('cancel');
            }
          },
          resolve: {
            volunteer: function(){
              return volunteer;
            }
          }
        });

        modal.result
          .then(
            function(result){
              VolunteerService.remove(result);
              Notification.success('Volunteer was removed');
              vm.currentPage = $scope.navigatePagination(vm.volunteers);
            },
            function() {
              console.log('Cancelled');
            }
          );
      },

      handleDownload: function() {
        $scope.loadingFile = true;
        var ids = vm.filterVolunteers.map(function(item){
          return item.id;
        });
        EventService.getCsvId('volunteer', ids.join(','))
          .then(
            function(response){
              var id = response.data.id+".csv";
              EventService.getCsvFile(id)
                .then(
                  function(response){
                    var url = URL.createObjectURL(new Blob([response.data]));
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = moment().format('YYYYMMDDHHmm') +'-volunteers.csv';
                    a.target = '_blank';
                    // Need for ff
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  },
                  $scope.handleError
                );
              $scope.loadingFile = false;
            },
            $scope.handleError
          );
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      },

      onChangeItemsOf: function() {
        var total = vm.filterVolunteers.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      },

      totalTime: function(m){
        var timeToShow = '';

        var hoursPerDay = 24;
        var minutesPerDay = 1440;

        var days = null;

        if ( m >= minutesPerDay ){
          days = Math.floor(m/minutesPerDay);
          if ( days !== 1 ){
            m = (m - (minutesPerDay*days));
          }
        }

        var hours = moment.duration(m, 'm').hours();
        var minutes = moment.duration(m, 'm').minutes();

        if ( days !== null ){
          timeToShow += hours + (days*hoursPerDay) +'h'
        } else {
          if ( hours !== 0 ){
            timeToShow += hours +'h'
          }
        }
        if (minutes !== 0){
          timeToShow += (timeToShow ? ' ' : '') + minutes +'m'
        }
        if (minutes == 0 && hours == 0 && days == 0){
          timeToShow = '0m'
        }
        return timeToShow || '0';
      }
    });

    // On Assignments
    vm.onAssignments = function(volunteer){
      if ( volunteer && volunteer.id ){
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/volunteers/assignments/assignments.html',
          controller: 'OrganizerVolunteerAssignmentsController',
          controllerAs: 'vm',
          resolve: {
            volunteer: function(){
              return volunteer;
            }
          }
        });
      }
    }

  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVendorsRequestsFormController', OrganizerVendorsRequestsFormController);
  
  OrganizerVendorsRequestsFormController.$inject = [
    '$scope',
    '$uibModalInstance',
    'moment',
    'Notification',
    'VendorService',
    'CategoryService',
    'PriceService',
    'PROFILE_VISIBILITY',
    'resolveData'
  ];

  function OrganizerVendorsRequestsFormController(
    $scope,
    $uibModalInstance,
    moment,
    Notification,
    __vendor,
    __category,
    __price,
    PROFILE_VISIBILITY,
    resolveData
  ) {
    var vm = this;
    vm.prices = [];

    angular.extend($scope, {
      label: 'Update',
      visibility: PROFILE_VISIBILITY,
      datepickerFormat: 'MMMM dd, yyyy',
      datepickerOptions: {
        formatYear: 'yy',
        minDate: new Date(),
        startingDay: 1
      },
      datepickerPopup: {
        opened: false
      }
    });

    angular.extend($scope, {
      onInit: function() {
        vm.profileVisibility = [];

        __category.getCategories()
          .then(
            function(response) {
              vm.categories = response.data;
            },
            $scope.handleError
          );

        __price.getPrices()
          .then(
            function(response) {
              response.data.forEach(function(item){
                if ( item.type === 'booth' ) {
                  if ( item.invoiceDueDate ) {
                    item['invoiceDueDate'] = moment(moment.utc(item.invoiceDueDate)).local().format('MMMM DD, YYYY');
                  }
                  vm.prices.push(item);
                }
              });

              if ( resolveData && resolveData.id ) {
                vm.request = resolveData;
                vm.profileVisibility = resolveData.profileVisibility || [];

                var requestDueDate = moment(moment.utc(resolveData.invoiceDueDate)).local().format('MMMM DD, YYYY');

                if ( resolveData.price && resolveData.invoiceDueDate ) {
                  vm.modelPackage = vm.prices.filter(function(item){
                    return ( item.price === resolveData.price && moment(item.invoiceDueDate).isSame(requestDueDate, 'day') );
                  })[0];
                }

                if ( typeof vm.modelPackage !== 'undefined' ) {
                  if ( vm.modelPackage.invoiceDueDate ){
                    vm.startDate = moment(moment.utc(vm.modelPackage.invoiceDueDate)).local().toDate();
                  }
                } else {
                  vm.modelPackage = {
                    price: resolveData.price
                  };
                  if ( resolveData.invoiceDueDate ){
                    vm.startDate = moment(moment.utc(data.invoiceDueDate)).local().toDate();
                  }
                }
              }
            },
            $scope.handleError
          );
      },

      handlePricePackage: function() {
        if ( vm.modelPackage && vm.modelPackage.invoiceDueDate ) {
          vm.startDate = new Date(vm.modelPackage.invoiceDueDate);
        } else {
          vm.startDate = null;
        }
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          if ( vm.files ) {
            vm.request.boothPhotos = [];
            angular.forEach(vm.files, function(item) {
              vm.request.boothPhotos.push({
                id: item.id,
                link: item.link
              });
            });
          }

          if ( vm.profileVisibility ) {
            vm.request.profileVisibility = vm.profileVisibility;
          }

          if ( vm.startDate ) {
            vm.request.invoiceDueDate = moment(vm.startDate).set({
              hour: 0, minute: 0, second: 0, millisecond: 0
            }).local();
          } else {
            vm.request.invoiceDueDate = null;
          }

          if ( vm.modelPackage && vm.modelPackage.price ) {
            vm.request.price = vm.modelPackage.price;
          } else {
            vm.request.price = 0;
          }

          __vendor.onUpdate(vm.request)
            .then(
              function(response){
                Notification.success('Vendor request was updated');
                $uibModalInstance.close(response.data);
              },
              $scope.handleError
            );
        }
      },

      handleDatepickerPopup: function() {
        $scope.datepickerPopup.opened = true;
      },

      profileChecked: function(value){
        var idx = vm.profileVisibility.indexOf(value);
        idx > -1 ? vm.profileVisibility.splice(idx, 1) : vm.profileVisibility.push(value);
      },

      handleCancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVendorsRequestsController', OrganizerVendorsRequestsController);
  
  OrganizerVendorsRequestsController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'moment',
    'Notification',
    'EventService',
    'VendorService',
    'MapService',
    'CategoryService',
    'ViewService',
    // 'TransactionService',
    'PaymentService',
    'STATUSES'
  ];

  function OrganizerVendorsRequestsController(
    $rootScope,
    $scope,
    $uibModal,
    moment,
    Notification,
    EventService,
    VendorService,
    MapService,
    CategoryService,
    ViewService,
    // __transaction,
    PaymentService,
    STATUSES
  ) {
    var vm = this;

    angular.extend($scope, {
      moment: moment,
      statuses: STATUSES.vendor
    });

    angular.extend($scope, {
      onInit: function() {
        vm.currentPage = 1;
        vm.event = $rootScope.currentEvent;
        vm.appView = localStorage.getItem('app_view');

        VendorService.getRequestsWithBooth()
          .then(function(response){
            vm.requests = VendorService.requests(response.data);
            return CategoryService.getCategories();
          })
          .then(function(response){
            vm.categories = response.data;
            return MapService.getMapByID($rootScope.currentEvent.mainEventMapId);
          })
          .then(function(response){
            vm.booths = response.data.booths;
          })
          .catch($scope.handleError);

      },

      onViewSwitch: function(type) {
        vm.appView = type;
        ViewService.setView(type);
      },

      handlePreview: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            templateUrl: 'app/users/request-preview.html',
            controller: function($scope, $rootScope, $uibModalInstance, request, CategoryService, PriceService, PROFILE_VISIBILITY){
              $scope.currentUser = $rootScope.currentUser;
              $scope.visibility = PROFILE_VISIBILITY;
              $scope.prices = [];

              CategoryService.getCategories()
                .then(
                  function(response) {
                    $scope.categories = response.data;
                  },
                  $scope.handleError
                );

              PriceService.getPrices()
                .then(
                  function(response) {
                    angular.forEach(response.data, function(item){
                      if ( item.type === 'booth' && item.enabled ) {
                        $scope.prices.push(item);
                      }
                    });
                  },
                  $scope.handleError
                );

              $scope.request = request;

              $scope.modelPackage = $scope.prices.filter(function(item){
                return item.price === request.price;
              })[0];

              $scope.profileVisibility = request.profileVisibility || [];

              if ( request.invoiceDueDate ) {
                $scope.startDate = moment(moment.utc(request.invoiceDueDate)).local().toDate();
              }

              if ( !$scope.modelPackage ) {
                $scope.modelPackage = {
                  price: request.price
                }
              }

              $scope.handleClose = function(){
                $uibModalInstance.dismiss('cancel');
              }
              
              $scope.handlePhotoPreview = function(photo){
                var modal = $uibModal.open({
                  windowTopClass: 'modal-preview',
                  backdropClass: 'modal-backdrop-preview',
                  template: '\
                    <div class="modal-body">\
                      <div class="modal-body-inner">\
                        <div><img ng-click="handleClose()" ng-src="{{ photo.link }}" alt="Photo close" /></div>\
                      </div>\
                    </div>\
                    <div class="modal-footer">\
                      <button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>\
                    </div>\
                  ',
                  controller: function($scope, $uibModalInstance, photo){
                    $scope.photo = photo;
                    $scope.handleClose = function(){
                      $uibModalInstance.dismiss('cancel');
                    }
                  },
                  resolve: {
                    photo: function(){
                      return photo;
                    }
                  }
                });
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });
        }
      },

      handleCancel: function(request) {
        if ( request && request.id ) {
          $rootScope.loadingInformation = true;
          VendorService.onCancel(request.id)
            .then(
              function(response){
                $rootScope.loadingInformation = false;
                Notification.success('Vendor request was cancelled');
                VendorService.updateRequest(response.data);
              },
              $scope.handleError
            );
        }
      },

      loadingFile: false,

      handleDownload: function(){
        $scope.loadingFile = true;
        var ids = vm.filterVendors.map(function(item){
          return item.id;
        });
        VendorService.getRequestCsv(ids.join(','))
          .then(
            function(response){
              var id = response.data.id+'.csv';
              EventService.getCsvFile(id)
                .then(
                  function(response){
                    var url = URL.createObjectURL(new Blob([response.data]));
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = moment().format('YYYYMMDDHHmm') +'-vendor-requests.csv';
                    a.target = '_blank';
                    // Need for ff
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  },
                  $scope.handleError
                );
              $scope.loadingFile = false;
            },
            function(){
              $scope.loadingFile = false;
            }
          );
      },

      // handleAccept: function(request) {
      //   if ( request && request.id ) {
      //     $rootScope.loadingInformation = true;
      //     VendorService.onAccept(request.id)
      //       .then(
      //         function(response){
      //           $rootScope.loadingInformation = false;
      //           Notification.success('Vendor request was accepted');
      //           VendorService.updateRequest(response.data);
      //         },
      //         $scope.handleError
      //       );
      //   }
      // },

      handleMarkPaid: function(request){
        if ( request && request.id ) {
          $rootScope.loadingInformation = true;
          VendorService.markPaid(request.id)
            .then(
              function(response){
                $rootScope.loadingInformation = false;
                Notification.success('Vendor request was marked as paid');
                VendorService.updateRequest(response.data);
              },
              $scope.handleError
            );
        }
      },

      handleInvoice: function(request) {
        if ( request && request.id ) {
          $rootScope.loadingInformation = true;
          VendorService.onInvoice(request.id)
            .then(
              function(response){
                $rootScope.loadingInformation = false;
                Notification.success('Vendor request was invoiced');
                VendorService.updateRequest(response.data);
              },
              $scope.handleError
            );
        }
      },

      handleDecline: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Vendor is currently {{request.status}}. By clicking the "Decline" button, you will remove Vendor from the event.\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDecline()">Decline</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, request){
              $scope.request = request;
              $scope.handleDecline = function(){
                $uibModalInstance.close(request);
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(result){
                $rootScope.loadingInformation = true;
                VendorService.onDecline(result.id)
                  .then(
                    function(response){
                      $rootScope.loadingInformation = false;
                      Notification.success('Vendor request was declined');
                      VendorService.updateRequest(response.data);
                    },
                    $scope.handleError
                  );
              },
              function() {
                console.log('Declined');
              }
            );
        }
      },

      handleEdit: function(request){
        if ( request && request.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/vendors/requests/requests.form.html',
            controller: 'OrganizerVendorsRequestsFormController as vm',
            resolve: {
              resolveData: function(){
                return request;
              }
            }
          }).result.then(
            function(result){
              VendorService.updateRequest(result);
            },
            function(err){

            }
          );
        }
      },

      handleDelete: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Are you sure you want to delete vendor request and all it\'s content?\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDelete()">Delete</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, request){
              $scope.handleDelete = function(){
                $uibModalInstance.close(request);
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(result){
                $rootScope.loadingInformation = true;
                VendorService.onDelete(result.id)
                  .then(
                    function(response){
                      $rootScope.loadingInformation = false;
                      Notification.success('Vendor request was deleted');
                      var index = vm.requests.indexOf(result);
                      vm.requests.splice(index, 1);
                    },
                    $scope.handleError
                  );
              },
              function() {
                console.log('Deleted');
              }
            );
        }
      },

      handleReset: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">Are you sure you want to put request back to draft status?</h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleReset()">Reset</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, request){
              $scope.handleReset = function(){
                $uibModalInstance.close(request);
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(result){
                $rootScope.loadingInformation = true;
                VendorService.onReset(result.id)
                  .then(
                    function(response){
                      $rootScope.loadingInformation = false;
                      Notification.success('Vendor request was reset');
                      VendorService.updateRequest(response.data);
                    },
                    $scope.handleError
                  );
              },
              function () {
                console.log('Cancelled');
              }
            );
        }
      },

      handleCheckIn: function(request) {
        if ( request && request.id ) {
          VendorService.onCheckIn(request.id)
            .then(
              function() {
                angular.forEach(vm.requests, function(item){
                  if ( item.id === request.id ) {
                    var index = vm.requests.indexOf(item);
                    vm.requests[index].checkedIn = true;
                  }
                });
                Notification.success('Request was checked in');
              },
              $scope.handleError
            );
        }
      },

      handleTransaction:function(request) {
        if ( request.id ) {
          $uibModal.open({
            templateUrl: 'app/users/organizer/transaction/transaction.modal.html',
            controller: 'OrganizerTransactionController',
            controllerAs: 'vm',
            resolve: {
              request: function(){
                return request;
              },
              userType: function(){
                return 'evr';
              }
            }
          });
        }
      },

      showAssignedToBoothOnly: function(request){
        if ( $scope.showAssignedToBooth ){
          return typeof request.booth !== 'undefined';
        }
        return request;
      },

      requestVendor: function(request) {
        if ( $scope.vendorRequestValue && $scope.vendorRequestValue !== '' ) {
          var vendor = request.vendor;
          return (
            vendor.name.toLowerCase().indexOf($scope.vendorRequestValue.toLowerCase()) > -1 ||
            vendor.username.toLowerCase().indexOf($scope.vendorRequestValue.toLowerCase()) > -1 ||
            vendor.email.toLowerCase().indexOf($scope.vendorRequestValue.toLowerCase()) > -1 ||
            (request.description ? request.description.toLowerCase().indexOf($scope.vendorRequestValue.toLowerCase()) > -1 : false) ||
            (request.booth ? request.booth.toLowerCase().indexOf($scope.vendorRequestValue.toLowerCase()) > -1 : false) ||
            (request.individualFeaturedItems ? request.individualFeaturedItems.toLowerCase().indexOf($scope.vendorRequestValue.toLowerCase()) > -1 : false)
          );
        }
        return request;
      },

      onChangeItemsOf: function() {
        var total = vm.filterVendors.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },


      // Handle payment buttons
      handlePaypalButton: function(pay, request) {
        var paymentData = {
          id: request.id,
          name: request.vendor.name,
          amount: request.price
        };

        PaymentService.paypalForm(pay, paymentData, 'evr');
      },

      handleTransactionButton: function(pay, request){
        var paymentData = {
          id: request.id,
          amount: request.price
        };

        PaymentService.transactionForm(pay, paymentData, 'evr');
      },

      handleStripeButton: function(pay, request){
        var paymentData = {
          id: request.id,
          amount: request.price,
          name: request.vendor.name,
          description: request.description,
          email: request.vendor.email
        };
        PaymentService.stripeForm(pay, paymentData, 'evr',
          function(){
            VendorService.getRequestById(request.id)
              .then(
                function(response){
                  VendorService.updateRequest(response.data);
                  Notification.success('Payment successfully submitted')
                },
                function(err){
                  console.log(err);
                }
              );
          },
          function(err){
            Notification.error(err.data.message);
          }
        );
      },

      handleSquareupButton: function(pay, request){
        var modal = $uibModal.open({
          templateUrl: 'app/squareup-form/squareup-form.html',
          controller: 'SquareupFormController',
          controllerAs: 'vm',
          size: 'sm',
          resolve: {
            dataPay: function(){
              return {
                applicationId: pay.applicationId,
                locationId: pay.locationId
              };
            },
            dataResult: function(){
              return {
                amount: request.price,
                id: request.id
              };
            },
            itemType: function(){
              return 'evr';
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              VendorService.getRequestById(request.id)
                .then(
                  function(response){
                    VendorService.updateRequest(response.data);
                    Notification.success('Payment successfully submitted')
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(){
              console.log('Dissmissed');
            }
          );
      },

      handlePayeezyButton: function(pay, request){
        var modal = $uibModal.open({
          templateUrl: 'app/payeezy-form/payeezy-form.html',
          controller: 'PayeezyFormController',
          controllerAs: 'vm',
          size: 'sm',
          resolve: {
            dataPay: function(){
              return {
                apiKey: pay.apiKey,
                paymentJSUrl: pay.paymentJSUrl,
                transarmorToken: pay.transarmorToken,
                jsSecurityKey: pay.jsSecurityKey
              };
            },
            dataResult: function(){
              return {
                amount: request.price,
                id: request.id
              };
            },
            itemType: function(){
              return 'evr';
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              VendorService.getRequestById(request.id)
                .then(
                  function(response){
                    VendorService.updateRequest(response.data);
                    Notification.success('Payment successfully submitted')
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(){
            }
          );
      },

      handleError: function(err) {
        Notification.error(err.data.message);
        $rootScope.loadingInformation = false;
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVendorsBulkController', OrganizerVendorsBulkController);
  
  OrganizerVendorsBulkController.$inject = [
    '$scope'
  ];

  function OrganizerVendorsBulkController(
    $scope
  ){
    angular.extend($scope, {
      onInit: function(){

      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVendorsAllController', OrganizerVendorsAllController);
  
  OrganizerVendorsAllController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'moment',
    'Notification',
    'EventService',
    'VendorService',
    'UserGroupsService',
    'ViewService'
  ];

  function OrganizerVendorsAllController(
    $rootScope,
    $scope,
    $uibModal,
    moment,
    Notification,
    __event,
    __vendor,
    UserGroupsService,
    __view
  ) {
    var vm = this;

    $scope.groups = [];
    vm.userGroups = [];

    $scope.userGroupsSearch = '';

    $scope.sortDate = function(user){
      var date = new Date(user.createdOn);
      return date;
    }

    angular.extend($scope, {
      loadingFile: false,
      onInit: function() {
        vm.currentPage = 1;

        vm.appView = localStorage.getItem('app_view');

        UserGroupsService.getGroups(true)
          .then(function(response){
            $scope.groups = response.data;
            return __event.getVendors();
          })
          .then(function(response){
            var result = [];
            var groups = [];
            if ( response.data.length ){
              for ( var i in response.data ){
                var user = response.data[i];
                user['userGroups'] = [];

                if ( $scope.groups.length ){
                  for ( var j in $scope.groups ){
                    var group = $scope.groups[j];
                    if ( group.userIds && group.userIds.length ){
                      if ( group.userIds.indexOf(user.id) !== -1 ){

                        if ( groups.indexOf(group) === -1 ){
                          groups.push(group);
                        }

                        if ( user['userGroups'].indexOf(group.name) === -1 ){
                          user['userGroups'].push(group.name);
                        }

                      }
                    }
                  }
                }

                result.push(user);
              }
            }
            vm.userGroups = groups;
            vm.vendors = __vendor.requests(result);
            return __vendor.getRequests();
          })
          .then(function(response){
            vm.requests = response.data;
          })
          .catch(function(err){
            console.log(err);
          });

        // __event.getVendors()
        //   .then(function(response){
        //     console.log(response.data);
        //     vm.vendors = __vendor.requests(response.data);
        //     return __vendor.getRequests()
        //   })
        //   .then(function(response){
        //     vm.requests = response.data;
        //     return UserGroupsService.getGroups(true);
        //   })
          
        //   .catch(function(err){
        //     console.log(err);
        //   })
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        __view.setView(type);
      },

      handleLoginAs: function(user) {
        var modal = $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/login-as/login-as.html',
          controller: 'OrganizerLoginAsController',
          resolve: {
            loginAs: function(){
              return user;
            }
          }
        });
      },

      // getUserGroups: function(userId){
      //   var result = [];
      //   if ( vm.userGroups.length ){
      //     for ( var i in vm.userGroups ){
      //       var group = vm.userGroups
      //     }
      //   }
      //   return result;
      // },

      handleDownload: function() {
        $scope.loadingFile = true;
        var ids = vm.filterVendors.map(function(item){
          return item.id;
        });
        __event.getCsvId('vendor', ids.join(','))
          .then(
            function(response){
              var id = response.data.id+".csv";
              __event.getCsvFile(id)
                .then(
                  function(response){
                    var url = URL.createObjectURL(new Blob([response.data]));
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = moment().format('YYYYMMDDHHmm') +'-vendors.csv';
                    a.target = '_blank';
                    // Need for ff
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  },
                  $scope.handleError
                );
              $scope.loadingFile = false;
            },
            $scope.handleError
          );
      },

      // handleIdleUsers: function(){
      //   __event.getVendors()
      //     .then(
      //       function(response){
      //         var data = response.data;
      //         if ( $scope.idleUsers ) {
      //           vm.vendors = data.filter(function(user){
      //             return !vm.requests.some(function(request){
      //               return user.id === request.vendor.id;
      //             });
      //           });
      //         } else {
      //           vm.vendors = __vendor.requests(data);
      //         }
      //       },
      //       $scope.handleError
      //     );
      // },

      handleEditProfile: function(vendor){
        if ( vendor && vendor.id ){
          var modal = $uibModal.open({
            size: 'md',
            templateUrl: 'app/users/organizer/profile/profile.html',
            controller: 'OrganizerUserProfileFormController',
            controllerAs: 'vm',
            resolve: {
              userProfile: function(){
                return vendor;
              }
            }
          });
          modal.result
            .then(
              function(result){
                for ( var i in vm.vendors ){
                  var vendor = vm.vendors[i];
                  if ( vendor.id === result.id ){
                    var idx = vm.vendors.indexOf(vendor);
                    vm.vendors[idx] = result;
                  }
                }
                Notification.success('Vendor profile was updated');
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleDeleteUser: function(vendor){
        var contain = false;
        var requestAccepted = [];
        if ( vendor && vendor.id ) {
          for(var i = 0; i < vm.requests.length; i++){
            var request = vm.requests[i];
            if ( request.vendor.id === vendor.id ) {
              if ( request.status === 'accepted' ) {
                contain = true;
                break;
              }
            }
          }

          if ( contain ) {
            for(var i = 0; i < vm.requests.length; i++){
              var request = vm.requests[i];
              if ( request.vendor.id === vendor.id ) {
                if ( request.status === 'accepted' ) {
                  requestAccepted.push(request);
                }
              }
            }
          }

          if ( contain ) {
            var modal = $uibModal.open({
              size: 'md',
              template: '\
                <div class="modal-header">\
                  <h4 class="modal-title" style="text-align: center;" ng-bind-html="msg | trusted"></h4>\
                </div>\
                <div class="modal-body" ng-if="requests.length != 0">\
                  <div class="row row-flex row-8">\
                    <div class="col-xs-12 col-sm-6" style="overflow: hidden; margin-bottom: 8px;" ng-repeat="request in requests track by $index">\
                      <div class="card card-default">\
                        <div class="card-head" ng-show="request.vendor.name || request.description">\
                          <h3 ng-show="request.vendor.name" class="card-title" ng-bind="request.vendor.name"></h3>\
                          <h5 ng-bind="request.vendor.username"></h5>\
                          <div ng-show="request.description" class="card-describe" ng-bind="request.description"></div>\
                        </div>\
                        <div class="card-body">\
                          <div class="card-group" ng-show="request.createdOn">\
                            <span class="card-group-label">Date:</span>\
                            <div class="card-group-value" ng-bind="request.createdOn | dateFormated"></div>\
                          </div>\
                          <div class="card-group" ng-show="request.vendor.email">\
                            <span class="card-group-label" ng-bind="\'LABEL.EMAIL\' | translate"></span>\
                            <div class="card-group-value"><a href="mailto:{{ request.vendor.email }}" ng-bind="request.vendor.email"></a></div>\
                          </div>\
                          <div class="card-group" ng-show="request.status">\
                            <span class="card-group-label">Status:</span>\
                            <div class="card-group-value" ng-bind="request.status"></div>\
                          </div>\
                          <div class="card-group" ng-show="request.goodsCategory.name">\
                            <span class="card-group-label">Category:</span>\
                            <div class="card-group-value" ng-bind="request.goodsCategory.name"></div>\
                          </div>\
                          <div class="card-group" ng-show="request.individualFeaturedItems">\
                            <span class="card-group-label">Individual featured items:</span>\
                            <div class="card-group-value" ng-bind="request.individualFeaturedItems"></div>\
                          </div>\
                          <div class="row">\
                            <div class="col-xs-6">\
                              <div class="card-group" ng-show="request.price">\
                                <span class="card-group-label">Price:</span>\
                                <div class="card-group-value" ng-bind="\'&#36;\' + request.price"></div>\
                              </div>\
                            </div>\
                            <div class="col-xs-6">\
                              <div class="card-group" ng-show="request.invoiceDueDate">\
                                <span class="card-group-label">Invoice due date:</span>\
                                <div class="card-group-value" ng-bind="request.invoiceDueDate | dateFormated"></div>\
                              </div>\
                            </div>\
                          </div>\
                          <div class="row">\
                            <div class="col-xs-6">\
                              <div class="card-group" ng-show="request.invoiceStatus">\
                                <span class="card-group-label">Payment status:</span>\
                                <div class="card-group-value" ng-bind="request.invoiceStatus"></div>\
                              </div>\
                            </div>\
                            <div class="col-xs-6">\
                              <div class="card-group" ng-show="request.invoiceSubmitDate">\
                                <span class="card-group-label">Payment date:</span>\
                                <div class="card-group-value" ng-bind="request.invoiceSubmitDate | dateFormated"></div>\
                              </div>\
                            </div>\
                          </div>\
                        </div>\
                        <div class="card-foot" ng-if="request.status != \'declined\'">\
                          <button class="btn btn-danger" type="button" ng-click="handleDecline(request)">Decline</button>\
                        </div>\
                      </div>\
                    </div>\
                  </div>\
                </div>\
                <div class="modal-footer">\
                  <button class="btn btn-primary" type="button" ng-if="requests.length == 0" ng-click="handleConfirm()" ng-disabled="loadingConfirm">\
                    <i ng-if="loadingConfirm" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                  </button>\
                  <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                </div>\
              ',
              controller: function($scope, $uibModal, $uibModalInstance, vendor, requests, AuthService, VendorService){
                $scope.requests = requests;
                $scope.loadingConfirm = false;

                $scope.msg = '<p><b>'+ vendor.username +'</b></p><p>('+ vendor.name +'/'+ vendor.email +')</p> Vendor account can`t be deleted because there are accepted request';

                $scope.handleConfirm = function(){
                  $scope.loadingConfirm = true;
                  AuthService.onDelete(vendor.id)
                    .then(
                      function(response){
                        $uibModalInstance.close(vendor);
                        $scope.loadingConfirm = false;
                      },
                      $scope.handleError
                    );
                }
                $scope.handleCancel = function(){
                  $uibModalInstance.dismiss('cancel');
                }

                $scope.handleDecline = function(request) {
                  if ( request && request.id ) {
                    var modal = $uibModal.open({
                      size: 'md',
                      template: '\
                        <div class="modal-header">\
                          <h3 class="modal-title" style="text-align: center;">\
                            Vendor is currently accepted. By clicking the "Decline" button, you will remove Vendor from the event.\
                          </h3>\
                        </div>\
                        <div class="modal-footer">\
                          <button class="btn btn-primary" type="button" ng-click="handleDecline()" ng-disabled="loading">\
                            <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Decline\
                          </button>\
                          <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                        </div>\
                      ',
                      controller: function($scope, $uibModalInstance, request){
                        $scope.loading = false;
                        $scope.handleDecline = function(){
                          $scope.loading = true;
                          VendorService.onDecline(request.id)
                            .then(
                              function(response){
                                $uibModalInstance.close(response.data);
                                $scope.loading = false;
                              },
                              $scope.handleError
                            );
                        }
                        $scope.handleCancel = function(){
                          $uibModalInstance.dismiss('cancel');
                        }
                      },
                      resolve: {
                        request: function(){
                          return request;
                        }
                      }
                    });

                    modal.result
                      .then(
                        function(result){
                          var index = $scope.requests.indexOf(result);
                          $scope.requests.splice(index, 1);
                          if( $scope.requests.length === 0 ){
                            $scope.msg = '<span class="text-danger">Are you sure you want to completely delete <b>'+ vendor.username +'</b> ('+ vendor.name +'/'+ vendor.email +') vendor user account?<p>It will delete all the user data and operation can`t be undone</p></span>';
                          }
                        },
                        function() {
                          console.log('Cancelled');
                        }
                      );
                  }
                }
              },
              resolve: {
                vendor: function(){
                  return vendor;
                },
                requests: function(){
                  return requestAccepted;
                }
              }
            });

            $scope.handleModalResolve(modal);

          } else {
            var modal = $uibModal.open({
              size: 'md',
              template: '\
                <div class="modal-header">\
                  <h4 class="modal-title text-danger" style="text-align: center;">\
                    Are you sure you want to completely delete <b>{{vendor.username}}</b> ({{vendor.name}}/{{vendor.email}}) vendor user account?<p>It will remove all the user data and operation can`t be undone</p>\
                  </h4>\
                </div>\
                <div class="modal-footer">\
                  <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                    <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                  </button>\
                  <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                </div>\
              ',
              controller: function($scope, $uibModalInstance, vendor, AuthService){
                $scope.vendor = vendor;
                $scope.loading = false;
                $scope.handleConfirm = function(){
                  $scope.loading = true;
                  AuthService.onDelete(vendor.id)
                    .then(
                      function(response){
                        $uibModalInstance.close(vendor);
                        $scope.loading = false;
                      },
                      $scope.handleError
                    );
                }
                $scope.handleCancel = function(){
                  $uibModalInstance.dismiss('cancel');
                }
              },
              resolve: {
                vendor: function(){
                  return vendor;
                }
              }
            });

            $scope.handleModalResolve(modal);
          }
        }
      },

      handleModalResolve: function(modal){
        modal.result
          .then(
            function(result){
              __vendor.spliceRequest(result);
              Notification.success('Vendor was removed');
              vm.currentPage = $scope.navigatePagination(vm.vendors);
            },
            function() {
              console.log('Cancelled');
            }
          );
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      },

      onChangeItemsOf: function() {
        var total = vm.filterVendors.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerUserGroupsListController', OrganizerUserGroupsListController);
  
  OrganizerUserGroupsListController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'UserGroupsService'
  ];

  function OrganizerUserGroupsListController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    __groups
  ) {
    var vm = this;
    vm.currentPage = 1;
    vm.userGroups = [];

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;

        __groups.getGroups(true)
          .then(
            function(response) {
              vm.userGroups = __groups.groups(response.data);
            },
            $scope.handleError
          );
      },

      handleCreate: function(){
        var modal = $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/user-groups/form/form.html',
          controller: 'OrganizerUserGroupsFormController',
          controllerAs: 'vm',
          resolve: {
            group: function(){
              return null;
            }
          }
        });
        modal.result.then(
          function(result){
            __groups.add(result);
          },
          function(err){
            console.log(err);
          }
        );
      },

      handleEdit: function(group){
        if ( group && group.id ){
          var modal = $uibModal.open({
            size: 'md',
            templateUrl: 'app/users/organizer/user-groups/form/form.html',
            controller: 'OrganizerUserGroupsFormController',
            controllerAs: 'vm',
            resolve: {
              group: function(){
                return group;
              }
            }
          });
          modal.result.then(
            function(result){
              __groups.update(result);
            },
            function(err){
              console.log(err);
            }
          );
        }
      },

      handleDelete: function(group) {
        if ( group ) {
          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete group: <b>{{group.name}}</b>?\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, UserGroupsService, resolveGroup){
              $scope.group = resolveGroup;
              $scope.loading = false;
              
              $scope.handleConfirm = function(){
                $scope.loading = true;
                UserGroupsService.deleteGroup(resolveGroup.id)
                  .then(function() {
                    $scope.loading = false;
                    $uibModalInstance.close(resolveGroup);
                  })
                  .catch(function(err){
                    $scope.loading = false;
                    Notification.error(err.data.message);
                  })
              }
  
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              resolveGroup: function(){
                return group;
              }
            }
          });
  
          modal.result
            .then(
              function(result){
                __groups.remove(result);
                Notification.success('User group was removed');
                vm.currentPage = $scope.navigatePagination(vm.userGroups);
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleError: function(err){
        Notification.alert(err.data.message);
      },

      onChangeItemsOf: function() {
        var total = vm.userGroups.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });
  }

})();
(function() {
  'use strict';
  
  angular
    .module('eventmap')
    .controller('OrganizerUserGroupsFormController', OrganizerUserGroupsFormController);
  
  OrganizerUserGroupsFormController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$uibModalInstance',
    'Notification',
    'UserGroupsService',
    'group'
  ];

  function OrganizerUserGroupsFormController(
    $rootScope,
    $scope,
    $timeout,
    $uibModalInstance,
    Notification,
    UserGroupsService,
    group
  ) {
    var vm = this;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    var userSearch;
    vm.event = $rootScope.currentEvent;

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.vendorModule = $scope.currentEvent.preferences.vendorModule;
    $scope.participantModule = $scope.currentEvent.preferences.participantModule;
    $scope.volunteerModule = $scope.currentEvent.preferences.volunteerModule;
    $scope.sponsorModule = $scope.currentEvent.preferences.sponsorModule;

    $scope.userType = function(type){
      if ( type.toLowerCase() === 'vendor' ) return $scope.vendorModule.label;
      if ( type.toLowerCase() === 'participant' ) return $scope.participantModule.label;
      if ( type.toLowerCase() === 'sponsor' ) return $scope.sponsorModule.label;
      if ( type.toLowerCase() === 'volunteer' ) return $scope.volunteerModule.label;
      if ( type === 'eventCoordinator' ) return 'Event coordinator';
      if ( type === 'volunteerCoordinator' ) return 'Volunteer coordinator';
      return type;
    };

    angular.extend($scope, {
      label: ( group && group.id ? 'Update' : 'Add'),
      searchType: 'vendor,volunteer,special,volunteerCoordinator,eventCoordinator,eo'
    });

    angular.extend($scope, {
      onInit: function() {
        vm.participantModule = vm.event.preferences.participantModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        if ( vm.event.modules.indexOf('participant') > -1 ) {
          $scope.searchType += ',participant';
        }

        if ( vm.event.modules.indexOf('sponsor') > -1 ) {
          $scope.searchType += ',sponsor';
        }

        if ( group && group.id ) {
          UserGroupsService.getGroupById(group.id)
            .then(function(response) {
              var data = response.data;
              vm.userGroup = data;
              vm.usersInGroup = data.users;
            });
        }
      },

      handleUsersSearch: function(query) {
        $timeout.cancel(userSearch);
        if ( query.length !== 0 ) {
          userSearch = $timeout(function(){
            UserGroupsService.searchUsers($scope.searchType, query)
              .then(function(response){
                vm.usersSearch = response.data;
              })
              .catch(function(err){
                console.error(err);
              });
          }, 1000);
        }
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          vm.userGroup.userIds = [];
          angular.forEach(vm.usersInGroup, function(item){
            vm.userGroup.userIds.push(item.id)
          });
          if ( group && group.id ) {
            UserGroupsService.updateGroup(group.id, vm.userGroup)
              .then(
                function(response){
                  Notification.success('User group was updated');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          } else {
            UserGroupsService.addGroup(vm.userGroup)
              .then(
                function(response){
                  Notification.success('User group was added');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          }
        }
      },

      onClose: function() {
        $uibModalInstance.dismiss('cancel');
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerUserGroupDetailsController', OrganizerUserGroupDetailsController);
  
  OrganizerUserGroupDetailsController.$inject = [
    '$rootScope',
    '$scope',
    '$stateParams',
    'EventService',
    'UserGroupsService',
    'ViewService',
    'Notification'
  ];

  function OrganizerUserGroupDetailsController(
    $rootScope,
    $scope,
    $stateParams,
    EventService,
    UserGroupsService,
    ViewService,
    Notification
  ){
    var vm = this;

    $scope.pageLoading = true;

    $scope.users = [];

    vm.currentPage = 1;
    vm.event = $rootScope.currentEvent;
    vm.appView = localStorage.getItem('app_view');

    angular.extend($scope, {
      onInit: function(){
        if ( typeof $stateParams.id !== 'undefined' ){
          UserGroupsService.getGroupById($stateParams.id)
            .then(function(response) {
              var data = response.data;
              $scope.currentUserGroup = data;
              if ( data.users && data.users.length ){
                $scope.users = data.users;
              }
              $scope.pageLoading = false;
            })
            .catch(function(err){
              console.error(err);
            });
        }
      },

      handleDownload: function() {
        $scope.loadingFile = true;
        var ids = vm.filterUsers.map(function(item){
          return item.id;
        });
        if ( typeof $stateParams.id !== 'undefined' ){
          UserGroupsService.exportGroup($stateParams.id, ids.join(','))
            .then(
              function(response){
                var id = response.data.id+'.csv';
                EventService.getCsvFile(id)
                  .then(
                    function(response){
                      var url = URL.createObjectURL(new Blob([response.data]));
                      var a = document.createElement('a');
                      a.href = url;
                      a.download = moment().format('YYYYMMDDHHmm') +'-groups.csv';
                      a.target = '_blank';
                      // Need for ff
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                    },
                    $scope.handleError
                  );
                $scope.loadingFile = false;
              },
              $scope.handleError
            );
        } else {
          Notification.error('Group ID is not present');
        }
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        ViewService.setView(type);
      },

      onChangeItemsOf: function() {
        var total = $scope.users.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerSponsorsFormRequestsController', OrganizerSponsorsFormRequestsController);
  
  function OrganizerSponsorsFormRequestsController(
    $scope,
    $uibModalInstance,
    SponsorService,
    Notification,
    PROFILE_VISIBILITY,
    request
  ){
    $scope.visibility = PROFILE_VISIBILITY.slice(0, -1);
    $scope.request = request;

    // $scope.requestData = {
    //   profileVisibility: []
    // };

    angular.extend($scope, {
      onInit: function(){
        if ( typeof $scope.request !== 'undefined' ){
          if ( typeof $scope.request.id !== 'undefined' ){
            SponsorService.getRequestById($scope.request.id)
              .then(
                function(response){
                  $scope.requestData = response.data;

                  if (
                    typeof $scope.requestData.profileVisibility === 'undefined' ||
                    !$scope.requestData.profileVisibility
                  ){
                    $scope.requestData.profileVisibility = [];
                  }
                },
                function(err){
                  console.error(err);
                }
              );
          } else {
            console.error('No request id');
          }
        } else {
          console.error('No request');
        }
      },

      profileChecked: function(value){
        var idx = $scope.requestData.profileVisibility.indexOf(value);
        idx > -1 ? $scope.requestData.profileVisibility.splice(idx, 1) : $scope.requestData.profileVisibility.push(value);
      },

      handleSubmit: function(){
        if ( typeof $scope.request !== 'undefined' ){
          if ( typeof $scope.request.id !== 'undefined' ){

            SponsorService.updateRequest($scope.request.id, $scope.requestData)
              .then(
                function(response){
                  Notification.success('Request profile visibility were updated');
                  $uibModalInstance.close(response.data);
                },
                function(err){
                  console.log(err);
                }
              );

          } else {
            console.error('No request id');
          }
        } else {
          console.error('No request');
        }
      },

      handleClose: function(){
        $uibModalInstance.dismiss('Dissmissed');
      }
    });
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerSponsorsRequestsController', OrganizerSponsorsRequestsController);
  
  OrganizerSponsorsRequestsController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'SponsorService',
    'ViewService',
    'STATUSES'
  ];
  
  function OrganizerSponsorsRequestsController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    SponsorService,
    __view,
    STATUSES
  ) {
    var vm = this;
    vm.loadingMarkPaid = false;
    vm.statuses = STATUSES.sponsor

    vm.requests = [];

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;
        vm.event = $rootScope.currentEvent;
        vm.appView = localStorage.getItem('app_view');

        SponsorService.getRequests()
          .then(
            function(response){
              vm.requests = SponsorService.sponsors(response.data.filter(function(item){
                return item.status !== 'draft';
              }));
            },
            $scope.handleError
          );
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        __view.setView(type);
      },

      handleCheckIn: function(request) {
        if ( request && request.id ) {
          SponsorService.checkedIn(request.id)
            .then(
              function() {
                var idx = vm.requests.indexOf(request);
                vm.requests[idx].checkedIn = true;
                Notification.success('Request was checked in');
              },
              $scope.handleError
            )
        }
      },

      onShowNotes: function(request){
        if ( request && request.id ){
          var modal = $uibModal.open({
            template: '\
              <div class="modal-body">\
                <div class="from-group">\
                  <label for="notes">Special requests or notes:</label>\
                  <textarea class="form-control" id="notes" name="notes" ng-model="sponsorRequest.notes" rows="7" placeholder="Notes"></textarea>\
                </div>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                <button class="btn btn-primary" type="button" ng-click="handleSave()">Save</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, SponsorService, Notification, request){
              $scope.sponsorRequest = request;
              $scope.handleSave = function(){
                SponsorService.updateRequest($scope.sponsorRequest.id, $scope.sponsorRequest)
                  .then(function(response){
                    Notification.success('Request notes were updated');
                    $uibModalInstance.close(response.data);
                  })
                  .catch(function(err){
                    console.error(err);
                  })
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });
          modal.result.then(function(result){
            var idx = vm.requests.indexOf(request);
            vm.requests[idx] = result;
          }, function(err){
            console.warn(err);
          })
        }
      },

      handleMarkPaid: function(request) {
        if ( request && request.id ) {
          vm.loadingMarkPaid = true;
          SponsorService.requestMarkPaid(request)
            .then(
              function(response) {
                vm.loadingMarkPaid = false;
                Notification.success('Request marked paid');
                SponsorService.update(response.data);
              },
              $scope.handleError
            )
        }
      },

      handleProfileVisibility: function(request){
        if ( request && request.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/sponsors/requests/requests.form.html',
            controller: 'OrganizerSponsorsFormRequestsController',
            controllerAs: 'vm',
            resolve: {
              request: function(){
                return request;
              }
            }
          }).result.then(
            function(result){
              var idx = vm.requests.indexOf(request);
              vm.requests[idx] = result;
            },
            function(err){
              console.log(err);
            }
          )
        }
      },

      handleTransaction:function(request) {
        if ( request && request.id ) {
          $uibModal.open({
            templateUrl: 'app/users/organizer/transaction/transaction.modal.html',
            controller: 'OrganizerTransactionController',
            controllerAs: 'vm',
            resolve: {
              request: function(){
                return request;
              },
              userType: function(){
                return 'esr';
              }
            }
          });
        }
      },

      handleDelete: function(request){
        if ( request && request.id ){
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title text-danger text-center">\Are you sure you want to delete sponsor request and all it\'s content?</h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDelete()">Delete</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, SponsorService, request){
              $scope.handleDelete = function(){
                SponsorService.deleteRequest(request.id)
                  .then(
                    function(){
                      $uibModalInstance.close();
                    },
                    function(err){
                      Notification.error(err.data.message);
                      $scope.handleCancel();
                    }
                  );
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(){
                Notification.success('Sponsor request was deleted');
                var idx = vm.requests.indexOf(request);
                vm.requests.splice(idx, 1);
              },
              function() {
              }
            );
        }
      },

      onChangeItemsOf: function() {
        var total = vm.filterSponsors.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      requestSponsor: function(request) {
        if ( $scope.sponsorRequestValue && $scope.sponsorRequestValue !== '' ) {
          var sponsor = request.sponsor;
          return (
            sponsor.name.toLowerCase().indexOf($scope.sponsorRequestValue.toLowerCase()) > -1 ||
            sponsor.username.toLowerCase().indexOf($scope.sponsorRequestValue.toLowerCase()) > -1 ||
            sponsor.email.toLowerCase().indexOf($scope.sponsorRequestValue.toLowerCase()) > -1 ||
            (request.description ? request.description.toLowerCase().indexOf($scope.sponsorRequestValue.toLowerCase()) > -1 : false) ||
            (request.booth ? request.booth.toLowerCase().indexOf($scope.sponsorRequestValue.toLowerCase()) > -1 : false) ||
            (request.individualFeaturedItems ? request.individualFeaturedItems.toLowerCase().indexOf($scope.sponsorRequestValue.toLowerCase()) > -1 : false)
          );
        }
        return request;
      },

      handleError: function(err) {
        Notification.error(err.data.message);
        vm.loadingMarkPaid = false;
      }
    });
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerSponsorsBulkController', OrganizerSponsorsBulkController);
  
  OrganizerSponsorsBulkController.$inject = [
    '$scope'
  ];

  function OrganizerSponsorsBulkController(
    $scope
  ){
    angular.extend($scope, {
      onInit: function(){

      }
    });
  }

})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerSponsorAttendantController', OrganizerSponsorAttendantController);

  function OrganizerSponsorAttendantController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    SponsorService,
    ViewService
  ) {
    var vm = this;
    $scope.pageLoading = true;

    $scope.attendants = [];

    vm.currentPage = 1;
    vm.event = $rootScope.currentEvent;
    vm.appView = localStorage.getItem('app_view');

    angular.extend($scope, {
      onInit: function(){
        $scope.fecthAttendantRequests();
      },

      fecthAttendantRequests: function(){
        SponsorService.getAttendantRequests()
          .then(function(response){
            $scope.attendantRequests = response.data;
            $scope.pageLoading = false;
          })
          .catch(function(err){
            console.error(err);
          });
      },

      onCheckInAttendant: function(request){
        if ( request && request.id ){
          SponsorService.actionCheckInAttendantRequest(request.id)
            .then(function(){
              var idx = $scope.attendantRequests.indexOf(request);
              $scope.attendantRequests[idx].checkedIn = true;
              Notification.success('Request was checked in')
            })
            .catch(function(err){
              console.error(err);
            });
        } else {
          console.error('No request ID present');
        }
      },

      onDeleteAttendant: function(user){
        if ( user && user.id ){

          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete <b>{{user.username}}</b> ({{user.name}}/{{user.email}}) sponsor attendant user account?<p>It will remove all the user data and operation can`t be undone</p>\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, user, AuthService){
              $scope.user = user;
              $scope.loading = false;
              
              $scope.handleConfirm = function(){
                $scope.loading = true;
                AuthService.onDelete(user.id)
                  .then(
                    function(){
                      $uibModalInstance.close();
                      $scope.loading = false;
                    },
                    function(err){
                      $scope.loading = false;
                      Notification.error(err.data.message);
                    }
                  );
              }
  
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              user: function(){
                return user;
              }
            }
          });
  
          modal.result
            .then(
              function(result){
                Notification.success('Sponsor attendant was removed');
                $scope.fecthAttendantRequests();
              },
              function() {
                console.log('Cancelled');
              }
            );

        } else {
          console.error('Sponsor attendant id not present');
        }
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        ViewService.setView(type);
      },

      onChangeItemsOf: function() {
        var total = $scope.attendantRequests.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },
    });
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerSponsorsAllController', OrganizerSponsorsAllController);
  
  OrganizerSponsorsAllController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'EventService',
    'UserGroupsService',
    'ViewService'
  ];
  
  function OrganizerSponsorsAllController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    __event,
    UserGroupsService,
    __view
  ) {
    var vm = this;

    $scope.groups = [];
    vm.userGroups = [];

    $scope.userGroupsSearch = '';

    $scope.sortDate = function(user){
      var date = new Date(user.createdOn);
      return date;
    }

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;
        vm.appView = localStorage.getItem('app_view');

        UserGroupsService.getGroups(true)
          .then(function(response){
            $scope.groups = response.data;
            return __event.getSponsors()
          })
          .then(function(response){
            var result = [];
            var groups = [];
            if ( response.data.length ){
              for ( var i in response.data ){
                var user = response.data[i];
                user['userGroups'] = [];

                if ( $scope.groups.length ){
                  for ( var j in $scope.groups ){
                    var group = $scope.groups[j];
                    if ( group.userIds && group.userIds.length ){
                      if ( group.userIds.indexOf(user.id) !== -1 ){

                        if ( groups.indexOf(group) === -1 ){
                          groups.push(group);
                        }

                        if ( user['userGroups'].indexOf(group.name) == -1 ){
                          user['userGroups'].push(group.name);
                        }

                      }
                    }
                  }
                }

                result.push(user);
              }
            }
            vm.userGroups = groups;
            vm.sponsors = result;
          })
          .catch(function(err){
            console.log(err);
          });
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        __view.setView(type);
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      },

      handleDownload: function() {
        $scope.loadingFile = true;
        var ids = vm.filterSponsors.map(function(item){
          return item.id;
        });
        __event.getCsvId('sponsor', ids.join(','))
          .then(
            function(response){
              var id = response.data.id+".csv";
              __event.getCsvFile(id)
                .then(
                  function(response){
                    var url = URL.createObjectURL(new Blob([response.data]));
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = moment().format('YYYYMMDDHHmm') +'-sponsors.csv';
                    a.target = '_blank';
                    // Need for ff
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  },
                  $scope.handleError
                );
              $scope.loadingFile = false;
            },
            $scope.handleError
          );
      },

      handleLoginAs: function(user) {
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/login-as/login-as.html',
          controller: 'OrganizerLoginAsController',
          resolve: {
            loginAs: function(){
              return user;
            }
          }
        });
      },

      handleEditProfile: function(sponsor){
        if ( sponsor && sponsor.id ){
          var modal = $uibModal.open({
            size: 'md',
            templateUrl: 'app/users/organizer/profile/profile.html',
            controller: 'OrganizerUserProfileFormController',
            controllerAs: 'vm',
            resolve: {
              userProfile: function(){
                return sponsor;
              }
            }
          });
          modal.result
            .then(
              function(result){
                for ( var i in vm.sponsors ){
                  var sponsor = vm.sponsors[i];
                  if ( sponsor.id === result.id ){
                    var idx = vm.sponsors.indexOf(sponsor);
                    vm.sponsors[idx] = result;
                  }
                }
                Notification.success('Sponsor profile was updated');
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleDeleteUser: function(sponsor) {
        var modal = $uibModal.open({
          size: 'md',
          template: '\
            <div class="modal-header">\
              <h4 class="modal-title text-danger" style="text-align: center;">\
                Are you sure you want to completely delete <b>{{sponsor.username}}</b> ({{sponsor.name}}/{{sponsor.email}}) sponsor user account?<p>It will remove all the user data and operation can`t be undone</p>\
              </h4>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
              </button>\
              <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance, sponsor, AuthService){
            $scope.sponsor = sponsor;
            $scope.loading = false;
            
            $scope.handleConfirm = function(){
              $scope.loading = true;
              AuthService.onDelete(sponsor.id)
                .then(
                  function(){
                    $uibModalInstance.close(sponsor);
                    $scope.loading = false;
                  },
                  function(err){
                    $uibModalInstance.dismiss('cancel');
                    $scope.loading = false;
                    Notification.error(err.data.message);
                  }
                );
            }

            $scope.handleCancel = function(){
              $uibModalInstance.dismiss('cancel');
            }
          },
          resolve: {
            sponsor: function(){
              return sponsor;
            }
          }
        });

        modal.result
          .then(
            function(result){
              Notification.success('Sponsor was removed');
              var index = vm.sponsors.indexOf(result);
              vm.sponsors.splice(index, 1);
              vm.currentPage = $scope.navigatePagination(vm.sponsors);
            },
            function() {
              console.log('Cancelled');
            }
          );
      },

      onChangeItemsOf: function() {
        var total = vm.filterSponsors.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerSponsorsAdsFormController', OrganizerSponsorsAdsFormController);
  
  OrganizerSponsorsAdsFormController.$inject = [
    '$scope',
    'moment',
    '$uibModalInstance',
    'Notification',
    'EventService',
    'SponsorService',
    'resolveData'
  ];

  function OrganizerSponsorsAdsFormController(
    $scope,
    moment,
    $uibModalInstance,
    Notification,
    __event,
    __sponsor,
    resolveData
  ) {
    var vm = this;

    vm.sponsorAd = {
      enabled: false,
      headline: false
    };

    $scope.formSubmitted = false;
    $scope.formLoading = false;
    $scope.isRequired = false;

    angular.extend($scope, {
      label: ( resolveData && resolveData.id ? 'Update' : 'Add'),
      datepickerFormat: 'MMMM dd, yyyy',
      datepickerOptions: {
        dateDisabled: false,
        minDate: new Date(),
        formatYear: 'yy',
        startingDay: 1
      },
      popup1: {
        opened: false
      },
      popup2: {
        opened: false
      }
    })

    angular.extend($scope, {
      onInit: function() {
        __event.getSponsors()
          .then(function(response){
            vm.sponsors = response.data;
          });

        if ( resolveData && resolveData.id ){
          vm.sponsorAd = resolveData;

          if ( vm.sponsorAd.validFrom && vm.sponsorAd.validTo ){
            vm.adStartDate = moment(moment.utc(vm.sponsorAd.validFrom)).local().toDate();
            vm.adEndDate = moment(moment.utc(vm.sponsorAd.validTo)).local().toDate();

            vm.startDate = vm.adStartDate;
            vm.endDate = vm.adEndDate;

            $scope.isRequired = true;
          }
        }
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;

        if ( form.$valid ) {
          $scope.formLoading = true;
          if ( vm.link ) {
            if ( vm.link.logo.length !== 0 ) {
              vm.sponsorAd.logo = {
                id: vm.link.logo.id,
                link: vm.link.logo.link
              };
            } else {
              vm.sponsor.logo = null;
            }
          }

          if ( vm.startDate && vm.endDate ){
            vm.sponsorAd.validFrom = moment(vm.startDate).local();
            vm.sponsorAd.validTo = moment(vm.endDate).local();
          }

          if ( resolveData && resolveData.id ) {
            __sponsor.onUpdate(resolveData.id, vm.sponsorAd)
              .then(
                function(response){
                  Notification.success('Sponsor was updated');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          } else {
            __sponsor.onAdd(vm.sponsorAd)
              .then(
                function(response){
                  Notification.success('Sponsor was added');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          }
        }
      },

      onPopup1Open: function(){
        $scope.popup1.opened = true;
      },
      onPopup2Open: function(){
        $scope.popup2.opened = true;
      },

      handleCancel: function(){
        $uibModalInstance.dismiss('cancel');
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    })
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerSponsorsAdsController', OrganizerSponsorsAdsController);
  
  OrganizerSponsorsAdsController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'SponsorService'
  ];

  function OrganizerSponsorsAdsController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    __sponsor
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;

        __sponsor.getSponsors()
          .then(
            function(response){
              vm.sponsors = __sponsor.sponsors(response.data);
            },
            $scope.handleError
          );
      },

      handleCreate: function(){
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/sponsors/ads/ads.form.html',
          controller: 'OrganizerSponsorsAdsFormController as vm',
          resolve: {
            resolveData: function(){
              return null;
            }
          }
        }).result.then(
          function(result){
            __sponsor.add(result);
          },
          function(err){
            console.warn(err);
          }
        );
      },

      handleEdit: function(data){
        if ( data && data.id ){
          $uibModal.open({
            size: 'md',
            templateUrl: 'app/users/organizer/sponsors/ads/ads.form.html',
            controller: 'OrganizerSponsorsAdsFormController as vm',
            resolve: {
              resolveData: function(){
                return data;
              }
            }
          }).result.then(
            function(result){
              __sponsor.update(result);
            },
            function(err){
              console.warn(err);
            }
          );
        }
      },

      handleDelete: function(sponsor) {
        if ( sponsor && sponsor.id ) {
          $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger text-center">Are you sure you want to delete sponsor ad: <b ng-bind="data.name"></b>?</h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDelete()">Delete</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, SponsorService, resolveData){
              $scope.data = resolveData;

              $scope.handleDelete = function(){
                SponsorService.onDelete(sponsor.id)
                  .then(function(){
                    $uibModalInstance.close(sponsor);
                  });
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              resolveData: function(){
                return sponsor;
              }
            }
          }).result.then(
            function(result){
              __sponsor.remove(result);
              Notification.success('Sponsor was removed');
              vm.currentPage = $scope.navigatePagination(vm.sponsors);
            },
            function() {
            }
          );
        }
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });

  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerScavengerHuntLeaderboardCtrl', OrganizerScavengerHuntLeaderboardCtrl);
  
  OrganizerScavengerHuntLeaderboardCtrl.$inject = [
    '$scope',
    'ScavengerHuntService',
    'ApproveService',
    'EventService',
    'Notification'
  ];
  
  function OrganizerScavengerHuntLeaderboardCtrl(
    $scope,
    ScavengerHuntService,
    ApproveService,
    EventService,
    Notification
  ) {
    var vm = this;
    $scope.leaderboard = [];
    $scope.loadingFile = false;

    angular.extend($scope, {
      onInit: function(){

        ScavengerHuntService.getLeaderboard()
          .then(function(response){
            var data = response.data;
            $scope.leaderboard = data;

            $scope.buildParticipants(data);
          });

      },

      buildParticipants: function(data){
        var participants = {};

        for ( var i in data ){
          var point = data[i];

          if ( point.checkinRecords && point.checkinRecords.length > 0 ){
            for ( var j in point.checkinRecords ){
              var record = point.checkinRecords[j];

              var p = participants[record.participantId];

              if ( !p ){
                participants[record.participantId] = {
                  user: record.participant,
                  points: data.map(function(item){
                    return {
                      id: item.id,
                      name: item.name,
                      record: null
                    }
                  })
                }
              }

              angular.forEach(participants[record.participantId].points, function(item){
                if ( item.id === record.checkinPointId ){
                  item['record'] = record;
                }
              });
            }
          }
        }

        $scope.participants = participants;
      },

      onApproveCheckin: function(point){
        ApproveService(
          'Are you sure you want to approve '+ point.name +' check-in?',
          'Yes',
          function(){
            return ScavengerHuntService.approveCheckin(point.record.id)
          },
          'No'
        ).result.then(
          function(response){
            var data = response.data;
            $scope.changeStatus(data);
            Notification.success('Check-in point was approved');
          },
          function(err){
            console.log('Cancel');
          }
        );
      },

      onRejectCheckin: function(point){
        ApproveService(
          'Are you sure you want to reject '+ point.name +' check-in?',
          'Reject',
          function(){
            return ScavengerHuntService.rejectCheckin(point.record.id)
          }
        ).result.then(
          function(response){
            var data = response.data;
            $scope.changeStatus(data);
            Notification.success('Check-in point was rejected');
          },
          function(err){
            console.log('Cancel');
          }
        );
      },

      onExportCSV: function(){
        $scope.loadingFile = true;

        ScavengerHuntService.exportLeaderboard()
          .then(function(response){
            var id = response.data.id +'.csv';
            return EventService.getCsvFile(id);
          })
          .then(function(response){
            var url = URL.createObjectURL(new Blob([response.data]));
            var a = document.createElement('a');
            a.href = url;
            a.download = moment().format('YYYYMMDDHHmm') +'-leaderboard.csv';
            a.target = '_blank';
            // Need for ff
            document.body.appendChild(a);
            a.click();
            a.remove();

            $scope.loadingFile = false;
          })
          .catch(function(err){
            console.log(err);
            $scope.loadingFile = false;
          })
      },

      changeStatus: function(data){
        angular.forEach($scope.leaderboard, function(item){
          if ( item.id === data.checkinPointId ){
            for ( var j in item.checkinRecords ){
              var checkin = item.checkinRecords[j];
              if ( checkin.id === data.id ){
                checkin['status'] = data.status;
              }
            }
          }
        });

        $scope.buildParticipants($scope.leaderboard);
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerScavengerHuntCheckinPointsCtrl', OrganizerScavengerHuntCheckinPointsCtrl);
  
  OrganizerScavengerHuntCheckinPointsCtrl.$inject = [
    '$scope',
    '$document',
    '$uibModal',
    'ApproveService',
    'ScavengerHuntService',
    'Notification'
  ];
  
  function OrganizerScavengerHuntCheckinPointsCtrl(
    $scope,
    $document,
    $uibModal,
    ApproveService,
    ScavengerHuntService,
    Notification
  ) {
    var vm = this;
    $scope.checkinPoints = [];
    $scope.lat = null;
    $scope.lng = null;

    var bounds = new google.maps.LatLngBounds();
    var map;
    var poly;
    var markers = [];

    var directionIcons = [
      {label: 'By Car', icon: 'fa fa-car', mode: 'driving'},
      {label: 'Bike', icon: 'fa fa-bicycle', mode: 'bicycling'},
      {label: 'Walking', icon: 'fa fa-male', mode: 'walking'}
    ];

    $scope.fieldLocation = '';

    var lat = 27.942749279781406;
    var lng = -82.45903329675298;

    angular.extend($scope, {
      onInit: function(){

        ScavengerHuntService.getPoints()
          .then(function(response){
            var data = response.data;

            $scope.checkinPoints = response.data;

            $scope.buildMap(data);

            if ( navigator.geolocation ){
              navigator.geolocation.getCurrentPosition(
                function(position){
                  $scope.lat = position.coords.latitude;
                  $scope.lng = position.coords.longitude;
    
                  if(!$scope.checkinPoints || $scope.checkinPoints.length==0){
                    map.setCenter({
                      lat: $scope.lat,
                      lng: $scope.lng
                    });
                  }
                }, function(err){
                  console.log(err);
                }
              )
            }
          })
      },

      buildMap: function(points){
        var mapSelector = $document[0].querySelector('#scavengerHuntMap');

        var center = {
          lat: $scope.lat ? $scope.lat : lat,
          lng: $scope.lng ? $scope.lng : lng
        };

        map = new google.maps.Map(mapSelector, {
          zoom: 16,
          maxZoom: 20,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          clickableIcons: false,
          streetViewControl: false,
          fullscreenControl: true,
          center: center,
          gestureHandling: 'greedy',
          styles: [
            {
              featureType: 'poi',
              stylers: [
                { visibility: 'off' }
              ],
            },{
              featureType: 'transit',
              stylers: [
                { visibility: 'off' }
              ]
            }
          ]
        });

        // poly = new google.maps.Polyline({
        //   strokeColor: '#FF0000',
        //   strokeOpacity: 1.0,
        //   strokeWeight: 2,
        //   icons: [{
        //     icon: {
        //       path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        //     },
        //     offset: '100%',
        //     repeat: '100px'
        //   }],
        // });

        if ( points.length ){
          points.sort(function(a, b){ return a.order - b.order; });
          $scope.buildPoint(map, points);
        }

        $scope.buildMapField(map);
      },

      buildPoint: function(map, points){
        for ( var i in markers ){
          markers[i].setMap(null);
        }

        var polyCoordinates = [];

        for ( var i = 0; i < points.length; i++ ){
          var point = points[i];

          // polyCoordinates.push({
          //   lat: point.lat,
          //   lng: point.lng
          // });

          var marker = new google.maps.Marker();
          var latLng = new google.maps.LatLng(point.lat, point.lng);
          marker.setPosition(latLng)
          marker.setMap(map);
          marker.addListener('click', function() {
            if(this.infowindow){
              this.infowindow.close();
              this.infowindow.open(map, this);
            }
          });

          markers.push(marker);

          bounds.extend(latLng);

          marker.infowindow = new google.maps.InfoWindow();
          var pointInfoPopupContent = '<div class="infowindow-sh-content"><h4 class="_name">'+ point.name +'</h4>';
          if(point.description){
            pointInfoPopupContent += ('<span class="_description">'+point.description+'</p>').replace(/\n/g, '<br />');
          }

        var directionsMarkup = '<ul class="list-directionIcons">'
        
        for ( var j in directionIcons ){
          var item = directionIcons[j];

          directionsMarkup+='<li><a href="'+ 'https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination='+ 
            point.lat + ','+ point.lng +'&travelmode='+ item.mode + '" target="_blank">';
          directionsMarkup+='<i class="'+item.icon+'" "aria-hidden"="true"></i>';
          directionsMarkup+='<span>'+item.label+'</span>';
          directionsMarkup+='</a></li>';
        }
          directionsMarkup+='</ul>';
          pointInfoPopupContent+=directionsMarkup;
          pointInfoPopupContent+='</div>';
          marker.infowindow.setContent(pointInfoPopupContent);
          //marker.infowindow.open(map, marker);

          map.fitBounds(bounds);
        }

        //poly.setPath(polyCoordinates);
        //poly.setMap(map);
      },

      buildMapField: function(map){
        var fieldLocation = $document[0].querySelector('#scavengerHuntFieldLocation');

        map.controls[google.maps.ControlPosition.TOP_LEFT].push(fieldLocation);

        var location = new google.maps.places.SearchBox(fieldLocation);

        map.addListener('bounds_changed', function() {
          location.setBounds(map.getBounds());
        });

        location.addListener('places_changed', function() {
          var places = location.getPlaces();
          if ( places.length == 0 ) return;
          var bounds = new google.maps.LatLngBounds();
          angular.forEach(places, function(place) {
            ( place.geometry.viewport ) ? bounds.union(place.geometry.viewport) : bounds.extend(place.geometry.location);
          });
          map.fitBounds(bounds);
        });
      },

      onCreatePoint: function(lat, lng){
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/scavenger-hunt/check-in-points/form/form.html',
          controller: 'OrganizerScavengerHuntCheckinPointsFormCtrl as vm',
          resolve: {
            point: function(){
              return null;
            },
            checkinPoints: function(){
              return $scope.checkinPoints;
            }
          }
        }).result.then(
          function(result){
            $scope.checkinPoints.push(result);
            $scope.checkinPoints.sort(function(a, b){ return a.order - b.order; });

            $scope.buildPoint(map, $scope.checkinPoints);
          },
          function(cancel){
            console.log(cancel);
          }
        )
      },

      onEditPoint: function(point){
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/scavenger-hunt/check-in-points/form/form.html',
          controller: 'OrganizerScavengerHuntCheckinPointsFormCtrl as vm',
          resolve: {
            point: function(){
              return point;
            },
            checkinPoints: function(){
              return null;
            }
          }
        }).result.then(
          function(result){
            $scope.checkinPoints.map(function(p){
              return p.id === result.id ? angular.extend({}, p, result) : p
            });
            $scope.checkinPoints.sort(function(a, b){  return b.order - a.order; });

            $scope.buildPoint(map, $scope.checkinPoints);
          },
          function(cancel){
            console.log(cancel);
          }
        )
      },

      onDeletePoint: function(point){
        ApproveService(
          'Are you sure you want to delete point: '+ point.name +'?',
          'Delete',
          function(){
            return ScavengerHuntService.deletePoint(point.id)
          }
        ).result.then(
          function(){
            var idx = $scope.checkinPoints.indexOf(point);
            $scope.checkinPoints.splice(idx, 1);

            $scope.buildPoint(map, $scope.checkinPoints);
          },
          function(err){
            Notification.error(err.data.message);
          }
        );
      }
    });

  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerParticipantsTeamFormController', OrganizerParticipantsTeamFormController);

  function OrganizerParticipantsTeamFormController(
    $scope,
    $uibModal,
    $uibModalInstance,
    $timeout,
    Notification,
    TeamService,
    UserGroupsService,
    teamById
  ) {
    var vm = this;
    var userSearch;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    angular.extend($scope, {
      label: !!teamById ? 'Update' : 'Create',
      searchType: 'participant',
      onInit: function() {
        if ( !!teamById ) {
          vm.usersInTeam = [];
          TeamService.getTeamById(teamById.id)
            .then(
              function(response) {
                var data = response.data;
                vm.team = data;
                vm.usersInTeam = data.users;
              },
              $scope.handleError
            );
        }
      },
      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err);
      },
      onClose: function() {
        $uibModalInstance.dismiss('cancel');
      },
      handleUsersSearch: function(query) {
        $timeout.cancel(userSearch);
        if ( query.length !== 0 ) {
          userSearch = $timeout(function(){
            UserGroupsService.searchUsers($scope.searchType, query)
              .then(
                function(response){
                  vm.usersSearch = response.data;
                },
                $scope.handleError
              );
          }, 1000);
        }
      },
      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          vm.team.userIds = [];
          angular.forEach(vm.usersInTeam, function(item){
            vm.team.userIds.push(item.id)
          });
          if ( !!teamById ) {
            TeamService.updateTeam(teamById.id, vm.team)
              .then(
                function(response){
                  TeamService.update(response.data);
                  Notification.success('Team was updated');
                  $scope.onClose();
                },
                $scope.handleError
              );
          } else {
            TeamService.addTeam(vm.team)
              .then(
                function(response){
                  TeamService.add(response.data);
                  Notification.success('Team was added');
                  $scope.onClose();
                },
                $scope.handleError
              );
          }
        }
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerParticipantsTeamsController', OrganizerParticipantsTeamsController);
  
  OrganizerParticipantsTeamsController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'TeamService'
  ];

  function OrganizerParticipantsTeamsController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    __team
  ) {
    var vm = this;
    vm.currentPage = 1;
    vm.teams = [];

    angular.extend($scope, {
      onInit: function() {

        __team.getTeams()
          .then(
            function(response) {
              vm.teams = __team.teams(response.data);
            },
            $scope.handleError
          );

      },
      handleError: function(err) {
        Notification.error(err);
      },

      onAdd: function() {
        $scope.modalForm(null);
      },

      onUpdate: function(team) {
        $scope.modalForm(team);
      },

      onDelete: function(team) {
        if ( team && team.id ) {
          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete <b>{{team.name}}</b> ?\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, team, TeamService){
              $scope.team = team;
              $scope.loading = false;
              
              $scope.handleConfirm = function(){
                $scope.loading = true;

                TeamService.deleteTeam(team.id)
                  .then(
                    function(response){
                      $uibModalInstance.close(team);
                      $scope.loading = false;
                    },
                    function(err){
                      $uibModalInstance.dismiss('cancel');
                      $scope.loading = false;
                      Notification.error(err.data.message);
                    }
                  );
              }

              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              team: function(){
                return team;
              }
            }
          });

          modal.result
            .then(
              function(result){
                __team.remove(result);
                Notification.success('Team was removed');
                vm.currentPage = $scope.navigatePagination(vm.teams);
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      modalForm: function(data) {
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/participants/teams/teams.form.html',
          controller: 'OrganizerParticipantsTeamFormController',
          controllerAs: 'vm',
          resolve: {
            teamById: function(){
              return data;
            }
          }
        });
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerParticipantsReservationsController', OrganizerParticipantsReservationsController);
  
  OrganizerParticipantsReservationsController.$inject = [
    '$rootScope',
    '$scope',
    'Notification',
    'RequestReservationService',
    'ViewService',
    'STATUSES'
  ];
  
  function OrganizerParticipantsReservationsController(
    $rootScope,
    $scope,
    Notification,
    RequestReservationService,
    ViewService,
    STATUSES
  ) {
    var vm = this;

    $scope.reservations = [];

    angular.extend($scope, {
      moment: moment,
      statuses: STATUSES.participant.concat(['draft'])
    });

    angular.extend($scope, {
      onInit: function() {
        vm.currentPage = 1;
        vm.appView = localStorage.getItem('app_view');

        RequestReservationService.getReservationRequests()
          .then(function(response){
            $scope.reservations = response.data;
          })
          .catch(function(err){
            console.error(err);
          });

      },

      handleCheckIn: function(request){
        if ( request && request.id ){
          RequestReservationService.checkInReservationRequest(request.id)
            .then(
              function(response) {
                var data = response.data;
                angular.forEach($scope.reservations, function(item){
                  if ( item.id === data.id ) {
                    var index = $scope.reservations.indexOf(item);
                    $scope.reservations[index] = data;
                  }
                });
                Notification.success('Request was checked in');
              },
              $scope.handleError
            )
        }
      },

      handleMarkPaid: function(request) {
        if ( request && request.id ) {
          $rootScope.loadingInformation = true;
          RequestReservationService.markAsPaidReservationRequest(request.id)
            .then(function(response) {
              var data = response.data;
              var idx = $scope.reservations.indexOf(request);
              $scope.reservations[idx].status = data.status;
              Notification.success('Request marked paid');
              $rootScope.loadingInformation = false;
            })
            .catch(function(err){
              $rootScope.loadingInformation = false;
              console.log(err)
            });
        }
      },

      handleCancel: function(request) {
        if ( request && request.id ) {
          $rootScope.loadingInformation = true;
          RequestReservationService.cancelReservationRequest(request.id)
            .then(function(response) {
              var data = response.data;
              var idx = $scope.reservations.indexOf(request);
              $scope.reservations[idx].status = data.status;
              Notification.success('Request was cancelled');
              $rootScope.loadingInformation = false;
            })
            .catch(function(err){
              $rootScope.loadingInformation = false;
              console.log(err)
            });
        }
      },

      requestParticipant: function(request) {
        if ( $scope.participantRequestValue && $scope.participantRequestValue !== '' ) {
          var participant = request.participant;
          return (
            participant.name.toLowerCase().indexOf($scope.participantRequestValue.toLowerCase()) > -1 ||
            participant.username.toLowerCase().indexOf($scope.participantRequestValue.toLowerCase()) > -1 ||
            participant.email.toLowerCase().indexOf($scope.participantRequestValue.toLowerCase()) > -1
          );
        }
        return request;
      },

      onChangeItemsOf: function() {
        var total = vm.filterParticipants.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        ViewService.setView(type);
      }
    });

    $scope.toMonth = function(date){
      return moment(moment.utc(date)).local().format('MMMM DD HH:mm');
    }

    $scope.toHours = function(time){
      return moment(moment.utc(time)).local().format('HH:mm')
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerParticipantsRequestsController', OrganizerParticipantsRequestsController);
  
  OrganizerParticipantsRequestsController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'moment',
    'Notification',
    'EventService',
    'ParticipantService',
    'PriceService',
    'ViewService',
    'STATUSES'
  ];

  function OrganizerParticipantsRequestsController(
    $rootScope,
    $scope,
    $uibModal,
    moment,
    Notification,
    EventService,
    __participant,
    __package,
    __view,
    STATUSES
  ) {
    var vm = this;
    vm.loadingMarkPaid = false;

    angular.extend($scope, {
      moment: moment,
      statuses: STATUSES.participant
    });

    angular.extend($scope, {
      onInit: function() {
        // console.log($rootScope);
        vm.currentPage = 1;
        vm.appView = localStorage.getItem('app_view');

        __participant.getRequests()
          .then(
            function(response) {
              vm.requests = response.data.filter(function(item){
                return item.status !== 'draft';
              });
            },
            $scope.handleError
          );

        __package.getPrices('','participation')
          .then(
            function(response){
              vm.pricePackages = response.data;
            },
            $scope.handleError
          );
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        __view.setView(type);
      },

      filterOnPricePackages: function(request){
        if ( $scope.filterPricePackageID === 'all' ){
          return request;
        }
        if ( $scope.filterPricePackageID && $scope.filterPricePackageID !== '' ){
          var id = parseInt($scope.filterPricePackageID, 10);
          var items = request.items;
          for ( var i in items ){
            if ( items[i].pricePackageId === id ){
              return request;
            }
          }
        }
      },

      requestParticipant: function(request) {
        if ( $scope.participantRequestValue && $scope.participantRequestValue !== '' ) {
          var participant = request.participant;
          return (
            participant.name.toLowerCase().indexOf($scope.participantRequestValue.toLowerCase()) > -1 ||
            participant.username.toLowerCase().indexOf($scope.participantRequestValue.toLowerCase()) > -1 ||
            participant.email.toLowerCase().indexOf($scope.participantRequestValue.toLowerCase()) > -1 ||
            (request.code && request.code.indexOf($scope.participantRequestValue.toLowerCase()) > -1) ||
            (request.bibNumber && request.bibNumber.indexOf($scope.participantRequestValue.toLowerCase()) > -1)
          );
        }
        return request;
      },

      handleMarkPaid: function(request) {
        if ( request && request.id ) {
          // vm.loadingMarkPaid = true;
          $rootScope.loadingInformation = true;
          __participant.requestMarkPaid(request)
            .then(function() {
              // angular.forEach(vm.requests, function(item){
              //   if ( item.id === request.id ) {
              //     var index = vm.requests.indexOf(item);
              //     vm.requests[index] = response.data;
              //   }
              // });
              // vm.loadingMarkPaid = false;
              return __participant.getRequests()
            })
            .then(function(response){
              Notification.success('Request marked paid');
              $rootScope.loadingInformation = false;
              vm.requests = response.data.filter(function(item){
                return item.status !== 'draft';
              });
            })
            .catch($scope.handleError)
        }
      },

      handleDownload: function(){
        $scope.loadingFile = true;
        var ids = vm.filterParticipants.map(function(item){
          return item.id;
        });
        __participant.getRequestCsv(ids.join(','))
          .then(
            function(response){
              var id = response.data.id+'.csv';
              EventService.getCsvFile(id)
                .then(
                  function(response){
                    var url = URL.createObjectURL(new Blob([response.data]));
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = moment().format('YYYYMMDDHHmm') +'-participant-requests.csv';
                    a.target = '_blank';
                    // Need for ff
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  },
                  $scope.handleError
                );
              $scope.loadingFile = false;
            },
            function(){
              $scope.loadingFile = false;
            }
          );
      },

      handleCheckIn: function(request) {
        if ( request && request.id ) {
          __participant.checkedInRequest(request.id)
            .then(
              function(response) {
                var data = response.data;
                angular.forEach(vm.requests, function(item){
                  if ( item.id === data.id ) {
                    var index = vm.requests.indexOf(item);
                    vm.requests[index] = data;
                  }
                });
                Notification.success('Request was checked in');
              },
              $scope.handleError
            )
        }
      },

      handleSetBibNumber: function(request) {
        if ( request && request.id ) {
          $uibModal.open({
            templateUrl: 'app/users/organizer/participants/modals/bib.modal.html',
            controller: function($scope, $uibModalInstance, ParticipantService, resolveData){
              $scope.formSubmitted = false;
              $scope.formLoading = false;

              $scope.bibNumber = parseInt(resolveData.bibNumber) || null

              $scope.handleSetBib = function(){
                $scope.formSubmitted = true;
                var form = $scope.form;
                if ( form.$valid ) {
                  $scope.formLoading = true;

                  ParticipantService.setRequestBibNumber(resolveData.id, $scope.bibNumber)
                    .then(function(response) {
                      Notification.success('Bib number was updated');
                      $uibModalInstance.close(response.data);
                    });
                }
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              resolveData: function(){
                return request;
              }
            }
          }).result.then(
            function(result){
              angular.forEach(vm.requests, function(item){
                if ( item.id === result.id ) {
                  var index = vm.requests.indexOf(item);
                  vm.requests[index] = result;
                }
              });
            }
          );
        }
      },

      onShowNotes: function(request){
        if ( request && request.id ){
          $uibModal.open({
            template: '\
              <div class="modal-body">\
                <div class="from-group">\
                  <label for="notes">Special requests or notes:</label>\
                  <textarea class="form-control" id="notes" name="notes" ng-model="participantRequest.notes" rows="7" placeholder="Notes"></textarea>\
                </div>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                <button class="btn btn-primary" type="button" ng-click="handleSave()">Save</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, ParticipantService, Notification, request){
              $scope.participantRequest = request;
              $scope.handleSave = function(){
                ParticipantService.onUpdate($scope.participantRequest.id, $scope.participantRequest)
                  .then(function(){
                    Notification.success('Request notes were updated');
                    $uibModalInstance.close();
                  })
                  .catch(function(err){
                    console.error(err);
                  });
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });
        }
      },

      handleCancel: function(request){
        if ( request && request.id ) {
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">Are you sure you want to cancel request?</h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleCancel()">Cancel</button>\
                <button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, request){
              $scope.handleCancel = function(){
                $uibModalInstance.close(request);
              }
              $scope.handleClose = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(result){
                $rootScope.loadingInformation = true;
                __participant.onCancel(result.id)
                  .then(
                    function(response){
                      $rootScope.loadingInformation = false;
                      Notification.success('Participant request was cancelled');

                      var idx = vm.requests.indexOf(result);
                      vm.requests[idx] = response.data;
                      // vm.requests.splice(index, 1);
                    },
                    $scope.handleError
                  );
              },
              function() {
                console.log('Deleted');
              }
            );
        }
      },

      handleDelete: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Are you sure you want to delete participant request and all it\'s content?\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDelete()">Delete</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, request){
              $scope.handleDelete = function(){
                $uibModalInstance.close(request);
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(result){
                $rootScope.loadingInformation = true;
                __participant.onDelete(result.id)
                  .then(
                    function(){
                      $rootScope.loadingInformation = false;
                      Notification.success('Participant request was deleted');
                      var index = vm.requests.indexOf(result);
                      vm.requests.splice(index, 1);
                    },
                    $scope.handleError
                  );
              },
              function() {
                console.log('Deleted');
              }
            );
        }
      },

      handleTransaction:function(request) {
        if ( request.id ) {
          var modal = $uibModal.open({
            templateUrl: 'app/users/organizer/transaction/transaction.modal.html',
            controller: 'OrganizerTransactionController',
            controllerAs: 'vm',
            resolve: {
              request: function(){
                return request;
              },
              userType: function(){
                return 'epr';
              }
            }
          });
        }
      },

      onlyForGift: function(request){
        var result = true;
        if ( request.items && request.items.length ){
          var items = request.items;
          for ( var i in items ){
            var item = items[i];
            if ( !item.participantName || !item.participantEmail ){
              result = false;
            }
          }
        }
        return result;
      },

      onChangeItemsOf: function() {
        var total = vm.filterParticipants.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      handleError: function(err) {
        Notification.error(err.data.message);
        $rootScope.loadingInformation = false;
        vm.loadingMarkPaid = false;
      }
    });

    function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerParticipantsBulkRegisterController', OrganizerParticipantsBulkRegisterController);
  
  OrganizerParticipantsBulkRegisterController.$inject = [
    '$scope'
  ];

  function OrganizerParticipantsBulkRegisterController(
    $scope
  ) {
    angular.extend($scope, {
      onInit: function() {
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerParticipantsAllController', OrganizerParticipantsAllController);
  
  OrganizerParticipantsAllController.$inject = [
    '$rootScope',
    '$scope',
    '$log',
    '$uibModal',
    'moment',
    'Notification',
    'EventService',
    'ParticipantService',
    'UserGroupsService',
    'ViewService'
  ];

  function OrganizerParticipantsAllController(
    $rootScope,
    $scope,
    $log,
    $uibModal,
    moment,
    Notification,
    __event,
    ParticipantService,
    UserGroupsService,
    __view
  ) {
    var vm = this;

    $scope.groups = [];
    vm.userGroups = [];
    vm.requests = [];

    $scope.userGroupsSearch = '';

    $scope.sortDate = function(user){
      var date = new Date(user.createdOn);
      return date;
    }

    angular.extend($scope, {
      loadingFile: false,
      onInit: function() {
        vm.currentPage = 1;
        vm.appView = localStorage.getItem('app_view');

        ParticipantService.getRequests()
          .then(function(response){
            vm.requests = response.data;
            return UserGroupsService.getGroups(true);
          })
          .then(function(response){
            $scope.groups = response.data;
            return __event.getParticipants()
          })
          .then(function(response){
            var result = [];
            var groups = [];
            if ( response.data.length ){
              for ( var i in response.data ){
                var user = response.data[i];
                user['userGroups'] = [];

                if ( $scope.groups.length ){
                  for ( var j in $scope.groups ){
                    var group = $scope.groups[j];
                    if ( group.userIds && group.userIds.length ){
                      if ( group.userIds.indexOf(user.id) !== -1 ){

                        if ( groups.indexOf(group) === -1 ){
                          groups.push(group);
                        }

                        if ( user['userGroups'].indexOf(group.name) == -1 ){
                          user['userGroups'].push(group.name);
                        }

                      }
                    }
                  }
                }

                result.push(user);
              }
            }
            vm.userGroups = groups;
            vm.participants = result;
          })
          .catch(function(err){
            console.log(err)
          });
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        __view.setView(type);
      },

      handleLoginAs: function(user) {
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/login-as/login-as.html',
          controller: 'OrganizerLoginAsController',
          resolve: {
            loginAs: function(){
              return user;
            }
          }
        });
      },

      handleEditProfile: function(participant){
        if ( participant && participant.id ){
          var modal = $uibModal.open({
            size: 'md',
            templateUrl: 'app/users/organizer/profile/profile.html',
            controller: 'OrganizerUserProfileFormController',
            controllerAs: 'vm',
            resolve: {
              userProfile: function(){
                return participant;
              }
            }
          });
          modal.result
            .then(
              function(result){
                for ( var i in vm.participants ){
                  var participant = vm.participants[i];
                  if ( participant.id === result.id ){
                    var idx = vm.participants.indexOf(participant);
                    vm.participants[idx] = result;
                  }
                }
                Notification.success('Participant profile was updated');
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleDeleteUser: function(participant) {
        var modal = $uibModal.open({
          size: 'md',
          template: '\
            <div class="modal-header">\
              <h4 class="modal-title text-danger" style="text-align: center;">\
                Are you sure you want to completely delete <b>{{participant.username}}</b> ({{participant.name}}/{{participant.email}}) participant user account?<p>It will remove all the user data and operation can`t be undone</p>\
              </h4>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
              </button>\
              <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance, participant, AuthService){
            $scope.participant = participant;
            $scope.loading = false;
            
            $scope.handleConfirm = function(){
              $scope.loading = true;
              AuthService.onDelete(participant.id)
                .then(
                  function(){
                    $uibModalInstance.close(participant);
                    $scope.loading = false;
                  },
                  function(err){
                    $uibModalInstance.dismiss('cancel');
                    $scope.loading = false;
                    Notification.error(err.data.message);
                  }
                );
            }

            $scope.handleCancel = function(){
              $uibModalInstance.dismiss('cancel');
            }
          },
          resolve: {
            participant: function(){
              return participant;
            }
          }
        });

        modal.result
          .then(
            function(result){
              Notification.success('Participant was removed');
              var index = vm.participants.indexOf(result);
              vm.participants.splice(index, 1);
              vm.currentPage = $scope.navigatePagination(vm.participants);
            },
            function() {
              console.log('Cancelled');
            }
          );
      },

      handleDownload: function() {
        $scope.loadingFile = true;
        var ids = vm.filterParticipants.map(function(item){
          return item.id;
        });
        __event.getCsvId('participant', ids.join(','))
          .then(
            function(response){
              var id = response.data.id +'.csv';
              __event.getCsvFile(id)
                .then(
                  function(response){
                    var url = URL.createObjectURL(new Blob([response.data]));
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = moment().format('YYYYMMDDHHmm') +'-participants.csv';
                    a.target = '_blank';
                    // Need for ff
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  },
                  $scope.handleError
                );
              $scope.loadingFile = false;
            },
            $scope.handleError
          );
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      },
      
      onChangeItemsOf: function() {
        var total = vm.filterParticipants.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      handleError: function(err) {
        $log.error(err);
      }
    });

  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ToolsRoute', ToolsRoute);
  
  ToolsRoute.$inject = [
    
  ];

  function ToolsRoute(
    
  ) {

  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ToolsResponsibilityZone', ToolsResponsibilityZone);
  
  function ToolsResponsibilityZone(
    
  ) {
    return {
      onInitZone: function(zone, volunteerRequests){
        zone.volunteerData = {
          request: null,
          startDate: null,
          endDate: null,
          startTime: null,
          endTime: null
        };

        zone.volunteerAssignmentsRequests = [];
        if (
          zone.volunteerAssignments &&
          zone.volunteerAssignments.length !== 0
        ) {
          for ( var i in volunteerRequests ){
            var rq = volunteerRequests[i];
            for ( var j in zone.volunteerAssignments ){
              var volunteer = zone.volunteerAssignments[j];
              if ( rq.id === volunteer.volunteerRequestId ){
                zone.volunteerAssignmentsRequests.push({
                  request: rq,
                  from: volunteer.from,
                  to: volunteer.to
                });
              }
            }
          }
        }
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ToolsMap', ToolsMap);
  
  ToolsMap.$inject = [
    '$uibModal'
  ];

  function ToolsMap(
    $uibModal
  ) {
    var types = ['eventZones', 'respZones', 'routes', 'booths'];

    var drawType = {
      overlay: 'Overlay',
      booth: 'Booth',
      route: 'Route',
      respZone: 'RespZone',
      eventZone: 'EventZone'
    };

    var selectedItem = null;
    var selectedItemColor = null;

    function removeMapItem(item){
      if ( item ){
        return $uibModal.open({
          template: '\
            <div class="modal-header">\
              <h3 class="modal-title" style="text-align: center;">\
                Are you sure you want to remove {{label}} from map?\
              </h3>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              <button class="btn btn-primary" type="button" ng-click="handleSubmit()">Remove</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance, item){
            if ( item.kind === drawType.booth ){
              $scope.label = 'booth';
            } else if ( item.kind === drawType.route ){
              $scope.label = 'route';
            } else if ( item.kind === drawType.respZone ){
              $scope.label = 'responsibility zone';
            } else if ( item.kind === drawType.eventZone ) {
              $scope.label = 'event zone';
            }
            $scope.handleSubmit = function(){
              $uibModalInstance.close();
            }
            $scope.handleCancel = function(){
              $uibModalInstance.dismiss('cancel');
            }
          },
          resolve: {
            item: function(){
              return item;
            }
          }
        });
      } else {
        console.error('No item selected');
      }
    }

    function onSelectedItem(){
      return {
        setItem: function(item){
          selectedItemColor.setColor(item);
          selectedItem = item;
          selectedItem.focus();
        },
        getItem: function(){
          return selectedItem;
        },
        clearItem: function(){
          if ( selectedItem ){
            selectedItem.unfocus();
            selectedItem = null;
          }
        }
      }
    }

    function onSelectedItemColor(){
      return {
        setColor: function(item){
          if ( item.kind === drawType.route ){
            selectedItemColor = item.strokeColor;
          } else {
            selectedItemColor = item.fillColor;
          }
        },
        changeColor: function(item, color){
          item.setColor(color);
          if ( item.kind === drawType.route ){
            item.strokeColor = color;
          } else {
            item.fillColor = color;
          }
        }
      }
    }

    return {
      types: types,
      drawType: drawType,

      onSelectedItem: onSelectedItem,
      onSelectedItemColor: onSelectedItemColor,

      removeMapItem: removeMapItem,
    }
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ToolsEventZone', ToolsEventZone);
  
  ToolsEventZone.$inject = [
    
  ];

  function ToolsEventZone(
    
  ) {

  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ToolsBooth', ToolsBooth);
  
  ToolsBooth.$inject = [
    '$rootScope',
    '$state',
    'MapService',
    'ReservationService'
  ];

  function ToolsBooth(
    $rootScope,
    $state,
    MapService,
    ReservationService
  ) {
    var step = 3.28084;
    var defaultBoothIcon = 'assets/images/default.png';
    var defaultBoothColor = '#000000';

    function onInitBooth(booth, routes, indoorMaps, userCommercialAssignments, userNonCommercialAssignments){

      booth.reservations = [];
      // booth.indoorMaps = [];
      booth.nonCommercialList = [];
      booth.commercialList = [];

      booth.nonCommercialData = {
        isValid: true,
        user: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        notes: ''
      };

      booth.commercialData = {
        isValid: true,
        request: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        notes: ''
      };

      if ( booth.route ){
        booth.selectedRoute = routes.filter(function(item){
          return item.id === booth.route.id;
        })[0];
      } else {
        booth.selectedRoute = null;
      }

      if ( $rootScope.currentEvent.modules.indexOf('reservations') > -1 ){
        ReservationService.getReservations(booth.id)
          .then(function(response){
            booth.reservations = response.data;
          })
          .catch(function(err){
            console.error(err);
          });
      }

      booth.hasRoutes = [];
      booth.hasIndoorMaps = [];
      booth.unlinkedRoutes = [];

      for ( var i in indoorMaps ){
        var indoorMap = indoorMaps[i];
        if ( booth.indoorMapIds.indexOf(indoorMap.id) !== -1 ){
          booth.hasIndoorMaps.push(indoorMap);
        }
      }

      for ( var i in routes ){
        if ( booth.routeIds && booth.routeIds.indexOf(routes[i].id) !== -1 ){
          booth.hasRoutes.push(routes[i]);
        } else {
          booth.unlinkedRoutes.push(routes[i]);
        }
      }

      if ( booth.userNonCommercialAssignments && booth.userNonCommercialAssignments.length ){
        for ( var i in booth.userNonCommercialAssignments ){
          var nonAssign = booth.userNonCommercialAssignments[i];
          var user = userNonCommercialAssignments.filter(function(item){
            return item.id === nonAssign.userId && item.type === nonAssign.userType;
          })[0];
          booth.nonCommercialList.push({
            user: user,
            from: nonAssign.from,
            to: nonAssign.to,
            notes: nonAssign.notes
          });
        }
      }

      if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
        for ( var i in booth.userCommercialAssignments ){
          var assign = booth.userCommercialAssignments[i];
          var request = userCommercialAssignments.filter(function(item){
            return item.id === assign.eventRequestId && item.user.type === assign.userType;
          })[0];
          booth.commercialList.push({
            request: request,
            from: assign.from,
            to: assign.to,
            notes: assign.notes
          });
        }
      }
    }

    // 
    // Booth type
    // 
    function changeBoothType(booth, boothType){
      if ( boothType && boothType.id ){
        booth.boothTypeId = boothType.id;

        booth.width = boothType.width;
        booth.height = boothType.height;
        booth.backgroundImage = ( boothType.icon && boothType.icon.link ) ? boothType.icon : {
          id: 'default',
          link: 'assets/images/default.png'
        };
        booth.fillColor = ( boothType.preferences && boothType.preferences.color ) ? boothType.preferences.color : defaultBoothColor;
      } else {
        booth.boothTypeId = null;
      }
    }
    // 
    // Route
    // 
    function addRoute(booth){
      var route = booth.selectedRoute;

      console.log(booth);
      if ( route && route.id ){
        booth.unlinkedRoutes.splice(booth.unlinkedRoutes.indexOf(route), 1);

        booth.hasRoutes.push(route);
        booth.routeIds.push(route.id);

        booth.selectedRoute = null;
      } else {
        console.error('No route selected');
      }
    }
    function removeRoute(booth, route){
      if ( route && route.id ){
        booth.unlinkedRoutes.push(route);

        booth.hasRoutes.splice(booth.hasRoutes.indexOf(route), 1);
        booth.routeIds.splice(booth.routeIds.indexOf(route.id), 1);
      } else {
        console.error('No route selected');
      }
    }

    // 
    // Indoor maps
    // 
    // Add indoor map
    function addIndoorMap(booth){
      var indoorMap = booth.selectedIndoorMap;
      if ( indoorMap && indoorMap.id ){
        booth.unlinkedIndoorMaps.splice(booth.unlinkedIndoorMaps.indexOf(indoorMap), 1);

        booth.hasIndoorMaps.push(indoorMap);
        booth.indoorMapIds.push(indoorMap.id);
        booth.selectedIndoorMap = null;
      } else {
        console.error('No indoor map selected');
      }
    }
    function removeIndoorMap(booth, indoorMap){
      if ( indoorMap && indoorMap.id ){
        booth.unlinkedIndoorMaps.push(indoorMap);

        booth.hasIndoorMaps.splice(booth.hasIndoorMaps.indexOf(indoorMap), 1);
        booth.indoorMapIds.splice(booth.indoorMapIds.indexOf(indoorMap.id), 1);
      } else {
        console.error('No indoor map selected');
      }
    }

    // 
    // Help functions
    // 
    function requestsForBooth(requests, booth){
      var result = [];
      if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
        for ( var i in booth.userCommercialAssignments ){
          var id = booth.userCommercialAssignments[i].eventRequestId;
          for ( var j in requests ){
            var request = requests[j];
            if ( request.id === id ){
              result.push(request);
            }
          }
        }
      }
      return result;
    }

    // 
    // *******************************************
    // Get user booth
    // *******************************************
    // 
    function getUserBooths(onlyNonCommercial, user, booths, boothTypes, indoorMaps, requests){
      var result = [];
      if ( booths && booths.length ) {
        for ( var i in booths ) {
          var booth = booths[i];
          var type = boothTypes.filter(function(item){
            return item.id === booth.boothTypeId;
          })[0];

          if ( !type || !booth.boothTypeId ) continue;

          if ( onlyNonCommercial ){
            if ( type.id === booth.boothTypeId && !type.commercial ){
              if ( nonCommercialBoothBelongToUser(booth, user.id, user.type, indoorMaps) ){
                result.push(booth);
              }
            }
          } else {
            if ( type.id === booth.boothTypeId ){
              if ( boothBelongToUser(booth, requests, user.id, user.type, indoorMaps) ){
                result.push(booth);
              }
            }
          }
        }
      }
      return result;
    }

    function boothBelongToUser(booth, requests, userId, userType, indoorMaps){
      var isBelong = false;
      isBelong = nonCommercialExist(booth, userId, userType);

      if ( !isBelong && requests && requests.length ){
        isBelong = commercialExist(booth, requests, userId, userType);
      }

      if ( !isBelong && booth.indoorMapIds && booth.indoorMapIds.length ){
        var indoorMapsNext = [];
        for ( var i in indoorMaps ){
          var map = indoorMaps[i];
          if ( booth.indoorMapIds.indexOf(map.id) !== -1 ){
            indoorMapsNext.push(map);
          }
        }
        for ( var j in indoorMapsNext ){
          var indoor = indoorMapsNext[j];
          if ( indoor.booths && indoor.booths.length ){
            for ( var k in indoor.booths ){
              isBelong = nonCommercialExist(indoor.booths[k], userId, userType);
              if ( !isBelong && requests && requests.length ){
                isBelong = commercialExist(indoor.booths[k], requests, userId, userType)
              }
              if ( isBelong ){
                break;
              }
            }
          }
          if ( isBelong ){
            break;
          }
        }
      }
      return isBelong;
    }

    function nonCommercialBoothBelongToUser(booth, userId, userType, indoorMaps){
      var isBelong = false;
      isBelong = nonCommercialExist(booth, userId, userType);

      if ( !isBelong && booth.indoorMapIds && booth.indoorMapIds.length ){
        var indoorMapsNext = [];
        for ( var i in indoorMaps ){
          var map = indoorMaps[i];
          if ( booth.indoorMapIds.indexOf(map.id) !== -1 ){
            indoorMapsNext.push(map);
          }
        }
        for ( var j in indoorMapsNext ){
          var indoor = indoorMapsNext[j];
          if ( indoor.booths && indoor.booths.length ){
            for ( var k in indoor.booths ){
              isBelong = nonCommercialExist(indoor.booths[k], userId, userType);
              if ( isBelong ){
                break;
              }
            }
          }
          if ( isBelong ){
            break;
          }
        }
      }
      return isBelong;
    }

    function commercialExist(booth, requests, userId, userType){
      var result = false;
      if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
        for ( var i in booth.userCommercialAssignments ){
          var assign = booth.userCommercialAssignments[i];
          if ( requests && requests.length ){
            for ( var j in requests ){
              var request = requests[j];
              if (
                request.id === assign.eventRequestId &&
                request.user.id === userId &&
                request.user.type === userType
              ){
                result = true;
                break;
              }
            }
          }
          if ( result ) break;
        }
      }
      return result;
    }

    function nonCommercialExist(booth, userId, userType){
      var result = false;
      if ( booth.userNonCommercialAssignments && booth.userNonCommercialAssignments.length ){
        for ( var i in booth.userNonCommercialAssignments ){
          var assign = booth.userNonCommercialAssignments[i];
          if (
            assign.userId === userId &&
            assign.userType === userType
          ){
            result = true;
            break;
          }
        }
      }
      return result;
    }

    return {
      defaultBoothIcon: defaultBoothIcon,
      defaultBoothColor: defaultBoothColor,

      onInitBooth: onInitBooth,

      changeBoothType: changeBoothType,

      addRoute: addRoute,
      removeRoute: removeRoute,

      addIndoorMap: addIndoorMap,
      removeIndoorMap: removeIndoorMap,

      requestsForBooth: requestsForBooth,

      getUserBooths: getUserBooths,
      boothBelongToUser: boothBelongToUser,
      nonCommercialBoothBelongToUser: nonCommercialBoothBelongToUser
    }
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .factory('OutdoorService', OutdoorService)

  function OutdoorService(
    $rootScope,
    $window,
    $document,

    MapService,

    EventZone,
    RespZone,
    Route,
    Booth,
    ToolsMap,
    GenerateUUID
  ){
    var google = google || $window.google;

    var _cbMap = null;

    var _map = null;
    var _indoorMapLink = '';

    var _zoom = 0;
    var _center = [];

    var _eventZones = [];
    var _responsibilityZones = [];
    var _routes = [];
    var _booths = [];

    var _selectedItem = null;

    var _isDrawModeEnabled = false;
    var _drawModeType = null;
    var _drawObjectType = null;

    var _isServiceActive = false;

    var _g_route = new Route();

    function _resetOutdoorData(){
      _cbMap = null;

      _zoom = 0;
      _center = 0;

      _eventZones = [];
      _responsibilityZones = [];
      _routes = [];
      _booths = [];

      _selectedItem = null;

      _isDrawModeEnabled = false;
      _drawModeType = null;

      _isServiceActive = false;

      _g_route = new Route();
    }

    return {
      resetOutdoorData: _resetOutdoorData,
      isServiceActive: function(){
        return _isServiceActive;
      },
      getType: function(){
        return 'outdoor';
      },
      getMap: function(){
        return _map;
      },
      getZoom: function(){
        return _zoom;
      },
      getCenter: function(){
        return _center;
      },
      initMap: function(data, cb, indoorMapLink){
        _resetOutdoorData();

        if ( cb ) _cbMap = cb();
        if ( indoorMapLink ) _indoorMapLink = indoorMapLink;

        _isServiceActive = true;

        var mapSelector = $document[0].querySelector('#map');

        var pref = data.preferences;
        _zoom = ( pref && pref.zoom ? pref.zoom : 2 );
        _center = {
          lat: ( pref && pref.position ? pref.position.lat : 28.068222 ),
          lng: ( pref && pref.position ? pref.position.lng : -82.635873 )
        };

        _map = new google.maps.Map(mapSelector, {
          zoom: _zoom,
          center: _center,
          maxZoom: 20,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          clickableIcons: false,
          streetViewControl: false,
          fullscreenControl: false,
          // mapTypeControl: false,
          // navigationControl: false,
          gestureHandling: 'greedy',
          styles: [
            {
              featureType: 'poi',
              stylers: [
                { visibility: 'off' }
              ],
            },{
              featureType: 'transit',
              stylers: [
                { visibility: 'off' }
              ]
            }
          ]
        });

        google.maps.event.addListener(_map, 'click', handleMapClick);
      }, // Init map: end

      getMapData: function(){
        return {
          name: 'Outdoor',
          type: 'outdoor',
          preferences: {
            mapTypeId: _map.getMapTypeId(),
            position : {
              lat: _map.getCenter().lat(),
              lng: _map.getCenter().lng()
            },
            zoom: _map.getZoom() || 2
          }
        };
      },

      getSelectedItem: function(){
        return _selectedItem;
      },

      setSelectedItem: _setSelectedItem,

      clearSelectedItem: function(){
        _selectedItem = null;
      },

      checkGlobalRoute: checkGlobalRoute,

      changeSelectedItemColor: function(color){
        _selectedItem.setColor(color);
        if ( _selectedItem.kind === ToolsMap.drawType.route ){
          _selectedItem.stroke = color;
        } else {
          _selectedItem.fillColor = color;
        }
      },

      drawMode: function(isEnabled, type, objectType){
        _isDrawModeEnabled = isEnabled;
        _drawModeType = type;
        _drawObjectType = objectType;

        _map.setOptions({
          draggableCursor: isEnabled ? 'crosshair' : 'url(//maps.gstatic.com/mapfiles/openhand_8_8.cur), move'
        });

        if ( !isEnabled ){
          checkGlobalRoute();
        }
      },

      // Fetch items
      fetchEventZones: function(){
        return _eventZones;
      },
      fetchResponsibilityZones: function(){
        return _responsibilityZones;
      },
      fetchRoutes: function(){
        return _routes;
      },
      fetchBooths: function(){
        return _booths;
      },

      drawEventZone: drawEventZone,
      drawResponsibilityZone: drawResponsibilityZone,
      drawRoute: drawRoute,
      drawBooth: drawBooth,

      removeEventZone: function(zone){
        var idx = _eventZones.indexOf(zone);
        _eventZones.splice(idx, 1);
      },
      removeResponsibilityZone: function(zone){
        var idx = _responsibilityZones.indexOf(zone);
        _responsibilityZones.splice(idx, 1);
      },
      removeRoute: function(zone){
        var idx = _routes.indexOf(zone);
        _routes.splice(idx, 1);
      },
      removeBooth: function(zone){
        var idx = _booths.indexOf(zone);
        _booths.splice(idx, 1);
      },

      // Clear items
      clearResponsibilityZones: function(){
        for ( var i in _responsibilityZones ){
          _responsibilityZones[i].remove();
        }
        _responsibilityZones = [];
      },
      clearBooths: function(){
        for ( var i in _booths ){
          _booths[i].remove();
        }
        _booths = [];
      },

      // Create 'Show me on map' button
      showMeOnMapButton: function(position, map){
        var centerControlDiv = document.createElement('div');
        var centerControl = new CenterControl(centerControlDiv, position);
        centerControlDiv.index = 1;
        _map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(centerControlDiv);
      }
    }

    function checkGlobalRoute(){
      if (
        _g_route && _g_route.coordinates && _g_route.coordinates.length >= 2
      ){
        _routes.push(_g_route);
        _g_route = new Route();
      }
    };

    function handleMapClick(evt){
      var latLng;
      var result = true;

      if ( evt.latLng ) {
        latLng = new google.maps.LatLng({
          lat: evt.latLng.lat(),
          lng: evt.latLng.lng()
        });
      }

      if ( _isDrawModeEnabled ){
        switch ( _drawModeType ) {
          case ToolsMap.drawType.eventZone:
            _createEventZone(latLng);
            _cbMap.handleDrawModeType();
            break;
          case ToolsMap.drawType.respZone:
            _createResponsibilityZone(latLng);
            _cbMap.handleDrawModeType();
            break;
          case ToolsMap.drawType.route:
            _createRoute(latLng);
            break;
          case ToolsMap.drawType.booth:
            _createBooth(latLng);
            _cbMap.handleDrawModeType();
            break;
        }
      } else {
        result = false;

        for ( var i in _booths ){
          var booth = _booths[i];
          var polygon;
          if ( booth._type === 'fixed' ){
            polygon = new google.maps.Polygon({
              paths: booth.overlay.polygon
            });
          } else {
            polygon = booth.polygon;
          }

          if ( google.maps.geometry.poly.containsLocation(latLng, polygon) && !booth.isHidden ){
            if ( booth._type === 'flexible' ){
              if ( booth.indoorMapIds && booth.indoorMapIds.length ){
                MapService.getMaps(booth.indoorMapIds.join(','))
                  .then(
                    function(response){
                      booth.showInfowindow(_map, response.data, _indoorMapLink);
                    },
                    function(err){
                      console.log(err);
                    }
                  );
              } else {
                booth.showInfowindow(_map);
              }
            } else if ( booth._type === 'fixed' ){
              if ( _cbMap ){
                _onClickItem(booth);
              } else {
                if ( booth.indoorMapIds && booth.indoorMapIds.length ){
                  MapService.getMaps(booth.indoorMapIds.join(','))
                    .then(
                      function(response){
                        booth.showInfowindow(_map, response.data, _indoorMapLink);
                      },
                      function(err){
                        console.log(err);
                      }
                    );
                } else {
                  booth.showInfowindow(_map);
                }
              }
              // break;
              result = true;
              break;
            }
          }
        }
      }

      return result;
    }

    // Draw items
    function drawEventZone(zone, isConstructor){
      zone.draw(_map);
      if ( isConstructor ){
        zone.addClickListener(function(evt){
          if ( !handleMapClick(evt) ){
            _onClickItem(zone);
          }
        });
      } else {
        zone.addClickListener(function(evt){
          handleMapClick(evt)
        });
      }
      _eventZones.push(zone);
    }

    function drawResponsibilityZone(zone, isConstructor){
      zone.draw(_map);
      if ( isConstructor ){
        zone.addClickListener(function(evt){
          if ( !handleMapClick(evt) ){
            _onClickItem(zone);
          }
        });
      }
      _responsibilityZones.push(zone);
    }

    function drawRoute(route, isConstructor){
      route.checked = true;
      route.draw(_map);

      if ( isConstructor ){
        route.addClickListener(function(evt){
          if ( !handleMapClick(evt) ){
            _onClickItem(route);
          }
        });
      }

      if ( !_isDrawModeEnabled ){
        _routes.push(route);
      }
    }
    function drawBooth(booth, isConstructor){
      booth.draw(_map);

      var polygon = null;

      if ( booth._type === 'flexible' ){
        if ( isConstructor ){
          booth.addClickListener(function(evt){
            if ( !handleMapClick(evt) ){
              _onClickItem(booth);
            }
          });
        } else {
          booth.addClickListener(function(evt){
            handleMapClick(evt)
          });
        }
      }

      if ( _isDrawModeEnabled ){
        for ( var i in _eventZones ){
          var zone = _eventZones[i];
          polygon = new google.maps.Polygon({
            paths: zone.coordinates
          });
          if ( google.maps.geometry.poly.containsLocation(booth.position, polygon) ) {
            booth.zoneId = zone.id;
          }
        }
      }

      _booths.push(booth);
    }


    function _onClickItem(item){
      if ( !_isDrawModeEnabled ){
        _setSelectedItem(item);

        _cbMap.clearSelectedItem();
        _cbMap.setSelectedItem(item);
      }
    }


    // Set/Get selected item
    function _setSelectedItem(item){
      _selectedItem = item;
    };


    // Create map items
    function _createEventZone(latlng){
      var zone = new EventZone();
      zone.id = GenerateUUID.uuid();
      zone.latLng = latlng;

      drawEventZone(zone, true);

      _cbMap.createItem(zone);

      _setSelectedItem(zone);
    };
    function _createResponsibilityZone(latlng){
      var zone = new RespZone();
      zone.id = GenerateUUID.uuid();
      zone.latLng = latlng;

      drawResponsibilityZone(zone, true);

      _cbMap.createItem(zone);

      _setSelectedItem(zone);
    };
    function _createRoute(latlng){
      _g_route.id = GenerateUUID.uuid();
      _g_route.addCoordinates(latlng);

      if ( _g_route.coordinates.length > 1 ){
        _map.setCenter(latlng);
      }

      drawRoute(_g_route, true);

      calculateRouteDistance(_g_route);
    };
    function _createBooth(latlng){
      var booth = new Booth(true);
      booth._type = _drawObjectType;
      booth.id = GenerateUUID.uuid();
      booth.position = latlng;

      drawBooth(booth, true);

      _cbMap.createItem(booth);

      _setSelectedItem(booth);
    };


    function calculateRouteDistance(route){
      var routeDistance = 0;
      var step = 3.28084;
      var path = route.polyline.getPath();

      if ( $rootScope.currentEvent.preferences.measurementSystem === 'imperial' ) {
        routeDistance = (route.getPolylineDistance(path) * step).toFixed(0);
      } else {
        routeDistance = (route.getPolylineDistance(path)).toFixed(0);
      }

      $rootScope.selectedItemDistance = parseInt(routeDistance, 10);
      $rootScope.$apply();
    }


    // Create show me on map button
    function CenterControl(controlDiv, currentPosition) {
      // Create clicked box
      var controlUI = document.createElement('div');
      controlUI.style.backgroundColor = '#fff';
      controlUI.style.borderRadius = '3px';
      controlUI.style.boxShadow = '0px 1px 4px -1px rgba(0, 0, 0, 0.3)';
      controlUI.style.cursor = 'pointer';
      controlUI.style.marginBottom = '24px';
      controlUI.style.paddingLeft = '16px';
      controlUI.style.paddingRight = '16px';
      controlUI.style.textAlign = 'center';
      controlUI.title = 'Click to recenter the map';
      controlDiv.appendChild(controlUI);

      // Create icon
      var controlIcon = document.createElement('i');
      controlIcon.className = 'glyphicon glyphicon-map-marker';
      controlIcon.style.position = 'relative';
      controlIcon.style.top = '-1px';
      controlIcon.style.fontSize = '16px';
      controlIcon.style.marginRight = '4px';
      controlIcon.style.verticalAlign = 'middle';
      controlUI.appendChild(controlIcon);

      // Set CSS for the control interior.
      var controlText = document.createElement('span');
      controlText.style.color = 'rgb(25,25,25)';
      controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
      controlText.style.fontSize = '12px';
      controlText.style.lineHeight = '28px';
      controlText.innerHTML = 'Show me on map';
      controlUI.appendChild(controlText);

      // SHow me on map control
      controlUI.addEventListener('click', function() {
        var pos = {
          lat: currentPosition.coords.latitude,
          lng: currentPosition.coords.longitude
        };
        var marker = new google.maps.Marker({position: pos});
        marker.setMap(_map);
        _map.setCenter(pos);
      });
    }
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .factory('IndoorService', IndoorService)

  function IndoorService(
    IndoorStage,
    IndoorOverlay,
    IndoorBooth,
    IndoorRoute,
    IndoorZone,
    ToolsMap,
    ToolsBooth,
    GenerateUUID
  ){
    // Private global variables
    var _konva = null;
    var _stage = null;
    var _layer = null;
    var _overlay = null;

    var _cbMap = null;

    var _eventZones = [];
    var _responsibilityZones = [];
    var _routes = [];
    var _booths = [];

    var _selectedItem = null;

    var _isDrawModeEnabled = false;
    var _drawModeType = null;
    var _drawObjectType = null;

    var _isServiceActive = false;

    var _g_route = new IndoorRoute(true);

    function _resetIndoorData(){
      _konva = null;
      _stage = null;
      _layer = null;
      _overlay = null;

      _cbMap = null;

      _eventZones = [];
      _responsibilityZones = [];
      _routes = [];
      _booths = [];

      _selectedItem = null;

      _isDrawModeEnabled = false;
      _drawModeType = null;

      _isServiceActive = false;

      _g_route = new IndoorRoute(true);
    }

    return {
      resetIndoorData: _resetIndoorData,
      isServiceActive: function(){
        return _isServiceActive;
      },
      getType: function(){
        return 'indoor';
      },
      initMap: function(data, cb){
        _resetIndoorData();

        if ( cb ) _cbMap = cb();

        _isServiceActive = true;

        var stage = new IndoorStage(true);

        _konva = stage.Konva();
        _stage = stage.onInit(data);
        _layer = stage.Layer();

        _stage.add(_layer);

        // Stage constructor resize
        stage.changeResize();

        _stage.on('click', function(evt){
          if ( _isDrawModeEnabled ){
            var scale = this.scaleX();
            var pos = {
              x: this.getPointerPosition().x / scale - this.x() / scale,
              y: this.getPointerPosition().y / scale - this.y() / scale,
            };
            switch ( _drawModeType ){
              case ToolsMap.drawType.eventZone:
                _createEventZone(pos);
                _cbMap.handleDrawModeType();
                break;
              case ToolsMap.drawType.respZone:
                _createResponsibilityZone(pos);
                _cbMap.handleDrawModeType();
                break;
              case ToolsMap.drawType.route:
                _createRoute(pos);
                break;
              case ToolsMap.drawType.booth:
                _createBooth(pos);
                _cbMap.handleDrawModeType();
                break;
            }
          }
        });

        // Overlay
        _overlay = new IndoorOverlay(true);
        _overlay.read(data, _layer);
        _overlay.draw(_konva, _layer);

        if ( cb ){
          _overlay.click(function(evt){
            // console.log(evt);
            if ( !_isDrawModeEnabled ){
              _setSelectedItem(_overlay);
  
              _cbMap.clearSelectedItem();
              _cbMap.setSelectedItem(_overlay);
            }
          });
        }

        stage.changeScale(_overlay);
        stage.drag(_overlay);
        stage.zoomInOut(_overlay);
      },

      getMapData: function(){
        return _overlay.set();
      },

      setSelectedItem: _setSelectedItem,

      getSelectedItem: function(){
        return _selectedItem;
      },

      clearSelectedItem: function(){
        _selectedItem = null;
      },

      checkGlobalRoute: checkGlobalRoute,

      changeSelectedItemColor: function(color){
        _selectedItem.setColor(color);
        if ( _selectedItem.kind === ToolsMap.drawType.route ){
          _selectedItem.strokeColor = color;
        } else {
          _selectedItem.fillColor = color;
        }
      },

      drawMode: function(isEnabled, type, objectType){
        _isDrawModeEnabled = isEnabled;
        _drawModeType = type;
        _drawObjectType = objectType;

        if ( !isEnabled ){
          checkGlobalRoute();
        }
      },

      // Fetch items
      fetchEventZones: function(){
        return _eventZones;
      },
      fetchResponsibilityZones: function(){
        return _responsibilityZones;
      },
      fetchRoutes: function(){
        return _routes;
      },
      fetchBooths: function(){
        return _booths;
      },

      drawEventZone: drawEventZone,
      drawResponsibilityZone: drawResponsibilityZone,
      drawRoute: drawRoute,
      drawBooth: drawBooth,

      removeEventZone: function(zone){
        var idx = _eventZones.indexOf(zone);
        _eventZones.splice(idx, 1);
      },
      removeResponsibilityZone: function(zone){
        var idx = _responsibilityZones.indexOf(zone);
        _responsibilityZones.splice(idx, 1);
      },
      removeRoute: function(zone){
        var idx = _routes.indexOf(zone);
        _routes.splice(idx, 1);
      },
      removeBooth: function(zone){
        var idx = _booths.indexOf(zone);
        _booths.splice(idx, 1);
      },

      // Clear items
      clearResponsibilityZones: function(){
        for ( var i in _responsibilityZones ){
          _responsibilityZones[i].remove();
        }
        _responsibilityZones = [];
      },
      clearBooths: function(){
        for ( var i in _booths ){
          _booths[i].remove();
        }
        _booths = [];
      }
    }

    function checkGlobalRoute(){
      if (
        _g_route && _g_route.points && _g_route.points.length >= 2
      ){
        _routes.push(_g_route);
        _g_route = new IndoorRoute(true);
      }
    };

    // Draw items
    function drawEventZone(zone, isConstructor){
      if ( !isConstructor ){
        zone.draw(_konva, _layer, null);
      } else {
        zone.draw(_konva, _layer, function(){
          _onClickItem(zone);
        });
      }
      _eventZones.push(zone);
    };
    function drawResponsibilityZone(zone, isConstructor){
      if ( !isConstructor ){
        zone.draw(_konva, _layer, null, true);
      } else {
        zone.draw(_konva, _layer, function(){
          _onClickItem(zone);
        });
      }
      _responsibilityZones.push(zone);
    };
    function drawRoute(route, isConstructor){
      if ( !isConstructor ){
        route.draw(_konva, _layer, null);
      } else {
        route.checked = true;
        route.draw(_konva, _layer, function(){
          _onClickItem(route);
        });
      }
      route.stage = _stage;
      if ( !_isDrawModeEnabled ){
        _routes.push(route);
      }
    };
    function drawBooth(booth, isConstructor){
      if ( !isConstructor ){
        booth.draw(_konva, _layer, null, true);
      } else {
        booth.draw(_konva, _layer, function(){
          _onClickItem(booth);
        });
      }
      booth.stage = _stage;
      if ( _isDrawModeEnabled ){
        if ( _eventZones.length ){
          for ( var i in _eventZones ){
            var zone = _eventZones[i];

            var zoneX = zone.x + zone.width;
            var zoneY = zone.y + zone.height;

            if (
              (zone.x <= booth.x && booth.x <= zoneX) &&
              (zone.y <= booth.y && booth.y <= zoneY)
            ){
              booth.zoneId = zone.id;
            }
          }
        }
      }

      _booths.push(booth);
    };

    // General click item
    function _onClickItem(item){
      if ( !_isDrawModeEnabled ){
        _setSelectedItem(item);

        _cbMap.clearSelectedItem();
        _cbMap.setSelectedItem(item);
      }
    }




    // Set/Get selected item
    function _setSelectedItem(item){
      _selectedItem = item;
    };

    // Create items
    function _createEventZone(pos){
      var zone = new IndoorZone(true);
      zone.id = GenerateUUID.uuid();
      zone.kind = ToolsMap.drawType.eventZone;
      zone.x = pos.x - zone.width/2,
      zone.y = pos.y - zone.height/2;

      drawEventZone(zone, true);

      _cbMap.createItem(zone);

      _setSelectedItem(zone);
    };
    function _createResponsibilityZone(pos){
      var zone = new IndoorZone(true);
      zone.id = GenerateUUID.uuid();
      zone.kind = ToolsMap.drawType.respZone;
      zone.volunteerAssignments = [];
      zone.x = pos.x - zone.width/2,
      zone.y = pos.y - zone.height/2;

      drawResponsibilityZone(zone, true);

      _cbMap.createItem(zone);

      _setSelectedItem(zone);
    };
    function _createRoute(pos){
      _g_route.id = GenerateUUID.uuid();
      _g_route.setPoints(pos);

      drawRoute(_g_route, true);
    };
    function _createBooth(pos){
      var booth = new IndoorBooth(true);
      booth._type = _drawObjectType;
      booth.id = GenerateUUID.uuid();
      booth.x = pos.x,
      booth.y = pos.y;

      drawBooth(booth, true);

      _cbMap.createItem(booth);

      _setSelectedItem(booth);
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerMapConstructorController', OrganizerMapConstructorController)
  
  OrganizerMapConstructorController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$uibModal',
    '$document',
    '$state',
    '$stateParams',
    'moment',
    'Notification',
    'BoothTypeService',
    'EventService',
    'VendorService',
    'VolunteerService',
    'ParticipantService',
    'SponsorService',
    'MapService',
    // GUUID
    'GenerateUUID',
    // Indoor && Outdoor Service
    'IndoorService',
    'OutdoorService',
    // Outdoor
    'Booth',
    'Route',
    'RespZone',
    'EventZone',
    // Indoor
    'IndoorBooth',
    'IndoorRoute',
    'IndoorZone',
    // Tools
    'ToolsMap',
    'ToolsBooth',
  ];

  function OrganizerMapConstructorController(
    $rootScope,
    $scope,
    $timeout,
    $uibModal,
    $document,
    $state,
    $stateParams,
    moment,
    Notification,
    BoothTypeService,
    EventService,
    VendorService,
    VolunteerService,
    ParticipantService,
    SponsorService,
    MapService,

    GenerateUUID,

    IndoorService,
    OutdoorService,

    // Outdoor
    Booth,
    Route,
    RespZone,
    EventZone,

    // Indoor
    IndoorBooth,
    IndoorRoute,
    IndoorZone,

    // Tools
    ToolsMap,
    ToolsBooth
  ){
    var vm = this;

    // var $scope.currentMapID;
    $scope.currentMapID = null;

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.currentUser = $rootScope.currentUser;

    $scope.boothTypes = [];

    $scope.userNonCommercialAssignments = [];
    $scope.userCommercialAssignments = [];

    $scope.map = null;

    $scope.booths = [];
    $scope.routes = [];
    $scope.responsibilityZones = [];
    $scope.eventZones = [];

    // Map items visibility
    $scope.isBoothsVisible = true;
    $scope.isRoutesVisible = true;
    $scope.isRespZonesVisible = true;
    $scope.isEventZonesVisible = true;
    // Unassigned
    $scope.onlyUnassignedRespZone = false;
    $scope.onlyUnassignedBooth = false;

    // Selected Item/Color
    $scope.selectedItem = null;
    $scope.selectedItemColor = null;
    // Draw Mode
    $scope.isDrawModeEnabled = false;
    $scope.drawModeType = null;

    // Draw Mode type
    $scope.drawTypeOverlay = 'Overlay';
    $scope.drawTypeBooth = ToolsMap.drawType.booth;
    $scope.drawTypeRoute = ToolsMap.drawType.route;
    $scope.drawTypeRespZone = ToolsMap.drawType.respZone;
    $scope.drawTypeEventZone = ToolsMap.drawType.eventZone;

    $scope.indoorMaps = [];
    $scope.linkedIndoorMapIds = [];
    $scope.unlinkedIndoorMaps = [];

    $rootScope.selectedItemDistance = 0;

    var MAP_SEARCH;
    var MAP_LOCATION;

    $scope.mapFields = {
      search: '',
      location: ''
    };

    angular.extend($scope, {
      showIndoorZoom: true,
      onInit: function(){
        OutdoorService.resetOutdoorData();
        IndoorService.resetIndoorData();

        // if ( $scope.currentMapID ){
          BoothTypeService.getBooths()
            .then(function(response){
              $scope.boothTypes = response.data;

              return EventService.getSpecials('special');
            })
            .then(function(response){
              for ( var i in response.data ){
                setUserNonCommercialAssignments(response.data[i]);
              }

              return VendorService.getRequestByStatus('accepted');
            })
            .then(function(response){
              var data = response.data;
              // $scope.vendorRequests = data;

              for ( var i in data ){
                var item = data[i];
                // Commercial Assignments
                $scope.userCommercialAssignments.push($.extend({}, item, {
                  user: item.vendor
                }));

                // Non commercial assignments
                setUserNonCommercialAssignments(item.vendor);
              }
              return VolunteerService.getRequestByStatus('accepted');
            })
            .then(function(response){
              var data = response.data;
              $scope.volunteerRequests = data;

              for ( var i in data ){
                // Non commercial assignments
                setUserNonCommercialAssignments(data[i].volunteer);
              }
              return ParticipantService.getRequests('accepted');
            })
            .then(function(response){
              var data = response.data;
              $scope.participantRequests = data;
              
              for ( var i in data ){
                var item = data[i];
                item.participant.type = 'participant';
  
                // Commercial Assignments
                $scope.userCommercialAssignments.push($.extend({}, item, {
                  user: item.participant
                }));
  
                // Non commercial assignments
                setUserNonCommercialAssignments(item.participant);
              }
              return SponsorService.getRequests('accepted');
            })
            .then(function(response){
              var data = response.data;
              $scope.sponsorRequests = data;

              for ( var i in data ){
                var item = data[i];
  
                // Commercial Assignments
                $scope.userCommercialAssignments.push($.extend({}, item, {
                  user: item.sponsor
                }));
  
                // Non commercial assignments
                setUserNonCommercialAssignments(item.sponsor);
              }

              if ( typeof $stateParams.id !== 'undefined' ){
                $scope.currentMapID = parseInt($stateParams.id, 10);
                $scope.fetchMap($scope.currentMapID);
              } else if ( typeof $stateParams.id === 'undefined' && $scope.currentEvent.mainEventMapId ){
                $scope.currentMapID = $scope.currentEvent.mainEventMapId;
                $scope.fetchMap($scope.currentEvent.mainEventMapId);
              } else if ( typeof $stateParams.id === 'undefined' && !$scope.currentEvent.mainEventMapId ){
                $scope.map = OutdoorService;
                $scope.map.initMap({}, $scope.mapCallback);
                $scope.initMapItems({}, $scope.map);
              }
            })
            .catch(function(err){
              console.error(err);
            });
        // } else {
        //   Notification.error('Map ID not present');
        // }

      },

      fetchMap: function(id){
        MapService.getMapByID(id)
          .then(function(response){
            var data = response.data;
            if ( data.type === 'outdoor' ){
              $scope.renderOutdoorMapItems(function(){
                $scope.showIndoorZoom = false;

                $scope.map = OutdoorService;
                $scope.map.initMap(data, $scope.mapCallback);
                $scope.initMapItems(data, $scope.map);
              })
            } else if ( data.type === 'indoor' ){
              $scope.map = IndoorService;
              $scope.map.initMap(data, $scope.mapCallback);
              $scope.initMapItems(data, $scope.map);
            } else {
              Notification.error('Map type not present');
            }
          })
          .catch(function(err){
            console.log(err);
          });
      },

      renderOutdoorMapItems: function(cb){

        MapService.getMaps(null, null, 'indoor')
          .then(function(response){
            $scope.indoorMaps = response.data;

            cb();
          })
          .catch(function(err){
            console.error(err);
          });

      },

      initMapItems: function(data, map){
        $scope.mapData = data;

        if ( data.eventZones && data.eventZones.length ){
          var zones = GenerateUUID.replaceDuplicateID(data.eventZones);
          for ( var i in zones ) {
            var item = zones[i];
            var zone = data.type === 'indoor' ? new IndoorZone() : new EventZone();
            zone.read(item);
            if ( typeof zone.id === 'undefined' ){
              zone.id = GenerateUUID.uuid();
            }
            map.drawEventZone(zone, true);
          }
        }
  
        if ( data.responsibilityZones && data.responsibilityZones.length ){
          var zones = GenerateUUID.replaceDuplicateID(data.responsibilityZones);
          for ( var i in zones ){
            var item = zones[i];
            var zone = data.type === 'indoor' ? new IndoorZone() : new RespZone();
            zone.read(item);
            if ( typeof zone.id === 'undefined' ){
              zone.id = GenerateUUID.uuid();
            }
            map.drawResponsibilityZone(zone, true);
          }
        }
  
        if ( data.routes && data.routes.length ){
          var routes = GenerateUUID.replaceDuplicateID(data.routes);
          for ( var i in routes ){
            var item = routes[i];
            var route = data.type === 'indoor' ? new IndoorRoute(true) : new Route();
            route.read(item);
            if ( typeof route.id === 'undefined' ){
              route.id = GenerateUUID.uuid();
            }
            map.drawRoute(route, true);
          }
        }
  
        if ( data.booths && data.booths.length ){
          var booths = GenerateUUID.replaceDuplicateID(data.booths);
          for ( var i in booths ){
            var item = booths[i];
            // IndoorBooth:
            // @params isDraggable
            var booth = data.type === 'indoor' ? new IndoorBooth(true) : new Booth(true);
            booth.read(item, $scope.boothTypes);
            if ( typeof booth.id === 'undefined' ){
              booth.id = GenerateUUID.uuid();
            }
            map.drawBooth(booth, true);

            if ( data.type === 'outdoor' ){
              if ( booth.indoorMapIds.length ){
                for ( var j in booth.indoorMapIds ){
                  if ( $scope.linkedIndoorMapIds.indexOf(booth.indoorMapIds[j]) === -1 ){
                    $scope.linkedIndoorMapIds.push(booth.indoorMapIds[j]);
                  }
                }
              }
            }
          }
        }

        for ( var i in $scope.indoorMaps ){
          var indoorMap = $scope.indoorMaps[i];
          if ( $scope.linkedIndoorMapIds.indexOf(indoorMap.id) === -1 ){
            $scope.unlinkedIndoorMaps.push(indoorMap);
          }
        }

        $scope.eventZones = map.fetchEventZones();
        $scope.responsibilityZones = map.fetchResponsibilityZones();
        $scope.routes = map.fetchRoutes();
        $scope.booths = map.fetchBooths();

        $scope.unlinkedRequests = $scope.getUnlinkedRequests();

        // Remove it in feature
        window.googleMap = data.type === 'outdoor' ? $scope.map.getMap() : null;
        window.booths = $scope.booths;
        window.routes = $scope.routes;
        window.respZones = $scope.responsibilityZones;
        window.eventZones = $scope.eventZones;


        if ( data.type === 'outdoor' ){
          $timeout(function(){
            MAP_LOCATION = $document[0].querySelector('#map-location');
            MAP_SEARCH = $document[0].querySelector('#map-search');

            map.getMap().controls[google.maps.ControlPosition.TOP_LEFT].push(MAP_SEARCH);
            map.getMap().controls[google.maps.ControlPosition.TOP_LEFT].push(MAP_LOCATION);

            if ( MAP_LOCATION ){
              $scope.initMapLocationSearch();
            }
          }, 500);
        }

        $scope._mapData = $scope.getMapData();
      },

      getMapData: function(){
        var data = $scope.map.getMapData();

        data['eventZones'] = [];
        data['responsibilityZones'] = [];
        data['routes'] = [];
        data['booths'] = [];

        for ( var i in $scope.map.fetchEventZones() ){
          data.eventZones.push($scope.map.fetchEventZones()[i].set());
        }
        for ( var i in $scope.map.fetchRoutes() ){
          data.routes.push($scope.map.fetchRoutes()[i].set());
        }
        for ( var i in $scope.map.fetchResponsibilityZones() ){
          data.responsibilityZones.push($scope.map.fetchResponsibilityZones()[i].set());
        }
        for ( var i in $scope.map.fetchBooths() ){
          data.booths.push($scope.map.fetchBooths()[i].set());
        }

        return data;
      },

      // Save map
      mapSaveLoading: false,

      saveMapData: function(){
        $scope.map.checkGlobalRoute();

        var data = $scope.getMapData();

        if ( data ){
          $scope.mapSaveLoading = true;
          if ( $scope.currentMapID ){
            MapService.updateMap($scope.currentMapID, data)
              .then(function(response){
                Notification.success('Map was saved');

                $scope.handleDrawModeType();

                $scope.mapSaveLoading = false;

                $scope.isCreatedNewMapItem = false;
                $scope.isFieldRequired = false;

                $scope._mapData = $scope.getMapData();
              })
              .catch(function(err){
                console.error(err);
                $scope.mapSaveLoading = false;
              });
          } else {
            MapService.createMap(data)
              .then(function(response){
                var data = response.data;

                EventService.assignMainMap(data.id)
                  .then(function(){
                    Notification.success('Map was saved');
    
                    $scope.handleDrawModeType();
    
                    $scope.mapSaveLoading = false;
    
                    $scope.isCreatedNewMapItem = false;
                    $scope.isFieldRequired = false;
    
                    // Set main map
                    $rootScope.currentEvent['mainEventMapId'] = data.id;
                  })
                  .catch(function(err){
                    console.error(err);
                    $scope.mapSaveLoading = false;
                  });
              })
              .catch(function(err){
                console.error(err);
                $scope.mapSaveLoading = false;
              })
          }
        }
      }, // END: onSaveMap

      // Lock/Unlock map
      handleLockMap: function(){
        EventService.lockMap()
          .then(function(response){
            var data = response.data;
            $rootScope.currentEvent = data;
            $scope.currentEvent = data;
            Notification.success('Event map was locked');
          }).catch(function(err){
            console.error(err);
          })
      },
      handleUnlockMap: function(){
        EventService.unlockMap()
          .then(function(response){
            var data = response.data;
            $rootScope.currentEvent = data;
            $scope.currentEvent = data;
            Notification.success('Event map was unlocked');
          }).catch(function(err){
            console.error(err);
          })
      },
      // Publish/Unpublish map
      handlePublish: function() {
        EventService.onPublish($scope.currentEvent)
          .then(function(response){
            var data = response.data;
            $rootScope.currentEvent = data;
            $scope.currentEvent = data;
            Notification.success('Event was published');
          }).catch(function(err){
            console.error(err);
          })
      },
      handleUnpublish: function() {
        EventService.onUnpublish($scope.currentEvent)
          .then(function(response){
            var data = response.data;
            $rootScope.currentEvent = data;
            $scope.currentEvent = data;
            Notification.success('Event was unpublished');
          }).catch(function(err){
            console.error(err);
          })
      },
    }); // END: angular.extend $scope


    // Outdoor/indoor callback functions
    $scope.mapCallback = function(){
      return {
        setSelectedItem: function(item){
          $timeout(function(){
            $scope.selectedItem = item;
            $scope.selectedItem.focus();
            $scope.$apply();
          }, 150);
        },
        clearSelectedItem: function(){
          if ( $scope.selectedItem ){
            $timeout(function(){
              $rootScope.selectedItemDistance = 0;
              $scope.selectedItem.unfocus();
              $scope.selectedItem = null;
              $scope.$apply();
            }, 150);
          }
        },
        createItem: function(item){
          $timeout(function(){
            $scope.isFieldRequired = false;

            $scope.mapCallback().setSelectedItem(item);
            $scope.isCreatedNewMapItem = true;
          }, 150);
        },
        handleDrawModeType: function(){
          $scope.handleDrawModeType(null);
          $scope.$apply();
        }
      }
    }

    $scope.handleMapCheck = function(url, id){
      var _mapData = $scope.getMapData();
      var isSameMap = true;
      if ( isSameMap && JSON.stringify(_mapData['booths']) !== JSON.stringify($scope._mapData['booths']) ){
        isSameMap = false
      }
      if ( isSameMap && JSON.stringify(_mapData['routes']) !== JSON.stringify($scope._mapData['routes']) ){
        isSameMap = false
      }
      if ( isSameMap && JSON.stringify(_mapData['responsibilityZones']) !== JSON.stringify($scope._mapData['responsibilityZones']) ){
        isSameMap = false
      }
      if ( isSameMap && JSON.stringify(_mapData['eventZones']) !== JSON.stringify($scope._mapData['eventZones']) ){
        isSameMap = false
      }
      if ( isSameMap && JSON.stringify(_mapData['preferences']) !== JSON.stringify($scope._mapData['preferences']) ){
        isSameMap = false
      }

      if ( !isSameMap ){
        var modal = $uibModal.open({
          template: '\
            <div class="modal-header">\
              <h3 class="modal-title text-danger" style="text-align: center;">\
                All unsaved data will be lost. Save map before leaving?\
              </h3>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-default" type="button" ng-click="handleNo()">No</button>\
              <button class="btn btn-primary" type="button" ng-click="handleYes()">Yes</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance){
            $scope.handleYes = function(){
              $uibModalInstance.close(true);
            }
            $scope.handleNo = function(){
              $uibModalInstance.close(false);
            }
          }
        });
        modal.result
          .then(
            function(result){
              if ( result ){
                MapService.updateMap($scope.currentMapID, $scope.getMapData())
                  .then(function(){
                    $state.go(url, { id: id });
                  });
              } else {
                $state.go(url, { id: id });
              }
            },
            function(){
              console.log('Cancelled');
            }
          )
      } else {
        $state.go(url, { id: id });
      }
    };

    // 
    // ************************************************
    // Unlinked requests
    // ************************************************
    // 
    // Get
    $scope.getUnlinkedRequests = function(){
      var assignedRequests = [];

      if ( $scope.booths && $scope.booths.length ){
        for ( var i in $scope.booths ){
          var booth = $scope.booths[i];
          if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
            for ( var j in booth.userCommercialAssignments ){
              var exist = false;
              var assign = booth.userCommercialAssignments[j];

              if ( !assign.from && !assign.to ){
                if ( assignedRequests.length ){
                  for ( var k in assignedRequests ){
                    var assignR = assignedRequests[k];
                    if (
                      assignR.eventRequestId === assign.eventRequestId &&
                      assignR.userType === assign.userType
                    ){
                      exist = true;
                      break;
                    }
                  }
                  if ( !exist ){
                    assignedRequests.push(assign);
                  }
                } else {
                  assignedRequests.push(assign);
                }
              }
            }
          }
        }
      }

      var result = [];

      if ( $scope.userCommercialAssignments && $scope.userCommercialAssignments.length ){
        for ( var i in $scope.userCommercialAssignments ){
          var skipToPush = false;
          var assign = $scope.userCommercialAssignments[i];

          if ( assignedRequests && assignedRequests.length ){
            for ( var j in assignedRequests ){
              var assignR = assignedRequests[j];
              if (
                assign.id === assignR.eventRequestId &&
                assign.user.type === assignR.userType
              ){
                skipToPush = true;
                break;
              }
            }
          }

          if ( !skipToPush ){
            result.push(assign);
          }
        }
      }

      return result;
    };
    // Set
    $scope.setUnlinkedRequest = function(data){
      if ( !data.from && !data.to ){
        var request = data.request;
        if ( $scope.unlinkedRequests && $scope.unlinkedRequests.length ){
          for ( var i in $scope.unlinkedRequests ){
            var unlinked = $scope.unlinkedRequests[i];
            if (
              unlinked.id === request.id &&
              unlinked.user.type === request.user.type
            ){
              $scope.unlinkedRequests.splice(i, 1);
            }
          }
        }
      }
    };
    // Delete
    $scope.deleteUnlinkedRequest = function(data){
      if ( !data.from && !data.to ){
        $scope.unlinkedRequests.push(data.request);
      }
    };


    $scope.onAddIndoorMap = function(selectedItem){
      if ( selectedItem.selectedIndoorMap && selectedItem.selectedIndoorMap.id ){
        var selectedIndoorMap = selectedItem.selectedIndoorMap;
        var idx = $scope.unlinkedIndoorMaps.indexOf(selectedIndoorMap);
        $scope.unlinkedIndoorMaps.splice(idx, 1);

        selectedItem.indoorMapIds.push(selectedIndoorMap.id);

        selectedItem.selectedIndoorMap = null;

        selectedItem.hasIndoorMaps.push(selectedIndoorMap);
      }
    };

    $scope.onRemoveIndoorMap = function(selectedItem, indoorMap){
      if ( indoorMap && indoorMap.id ){
        var map = $scope.indoorMaps.filter(function(item){
          return item.id === indoorMap.id
        })[0];
        $scope.unlinkedIndoorMaps.push(map);

        var idx = selectedItem.indoorMapIds.indexOf(indoorMap.id);
        selectedItem.indoorMapIds.splice(idx, 1);

        selectedItem.hasIndoorMaps.splice(selectedItem.hasIndoorMaps.indexOf(indoorMap), 1);
      }
    };


    // Trigger route
    $scope.onRouteClick = function(e, route){
      $scope.map.setSelectedItem(route);

      $scope.mapCallback().clearSelectedItem();
      $scope.mapCallback().setSelectedItem(route);
    };
    $scope.changeRouteVisibility = function(isChecked, id){
      var allChecked = true;
      for ( var i in $scope.routes ) {
        var route = $scope.routes[i];
        if ( !isChecked ) {
          if ( route.id === id ) {
            route.hide();
          }
        } else {
          if ( route.id === id ) {
            route.show();
          }
        }
      }
      for ( var j in $scope.routes ) {
        if ( !$scope.routes[j].checked ) {
          allChecked = false;
          break;
        }
      }
      $scope.isRoutesVisible = allChecked;
    };

    $scope.handleDrawModeType = function(type, objectType) {
      if ( !type || $scope.drawModeType === type ) {
        $scope.drawModeType = null;
        $scope.isDrawModeEnabled = false;

        $scope.map.drawMode(false, null, null);

        $rootScope.selectedItemDistance = 0;
      } else {
        $scope.mapCallback().clearSelectedItem();
        $scope.map.clearSelectedItem();

        $scope.drawModeType = type;
        $scope.isDrawModeEnabled = true;

        $scope.map.drawMode(true, type, objectType);
      }
    };

    // Remove map item
    $scope.onRemoveObjectFromMap = function(item){
      var modal = ToolsMap.removeMapItem(item);
      modal.result
        .then(
          function(){
            $scope.mapCallback().clearSelectedItem();
            $scope.map.clearSelectedItem();

            $timeout(function(){

              if ( item.kind === $scope.drawTypeEventZone ){
                $scope.map.removeEventZone(item);
              }
              if ( item.kind === $scope.drawTypeRespZone ){
                $scope.map.removeResponsibilityZone(item);
              }
              if ( item.kind === $scope.drawTypeRoute ){
                $scope.map.removeRoute(item);
              }
              if ( item.kind === $scope.drawTypeBooth ){
                $scope.map.removeBooth(item);
              }

              item.remove();

              $scope.isCreatedNewMapItem = false;

              $scope.$apply();
            }, 200);
          },
          function() {
            console.log('Cancelled');
          }
        );
    };

    // 
    // Aside
    // OnClose validation
    // 
    $scope.isCreatedNewMapItem = false;
    $scope.isFieldRequired = false;

    // Aside close
    $scope.handleMapAsideClose = function(){
      if ( $scope.isCreatedNewMapItem ){
        $scope.setFieldRequired();
      } else {
        $scope.mapCallback().clearSelectedItem();
      }
    }

    $scope.setFieldRequired = function(){
      $scope.isFieldRequired = true;
    }

    $scope.onCheckValidation = function(){
      if ( $scope.selectedItem ){
        if ( $scope.selectedItem.kind === $scope.drawTypeEventZone ){
          $scope.isCreatedNewMapItem = $scope.selectedItem.name && $scope.selectedItem.name.length ? false : true;
        }
        if ( $scope.selectedItem.kind === $scope.drawTypeRespZone ){
          if (
            $scope.selectedItem.name && $scope.selectedItem.name.length &&
            $scope.selectedItem.description && $scope.selectedItem.description.length
          ){
            $scope.isCreatedNewMapItem = false;
          } else {
            $scope.isCreatedNewMapItem = true;
          }
        }
      }
    }

    $scope.onChangeMapObjectVisible = function(type, value){
      $scope.handleMapAsideClose();
      switch (type) {
        case 'booth':
          for ( var i in $scope.booths ){
            value ? $scope.booths[i].show() : $scope.booths[i].hide();
          }
          break;
        case 'route':
          for ( var i in $scope.routes ){
            if ( value ){
              $scope.routes[i].show();
              $scope.routes[i].checked = true;
            } else {
              $scope.routes[i].hide();
              $scope.routes[i].checked = false;
            }
          }
          break;
        case 'respZone':
          for ( var i in $scope.responsibilityZones ){
            value ? $scope.responsibilityZones[i].show() : $scope.responsibilityZones[i].hide();
          }
          break;
        case 'eventZone':
          for ( var i in $scope.eventZones ){
            value ? $scope.eventZones[i].show() : $scope.eventZones[i].hide();
          }
          break;
      }
    }
    // Show all map items
    // ***** Private function
    $scope.showAllMapItems = function(visibility){
      if ( visibility.isBoothsVisible ){
        for ( var i in $scope.booths ){
          $scope.booths[i].show();
        }
      }
      if ( visibility.isRoutesVisible ){
        for ( var i in $scope.routes ){
          $scope.routes[i].show();
        }
      }
      if ( visibility.isRespZonesVisible ){
        for ( var i in $scope.responsibilityZones ){
          $scope.responsibilityZones[i].show();
        }
      }
      if ( visibility.isEventZonesVisible ){
        for ( var i in $scope.eventZones ){
          $scope.eventZones[i].show();
        }
      }
    }
    // Show/hide only unassigned booth
    $scope.onChangeOnlyUnassignedBooth = function(value, visibility){
      if ( value ){
        for ( var i in $scope.booths ){
          var item = $scope.booths[i];
          if ( item.boothType && item.boothType.commercial ){
            if (
              item.userCommercialAssignments &&
              item.userCommercialAssignments.length
            ){
              item.hide();
            }
          } else {
            item.hide();
          }
        }
      } else {
        if ( visibility.isBoothsVisible ){
          for ( var i in $scope.booths ){
            $scope.booths[i].show();
          }
        }
      }
    }
    // Show/hide unassigned respZone
    $scope.onChangeOnlyUnassignedRespZone = function(value, visibility){
      if ( value ){
        for ( var i in $scope.booths ){
          $scope.booths[i].hide();
        }
        for ( var i in $scope.routes ){
          $scope.routes[i].hide();
        }
        for ( var i in $scope.responsibilityZones ){
          var item = $scope.responsibilityZones[i];
          if (
            item.volunteerAssignments &&
            item.volunteerAssignments.length
          ){
            item.hide();
          }
        }
        for ( var i in $scope.eventZones ){
          $scope.eventZones[i].hide();
        }
      } else {
        $scope.showAllMapItems(visibility);
      }
    }

    $scope.toKm = function(dist){
      var km = 1000;
      var result = (dist/km).toFixed(2)
      return result >= 1 ? ' ('+ result +' km)' : '';
    }

    $scope.toMls = function(dist){
      var m = 0.00018939;
      var result = (dist*m).toFixed(2)
      return result >= 1 ? ' ('+ result +' miles)' : '';
    }


    $scope.isSameDayC = function(from, to){
      return moment(from).isSame(moment(to).subtract(1, 'days'), 'day');
    }

    $scope.isSameDay = function(start, end){
      return moment(start).isSame(end, 'day')
    }

    $scope.isSameMonth = function(start, end){
      return moment(start).isSame(end, 'month')
    }

    $scope.fromMonth = function(date){
      return moment(moment.utc(date)).local().format('MMM') +' '+ ordinal_suffix_of(moment(moment.utc(date)).local().format('D'));
    }

    $scope.toMonth = function(date){
      var utcLocal = moment(moment.utc(date)).subtract(1, 'days').local();
      return utcLocal.format('MMM') +' '+ ordinal_suffix_of(utcLocal.format('D'));
    }

    $scope.toHours = function(time){
      return moment(time).format('HH:mm');
    }

    function ordinal_suffix_of(i) {
      var j = i % 10,
          k = i % 100;
      if (j == 1 && k != 11) {
          return i + "st";
      }
      if (j == 2 && k != 12) {
          return i + "nd";
      }
      if (j == 3 && k != 13) {
          return i + "rd";
      }
      return i + "th";
    }

    // Moment isSame
    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };

    function setUserNonCommercialAssignments(item){
      var exist = false;
      for ( var i in $scope.userNonCommercialAssignments ){
        var nonCommercial = $scope.userNonCommercialAssignments[i];
        if ( nonCommercial.id === item.id ){
          exist = true;
          break;
        }
      }
      if ( !exist ){
        $scope.userNonCommercialAssignments.push(item);
      }
    }

    // Beta
    $scope.initMapLocationSearch = function() {
      var location = new google.maps.places.SearchBox(MAP_LOCATION);
      var map = $scope.map.getMap();
      map.addListener('bounds_changed', function() {
        location.setBounds(map.getBounds());
      });
      location.addListener('places_changed', function() {
        var places = location.getPlaces();
        if ( places.length == 0 ) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        angular.forEach(places, function(place) {
          ( place.geometry.viewport ) ? bounds.union(place.geometry.viewport) : bounds.extend(place.geometry.location);
        });
        map.fitBounds(bounds);
      });
    };


    $scope.handleMapSearch = function(query){
      var bounds;
      if ( $scope.mapData.type === 'outdoor' ) bounds = new google.maps.LatLngBounds();

      if ( query.length === 0 ){
        for ( var i in $scope.booths ){
          $scope.booths[i].show();

          if ( $scope.mapData.type === 'outdoor' ){
            $scope.map.getMap().setCenter($scope.map.getCenter());
            $scope.map.getMap().setZoom($scope.map.getZoom());
          }
        }
      } else {
        var resultCommercial = commercialSearch($scope.userCommercialAssignments, query);
        var resultNonCommercial = nonCommercialSearch($scope.booths, query);

        for ( var i in $scope.booths ){
          var booth = $scope.booths[i];
          if (
            hasSome(resultCommercial, ToolsBooth.requestsForBooth($scope.userCommercialAssignments, booth)) ||
            resultNonCommercial.indexOf(booth) !== -1
          ){
            booth.show();

            if ( $scope.mapData.type === 'outdoor' ){
              var latLng;
              if ( booth.position ){
                latLng = new google.maps.LatLng(booth.position.lat(), booth.position.lng());
                bounds.extend(latLng);
              } else {
                for ( var j in booth.coordinates ){
                  var coord = booth.coordinates[j];
                  latLng = new google.maps.LatLng(coord.lat, coord.lng);
                  bounds.extend(latLng);
                }
              }
              $scope.map.getMap().fitBounds(bounds);
            }
          } else {
            booth.hide();
          }
        }
      }
    }

    function hasSome(filtered, requests){
      var result = false;
      if (
        filtered && filtered.length &&
        requests && requests.length
      ){
        for ( var i in requests ){
          var request = requests[i];
          if ( filtered.indexOf(request) !== -1 ){
            result = true;
          }
        }
      }
      return result;
    }

    // NonCommercial
    function nonCommercialSearch(booths, search){
      var result = [];
      if ( search.length !== 0 ){
        var s = search.toLowerCase();
        for ( var i in booths ){
          var booth = booths[i];
          var matchSearch = !s || (
            ( booth.description && booth.description.toLowerCase().indexOf(s) > -1 )
          );
          if ( matchSearch ){
            result.push(booth);
          }
        }
        return result;
      }
      return result;
    }
    // Commercial
    function commercialSearch(requests, search){
      var result = [];
      if ( search.length !== 0 ){
        var s = search.toLowerCase();
        for ( var i in requests ){
          var request = requests[i];
          var matchSearch = !s || (
            ( request.description && request.description.toLowerCase().indexOf(s) > -1 ) ||
            ( request.individualFeaturedItems && request.individualFeaturedItems.toLowerCase().indexOf(s) > -1 ) ||
            ( request.user.name.toLowerCase().indexOf(s) > -1 ) ||
            ( request.user.description && request.user.description.toLowerCase().indexOf(s) > -1 )
          );
          if ( matchSearch ) {
            result.push(request);
          }
        }
        return result;
      }
      return result;
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerMapAllController', OrganizerMapAllController)
  
  OrganizerMapAllController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'EventService',
    'MapService',
    'Notification'
  ];

  function OrganizerMapAllController(
    $rootScope,
    $scope,
    $uibModal,
    EventService,
    MapService,
    Notification
  ){
    var vm = this;

    $scope.mapList = [];
    $scope.pageLoading = true;

    angular.extend($scope, {
      onInit: function(){
        $scope.mainEventMapId = $rootScope.currentEvent['mainEventMapId'] || 1;

        MapService.getMaps(null, 'name,type,preferences,backgroundImage,createdOn,modifiedOn')
          .then(function(response){
            $scope.mapList = response.data;
            $scope.pageLoading = false;
          })
          .catch(function(err){
            $scope.pageLoading = false;
            console.error(err);
          });
      },

      onAssignMainMap: function(id){
        if ( id ){
          EventService.assignMainMap(id)
            .then(function(response){
              $rootScope.currentEvent['mainEventMapId'] = id;
              $scope.mainEventMapId = id;
              Notification.success('Map set as main');
            })
            .catch(function(err){
              console.error(err);
            })
        } else {
          console.error('No map id');
        }
      },

      onCreateMap: function(){
        var modal = $uibModal.open({
          size: 'md',
          template: '\
            <div class="modal-header">\
              <h3 class="modal-title">Create map</h3>\
            </div>\
            <div class="modal-body">\
              <div class="form-group">\
                <label>Type</label>\
                <div class="radio"><label><input type="radio" name="selectedMapType" value="outdoor" ng-model="selectedMapType" selected />Outdoor</label></div>\
                <div class="radio"><label><input type="radio" name="selectedMapType" value="indoor" ng-model="selectedMapType" />Indoor</label></div>\
              </div>\
              <div class="form-group">\
                <label>Name</label>\
                <input class="form-control" type="text" ng-model="selectedMapName" />\
              </div>\
              <div class="form-group">\
                <p class="help-block help-block-default" style="position: relative;">( Map type could be set only once and can`t be changed anymore )</p>\
              </div>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-default" type="button" ng-click="onCancel()">Cancel</button>\
              <button class="btn btn-primary" type="button" ng-click="onChoose()">Create {{selectedMapType}} map</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance){
            $scope.selectedMapType = 'outdoor';
            $scope.selectedMapName = 'Map';

            $scope.onCancel = function(){
              $uibModalInstance.dismiss('cancel');
            };
            $scope.onChoose = function(){
              $uibModalInstance.close({name: $scope.selectedMapName, type: $scope.selectedMapType });
            };
          }
        });

        modal.result
          .then(
            function(result){
              var data = {
                name: result.name || result.type,
                backgroundImage: {},
                booths: [],
                routes: [],
                responsibilityZones: [],
                eventZones: [],
                type: result.type
              }
              MapService.createMap(data)
                .then(function(response){
                  $scope.mapList.push(response.data);
                  Notification.success('Map was created');
                })
                .catch(function(err){
                  console.error(err);
                });
            },
            function(err){
              console.log(err);
            }
          )
      },

      onDeleteMap: function(map){
        if ( map && map.id ){
          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete <p><b>{{selectedMap.name}}</b> map?</p><p>It will remove all data and operation can`t be undone</p>\
                </h4>\
              </div>\
              <div class="modal-body" ng-if="linkedBooths.length">\
                <h4 class="text-center text-danger" style="margin-top: 0; font-weight: bold;">Map is linked to these booth(s)</h4>\
                <ul class="list-indoorMapLinks"><li ng-repeat="booth in linkedBooths">\
                  <div><b>Booth:&nbsp;</b><span ng-bind="booth.boothName"></span></div>\
                  <div><b>Map:&nbsp;</b><span ng-bind="booth.mapName"></span></div>\
                </li></ul>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="btnLoading">\
                  <i ng-if="btnLoading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>\
                  <span ng-if="linkedBooths.length" ng-bind="\'Confirm delete\'"></span>\
                  <span ng-if="linkedBooths.length === 0" ng-bind="\'Delete\'"></span>\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, selectedMap, MapService){
              $scope.selectedMap = selectedMap;
              $scope.btnLoading = false;

              $scope.linkedBooths = [];

              if ( selectedMap.type === 'indoor' ){
                MapService.getLinkedBoothToMap(selectedMap.id)
                  .then(function(response){
                    $scope.linkedBooths = response.data;
                  })
                  .catch(function(err){
                    console.log(err);
                  });
              }

              $scope.handleConfirm = function(){
                $scope.btnLoading = true;

                MapService.deleteMap(selectedMap.id)
                  .then(
                    function(){
                      $scope.btnLoading = false;
                      $uibModalInstance.close(selectedMap);
                    },
                    function(err){
                      $scope.btnLoading = false;
                      $uibModalInstance.dismiss('cancel');

                      Notification.error(err.data.message);
                    }
                  );
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              selectedMap: function(){
                return map;
              }
            }
          });

          modal.result
            .then(
              function(result){
                var idx = $scope.mapList.indexOf(result);
                $scope.mapList.splice(idx, 1);

                Notification.success('Map was removed');
              },
              function() {
                console.log('Cancelled');
              }
            );
        } else {
          Notification.error('No map ID present');
        }
      },


      handleEmbed: function(){
        $uibModal.open({
          template: [
            '<div class="modal-header">',
              '<h4 class="modal-title">Embed main map</h4>',
            '</div>',
            '<div class="modal-body">',
              '<textarea class="form-control" rows="5" ng-model="frameMap" name="frameMap" readonly />',
            '</div>',
            '<div class="modal-footer">',
              '<button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>',
            '</div>'
          ].join(''),
          controller: function($scope, $location, $uibModalInstance){
            $scope.url = $location.$$protocol +'://'+ $location.$$host + ($location.$$port ? ':'+ $location.$$port : '') + '/frame-public-map';
            $scope.frameMap = '<iframe src="'+ $scope.url +'" name="publiMap" scrolling="no" frameborder="1" marginheight="0px" marginwidth="0px" height="400px" width="600px" allow="fullscreen *" allowfullscreen></iframe>';
            $scope.handleClose = function(){
              $uibModalInstance.dismiss('cancel');
            }
          }
        })
      }
      
    });
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerEventStaticPageController', OrganizerEventStaticPageController);

  function OrganizerEventStaticPageController(
    $rootScope,
    $scope,
    Notification,
    PageService
  ) {

    var vm = this;

    vm.pages = [
      { tag:'about', page: 'pageAbout' },
      { tag:'contact', page: 'pageContact' },
      { tag:'contentFooter', page: 'contentFooter' },
      { tag:'appFormVendor', page: 'appFormVendor' },
      { tag:'appFormVolunteer', page: 'appFormVolunteer' },
      { tag:'appFormParticipant', page: 'appFormParticipant' },
      { tag:'appFormSponsor', page: 'appFormSponsor' },
      { tag:'appFormSponsorAttendant', page: 'appFormSponsorAttendant' }
    ];

    $scope.pageLoading = true;

    angular.extend($scope, {
      onInit: function(){

        $scope.event = $rootScope.currentEvent;
        $scope.vendorModule = $scope.event.preferences.vendorModule;
        $scope.volunteerModule = $scope.event.preferences.volunteerModule;
        $scope.participantModule = $scope.event.preferences.participantModule;
        $scope.sponsorModule = $scope.event.preferences.sponsorModule;

        angular.forEach(vm.pages, function(item, index){
          $scope.fetchPagesByTag(item.tag, item.page, index);
        });

      },

      fetchPagesByTag: function(tag, page, index){
        if ( tag ){

          PageService.getPageByTag('fixed', tag)
            .then(function(response){
              // vm[page] = response.data || {};

              var data = response.data;
              if ( data.id && data.tag ){
                vm[page] = data;
              } else {
                vm[page] = {
                  tag: tag,
                  name: page
                };
              }

              if ( vm.pages.length - 1 === index ){
                $scope.pageLoading = false;
              }
            })
            .catch(function(err){
              if ( vm.pages.length - 1 === index ){
                $scope.pageLoading = false;
              }
            })
        }
      },

      handleSubmit: function(page){
        if ( page && page.id ){
          delete page['name'];
          PageService.updatePage(page)
            .then(function(response){
              Notification.success('Web page was updated');
            })
            .catch(function(err){
              console.error(err);
            });
        } else {
          page['type'] = 'fixed';
          PageService.createPage(page)
            .then(function(response){
              Notification.success('Web page was created');

              vm[page] = response.data;
            })
            .catch(function(err){
              console.error(err);
            });
        }
      }
    })

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerEventSmtpController', OrganizerEventSmtpController);
  
  OrganizerEventSmtpController.$inject = [
    '$rootScope',
    '$scope',
    'Notification',
    'SettingService'
  ];

  function OrganizerEventSmtpController(
    $rootScope,
    $scope,
    Notification,
    __setting
  ) {
    var vm = this;
    $scope.formSubmitted = false;
    $scope.formLoading = false;

    $scope.numberPattern = /^\d+$/;

    angular.extend($scope, {
      loading: false,
      onInit: function() {
        vm.event = $rootScope.currentEvent;
        __setting.getSettingsByGroup('mail')
          .then(
            function(response){
              vm.settings = response.data;
            },
            // $scope.handleError
            function(err){
              console.log(err);
            }
          );
      },
      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          __setting.updateSettings(vm.settings)
            .then(
              function(response){
                $scope.formLoading = false;
                Notification.success('SMTP server data was updated');
              },
              function(err) {
                $scope.formLoading = false;
                Notification.error(err.data.message);
              }
            );
        }
      },

      handleResetSMTP: function(){
        // vm.settings = {};
        var data = vm.settings.map(function(item){
          return {
            name: item.name,
            value: '',
            description: item.description,
            group: item.group
          }
        });
        // console.log(data);
        __setting.updateSettings(data)
          .then(
            function(){
              vm.settings = data;
              Notification.success('SMTP server was reset');
            },
            // $scope.handleError
            function(err){
              console.log(err);
            }
          );
      },
    });
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerEventSettingsController', OrganizerEventSettingsController);
  
  OrganizerEventSettingsController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    'moment',
    'Notification',
    'EventService',
    'ActivityLogService',
    'PageService',
    'SettingService',
    'APP_COLORS'
  ];

  function OrganizerEventSettingsController(
    $rootScope,
    $scope,
    $timeout,
    moment,
    Notification,
    __event,
    ActivityLogService,
    PageService,
    __setting,
    APP_COLORS
  ) {
    var vm = this;
    $scope.formSubmitted = false;
    $scope.formLoading = false;

    vm.appColors = APP_COLORS;

    angular.extend($scope, {
      popup1: {
        opened: false
      },
      popup2: {
        opened: false
      },

      inputType: 'password'
    });

    angular.extend($scope, {
      onInit: function() {

        vm.event = $rootScope.currentEvent;
        vm.metaTags = vm.event.preferences.metaTags;

        vm.scheduleModule = vm.event.preferences.scheduleModule;

        vm.vendorModule = vm.event.preferences.vendorModule;
        vm.volunteerModule = vm.event.preferences.volunteerModule;
        vm.participantModule = vm.event.preferences.participantModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;
        vm.homePageButtonsModule = vm.event.preferences.homePageButtonsModule;

        vm.eventDate = {
          startDate: moment(moment.utc(vm.event.start)).local().toDate(),
          startTime: moment(moment.utc(vm.event.start)).local(),
          endDate: moment(moment.utc(vm.event.end)).local().toDate(),
          endTime: moment(moment.utc(vm.event.end)).local()
        };

        PageService.getPageByTag('fixed', 'participantWaiver')
          .then(function(response){
            var data = response.data;
            if ( data.id && data.tag ){
              vm.participantWaiver = data;
              vm.participantWaiverContent = data.content || '';
            } else {
              vm.participantWaiver = {
                tag: 'participantWaiver',
                name: 'participantWaiver'
              };
            }
          })
          .catch(function(err){
            console.error(err);
          });
      },

      onChangeColorScheme: function(color) {
        vm.event.preferences.colorScheme = color;
      },

      showHidePassword: function(){
        $scope.inputType = ( $scope.inputType == 'password' ? 'text' : 'password' );
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;

        if ( form.$valid ) {
          $scope.formLoading = true;
          vm.event.start = moment(vm.eventDate.startDate).set({
            hour: moment(vm.eventDate.startTime).hour(),
            minute: moment(vm.eventDate.startTime).minute()
          }).local();
          vm.event.end = moment(vm.eventDate.endDate).set({
            hour: moment(vm.eventDate.endTime).hour(),
            minute: moment(vm.eventDate.endTime).minute()
          }).local();

          if ( vm.link ) {
            if ( vm.link.confirmationDocument && vm.link.confirmationDocument.length !== 0 ) {
              vm.event.preferences.confirmationDocument = {
                id: vm.link.confirmationDocument.id,
                link: vm.link.confirmationDocument.link
              };
            } else {
              vm.event.preferences.confirmationDocument = null;
            }

            if ( vm.link.logo && vm.link.logo.link !== '' ) {
              vm.event.preferences.logo = {
                id: vm.link.logo.id,
                link: vm.link.logo.link
              };
            }

            if ( vm.link.favicon && vm.link.favicon.link !== '' ) {
              vm.event.preferences.favicon = {
                id: vm.link.favicon.id,
                link: vm.link.favicon.link
              };
            }

            if ( vm.link.backgroundImage && vm.link.backgroundImage.link !== '' ) {
              vm.event.preferences.backgroundImage = {
                id: vm.link.backgroundImage.id,
                link: vm.link.backgroundImage.link
              };
            }
          }

          __setting.updateSettings([
            {
              'group': 'links',
              'name': 'linksParticipantCheckIn',
              'value': 'http://'+ vm.event.domain +'/auto-check-in?type=request&user=participant&code=${code}'
            },{
              'group': 'links',
              'name': 'linksReservationCheckIn',
              'value': 'http://'+ vm.event.domain +'/auto-check-in?type=reservation&code=${code}'
            },{
              'group': 'links',
              'name': 'linksVendorCheckIn',
              'value': 'http://'+ vm.event.domain +'/auto-check-in?id=${id}'
            },{
              'group': 'links',
              'name': 'linksSponsorCheckIn',
              'value': 'http://'+ vm.event.domain +'/auto-check-in?type=request&user=sponsor&id=${id}'
            },{
              'group': 'links',
              'name': 'linksSponsorAttendantCheckIn',
              'value': 'http://'+ vm.event.domain +'/auto-check-in?type=request&user=sponsorAttendant&id=${id}'
            }
          ])
            .then(
              function(){},
              $scope.handleError
            );

          __event.onUpdate(vm.event)
            .then(
              function(response){
                $timeout(function(){
                  $rootScope.currentEvent = response.data;
                  $scope.$apply();
                }, 100);

                $scope.formLoading = false;
                Notification.success('Event was updated');

                if ( vm.event.modules.indexOf('participant') > -1 ){
                  if ( vm.participantModule.waiverEnabled ){
                    vm.participantWaiver['content'] = vm.participantWaiverContent;
                    if ( vm.participantWaiver && vm.participantWaiver.id ){
                      delete vm.participantWaiver['name'];
                      PageService.updatePage(vm.participantWaiver)
                        .then(function(response){
                          // $scope.formLoading = false;
                        })
                        .catch(function(err){
                          // $scope.formLoading = false;
                          console.error(err);
                        });
                    } else {
                      vm.participantWaiver['type'] = 'fixed';
                      PageService.createPage(vm.participantWaiver)
                        .then(function(response){
                          // $scope.formLoading = false;
                          vm.participantWaiver = response.data;
                        })
                        .catch(function(err){
                          // $scope.formLoading = false;
                          console.error(err);
                        });
                    }
                  }
                }
              },
              $scope.handleError
            );
        }
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerScheduleController', OrganizerScheduleController);
  
  OrganizerScheduleController.$inject = [
    '$rootScope',
    '$scope',
    // '$timeout',
    '$uibModal',
    'moment',
    'Notification',
    'ScheduleService'
  ];

  function OrganizerScheduleController(
    $rootScope,
    $scope,
    // $timeout,
    $uibModal,
    moment,
    Notification,
    ScheduleService
  ){
    var vm = this;
    vm.dateRange = null;

    $scope.filterUserType = $rootScope.currentUser.type === 'volunteerCoordinator' ? 'volunteer' : '';

    $scope.event = $rootScope.currentEvent;
    $scope.userTypes = [
      // { type: 'admin', label: 'Admin' },
      { type: 'eo', label: 'Organizator' },
      // { type: 'eo', label: 'Event coordinator' },
      // { type: 'eo', label: 'Volunteer coordinator' },
      // { type: 'special', label: 'Special' }
    ];

    var minMd = 992;
    var minSm = 768;
    var minXs = 480;

    // Program
    vm.program = null;
    vm.locations = [];

    $scope.currentDate = moment();

    angular.extend($scope, {
      moment: moment,
      onInit: function(){
        vm.dateRange = $scope.buildDateArray($scope.currentDate);

        var pref = $scope.event.preferences;

        $scope.vendorModule = pref.vendorModule;
        $scope.volunteerModule = pref.volunteerModule;
        $scope.participantModule = pref.participantModule;
        $scope.sponsorModule = pref.sponsorModule;
        $scope.scheduleModule = $scope.event.preferences.scheduleModule;

        if ( $scope.event.modules.indexOf('vendor') > -1 ){
          $scope.userTypes.push({
            type: 'vendor', label: $scope.vendorModule.label
          });
        }

        if ( $scope.event.modules.indexOf('volunteer') > -1 ){
          $scope.userTypes.push({
            type: 'volunteer', label: $scope.volunteerModule.label
          });
        }

        if ( $scope.event.modules.indexOf('participant') > -1 ){
          $scope.userTypes.push({
            type: 'participant', label: $scope.participantModule.label
          });
        }

        if ( $scope.event.modules.indexOf('sponsor') > -1 ){
          $scope.userTypes.push({
            type: 'sponsor', label: $scope.sponsorModule.label
          });
          // $scope.userTypes.push({
          //   type: 'sponsorAttendant', label: 'Sponsor attendant'
          // });
        }

        $scope.getSchedulesByType($scope.filterUserType, function(data){
          vm.schedules = ScheduleService.schedules(data);

          $scope.buildProgram();
        });

        window.onresize = function(){
          vm.dateRange = $scope.buildDateArray($scope.currentDate);

          $scope.buildProgram();

          $scope.$apply();
        }

        var height = window.innerHeight;
        setTimeout(function(){
          var list = document.querySelectorAll('.slickItemProgram');
          // var calcHeight = vm.scheduleModule.groupByLocation && vm.locations.length > 1 ? 374 : 274;
          var calcHeight = 300;
          if ( list.length ){
            for ( var i in list ){
              var item = list[i];
              if ( item && item.style ) item.style.height = height - calcHeight +'px';
            }
          }
        }, 500);
      },

      getSchedulesByType: function(type, cb){
        ScheduleService.getSchedules(type)
          .then(
            function(response){
              if ( cb ) cb(response.data);
            },
            function(err){
              console.error(err);
            }
          );
      },

      handleChangeUserType: function(type){
        $scope.getSchedulesByType(type, function(data){
          vm.schedules = ScheduleService.schedules(data);

          $scope.buildProgram();

          $scope.filterUserType = type;
        });
      },

      handlePrevSlide: function(){
        $scope.currentDate.subtract(1, 'd');

        vm.dateRange = $scope.buildDateArray($scope.currentDate);

        $scope.buildProgram();
      },

      currentDate: moment(),

      handleNextSlide: function(){
        $scope.currentDate.add(1, 'd');

        vm.dateRange = $scope.buildDateArray($scope.currentDate);

        $scope.buildProgram();
      },

      onAddSchedule: function(){
        var modal = $uibModal.open({
          templateUrl: 'app/users/organizer/event/schedule/schedule-form.html',
          controller: 'OrganizerScheduleFormController',
          controllerAs: 'vm',
          resolve: {
            currentSchedule: function(){
              return null;
            },
            locations: function(){
              return vm.locations
            },
            resolveFilterUserType: function(){
              return $scope.filterUserType;
            }
          }
        });
        modal.result
          .then(
            function(result){
              if ( result.userType === $scope.filterUserType || ( !result.userType && $scope.filterUserType === '' )){
                ScheduleService.add(result);
                $scope.addSchedule(result);
              }
            },
            function(){
              console.log('Dissmissed');
            }
          );
      },

      onUpdateSchedule: function(schedule){
        if ( schedule && schedule.id ){
          var modal = $uibModal.open({
            templateUrl: 'app/users/organizer/event/schedule/schedule-form.html',
            controller: 'OrganizerScheduleFormController',
            controllerAs: 'vm',
            resolve: {
              currentSchedule: function(){
                return schedule;
              },
              locations: function(){
                return vm.locations
              },
              resolveFilterUserType: function(){
                return schedule.userType
              }
            }
          });
          modal.result
            .then(
              function(result){
                // if ( result.userType === $scope.filterUserType || ( !result.userType && $scope.filterUserType === '' )){
                $scope.removeSchedule(result);
                // }
                ScheduleService.updateSchedule(result)
                  .then(
                    function(response){
                      // if ( result.userType === $scope.filterUserType || ( !result.userType && $scope.filterUserType === '' )){
                        var data = response.data;
                        ScheduleService.update(data);
                        $scope.updateSchedule(data);
                      // }
                      Notification.success('Record was updated');
                    },
                    $scope.handleError
                  );
              },
              function(){
                console.log('Dissmissed');
              }
            );
        }
      },

      onRemoveSchedule: function(schedule){
        if ( schedule && schedule.id ){
          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete record ?\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()">\
                  Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, currentSchedule){
              $scope.handleConfirm = function(){
                $uibModalInstance.close(currentSchedule);
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              currentSchedule: function(){
                return schedule;
              }
            }
          });

          modal.result
            .then(
              function(result){
                // if ( result.userType === $scope.filterUserType || ( !result.userType && $scope.filterUserType === '' )){
                // }

                ScheduleService.removeSchedule(schedule.id)
                  .then(
                    function(){
                      ScheduleService.remove(schedule);
                      $scope.removeSchedule(schedule);
                      // $scope.loading = false;
                      // $uibModalInstance.close(currentSchedule);
                      Notification.success('Record was removed');
                    },
                    function(err){
                      // $scope.loading = false;
                      // $uibModalInstance.dismiss('cancel');
                      Notification.error(err.data.message);
                    }
                  );
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      formatTime: function(date){
        return moment(date).format('hh:mm a');
      },

      buildDateArray: function(startDate){
        var result = [];
        var days = 3;

        if ( window.innerWidth <= minMd && window.innerWidth >= minSm + 1 ){
          days = 2;
        } else if ( window.innerWidth <= minSm && window.innerWidth >= minXs + 1 ){
          days = 1;
        } else if ( window.innerWidth <= minXs ) {
          days = 0;
        }

        var startDate = moment(moment.utc(startDate)).local();
        var endDate = moment(moment.utc(moment(startDate).add(days, 'days'))).local();

        while (startDate <= endDate) {
          result.push(moment(startDate).format('MMMM DD, YYYY'))
          startDate = moment(startDate).add(1, 'd');
        }
        return result;
      },

      buildProgram: function(){
        vm.locations = [];

        for ( var i in vm.schedules ){
          var schedule = vm.schedules[i];
          if ( vm.locations.indexOf(schedule.location) === -1 ){
            vm.locations.push(schedule.location);
          }
        }
        // Generate programs
        vm.program = vm.dateRange.map(function(item){
          // Programs
          var programs = [];
          for ( var j in vm.schedules ){
            var schedule = $.extend({}, vm.schedules[j], {
              start: moment(moment.utc(vm.schedules[j].start)).local(),
              end: moment(moment.utc(vm.schedules[j].end)).local()
            });
            if ( moment(item).isSame(schedule.start, 'day') ){
              programs.push(schedule);
            }
          }

          if ( $scope.scheduleModule.groupByLocation ){
            // Day locations
            var dayLocations = [];
            for ( var k in programs ){
              var program = programs[k];
              if ( dayLocations.indexOf(program.location) === -1 ){
                dayLocations.push(program.location);
              }
            }
            // Location schedule
            var locations = [];
            for ( var l in dayLocations ){
              var schedules = [];
              for ( var m in programs ){
                if ( programs[m].location === dayLocations[l] ){
                  schedules.push(programs[m]);
                }
              }
              locations.push({
                name: dayLocations[l],
                schedules: schedules
              });
            }
            return {
              date: item,
              locations: locations
            };
          } else {
            return {
              date: item,
              schedules: programs
            }
          }
        });
      },

      addSchedule: function(scheduleNew){
        if ( vm.locations.indexOf(scheduleNew.location) === -1 ){
          vm.locations.push(scheduleNew.location);
        }

        var schedule = $.extend({}, scheduleNew, {
          start: moment(moment.utc(scheduleNew.start)).local(),
          end: moment(moment.utc(scheduleNew.end)).local()
        });

        for ( var i in vm.program ){
          var program = vm.program[i];
          if ( moment(program.date).isSame(schedule.start, 'day') ){
            // Schedule groupByLocation: true
            if ( $scope.scheduleModule.groupByLocation ){
              var withoutLocationName = false;
              if ( program.locations.length !== 0 ){
                var isInLocation = false;
                for ( var j in program.locations ){
                  var location = program.locations[j];
                  if ( location.name && location.name.indexOf(schedule.location) !== -1 ){
                    location.schedules.push(schedule);
                    isInLocation = true;
                  }
                  if ( schedule.location === '' || !schedule.location ){
                    if ( location.name === '' || !location.name ){
                      withoutLocationName = true;
                      location.schedules.push(schedule);
                    }
                  }
                }
                if ( !isInLocation && !withoutLocationName ){
                  program.locations.push({
                    name: schedule.location,
                    schedules: [schedule]
                  });
                }
              } else {
                if ( !withoutLocationName ){
                  program.locations.push({
                    name: schedule.location,
                    schedules: [schedule]
                  });
                }
              }
            } else {
              program.schedules.push(schedule);
            }
          }
        }
      },

      updateSchedule: function(scheduleNew){
        if ( vm.locations.indexOf(scheduleNew.location) === -1 ){
          vm.locations.push(scheduleNew.location);
        }

        var schedule = $.extend({}, scheduleNew, {
          start: moment(moment.utc(scheduleNew.start)).local(),
          end: moment(moment.utc(scheduleNew.end)).local()
        });

        for ( var i in vm.program ){
          var program = vm.program[i];
          if ( moment(program.date).isSame(schedule.start, 'day') ){
            // Schedule groupByLocation: true
            if ( $scope.scheduleModule.groupByLocation ){
              if ( program.locations.length !== 0 ){
                var isInLocation = false;
                for ( var j in program.locations ){
                  var location = program.locations[j];
                  if ( location.name && location.name.indexOf(schedule.location) !== -1 ){
                    isInLocation = true;
                    location.schedules.push(schedule);
                    // for ( var k in location.schedules ){
                    //   var sch = location.schedules[k];
                    //   if ( sch.id === schedule.id ){
                    //     var scheduleID = location.schedules.indexOf(sch);
                    //     location.schedules[scheduleID] = schedule;
                    //   } else {
                    //     location.schedules.push(schedule);
                    //   }
                    // }
                  }
                }
                if ( !isInLocation ){
                  program.locations.push({
                    name: schedule.location,
                    schedules: [schedule]
                  });
                }
              } else {
                program.locations.push({
                  name: schedule.location,
                  schedules: [schedule]
                });
              }
            } else {
              program.schedules.push(schedule);
            }
          }
        }
      },

      removeSchedule: function(schedule){
        vm.locations = [];
        for ( var i in vm.program ){
          var program = vm.program[i];
          // Schedule groupByLocation: true
          if ( $scope.scheduleModule.groupByLocation ){
            for ( var j in program.locations ){
              var location = program.locations[j];
              for ( var k in location.schedules ){
                var sch = location.schedules[k];
                if ( sch.id === schedule.id ){
                  var scheduleID = location.schedules.indexOf(sch);
                  location.schedules.splice(scheduleID, 1);
                  if ( location.schedules.length === 0 ){
                    var locationID = program.locations.indexOf(location);
                    program.locations.splice(locationID, 1);
                  }
                }
                if ( vm.locations.indexOf(sch.location) === -1 ){
                  vm.locations.push(sch.location);
                }
              }
            }
          } else {
            for ( var k in program.schedules ){
              var sch = program.schedules[k];
              if ( sch.id === schedule.id ){
                var scheduleID = program.schedules.indexOf(sch);
                program.schedules.splice(scheduleID, 1);
              }
            }
          }
        }
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerScheduleFormController', OrganizerScheduleFormController);

  function OrganizerScheduleFormController(
    $rootScope,
    $scope,
    $uibModalInstance,
    moment,
    Notification,
    ScheduleService,
    currentSchedule,
    locations,
    resolveFilterUserType
  ){
    var vm = this;

    $scope.event = $rootScope.currentEvent;
    $scope.userTypes = [
      // { type: 'admin', label: 'Admin' },
      { type: 'eo', label: 'Organizator' },
      // { type: 'eo', label: 'Event coordinator' },
      // { type: 'eo', label: 'Volunteer coordinator' },
      // { type: 'special', label: 'Special' }
    ];

    vm.schedule = {
      userType: resolveFilterUserType
    }

    vm.label = currentSchedule && currentSchedule.id ? 'Update' : 'Add';
    // vm.scheduleStartDate = moment(moment.utc($rootScope.currentEvent.start)).local().toDate();
    vm.scheduleStartDate = new Date();
    vm.scheduleStartTime = new Date().getTime();
    vm.scheduleStartTimeC = new Date();
    vm.scheduleEndTime = new Date().getTime();
    vm.scheduleEndTimeC = new Date();

    vm.loading = false;

    angular.extend($scope, {
      locations: locations.map(function(item, index){
        return {
          id: index,
          name: item
        }
      }),
      datepickerFormat: 'MMMM dd, yyyy',
      scheduleDateOptions: {
        dateDisabled: false,
        minDate: new Date(),
        // minDate: moment(moment.utc($rootScope.currentEvent.start)).local().toDate(),
        // maxDate: moment(moment.utc($rootScope.currentEvent.end)).local().toDate(),
        formatYear: 'yy',
        startingDay: 1
      },
      popup1: {
        opened: false
      }
    })

    angular.extend($scope, {
      onInit: function(){
        vm.eventStartDate = moment(moment.utc($scope.event.start)).local().toDate();
        vm.eventEndDate = moment(moment.utc($scope.event.end)).local().toDate();

        var pref = $scope.event.preferences;

        $scope.vendorModule = pref.vendorModule;
        $scope.volunteerModule = pref.volunteerModule;
        $scope.participantModule = pref.participantModule;
        $scope.sponsorModule = pref.sponsorModule;
        $scope.scheduleModule = $scope.event.preferences.scheduleModule;

        if ( $scope.event.modules.indexOf('vendor') > -1 ){
          $scope.userTypes.push({
            type: 'vendor', label: $scope.vendorModule.label
          });
        }

        if ( $scope.event.modules.indexOf('volunteer') > -1 ){
          $scope.userTypes.push({
            type: 'volunteer', label: $scope.volunteerModule.label
          });
        }

        if ( $scope.event.modules.indexOf('participant') > -1 ){
          $scope.userTypes.push({
            type: 'participant', label: $scope.participantModule.label
          });
        }

        if ( $scope.event.modules.indexOf('sponsor') > -1 ){
          $scope.userTypes.push({
            type: 'sponsor', label: $scope.sponsorModule.label
          });
          // $scope.userTypes.push({
          //   type: 'sponsorAttendant', label: 'Sponsor attendant'
          // });
        }

        if ( currentSchedule && currentSchedule.id ){
          vm.schedule = currentSchedule;

          vm.scheduleStartDate = moment(moment.utc(vm.schedule.start)).local().toDate();
          vm.scheduleStartTime = moment(moment.utc(vm.schedule.start)).local();
          vm.scheduleStartTimeC = vm.scheduleStartTime.toDate();
          vm.scheduleEndTime = moment(moment.utc(vm.schedule.end)).local();
          vm.scheduleEndTimeC = vm.scheduleEndTime.toDate();
        }
      },

      handleSubmit: function(){
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ){
          $scope.formLoading = true;
          vm.schedule.start = moment(vm.scheduleStartDate).set({
            hour: moment(vm.scheduleStartTime).hour(),
            minute: moment(vm.scheduleStartTime).minute()
          }).local();
          vm.schedule.end = moment(vm.scheduleStartDate).set({
            hour: moment(vm.scheduleEndTime).hour(),
            minute: moment(vm.scheduleEndTime).minute()
          }).local();

          if ( $rootScope.currentUser.type === 'volunteerCoordinator' ){
            vm.schedule['userType'] = 'volunteer';
          }

          if ( vm.schedule['userType'] === '' ){
            delete vm.schedule['userType'];
          }

          if ( !vm.outOfEventDateRange ) {
            if ( vm.schedule.id ){
              vm.loading = false;
              $uibModalInstance.close(vm.schedule);
            } else {
              ScheduleService.addSchedule(vm.schedule)
                .then(
                  function(response){
                    vm.loading = false;
                    Notification.success('Record was added');
                    $uibModalInstance.close(response.data);
                  },
                  $scope.handleError
                );
            }
          }
        }
      },

      handleError: function(err){
        $scope.formLoading = false;
        console.error(err);
      },

      handleClose: function(){
        $uibModalInstance.dismiss('cancel');
      },

      onPopup1Open: function(){
        $scope.popup1.opened = true;
      },

      // onChangeScheduleDate: function(){
      //   var form = $scope.form;

      //   vm.startDateError = false;
      //   vm.outOfEventDateRange = false;

      //   form.scheduleStartDate.$invalid = false;
      //   form.scheduleStartTime.$invalid = false;
      //   form.scheduleEndTime.$invalid = false;

      //   var start = moment(vm.scheduleStartDate).set({
      //     hour: moment(vm.scheduleStartTime).hour(),
      //     minute: moment(vm.scheduleStartTime).minute()
      //   }).local();
      //   var end = moment(vm.scheduleStartDate).set({
      //     hour: moment(vm.scheduleEndTime).hour(),
      //     minute: moment(vm.scheduleEndTime).minute()
      //   }).local();

      //   if ( moment(start).isBefore(vm.eventStartDate) ){
      //     if ( !moment(start).isSame(vm.eventStartDate, 'day') ){
      //       form.scheduleStartDate.$invalid = true;
      //       vm.startDateError = true;
      //     } else {
      //       if ( moment(start, 'h:mma').isBefore(vm.eventStartDate, 'h:mma') ){
      //         if ( moment(start).format('h:mma') !== moment(vm.eventStartDate).format('h:mma') ){
      //           form.scheduleStartTime.$invalid = true;
      //           vm.outOfEventDateRange = true;
      //         }
      //       }
      //     }
      //   }
      //   if ( moment(end).isAfter(vm.eventEndDate)) {
      //     if ( !moment(end).isSame(vm.eventEndDate, 'day') ){
      //       form.scheduleStartDate.$invalid = true;
      //       vm.startDateError = true;
      //     } else {
      //       if ( moment(end, 'h:mma').isAfter(vm.eventEndDate, 'h:mma') ){
      //         if ( moment(end).format('h:mma') !== moment(vm.eventEndDate).format('h:mma') ){
      //           form.scheduleEndTime.$invalid = true;
      //           vm.outOfEventDateRange = true;
      //         }
      //       }
      //     }
      //   }
      // },

      // isFormInvalid: function(){
      //   var result = false;
      //   var form = $scope.form;
      //   if ( form.$valid ){
      //     if ( vm.startDateError ){
      //       result = true;
      //     }
      //   } else {
      //     result = true;
      //   }
      //   return result;
      // },

      refreshResults: function($select){
        var search = $select.search;
        var list = angular.copy($select.items);
        var FLAG = -1;

        // remove last user input
        list = list.filter(function(item) { 
          return item.id !== FLAG;
        });
        
        if (!search) {
          // use the predefined list
          $select.items = list;
        }
        else {
          //manually add user input and set selection
          var userInputItem = {
            id: FLAG,
            name: search
          };
          // var userInputItem = search;
          $select.items = [userInputItem].concat(list);
          $select.selected = userInputItem;
        }
      }

    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerReservationCalendarsController', OrganizerReservationCalendarsController)

  OrganizerReservationCalendarsController.$inject = [
    '$scope',
    '$uibModal',
    'moment',
    'Notification',
    'ReservationService'
  ];

  function OrganizerReservationCalendarsController(
    $scope,
    $uibModal,
    moment,
    Notification,
    ReservationService
  ){
    var vm = this;

    $scope.loading = true;
    $scope.reservations = [];

    angular.extend($scope, {
      onInit: function(){

        ReservationService.getReservations()
          .then(function(response){
            $scope.loading = false;
            $scope.reservations = response.data;
          })
          .catch(function(err){
            console.log(err)
          })

      },

      handleEditCalendar: function(reservation){
        var modal = $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/reservation/form.reservation.html',
          controller: 'OrganizerFormReservationController',
          controllerAs: 'vm',
          resolve: {
            $$reservation: function(){
              return reservation;
            },
            $$boothId: function(){
              return reservation.boothId;
            }
          }
        });
        modal.result
          .then(
            function(result){
              var reserv = $scope.reservations.filter(function(item){
                return item.id === result.id;
              })[0];
              var idx = $scope.reservations.indexOf(reserv);
              $scope.reservations[idx] = result;
              Notification.success('Calendar was updated');
            },
            function() {
              console.log('Cancelled');
            }
          );
      },

      handleDeleteCalendar: function(reservation){
        if ( reservation && reservation.id ){
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Are you sure you want to remove calendar?\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                <button class="btn btn-primary" type="button" ng-click="handleSubmit()">Remove</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance){
              $scope.handleSubmit = function(){
                $uibModalInstance.close();
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            }
          });
          modal.result
            .then(
              function(){
                ReservationService.deteleReservation(reservation.id)
                  .then(function(){
                    var reserv = $scope.reservations.filter(function(item){
                      return item.id === reservation.id;
                    })[0];
                    var idx = $scope.reservations.indexOf(reserv);
                    $scope.reservations.splice(idx, 1);
                    $scope.slots = [];
                    Notification.success('Calendar was removed');

                    if ( $scope.selectedDay ){
                      delete $scope.selectedDay['calendarID'];
                      delete $scope.selectedDay['operatingHours'];
                      $scope.handleSelectDay($scope.selectedDay);
                    }
                  })
                  .catch(function(err){
                    console.log(err);
                    Notification.error(err.data.message);
                  });
              },
              function(){
                console.log('Cancelled');
              }
            )
        }
      },

      toMonth: function(date){
        return moment(moment.utc(date)).local().format('MMM') +' '+ moment(moment.utc(date)).local().format('Do');
      }
    });
  }
})();
(function() {
  'use strict';
  
  angular
    .module('eventmap')
    .controller('OrganizerPricesFormController', OrganizerPricesFormController);
  
  OrganizerPricesFormController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModalInstance',
    'moment',
    'Notification',
    'PriceService',
    'resolveData'
  ];

  function OrganizerPricesFormController(
    $rootScope,
    $scope,
    $uibModalInstance,
    moment,
    Notification,
    __price,
    resolveData
  ) {
    var vm = this;
    $scope.formSubmitted = false;
    $scope.formLoading = false;

    vm.invoiceDueDate = false;

    angular.extend($scope, {
      label: ( resolveData && resolveData.id ? 'Update' : 'Add'),
      datepickerFormat: 'MMMM dd, yyyy',
      datepickerOptions: {
        formatYear: 'yy',
        //maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      },
      datepickerPopup: {
        opened: false
      }
    });

    angular.extend($scope, {
      onInit: function() {
        vm.priceMaxAvailable = 0;
        vm.price = {
          enabled: true,
          maxAvailable: 0,
          preferences: {
            showUnsoldCount: false,
            maxAttendants: 0,
            private: false,
            purchaseOnBehalfEnabled: true
          }
        };

        vm.startDate = new Date();

        vm.event = $rootScope.currentEvent;
        vm.participantModule = vm.event.preferences.participantModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        if ( resolveData && resolveData.id ) {
          if (
            resolveData.type === 'participation' &&
            (
              typeof resolveData.preferences === 'undefined' ||
              (resolveData.preferences && typeof resolveData.preferences.purchaseOnBehalfEnabled === 'undefined')
            )
          ){
            resolveData.preferences = {};
            resolveData.preferences['purchaseOnBehalfEnabled'] = true;
          }

          vm.price = resolveData;

          if ( vm.price && vm.price.invoiceDueDate ) {
            vm.invoiceDueDate = true;
            vm.startDate = moment(moment.utc(vm.price.invoiceDueDate)).local().toDate();
            vm.startTime = moment(moment.utc(vm.price.invoiceDueDate)).local();
          }
        }
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;

          if ( vm.invoiceDueDate ) {
            vm.price.invoiceDueDate = moment(vm.startDate).set({
              hour: moment(vm.startTime).hour(),
              minute: moment(vm.startTime).minute()
            }).local();
          } else {
            delete vm.price['invoiceDueDate'];
          }

          if ( !vm.price.maxAvailable || vm.price.maxAvailable < 0 ) {
            delete vm.price['maxAvailable'];
          }

          if ( !vm.price.limitPerPerson || vm.price.limitPerPerson < 0 ) {
            delete vm.price['limitPerPerson'];
          }

          if ( vm.price.type !== 'sponsor' ){
            if ( vm.price.preferences ) delete vm.price.preferences['maxAttendants'];
          } else {
            vm.price.preferences['maxAttendants'] = parseInt(vm.price.preferences['maxAttendants'], 10);
          }

          if ( resolveData && resolveData.id ) {
            __price.onUpdate(resolveData.id, vm.price)
              .then(
                function(response) {
                  // __price.update(response.data);
                  Notification.success('Price package was updated');
                  $uibModalInstance.close(response.data);
                  // $scope.onClose();
                },
                $scope.handleError
              );
          } else {
            __price.onAdd(vm.price)
              .then(
                function(response) {
                  // __price.add(response.data);
                  Notification.success('Price package was added');
                  $uibModalInstance.close(response.data);
                  // $scope.onClose();
                },
                $scope.handleError
              );
          }
        }
      },

      onGeneratePromocode: function(){
        var charts = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        vm.price.promoCode = '';
        for ( var i = 0; i < 10; i++ ) {
          vm.price.promoCode += charts.charAt(Math.floor(Math.random() * charts.length));
        }
      },

      handleDatepickerPopup: function() {
        $scope.datepickerPopup.opened = true;
      },

      handleCancel: function() {
        $uibModalInstance.dismiss('cancel');
        // $state.go('users.organizer.event.prices');
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerPricesController', OrganizerPricesController);
  
  OrganizerPricesController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'moment',
    'Notification',
    'PriceService'
  ];

  function OrganizerPricesController(
    $rootScope,
    $scope,
    $uibModal,
    moment,
    Notification,
    __price
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;

        vm.participantModule = $rootScope.currentEvent.preferences.participantModule;
        vm.sponsorModule = $rootScope.currentEvent.preferences.sponsorModule;

        __price.getPrices()
          .then(
            function(response) {
              var result = [];
              for ( var i in response.data ){
                var item = response.data[i];

                if ( item.type === 'participation' && $rootScope.currentEvent.modules.indexOf('participant') > -1 ){
                  result.push(item);
                } else if ( item.type === 'sponsor' && $rootScope.currentEvent.modules.indexOf('sponsor') > -1 ){
                  result.push(item);
                } else if ( item.type === 'booth' ){
                  result.push(item);
                }
              }
              vm.pricePackages = __price.prices(result);
            },
            $scope.handleError
          );
      },

      filterPricePackageSearch: function(pricePackage){
        if ( $scope.pricePackageSearch && $scope.pricePackageSearch !== '' ) {
          return (
            pricePackage.name.toLowerCase().indexOf($scope.pricePackageSearch.toLowerCase()) > -1
          );
        }
        return pricePackage;
      },

      handleCreate: function(){
        $uibModal.open({
          templateUrl: 'app/users/organizer/event/prices/prices.form.html',
          controller: 'OrganizerPricesFormController as vm',
          resolve: {
            resolveData: function(){
              return null;
            }
          }
        }).result.then(
          function(result){
            __price.add(result);
          },
          function(err){

          }
        );
      },

      handleEdit: function(pricePackage){
        if ( pricePackage && pricePackage.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/event/prices/prices.form.html',
            controller: 'OrganizerPricesFormController as vm',
            resolve: {
              resolveData: function(){
                return pricePackage;
              }
            }
          }).result.then(
            function(result){
              __price.update(result);
            },
            function(err){

            }
          );
        }
      },

      handleDelete: function(pricePackage) {
        if ( pricePackage && pricePackage.id ) {
          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete price package <b>{{pricePackage.name}}</b>?\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, PriceService, pricePackage){
              $scope.pricePackage = pricePackage;
              $scope.loading = false;
              
              $scope.handleConfirm = function(){
                $scope.loading = true;

                PriceService.onRemove(pricePackage.id)
                  .then(
                    function(){
                      $uibModalInstance.close(pricePackage);
                      $scope.loading = false;
                    },
                    function(err){
                      $scope.loading = false;
                      Notification.error(err.data.message);
                    }
                  );
              }
  
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              pricePackage: function(){
                return pricePackage;
              }
            }
          });
  
          modal.result
            .then(
              function(result){
                Notification.success('Price package was removed');
                __price.remove(result);
                vm.currentPage = $scope.navigatePagination(vm.pricePackages);
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      },

      onChangeItemsOf: function() {
        var total = vm.filterPricePackages.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },
    });

  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerEventMediaGalleryController', OrganizerEventMediaGalleryController);

  OrganizerEventMediaGalleryController.$inject = [
    '$scope',
    '$uibModal',
    'FileService',
    'Notification'
  ];

  function OrganizerEventMediaGalleryController(
    $scope,
    $uibModal,
    FileService,
    Notification
  ) {
    var vm = this;

    $scope.pageLoading = true;
    $scope.mediaSource = 'gallery';

    $scope.mediaList = [];
    $scope.selectedMediaList = [];

    $scope.allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg|\.ico)$/i;

    // Upload media button
    $scope.uploadMediaLoading = false;
    $scope.uploadMediaDisabled = false;

    angular.extend($scope, {
      onInit: function(){
        // Load media files
        FileService.getFiles($scope.mediaSource)
          .then(function(response){
            $scope.mediaList = response.data;
            $scope.pageLoading = false;
          })
          .catch(function(err){
            console.error(err);
          });
      },

      handleUploadMedia: function(evt, type){
        var files = evt.target.files;

        var maxImage360Size = 4096;

        $scope.uploadMediaLoading = true;
        $scope.uploadMediaDisabled = true;

        angular.forEach(files, function(file, index){
          if ( !$scope.allowedExtensions.exec(file.name) ){
            Notification.error('Allowed upload only image files. Please choose another');
            $scope.uploadMediaLoading = false;
            $scope.uploadMediaDisabled = false;
            return false;
          }

          if ( type === 'image_360' ){
            var img = new Image();
            img.src = window.URL.createObjectURL(file);
            img.onload = function(){
              if ( img.naturalWidth <= maxImage360Size ){
                FileService.onAdd(file, $scope.mediaSource, type)
                  .then(function(response){
                    $scope.mediaList.push(response.data);

                    if ( index === files.length - 1 ){
                      $scope.uploadMediaLoading = false;
                      $scope.uploadMediaDisabled = false;
          
                      Notification.success('All media file(s) was uploaded');
          
                      var fileElement = angular.element('#uploadMedia');
                      angular.element(fileElement).val(null);
                    }
                  })
                  .catch(function(err){
                    Notification.error(err.data.message);
                  });
              } else {
                Notification.error('Image size is more than 4096px');
                $scope.uploadMediaLoading = false;
                $scope.uploadMediaDisabled = false;
              }
            }
          } else {
            FileService.onAdd(file, $scope.mediaSource, type)
              .then(function(response){
                $scope.mediaList.push(response.data);

                if ( index === files.length - 1 ){
                  $scope.uploadMediaLoading = false;
                  $scope.uploadMediaDisabled = false;
      
                  Notification.success('All media file(s) was uploaded');
      
                  var fileElement = angular.element('#uploadMedia');
                  angular.element(fileElement).val(null);
                }
              })
              .catch(function(err){
                Notification.error(err.data.message);
              });
          }
        })
      },

      handlePreview: function(media){
        if ( media && media.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/event/media-gallery/360-modal.html',
            controller: 'MediaGallery360Controller as vm',
            backdrop: 'static',
            resolve: {
              resolveMedia: function(){
                return media;
              }
            }
          });
        }
      },

      handleDeleteMedia: function(media){
        if ( media && media.id ){
          $scope.uploadMediaDisabled = true;
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Are you sure you want to delete media ?\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDelete()">Delete</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance){
              $scope.handleDelete = function(){
                $uibModalInstance.close();
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            }
          });

          modal.result
            .then(
              function(){
                FileService.onDelete(media.id)
                  .then(function(){
                    var idx = $scope.mediaList.indexOf(media);
                    $scope.mediaList.splice(idx, 1);
                    $scope.uploadMediaDisabled = false;

                    if ( $scope.selectedMediaList.indexOf(media) > -1 ){
                      var sIDX = $scope.selectedMediaList.indexOf(media);
                      $scope.selectedMediaList.splice(sIDX, 1);
                    }

                    Notification.success('Media file was deleted');
                  })
                  .catch(function(err){
                    console.error(err);
                    $scope.uploadMediaDisabled = false;
                  });
              },
              function() {
                $scope.uploadMediaDisabled = false;
              }
            );
        } else {
          Notification.error('Cannot find media ID');
        }
      }
    })
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('MediaGallery360Controller', MediaGallery360Controller);

  MediaGallery360Controller.$inject = [
    '$scope',
    '$uibModalInstance',
    'resolveMedia'
  ];

  function MediaGallery360Controller(
    $scope,
    $uibModalInstance,
    resolveMedia
  ){
    var vm = this;
    $scope.resolveMedia = resolveMedia;

    angular.extend($scope, {
      onInit: function(){
        if ( resolveMedia.type === 'image_360' ){
          var pannellum = window.pannellum || pannellum;

          pannellum.viewer('panorama', {
            'type': 'equirectangular',
            'panorama': resolveMedia.link,
            'autoLoad': true,
            'showFullscreenCtrl': true,
            'showControls': true
          });
        }

      },

      handleClose: function(){
        $uibModalInstance.dismiss();
      }
    })
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerMailTemplateController', OrganizerMailTemplateController);
  
  OrganizerMailTemplateController.$inject = [
    '$rootScope',
    '$scope',
    'Notification',
    'TemplateService'
  ];

  function OrganizerMailTemplateController(
    $rootScope,
    $scope,
    Notification,
    __template
  ) {
    var vm = this;
    vm.templates = [];
    vm.templateName = null;
    vm.templateData = null;
    // vm.focusedElement = null;
    vm.macroData = '';

    // $scope.isSaved = false;

    angular.extend($scope, {
      taToolbar: [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'fontColor'],
        ['bold', 'italics', 'underline', 'strikeThrough'],
        ['ul', 'ol'],
        ['redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
        ['html', 'insertImage','insertLink']
      ],
      active: false,
      onInit: function(){
        vm.event = $rootScope.currentEvent;

        vm.vendorModule = vm.event.preferences.vendorModule;
        vm.volunteerModule = vm.event.preferences.volunteerModule;
        vm.participantModule = vm.event.preferences.participantModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        __template.getTemplates()
          .then(
            function(response){
              var data = response.data;
              for ( var i = 0; i < data.length; i++ ) {
                var item = data[i];
                // system, event, participant, vendor, volunteer, sponsor, sponsorAttendant
                if ( item.type === 'participant' && vm.event.modules.indexOf('participant') > -1 ){
                  vm.templates.push({
                    name: item.name,
                    description: $scope.nameReplace(item.description)
                  });
                } else if ( item.type === 'sponsor' && vm.event.modules.indexOf('sponsor') > -1 ){
                  vm.templates.push({
                    name: item.name,
                    description: $scope.nameReplace(item.description)
                  });
                } else if ( item.type === 'system' || item.type === 'event' || item.type === 'vendor' || item.type === 'volunteer' || item.type === 'sponsorAttendant' ) {
                  vm.templates.push({
                    name: item.name,
                    description: $scope.nameReplace(item.description)
                  });
                }
              }
              vm.templateName = vm.templates[0];
              $scope.getTemplateByName(vm.templateName.name);
            },
            $scope.handleError
          );
      },

      setDataOnCursorPosition: function() {
        if (vm.macroData) {
          var sel, range;
          sel = window.getSelection();
          if (sel.getRangeAt && sel.rangeCount) {
            vm.rango = sel.getRangeAt(0);
            vm.rango.insertNode(document.createTextNode(vm.macroData));
            vm.macroData = '';
            $scope.active = false;
            return sel.getRangeAt(0);
          }
        }
      },

      getButtonData: function(data, id) {
        vm.macroData = data;
        $scope.active = id;
      },

      clearMacros: function() {
        $scope.active = false;
        vm.macroData = '';
      },

      handleTemplateNameSelect: function(){
        if ( vm.templateName !== null ) {
          var name = vm.templateName.name;
          $scope.getTemplateByName(name);
        }
      },

      // <#list - <list
      // </#list - </list

      // replaceListTag: function(string, rep) {
      //   if ( rep ) {
      //     var startReplace = new RegExp('<#list', 'g');
      //     var endReplace = new RegExp('</#list', 'g');
      //     return string.replace(startReplace, '<list')
      //                  .replace(endReplace, '</list')
      //   } else {
      //     var startRever = new RegExp('<list', 'g');
      //     var endRever = new RegExp('</list', 'g');
      //     return string.replace(startRever, '<#list')
      //                  .replace(endRever, '</#list')
      //   }
      // },
      handleTestMailSending: function(email){
        if ( email ){
          if ( vm.templateName !== null ) {
            var name = vm.templateName.name;
            __template.sendTestMail(name, email)
              .then(function(response){
                ;
                Notification.success('Test email has been sent');
              })
              .catch(function(err){
                console.log(err);
                Notification.error(err.data.message);
              });
          }
        }
      },

      handleSubmit: function(){
        var form = $scope.form;
        if ( form.$valid ){
          if ( vm.templateName !== null ) {
            var name = vm.templateName.name;
            __template.updateTemplateByName(name, vm.templateData)
              .then(
                function(){
                  Notification.success('Mail template was updated');
                  // $scope.isSaved = true;
                },
                $scope.handleError
              )
          }
        }
      },

      getTemplateByName: function(name){
        if ( name !== '' ) {
          __template.getTemplateByName(name)
            .then(
              function(response){
                var data = response.data;
                vm.templateData = {
                  description: $scope.nameReplace(data.description),
                  name: data.name,
                  subject: data.subject,
                  template: data.template,
                  vars: data.vars.map(function(item){
                    return {
                      var: item.var,
                      description: $scope.nameReplace(item.description)
                    }
                  })
                };
                // $scope.isSaved = false;
              },
              $scope.handleError
            );
        }
      },

      nameReplace: function(string){
        var string = string.toLowerCase();
        var newString;

        var vendor = 'vendor';
        var volunteer = 'volunteer';
        var participant = 'participant';
        var sponsor = 'sponsor';

        var rootVendor = vm.vendorModule.label || 'vendor';
        var rootVolunteer = vm.volunteerModule.label || 'volunteer';
        var rootParticipant = vm.participantModule.label || 'participant';
        var rootSponsor = vm.sponsorModule.label || 'sponsor';

        if ( string.indexOf(vendor) !== -1 ) {
          newString = string.replace(vendor, rootVendor);
        } else if ( string.indexOf(volunteer) !== -1 ) {
          newString = string.replace(volunteer, rootVolunteer);
        } else if ( string.indexOf(participant) !== -1 ) {
          newString = string.replace(participant, rootParticipant);
        } else if ( string.indexOf(sponsor) !== -1 ){
          newString = string.replace(sponsor, rootSponsor);
        } else {
          newString = string;
        }

        return newString.charAt(0).toUpperCase() + newString.slice(1);
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      }
    });

  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerEventK2OneTimeFormController', OrganizerEventK2OneTimeFormController)
         .filter('FilterSearchBy', FilterSearchBy);

  function FilterSearchBy(){
    return function(items, query){
      if ( items ){
        if ( query ){
          var result = [];
          var s = query.toLowerCase();
          for ( var i in items ){
            if (
              (items[i].FirstName && items[i].FirstName.toLowerCase().indexOf(s) > -1) ||
              (items[i].LastName && items[i].LastName.toLowerCase().indexOf(s) > -1) ||
              (items[i].Email && items[i].Email.toLowerCase().indexOf(s) > -1) ||
              (items[i].Phone1 && items[i].Phone1.toLowerCase().indexOf(s) > -1) ||
              (items[i].Phone2 && items[i].Phone2.toLowerCase().indexOf(s) > -1)
            ){
              result.push(items[i]);
            }
          }
          return result;
        }
      }
      return items;
    }
  }

  OrganizerEventK2OneTimeFormController.$inject = [
    '$scope',
    '$uibModalInstance',
    'moment',
    'K2Service',
    'Notification'
  ];

  function OrganizerEventK2OneTimeFormController(
    $scope,
    $uibModalInstance,
    moment,
    K2Service,
    Notification
  ) {
    var vm = this;

    vm.selectedMacrosIndex = null;
    vm.selectedMacrosValue = null;

    var format = 'YYYY-MM-DDTHH:mm:ss.000Z';

    var startDate = moment(new Date()).set({
      hour: 0, minute: 0, second: 0
    });
    var endDate = moment(new Date()).set({
      hour: 23, minute: 59, second: 59
    }).add(1, 'days');

    $scope.template = {
      users: []
    };
    $scope.macroses = [];
    $scope.users = {};

    $scope.formLoading = false;
    $scope.usersLoading = true;
    // $scope.modalLoading = true;

    // $scope.startMaxDate = endDate.toDate();
    $scope.endMindate = startDate.toDate();

    angular.extend($scope, {
      datepickerFormat: 'MMMM dd, yyyy',

      startDateOptions: {
        formatYear: 'yy',
        // maxDate: moment(endDate).subtract(1, 'days').toDate(),
        startingDay: 1
      },

      endDateOptions: {
        formatYear: 'yy',
        minDate: moment(startDate).add(1, 'days').toDate(),
        startingDay: 1
      },

      popup1: {
        opened: false
      },
      popup2: {
        opened: false
      },
      onPopup1Open: function(){
        $scope.popup1.opened = true;
        
      },
      onPopup2Open: function(){
        $scope.popup2.opened = true;
        // $scope.endDateOptions.minDate = moment(vm.startDate).add(1, 'days').toDate();
      },

      handleStartDate: function(start, end){
        if ( moment(start).isAfter(end) ){
          if ( !moment(start).isSame(end) ){
            vm.endDate = moment(start).add(1, 'days').toDate();
          }
        }
        $scope.endDateOptions.minDate = moment(start).add(1, 'days').toDate();
      },

      onInit: function(){
        K2Service.fetchVariables()
          .then(function(response){
            $scope.macroses = response.data;

            return K2Service.fetchUsers(startDate.utc().format(format), endDate.utc().format(format));
          })
          .then(function(response){
            vm.startDate = startDate.toDate();
            vm.endDate = endDate.toDate();
            $scope.users = response.data.map(function(item){
              return angular.extend({}, item, { checked: false });
            });
            $scope.usersLoading = false;
          })
          .catch(function(err){
            console.error(err);
          })
      },

      handleCheckAll: function(checked){
        if ( checked ){
          var users = $scope.users.map(function(item){
            item['checked'] = true
            return item;
          });
          $scope.template.users = users;
        } else {
          var users = $scope.users.map(function(item){
            item['checked'] = false
            return item;
          });
          $scope.template.users = [];
        }
      },

      handleChangeSearch: function(s){
        vm.filterSearch = s;
      },

      handleUsers: function(user){
        var idx = $scope.template.users.indexOf(user);
        idx === -1 ? $scope.template.users.push(user) : $scope.template.users.splice(idx, 1);
      },

      handleApply: function(){
        $scope.usersLoading = true;

        var start = moment(vm.startDate).set({
          hour: 0, minute: 0, second: 0
        });
        var end = moment(vm.endDate).set({
          hour: 23, minute: 59, second: 59
        });

        K2Service.fetchUsers(start.utc().format(format), end.utc().format(format))
          .then(function(response){
            vm.startDate = start.toDate();
            vm.endDate = end.toDate();
            $scope.users = response.data.map(function(item){
              return angular.extend({}, item, { checked: false });
            });
            $scope.usersLoading = false;
          })
          .catch(function(err){
            console.error(err);
            $scope.usersLoading = false;
            Notification.error(err.data.message);
          })
      },

      handleSubmit: function(){
        var form = $scope.form;

        if ( form.$valid && $scope.template.users.length ){
          K2Service.sendOneTime($scope.template)
            .then(function(){
              Notification.success('Notification sent');
              $uibModalInstance.close();
            })
            .catch(function(err){
              console.log(err);
            });
        }
      },

      handleCancel: function(){
        $uibModalInstance.dismiss('Cancel');
      },


      handleClickMacros: function(value, index){
        vm.selectedMacrosValue = value;
        vm.selectedMacrosIndex = index;
      },

      handleClickClearMacros: function(){
        vm.selectedMacrosValue = null;
        vm.selectedMacrosIndex = null;
      },

      handleClickCursorPosition: function(){
        if ( vm.selectedMacrosValue ){
          var sel, range;
          sel = window.getSelection();
          if ( sel.getRangeAt && sel.rangeCount ){
            vm.rango = sel.getRangeAt(0);
            vm.rango.insertNode(document.createTextNode(vm.selectedMacrosValue));
            // vm.macroData = '';
            // $scope.active = false;
            $scope.handleClickClearMacros();
            return sel.getRangeAt(0);
          }
        }
      },

      handleFocusControl: function(elem){
        if ( vm.selectedMacrosValue ){
          var input = document.getElementById(elem);
          if ( document.selection ){
            input.focus();
            sel = document.selection.createRange();
            sel.text = vm.selectedMacrosValue;
            $scope.template[elem] = sel.text;
          } else if ( input.selectionStart || input.selectionStart == '0'){
            var startPos = input.selectionStart;
            var endPos = input.selectionEnd;
            input.value = input.value.substring(0, startPos)
                + vm.selectedMacrosValue
                + input.value.substring(endPos, input.value.length);
            $scope.template[elem] = input.value;
          } else {
            input.value += vm.selectedMacrosValue;
            $scope.template[elem] = input.value;
          }
          $scope.handleClickClearMacros();
        }
      }
    })
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerEventK2TemplatesController', OrganizerEventK2TemplatesController);

  OrganizerEventK2TemplatesController.$inject = [
    '$scope',
    '$uibModal',
    'K2Service',
    'ApproveService',
    'Notification'
  ];

  function OrganizerEventK2TemplatesController(
    $scope,
    $uibModal,
    K2Service,
    ApproveService,
    Notification
  ) {
    var vm = this;

    $scope.pageLoading = true;

    angular.extend($scope, {
      onInit: function(){
        // Load templates
        K2Service.fetchTemplates()
          .then(function(response){
            $scope.templates = response.data;
            $scope.pageLoading = false;
          })
          .catch(function(err){
            console.log(err);
          });
      },

      handleCreateTemplate: function(){
        $uibModal.open({
          templateUrl: 'app/users/organizer/event/k2-templates/form.html',
          controller: 'OrganizerEventK2TemplatesFormController as vm',
          size: 'lg',
          resolve: {
            resolveTemplate: function(){
              return null;
            }
          }
        }).result.then(
          function(result){
            $scope.templates.push(result);
          },
          function(err){}
        )
      },

      handleUpdateTemplate: function(data){
        if ( data && data.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/event/k2-templates/form.html',
            controller: 'OrganizerEventK2TemplatesFormController as vm',
            size: 'lg',
            resolve: {
              resolveTemplate: function(){
                return data;
              }
            }
          }).result.then(
            function(result){
              var tm = $scope.templates.find(function(item){
                return item.id === result.id;
              });
              var idx = $scope.templates.indexOf(tm);
              $scope.templates[idx] = result;
            }
          )
        } else {
          console.error('No template or template ID exist');
        }
      },

      handleDeleteTemplate: function(data){
        if ( data && data.id ){
          ApproveService(
            'Are you sure you want to delete notification template?',
            'Delete',
            function(){
              return K2Service.deleteTemplate(data.id)
            }
          ).result.then(
            function(){
              var tm = $scope.templates.find(function(item){
                return item.id === data.id;
              });
              var idx = $scope.templates.indexOf(tm);
              $scope.templates.splice(idx, 1);

              Notification.success('Template was removed');
            },
            function(err){
              // console.log('Cancel');
            }
          );
        } else {
          console.error('No template or template ID exist');
        }
      },


      // One time notification
      handleOneTimeNotification: function(){
        $uibModal.open({
          templateUrl: 'app/users/organizer/event/k2-templates/one-time.form.html',
          controller: 'OrganizerEventK2OneTimeFormController as vm',
          size: 'lg'
        });
      }
    })
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerEventK2TemplatesFormController', OrganizerEventK2TemplatesFormController);

  OrganizerEventK2TemplatesFormController.$inject = [
    '$scope',
    '$uibModalInstance',
    'K2Service',
    'Notification',
    'resolveTemplate'
  ];

  function OrganizerEventK2TemplatesFormController(
    $scope,
    $uibModalInstance,
    K2Service,
    Notification,
    resolveTemplate
  ) {
    var vm = this;

    vm.selectedMacrosIndex = null;
    vm.selectedMacrosValue = null;
    // $scope.formData = {};
    $scope.template = {};
    $scope.macroses = [];

    $scope.formLoading = false;
    // $scope.modalLoading = true;

    angular.extend($scope, {
      onInit: function(){

        K2Service.fetchVariables()
          .then(function(response){
            if ( resolveTemplate && typeof resolveTemplate !== 'undefined' ){
              $scope.template = angular.copy(resolveTemplate);
            }
            $scope.macroses = response.data;
          })
          .catch(function(err){
            console.error(err);
          })
      },

      handleSubmit: function(){
        var form = $scope.form;

        if ( form.$valid ){
          $scope.formLoading = true;

          if ( $scope.template.notificationTimeType === '' ){
            delete $scope.template['notificationTimeType'];
            delete $scope.template['daysNumber'];
          }

          if ( resolveTemplate && typeof resolveTemplate !== 'undefined' ){
            K2Service.updateTemplate($scope.template)
              .then(function(response){
                $scope.handleResponse(response.data, 'Template was updated');
              })
              .catch($scope.catchError);
          } else {
            K2Service.createTemplate($scope.template)
              .then(function(response){
                $scope.handleResponse(response.data, 'Template was created');
              })
              .catch($scope.catchError);
          }
        }
      },

      handleResponse: function(data, msg){
        Notification.success(msg);
        $uibModalInstance.close(data);
        // console.log(data);
        $scope.formLoading = false;
      },

      catchError: function(err){
        Notification.error(err);
        // console.log(err);
        $scope.formLoading = false;
      },

      handleCancel: function(){
        $uibModalInstance.dismiss('Cancel');
      },


      handleClickMacros: function(value, index){
        vm.selectedMacrosValue = value;
        vm.selectedMacrosIndex = index;
      },

      handleClickClearMacros: function(){
        vm.selectedMacrosValue = null;
        vm.selectedMacrosIndex = null;
      },

      handleClickCursorPosition: function(){
        if ( vm.selectedMacrosValue ){
          var sel, range;
          sel = window.getSelection();
          if ( sel.getRangeAt && sel.rangeCount ){
            vm.rango = sel.getRangeAt(0);
            vm.rango.insertNode(document.createTextNode(vm.selectedMacrosValue));
            // vm.macroData = '';
            // $scope.active = false;
            $scope.handleClickClearMacros();
            return sel.getRangeAt(0);
          }
        }
      },

      handleFocusControl: function(elem){
        if ( vm.selectedMacrosValue ){
          var input = document.getElementById(elem);
          if ( document.selection ){
            input.focus();
            sel = document.selection.createRange();
            sel.text = vm.selectedMacrosValue;
            $scope.template[elem] = sel.text;
          } else if ( input.selectionStart || input.selectionStart == '0'){
            var startPos = input.selectionStart;
            var endPos = input.selectionEnd;
            input.value = input.value.substring(0, startPos)
                + vm.selectedMacrosValue
                + input.value.substring(endPos, input.value.length);
            $scope.template[elem] = input.value;
          } else {
            input.value += vm.selectedMacrosValue;
            $scope.template[elem] = input.value;
          }
          $scope.handleClickClearMacros();
        }
      }
    })
  }
})();
(function() {
  'use strict';
  
  angular
    .module('eventmap')
    .controller('OrganizerInventoryFormController', OrganizerInventoryFormController);

  function OrganizerInventoryFormController(
    $rootScope,
    $scope,
    $uibModalInstance,
    Notification,
    InventoryService,
    // EventService,
    MapService,
    UserGroupsService,
    resolveData
  ) {
    var vm = this;
    $scope.formSubmitted = false;
    $scope.formLoading = false;

    vm.event = $rootScope.currentEvent;
    vm.link = [];

    angular.extend($scope, {
      label: ( resolveData && resolveData.id ? 'Update' : 'Add'),
      searchType: 'vendor,volunteer,special'
    });

    angular.extend($scope, {
      onInit: function() {
        vm.participantModule = $rootScope.currentEvent.preferences.participantModule;
        // vm.sponsorModule = $rootScope.currentEvent.preferences.sponsorModule;

        if ( vm.event.modules.indexOf('participant') > -1 ) {
          $scope.searchType += ',participant';
        }

        MapService.getMapByID($rootScope.currentEvent.mainEventMapId)
          .then(
            function(response){
              var data = response.data;
              vm.eventZones = data.eventZones;
              vm.respZones = data.responsibilityZones;

              if ( resolveData && resolveData.id ) {
                vm.inventory = resulveData;
                vm.link.users = [];
                vm.link.groups = [];

                angular.forEach(resolveData.links, function(item) {
                  if ( item.type === 'eventZones' ) {
                    if ( vm.eventZones ) {
                      vm.link.eventZones = vm.eventZones.filter(function(zone) {
                        return zone.id === item.id;
                      })[0];
                    }
                  }

                  if ( item.type === 'respZones' ) {
                    if ( vm.respZones ) {
                      vm.link.respZones = vm.respZones.filter(function(zone) {
                        return zone.id === item.id;
                      })[0];
                    }
                  }

                  if ( item.type === 'users' ) {
                    vm.link.users.push({
                      id: item.id,
                      type: item.type,
                      name: item.note
                    });
                  }
                  if ( item.type === 'groups' ) {
                    vm.link.groups.push({
                      id: item.id,
                      type: item.type,
                      name: item.note
                    });
                  }
                });
              }
            },
            $scope.handleError
          );

        UserGroupsService.getGroups()
          .then(
            function(response) {
              vm.userGroups = response.data;
            },
            $scope.handleError
          );
      },

      handleUsersSearch: function(query) {
        UserGroupsService.searchUsers($scope.searchType, query)
          .then(
            function(response){
              vm.usersSearch = response.data;
            },
            $scope.handleError
          );
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          vm.inventory.links = [];
          if ( vm.link.eventZones ) {
            vm.inventory.links.push({
              type: 'eventZones',
              id: parseInt(vm.link.eventZones.id),
              note: vm.link.eventZones.name
            });
          }
          if ( vm.link.respZones ) {
            vm.inventory.links.push({
              type: 'respZones',
              id: parseInt(vm.link.respZones.id),
              note: vm.link.respZones.description
            });
          }
          if ( vm.link.users ) {
            angular.forEach(vm.link.users, function(item){
              vm.inventory.links.push({
                type: 'users',
                id: item.id,
                note: item.name
              });
            });
          }
          if ( vm.link.groups ) {
            angular.forEach(vm.link.groups, function(item){
              vm.inventory.links.push({
                type: 'groups',
                id: item.id,
                note: item.name
              });
            });
          }
          if ( resolveData && resolveData.id ) {
            InventoryService.onUpdate(vm.inventory)
              .then(
                function(response) {
                  Notification.success('Inventory was updated');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          } else {
            InventoryService.onAdd(vm.inventory)
              .then(
                function(response) {
                  Notification.success('Inventory was added');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          }
        }
      },

      handleCancel: function() {
        // $state.go('users.organizer.event.inventory');
        $uibModalInstance.dismiss('cancel');
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerInventoryController', OrganizerInventoryController);
  
  OrganizerInventoryController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'InventoryService'
  ];

  function OrganizerInventoryController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    __inventory
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function() {
        vm.currentPage = 1;

        __inventory.getInventories()
          .then(
            function(response) {
              vm.inventories = __inventory.inventories(response.data);
            },
            $scope.handleError
          )
      },

      handleCreate: function(){
        $uibModal.open({
          templateUrl: 'app/users/organizer/event/inventory/inventory.form.html',
          controller: 'OrganizerInventoryFormController as vm',
          resolve: {
            resolveData: function(){
              return null;
            }
          }
        }).result.then(
          function(result){
            __inventory.add(result);
          },
          function(err){

          }
        );
      },

      handleEdit: function(inventory){
        if ( inventory && inventory.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/event/inventory/inventory.form.html',
            controller: 'OrganizerInventoryFormController as vm',
            resolve: {
              resolveData: function(){
                return inventory;
              }
            }
          }).result.then(
            function(result){
              __inventory.update(result);
            },
            function(err){

            }
          );
        }
      },

      handleRemove: function(inventory) {
        if ( inventory && inventory.id ) {
          __inventory.onRemove(inventory.id)
            .then(
              function(response){
                Notification.success('Inventory was removed');
                __inventory.remove(response.data);

                vm.currentPage = $scope.navigatePagination(vm.inventories);
              },
              $scope.handleError
            );
        }
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerFinancialReportController', OrganizerFinancialReportController);
  
  OrganizerFinancialReportController.$inject = [
    '$rootScope',
    '$scope',
    'ReportService'
  ];

  function OrganizerFinancialReportController(
    $rootScope,
    $scope,
    __report
  ){
    var vm = this;
    vm.labels = [];
    vm.data = [];

    vm.reports = [];
    vm.total = null;

    var colors = [
      '#97BBCD', // blue
      '#DCDCDC', // light grey
      '#F7464A', // red
      '#46BFBD', // green
      '#FDB45C', // yellow
      '#949FB1', // grey
      '#4D5360'  // dark grey
    ];

    angular.extend($scope, {
      onInit: function(){

        __report.getReport()
          .then(
            function(response){
              var data = response.data;
              var idx = -1;
              for ( var i in data ){
                if ( i.toString() !== 'total' ){
                  vm.labels.push(i);
                  vm.data.push(data[i]);
                  vm.reports.push({
                    'label': i,
                    'data': data[i],
                    'color': colors[idx]
                  });
                } else {
                  vm.total = {
                    'label': i,
                    'data': data[i]
                  };
                }
                idx++;
              }
            }
          );

      }
    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerEventDynamicPageController', OrganizerEventDynamicPageController);

  function OrganizerEventDynamicPageController(
    $rootScope,
    $scope,
    $location,
    $uibModal,
    Notification,
    PageService
  ){
    var vm = this;
    $scope.formSubmitted = false;
    $scope.formLoading = false;
    $scope.form = {
      formData: null
    };

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.tagURL = null;

    $scope.dynamicPages = [];

    $scope.selectedPage = null;

    $scope.pageLoading = true;
    $scope.loading = false;

    $scope.copied = false;

    angular.extend($scope, {
      onInit: function(){
        var domain = ( $scope.currentEvent.domain !== 'localhost' ? $scope.currentEvent.domain : $scope.currentEvent.domain +':'+ $location.$$port);
        $scope.tagURL = 'http'+ ($scope.currentEvent.sslEnabled && $scope.currentEvent.domain !== 'localhost' ? 's' : '') +'://'+ domain +'/content-page';

        PageService.getPages('dynamic')
          .then(function(response){
            var data = response.data;

            $scope.dynamicPages = data;

            if ( data.length ) $scope.selectedPage = data[0];

            $scope.pageLoading = false;
          })
          .catch(function(err){
            console.error(err);

            $scope.pageLoading = false;
          });

      },

      handleAddPage: function(){
        $scope.formSubmitted = false;

        var page = {
          type: 'dynamic',
          tag: 'dynamicPageTag',
          name: '',
          content: ''
        };

        $scope.dynamicPages.push(page);
        $scope.selectedPage = page;
      },

      handleGetPage: function(page){
        $scope.selectedPage = page;
      },

      onCreatePage: function(page){
        $scope.formSubmitted = true;
        var form = $scope.form.formData;
        console.log(form);
        if ( form.$valid ){
          $scope.formLoading = true;
          PageService.createPage(page)
            .then(function(response){
              Notification.success('Extra page was created');

              var data = response.data;
              var idx = $scope.dynamicPages.indexOf(page);
              $scope.dynamicPages[idx] = data;

              if ( $scope.selectedPage ) $scope.selectedPage = data;

              $scope.formLoading = false;
            })
            .catch(function(err){
              Notification.error(err.data.message);

              $scope.formLoading = false;
            });
        }
      },

      onUpdatePage: function(page){
        var form = $scope.form.formData;
        if ( page && page.id ){
          $scope.formSubmitted = true;
          if ( form.$valid ){
            $scope.formLoading = true;
            // $scope.loading = true;
            PageService.updatePage(page)
              .then(function(response){
                Notification.success('Extra page was updated');

                $scope.formLoading = false;
              })
              .catch(function(err){
                $scope.formLoading = false;
                Notification.success(err.data.message);
              });
          }
        }
      },

      st: null,

      onClipBoard: function(){
        var copyText = document.getElementById('pageLink')
        copyText.select();
        document.execCommand('copy');

        $scope.copied = true;

        if ( $scope.st ){
          clearTimeout($scope.st);
        }

        $scope.st = setTimeout(function(){
          $scope.copied = false;
          $scope.$apply();
        }, 1000);
      },

      onDeletePage: function(page){
        if ( page && page.id ){
          $scope.loading = true;

          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete extra page: <b ng-bind="page.name"></b>?\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDelete()">Delete</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, PageService, page){
              $scope.page = page;
              $scope.handleDelete = function(){
                PageService.deletePage(page.id)
                  .then(function(){
                    $uibModalInstance.close();
                  })
                  .catch(function(err){
                    console.error(err);
                  });
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              page: function(){
                return page;
              }
            }
          });

          modal.result
            .then(
              function(){
                Notification.success('Extra page was deleted');

                var idx = $scope.dynamicPages.indexOf(page);
                $scope.dynamicPages.splice(idx, 1);

                $scope.loading = false;

                $scope.selectedPage = null;

                if ( $scope.dynamicPages.length ) $scope.selectedPage = $scope.dynamicPages[0];
              },
              function(){
                console.log('Deleted');

                $scope.loading = false;
              }
            );
        } else {
          var idx = $scope.dynamicPages.indexOf(page);
          $scope.dynamicPages.splice(idx, 1);

          $scope.selectedPage = null;

          if ( $scope.dynamicPages.length ) $scope.selectedPage = $scope.dynamicPages[0];
        }
      }
    });
  }

})();
(function() {
  'use strict';
  
  angular
    .module('eventmap')
    .controller('OrganizerBoothsFormController', OrganizerBoothsFormController);

  function OrganizerBoothsFormController(
    $scope,
    $uibModalInstance,
    Notification,
    BoothTypeService,
    boothType
  ) {
    var vm = this;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    angular.extend($scope, {
      label: ( boothType ? 'Update' : 'Add')
    });

    vm.selectedColor = '#000000';
    vm.boothType = {
      commercial: false,
      preferences: {
        color: vm.selectedColor,
        private: false
      }
    }

    angular.extend($scope, {
      onInit: function() {
        if ( boothType ){
          vm.boothType = boothType;
          vm.selectedColor = boothType.preferences && boothType.preferences.color ? boothType.preferences.color : vm.selectedColor;
        }
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;

        if ( vm.boothType.icon && vm.boothType.icon.length === 0 ){
          vm.boothType.icon = null;
        }

        if ( form.$valid ) {
          $scope.formLoading = true;
          if ( vm.boothType.commercial ){
            vm.boothType.preferences.private = false;
          }
          if ( boothType && boothType.id ) {
            BoothTypeService.onUpdate(boothType.id, vm.boothType)
              .then(
                function(response){
                  Notification.success('Booth type was updated');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          } else {
            BoothTypeService.onAdd(vm.boothType)
              .then(
                function(response){
                  Notification.success('Booth type was created');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          }
        }
      },

      handleCancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

    vm.onChangeSelectedColor = function(color){
      var pref = vm.boothType.preferences;
      pref.color = color;
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerBoothsController', OrganizerBoothsController);
  
  OrganizerBoothsController.$inject = [
    '$rootScope',
    '$scope',
    'Notification',
    '$uibModal',
    'BoothTypeService'
  ];

  function OrganizerBoothsController(
    $rootScope,
    $scope,
    Notification,
    $uibModal,
    __boothType
  ) {
    var vm = this;
    vm.boothTypes = null;

    $scope.loading = true;

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;

        __boothType.getBooths()
          .then(
            function(response){
              var data = response.data;
              vm.boothTypes = __boothType.booths(data);

              $scope.loading = false;
            },
            $scope.handleError
          );
      },

      handleCreate: function(){
        $uibModal.open({
          templateUrl: 'app/users/organizer/event/booths/booths.form.html',
          controller: 'OrganizerBoothsFormController as vm',
          resolve: {
            boothType: function(){
              return null;
            }
          }
        }).result.then(
          function(result){
            __boothType.pushBooth(result);
          },
          function(err){

          }
        );
      },

      handleEdit: function(boothType){
        if ( boothType && boothType.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/event/booths/booths.form.html',
            controller: 'OrganizerBoothsFormController as vm',
            resolve: {
              boothType: function(){
                return boothType;
              }
            }
          }).result.then(
            function(result){
              __boothType.updateBooth(result);
            },
            function(err){

            }
          );
        }
      },

      handleDelete: function(boothType){
        if ( boothType && boothType.id ){
          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete <b>{{boothType.type}}</b>?\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, boothType, BoothTypeService){
              $scope.boothType = boothType;
              $scope.loading = false;
              
              $scope.handleConfirm = function(){
                $scope.loading = true;
                BoothTypeService.onDelete(boothType.id)
                  .then(
                    function(){
                      $uibModalInstance.close(boothType);
                      $scope.loading = false;
                    },
                    function(err){
                      $uibModalInstance.dismiss('cancel');
                      $scope.loading = false;
                      Notification.error(err.data.message);
                    }
                  );
              }
  
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              boothType: function(){
                return boothType;
              }
            }
          });
  
          modal.result
            .then(
              function(result){
                Notification.success('Booth type was removed');
                __boothType.spliceBooth(result);
                vm.currentPage = $scope.navigatePagination(vm.boothTypes);
              },
              function() {
              }
            );
        }
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      },
      
      onChangeItemsOf: function() {
        var total = vm.filterBoothTypes.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },
    });

  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerDontationsController', OrganizerDontationsController);
  
  OrganizerDontationsController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'EventService',
    'DonationsService'
  ];

  function OrganizerDontationsController(
    $rootScope,
    $scope,
    $uibModal,
    __event,
    __donations
  ) {
    var vm = this;

    $scope.loadingFile = false;

    angular.extend($scope, {
      onInit: function(){
        vm.event = $rootScope.currentEvent;

        __donations.getDonations()
          .then(
            function(response) {
              vm.donations = __donations.donations(response.data);
            },
            function(err) {
              console.log(err);
            }
          );

      },

      handleDonation: function() {
        var modal = $uibModal.open({
          templateUrl: 'app/donations-form/donations-form.html',
          controller: 'DonationFormController',
          controllerAs: 'vm',
          resolve: {
            relocate: function(){
              return false;
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              __donations.add(resolve);
            },
            function(){
              console.log('Dissmissed');
            }
          );
      },

      handleTransaction: function(donate){
        if ( donate.id ) {
          var modal = $uibModal.open({
            templateUrl: 'app/users/organizer/transaction/transaction.modal.html',
            controller: 'OrganizerTransactionController',
            controllerAs: 'vm',
            resolve: {
              request: function(){
                return donate;
              },
              userType: function(){
                return 'edr';
              }
            }
          });
        }
      },

      handleDownload: function() {
        $scope.loadingFile = true;
        __donations.exportDonations()
          .then(
            function(response){
              var id = response.data.id +'.csv';
              __event.getCsvFile(id)
                .then(
                  function(response){
                    var url = URL.createObjectURL(new Blob([response.data]));
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = moment().format('YYYYMMDDHHmm') +'-participants.csv';
                    a.target = '_blank';
                    // Need for ff
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  },
                  $scope.handleError
                );
              $scope.loadingFile = false;
            },
            function(err){
              $scope.loadingFile = false;
              console.log(err);
            }
          );
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerCategoriesFormController', OrganizerCategoriesFormController);
  
  OrganizerCategoriesFormController.$inject = [
    '$scope',
    '$uibModalInstance',
    // '$state',
    // '$stateParams',
    'Notification',
    'CategoryService',
    'resolveData'
  ];

  function OrganizerCategoriesFormController(
    $scope,
    $uibModalInstance,
    // $state,
    // $stateParams,
    Notification,
    CategoryService,
    resolveData
  ) {
    var vm = this;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    vm.category = {
      preferences: null
    };
    vm.selectedColor = '#000000';

    angular.extend($scope, {
      label: ( resolveData && resolveData.id ? 'Update' : 'Add')
    })

    angular.extend($scope, {
      onInit: function() {
        if ( resolveData && resolveData.id ) {
          vm.category = resolveData;
          vm.selectedColor = resolveData.preferences && resolveData.preferences.color ? resolveData.preferences.color : '';
        }
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          if ( resolveData && resolveData.id ) {
            CategoryService.onUpdate(resolveData.id, vm.category)
              .then(
                function(response){
                  Notification.success('Category was updated');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          } else {
            CategoryService.onAdd(vm.category)
              .then(
                function(response){
                  Notification.success('Category was created');
                  $uibModalInstance.close(response.data);
                },
                $scope.handleError
              );
          }
        }
      },

      handleCancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

    vm.onChangeSelectedColor = function(color){
      var pref = vm.category.preferences;
      if ( pref ) {
        pref.color = color
      } else {
        vm.category.preferences = {
          color: color
        };
      }
    };

  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerCategoriesController', OrganizerCategoriesController);
  
  OrganizerCategoriesController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'CategoryService'
  ];

  function OrganizerCategoriesController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    CategoryService
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function() {
        vm.currentPage = 1;

        CategoryService.getCategories()
          .then(
            function(response){
              vm.categories = CategoryService.categories(response.data);
            },
            $scope.handleDelete
          );
      },

      handleCreate: function(){
        $uibModal.open({
          templateUrl: 'app/users/organizer/event/categories/categories.form.html',
          controller: 'OrganizerCategoriesFormController as vm',
          resolve: {
            resolveData: function(){
              return null;
            }
          }
        }).result.then(
          function(result){
            CategoryService.pushCategory(result);
          },
          function(err){
            console.log(err);
          }
        )
      },

      handleEdit: function(category){
        if ( category && category.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/event/categories/categories.form.html',
            controller: 'OrganizerCategoriesFormController as vm',
            resolve: {
              resolveData: function(){
                return category;
              }
            }
          }).result.then(
            function(result){
              CategoryService.updateCategory(result);
            },
            function(err){
              console.log(err);
            }
          )
        }
      },

      handleDelete: function(category) {
        if ( category && category.id ) {

          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger text-center">Are you sure you want to completely delete category <b>{{category.name}}</b>?</h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, category, CategoryService){
              $scope.category = category;
              $scope.loading = false;
              
              $scope.handleConfirm = function(){
                $scope.loading = true;

                CategoryService.onDelete(category.id)
                  .then(
                    function(){
                      $uibModalInstance.close(category);
                      $scope.loading = false;
                    },
                    function(err){
                      $scope.loading = false;
                      Notification.error(err.data.message);
                    }
                  );
              }
  
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              category: function(){
                return category;
              }
            }
          });
  
          modal.result
            .then(
              function(result){
                Notification.success('Category was removed');
                CategoryService.spliceCategory(result);
                vm.currentPage = $scope.navigatePagination(vm.categories);
              },
              function() {
              }
            );
        }
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });

  }
})();
(function(){
  'use strict';

  var hash = window.objectHash || objectHash;

  angular
    .module('eventmap')
    .controller('VolunteerCoordinatorMapController', VolunteerCoordinatorMapController)

  function VolunteerCoordinatorMapController(
    $rootScope,
    $scope,
    $timeout,
    $uibModal,
    $state,
    $stateParams,
    moment,

    Notification,
    BoothTypeService,
    EventService,
    VolunteerService,
    MapService,

    GenerateUUID,

    IndoorService,
    OutdoorService,

    // Outdoor
    Route,
    RespZone,

    // Indoor
    IndoorRoute,
    IndoorZone,

    // Tools
    ToolsMap
  ){
    var vm = this;

    var MAP_ID;

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.currentUser = $rootScope.currentUser;

    $scope.boothTypes = [];

    $scope.userNonCommercialAssignments = [];
    $scope.userCommercialAssignments = [];

    $scope.map = null;

    // $scope.booths = [];
    // $scope._eventZones = [];
    $scope.responsibilityZones = [];
    $scope.routes = [];
    // $scope._booths = [];
    // $scope.eventZones = [];

    // Map items visibility
    // $scope.isBoothsVisible = true;
    $scope.isRoutesVisible = true;
    $scope.isRespZonesVisible = true;
    // $scope.isEventZonesVisible = true;
    // Unassigned
    $scope.onlyUnassignedRespZone = false;
    // $scope.onlyUnassignedBooth = false;

    // Selected Item/Color
    $scope.selectedItem = null;
    $scope.selectedItemColor = null;
    // Draw Mode
    $scope.isDrawModeEnabled = false;
    $scope.drawModeType = null;

    // Draw Mode type
    $scope.drawTypeOverlay = 'Overlay';
    // $scope.drawTypeBooth = ToolsMap.drawType.booth;
    $scope.drawTypeRoute = ToolsMap.drawType.route;
    $scope.drawTypeRespZone = ToolsMap.drawType.respZone;
    // $scope.drawTypeEventZone = ToolsMap.drawType.eventZone;

    $scope.mapData = null;

    angular.extend($scope, {
      onInit: function(){
        OutdoorService.resetOutdoorData();
        IndoorService.resetIndoorData();

        // if ( MAP_ID ){
          BoothTypeService.getBooths()
            .then(function(response){
              $scope.boothTypes = response.data;

              return EventService.getSpecials('special');
            })
            .then(function(response){
              for ( var i in response.data ){
                setUserNonCommercialAssignments(response.data[i]);
              }

              return VolunteerService.getRequestByStatus('accepted');
            })
            .then(function(response){
              var data = response.data;
              $scope.volunteerRequests = data;

              for ( var i in data ){
                // Non commercial assignments
                setUserNonCommercialAssignments(data[i].volunteer);
              }

              if ( typeof $stateParams.id !== 'undefined' ){
                MAP_ID = parseInt($stateParams.id, 10);
                $scope.fetchMap(MAP_ID);
              } else if ( typeof $stateParams.id === 'undefined' && $scope.currentEvent.mainEventMapId ){
                MAP_ID = $scope.currentEvent.mainEventMapId;
                $scope.fetchMap($scope.currentEvent.mainEventMapId);
              } else if ( typeof $stateParams.id === 'undefined' && !$scope.currentEvent.mainEventMapId ){
                $scope.map = OutdoorService;
                $scope.map.initMap({}, $scope.mapCallback);
                $scope.initMapItems({}, $scope.map);
              }
            })
            .catch(function(err){
              console.error(err);
            });
        // } else {
        //   Notification.error('Map ID not present');
        // }

      },

      fetchMap: function(id){
        MapService.getMapByID(id)
          .then(function(response){
            var data = response.data;
            if ( data.type === 'outdoor' ){
              $scope.map = OutdoorService;
              $scope.map.initMap(data, $scope.mapCallback);
              $scope.initMapItems(data, $scope.map);
            } else if ( data.type === 'indoor' ){
              $scope.map = IndoorService;
              $scope.map.initMap(data, $scope.mapCallback);
              $scope.initMapItems(data, $scope.map);
            } else {
              Notification.error('Map type not present');
            }
          })
          .catch(function(err){
            console.log(err);
          });
      },

      initMapItems: function(data, map){
        $scope.mapData = data;
        // if ( data.eventZones && data.eventZones.length ){
        //   // var zones = GenerateUUID.replaceDuplicateID(data.eventZones);
        //   for ( var i in data.eventZones ) {
        //     var item = data.eventZones[i];
        //     var zone = data.type === 'indoor' ? new IndoorZone() : new EventZone();
        //     zone.read(item);
        //     $scope._eventZones.push(zone);
        //     // map.drawEventZone(zone, false);
        //   }
        // }
  
        if ( data.responsibilityZones && data.responsibilityZones.length ){
          var zones = GenerateUUID.replaceDuplicateID(data.responsibilityZones);
          for ( var i in zones ){
            var item = zones[i];
            var zone = data.type === 'indoor' ? new IndoorZone() : new RespZone();
            zone.read(item);
            if ( typeof zone.id === 'undefined' ){
              zone.id = GenerateUUID.uuid();
            }
            map.drawResponsibilityZone(zone, true);
          }
        }
  
        if ( data.routes && data.routes.length ){
          var routes = GenerateUUID.replaceDuplicateID(data.routes);
          for ( var i in routes ){
            var item = routes[i];
            var route = data.type === 'indoor' ? new IndoorRoute(true) : new Route();
            route.read(item);
            if ( typeof route.id === 'undefined' ){
              route.id = GenerateUUID.uuid();
            }
            map.drawRoute(route, true);
          }
        }
  
        // if ( data.booths && data.booths.length ){
        //   // var booths = GenerateUUID.replaceDuplicateID(data.booths);
        //   for ( var i in data.booths ){
        //     var item = data.booths[i];
        //     // IndoorBooth:
        //     // @params isDraggable
        //     var booth = data.type === 'indoor' ? new IndoorBooth(true) : new Booth();
        //     booth.read(item, $scope.boothTypes);
        //     $scope._booths.push(booth);
        //     // map.drawBooth(booth, false);
        //   }
        // }

        // $scope.eventZones = map.fetchEventZones();
        $scope.responsibilityZones = map.fetchResponsibilityZones();
        $scope.routes = map.fetchRoutes();
        // $scope.booths = map.fetchBooths();

        $scope.unlinkedRequests = $scope.getUnlinkedRequests();

        $scope.mapHash = hash($scope.getMapData());

        // Remove it in feature
        window.googleMap = $scope.map.getMap();
        // window.booths = $scope.booths;
        window.routes = $scope.routes;
        window.respZones = $scope.responsibilityZones;
        // window.eventZones = $scope.eventZones;
      },

      getMapData: function(){
        var data = $scope.map.getMapData();

        data['eventZones'] = $scope.mapData.eventZones;
        data['responsibilityZones'] = [];
        data['routes'] = [];
        data['booths'] = $scope.mapData.booths;

        // for ( var i in $scope._eventZones ){
        //   data.eventZones.push($scope._eventZones[i].set());
        // }
        for ( var i in $scope.map.fetchRoutes() ){
          data.routes.push($scope.map.fetchRoutes()[i].set());
        }
        for ( var i in $scope.map.fetchResponsibilityZones() ){
          data.responsibilityZones.push($scope.map.fetchResponsibilityZones()[i].set());
        }
        // for ( var i in $scope._booths ){
        //   data.booths.push($scope._booths[i].set());
        // }

        return data;
      },

      // Save map
      mapSaveLoading: false,

      saveMapData: function(){
        $scope.map.checkGlobalRoute();

        var data = $scope.getMapData();

        if ( data ){
          $scope.mapSaveLoading = true;
          if ( MAP_ID ){
            MapService.updateMap(MAP_ID, data)
              .then(function(response){
                Notification.success('Map was updated');

                $scope.handleDrawModeType();

                $scope.mapSaveLoading = false;

                $scope.isCreatedNewMapItem = false;
                $scope.isFieldRequired = false;

                console.log('Response', response);
              })
              .catch(function(err){
                console.error(err);

                $scope.mapSaveLoading = false;
              });
          } else {
            MapService.createMap(data)
              .then(function(response){
                var data = response.data;

                EventService.assignMainMap(data.id)
                  .then(function(){
                    Notification.success('Map was saved');
    
                    $scope.handleDrawModeType();
    
                    $scope.mapSaveLoading = false;
    
                    $scope.isCreatedNewMapItem = false;
                    $scope.isFieldRequired = false;
    
                    // Set main map
                    $rootScope.currentEvent['mainEventMapId'] = data.id;
                  })
                  .catch(function(err){
                    console.error(err);

                    $scope.mapSaveLoading = false;
                  });
              })
              .catch(function(err){
                console.error(err);

                $scope.mapSaveLoading = false;
              })
          }
        }
      }
    });


    // Outdoor/indoor callback functions
    $scope.mapCallback = function(){
      return {
        setSelectedItem: function(item){
          // $scope.selectedItemColor().setColor(item);
          $timeout(function(){
            $scope.selectedItem = item;
            $scope.selectedItem.focus();
            $scope.$apply();
          }, 150);
        },
        clearSelectedItem: function(){
          if ( $scope.selectedItem ){
            $timeout(function(){
              $scope.selectedItem.unfocus();
              $scope.selectedItem = null;
              $scope.$apply();
            }, 150);
          }
        },
        createItem: function(item){
          $timeout(function(){
            $scope.isFieldRequired = false;

            $scope.mapCallback().setSelectedItem(item);
            $scope.isCreatedNewMapItem = true;
          }, 150);
        },
        handleDrawModeType: function(){
          $scope.handleDrawModeType(null);
          $scope.$apply();
        }
      }
    }

    $scope.handleMapCheck = function(url, id){
      var mapHash = hash($scope.getMapData());
      if ( $scope.mapHash !== mapHash ){
        var modal = $uibModal.open({
          template: '\
            <div class="modal-header">\
              <h3 class="modal-title text-danger" style="text-align: center;">\
                All unsaved data will be lost. Save map before leaving?\
              </h3>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-default" type="button" ng-click="handleNo()">No</button>\
              <button class="btn btn-primary" type="button" ng-click="handleYes()">Yes</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance){
            $scope.handleYes = function(){
              $uibModalInstance.close(true);
            }
            $scope.handleNo = function(){
              $uibModalInstance.close(false);
            }
          }
        });
        modal.result
          .then(
            function(result){
              if ( result ){
                MapService.updateMap(MAP_ID, $scope.getMapData())
                  .then(function(){
                    $state.go(url, { id: id });
                  });
              } else {
                $state.go(url, { id: id });
              }
            },
            function(){
              console.log('Cancelled');
            }
          )
      } else {
        $state.go(url, { id: id });
      }
    };

    // 
    // ************************************************
    // Unlinked requests
    // ************************************************
    // 
    // Get
    $scope.getUnlinkedRequests = function(){
      var assignedRequests = [];

      if ( $scope.booths && $scope.booths.length ){
        for ( var i in $scope.booths ){
          var booth = $scope.booths[i];
          if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
            for ( var j in booth.userCommercialAssignments ){
              var exist = false;
              var assign = booth.userCommercialAssignments[j];

              if ( !assign.from && !assign.to ){
                if ( assignedRequests.length ){
                  for ( var k in assignedRequests ){
                    var assignR = assignedRequests[k];
                    if (
                      assignR.eventRequestId === assign.eventRequestId &&
                      assignR.userType === assign.userType
                    ){
                      exist = true;
                      break;
                    }
                  }
                  if ( !exist ){
                    assignedRequests.push(assign);
                  }
                } else {
                  assignedRequests.push(assign);
                }
              }
            }
          }
        }
      }

      var result = [];

      if ( $scope.userCommercialAssignments && $scope.userCommercialAssignments.length ){
        for ( var i in $scope.userCommercialAssignments ){
          var skipToPush = false;
          var assign = $scope.userCommercialAssignments[i];

          if ( assignedRequests && assignedRequests.length ){
            for ( var j in assignedRequests ){
              var assignR = assignedRequests[j];
              if (
                assign.id === assignR.eventRequestId &&
                assign.user.type === assignR.userType
              ){
                skipToPush = true;
                break;
              }
            }
          }

          if ( !skipToPush ){
            result.push(assign);
          }
        }
      }

      return result;
    };
    // Set
    $scope.setUnlinkedRequest = function(data){
      if ( !data.from && !data.to ){
        // console.log(data);
        var request = data.request;
        if ( $scope.unlinkedRequests && $scope.unlinkedRequests.length ){
          for ( var i in $scope.unlinkedRequests ){
            var unlinked = $scope.unlinkedRequests[i];
            if (
              unlinked.id === request.id &&
              unlinked.user.type === request.user.type
            ){
              $scope.unlinkedRequests.splice(i, 1);
            }
          }
        }
      }
    };
    // Delete
    $scope.deleteUnlinkedRequest = function(data){
      if ( !data.from && !data.to ){
        $scope.unlinkedRequests.push(data.request);
      }
    };

    // Trigger route
    $scope.onRouteClick = function(e, route){
      $scope.map.setSelectedItem(route);

      $scope.mapCallback().clearSelectedItem();
      $scope.mapCallback().setSelectedItem(route);
    };
    $scope.changeRouteVisibility = function(isChecked, id){
      var allChecked = true;
      for ( var i in $scope.routes ) {
        var route = $scope.routes[i];
        if ( !isChecked ) {
          if ( route.id === id ) {
            route.hide();
          }
        } else {
          if ( route.id === id ) {
            route.show();
          }
        }
      }
      for ( var j in vm.routes ) {
        if ( !vm.routes[j].checked ) {
          allChecked = false;
          break;
        }
      }
      $scope.isRoutesVisible = allChecked;
    };

    $scope.handleDrawModeType = function(type) {
      if ( !type || $scope.drawModeType === type ) {
        $scope.drawModeType = null;
        $scope.isDrawModeEnabled = false;

        $scope.map.drawMode(false, null);
      } else {
        $scope.mapCallback().clearSelectedItem();
        $scope.map.clearSelectedItem();

        $scope.drawModeType = type;
        $scope.isDrawModeEnabled = true;

        $scope.map.drawMode(true, type);
      }
    };

    // Remove map item
    $scope.onRemoveObjectFromMap = function(item){
      var modal = ToolsMap.removeMapItem(item);
      modal.result
        .then(
          function(){
            $scope.mapCallback().clearSelectedItem();
            $scope.map.clearSelectedItem();

            $timeout(function(){

              // if ( item.kind === $scope.drawTypeEventZone ){
              //   $scope.map.removeEventZone(item);
              // }
              if ( item.kind === $scope.drawTypeRespZone ){
                $scope.map.removeResponsibilityZone(item);
              }
              if ( item.kind === $scope.drawTypeRoute ){
                $scope.map.removeRoute(item);
              }
              // if ( item.kind === $scope.drawTypeBooth ){
              //   $scope.map.removeBooth(item);
              // }

              item.remove();

              $scope.isCreatedNewMapItem = false;

              $scope.$apply();
            }, 200);
          },
          function() {
            console.log('Cancelled');
          }
        );
    };

    // 
    // Aside
    // OnClose validation
    // 
    $scope.isCreatedNewMapItem = false;
    $scope.isFieldRequired = false;

    // Aside close
    $scope.handleMapAsideClose = function(){
      if ( $scope.isCreatedNewMapItem ){
        $scope.setFieldRequired();
      } else {
        $scope.mapCallback().clearSelectedItem();
      }
    }

    $scope.setFieldRequired = function(){
      $scope.isFieldRequired = true;
    }

    $scope.onCheckValidation = function(){
      if ( $scope.selectedItem ){
        if ( $scope.selectedItem.kind === $scope.drawTypeEventZone ){
          $scope.isCreatedNewMapItem = $scope.selectedItem.name && $scope.selectedItem.name.length ? false : true;
        }
        if ( $scope.selectedItem.kind === $scope.drawTypeRespZone ){
          if (
            $scope.selectedItem.name && $scope.selectedItem.name.length &&
            $scope.selectedItem.description && $scope.selectedItem.description.length
          ){
            $scope.isCreatedNewMapItem = false;
          } else {
            $scope.isCreatedNewMapItem = true;
          }
        }
      }
    }

    $scope.onChangeMapObjectVisible = function(type, value){
      switch (type) {
        // case 'booth':
        //   for ( var i in $scope.booths ){
        //     value ? $scope.booths[i].show() : $scope.booths[i].hide();
        //   }
        //   break;
        case 'route':
          for ( var i in $scope.routes ){
            if ( value ){
              $scope.routes[i].show();
              $scope.routes[i].checked = true;
            } else {
              $scope.routes[i].hide();
              $scope.routes[i].checked = false;
            }
          }
          break;
        case 'respZone':
          for ( var i in $scope.responsibilityZones ){
            value ? $scope.responsibilityZones[i].show() : $scope.responsibilityZones[i].hide();
          }
          break;
        // case 'eventZone':
        //   for ( var i in $scope.eventZones ){
        //     value ? $scope.eventZones[i].show() : $scope.eventZones[i].hide();
        //   }
        //   break;
      }
    }
    // Show all map items
    // ***** Private function
    $scope.showAllMapItems = function(visibility){
      // if ( visibility.isBoothsVisible ){
      //   for ( var i in $scope.booths ){
      //     $scope.booths[i].show();
      //   }
      // }
      if ( visibility.isRoutesVisible ){
        for ( var i in $scope.routes ){
          $scope.routes[i].show();
        }
      }
      if ( visibility.isRespZonesVisible ){
        for ( var i in $scope.responsibilityZones ){
          $scope.responsibilityZones[i].show();
        }
      }
      // if ( visibility.isEventZonesVisible ){
      //   for ( var i in $scope.eventZones ){
      //     $scope.eventZones[i].show();
      //   }
      // }
    }
    // Show/hide only unassigned booth
    // $scope.onChangeOnlyUnassignedBooth = function(value, visibility){
    //   if ( value ){
    //     for ( var i in $scope.booths ){
    //       var item = $scope.booths[i];
    //       if ( item.boothType && item.boothType.commercial ){
    //         if (
    //           item.userCommercialAssignments &&
    //           item.userCommercialAssignments.length
    //         ){
    //           item.hide();
    //         }
    //       } else {
    //         item.hide();
    //       }
    //     }
    //     for ( var i in $scope.routes ){
    //       $scope.routes[i].hide();
    //     }
    //     for ( var i in $scope.responsibilityZones ){
    //       $scope.responsibilityZones[i].hide();
    //     }
    //     for ( var i in $scope.eventZones ){
    //       $scope.eventZones[i].hide();
    //     }
    //   } else {
    //     $scope.showAllMapItems(visibility);
    //   }
    // }
    // Show/hide unassigned respZone
    $scope.onChangeOnlyUnassignedRespZone = function(value, visibility){
      if ( value ){
        // for ( var i in $scope.booths ){
        //   $scope.booths[i].hide();
        // }
        for ( var i in $scope.routes ){
          $scope.routes[i].hide();
        }
        for ( var i in $scope.responsibilityZones ){
          var item = $scope.responsibilityZones[i];
          if (
            item.volunteerAssignments &&
            item.volunteerAssignments.length
          ){
            item.hide();
          }
        }
        // for ( var i in $scope.eventZones ){
        //   $scope.eventZones[i].hide();
        // }
      } else {
        $scope.showAllMapItems(visibility);
      }
    }


    $scope.isSameDay = function(start, end){
      return moment(start).isSame(end, 'day')
    }

    $scope.isSameMonth = function(start, end){
      return moment(start).isSame(end, 'month')
    }

    $scope.toMonth = function(date){
      return moment(moment.utc(date)).local().format('MMM') +' '+ ordinal_suffix_of(moment(moment.utc(date)).local().format('D'));
    }

    $scope.toHours = function(time){
      return moment(time).format('HH:mm');
    }

    function ordinal_suffix_of(i) {
      var j = i % 10,
          k = i % 100;
      if (j == 1 && k != 11) {
          return i + "st";
      }
      if (j == 2 && k != 12) {
          return i + "nd";
      }
      if (j == 3 && k != 13) {
          return i + "rd";
      }
      return i + "th";
    }

    // Moment isSame
    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };


    function setUserNonCommercialAssignments(item){
      var exist = false;
      for ( var i in $scope.userNonCommercialAssignments ){
        var nonCommercial = $scope.userNonCommercialAssignments[i];
        if ( nonCommercial.id === item.id ){
          exist = true;
          break;
        }
      }
      if ( !exist ){
        $scope.userNonCommercialAssignments.push(item);
      }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('VolunteerCoordinatorMessageFormController', VolunteerCoordinatorMessageFormController);
  
  VolunteerCoordinatorMessageFormController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$state',
    '$stateParams',
    'moment',
    'Notification',
    'AuthService',
    'UserGroupsService',
    'MessagesService',
    '$uibModalInstance',
    '$message'
  ];

  function VolunteerCoordinatorMessageFormController(
    $rootScope,
    $scope,
    $timeout,
    $state,
    $stateParams,
    moment,
    Notification,
    __auth,
    __groups,
    __messages,
    $uibModalInstance,
    $message
  ) {
    var vm = this;
    var userSearch;
    vm.event = $rootScope.currentEvent;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    angular.extend($scope, {
      label: ( $message ? 'Update' : 'Send'),
      searchType: 'vendor,volunteer,special,volunteerCoordinator,eventCoordinator,eo',
      sendTo: [{
        type: 'all_volunteers',
        name: 'All '+ vm.event.preferences.volunteerModule.label
      }],
      sendToAccepted: [{
        type: 'all_accepted_volunteers',
        name: 'All Accepted '+ vm.event.preferences.volunteerModule.label
      }],
      datepickerFormat: 'MMMM dd, yyyy',
      datepickerOptions: {
        formatYear: 'yy',
        //maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      },
      datepickerPopup: {
        opened: false
      },
      taToolbar: [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'fontColor'],
        ['bold', 'italics', 'underline', 'strikeThrough'],
        ['ul', 'ol'],
        ['redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
        ['html','insertImage','insertLink']
      ]
    });

    angular.extend($scope, {
      onInit: function() {
        vm.participantModule = vm.event.preferences.participantModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        vm.message = {
          recipientAliases: [],
          sendToEmail: false,
          sendToSms: false
        };

        vm.startDate = moment(new Date()).local().toDate();
        vm.startTime = moment(new Date()).local();

        __groups.getGroups()
          .then(
            function(response) {
              vm.userGroups = response.data;
            },
            $scope.handleError
          );

        if ( vm.event.modules.indexOf('participant') > -1 ) {
          $scope.searchType += ',participant';
        }

        if ( vm.event.modules.indexOf('sponsor') > -1 ) {
          $scope.searchType += ',sponsor';
        }

        if ( $message ) {
          var id = parseInt($message.id);
          __messages.getMessageById(id)
            .then(
              function(response) {
                var data = response.data;
                vm.message = data;

                if ( data.scheduledDate ) {
                  vm.scheduleDate = true;
                  vm.startDate = moment(moment.utc(data.scheduledDate)).local().toDate();
                  vm.startTime = moment(moment.utc(data.scheduledDate)).local();
                }

                if ( data.recipientIds.length !== 0 ) {
                  __auth.getUsersByQuery(data.recipientIds)
                    .then(
                      function(response){
                        vm.recipientIds = response.data;
                      },
                      $scope.handleError
                    );
                }

                if ( data.recipientGroupIds.length !== 0 ) {
                  __groups.getGroupsByQuery(data.recipientGroupIds)
                    .then(
                      function(response){
                        vm.recipientGroupIds = response.data;
                      },
                      $scope.handleError
                    );
                }

              },
              $scope.handleError
            );
        }
      },

      handleUsersSearch: function(query) {
        $timeout.cancel(userSearch);
        if ( query.length !== 0 ) {
          userSearch = $timeout(function(){
            __groups.searchUsers($scope.searchType, query)
              .then(
                function(response){
                  vm.usersSearch = response.data;
                },
                $scope.handleError
              );
          }, 1000);
        }
      },

      toggleCheckbox: function(send, type) {
        if ( type === 'all' ) {
          $scope.allChecked = false;
        } else {
          $scope.allAcceptedChecked = false;
        }

        var idx = vm.message.recipientAliases.indexOf(send.type);
        if (idx > -1) {
          vm.message.recipientAliases.splice(idx, 1);
        } else {
          vm.message.recipientAliases.push(send.type);
        }
      },

      // handleAllChecked: function(){
      //   if ( $scope.allChecked ) {
      //     angular.forEach($scope.sendTo, function(item){
      //       vm.message.recipientAliases.push(item.type);
      //     });
      //   } else {
      //     angular.forEach($scope.sendTo, function(item){
      //       var idx = vm.message.recipientAliases.indexOf(item.type);
      //       vm.message.recipientAliases.splice(idx, 1);
      //     });
      //   }
      // },

      // handleAllAcceptedChecked: function(){
      //   if ( $scope.allAcceptedChecked ) {
      //     angular.forEach($scope.sendToAccepted, function(item){
      //       vm.message.recipientAliases.push(item.type);
      //     });
      //   } else {
      //     angular.forEach($scope.sendToAccepted, function(item){
      //       var idx = vm.message.recipientAliases.indexOf(item.type);
      //       vm.message.recipientAliases.splice(idx, 1);
      //     });
      //   }
      // },

      onShortText: function(txt) {
        if ( vm.message.sendToSms ) {
          if ( txt ) {
            if ( !vm.message.subject ) {
              vm.message.subject = txt;
            }
            if ( !vm.message.body ) {
              vm.message.body = txt;
            }
          }
        }
      },

      handleSubmit: function () {
        $scope.formSubmitted = true;
        var form = $scope.form;
        // var format = 'YYYY-MM-DD[T]HH:mm:ss';
        if ( form.$valid ) {
          $scope.formLoading = true;
          vm.message.sendToApp = true;
          vm.message.recipientIds = [];
          vm.message.recipientGroupIds = [];
          if ( vm.scheduleDate ) {
            vm.message.scheduledDate = moment.utc(vm.startDate).set({
              hour: moment.utc(vm.startTime).hour(),
              minute: moment.utc(vm.startTime).minute()
            });
          }
          if ( vm.recipientIds ) {
            angular.forEach(vm.recipientIds, function(item){
              vm.message.recipientIds.push(item.id);
            });
          }
          if ( vm.recipientGroupIds ) {
            angular.forEach(vm.recipientGroupIds, function(item){
              vm.message.recipientGroupIds.push(item.id);
            });
          }
          $uibModalInstance.close(vm.message);
        }
      },

      handleClose: function () {
        $uibModalInstance.dismiss('cancel');
      },

      handleDatepickerPopup: function() {
        $scope.datepickerPopup.opened = true;
      },

      // onClose: function() {
      //   // $state.go( $state.current.name.replace(( $state.params && $state.params.id ? '.update' : '.send' ), ''));
      //   $state.go('users.organizer.messages.inbox');
      // },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('VolunteerCoordinatorMessagesController', VolunteerCoordinatorMessagesController);
  
  VolunteerCoordinatorMessagesController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    '$location',
    'Notification',
    'MessagesService'
  ];

  function VolunteerCoordinatorMessagesController(
    $rootScope,
    $scope,
    $uibModal,
    $location,
    Notification,
    __messages
  ) {
    angular.extend($scope, {
      _:_
    });

    angular.extend($scope, {
      onInit: function() {},

      openModalMessage: function(){
        var modal = $uibModal.open({
          templateUrl: 'app/users/volunteerCoordinator/messages/messages.form.html',
          controller: 'VolunteerCoordinatorMessageFormController',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            $message: function(){
              return false;
            }
          }
        });

        modal.result
          .then(
            function(resolve){
              $rootScope.loadingInformation = true;
              __messages.sentMessage(resolve)
                .then(
                  function(response){
                    $rootScope.loadingInformation = false;
                    Notification.success('Message was sent');
                    if ( $location.$$path.indexOf('/messages/sent') !== -1 ){
                      __messages.add(response.data);
                    }
                  },
                  $scope.handleError
                );
            },
            function(){
              console.log('Dissmissed');
            }
          );
      },

      handleError: function(err){
        console.log(err.data.message);
      }
    });

  }

})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('VolunteerMapController', VolunteerMapController)

  function VolunteerMapController(
    $rootScope,
    $scope,
    $stateParams,
    MapService,
    BoothTypeService,
    VolunteerService,
    Notification,

    OutdoorService,
    IndoorService,

    EventZone,
    RespZone,
    Route,
    Booth,

    IndoorZone,
    IndoorRoute,
    IndoorBooth,

    ToolsBooth
  ) {
    var vm = this;

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.currentUser = $rootScope.currentUser;

    $scope.showOnlyMyZones = false;
    $scope.showEventZones = false;

    $scope.userCommercialAssignments = [];
    $scope.userNonCommercialAssignments = [];

    $scope.boothTypes = [];
    $scope.indoorMaps = [];

    $scope.mapData = null;

    angular.extend($scope, {
      showPosition: false,
      currentPosition: null,
      onInit: function(){
        OutdoorService.resetOutdoorData();
        IndoorService.resetIndoorData();

        VolunteerService.getRequestByStatus('accepted')
          .then(function(response){
            var data = response.data;
            for ( var i in data ){
              var item = data[i];
              // Commercial Assignments
              var user = item.volunteer;
              user['type'] = 'volunteer';
              delete item['volunteer'];
              $scope.userCommercialAssignments.push($.extend({}, item, {
                user: user
              }));
              setUserNonCommercialAssignments(user);
            }

            return BoothTypeService.getBooths()
          })
          .then(function(response){
            $scope.boothTypes = response.data;

            $scope.checkMapID();
          })
          .catch(function(err){
            console.error(err);
          })
      },

      checkMapID: function(){
        if ( typeof $stateParams.id !== 'undefined' ){
          $scope.fetchMap(parseInt($stateParams.id, 10));
        } else if ( typeof $stateParams.id === 'undefined' && $scope.currentEvent && $scope.currentEvent.mainEventMapId ){
          $scope.fetchMap($scope.currentEvent.mainEventMapId);
        } else {
          console.error('No map ID present');
        }
      },

      fetchMap: function(id){
        MapService.getMapByID(id)
          .then(function(response){
            var data = response.data;
            // console.log(data);
            if ( data.type === 'outdoor' ){
              // Only for outdoor
              $scope.renderOutdoorMapItems(function(){
                $scope.map = OutdoorService;
                $scope.map.initMap(data, null, 'users.volunteer.indoorMap');
                $scope.initMapItems(data, $scope.map);

                if ($scope.showPosition && !$scope.currentPosition){
                  Notification.warning('Reload page and grant access for your location to use option "Show me on map"');
                }

                $scope.$watch('currentPosition', function(){
                  if ( $scope.currentPosition ) {
                    OutdoorService.showMeOnMapButton($scope.currentPosition);
                  }
                });
              });
            } else if ( data.type === 'indoor' ){
              $scope.map = IndoorService;
              $scope.map.initMap(data);
              $scope.initMapItems(data, $scope.map);
            } else {
              console.error('Map type not present');
            }
          })
          .catch(function(err){
            console.error(err);
          })
      },

      // Only for outdoor map
      renderOutdoorMapItems: function(cb){
        // Set navigator if is outdoor map
        $scope.showPosition = true;
        if ( navigator.geolocation ){
          navigator.geolocation.getCurrentPosition(function(position){
            $scope.$apply(function(){
              $scope.currentPosition = position;
            });
          });
        }

        MapService.getMaps(null, 'name,type,booths', 'indoor')
          .then(function(response){
            $scope.indoorMaps = response.data;

            cb();
          })
          .catch(function(err){
            console.error(err);
          });
      },

      initMapItems: function(data, map){
        $scope.mapData = data;

        $scope.showOnlyMyZones = $scope.getVolunteerZones(data).length > 0;

        var booths = [];

        // Event zone
        if ( data.eventZones && data.eventZones.length ){
          for ( var i in data.eventZones ){
            $scope.drawEventZone(data.type, data.eventZones[i], map);
          }
        }

        // Responsibility zone
        if ( data.responsibilityZones ) {
          var zones = [];
          if ( $scope.showOnlyMyZones ) {
            zones = $scope.getVolunteerZones(data);
            var bounds;
            if ( data.type === 'outdoor' ) bounds = new google.maps.LatLngBounds();
            for ( var i in zones ) {
              $scope.drawResponsibilityZone(data.type, zones[i], map);

              if ( data.type === 'outdoor' ){
                var coords = zones[i].coordinates;
                for ( var k in coords ) {
                  var latLng = new google.maps.LatLng(coords[k].lat, coords[k].lng);
                  bounds.extend(latLng);
                  map.getMap().fitBounds(bounds);
                }
              }
            }
          } else {
            zones = data.responsibilityZones;
            for ( var i in zones ) {
              $scope.drawResponsibilityZone(data.type, zones[i], map);
            }
            if ( data.type === 'outdoor' ){
              map.getMap().setCenter(map.getCenter());
              map.getMap().setZoom(map.getZoom());
            }
          }
        }

        // Routes
        if ( data.routes ){
          for ( var i in data.routes ){
            var route = data.routes[i];

            if ( !route.drawed ){
              if ( route.zoneId ){
                var isSame = false;
                if ( data.eventZones && data.eventZones.length ){
                  for ( var j in data.eventZones ){
                    var zone = data.eventZones[j];
                    if ( zone.id === route.zoneId ){
                      isSame = true;
                      break;
                    }
                  }
                }
                if ( isSame ){
                  $scope.drawRoute(data.type, route, map, true);
                  continue;
                }
              }
              if ( route.preferences && route.preferences.public ){
                $scope.drawRoute(data.type, route, map, false);
                continue;
              }
            }
          }
        }

        // Booths
        if ( data.booths ){
          booths = ToolsBooth.getUserBooths(
            true, // onlyNonCommercial
            $scope.currentUser, // Current user
            data.booths, // booths
            $scope.boothTypes, // boothTypes
            $scope.indoorMaps.length ? $scope.indoorMaps : null // indoor maps
          );
          for ( var i in booths ){
            $scope.drawBooth(data.type, booths[i], map);
          }
        }

        $scope.eventZones = map.fetchEventZones();
        $scope.routes = map.fetchRoutes();
      },

      drawEventZone: function(type, zoneData, map){
        var zone = type === 'outdoor' ? new EventZone() : new IndoorZone();
        zone.read(zoneData, false);
        map.drawEventZone(zone, false);

        zone.hide();
      },

      drawResponsibilityZone: function(type, zoneData, map){
        var zone = 
          type === 'outdoor' ?
            new RespZone(true, $scope.userCommercialAssignments.map(function(item){ return item.id }))
          :
            new IndoorZone(false, $scope.userCommercialAssignments.map(function(item){ return item.id }));

        zone.read(zoneData, false);
        map.drawResponsibilityZone(zone, false);
      },

      drawRoute: function(mapType, routeData, map, isZone){
        routeData['drawed'] = true;

        var route = mapType === 'outdoor' ? new Route() : new IndoorRoute();
        route.read(routeData);
        map.drawRoute(route, false);

        if ( isZone ) route.hide();
      },

      drawBooth: function(mapType, boothData, map){
        var draw = true;

        if ( $scope.boothTypes && $scope.boothTypes.length ) {
          for ( var i in $scope.boothTypes ) {
            var type = $scope.boothTypes[i];
            var pref = type.preferences;
            if ( boothData.boothTypeId === type.id ){
              if (
                ToolsBooth.nonCommercialBoothBelongToUser(
                  boothData,
                  $scope.currentUser.id,
                  $scope.currentUser.type,
                  $scope.indoorMaps.length ? $scope.indoorMaps : null
                )
              ){
                break;
              } else if ((pref && pref.private) || type.commercial || !type.commercial){
                draw = false;
                break;
              }
            }
          }
        }
        if ( draw ) {
          var booth = mapType === 'outdoor' ? new Booth(false, true) : new IndoorBooth(false, true);
          booth.read(boothData, $scope.boothTypes);
          map.drawBooth(booth, false);
        }
      },

      handleShowOnlyMyZones: function(){
        $scope.map.clearResponsibilityZones();

        var bounds;
        if ( $scope.mapData.type === 'outdoor' ) bounds = new google.maps.LatLngBounds();

        if ( $scope.showOnlyMyZones ){
          var zones = $scope.getVolunteerZones($scope.mapData);
          for ( var i in $scope.mapData.responsibilityZones ){
            var zone = $scope.mapData.responsibilityZones[i];
            if ( zones.length ){
              if ( zones.indexOf(zone) > -1 ){
                $scope.drawResponsibilityZone($scope.mapData.type, zone, $scope.map);

                if ( $scope.mapData.type === 'outdoor' ){
                  var coords = zone.coordinates;
                  for ( var k in coords ) {
                    var latLng = new google.maps.LatLng(coords[k].lat, coords[k].lng);
                    bounds.extend(latLng);
                    $scope.map.getMap().fitBounds(bounds);
                  }
                }
              }
            }
          }
        } else {
          for ( var i in $scope.mapData.responsibilityZones ){
            var zone = $scope.mapData.responsibilityZones[i];
            $scope.drawResponsibilityZone($scope.mapData.type, zone, $scope.map);

            $scope.map.getMap().setCenter($scope.map.getCenter());
            $scope.map.getMap().setZoom($scope.map.getZoom());
          }
        }
      },

      handleShowEventZone: function(){
        for ( var i in $scope.eventZones ){
          var zone = $scope.eventZones[i];
          if ( $scope.showEventZones ){
            zone.show();

            for ( var j in $scope.routes ){
              var route = $scope.routes[j];
              if ( route.zoneId === zone.id ){
                route.show();
              }
            }
          } else {
            zone.hide();

            for ( var j in $scope.routes ){
              var route = $scope.routes[j];
              if ( route.zoneId === zone.id ){
                route.hide();
              }
            }
          }
        }
      }
    });

    $scope.getVolunteerZones = function(data) {
      var zones = [];
      if ( data.responsibilityZones ) {
        for ( var i in data.responsibilityZones ) {
          var zone = data.responsibilityZones[i];
          if ( typeof zone.volunteerAssignments !== 'undefined' && $scope.zoneBelongToVolunteer(zone) ) {
            zones.push(zone);
          }
        }
      }
      return zones;
    };
    
    $scope.zoneBelongToVolunteer = function(zone) {
      var isZoneVolunteer = false;
      if ( zone.volunteerAssignments ) {
        for ( var i in zone.volunteerAssignments ) {
          var id = zone.volunteerAssignments[i].volunteerRequestId;
          for ( var j in $scope.userCommercialAssignments ) {
            var user = $scope.userCommercialAssignments[j];
            if ( user.id === id ) {
              if ( user.user.id === $scope.currentUser.id ) {
                isZoneVolunteer = true;
                break;
              }
            }
          }
          if ( isZoneVolunteer ) {
            break;
          }
        }
      }
      return isZoneVolunteer;
    };

    function setUserNonCommercialAssignments(item){
      var exist = false;
      for ( var i in $scope.userNonCommercialAssignments ){
        var nonCommercial = $scope.userNonCommercialAssignments[i];
        if ( nonCommercial.id === item.id ){
          exist = true;
          break;
        }
      }
      if ( !exist ){
        $scope.userNonCommercialAssignments.push(item);
      }
    }
  }
})();

(function(){

  angular
    .module('eventmap')
    .controller('VolunteerTimelogController', VolunteerTimelogController);

  VolunteerTimelogController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'Notification',
    'moment',
    'ActivityLogService',
    'VolunteerService',
    'ViewService'
  ];

  function VolunteerTimelogController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    moment,
    ActivityLogService,
    VolunteerService,
    ViewService
  ){
    var vm = this;
    $scope.currentEvent = $rootScope.currentEvent;
    $scope.currentPage = 1;

    $scope.loading = true;

    $scope.acceptedRequest = null;

    angular.extend($scope, {
      onInit: function(){
        vm.appView = localStorage.getItem('app_view');

        VolunteerService.getRequestsByUserId()
          .then(function(response){
            var data = response.data;
            if ( data.length ){
              for ( var i in data ){
                if ( data[i].status === 'accepted' ){
                  $scope.acceptedRequest = data[i];
                  break;
                }
              }
            }
            return ActivityLogService.fetchAll($rootScope.currentUser.id);
          })
          .then(function(response){
            $scope.logs = response.data;

            $scope.calcTotalTimeSpent($scope.logs);

            $scope.loading = false;
          })
          .catch(function(err){
            console.log(err);
          });
      },

      calcTotalTimeSpent: function(logs){
        var total = 0;

        if ( logs.length ){
          for ( var i in logs ){
            var log = logs[i];
            if ( log.status === 'confirmed' && log.timeSpentMin ){
              total += log.timeSpentMin;
            }
          }
        }

        $scope.totalTimeSpent = $scope.totalTime(total);
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        ViewService.setView(type);
      },

      handleCreate: function(){
        $uibModal.open({
          templateUrl: 'app/users/organizer/volunteers/log-book/form/form.html',
          controller: 'OrganizerVolunteerFormLogController',
          resolve: {
            resolveLog: function(){
              return null;
            },
            resolveAcceptedRequest: function(){
              return $scope.acceptedRequest;
            },
            resolveRequired: function(){
              return true;
            }
          }
        }).result.then(
          function(result){
            $scope.logs.push(result);

            $scope.calcTotalTimeSpent($scope.logs);
          },
          function(err){
            console.error(err);
          }
        )
      },

      handleEdit: function(log){
        if ( log ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/volunteers/log-book/form/form.html',
            controller: 'OrganizerVolunteerFormLogController',
            resolve: {
              resolveLog: function(){
                return log;
              },
              resolveAcceptedRequest: function(){
                return null;
              },
              resolveRequired: function(){
                return true;
              }
            }
          }).result.then(
            function(result){
              var idx = $scope.logs.indexOf(log);
              $scope.logs[idx] = result;

              $scope.calcTotalTimeSpent($scope.logs);
            },
            function(err){
              console.error(err);
            }
          )
        }
      },

      handleDelete: function(log) {
        if ( log && log.id ){
          $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete log ?\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, ActivityLogService, resolveLog){
              $scope.loading = false;
              $scope.handleConfirm = function(){
                $scope.loading = true;
                ActivityLogService.delete(resolveLog.id)
                  .then(function(){
                    $uibModalInstance.close();
                  })
                  .catch(function(err){
                    $scope.loading = false;
                  });
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              resolveLog: function(){
                return log;
              }
            }
          }).result.then(
            function(){
              var idx = $scope.logs.indexOf(log);
              $scope.logs.splice(idx, 1);

              $scope.calcTotalTimeSpent($scope.logs);

              Notification.success('Activity log was removed');
              $scope.currentPage = $scope.navigatePagination($scope.logs);
            },
            function() {
              console.log('Cancelled');
            }
          );
        }
      },

      totalTime: function(m){
        var timeToShow = '';

        var hoursPerDay = 24;
        var minutesPerDay = 1440;

        var days = null;

        if ( m >= minutesPerDay ){
          days = Math.floor(m/minutesPerDay);
          if ( days !== 1 ){
            m = (m - (minutesPerDay*days));
          }
        }

        var hours = moment.duration(m, 'm').hours();
        var minutes = moment.duration(m, 'm').minutes();

        if ( days !== null ){
          timeToShow += hours + (days*hoursPerDay) +'h'
        } else {
          if ( hours !== 0 ){
            timeToShow += hours +'h'
          }
        }
        if (minutes !== 0){
          timeToShow += (timeToShow ? ' ' : '') + minutes +'m'
        }
        if (minutes == 0 && hours == 0 && days == 0){
          timeToShow = '0m'
        }
        return timeToShow || '0';
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      },

      onChangeItemsOf: function() {
        var total = $scope.logs.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = ($scope.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });

  }

})();
(function(){

  angular
    .module('eventmap')
    .controller('VolunteerEventController', VolunteerEventController);

  VolunteerEventController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    'moment',
    'Notification',
    'EventService',
    'VolunteerService',
    'SponsorService',
    'PageService'
  ];

  function VolunteerEventController(
    $rootScope,
    $scope,
    $uibModal,
    moment,
    Notification,
    __event,
    __volunteer,
    __sponsor,
    PageService
  ){
    var vm = this;
    vm.sponsorsHeadline = [];
    vm.sponsorsSecondary = [];

    vm.isSameDate = false;

    angular.extend($scope, {
      onInit:function() {
        vm.event = $rootScope.currentEvent;
        vm.billingPreferences = vm.event.billingPreferences;
        vm.preferences = vm.event.preferences;
        vm.volunteerModule = vm.event.preferences.volunteerModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        vm.eventStartDate = moment(moment.utc(vm.event.start)).local().format('MMMM DD, YYYY');
        vm.eventStartTime = moment(moment.utc(vm.event.start)).local().format('hh:mm a');
        vm.eventEndDate = moment(moment.utc(vm.event.end)).local().format('MMMM DD, YYYY');
        vm.eventEndTime = moment(moment.utc(vm.event.end)).local().format('hh:mm a');

        if ( moment(vm.eventStartDate).isSame(vm.eventEndDate, 'day') ){
          vm.isSameDate = true;
        }

        PageService.getPageByTag('fixed', 'appFormVolunteer')
          .then(
            function(response){
              vm.appFormVolunteer = response.data;
            },
            $scope.handleError
          );

        __volunteer.getRequestsByUserId()
          .then(
            function(response){
              vm.requests = __volunteer.requests(response.data);
            },
            $scope.handleError
          );

        __sponsor.getSponsors('innerPages', true, true)
          .then(
            function(response){
              var arrays = [];
              angular.forEach(response.data, function(sponsor){
                if ( sponsor.headline ) {
                  vm.sponsorsHeadline.push(sponsor);
                } else {
                  arrays.push(sponsor);
                }
              });

              for ( var i = 0; i < arrays.length; i += 2 ) {
                if ( arrays.length > 8 ){
                  vm.sponsorsSecondary.push(arrays.slice(i, i + 2));
                } else {
                  vm.sponsorsSecondary = arrays;
                }
              }
            },
            $scope.handleError
          );
      },

      handleDonation: function() {
        $uibModal.open({
          templateUrl: 'app/donations-form/donations-form.html',
          controller: 'DonationFormController',
          controllerAs: 'vm',
          resolve: {
            relocate: function(){
              return false;
            }
          }
        });
      },

      handleAdd:function() {
        __volunteer.onAdd()
          .then(
            function(response){
              __volunteer.add(response.data);
              Notification.success('Your request was created')
            },
            $scope.handleError
          );
      },

      handleCancel:function(request) {
        if ( request && request.id ){
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  By clicking the "Cancel" button, you will be removed from the event.\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleCancel()">Cancel Participation</button>\
                <button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, request){
              $scope.handleCancel = function(){
                $uibModalInstance.close(request);
              }
              $scope.handleClose = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(result){
                __volunteer.onCancel(result.id)
                  .then(
                    function(response){
                      Notification.success('Your request was canceled');
                      __volunteer.update(response.data);

                      if ( vm.requests && vm.requests.length ){
                        for ( var i in vm.requests ){
                          if ( vm.requests[i].status === 'accepted' ){
                            $scope.$parent.$parent.hasAcceptedRequest = true;
                            break;
                          } else {
                            $scope.$parent.$parent.hasAcceptedRequest = false;
                          }
                        }
                      }
                    },
                    $scope.handleError
                  );
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      showEventPass: function(request) {
        if ( request && request.id ){
          $uibModal.open({
            templateUrl: 'app/users/event-pass/event-pass.html',
            controller: 'EventPassController',
            controllerAs: 'vm',
            windowClass: 'modal-event-pass',
            resolve: {
              resolveType: function(){
                return 'volunteer'
              },
              resolveRequest: function(){
                return request;
              }
            }
          });
        }
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };

    // Slick config
    angular.extend($scope, {
      slickConfig: {
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },{
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },{
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      slickHeadlineConfig: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true
      }
    });

    // On Assignments
    vm.onAssignments = function(){
      $uibModal.open({
        size: 'md',
        templateUrl: 'app/users/organizer/volunteers/assignments/assignments.html',
        controller: function($scope,$uibModalInstance,moment,MapItemsService){
          var vm = this;
          vm.isLoading = true;
          vm.assignments = [];

          angular.extend($scope, {
            onInit: function(){
              MapItemsService.getVolunteerZoneAssignments(null, true)
                .then(
                  function(response){
                    ;
                    vm.assignments = response.data;
                    vm.isLoading = false;
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            onClose: function(){
              $uibModalInstance.dismiss('cancel');
            },
            isSameDay: function(from, to){
              return moment(from).isSame(to, 'day');
            }
          });
        },
        controllerAs: 'vm'
      });
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('VolunteerMessagesController', VolunteerMessagesController);

  VolunteerMessagesController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    '$location',
    'Notification',
    'MessagesService'
  ];
  
  function VolunteerMessagesController(
    $rootScope,
    $scope,
    $uibModal,
    $location,
    Notification,
    __messages
  ){
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
        
      },
      openModalMessage: function(){
        $uibModal.open({
          templateUrl: 'app/users/messages/modal/modal.html',
          controller: 'MessageModalController',
          controllerAs: 'vm',
          resolve: {
            $message: function(){
              return false;
            }
          }
        }).result.then(
            function(resolve){
              // $rootScope.loadingInformation = true;
              __messages.sentMessageBackOffice(resolve)
                .then(
                  function(response){
                    // $rootScope.loadingInformation = false;
                    Notification.success('Message was sent');
                    if ( $location.$$path.indexOf('/messages/sent') !== -1 ){
                      __messages.add(response.data);
                    }
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(){
              console.log('Dissmissed');
            }
          );
      },
    });

  }

})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('VendorMapController', VendorMapController)

  function VendorMapController(
    $rootScope,
    $scope,
    $stateParams,
    Notification,

    MapService,
    BoothTypeService,
    VendorService,

    EventZone,
    Route,
    Booth,

    IndoorZone,
    IndoorRoute,
    IndoorBooth,

    OutdoorService,
    IndoorService,

    ToolsBooth
  ) {
    var vm = this;

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.currentUser = $rootScope.currentUser;

    $scope.boothTypes = [];

    $scope.userCommercialAssignments = [];

    $scope.indoorMaps = [];

    angular.extend($scope, {
      showPosition: false,
      currentPosition: null,
      onInit: function(){
        OutdoorService.resetOutdoorData();
        IndoorService.resetIndoorData();

        VendorService.getMyRequests()
          .then(function(response){
            var data = response.data;
            for ( var i in data ){
              var item = data[i];
              // Commercial Assignments
              var user = item.vendor;
              user['type'] = 'vendor';
              delete item['vendor'];
              $scope.userCommercialAssignments.push($.extend({}, item, {
                user: user
              }));
            }
            return BoothTypeService.getBooths();
          })
          .then(function(response){
            $scope.boothTypes = response.data;

            $scope.checkMapID();
          })
          .catch(function(err){
            console.log(err);
          });

      },

      checkMapID: function(){
        if ( typeof $stateParams.id !== 'undefined' ){
          $scope.fetchMap(parseInt($stateParams.id, 10));
        } else if ( typeof $stateParams.id === 'undefined' && $scope.currentEvent && $scope.currentEvent.mainEventMapId ){
          $scope.fetchMap($scope.currentEvent.mainEventMapId);
        } else {
          console.error('No map ID present');
        }
      },

      fetchMap: function(id){
        MapService.getMapByID(id)
          .then(function(response){
            var data = response.data;
            // console.log(data);
            if ( data.type === 'outdoor' ){
              // Only for outdoor
              $scope.renderOutdoorMapItems(function(){
                $scope.map = OutdoorService;
                $scope.map.initMap(data, null, 'users.vendor.indoorMap');
                $scope.initMapItems(data, $scope.map);

                if ($scope.showPosition && !$scope.currentPosition){
                  Notification.warning('Reload page and grant access for your location to use option "Show me on map"');
                }

                $scope.$watch('currentPosition', function(){
                  if ( $scope.currentPosition ) {
                    OutdoorService.showMeOnMapButton($scope.currentPosition);
                  }
                });
              });

            } else if ( data.type === 'indoor' ){
              $scope.map = IndoorService;
              $scope.map.initMap(data);
              $scope.initMapItems(data, $scope.map);
            } else {
              console.error('Map type not present');
            }
          })
          .catch(function(err){
            console.error(err);
          })
      },

      // Only for outdoor map
      renderOutdoorMapItems: function(cb){
        // Set navigator if is outdoor map
        $scope.showPosition = true;
        if ( navigator.geolocation ){
          navigator.geolocation.getCurrentPosition(function(position){
            $scope.$apply(function(){
              $scope.currentPosition = position;
            });
          });
        }

        MapService.getMaps(null, 'name,type,booths', 'indoor')
          .then(function(response){
            $scope.indoorMaps = response.data;
            cb();
          })
          .catch(function(err){
            console.error(err);
          });
      },

      initMapItems: function(data, map){
        $scope.mapData = data;

        var booths = [];

        // Booths
        if ( data.booths ){
          var bounds;
          if ( data.type === 'outdoor' ) bounds = new google.maps.LatLngBounds();
          booths = ToolsBooth.getUserBooths(
            false, // onlyNonCommercial
            $scope.currentUser, // Current user
            data.booths, // booths
            $scope.boothTypes, // boothTypes
            $scope.indoorMaps.length ? $scope.indoorMaps : null, // indoor maps
            $scope.userCommercialAssignments // requests
          );
          if ( booths && booths.length ){
            for ( var i in booths ){
              var booth = booths[i];
              $scope.drawBooth(data.type, booth, map);
  
              if ( data.type === 'outdoor' ){
                // var position = booth.position ? booth.position : booth.preferences.coordinates[0];
                // var latLng = new google.maps.LatLng(position.lat, position.lng);
    
                // bounds.extend(latLng);
                var latLng;
                if ( booth.position ){
                  latLng = new google.maps.LatLng(booth.position.lat, booth.position.lng);
                  bounds.extend(latLng);
                } else {
                  if ( booth.preferences.coordinates.length ){
                    for ( var j in booth.preferences.coordinates ){
                      var coord = booth.preferences.coordinates[j];
                      latLng = new google.maps.LatLng(coord.lat, coord.lng);
                      bounds.extend(latLng);
                    }
                  }
                }
                map.getMap().fitBounds(bounds);
              }
            }
          }
        }

        // EventZones
        if ( data.eventZones ){
          for ( var i in data.eventZones ) {
            var zone = data.eventZones[i];

            if ( booths.length ){
              for ( var j in booths ){
                var booth = booths[j];
                if ( booth.zoneId === zone.id ){
                  $scope.drawEventZone(data.type, zone, map);
                }
              }
            }
          }
        }

        // Route
        if ( booths.length ){
          for ( var i in booths ){
            var booth = booths[i];
            if ( data.routes ){
              for ( var j in data.routes ){
                var route = data.routes[j];
                if ( !route.drawed ){
                  if ( booth.routeIds.indexOf(route.id) !== -1 ){
                    $scope.drawRoute(data.type, route, map);
                    continue;
                  }
                  if ( route.zoneId ){
                    var isSame = false;
                    if ( data.eventZones && data.eventZones.length ){
                      for ( var j in data.eventZones ){
                        var zone = data.eventZones[j];
                        if (
                          zone.id === route.zoneId &&
                          zone.id === booth.zoneId
                        ){
                          isSame = true;
                          break;
                        }
                      }
                    }
                    if ( isSame ){
                      $scope.drawRoute(data.type, route, map);
                      continue;
                    }
                  }
                }
              }
            }
          }
        }
      },

      drawRoute: function(mapType, routeData, map){
        routeData['drawed'] = true;

        var route = mapType === 'outdoor' ? new Route() : new IndoorRoute();
        route.read(routeData);
        map.drawRoute(route, false);
      },

      drawBooth: function(mapType, boothData, map){
        var draw = true;

        if ( $scope.boothTypes && $scope.boothTypes.length ){
          for ( var i in $scope.boothTypes ){
            var type = $scope.boothTypes[i];
            var pref = type.preferences;
            if ( boothData.boothTypeId === type.id ){
              if (
                ToolsBooth.boothBelongToUser(
                  boothData,
                  $scope.userCommercialAssignments,
                  $scope.currentUser.id,
                  $scope.currentUser.type,
                  $scope.indoorMaps.length ? $scope.indoorMaps: null
                )
              ){
                break;
              } else if ((pref && pref.private) || type.commercial || !type.commercial) {
                draw = false;
                break;
              }
            }
          }
        }
        if ( draw ) {
          var booth = mapType === 'outdoor' ? new Booth(false, true) : new IndoorBooth(false, true);
          booth.read(boothData, $scope.boothTypes, $scope.userCommercialAssignments);
          map.drawBooth(booth, false);
        }
      },

      drawEventZone: function(mapType, zoneData, map){
        var zone = mapType === 'outdoor' ? new EventZone(false) : new IndoorZone(false);
        zone.read(zoneData, false);
        map.drawEventZone(zone, false);
      }
    }); // End angular.extend
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('VendorMessagesController', VendorMessagesController);
  
  VendorMessagesController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    '$location',
    'Notification',
    'MessagesService'
  ];
  
  function VendorMessagesController(
    $rootScope,
    $scope,
    $uibModal,
    $location,
    Notification,
    MessagesService
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){},
      openModalMessage: function(){
        var modal = $uibModal.open({
          templateUrl: 'app/users/messages/modal/modal.html',
          controller: 'MessageModalController',
          controllerAs: 'vm',
          resolve: {
            $message: function(){
              return false;
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              $rootScope.loadingInformation = true;
              MessagesService.sentMessageBackOffice(resolve)
                .then(
                  function(response){
                    $rootScope.loadingInformation = false;
                    Notification.success('Message was sent');
                    if ( $location.$$path.indexOf('/messages/sent') !== -1 ){
                      MessagesService.add(response.data);
                    }
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(){
              console.log('Dissmissed');
            }
          );
      },
    });

  }

})();
(function(){

  angular
    .module('eventmap')
    .controller('VendorEventFormController', EventFormController);
  
  EventFormController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    'Notification',
    'VendorService',
    'CategoryService',
    'FileService',
    'PROFILE_VISIBILITY'
  ];

  function EventFormController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    Notification,
    __vendor,
    __category,
    __file,
    PROFILE_VISIBILITY
  ) {
    var vm = this;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    angular.extend($scope, {
      label: ( typeof $stateParams.id !== 'undefined' ? 'Update' : 'Add'),
      visibility: PROFILE_VISIBILITY
    });

    angular.extend($scope, {
      onInit: function() {
        vm.requestRequired = true;
        vm.profileVisibility = [];

        vm.event = $rootScope.currentEvent;
        vm.vendorModule = vm.event.preferences.vendorModule;

        __category.getCategories()
          .then(
            function(response){
              vm.categories = response.data
            },
            $scope.handleError
          );
        
        if ( typeof $stateParams.id !== 'undefined' ) {
          __vendor.getRequestById($stateParams.id)
            .then(
              function(response){
                var data = response.data;
                vm.request = data;
                vm.requestRequired = ( !data.applicationForm && !vm.applicationForm );
                vm.profileVisibility = data.profileVisibility || [];
              },
              $scope.handleError
            );
        }
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          if ( vm.files ) {
            vm.request.boothPhotos = [];
            angular.forEach(vm.files, function(item) {
              vm.request.boothPhotos.push({
                id: item.id,
                link: item.link
              });
            });
          }

          if ( vm.applicationForm ) {
            vm.request.applicationForm = {
              id: vm.applicationForm.id,
              link: vm.applicationForm.link
            };
          }

          if ( vm.profileVisibility ) {
            vm.request.profileVisibility = vm.profileVisibility;
          }

          if ( typeof $stateParams.id !== 'undefined' ) {
            __vendor.onUpdate(vm.request)
              .then(
                function(response){
                  Notification.success('Your request was updated');
                  __vendor.updateRequest(response.data);
                  $scope.onClose();
                },
                $scope.handleError
              );
          } else {
            __vendor.onAdd(vm.request)
              .then(
                function(response){
                  Notification.success('Your request was added');
                  __vendor.pushRequest(response.data);
                  $scope.onClose();
                },
                $scope.handleError
              );
          }
        }
      },

      onClose: function(){
        $state.go('users.vendor.event');
      },

      profileChecked: function(value){
        var idx = vm.profileVisibility.indexOf(value);
        idx > -1 ? vm.profileVisibility.splice(idx, 1) : vm.profileVisibility.push(value);
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('VendorEventController', VendorEventController);
  
  VendorEventController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    '$location',
    '$interval',
    'moment',
    'Notification',
    // 'EventService',
    'MapService',
    'VendorService',
    'SponsorService',
    'TransactionService',
    'PaymentService',
    'PageService'
  ];
  
  function VendorEventController(
    $rootScope,
    $scope,
    $uibModal,
    $location,
    $interval,
    moment,
    Notification,
    // __event,
    MapService,
    __vendor,
    __sponsor,
    __transaction,
    PaymentService,
    PageService
  ) {
    var vm = this;

    $scope.currentEvent = $rootScope.currentEvent;

    vm.sponsorsHeadline = [];
    vm.sponsorsSecondary = [];

    vm.isSameDate = false;
    vm.mapData = {};

    angular.extend($scope, {
      moment: moment
    });

    angular.extend($scope, {
      onInit: function() {
        vm.event = $rootScope.currentEvent;
        vm.billingPreferences = vm.event.billingPreferences;
        vm.preferences = vm.event.preferences;
        vm.sponsorModule = vm.event.preferences.sponsorModule;
        vm.vendorModule = vm.event.preferences.vendorModule;

        vm.eventStartDate = moment(moment.utc(vm.event.start)).local().format('MMMM DD, YYYY');
        vm.eventStartTime = moment(moment.utc(vm.event.start)).local().format('hh:mm a');
        vm.eventEndDate = moment(moment.utc(vm.event.end)).local().format('MMMM DD, YYYY');
        vm.eventEndTime = moment(moment.utc(vm.event.end)).local().format('hh:mm a');

        if ( moment(vm.eventStartDate).isSame(vm.eventEndDate, 'day') ){
          vm.isSameDate = true;
        }

        __sponsor.getSponsors('innerPages', true, true)
          .then(
            function(response){
              var arrays = [];
              angular.forEach(response.data, function(sponsor){
                if ( sponsor.headline ) {
                  vm.sponsorsHeadline.push(sponsor);
                } else {
                  arrays.push(sponsor);
                }
              });

              for ( var i = 0; i < arrays.length; i += 2 ) {
                if ( arrays.length > 8 ){
                  vm.sponsorsSecondary.push(arrays.slice(i, i + 2));
                } else {
                  vm.sponsorsSecondary = arrays;
                }
              }
            },
            $scope.handleError
          );

        PageService.getPageByTag('fixed', 'appFormVendor')
          .then(
            function(response){
              vm.appFormVendor = response.data;
            },
            $scope.handleError
          );

        MapService.getMapByID($scope.currentEvent.mainEventMapId, 'booths')
          .then(function(response){
            ;
            var data = response.data;
            vm.mapData = data;
            vm.booths = data.booths;
          })
          .catch(function(err){
            console.error(err);
          });

        $scope.fetchMyRequests();

        if ( typeof $location.search().fetchingRequests !== 'undefined' ){
          $scope.showInfopanel = true;
          var count = 0;
          var clearInt = $interval(function(){
            if ( $scope.requestsTotal !== $scope.nextRequestTotal ){
              $scope.showInfopanel = false;
              $interval.cancel(clearInt);
              return;
            }
            __vendor.getMyRequests()
              .then(
                function(response){
                  vm.requests = __vendor.requests(response.data);
                  $scope.nextRequestTotal = response.data.length;
                }
              );
            if ( count === 5 ){
              $scope.showInfopanel = false;
              $interval.cancel(clearInt);
            } else {
              count++;
            }
          }, 5000);
        }
      },

      fetchMyRequests: function(){
        __vendor.getMyRequests()
          .then(
            function(response){
              vm.requests = __vendor.requests(response.data);
              $scope.requestsTotal = response.data.length;
              $scope.nextRequestTotal = response.data.length;
            },
            $scope.handleError
          )
      },

      handleDonation: function() {
        $uibModal.open({
          templateUrl: 'app/donations-form/donations-form.html',
          controller: 'DonationFormController',
          controllerAs: 'vm',
          resolve: {
            relocate: function(){
              return false;
            }
          }
        });
      },

      handleCancel: function(request) {
        if ( request && request.id ){
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Your status is currently {{request.status}}. By clicking the "Cancel" button, you will be removed from the event.\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleCancel()">Cancel</button>\
                <button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, request){
              $scope.request = request;
              $scope.handleCancel = function(){
                $uibModalInstance.close(request);
              }
              $scope.handleClose = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });

          modal.result
            .then(
              function(result){
                __vendor.onCancel(result.id)
                  .then(
                    function(response){
                      Notification.success('Your request was canceled');
                      __vendor.updateRequest(response.data);
                    },
                    $scope.handleError
                  );
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handlePreview: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            templateUrl: 'app/users/request-preview.html',
            controller: function($scope, $rootScope, $uibModalInstance, request, CategoryService, PriceService, PROFILE_VISIBILITY){
              $scope.currentUser = $rootScope.currentUser;
              $scope.visibility = PROFILE_VISIBILITY;
              $scope.prices = [];

              CategoryService.getCategories()
                .then(
                  function(response) {
                    $scope.categories = response.data;
                  },
                  $scope.handleError
                );

              PriceService.getPrices()
                .then(
                  function(response) {
                    angular.forEach(response.data, function(item){
                      if ( item.type === 'booth' && item.enabled ) {
                        $scope.prices.push(item);
                      }
                    });
                  },
                  $scope.handleError
                );

              $scope.request = request;

              $scope.modelPackage = $scope.prices.filter(function(item){
                return item.price === request.price;
              })[0];

              $scope.profileVisibility = request.profileVisibility || [];

              if ( request.invoiceDueDate ) {
                $scope.startDate = moment(moment.utc(request.invoiceDueDate)).local().toDate();
              }

              if ( !$scope.modelPackage ) {
                $scope.modelPackage = {
                  price: request.price
                }
              }

              $scope.handlePhotoPreview = function(photo){
                var modal = $uibModal.open({
                  windowTopClass: 'modal-preview',
                  backdropClass: 'modal-backdrop-preview',
                  template: '\
                    <div class="modal-body">\
                      <div class="modal-body-inner">\
                        <div><img ng-click="handleClose()" ng-src="{{ photo.link }}" alt="Photo close" /></div>\
                      </div>\
                    </div>\
                    <div class="modal-footer">\
                      <button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>\
                    </div>\
                  ',
                  controller: function($scope, $uibModalInstance, photo){
                    $scope.photo = photo;
                    $scope.handleClose = function(){
                      $uibModalInstance.dismiss('cancel');
                    }
                  },
                  resolve: {
                    photo: function(){
                      return photo;
                    }
                  }
                });
              }

              $scope.handleClose = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });
        }
      },

      handlePhotoPreview: function(photo){
        var modal = $uibModal.open({
          windowTopClass: 'modal-preview',
          backdropClass: 'modal-backdrop-preview',
          template: '\
            <div class="modal-body">\
              <div class="modal-body-inner">\
                <div><img ng-click="handleClose()" ng-src="{{ photo.link }}" alt="Photo close" /></div>\
              </div>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance, photo){
            $scope.photo = photo;
            $scope.handleClose = function(){
              $uibModalInstance.dismiss('cancel');
            }
          },
          resolve: {
            photo: function(){
              return photo;
            }
          }
        });
      },

      handleSubmit: function(request) {
        if ( request && request.id ) {
          __vendor.onSubmit(request.id)
            .then(
              function(response){
                Notification.success('Your request was submitted');
                Notification.warning('Don\'t forget to fill in online application form!');
                __vendor.updateRequest(response.data);
              },
              $scope.handleError
            );
          }
      },

      hasBoothLinked: function(request) {
        var isLinked = false;
        for ( var i in vm.booths ){
          var booth = vm.booths[i];
          if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
            for ( var i in booth.userCommercialAssignments ){
              var id = booth.userCommercialAssignments[i].eventRequestId;
              if ( id === request.id ){
                isLinked = true;
                break;
              }
            }
          }
          if ( isLinked ){
            break;
          }
        }
        return isLinked;
      },

      handlePaypalButton: function(pay, request) {
        var paymentData = {
          id: request.id,
          amount: request.price,
          name: request.vendor.name
        };
        PaymentService.paypalForm(pay, paymentData, 'evr');
      },

      handleTransactionButton: function(pay, request){
        var paymentData = {
          id: request.id,
          amount: request.price
        };
        PaymentService.transactionForm(pay, paymentData, 'evr');
      },

      handleStripeButton: function(pay, request){
        var paymentData = {
          id: request.id,
          amount: request.price,
          name: request.vendor.name,
          description: request.description,
          email: request.vendor.email
        };
        PaymentService.stripeForm(pay, paymentData, 'evr',
          function(){
            __vendor.getRequestById(request.id)
              .then(
                function(response){
                  // __vendor.pushRequest(response.data);
                  var data = response.data;
                  for ( var i in vm.requests ){
                    var item = vm.requests[i];
                    if ( item.id === data.id ){
                      var idx = vm.requests.indexOf(item);
                      vm.requests[idx] = data;
                    }
                  }
                  Notification.success('Payment successfully submitted')
                },
                function(err){
                  console.log(err);
                }
              );
          },
          function(err){
            Notification.error(err.data.message);
          }
        );
      },

      handleSquareupButton: function(pay, request) {
        var modal = $uibModal.open({
          templateUrl: 'app/squareup-form/squareup-form.html',
          controller: 'SquareupFormController',
          controllerAs: 'vm',
          size: 'sm',
          resolve: {
            dataPay: function(){
              return {
                applicationId: pay.applicationId,
                locationId: pay.locationId
              };
            },
            dataResult: function(){
              return {
                amount: request.price,
                id: request.id
              };
            },
            itemType: function(){
              return 'evr';
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              __vendor.getRequestById(request.id)
                .then(
                  function(response){
                    __vendor.pushRequest(response.data);
                    Notification.success('Payment successfully submitted')
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(){
              console.log('Dissmissed');
            }
          );
      },

      handlePayeezyButton: function(pay, request) {
        var modal = $uibModal.open({
          templateUrl: 'app/payeezy-form/payeezy-form.html',
          controller: 'PayeezyFormController',
          controllerAs: 'vm',
          size: 'sm',
          resolve: {
            dataPay: function(){
              return {
                apiKey: pay.apiKey,
                paymentJSUrl: pay.paymentJSUrl,
                transarmorToken: pay.transarmorToken,
                jsSecurityKey: pay.jsSecurityKey
              };
            },
            dataResult: function(){
              return {
                amount: request.price,
                id: request.id
              };
            },
            itemType: function(){
              return 'evr';
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              __vendor.getRequestById(request.id)
                .then(
                  function(response){
                    __vendor.pushRequest(response.data);
                    Notification.success('Payment successfully submitted')
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(){
            }
          );
      },

      showEventPass: function(request) {
        if ( request && request.id ){
          $uibModal.open({
            templateUrl: 'app/users/event-pass/event-pass.html',
            controller: 'EventPassController',
            controllerAs: 'vm',
            windowClass: 'modal-event-pass',
            resolve: {
              resolveType: function(){
                return 'vendor'
              },
              resolveRequest: function(){
                return request;
              }
            }
          });
        }
      },

      handleError: function(err){
        Notification.error(err.data.message);
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };

    angular.extend($scope, {
      slickConfig: {
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },{
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },{
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      slickHeadlineConfig: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('SponsorAttendantEventPassRequestController', SponsorAttendantEventPassRequestController);
  
    function SponsorAttendantEventPassRequestController(
      $rootScope,
      $scope,
      $uibModalInstance,
      $interval,
      sponsorRequest,
      SponsorService
    ) {
      var vm = this;
      vm.loading = true;
      vm.request = sponsorRequest;

      var stopInterval;

      angular.extend($scope, {
        onInit: function() {

          setTimeout(function(){
            var qrcodeLink = document.querySelector('.qrcode-link');
            if ( qrcodeLink ){
              qrcodeLink.addEventListener('click', function(evt){
                evt.preventDefault();
                console.log('clicked');
              });
            }
          }, 500);

          if ( !vm.request.checkedIn ){
            stopInterval = $interval(function(){
              SponsorService.getMyAttendantRequests()
                .then(function(response){ vm.request = response.data[0] });
            }, 5000);
          }

          vm.loading = false;
          vm.event = $rootScope.currentEvent;
          if ( vm.event && vm.event.domain ){
            var domain = ( vm.event.domain !== 'localhost' ? vm.event.domain : vm.event.domain +':3000');
            vm.qrURL = 'http://'+ domain +'/auto-check-in?type=request&user=sponsorAttendant&id='+ vm.request.id;
          }
        },

        onClose: function() {
          $uibModalInstance.dismiss(vm.request);
          $interval.cancel(stopInterval);
        },

        handleError: function(err) {
          vm.loading = false;
          console.error(err);
        }
      });
    }

})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('SponsorMapController', SponsorMapController)

  function SponsorMapController(
    $rootScope,
    $scope,
    $stateParams,
    MapService,
    BoothTypeService,
    SponsorService,
    Notification,

    OutdoorService,
    IndoorService,

    Route,
    Booth,
    EventZone,

    IndoorRoute,
    IndoorBooth,
    IndoorZone,

    ToolsBooth
  ) {
    var vm = this;

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.currentUser = $rootScope.currentUser;

    $scope.showOnlyMyBooths = false;

    $scope.userCommercialAssignments = [];

    $scope.boothTypes = [];
    $scope.indoorMaps = [];

    $scope.mapData = null;

    angular.extend($scope, {
      showPosition: false,
      currentPosition: null,
      onInit: function(){
        OutdoorService.resetOutdoorData();
        IndoorService.resetIndoorData();

        SponsorService.getMyRequests()
          .then(function(response){
            // vm.requests = response.data;
            var data = response.data;
            for ( var i in data ){
              var item = data[i];
              // Commercial Assignments
              var user = item.sponsor;
              user['type'] = 'sponsor';
              delete item['sponsor'];
              $scope.userCommercialAssignments.push($.extend({}, item, {
                user: user
              }));
            }

            return BoothTypeService.getBooths();
          })
          .then(function(response){
            $scope.boothTypes = response.data;

            $scope.checkMapID();
          })
          .catch(function(err){
            console.error(err);
          })

      },

      checkMapID: function(){
        if ( typeof $stateParams.id !== 'undefined' ){
          $scope.fetchMap(parseInt($stateParams.id, 10));
        } else if ( typeof $stateParams.id === 'undefined' && $scope.currentEvent && $scope.currentEvent.mainEventMapId ){
          $scope.fetchMap($scope.currentEvent.mainEventMapId);
        } else {
          console.error('No map ID present');
        }
      },

      fetchMap: function(id){
        MapService.getMapByID(id)
          .then(function(response){
            var data = response.data;
            // console.log(data);
            if ( data.type === 'outdoor' ){
              // Only for outdoor
              $scope.renderOutdoorMapItems(function(){
                $scope.map = OutdoorService;
                $scope.map.initMap(data, null, 'users.sponsor.indoorMap');
                $scope.initMapItems(data, $scope.map);

                if ($scope.showPosition && !$scope.currentPosition){
                  Notification.warning('Reload page and grant access for your location to use option "Show me on map"');
                }

                $scope.$watch('currentPosition', function(){
                  if ( $scope.currentPosition ) {
                    OutdoorService.showMeOnMapButton($scope.currentPosition);
                  }
                });
              });
            } else if ( data.type === 'indoor' ){
              $scope.map = IndoorService;
              $scope.map.initMap(data);
              $scope.initMapItems(data, $scope.map);
            } else {
              console.error('Map type not present');
            }
          })
          .catch(function(err){
            console.error(err);
          })
      },

      // Only for outdoor map
      renderOutdoorMapItems: function(cb){
        // Set navigator if is outdoor map
        $scope.showPosition = true;
        if ( navigator.geolocation ){
          navigator.geolocation.getCurrentPosition(function(position){
            $scope.$apply(function(){
              $scope.currentPosition = position;
            });
          });
        }

        MapService.getMaps(null, 'name,type,booths', 'indoor')
          .then(function(response){
            $scope.indoorMaps = response.data;
            cb();
          })
          .catch(function(err){
            console.error(err);
          });
      },

      initMapItems: function(data, map){
        $scope.mapData = data;

        var booths = [];
        // var boothRouteIds = [];

        // Booths
        if ( data.booths ){
          var bounds;
          if ( data.type === 'outdoor' ) bounds = new google.maps.LatLngBounds();

          var booths = ToolsBooth.getUserBooths(
            false, // onlyNonCommercial
            $scope.currentUser, // Current user
            data.booths, // booths
            $scope.boothTypes, // boothTypes
            $scope.indoorMaps.length ? $scope.indoorMaps : null, // indoor maps
            $scope.userCommercialAssignments // requests
          );

          if ( booths && booths.length ){
            for ( var i in booths ){
              var booth = booths[i];
              $scope.drawBooth(data.type, booth, map);
  
              if ( data.type === 'outdoor' ){
                // var position = booth.position ? booth.position : booth.preferences.coordinates[0];
                // var latLng = new google.maps.LatLng(position.lat, position.lng);
    
                // bounds.extend(latLng);
                var latLng;
                if ( booth.position ){
                  latLng = new google.maps.LatLng(booth.position.lat, booth.position.lng);
                  bounds.extend(latLng);
                } else {
                  // if ( booth.coordinates.length ){
                    for ( var j in booth.coordinates ){
                      var coord = booth.coordinates[j];
                      latLng = new google.maps.LatLng(coord.lat, coord.lng);
                      bounds.extend(latLng);
                    }
                  // }
                }
                map.getMap().fitBounds(bounds);
              }
            }
          }
        }

        if ( data.eventZones ){
          for ( var i in data.eventZones ) {
            var zone = data.eventZones[i];

            if ( booths.length ){
              for ( var j in booths ){
                var booth = booths[j];
                if ( booth.zoneId === zone.id ){
                  $scope.drawEventZone(data.type, zone, map);
                }
              }
            }
          }
        }

        // Routes
        if ( booths.length ){
          for ( var i in booths ){
            var booth = booths[i];
            if ( data.routes ){
              for ( var j in data.routes ){
                var route = data.routes[j];
                if ( !route.drawed ){
                  if ( booth.routeIds.indexOf(route.id) !== -1 ){
                    $scope.drawRoute(data.type, route, map);
                    continue;
                  }
                  if ( route.zoneId ){
                    var isSame = false;
                    if ( data.eventZones && data.eventZones.length ){
                      for ( var j in data.eventZones ){
                        var zone = data.eventZones[j];
                        if (
                          zone.id === route.zoneId &&
                          zone.id === booth.zoneId
                        ){
                          isSame = true;
                          break;
                        }
                      }
                    }
                    if ( isSame ){
                      $scope.drawRoute(data.type, route, map);
                      continue;
                    }
                  }
                }
              }
            }
          }
        }
      },

      drawBooth: function(mapType, boothData, map){
        var draw = true;

        if ( $scope.boothTypes && $scope.boothTypes.length ){
          for ( var i in $scope.boothTypes ){
            var type = $scope.boothTypes[i];
            var pref = type.preferences;
            if ( boothData.boothTypeId === type.id ){
              if (
                ToolsBooth.boothBelongToUser(
                  boothData,
                  $scope.userCommercialAssignments,
                  $scope.currentUser.id,
                  $scope.currentUser.type,
                  $scope.indoorMaps.length ? $scope.indoorMaps: null
                )
              ){
                break;
              } else if ((pref && pref.private) || type.commercial || !type.commercial) {
                draw = false;
                break;
              }
            }
          }
        }

        if ( draw ) {
          var booth = mapType === 'outdoor' ? new Booth(false, true) : new IndoorBooth(false, true);
          booth.read(boothData, $scope.boothTypes, $scope.userCommercialAssignments);
          map.drawBooth(booth);
        }
      },

      drawRoute: function(type, routeData, map){
        var route = type === 'outdoor' ? new Route(true) : new IndoorRoute();
        route['drawed'] = true;
        route.read(routeData);
        map.drawRoute(route, false);
      },

      drawEventZone: function(mapType, zoneData, map){
        var zone = mapType === 'outdoor' ? new EventZone(false) : new IndoorZone(false);
        zone.read(zoneData, false);
        map.drawEventZone(zone, false);
      }
    })
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('SponsorMessagesController', SponsorMessagesController);
  
  SponsorMessagesController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    '$location',
    'Notification',
    'MessagesService'
  ];
  
  function SponsorMessagesController(
    $rootScope,
    $scope,
    $uibModal,
    $location,
    Notification,
    __messages
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
      },
      openModalMessage: function(){
        var modal = $uibModal.open({
          templateUrl: 'app/users/messages/modal/modal.html',
          controller: 'MessageModalController',
          controllerAs: 'vm',
          resolve: {
            $message: function(){
              return false;
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              // $rootScope.loadingInformation = true;
              __messages.sentMessageBackOffice(resolve)
                .then(
                  function(response){
                    // $rootScope.loadingInformation = false;
                    Notification.success('Message was sent');
                    if ( $location.$$path.indexOf('/messages/sent') !== -1 ){
                      __messages.add(response.data);
                    }
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(){
              console.log('Dissmissed');
            }
          );
      }
    });

  }

})();
(function(){

  angular
    .module('eventmap')
    .controller('SponsorEventController', SponsorEventController);

  SponsorEventController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$uibModal',
    '$location',
    '$interval',
    '$window',
    'moment',
    'Notification',
    'SponsorService',
    'PriceService',
    'TransactionService',
    'PaymentService',
    'PageService'
  ];

  function SponsorEventController(
    $rootScope,
    $scope,
    $state,
    $uibModal,
    $location,
    $interval,
    $window,
    moment,
    Notification,
    __sponsor,
    __price,
    __transaction,
    PaymentService,
    PageService
  ){
    var vm = this;
    vm.sponsorsHeadline = [];
    vm.sponsorsSecondary = [];

    vm.isSameDate = false;
    vm.loadingBuy = false;
    vm.loadingCash = false;
    vm.pricePackages = [];
    vm.selectedPackage = null;

    vm.requests = [];

    $scope.showInfopanel = false;
    // $scope.nextRequestTotal = 0;
    // vm.invitePackages = [];

    angular.extend($scope, {
      onInit:function() {
        vm.event = $rootScope.currentEvent;
        vm.billingPreferences = vm.event.billingPreferences;
        vm.preferences = vm.event.preferences;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        vm.eventStartDate = moment(moment.utc(vm.event.start)).local().format('MMMM DD, YYYY');
        vm.eventStartTime = moment(moment.utc(vm.event.start)).local().format('hh:mm a');
        vm.eventEndDate = moment(moment.utc(vm.event.end)).local().format('MMMM DD, YYYY');
        vm.eventEndTime = moment(moment.utc(vm.event.end)).local().format('hh:mm a');

        if ( moment(vm.eventStartDate).isSame(vm.eventEndDate, 'day') ){
          vm.isSameDate = true;
        }

        __sponsor.getSponsors('innerPages', true, true)
          .then(
            function(response){
              var arrays = [];
              angular.forEach(response.data, function(sponsor){
                if ( sponsor.headline ) {
                  vm.sponsorsHeadline.push(sponsor);
                } else {
                  arrays.push(sponsor);
                }
              });

              for ( var i = 0; i < arrays.length; i += 2 ) {
                if ( arrays.length > 8 ){
                  vm.sponsorsSecondary.push(arrays.slice(i, i + 2));
                } else {
                  vm.sponsorsSecondary = arrays;
                }
              }

            },
            $scope.handleError
          );

        PageService.getPageByTag('fixed', 'appFormSponsor')
          .then(
            function(response){
              vm.appFormSponsor = response.data;
            },
            $scope.handleError
          );


        $scope.fetchMyRequests(function(){
          $scope.getPricePackages();
        });
        // vm.requests = __sponsor.getS();
        // $scope.requestsTotal = vm.requests.length;
        // $scope.nextRequestTotal = vm.requests.length;

        if ( typeof $location.search().fetchingRequests !== 'undefined' ){
          $scope.showInfopanel = true;
          var count = 0;
          var clearInt = $interval(function(){
            if ( $scope.requestsTotal !== $scope.nextRequestTotal ){
              $scope.showInfopanel = false;
              $interval.cancel(clearInt);
              return;
            }
            __sponsor.getMyRequests()
              .then(
                function(response){
                  vm.requests = __sponsor.sponsors(response.data);
                  $scope.nextRequestTotal = response.data.length;

                  $scope.$emit('childSponsorRequests', response.data);
                },
                $scope.handleError
              );
            if ( count === 5 ){
              $scope.showInfopanel = false;
              $interval.cancel(clearInt);
            } else {
              count++;
            }
          }, 5000);
        }

        // $scope.getPricePackages();
      },

      showEventPass: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            templateUrl: 'app/users/event-pass/event-pass.html',
            controller: 'EventPassController',
            controllerAs: 'vm',
            windowClass: 'modal-event-pass',
            resolve: {
              resolveType: function(){
                return 'sponsor'
              },
              resolveRequest: function(){
                return request;
              }
            }
          });
          modal.result
            .then(
              function(result){
                // console.log(result);
              },
              function(result) {
                // console.log(result);
                for ( var i in vm.requests ){
                  var rq = vm.requests[i];
                  if ( rq.id === result.id ){
                    var idx = vm.requests.indexOf(rq);
                    vm.requests[idx] = result;
                  }
                }
              }
            );
        }
      },

      onShowNotes: function(request){
        if ( request && request.id ){
          $uibModal.open({
            template: '\
              <div class="modal-body">\
                <div class="from-group">\
                  <label for="notes">Special requests or notes:</label>\
                  <textarea class="form-control" id="notes" name="notes" ng-model="sponsorRequest.notes" rows="7" placeholder="Notes"\
                            ng-readonly="isAccepted()"></textarea>\
                </div>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                <button class="btn btn-primary" type="button" ng-if="!isAccepted()" ng-click="handleSave()">Save</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, SponsorService, Notification, request){
              $scope.sponsorRequest = request;
              $scope.handleSave = function(){
                SponsorService.updateRequest($scope.sponsorRequest.id, $scope.sponsorRequest)
                  .then(function(response){
                    Notification.success('Request notes were updated');
                    $uibModalInstance.close(response.data);
                  })
                  .catch(function(err){
                    console.error(err);
                  });
              }
              $scope.isAccepted = function(){
                return request.status === 'accepted';
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          }).result.then(function(result){
            var idx = vm.requests.indexOf(request);
            vm.requests[idx] = result;
          }, function(err){
            console.warn(err);
          })
        }
      },

      fetchMyRequests: function(cb){
        __sponsor.getMyRequests()
          .then(
            function(response){
              vm.requests = __sponsor.sponsors(response.data);
              $scope.requestsTotal = response.data.length;
              $scope.nextRequestTotal = response.data.length;

              if ( cb ) cb();
            },
            $scope.handleError
          );
      },

      handleDonation: function() {
        $uibModal.open({
          templateUrl: 'app/donations-form/donations-form.html',
          controller: 'DonationFormController',
          controllerAs: 'vm',
          resolve: {
            relocate: function(){
              return false;
            }
          }
        });
      },

      calculateRemainingPackages: function(requests){
        var result = [];
        if ( requests.length <= 0 ) return result;
        for ( var i in requests ){
          var r = requests[i];
          var data = result[r.pricePackageId];
          if ( !data ){
            data = 0;
            result[r.pricePackageId] = data;
          }

          result[r.pricePackageId] += 1;
        }
        return result;
      },

      calculatePurchased: function(pkg){
        var isMaxAvailable = false;
        var isLimitPerPerson = false;
        if ( pkg.maxAvailable && pkg.maxAvailable > 0 ){
          isMaxAvailable = true;
        }
        if ( pkg.limitPerPerson && pkg.limitPerPerson > 0 ){
          isLimitPerPerson = true;
        }
        if ( isMaxAvailable && isLimitPerPerson ){
          return (pkg.maxAvailable - pkg.stats.inUse) > pkg.limitPerPerson ? $scope.remainingPackages[pkg.id] ? pkg.limitPerPerson - $scope.remainingPackages[pkg.id] : pkg.limitPerPerson : (pkg.maxAvailable - pkg.stats.inUse);
        } else if ( isLimitPerPerson ){
          return $scope.remainingPackages[pkg.id] ? pkg.limitPerPerson - $scope.remainingPackages[pkg.id] : pkg.limitPerPerson;
        }
      },

      getPricePackages: function() {
        $scope.remainingPackages = $scope.calculateRemainingPackages(vm.requests);
        vm.pricePackages = [];
        __price.getPrices(true, 'sponsor')
          .then(
            function(response) {
              angular.forEach(response.data, function(item){
                vm.pricePackages.push($.extend({}, item, {
                  amount: 0,
                  purchased: $scope.calculatePurchased(item)
                }));
              });
            },
            $scope.handleError
          );
      },

      onApplyPromocode: function(promocode){
        if ( promocode ){
          // vm.pricePackages = [];
          __price.getPrices(true, 'sponsor', promocode)
            .then(
              function(response) {
                angular.forEach(response.data, function(item){
                  vm.pricePackages.push($.extend({}, item, {
                    amount: 0,
                    purchased: $scope.calculatePurchased(item)
                  }));
                });
              },
              $scope.handleError
            );
        }
      },

      handleProfileVisibility: function(request){
        if ( request && request.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/sponsors/requests/requests.form.html',
            controller: 'OrganizerSponsorsFormRequestsController',
            controllerAs: 'vm',
            resolve: {
              request: function(){
                return request;
              }
            }
          }).result.then(
            function(result){
              console.log(result);
              var idx = vm.requests.indexOf(request);
              vm.requests[idx] = result;
            },
            function(err){
              console.log(err);
            }
          );
        }
      },

      handleError: function(err){
        Notification.error(err.data.message);
      }
    });

    // Payment
    angular.extend($scope, {
      // Handle payment buttons
      handleNoCostButton: function(){
        vm.loadingCash = true;
        if ( vm.selectedPackage && vm.selectedPackage.id ) {
          var data = {
            pricePackageId: vm.selectedPackage.id,
            payCash: true
          };
          if ( vm.sponsorRequestNotes && vm.sponsorRequestNotes !== '' ){
            data['notes'] = vm.sponsorRequestNotes;
          }
          __sponsor.addRequest(data)
            .then(
              function(response) {
                __sponsor.add(response.data);
                Notification.success('Request was added');
                vm.selectedPackage = null;
                vm.loadingCash = false;

                $scope.getPricePackages();

                onScrollTop(response.data);
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },
      handleCashButton: function() {
        if ( vm.sponsorModule.cashPayment ) {
          vm.loadingCash = true;
          if ( vm.selectedPackage && vm.selectedPackage.id ) {
            var data = {
              pricePackageId: vm.selectedPackage.id,
              payCash: true
            };
            if ( vm.sponsorRequestNotes && vm.sponsorRequestNotes !== '' ){
              data['notes'] = vm.sponsorRequestNotes;
            }
            __sponsor.addRequest(data)
              .then(
                function(response) {
                  __sponsor.add(response.data);
                  Notification.success('Request was added');
                  vm.selectedPackage = null;
                  vm.loadingCash = false;

                  $scope.getPricePackages();

                  onScrollTop(response.data);
                },
                $scope.handleError
              );
          } else {
            $scope.notificationAmount();
          }
        }
      },
      handlePaypalButton: function(pay) {
        if ( vm.selectedPackage && vm.selectedPackage.id ) {
          vm.loadingBuy = true;
          var data = { pricePackageId: vm.selectedPackage.id };
          if ( vm.sponsorRequestNotes && vm.sponsorRequestNotes !== '' ){
            data['notes'] = vm.sponsorRequestNotes;
          }
          __sponsor.addRequest(data)
            .then(
              function(response) {
                var data = response.data;
                if (vm.selectedPackage && vm.selectedPackage.amount) {
                  __sponsor.add(data);
                } else {
                  var paymentData = {
                    id: data.id,
                    amount: data.price,
                    name: data.sponsor.name,
                    description: data.description,
                    email: data.sponsor.email
                  };
                  PaymentService.paypalForm(pay, paymentData, 'esr');
                }

                vm.selectedPackage = null;
                vm.loadingBuy = false;
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },
      handleTransactionButton: function(pay) {
        if ( vm.selectedPackage && vm.selectedPackage.id ) {
          vm.loadingBuy = true;
          var data = { pricePackageId: vm.selectedPackage.id };
          if ( vm.sponsorRequestNotes && vm.sponsorRequestNotes !== '' ){
            data['notes'] = vm.sponsorRequestNotes;
          }
          __sponsor.addRequest(data)
            .then(
              function(response) {
                var data = response.data;
                if (vm.selectedPackage && vm.selectedPackage.amount) {
                  __sponsor.add(data);
                } else {
                  var paymentData = {
                    id: data.id,
                    amount: data.price,
                    name: data.sponsor.name,
                    description: data.description,
                    email: data.sponsor.email
                  };
                  PaymentService.transactionForm(pay, paymentData, 'esr');
                }

                vm.selectedPackage = null;
                vm.loadingBuy = false;
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },
      handleStripeButton: function(pay) {
        if ( vm.selectedPackage && vm.selectedPackage.id ) {
          vm.loadingBuy = true;
          var data = { pricePackageId: vm.selectedPackage.id };
          if ( vm.sponsorRequestNotes && vm.sponsorRequestNotes !== '' ){
            data['notes'] = vm.sponsorRequestNotes;
          }
          __sponsor.addRequest(data)
            .then(
              function(response) {
                var data = response.data;
                var paymentData = {
                  id: data.id,
                  amount: data.price,
                  name: data.sponsor.name,
                  description: data.description,
                  email: data.sponsor.email
                };
                PaymentService.stripeForm(pay, paymentData, 'esr',
                  function(){
                    __sponsor.getRequestById(data.id)
                      .then(
                        function(responseNext){
                          __sponsor.add(responseNext.data);
                          Notification.success('Payment successfully submitted');

                          onScrollTop(responseNext.data);
                        },
                        function(err){
                          console.log(err);
                        }
                      );
                  },
                  function(err){
                    console.log(err);
                  }
                );

                vm.selectedPackage = null;
                vm.loadingBuy = false;
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },

      handleSquareButton: function(pay){
        if ( vm.selectedPackage && vm.selectedPackage.id ) {
          vm.loadingBuy = true;
          var data = { pricePackageId: vm.selectedPackage.id };
          if ( vm.sponsorRequestNotes && vm.sponsorRequestNotes !== '' ){
            data['notes'] = vm.sponsorRequestNotes;
          }
          __sponsor.addRequest(data)
            .then(
              function(response) {
                var data = response.data;

                var modal = $uibModal.open({
                  templateUrl: 'app/squareup-form/squareup-form.html',
                  controller: 'SquareupFormController',
                  controllerAs: 'vm',
                  size: 'sm',
                  resolve: {
                    dataPay: function(){
                      return {
                        applicationId: pay.applicationId,
                        locationId: pay.locationId
                      };
                    },
                    dataResult: function(){
                      return {
                        amount: data.price,
                        id: data.id
                      };
                    },
                    itemType: function(){
                      return 'esr';
                    }
                  }
                });
                modal.result
                  .then(
                    function(){
                      __sponsor.getRequestById(data.id)
                        .then(
                          function(responseNext){
                            __sponsor.add(responseNext.data);
                            Notification.success('Payment successfully submitted');

                            onScrollTop(responseNext.data);
                          },
                          function(err){
                            console.log(err);
                          }
                        );
                    },
                    function(){
                      console.log('Dissmissed');
                    }
                  );

                vm.selectedPackage = null;
                vm.loadingBuy = false;
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },


      handlePayeezyButton: function(pay){
        if ( vm.selectedPackage && vm.selectedPackage.id ) {
          vm.loadingBuy = true;
          var data = { pricePackageId: vm.selectedPackage.id };
          if ( vm.sponsorRequestNotes && vm.sponsorRequestNotes !== '' ){
            data['notes'] = vm.sponsorRequestNotes;
          }
          __sponsor.addRequest(data)
            .then(
              function(response) {
                var data = response.data;

                var modal = $uibModal.open({
                  templateUrl: 'app/payeezy-form/payeezy-form.html',
                  controller: 'PayeezyFormController',
                  controllerAs: 'vm',
                  size: 'sm',
                  resolve: {
                    dataPay: function(){
                      return {
                        apiKey: pay.apiKey,
                        paymentJSUrl: pay.paymentJSUrl,
                        transarmorToken: pay.transarmorToken,
                        jsSecurityKey: pay.jsSecurityKey
                      }
                    },
                    dataResult: function(){
                      return {
                        amount: data.price,
                        id: data.id
                      };
                    },
                    itemType: function(){
                      return 'esr';
                    }
                  }
                });
                modal.result
                  .then(
                    function(resolve){
                      __sponsor.getRequestById(data.id)
                        .then(
                          function(responseNext){
                            __sponsor.add(responseNext.data);
                            Notification.success('Payment successfully submitted');

                            onScrollTop(responseNext.data);
                          },
                          function(err){
                            console.log(err);
                          }
                        );
                    },
                    function(){
                      console.log('Dissmissed');
                    }
                  );

                vm.selectedPackage = null;
                vm.loadingBuy = false;
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },

      notificationAmount: function() {
        Notification.error('Amount is exaggerated than selected package');
        vm.loadingCash = false;
        vm.loadingBuy = false;
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };

    angular.extend($scope, {
      slickConfig: {
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },{
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },{
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      slickHeadlineConfig: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true
      }
    });

    function onScrollTop(requetsData){
      $window.scrollTo(0, 0);

      __sponsor.getMyRequests()
        .then(function(response){
          vm.requests = __sponsor.sponsors(response.data);
          $scope.$emit('childSponsorRequests', response.data);

          vm.sponsorRequestNotes = '';

          var request = vm.requests.filter(function(item){
            return item.id === requetsData.id;
          })[0];

          if ( vm.requests.length > 1 ){
            var total = 0;
            for ( var i in vm.requests ){
              var rq = vm.requests[i];
              if ( rq.id !== request.id ){
                if ( rq.pricePackage.preferences && rq.pricePackage.preferences.maxAttendants ){
                  total += rq.pricePackage.preferences.maxAttendants;
                }
              }
            }
            if ( total === 0 ){
              if ( request.status === 'accepted' && (request.pricePackage.preferences && request.pricePackage.preferences.maxAttendants > 0) ){
                showRedirectModal();
              }
            }
          } else {
            if ( request.status === 'accepted' && (request.pricePackage.preferences && request.pricePackage.preferences.maxAttendants > 0) ){
              showRedirectModal();
            }
          }
        });
    }

    function showRedirectModal(){
      var modal = $uibModal.open({
        template: '\
          <div class="modal-header">\
            <h3 class="modal-title">Do you want to invite attendants now?</div></h3>\
          <div class="modal-footer">\
            <button class="btn btn-default" type="button" ng-click="onNo()">No</button>\
            <button class="btn btn-primary" type="button" ng-click="onYes()">Yes</button>\
          </div>\
        ',
        controller: function($scope, $uibModalInstance){
          $scope.onYes = function(){
            $uibModalInstance.close();
          }
          $scope.onNo = function(){
            $uibModalInstance.dismiss('no');
          }
        }
      });

      modal.result.then(function(result){
        $state.go('users.sponsor.attendants');
      }, function(cancel){
        console.log(cancel);
      });
    }

    $scope.$on('sponsorRequests', function(event, data) {
      vm.requests = data;
      $scope.requestsTotal = data.length;
      $scope.nextRequestTotal = data.length;
    });
  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('SponsorAttendantsController', SponsorAttendantsController);

  function SponsorAttendantsController(
    $rootScope,
    $scope,
    $uibModal,
    Notification,
    AuthService,
    SponsorService,
    ViewService
  ) {
    var vm = this;
    $scope.pageLoading = true;

    $scope.attendantRequests = [];

    $scope.myRequests = [];

    $scope.total = 0;
    $scope.totalAttentantRequests = 0;
    $scope.totalAvailableAttendantRequests = 0;

    vm.currentPage = 1;
    vm.event = $rootScope.currentEvent;
    vm.appView = localStorage.getItem('app_view');

    $scope.bulkID = 1;
    $scope.bulkFields = [{
      id: $scope.bulkID,
      name: null,
      username: null,
      email: null,
      password: '11111111',
      fieldName: 'name'+ $scope.bulkID,
      fieldUsername: 'username'+ $scope.bulkID,
      fieldEmail: 'email'+ $scope.bulkID,
      fieldPassword: 'password'+ $scope.bulkID,
      delete: false,
      success: false,
      error: false,
      errorMsg: null
    }];

    $scope.dataForm = {
      form: null
    };

    $scope.hideForm = false;

    angular.extend($scope, {
      onInit: function(){
        $scope.fetchAttendantRequests(function(totalAttentantRequests){
          $scope.totalAvailableAttendantRequests = totalAttentantRequests;
          $scope.totalAvailableAttendantRequests++;
        });

        if ( $scope.myRequests.length === 0 ){
          $scope.calcTotal(SponsorService.getS());
        }
      },

      fetchAttendantRequests: function(cb){
        SponsorService.getAttendantRequests()
          .then(function(response){
            $scope.hideForm = false;
            $scope.attendantRequests = response.data;
            $scope.pageLoading = false;

            $scope.totalAttentantRequests = parseInt($scope.attendantRequests.length, 10);
            // $scope.totalAvailableAttendantRequests = $scope.totalAttentantRequests;

            if ( $scope.total <= $scope.totalAttentantRequests ){
              $scope.hideForm = true;
            }

            if ( cb ) cb($scope.totalAttentantRequests);

            // $scope.totalAttentantRequests
            // $scope.totalAvailableAttendantRequests++;
          })
          .catch(function(err){
            console.error(err);
          });
      },

      calcTotal: function(requests){
        var acceptedMyRequests = [];
        var availablePricePackages = [];

        for ( var i in requests ){
          if ( requests[i].status === 'accepted' ){
            acceptedMyRequests.push(requests[i]);
          }
        }

        for ( var i in acceptedMyRequests ){
          var req = acceptedMyRequests[i];
          if ( availablePricePackages.indexOf(req.pricePackage) === -1 ){
            availablePricePackages.push(req.pricePackage);
          }
        }

        for ( var i in availablePricePackages ){
          var pkg = availablePricePackages[i];
          if ( pkg.preferences && pkg.preferences.maxAttendants ){
            $scope.total += parseInt(pkg.preferences.maxAttendants, 10);
          }
        }
      },

      showRemainingInvites: function(){
        var result = $scope.total - $scope.totalAttentantRequests;
        return (result < 0 ? 0 : result);
      },

      // onRegisterAttendant: function(){
      //   var modal = $uibModal.open({
      //     templateUrl: 'app/users/sponsor/attendants/attendants.register.html',
      //     controller: 'SponsorAttendantsRegisterController',
      //     controllerAs: 'vm',
      //   });

      //   modal.result.then(function(){
      //     Notification.success('Attendant was registered');
      //     $scope.fetchAttendantRequests();
      //   }, function(err){
      //     console.error(err);
      //   });
      // },

      onDeleteAttendant: function(user){
        if ( user && user.id ){

          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete <b>{{user.username}}</b> ({{user.name}}/{{user.email}}) sponsor attendant user account?<p>It will remove all the user data and operation can`t be undone</p>\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, user, AuthService){
              $scope.user = user;
              $scope.formLoading = false;
              
              $scope.handleConfirm = function(){
                $scope.formLoading = true;
                AuthService.onDelete(user.id)
                  .then(
                    function(){
                      $uibModalInstance.close();
                      $scope.formLoading = false;
                    },
                    function(err){
                      $scope.formLoading = false;
                      Notification.error(err.data.message);
                    }
                  );
              }
  
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              user: function(){
                return user;
              }
            }
          });
  
          modal.result
            .then(
              function(result){
                Notification.success('Sponsor attendant was removed');
                $scope.fetchAttendantRequests(function(totalAttentantRequests){
                  var fields = [];
                  if ( $scope.bulkFields && $scope.bulkFields.length ){
                    for ( var i in $scope.bulkFields ){
                      var f = $scope.bulkFields[i];
                      if ( !f.success && fields.indexOf(f) === -1 ) fields.push(f);
                    }
                  }
                  $scope.totalAvailableAttendantRequests = totalAttentantRequests + fields.length;
                  console.log($scope.totalAvailableAttendantRequests);
                });
              },
              function() {
                console.log('Cancelled');
              }
            );

        } else {
          console.error('Sponsor attendant id not present');
        }
      },

      onViewSwitch: function(type) {
        vm.appView = type;
        ViewService.setView(type);
      },

      // Add/Remove bulk
      addBulk: function() {
        var total = 0;

        for ( var i in $scope.bulkFields ){
          var bulk = $scope.bulkFields[i];
          if ( !bulk.success ) total++;
        }

        if ( total < $scope.total ){
          $scope.totalAvailableAttendantRequests++;
        } else {
          $scope.totalAvailableAttendantRequests++;
          return;
        }

        $scope.bulkID++;
        $scope.bulkFields.push({
          id: $scope.bulkID,
          name: null,
          username: null,
          email: null,
          password: '11111111',
          fieldName: 'name'+ $scope.bulkID,
          fieldUsername: 'username'+ $scope.bulkID,
          fieldEmail: 'email'+ $scope.bulkID,
          fieldPassword: 'password'+ $scope.bulkID,
          delete: true,
          success: false,
          error: false,
          errorMsg: null
        });
      },

      removeBulk: function(field) {
        for ( var i in $scope.bulkFields ) {
          var item = $scope.bulkFields[i];
          if ( item.id === field.id ) {
            $scope.bulkFields.splice($scope.bulkFields.indexOf(item), 1);
          }
        }
        $scope.totalAvailableAttendantRequests--;
        if ( $scope.totalAvailableAttendantRequests < 0 ){
          $scope.totalAvailableAttendantRequests = 0;
        }
      },

      handleRegisterBulk: function(){
        $scope.formSubmitted = true;
        var form = $scope.dataForm.form;

        var allUserRegistered = true;

        var bulkUsernames = $scope.bulkFields.map(function(item){ return item.username });

        var isDuplicate = bulkUsernames.some(function(item, idx){ 
          return bulkUsernames.indexOf(item) !== idx;
        });

        if ( isDuplicate ){
          Notification.error('Duplicate username found');
        } else {
          if ( form.$valid ){
            $scope.formLoading = true;
            for ( var i = 0; i < $scope.bulkFields.length; i++ ) {
              var field = $scope.bulkFields[i];
              var user = {
                type: 'sponsorAttendant',
                name: field.name,
                username: field.username,
                email: field.email,
                password: field.password
              };
              if (!field.success){
                $scope.sponsorAttendantRegisterCallback(field, user, i);
              }
            }

            for ( var i in $scope.bulkFields ){
              if ( !$scope.bulkFields[i].success ){
                allUserRegistered = false;
                break;
              }
            }

            if ( allUserRegistered ){
              $scope.formLoading = false;
              Notification.error('No new users to register');
            }
          }
        }
      },

      sponsorAttendantRegisterCallback: function(field, user, index){
        AuthService.onRegister(user)
          .then(function(){
            field.error = false;
            field.success = true;
            if ( (index + 1) == $scope.bulkFields.length ) {
              Notification.success('All users were successfully registered');
              $scope.formLoading = false;

              $scope.fetchAttendantRequests();
            }
          })
          .catch(function(err) {
            $scope.formLoading = false;
            field.error = true;
            field.errorMsg = err.data.message;
          });

      },

      onChangeItemsOf: function() {
        var total = $scope.attendantRequests.length;
        var itemsPerPage = $rootScope.currentEvent.preferences.itemsPerPage;
        var fd = (vm.currentPage - 1) * itemsPerPage + 1;
        var sd = (fd + (total < itemsPerPage ? total : itemsPerPage) - 1);
        var ss = (sd <= total ? sd : total);
        return fd+'-'+ss+' of '+total;
      },
    });

    $scope.$on('sponsorRequests', function(event, data) {
      $scope.myRequests = data;

      $scope.calcTotal(data);
    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('SpecialMapController', SpecialMapController)

  function SpecialMapController(
    $rootScope,
    $scope,
    $stateParams,
    Notification,

    MapService,
    CategoryService,
    BoothTypeService,

    IndoorService,
    OutdoorService,

    EventZone,
    RespZone,
    Route,
    Booth,

    IndoorZone,
    IndoorRoute,
    IndoorBooth,

    ToolsBooth
  ) {
    var vm = this;

    $scope.currentEvent = $rootScope.currentEvent;
    $scope.currentUser = $rootScope.currentUser;

    $scope.boothCategories = [];
    $scope.boothTypes = [];

    $scope.boothTypeIds = [];

    $scope.indoorMaps = [];

    angular.extend($scope, {
      showPosition: false,
      currentPosition: null,
      mapFields: {
        search: '',
        boothCategory: {}
      },
      onInit: function(){
        OutdoorService.resetOutdoorData();
        IndoorService.resetIndoorData();

        CategoryService.getCategories()
          .then(function(response){
            var data = response.data;
            if ( data && data.length ){
              for ( var i in data ){
                $scope.boothCategories.push({
                  type: 'Goods',
                  name: data[i].name,
                  value: data[i].id
                });
              }
            }
            return BoothTypeService.getBooths();
          })
          .then(function(response){
            $scope.boothTypes = response.data;

            $scope.checkMapID();
          });

      },

      checkMapID: function(){
        if ( typeof $stateParams.id !== 'undefined' ){
          $scope.fetchMap(parseInt($stateParams.id, 10));
        } else if ( typeof $stateParams.id === 'undefined' && $scope.currentEvent && $scope.currentEvent.mainEventMapId ){
          $scope.fetchMap($scope.currentEvent.mainEventMapId);
        } else {
          console.error('No map ID present');
        }
      },

      fetchMap: function(id){
        MapService.getMapByID(id)
          .then(function(response){
            var data = response.data;
            // console.log(data);
            if ( data.type === 'outdoor' ){
              // Only for outdoor
              $scope.renderOutdoorMapItems(function(){
                $scope.map = OutdoorService;
                $scope.map.initMap(data, null, 'users.special.indoorMap');
                $scope.initMapItems(data, $scope.map);

                if ($scope.showPosition && !$scope.currentPosition){
                  Notification.warning('Reload page and grant access for your location to use option "Show me on map"');
                }

                $scope.$watch('currentPosition', function(){
                  if ( $scope.currentPosition ) {
                    OutdoorService.showMeOnMapButton($scope.currentPosition);
                  }
                });
              });

            } else if ( data.type === 'indoor' ){
              $scope.map = IndoorService;
              $scope.map.initMap(data);
              $scope.initMapItems(data, $scope.map);
            } else {
              console.error('Map type not present');
            }
          })
          .catch(function(err){
            console.error(err);
          })
      },

      // Only for outdoor map
      renderOutdoorMapItems: function(cb){
        // Set navigator if is outdoor map
        $scope.showPosition = true;
        if ( navigator.geolocation ){
          navigator.geolocation.getCurrentPosition(function(position){
            $scope.$apply(function(){
              $scope.currentPosition = position;
            });
          });
        }

        MapService.getMaps(null, 'name,type,booths', 'indoor')
          .then(function(response){
            $scope.indoorMaps = response.data;
            cb();
          })
          .catch(function(err){
            console.error(err);
          });
      },

      initMapItems: function(data, map){
        $scope.mapData = data;

        var booths = [];
        var boothRouteIds = [];

        var contains = false;
        var groups = $scope.currentUser.groups;

        for ( var i = 0; i < groups.length; i++ ){
          var preferences = groups[i].preferences;
          if ( preferences && preferences.mapFullAccess ){
            contains = true;
            break;
          }
        }

        $scope.showOnlyMyBooths = ToolsBooth.getUserBooths(
          true, // onlyNonCommercial
          $scope.currentUser, // Current user
          data.booths, // booths
          $scope.boothTypes, // boothTypes
          $scope.indoorMaps.length ? $scope.indoorMaps : null, // Indoor maps
          null // requests
        ).length > 0;


        // Booth
        if ( data.booths ){
          if ( $scope.showOnlyMyBooths ){
            booths = ToolsBooth.getUserBooths(
              true, // onlyNonCommercial
              $scope.currentUser, // Current user
              data.booths, // booths
              $scope.boothTypes, // boothTypes
              $scope.indoorMaps.length ? $scope.indoorMaps : null, // Indoor maps
              null // requests
            );

            if ( booths.length ){
              for ( var i in booths ){
                var booth = booths[i];
                for ( var j in booth.routeIds ){
                  var routeID = booth.routeIds[j];
                  if ( boothRouteIds.indexOf(routeID) === -1 ){
                    boothRouteIds.push(routeID)
                  }
                }
              }
            }

            for ( var i in booths ){
              $scope.drawBooth(data.type, booths[i], map);
            }
          } else {
            booths = data.booths;
            for ( var i in booths ){
              $scope.drawBooth(data.type, booths[i], map);
            }
          }
        }

        // Routes
        if ( data.routes ){
          for ( var i in data.routes ){
            var route = data.routes[i];

            if ( !route.drawed ){
              if ( route.preferences && route.preferences.public ){
                $scope.drawRoute(data.type, route, map);
                continue;
              }
              if ( boothRouteIds.indexOf(route.id) !== -1 ){
                $scope.drawRoute(data.type, route, map);
                continue;
              }
            }
          }
        }

        // Contains
        if ( contains ){
          if ( data.responsibilityZones ){
            for ( var i in data.responsibilityZones ){
              var zoneData = data.responsibilityZones[i];
              var zone = data.type === 'outdoor' ? new RespZone() : new IndoorZone(false);
              zone.read(zoneData, false);
              map.drawEventZone(zone, false);
            }
          }
          if ( data.eventZones ){
            for ( var i in data.eventZones ){
              var zoneData = data.eventZones[i];
              var zone = data.type === 'outdoor' ? new EventZone(false) : new IndoorZone(false);
              zone.read(zoneData, false);
              map.drawEventZone(zone, false);
            }
          }
        }

        if ( $scope.boothTypeIds.length ){
          if ( $scope.boothTypes && $scope.boothTypes.length ){
            for ( var i in $scope.boothTypes ){
              var item = $scope.boothTypes[i];
              if ( item.preferences && !item.preferences['private'] ){
                if ( $scope.boothTypeIds.indexOf(item.id) !== -1 ){
                  $scope.boothCategories.push({
                    type: 'Services',
                    name: item.type,
                    value: item.id
                  });
                }
              }
            }
          }
        }

        $scope.booths = map.fetchBooths();
      },

      drawBooth: function(mapType, boothData, map){
        var draw = true;
        if ( $scope.boothTypes && $scope.boothTypes.length ){
          for ( var i in $scope.boothTypes ){
            var type = $scope.boothTypes[i];
            var pref = type.preferences;
            if ( boothData.boothTypeId === type.id ){
              if (
                ToolsBooth.nonCommercialBoothBelongToUser(
                  boothData,
                  $scope.currentUser.id,
                  $scope.currentUser.type,
                  $scope.indoorMaps.length ? $scope.indoorMaps : null
                )
              ){
                break;
              } else if ((pref && pref.private) || type.commercial) {
                draw = false;
                break;
              }
            }
          }
        }
        if ( draw ) {
          var booth = mapType === 'outdoor' ? new Booth(false, true) : new IndoorBooth(false, true);
          booth.read(boothData);
          map.drawBooth(booth, false);
        }
      },

      drawRoute: function(type, routeData, map){
        var route = type === 'outdoor' ? new Route(true) : new IndoorRoute();
        route['drawed'] = true;
        route.read(routeData);
        map.drawRoute(route, false);
      },

      handleShowOnlyMyBooths: function(){
        $scope.map.clearBooths();

        if ( $scope.mapData.booths ) {
          var booths = null;
          if ( $scope.showOnlyMyBooths ) {
            booths = ToolsBooth.getUserBooths(
              false, // onlyNonCommercial
              $scope.currentUser, // Current user
              $scope.mapData.booths, // booths
              $scope.boothTypes, // boothTypes
              $scope.indoorMaps.length ? $scope.indoorMaps : null, // Indoor maps
              $scope.userCommercialAssignments // requests
            );
            // var bounds = new google.maps.LatLngBounds();

            for ( var i in booths ) {
              $scope.drawBooth($scope.mapData.type, booths[i], $scope.map);
              // var bNext = booths[j];

              // var position = bNext.position;
              // var latLng = new google.maps.LatLng(position.lat, position.lng);

              // $scope.addBooth(bNext);

              // bounds.extend(latLng);
              // map.fitBounds(bounds);
            }
          } else {
            for ( var i in $scope.mapData.booths ) {
              $scope.drawBooth($scope.mapData.type, $scope.mapData.booths[i], $scope.map);
              // var booth = data.booths[i];
              // $scope.addBooth(booth);

              // map.setCenter(mapLatLng);
              // map.setZoom(mapZoom);
            }
          }
        }
      }

    }); // End angular.extend $scope

    $scope.foundBooths = [];
    $scope.foundIndoorBooths = [];
    $scope.indoorQuery = '';

    // Search booths
    $scope.handleMapSearch = function(newVal){
      $scope.foundBooths = [];
      $scope.foundIndoorBooths = [];

      $scope.indoorQuery = '';

      var search = newVal.search;
      var boothCategory = newVal.boothCategory;

      if (
        search.length === 0 &&
        (
          boothCategory === null || (boothCategory && typeof boothCategory.type === 'undefined')
        )
      ) {
        for ( var i in $scope.booths ){
          $scope.booths[i].show();
        }
      } else {
        // var resultCommercial = commercialSearch($scope.userCommercialAssignments, search, boothCategory);
        var resultNonCommercial = nonCommercialSearch($scope.booths, search, boothCategory);
        // var resultNonCommercialIndoor = nonCommercialSearch($scope.indoorBooths, search, boothCategory);

        for ( var i in $scope.booths ){
          var booth = $scope.booths[i];
          if (
            // hasSome(resultCommercial, ToolsBooth.requestsForBooth($scope.userCommercialAssignments, booth)) ||
            resultNonCommercial.indexOf(booth) !== -1
          ){
            booth.show();
            $scope.foundBooths.push(booth);

            // bounds.extend(booth.position);
            // map.fitBounds(bounds);
          } else {
            booth.hide();
          }
        }

        // Check in indoor maps booths
        // console.log($scope.indoorBooths);
        // if ( $scope.indoorBooths.length ){
        //   for ( var i in $scope.indoorBooths ){
        //     var booth = $scope.indoorBooths[i];
        //     if (
        //       hasSome(resultCommercial, ToolsBooth.requestsForBooth($scope.userCommercialAssignments, booth)) ||
        //       resultNonCommercialIndoor.indexOf(booth) !== -1
        //     ){
        //       $scope.indoorQuery = search;
        //       for ( var i in $scope.indoorMaps ){
        //         var indoor = $scope.indoorMaps[i];
        //         if ( booth.boothMapID === indoor.id ){
        //           if ( $scope.foundIndoorBooths.indexOf(indoor) === -1 ){
        //             $scope.foundIndoorBooths.push(indoor);
        //           }
        //         }
        //       }
        //     }
        //   }
        // }

        // console.log($scope.foundIndoorBooths);
      }

      // $scope.$apply();
    }

    function hasSome(filtered, requests){
      var result = false;
      if (
        filtered && filtered.length &&
        requests && requests.length
      ){
        for ( var i in requests ){
          var request = requests[i];
          if ( filtered.indexOf(request) !== -1 ){
            result = true;
          }
        }
      }
      return result;
    }

    // NonCommercial
    function nonCommercialSearch(booths, search, type){
      var result = [];
      if ( search.length !== 0 || (type !== null && typeof type.type !== 'undefined') ){
        var s = search.toLowerCase();
        for ( var i in booths ){
          var booth = booths[i];
          var matchSearch = !s || (
            ( booth.description && booth.description.toLowerCase().indexOf(s) > -1 )
          );
          var matchType = typeof type.type === 'undefined' || (
            ( type.type === 'Services' && booth.boothTypeId === type.value )
          );
          if ( matchSearch && matchType ){
            result.push(booth);
          }
        }
        return result;
      }
      return result;
    }
    // Commercial
    function commercialSearch(requests, search, type){
      var result = [];
      if ( search.length !== 0 || (type !== null && typeof type.type !== 'undefined') ){
        var s = search.toLowerCase();
        for ( var i in requests ){
          var request = requests[i];
          var matchSearch = !s || (
            ( request.description && request.description.toLowerCase().indexOf(s) > -1 ) ||
            ( request.individualFeaturedItems && request.individualFeaturedItems.toLowerCase().indexOf(s) > -1 ) ||
            ( request.user.name.toLowerCase().indexOf(s) > -1 ) ||
            ( request.user.description && request.user.description.toLowerCase().indexOf(s) > -1 )
          );
          var matchType = typeof type.type === 'undefined' || (
            type.type === 'Goods' && request.goodsCategory &&
            type.name.toLowerCase() === request.goodsCategory.name.toLowerCase()
          );
          if ( matchSearch && matchType ) {
            result.push(request);
          }
        }
        return result;
      }
      return result;
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('SpecialMessagesFormController', SpecialMessagesFormController);
  
  SpecialMessagesFormController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    'moment',
    'Notification',
    'UserGroupsService',
    'MessagesService'
  ];

  function SpecialMessagesFormController(
    $rootScope,
    $scope,
    $state,
    moment,
    Notification,
    __groups,
    __messages
  ) {
    var vm = this;
    vm.messageBodyRequired = true;
    vm.allowBulkMailSend = false;
    vm.message = {
      body: null,
      sendToEmail: false,
      sendToSms: false
    };

    angular.extend($scope, {
      searchType: 'vendor,volunteer,special,volunteerCoordinator,eventCoordinator,eo',
      userTypes: [
        { type: '', name: 'Choose type' },
        { type: 'all', name: 'All' },
        { type: 'vendors', name: $rootScope.currentEvent.preferences.vendorModule.label },
        { type: 'volunteers', name: $rootScope.currentEvent.preferences.volunteerModule.label }
      ],
      userSelectors: [
        { type: '', name: 'Choose selector' },
        { type: 'all', name: 'All' },
        { type: 'accepted', name: 'Accepted' },
        { type: 'idle', name: 'Idle' }
      ],
      taToolbar: [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'fontColor'],
        ['bold', 'italics', 'underline', 'strikeThrough'],
        ['ul', 'ol'],
        ['redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
        ['html', 'insertImage','insertLink']
      ]
    })

    angular.extend($scope, {
      onInit: function() {
        vm.event = $rootScope.currentEvent;
        vm.participantModule = $rootScope.currentEvent.preferences.participantModule;
        vm.sponsorModule = $rootScope.currentEvent.preferences.sponsorModule;

        var groups = $rootScope.currentUser.groups;

        if ( groups.length !== 0 ) {
          for ( var i = 0; i < groups.length; i++ ) {
            var preferences = groups[i].preferences;
            if ( preferences && preferences.allowBulkMailSend ) {
              vm.allowBulkMailSend = true;
              break;
            }
          }
        }

        if ( vm.event.modules.indexOf('participant') > -1 ) {
          $scope.searchType += ',participant';
          $scope.userTypes.push({
            type: 'participants',
            name: vm.participantModule.label
          });
        }

        if ( vm.event.modules.indexOf('sponsor') > -1 ) {
          $scope.searchType += ',sponsor';
          $scope.userTypes.push({
            type: 'sponsors',
            name: vm.sponsorModule.label
          });
        }

        __groups.getGroups()
          .then(
            function(response) {
              vm.userGroups = [];

              angular.forEach(response.data, function(item){
                var exist = groups.filter(function(group){
                  return group.id === item.id;
                })[0];

                if ( exist && exist.preferences && exist.preferences.allowSendMessages ) {
                  vm.userGroups.push(exist);
                }
              });
            },
            $scope.handleError
          );
      },

      onShortText: function(txt) {
        if ( vm.message.sendToSms ) {
          if ( txt ) {
            if ( !vm.message.subject ) {
              vm.message.subject = txt;
            }
            if ( !vm.message.body ) {
              vm.message.body = txt;
            }
          }
        }
      },

      onBlurBody: function(body){
        vm.messageBodyRequired = typeof body !== 'undefined' ? false : true;
      },

      onChangeUser: function() {
        vm.message.recipientAliases = [];
        if ( vm.userType && vm.userSelector ) {
          var type = vm.userType.toLowerCase();
          var selector = vm.userSelector.toLowerCase();
          if ( type === 'all') {
            if ( selector === 'all' ) {
              vm.message.recipientAliases = [
                'all_vendors',
                'all_volunteers'
              ];
              if ( vm.event.modules.indexOf('participant') > -1 ) {
                vm.message.recipientAliases.push('all_participants');
              }
            }
            if ( selector === 'accepted' ) {
              vm.message.recipientAliases = [
                'all_accepted_vendors',
                'all_accepted_volunteers'
              ];
              if ( vm.event.modules.indexOf('participant') > -1 ) {
                vm.message.recipientAliases.push('all_accepted_participants');
              }
            }
            if ( selector === 'idle' ) {
              vm.message.recipientAliases = [
                'all_idle_vendors',
                'all_idle_volunteers'
              ];
              if ( vm.event.modules.indexOf('participant') > -1 ) {
                vm.message.recipientAliases.push('all_idle_participants');
              }
            }
          }
          if ( type === 'vendors' ) {
            vm.message.recipientAliases.push(selector === 'all' ? 'all_'+ type : 'all_'+ selector +'_'+ type);
          }
          if ( type === 'volunteers' ) {
            vm.message.recipientAliases.push(selector === 'all' ? 'all_'+ type : 'all_'+ selector +'_'+ type);
          }
          if ( type === 'participants' ) {
            vm.message.recipientAliases.push(selector === 'all' ? 'all_'+ type : 'all_'+ selector +'_'+ type);
          }
        }
      },

      handleSubmit: function() {
        var form = $scope.form;
        if ( form.$valid ) {
          $rootScope.loadingInformation = true;
          // if ( vm.recipientGroupIds ) {
          //   angular.forEach(vm.recipientGroupIds, function(item){
          //     vm.message.recipientGroupIds.push(item.id);
          //   });
          // }
          if (
            vm.message.recipientGroupIds.length ||
            vm.message.recipientAliases.length
          ) {
            vm.message.sendToApp = true;
            __messages.sentMessage(vm.message)
              .then(
                function(){
                  $rootScope.loadingInformation = false;
                  Notification.success('Message was sent');
                  $scope.onClose();
                },
                $scope.handleError
              );
          } else {
            $rootScope.loadingInformation = false;
            Notification.error('No recipient(s) selected');
          }
        }
      },

      onClose: function() {
        $state.go('users.special.messages.inbox');
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('SpecialMessagesController', SpecialMessagesController);
  
  SpecialMessagesController.$inject = [
    '$rootScope',
    '$scope',
    'MessagesService'
  ];

  function SpecialMessagesController(
    $rootScope,
    $scope,
    __messages
  ) {
    var vm = this;
    vm.allowSendMessages = false;

    angular.extend($scope, {
      _:_
    });

    angular.extend($scope, {
      onInit: function() {
        var groups = $rootScope.currentUser.groups;

        if ( groups.length !== 0 ) {
          for ( var i = 0; i < groups.length; i++ ) {
            var preferences = groups[i].preferences;
            if ( preferences && preferences.allowSendMessages ) {
              vm.allowSendMessages = true;
              break;
            }
          }
        }
      }
    });
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantScavengerHunt', ParticipantScavengerHunt);
  
  ParticipantScavengerHunt.$inject = [
    '$scope',
    '$document',
    'ScavengerHuntService',
    'ApproveService',
    'Notification'
  ];
  
  function ParticipantScavengerHunt(
    $scope,
    $document,
    ScavengerHuntService,
    ApproveService,
    Notification
  ) {
    var vm = this;
    $scope.points = [];

    $scope.formLoading = false;

    $scope.checkInCode = null;
    $scope.lat = null;
    $scope.lng = null;

    var infowindow = new google.maps.InfoWindow();
    var bounds = new google.maps.LatLngBounds();
    var map;
    var poly;
    var markers = [];

    var alreadyShown = false;

    var directionIcons = [
      {label: 'By Car', icon: 'fa fa-car', mode: 'driving'},
      {label: 'Bike', icon: 'fa fa-bicycle', mode: 'bicycling'},
      {label: 'Walking', icon: 'fa fa-male', mode: 'walking'}
    ];

    angular.extend($scope, {
      onInit: function(){
        $scope.getLocation();
        
        ScavengerHuntService.getPoints()
          .then(function(response){
            var data = response.data;

            $scope.checkinPoints = response.data;

            $scope.buildMap(data);

            return ScavengerHuntService.getMy();
          })
          .then(function(response){
            $scope.points = response.data;
          })

      },

      getLocation: function(cb, err){
        if ( navigator.geolocation ){
          navigator.geolocation.getCurrentPosition(function(position){
            $scope.lat = position.coords.latitude;
            $scope.lng = position.coords.longitude;
            if ( cb ) cb();
          }, function(err){
            showError(err);
            if ( err ) err();
          });
        } else {
          Notification.error('Geolocation is not supported by this browser.');
          $scope.formLoading = false;
        }
      },

      buildMap: function(points){
        var mapSelector = $document[0].querySelector('#scavengerHuntMap');

        var lat = 27.942749279781406;
        var lng = -82.45903329675298;

        var center = {
          lat: $scope.lat ? $scope.lat : lat,
          lng: $scope.lng ? $scope.lng : lng
        };

        map = new google.maps.Map(mapSelector, {
          zoom: 16,
          maxZoom: 20,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          clickableIcons: false,
          streetViewControl: false,
          fullscreenControl: true,
          center: center,
          gestureHandling: 'greedy',
          styles: [
            {
              featureType: 'poi',
              stylers: [
                { visibility: 'off' }
              ],
            },{
              featureType: 'transit',
              stylers: [
                { visibility: 'off' }
              ]
            }
          ]
        });

        // poly = new google.maps.Polyline({
        //   strokeColor: '#FF0000',
        //   strokeOpacity: 1.0,
        //   strokeWeight: 2,
        //   icons: [{
        //     icon: {
        //       path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        //     },
        //     offset: '100%',
        //     repeat: '100px'
        //   }],
        // });

        if ( points.length ){
          points.sort(function(a, b){ return a.order - b.order; });
          $scope.buildPoint(map, points);
        }
      },

      buildPoint: function(map, points){
        var polyCoordinates = [];

        for ( var i = 0; i < points.length; i++ ){
          var point = points[i];

          // polyCoordinates.push({
          //   lat: point.lat,
          //   lng: point.lng
          // });

          var marker = new google.maps.Marker();
          var latLng = new google.maps.LatLng(point.lat, point.lng);
          marker.setPosition(latLng)
          marker.setMap(map);

          markers.push(marker);

          marker.infowindow = new google.maps.InfoWindow();
          var pointInfoPopupContent = '<div class="infowindow-sh-content"><h4 class="_name">'+ point.name +'</h4>';
          if(point.description){
            pointInfoPopupContent += ('<span class="_description">'+point.description+'</p>').replace(/\n/g, '<br />');
          }

        var directionsMarkup = '<ul class="list-directionIcons">'
        
        for ( var j in directionIcons ){
          var item = directionIcons[j];

          directionsMarkup+='<li><a href="'+ 'https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination='+ 
            point.lat + ','+ point.lng +'&travelmode='+ item.mode + '" target="_blank">';
          directionsMarkup+='<i class="'+item.icon+'" "aria-hidden"="true"></i>';
          directionsMarkup+='<span>'+item.label+'</span>';
          directionsMarkup+='</a></li>';
        }
          directionsMarkup+='</ul>';
          pointInfoPopupContent+=directionsMarkup;
          pointInfoPopupContent+='</div>';
          marker.infowindow.setContent(pointInfoPopupContent);
          //marker.infowindow.open(map, marker);

          bounds.extend(latLng);

          google.maps.event.addListener(marker, 'click', (function(marker, point){
            return function() {
              if(this.infowindow){
                this.infowindow.close();
                this.infowindow.open(map, this);
              }
            }
          })(marker, point));

          map.fitBounds(bounds);
        }

        // poly.setPath(polyCoordinates);
        // poly.setMap(map);
      },

      onSubmit: function(){
        var form = $scope.form;

        if ( form.$invalid ) return;

        $scope.formLoading = true;

        var data = {
          code: $scope.checkInCode
        };

        $scope.getLocation(function(){
          data['lat'] = $scope.lat;
          data['lng'] = $scope.lng;

          ScavengerHuntService.createCheckin(data)
            .then(function(response){
              updatePoint(response.data);
              $scope.formLoading = false;

              $scope.resetForm();

              Notification.success('Checked-in at '+ response.data.pointName);
            })
            .catch(function(err){
              if ( err.data.message === 'Check-in point location out of range' ){
                ApproveService(
                  'Check-in point location out of range. Check-in anyway ?',
                  'Yes',
                  function(){
                    data['skipGeoValidation'] = true;
                    return ScavengerHuntService.createCheckin(data)
                  },
                  'No'
                ).result.then(
                  function(result){
                    updatePoint(result.data);
                    $scope.formLoading = false;

                    $scope.resetForm();

                    Notification.success('Checked-in at '+ result.data.pointName);
                  },
                  function(err){
                    if ( err && err.data ){
                      Notification.error(err.data.message);
                    }
                    $scope.formLoading = false;
                  }
                );
              } else {
                Notification.error(err.data.message);
                $scope.formLoading = false;
              }
            });
        }, function(){
          ApproveService(
            'Location information is unavailable. Check-in anyway ?',
            'Yes',
            function(){
              data['lat'] = 0;
              data['lng'] = 0;
              data['skipGeoValidation'] = true;
              return ScavengerHuntService.createCheckin(data)
            },
            'No'
          ).result.then(
            function(result){
              updatePoint(result.data);
              $scope.formLoading = false;

              $scope.resetForm();

              Notification.success('Checked-in at '+ result.data.pointName);
            },
            function(err){
              if ( err && err.data ){
                Notification.error(err.data.message);
              }
              $scope.formLoading = false;
            }
          );
        });
      },

      resetForm: function(){
        $scope.checkInCode = null;
        $scope.form.$setPristine();
      }
    });

    function updatePoint(point){
      var p = $scope.points.find(function(item){
        return item.id === point.id;
      });
      if ( !p ){
        $scope.points.push(point);
      } else {
        $scope.points = $scope.points.map(function(item){
          if ( item.id === point.id ){
            item = point;
          }
          return item;
        });
      }
    }

    function showError(error) {
      switch(error.code) {
        case error.PERMISSION_DENIED:
          !alreadyShown && Notification.error('Can`t access your geo-location');
          break;
        case error.POSITION_UNAVAILABLE:
          !alreadyShown && Notification.error('Location information is unavailable.');
          break;
        case error.TIMEOUT:
          !alreadyShown && Notification.error('The request to get user location timed out.');
          break;
        case error.UNKNOWN_ERROR:
          !alreadyShown && Notification.error('An unknown error occurred.');
          break;
      }
      alreadyShown = true;
      $scope.formLoading = false;
      $scope.$apply();
    }
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantReservationController', ParticipantReservationController);
  
  ParticipantReservationController.$inject = [
    '$scope',
    '$uibModal',
    'RequestReservationService'
  ];
  
  function ParticipantReservationController(
    $scope,
    $uibModal,
    RequestReservationService
  ) {
    var vm = this;

    $scope.myReservations = [];

    angular.extend($scope, {
      onInit: function() {

        RequestReservationService.getMyReservationRequests()
          .then(function(response){
            ;
            $scope.myReservations = response.data;
          })
          .catch(function(err){
            console.error(err);
          });

      },

      showEventPass: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            templateUrl: 'app/users/participant/ep-reservation/ep-reservation.html',
            controller: 'ParticipantEventPassReservationController',
            controllerAs: 'vm',
            size: 'md',
            windowClass: 'modal-event-pass-participant',
            resolve: {
              participantRequest: function(){
                return request;
              }
            }
          });
          modal.result
            .then(
              function(result){
                // console.log(result);
              },
              function(result) {
                // console.log(result);
                for ( var i in vm.myReservations ){
                  var rq = vm.myReservations[i];
                  if ( rq.id === result.id ){
                    var idx = vm.myReservations.indexOf(rq);
                    vm.myReservations[idx] = result;
                  }
                }
              }
            );
        }
      }
    });

    $scope.toMonth = function(date){
      return moment(moment.utc(date)).local().format('MMMM DD HH:mm');
    }

    $scope.toHours = function(time){
      return moment(moment.utc(time)).local().format('HH:mm')
    }
  }
})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('ParticipantMapController', ParticipantMapController)

  function ParticipantMapController(
    $rootScope,
    $scope,
    $stateParams,
    $uibModal,
    Notification,

    OutdoorService,
    IndoorService,

    ParticipantService,
    BoothTypeService,
    MapService,

    Route,
    Booth,
    EventZone,

    IndoorRoute,
    IndoorBooth,
    IndoorZone,

    ToolsBooth
  ) {
    var vm = this;
    $scope.currentEvent = $rootScope.currentEvent;
    $scope.currentUser = $rootScope.currentUser;

    $scope.userCommercialAssignments = [];

    $scope.boothTypes = [];

    $scope.indoorMaps = [];

    angular.extend($scope, {
      onInit: function(){
        OutdoorService.resetOutdoorData();
        IndoorService.resetIndoorData();

        ParticipantService.getMyRequests()
          .then(function(response){
            var data = response.data;
            for ( var i in data ){
              var item = data[i];
              // Commercial Assignments
              var user = item.participant;
              user['type'] = 'participant';
              delete item['participant'];
              $scope.userCommercialAssignments.push($.extend({}, item, {
                user: user
              }));
            }
            return BoothTypeService.getBooths();
          })
          .then(function(response){
            $scope.boothTypes = response.data;

            $scope.checkMapID();
          })
          .catch(function(err){
            console.error(err);
          });
      },

      handleShowAvailable: function(){
        if ( !$scope.getAvailable ){
          $uibModal.open({
            templateUrl: 'app/public-map/available-booth.html',
            controller: 'AvailableBoothsController as vm',
            resolve: {
              resolveEventMapId: function(){
                return $scope.eventMapId;
              },
              resolveAvailable: function(){
                return null;
              }
            }
          }).result.then(
            function(result){
              $scope.getAvailable = true;

              $scope.filterBooths(result);
            },
            function(err){
              console.log(err);
            }
          )
        } else {
          $scope.getAvailable = false;
          $scope.availableBoothIds = [];
          for ( var i in $scope.booths ){
            $scope.booths[i].show();
            $scope.booths[i].availableFrom = null;
            $scope.booths[i].availableTo = null;
          }

          $scope.handleShowOnlyMyBooths();
        }
      },

      handleEditAvailable: function(){
        $uibModal.open({
          templateUrl: 'app/public-map/available-booth.html',
          controller: 'AvailableBoothsController as vm',
          resolve: {
            resolveEventMapId: function(){
              return $scope.eventMapId;
            },
            resolveAvailable: function(){
              return {
                from: $scope.availableFrom,
                to: $scope.availableTo
              }
            }
          }
        }).result.then(
          function(result){
            $scope.filterBooths(result);
          },
          function(err){
            console.log(err);
          }
        )
      },

      availableBoothIds: [],

      filterBooths: function(result){
        $scope.availableBoothIds = result.data;

        for ( var i in $scope.booths ){
          var booth = $scope.booths[i];
          booth.availableFrom = moment(result.availableFrom).format('MM-DD-YYYY');
          booth.availableTo = moment(result.availableTo).format('MM-DD-YYYY');
          if ( result.data.indexOf(booth.id) !== -1 ){
            var exist = false;
            if ( $scope.showOnlyMyBooths ){
              if ( $scope.myBoothIds.indexOf(booth.id) !== -1 ){
                exist = true;
              }
            } else {
              exist = true;
            }
            if ( exist ){
              booth.show();
            }
          } else {
            booth.hide();
          }
        }

        $scope.availableFrom = result.availableFrom;
        $scope.availableTo = result.availableTo;
      },

      checkMapID: function(){
        if ( typeof $stateParams.id !== 'undefined' ){
          $scope.fetchMap(parseInt($stateParams.id, 10));
        } else if ( typeof $stateParams.id === 'undefined' && $scope.currentEvent && $scope.currentEvent.mainEventMapId ){
          $scope.fetchMap($scope.currentEvent.mainEventMapId);
        } else {
          console.error('No map ID present');
        }
      },

      eventMapId: null,

      fetchMap: function(id){
        $scope.eventMapId = id;
        MapService.getMapByID(id)
          .then(function(response){
            var data = response.data;
            // console.log(data);
            if ( data.type === 'outdoor' ){
              // Only for outdoor
              $scope.renderOutdoorMapItems(function(){
                $scope.map = OutdoorService;
                $scope.map.initMap(data, null, 'users.participant.indoorMap');
                $scope.initMapItems(data, $scope.map);

                if ($scope.showPosition && !$scope.currentPosition){
                  Notification.warning('Reload page and grant access for your location to use option "Show me on map"');
                }

                $scope.$watch('currentPosition', function(){
                  if ( $scope.currentPosition ) {
                    OutdoorService.showMeOnMapButton($scope.currentPosition);
                  }
                });
              });
            } else if ( data.type === 'indoor' ){
              $scope.map = IndoorService;
              $scope.map.initMap(data);
              $scope.initMapItems(data, $scope.map);
            } else {
              console.error('Map type not present');
            }
          })
          .catch(function(err){
            console.error(err);
          })
      },

      // Only for outdoor map
      renderOutdoorMapItems: function(cb){
        // Set navigator if is outdoor map
        $scope.showPosition = true;
        if ( navigator.geolocation ){
          navigator.geolocation.getCurrentPosition(function(position){
            $scope.$apply(function(){
              $scope.currentPosition = position;
            });
          });
        }

        MapService.getMaps(null, 'name,booths', 'indoor')
          .then(function(response){
            $scope.indoorMaps = response.data;

            cb();
          })
          .catch(function(err){
            console.error('err');
          });
      },


      initMapItems: function(data, map){
        $scope.mapData = data;

        var booths = [];
        var boothRouteIds = [];

        var myBooths = ToolsBooth.getUserBooths(
          false, // onlyNonCommercial
          $scope.currentUser, // Current user
          data.booths, // booths
          $scope.boothTypes, // boothTypes
          $scope.indoorMaps.length ? $scope.indoorMaps : null, // Indoor maps
          $scope.userCommercialAssignments // requests
        );
        $scope.myBoothIds = myBooths.map(function(item){ return item.id });
        $scope.showOnlyMyBooths = myBooths.length > 0;

        // Booths
        if ( data.booths ) {
          if ( $scope.showOnlyMyBooths ) {
            var bounds;
            if ( data.type === 'outdoor' ) bounds = new google.maps.LatLngBounds();

            if ( myBooths.length ){
              for ( var i in myBooths ){
                var booth = myBooths[i];
                for ( var j in booth.routeIds ){
                  var routeID = booth.routeIds[j];
                  if ( boothRouteIds.indexOf(routeID) === -1 ){
                    boothRouteIds.push(routeID)
                  }
                }
              }
            }

            for ( var i in data.booths ){
              var booth = data.booths[i];
              if ( myBooths.indexOf(booth) !== -1 ){
                booth.withHide = false;
                if ( data.type === 'outdoor' ){
                  var latLng;
                  if ( booth.position ){
                    latLng = new google.maps.LatLng(booth.position.lat, booth.position.lng);
                    bounds.extend(latLng);
                  } else {
                    if ( booth.preferences.coordinates.length ){
                      for ( var j in booth.preferences.coordinates ){
                        var coord = booth.preferences.coordinates[j];
                        latLng = new google.maps.LatLng(coord.lat, coord.lng);
                        bounds.extend(latLng);
                      }
                    }
                  }
                  map.getMap().fitBounds(bounds);
                }
              } else {
                booth.withHide = true;
              }
              $scope.drawBooth(data.type, booth, map);
            }

            if ( data.eventZones ){
              for ( var i in data.eventZones ) {
                var zone = data.eventZones[i];
    
                if ( booths.length ){
                  for ( var j in booths ){
                    var booth = booths[j];
                    if ( booth.zoneId === zone.id ){
                      $scope.drawEventZone(data.type, zone, map);
                    }
                  }
                }
              }
            }
          } else {
            for ( var i in data.booths ) {
              $scope.drawBooth(data.type, data.booths[i], map);
            }
          }
        }

        // Routes
        if ( data.routes ){
          for ( var i in data.routes ){
            var route = data.routes[i];

            if ( !route.drawed ){
              if ( boothRouteIds.indexOf(route.id) !== -1 && $scope.showOnlyMyBooths ){
                $scope.drawRoute(data.type, route, map);
                continue;
              }
            }
          }
        }

        $scope.booths = map.fetchBooths();
      },

      drawBooth: function(mapType, boothData, map){
        var draw = false;

        if (
          $scope.currentEvent.status === 'published' &&
          boothData.preferences && boothData.preferences.boothReservation
        ){
          draw = true;
        }

        if ( !draw ){
          if ( $scope.boothTypes && $scope.boothTypes.length ){
            for ( var i in $scope.boothTypes ){
              var type = $scope.boothTypes[i];
              var pref = type.preferences;
              if ( boothData.boothTypeId === type.id ){
                if (
                  ToolsBooth.boothBelongToUser(
                    boothData,
                    $scope.userCommercialAssignments,
                    $scope.currentUser.id,
                    $scope.currentUser.type,
                    $scope.indoorMaps.length ? $scope.indoorMaps: null
                  )
                ){
                  draw = true;
                  break;
                } else if ((pref && pref.private) || type.commercial || !type.commercial) {
                  draw = false;
                  break;
                }
              }
            }
          }
        }

        if ( draw ) {
          var booth = mapType === 'outdoor' ? new Booth(false, true) : new IndoorBooth(false, true);
          booth.read(boothData, $scope.boothTypes);
          map.drawBooth(booth, false);
        }
      },

      drawRoute: function(type, routeData, map){
        var route = type === 'outdoor' ? new Route(true) : new IndoorRoute();
        route['drawed'] = true;
        route.read(routeData);
        map.drawRoute(route, false);
      },

      drawEventZone: function(mapType, zoneData, map){
        var zone = mapType === 'outdoor' ? new EventZone(false) : new IndoorZone(false);
        zone.read(zoneData, false);
        map.drawEventZone(zone, false);
      },

      handleShowOnlyMyBooths: function(){
        if ( $scope.showOnlyMyBooths ) {
          var bounds;
          if ( $scope.mapData.type === 'outdoor' ) bounds = new google.maps.LatLngBounds();

          for ( var i in $scope.booths ){
            var booth = $scope.booths[i];
            if (
              $scope.myBoothIds.indexOf(booth.id) !== -1
            ){
              var exist = false;

              if ( $scope.getAvailable ){
                if ( $scope.availableBoothIds.indexOf(booth.id) !== -1 ){
                  exist = true;
                }
              } else {
                exist = true;
              }

              if ( exist ){
                if ( $scope.mapData.type === 'outdoor' ){
                  var latLng;
                  if ( booth.position ){
                    bounds.extend(booth.position);
                  } else {
                    if ( booth.preferences.coordinates.length ){
                      for ( var j in booth.preferences.coordinates ){
                        var coord = booth.preferences.coordinates[j];
                        latLng = new google.maps.LatLng(coord.lat, coord.lng);
                        bounds.extend(latLng);
                      }
                    }
                  }
                  $scope.map.getMap().fitBounds(bounds);
                }
              }
            } else {
              booth.hide();
            }
          }

          if ( !$scope.myBoothIds.length ){
            $scope.map.getMap().setCenter($scope.map.getCenter());
            $scope.map.getMap().setZoom($scope.map.getZoom());
          }
        } else {
          for ( var i in $scope.booths ){
            var booth = $scope.booths[i];
            if ( $scope.getAvailable ){
              if ( $scope.availableBoothIds.indexOf(booth.id) !== -1 ){
                booth.show();
              }
            } else {
              booth.show();
            }
            if ( $scope.mapData.type === 'outdoor' ){
              $scope.map.getMap().setCenter($scope.map.getCenter());
              $scope.map.getMap().setZoom($scope.map.getZoom());
            }
          }
        }
      }
    });
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantMyTeamController', ParticipantMyTeamController);
  
  ParticipantMyTeamController.$inject = [
    '$scope',
    'TeamService'
  ];
  
  function ParticipantMyTeamController(
    $scope,
    __team
  ) {
    var vm = this;
    vm.myTeams = __team.myTeams();

    angular.extend($scope, {
      onInit: function() {},
      getMyTeamMembers: function(team) {
        if ( team && team.id ) {
          __team.getMyTeamMembers(team.id)
            .then(
              function(response) {
                var data = response.data;
                vm.myTeams = vm.myTeams.map(function(item) {
                  if ( item.id === team.id ) {
                    return $.extend({}, item, {
                      members: data && data.length !== 0 ? data : []
                    });
                  } else {
                    return item;
                  }
                });
              },
              function(err) {
                console.error(err);
              }
            );
        }
      }
    });
  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantMessagesController', ParticipantMessagesController);
  
  ParticipantMessagesController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    '$location',
    'Notification',
    'MessagesService'
  ];
  
  function ParticipantMessagesController(
    $rootScope,
    $scope,
    $uibModal,
    $location,
    Notification,
    __messages
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
      },
      openModalMessage: function(){
        var modal = $uibModal.open({
          templateUrl: 'app/users/messages/modal/modal.html',
          controller: 'MessageModalController',
          controllerAs: 'vm',
          resolve: {
            $message: function(){
              return false;
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              $rootScope.loadingInformation = true;
              __messages.sentMessageBackOffice(resolve)
                .then(
                  function(response){
                    $rootScope.loadingInformation = false;
                    Notification.success('Message was sent');
                    if ( $location.$$path.indexOf('/messages/sent') !== -1 ){
                      __messages.add(response.data);
                    }
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(){
              console.log('Dissmissed');
            }
          );
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantEventController', ParticipantEventController);
  
  ParticipantEventController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    '$location',
    '$interval',
    '$window',
    'moment',
    'Notification',
    'EventService',
    'PageService',
    'PriceService',
    'ParticipantService',
    'SponsorService',
    'TransactionService',
    'PaymentService'
  ];
  
  function ParticipantEventController(
    $rootScope,
    $scope,
    $uibModal,
    $location,
    $interval,
    $window,
    moment,
    Notification,
    __event,
    PageService,
    __price,
    __participant,
    __sponsor,
    __transaction,
    PaymentService
  ) {
    var vm = this;
    vm.sponsorsHeadline = [];
    vm.sponsorsSecondary = [];

    vm.loadingBuy = false;
    vm.loadingCash = false;
    vm.pricePackages = [];

    vm.invitedParticipants = [];
    // vm.invitePackages = [];
    vm.inviteID = 1;
    vm.participantRequestNotes = null;

    vm.isSameDate = false;

    $scope.showInfopanel = false;
    // $scope.nextRequestTotal = 0;

    angular.extend($scope, {
      moment: moment,
      pricePackages: []
    });

    angular.extend($scope, {
      onInit: function() {
        vm.currentUser = $rootScope.currentUser;
        vm.event = $rootScope.currentEvent;
        vm.billingPreferences = vm.event.billingPreferences;
        vm.preferences = vm.event.preferences;
        vm.participantModule = vm.event.preferences.participantModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        vm.eventStartDate = moment(moment.utc(vm.event.start)).local().format('MMMM DD, YYYY');
        vm.eventStartTime = moment(moment.utc(vm.event.start)).local().format('hh:mm a');
        vm.eventEndDate = moment(moment.utc(vm.event.end)).local().format('MMMM DD, YYYY');
        vm.eventEndTime = moment(moment.utc(vm.event.end)).local().format('hh:mm a');

        if ( moment(vm.eventStartDate).isSame(vm.eventEndDate, 'day') ){
          vm.isSameDate = true;
        }

        __sponsor.getSponsors('innerPages', true, true)
          .then(
            function(response){
              var arrays = [];
              angular.forEach(response.data, function(sponsor){
                if ( sponsor.headline ) {
                  vm.sponsorsHeadline.push(sponsor);
                } else {
                  arrays.push(sponsor);
                }
              });

              for ( var i = 0; i < arrays.length; i += 2 ) {
                if ( arrays.length > 8 ){
                  vm.sponsorsSecondary.push(arrays.slice(i, i + 2));
                } else {
                  vm.sponsorsSecondary = arrays;
                }
              }

            },
            $scope.handleError
          );

        PageService.getPageByTag('fixed', 'appFormParticipant')
          .then(
            function(response) {
              vm.appFormParticipant = response.data;
            },
            $scope.handleError
          );

        $scope.fetchMyRequests(function(){
          $scope.getPricePackages();
        });

        if ( typeof $location.search().fetchingRequests !== 'undefined' ){
          $scope.showInfopanel = true;
          var count = 0;
          var clearInt = $interval(function(){
            if ( $scope.requestsTotal !== $scope.nextRequestTotal ){
              $scope.showInfopanel = false;
              $interval.cancel(clearInt);
              return;
            }
            __participant.getMyRequests()
              .then(
                function(response){
                  vm.requests = __participant.participants(response.data);
                  $scope.nextRequestTotal = response.data.length;
                }
              );
            if ( count === 5 ){
              $scope.showInfopanel = false;
              $interval.cancel(clearInt);
            } else {
              count++;
            }
          }, 5000);
        }
      },

      fetchMyRequests: function(cb){
        __participant.getMyRequests()
          .then(
            function(response){
              vm.requests = __participant.participants(response.data);
              $scope.requestsTotal = response.data.length;
              $scope.nextRequestTotal = response.data.length;

              if ( cb ) cb();
            }
          );
      },

      calculateRemainingPackages: function(requests){
        var result = [];
        var requestPricePackages = requests.map(function(r){
          return r.items && r.items.map(function(p){
            return p;
          });
        });

        if ( requestPricePackages.length <= 0 ) return result;

        var arr = requestPricePackages.reduce(function(a, b){
          return a.concat(b);
        });

        for ( var i in arr ){
          var pkg = arr[i];
          var data = result[pkg.pricePackageId];
          if ( !data ){
            data = 0;
            result[pkg.pricePackageId] = data;
          }

          result[pkg.pricePackageId] += pkg.count;
        }
        return result;
      },

      handleDonation: function() {
        $uibModal.open({
          templateUrl: 'app/donations-form/donations-form.html',
          controller: 'DonationFormController',
          controllerAs: 'vm',
          resolve: {
            relocate: function(){
              return false;
            }
          }
        });
      },

      getPricePackages: function() {
        $scope.remainingPackages = $scope.calculateRemainingPackages(vm.requests);
        vm.pricePackages = [];
        __price.getPrices(true, 'participation')
          .then(
            function(response) {
              angular.forEach(response.data, function(item){
                vm.pricePackages.push($.extend({}, item, {
                  amount: 0,
                  purchased: $scope.calculatePurchased(item)
                }));
              });
              vm.invitedParticipants = [];
            },
            $scope.handleError
          );
      },

      calculatePurchased: function(pkg){
        var isMaxAvailable = false;
        var isLimitPerPerson = false;
        if ( pkg.maxAvailable && pkg.maxAvailable > 0 ){
          isMaxAvailable = true;
        }
        if ( pkg.limitPerPerson && pkg.limitPerPerson > 0 ){
          isLimitPerPerson = true;
        }
        if ( isMaxAvailable && isLimitPerPerson ){
          return (pkg.maxAvailable - pkg.stats.inUse) > pkg.limitPerPerson ? $scope.remainingPackages[pkg.id] ? pkg.limitPerPerson - $scope.remainingPackages[pkg.id] : pkg.limitPerPerson : (pkg.maxAvailable - pkg.stats.inUse);
        } else if ( isLimitPerPerson ){
          return $scope.remainingPackages[pkg.id] ? pkg.limitPerPerson - $scope.remainingPackages[pkg.id] : pkg.limitPerPerson;
        }
      },

      disableIncrease: function(pkg){
        if ( typeof pkg.limitPerPerson !== 'undefined' ){
          return pkg.purchased === 0;
        } else {
          return (pkg.maxAvailable && pkg.maxAvailable - pkg.stats.inUse == pkg.amount);
        }
      },

      resetAmount: function(){
        vm.invitedParticipants = [];
        vm.inviteID = 1;

        vm.pricePackages.map(function(item){
          return item['amount'] = 0;
        });
      },

      increaseAmount: function(pkg) {
        $scope.addInvite(pkg);

        pkg.amount += 1;
        pkg.purchased -= 1;
      },

      decreaseAmount: function(pkg) {
        $scope.removeInvite(pkg);

        pkg.amount -= 1;
        pkg.purchased += 1;
      },

      // Invite participant
      addInvite: function(pkg){
        var data = {
          id: vm.inviteID,
          name: '',
          email: '',
          amount: 1,
          package: pkg,
          readonly: false,
          required: true
        };

        if ( typeof pkg.preferences === 'undefined' ) return;
        if ( typeof pkg.preferences.purchaseOnBehalfEnabled !== 'undefined' && pkg.preferences.purchaseOnBehalfEnabled ){
          if ( vm.requests && vm.requests.length === 0 ){
            if ( vm.invitedParticipants.length === 0 ){
              vm.invitedParticipants.push($.extend({}, data, {
                name: vm.currentUser.name,
                email: vm.currentUser.email
              }));
            } else {
              vm.invitedParticipants.push(data);
            }
          } else {
            // var item;
            var ownPricePackage = false;
            for ( var i = 0; i < vm.requests.length; i++ ){
              var request = vm.requests[i];
              var item = request.items.find(function(p){
                return p.pricePackageId === pkg.id
              });
              if ( item && item.participantId === vm.currentUser.id ){
                ownPricePackage = true;
                break;
              }
            }
            if ( ownPricePackage ){
              vm.invitedParticipants.push(data);
            } else {
              if ( vm.invitedParticipants.length === 0 ){
                vm.invitedParticipants.push($.extend({}, data, {
                  name: vm.currentUser.name,
                  email: vm.currentUser.email
                }));
              } else {
                vm.invitedParticipants.push(data);
              }
            }
          }
        } else {
          vm.invitedParticipants.push($.extend({}, data, {
            name: vm.currentUser.name,
            email: vm.currentUser.email,
            readonly: true
          }));
        }

        vm.inviteID++;
      },

      removeInvite: function(pkg){
        if ( vm.invitedParticipants.length ){
          for ( var i = vm.invitedParticipants.length - 1; i >= 0; i-- ){
            var invite = vm.invitedParticipants[i];
            if ( invite.package.id === pkg.id ){
              var idx = vm.invitedParticipants.indexOf(invite);
              vm.invitedParticipants.splice(idx, 1);
              break;
            } else {
              continue;
            }
          }
        }
      },

      removeSelectedInvite: function(item){
        for ( var i in vm.invitedParticipants ) {
          var invited = vm.invitedParticipants[i];
          if ( invited.id === item.id ) {
            vm.invitedParticipants.splice(vm.invitedParticipants.indexOf(item), 1);
          }
        }
        for ( var i in vm.pricePackages ){
          var pkg = vm.pricePackages[i];
          if ( pkg.id === item.package.id ){
            pkg.amount--;
            pkg.purchased++;
          }
        }
      },

      handleFieldsValidation: function() {
        if ( !vm.pricePackages ) return;
        var result = true;
        var total = 0;
        for ( var j in vm.pricePackages ) {
          total += vm.pricePackages[j].amount;
        }
        if ( total !== 0 ) {
          result = false;
        }
        if ( vm.invitedParticipants.length !== 0 ) {
          for ( var i in vm.invitedParticipants ) {
            var item = vm.invitedParticipants[i];
            if (
              !item.name ||
              !item.email ||
              !item.package ||
              !item.amount
            ) {
              result = true;
              break;
            }
          }
        }
        return result;
      },

      handleFormValidate: function() {
        var result = true;
        return result;
      },

      totalPackagesCount: function(){
        var total = 0;
        vm.pricePackages.forEach(function(item) {
          total += item.amount;
        });
        return total;
      },

      totalPrice: function() {
        if ( !vm.pricePackages ) return;
        var total = 0;
        vm.pricePackages.forEach(function(item) {
          total += item.price * item.amount;
        });
        return total;
      },

      totalPriceLabel: function(){
        return Number($scope.totalPrice()).toFixed(2)
      },

      showEventPass: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            templateUrl: 'app/users/event-pass/event-pass.html',
            controller: 'EventPassController',
            controllerAs: 'vm',
            windowClass: 'modal-event-pass',
            resolve: {
              resolveType: function(){
                return 'participant'
              },
              resolveRequest: function(){
                return request;
              }
            }
          });
          modal.result
            .then(
              function(result){

              },
              function(result) {
                for ( var i in vm.requests ){
                  var rq = vm.requests[i];
                  if ( rq.id === result.id ){
                    var idx = vm.requests.indexOf(rq);
                    vm.requests[idx] = result;
                  }
                }
              }
            );
        }
      },

      onApplyPromocode: function(promocode){
        if ( promocode ){
          // vm.pricePackages = [];
          __price.getPrices(true, 'participation', promocode)
            .then(
              function(response) {
                angular.forEach(response.data, function(item){
                  vm.pricePackages.push($.extend({}, item, {
                    amount: 0,
                    purchased: $scope.calculatePurchased(item)
                  }));
                });
              },
              $scope.handleError
            );
        }
      },

      handleError: function(err){
        vm.loadingBuy = false;
        vm.loadingCash = false;
        Notification.error(err.data.message);
      }
    });

    // Payment
    angular.extend($scope, {
      openModalAgreement: function() {
        return $uibModal.open({
          templateUrl: 'app/users/participant/agreement/agreement.html',
          controller: 'ParticipantAgreementController',
          controllerAs: 'vm'
        });
      },
      handleNoCost: function(){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function(){
                $scope.noCostRequest();
              }
            )
        } else {
          $scope.noCostRequest();
        }
      },
      // Handle payment buttons
      handleCashButton: function() {
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function(){
                $scope.cashRequest();
              }
            )
        } else {
          $scope.cashRequest();
        }
      },
      handlePaypalButton: function(pay) {
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.paypalRequest(pay);
              }
            )
        } else {
          $scope.paypalRequest(pay);
        }
      },
      handleTransactionButton: function(pay) {
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.transactionRequest(pay);
              }
            )
        } else {
          $scope.transactionRequest(pay);
        }
      },
      handleStripeButton: function(pay){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.stripeRequest(pay);
              }
            )
        } else {
          $scope.stripeRequest(pay);
        }
      },
      handleSquareupButton: function(pay){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.squareupRequest(pay);
              }
            )
        } else {
          $scope.squareupRequest(pay);
        }
      },
      handlePayeezyButton: function(pay){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.payeezyRequest(pay);
              }
            )
        } else {
          $scope.payeezyRequest(pay);
        }
      },
      // Requests
      noCostRequest: function(){
        vm.loadingCash = true;
        if ( $scope.handleFormValidate() ) {
          var data = $scope.generateFormData();
          data['payCash'] = true;

          __participant.onAdd(data)
            .then(
              function(response) {
                vm.invitedParticipants = [];
                vm.loadingCash = false;

                Notification.success('Request was added');
                __participant.add(response.data);
                $scope.getPricePackages();

                onScrollTop();
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },
      cashRequest: function() {
        if ( vm.participantModule.cashPayment ) {
          vm.loadingCash = true;
          if ( $scope.handleFormValidate() ) {
            var data = $scope.generateFormData();
            data['payCash'] = true;

            __participant.onAdd(data)
              .then(
                function(response) {
                  var responseData = response.data;
                  // vm.invitedParticipants = [];
                  vm.loadingCash = false;

                  Notification.success('Request was added');
                  __participant.add(response.data);
                  $scope.getPricePackages();

                  onScrollTop();
                },
                $scope.handleError
              );
          } else {
            $scope.notificationAmount();
          }
        }
      },
      paypalRequest: function(pay) {
        if ( $scope.handleFormValidate() ) {
          vm.loadingBuy = true;
          var data = $scope.generateFormData();

          __participant.onAdd(data)
            .then(
              function(response) {
                var responseData = response.data;
                // vm.invitedParticipants = [];
                vm.loadingBuy = false;

                $scope.generatePaypalForm(pay, responseData);
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },
      transactionRequest: function(pay) {
        if ( $scope.handleFormValidate() ) {
          vm.loadingBuy = true;
          var data = $scope.generateFormData();

          __participant.onAdd(data)
            .then(
              function(response) {
                var responseData = response.data;
                // vm.invitedParticipants = [];
                vm.loadingBuy = false;

                $scope.generateTransactionForm(pay, responseData);
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },
      stripeRequest: function(pay){
        if ( $scope.handleFormValidate() ) {
          vm.loadingBuy = true;
          var data = $scope.generateFormData();

          __participant.onAdd(data)
            .then(
              function(response) {
                var responseData = response.data;
                // vm.invitedParticipants = [];
                vm.loadingBuy = false;

                $scope.generateStripe(pay, responseData);
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },
      squareupRequest: function(pay){
        if ( $scope.handleFormValidate() ) {
          vm.loadingBuy = true;
          var data = $scope.generateFormData();
          __participant.onAdd(data)
            .then(
              function(response) {
                var responseData = response.data;
                // vm.invitedParticipants = [];
                vm.loadingBuy = false;

                $scope.generateSquareupForm(pay, responseData);
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },

      payeezyRequest: function(pay){
        if ( $scope.handleFormValidate() ) {
          vm.loadingBuy = true;
          var data = $scope.generateFormData();
          __participant.onAdd(data)
            .then(
              function(response) {
                var responseData = response.data;
                // vm.invitedParticipants = [];
                vm.loadingBuy = false;

                $scope.generatePayeezyForm(pay, responseData);
              },
              $scope.handleError
            );
        } else {
          $scope.notificationAmount();
        }
      },

      // Paypal
      generatePaypalForm: function(pay, data) {
        if ($scope.totalPrice() === 0) {
          __participant.add(data);
        } else {
          var packages = [];
          for ( var i in vm.pricePackages ) {
            var item = vm.pricePackages[i];
            if ( item.amount !== 0 ) {
              packages.push(item.name + 'x' + item.amount);
            }
          }

          var paymentData = {
            id: data.id,
            name: packages.join(', '),
            amount: $scope.totalPrice()
          };

          PaymentService.paypalForm(pay, paymentData, 'epr');
        }
      },
      // Transaction
      generateTransactionForm: function(pay, data) {
        if ($scope.totalPrice() === 0) {
          __participant.add(data);
        } else {
          var paymentData = {
            id: data.id,
            amount: $scope.totalPrice()
          };

          PaymentService.transactionForm(pay, paymentData, 'epr');
        }
      },
      // Stripe
      generateStripe: function(pay, request){
        if ($scope.totalPrice() === 0) {
          __participant.add(request);
        } else {
          var paymentData = {
            id: request.id,
            amount: request.price,
            name: request.participant.name,
            description: request.description,
            email: request.participant.email
          };
          PaymentService.stripeForm(pay, paymentData, 'epr',
            function(){
              __participant.getRequestById(request.id)
                .then(
                  function(response){
                    __participant.add(response.data);
                    Notification.success('Payment successfully submitted')

                    $scope.getPricePackages();

                    onScrollTop();
                  },
                  function(err){
                    console.log(err);
                  }
                );
            },
            function(err){
              Notification.error(err.data.message);
            }
          );
        }
      },
      // Squareup
      generateSquareupForm: function(pay, request){
        if ($scope.totalPrice() === 0) {
          __participant.add(request);
        } else {
          var modal = $uibModal.open({
            templateUrl: 'app/squareup-form/squareup-form.html',
            controller: 'SquareupFormController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
              dataPay: function(){
                return {
                  applicationId: pay.applicationId,
                  locationId: pay.locationId
                };
              },
              dataResult: function(){
                return {
                  amount: request.price,
                  id: request.id
                };
              },
              itemType: function(){
                return 'epr';
              }
            }
          });
          modal.result
            .then(
              function(){
                __participant.getRequestById(request.id)
                  .then(
                    function(response){
                      __participant.add(response.data);
                      Notification.success('Payment successfully submitted');

                      $scope.getPricePackages();
                      onScrollTop();
                    },
                    function(err){
                      console.log(err);
                    }
                  );
              },
              function(){
                $scope.resetAmount();
                console.log('Dissmissed');
              }
            );
        }
      },

      generatePayeezyForm: function(pay, request){
        if ($scope.totalPrice() === 0) {
          __participant.add(request);
        } else {
          var modal = $uibModal.open({
            templateUrl: 'app/payeezy-form/payeezy-form.html',
            controller: 'PayeezyFormController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
              dataPay: function(){
                return {
                  apiKey: pay.apiKey,
                  paymentJSUrl: pay.paymentJSUrl,
                  transarmorToken: pay.transarmorToken,
                  jsSecurityKey: pay.jsSecurityKey
                };
              },
              dataResult: function(){
                return {
                  amount: request.price,
                  id: request.id
                };
              },
              itemType: function(){
                return 'epr';
              }
            }
          });
          modal.result
            .then(
              function(resolve){
                __participant.getRequestById(request.id)
                  .then(
                    function(response){
                      __participant.add(response.data);
                      Notification.success('Payment successfully submitted');

                      $scope.getPricePackages();
                      onScrollTop();
                    },
                    function(err){
                      console.log(err);
                    }
                  );
              },
              function(){
                // $scope.getPricePackages();
              }
            );
        }
      },

      // Generate form data
      generateFormData: function() {
        var items = [];
        for ( var i = 0; i < vm.invitedParticipants.length; i++ ){
          var invited = vm.invitedParticipants[i];
          if ( items.length ){
            var notExist = false;
            var isExist = false;
            for ( var j = 0; j < items.length; j++ ){
              var item = items[j];
              if (item.participantEmail === invited.email && item.pricePackageId === invited.package.id) {
                $.extend({}, item, {
                  count: item.count++,
                  participantName: invited.name
                });
                isExist = true;
                break;
              } else {
                notExist = true;
              }
            }
            if ( notExist && !isExist ){
              items.push({
                count: 1,
                participantEmail: invited.email,
                participantName: invited.name,
                pricePackageId: invited.package.id
              });
            }
          } else {
            items.push({
              count: 1,
              participantEmail: invited.email,
              participantName: invited.name,
              pricePackageId: invited.package.id
            });
          }
        }

        return {
          eventId: vm.event.id,
          items: items,
          notes:  (vm.participantRequestNotes && vm.participantRequestNotes !== '' ? vm.participantRequestNotes : '')
        }
      },

      notificationAmount: function() {
        // Notification.error('Amount is exaggerated than selected package');
        Notification.error('No participant added');
        vm.loadingCash = false;
        vm.loadingBuy = false;
      },


      onShowNotes: function(request){
        if ( request && request.id ){
          var modal = $uibModal.open({
            template: '\
              <div class="modal-body">\
                <div class="from-group">\
                  <label for="notes">Special requests or notes:</label>\
                  <textarea class="form-control" id="notes" name="notes" ng-model="participantRequest.notes" rows="7" placeholder="Notes" ng-readonly="isAccepted()"></textarea>\
                </div>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleSave()" ng-if="!isAccepted()">Save</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, ParticipantService, Notification, request){
              $scope.participantRequest = request;
              $scope.handleSave = function(){
                ParticipantService.onUpdate($scope.participantRequest.id, $scope.participantRequest)
                  .then(function(){
                    Notification.success('Request notes were updated');
                    $uibModalInstance.close();
                  })
                  .catch(function(err){
                    console.error(err);
                  });
              }
              $scope.isAccepted = function(){
                return request.status === 'accepted';
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              request: function(){
                return request;
              }
            }
          });
        }
      },
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };

    angular.extend($scope, {
      slickConfig: {
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },{
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },{
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      slickHeadlineConfig: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true
      }
    });

    function onScrollTop(){
      $window.scrollTo(0, 0);

      vm.participantRequestNotes = null;
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantEventPassReservationController', ParticipantEventPassReservationController);
  
    function ParticipantEventPassReservationController(
      $document,
      $rootScope,
      $scope,
      $uibModalInstance,
      $interval,
      participantRequest,
      RequestReservationService
      // ParticipantService
    ) {
      var vm = this;
      vm.loading = true;
      vm.request = participantRequest;

      var stopInterval;

      angular.extend($scope, {
        onInit: function() {

          if ( !vm.request.checkedIn ){
            stopInterval = $interval(function(){
              RequestReservationService.getReservationRequestById(vm.request.id)
                .then(function(response){ vm.request = response.data });
            }, 5000);
          }

          vm.loading = false;
          vm.event = $rootScope.currentEvent;
          if ( vm.event && vm.event.domain ){
            var domain = ( vm.event.domain !== 'localhost' ? vm.event.domain : vm.event.domain +':3000');
            vm.qrURL = 'http://'+ domain +'/auto-check-in?type=reservation&code='+ vm.request.code;
          }
        },

        onClose: function() {
          $uibModalInstance.dismiss(vm.request);
          $interval.cancel(stopInterval);
        },

        handleError: function(err) {
          vm.loading = false;
          console.error(err);
        }
      });
    }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantAgreementController', ParticipantAgreementController);

  function ParticipantAgreementController(
    $rootScope,
    $scope,
    $uibModalInstance,
    PageService
  ) {
    var vm = this;
    vm.participantModule = $rootScope.currentEvent.preferences.participantModule;
    vm.waiverAgreement = false;

    angular.extend($scope, {
      onInit: function() {
        PageService.getPageByTag('fixed', 'participantWaiver')
          .then(
            function(response){
              vm.participantWaiver = response.data;
            },
            $scope.handleError
          );
      },
      handleAccept: function () {
        if ( vm.waiverAgreement ) {
          $uibModalInstance.close('Accepted');
        }
      },
      handleDecline: function () {
        $uibModalInstance.dismiss('Dissmissed');
      }
    });
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVolunteerController', OrganizerVolunteerController)
  
  OrganizerVolunteerController.$inject = [
    '$scope'
  ];

  function OrganizerVolunteerController(
    $scope
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){}
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerVendorsController', OrganizerVendorsController);
  
  OrganizerVendorsController.$inject = [
    '$scope'
  ];
  
  function OrganizerVendorsController(
    $scope
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){}
    });
  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('OrganizerUserGroupsController', OrganizerUserGroupsController);

  OrganizerUserGroupsController.$inject = [
    '$scope'
  ];

  function OrganizerUserGroupsController(
    $scope
  ){
    var vm = this;

    angular.extend($scope, {

    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerTransactionController', OrganizerTransactionController);
  
  OrganizerTransactionController.$inject = [
    '$rootScope',
    '$scope',
    '$uibModal',
    '$uibModalInstance',
    'moment',
    'Notification',
    'TransactionService',
    'request',
    'userType'
  ];

  function OrganizerTransactionController(
    $rootScope,
    $scope,
    $uibModal,
    $uibModalInstance,
    moment,
    Notification,
    __transaction,
    request,
    userType
  ) {
    var vm = this;
    vm.transactions = [];
    vm.label = userType === 'evr' ? 'Vendor' : userType === 'epr' ? 'Participant' : userType === 'esr' ? 'Sponsor' : userType === 'edr' ? 'Donation' : '';

    $scope.request = request;

    angular.extend($scope, {
      moment:moment,
      loading:false,
      errorExist:false,
      errorMessage:null
    });

    angular.extend($scope, {
      onInit:function(){
        vm.currentEvent = $rootScope.currentEvent;

        if ( request.id && userType ) {
          __transaction.getTransactions(userType, request.id)
            .then(
              function(response){
                var data = response.data;
                var total = 0;
                for ( var i in data ){
                  var d = data[i];
                  if ( d.status === 'completed' && d.type === 'refund' ){
                    total += d.amount;
                  }
                  vm.transactions.push(d);
                }
                vm.transactions.map(function(item){
                  if ( item.status === 'completed' && item.type === 'payment' ){
                    item.amountChange = Number(parseFloat(item.amount - total).toFixed(2));
                  }
                });
              }
            );
        }

      },

      noPayeezy: function(transactions){
        var show = true;
        if ( transactions.length ){
          for ( var i in transactions ){
            if ( transactions[i].service === 'payeezy' ){
              show = false;
              break;
            }
          }
        }
        return show;
      },

      handleRefund:function(transaction, price){
        if ( transaction && transaction.id ) {
          $scope.errorExist = false;
          $scope.errorMessage = null;
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Are you sure you want to refund $<span ng-bind="transaction.amountChange"></span>?\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleRefund()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>\
                  Refund\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                <div class="form-group" style="margin-bottom: 0;">\
                  <div class="help-block help-block-default" style="text-align: right !important; margin-bottom: 0 !important; position: relative;">( it could take some time to submit refund )</div>\
                </div>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, transaction){
              $scope.transaction = transaction;
              var data = {
                amount: parseFloat(transaction.amountChange),
                eventId: transaction.eventId,
                service: transaction.service,
                id: transaction.id
              };
              // console.log(data);
              // console.log(transaction);
              $scope.handleRefund = function(){
                $scope.loading = true;
                __transaction.refundTransaction(data)
                  .then(
                    function(response){
                      $uibModalInstance.close(response.data);
                    },
                    function(error){
                      $uibModalInstance.dismiss(error);
                    }
                  );
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              transaction: function(){
                return transaction;
              }
            }
          });

          modal.result
            .then(
              function(result){
                Notification.success('Transaction refund successfully initiated');
                vm.transactions.push(result);

                var total = 0;
                for ( var i in vm.transactions ){
                  var d = vm.transactions[i];
                  if ( d.status === 'completed' && d.type === 'refund' ){
                    total += d.amount;
                  }
                }
                vm.transactions.map(function(item){
                  if ( item.status === 'completed' && item.type === 'payment' ){
                    item.amountChange = Number(parseFloat(item.amount - total).toFixed(2));
                  }
                });
              },
              function(error) {
                if ( error && error.data ) {
                  $scope.errorExist = true;
                  $scope.errorMessage = error.data.message;
                }
              }
            );
        }
      },

      calcAmount:function(){
        var payment = null;
        var total = 0;
        var result = false;
        for ( var i in vm.transactions ){
          var tr = vm.transactions[i];
          if ( tr.status === 'completed' && tr.type === 'payment' ){
            payment = tr;
          }
          if ( tr.status === 'completed' && tr.type === 'refund' ){
            total += tr.amount;
          }
        }
        if ((total + payment.amountChange) > payment.amount){
          result = true;
        }
        return result;
      },

      checkAmount:function(transaction){
        var result = false;
        // console.log(transaction.amountChange.length);
        if ( transaction && transaction.amountChange ){
          if ( transaction.amountChange < 0 || transaction.amountChange.length === 0 ){
            result = true;
          }
        }
        return result;
      },

      refundButton:function(type, status){
        return ( type === 'payment' && status.toLowerCase() === 'completed' ? true : false );
      },

      onClose:function() {
        $uibModalInstance.dismiss('cancel');
      }
    })
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerSponsorsController', OrganizerSponsorsController);
  
  OrganizerSponsorsController.$inject = [
    '$scope'
  ];
  
  function OrganizerSponsorsController(
    $scope
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){}
    });
  }

})();

(function() {
  'use strict';
  
  angular
    .module('eventmap')
    .controller('OrganizerSpecialUsersFormController', OrganizerSpecialUsersFormController);
  
  OrganizerSpecialUsersFormController.$inject = [
    '$scope',
    '$state',
    '$uibModalInstance',
    'Notification',
    'EventService',
    'AuthService',
    'resolveUser'
  ];

  function OrganizerSpecialUsersFormController(
    $scope,
    $state,
    $uibModalInstance,
    Notification,
    __event,
    __auth,
    resolveUser
  ) {
    var vm = this;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    angular.extend($scope, {
      label: ( resolveUser && resolveUser.id ? 'Update' : 'Create'),
      passwordRequired: ( resolveUser && resolveUser.id ? false : true),
      loading: false
    });

    angular.extend($scope, {
      onInit: function() {
        if ( resolveUser && resolveUser.id ) {
          vm.user = resolveUser;
          // __auth.getUserById(resolveUser.id)
          //   .then(
          //     function(response){
          //       vm.user = response.data;
          //     },
          //     $scope.handleError
          //   );
        }
      },

      handleCancel: function(){
        $uibModalInstance.dismiss('cancel');
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          if ( vm.user.phone1 && !vm.user.phone1.number ){
            delete vm.user['phone1'];
          }
          if ( resolveUser && resolveUser.id ) {
            __auth.onUpdate(vm.user)
              .then(
                function(response) {
                  $scope.formLoading = false;
                  // __event.specialsUpdate(response.data);
                  Notification.success('User was updated');
                  $uibModalInstance.close(response.data);
                  // $scope.onClose();
                },
                function(err){
                  $scope.formLoading = false;
                  Notification.error(err.data.message);
                }
              );
          } else {
            __auth.onRegister(vm.user)
              .then(
                function(response) {
                  $scope.formLoading = false;
                  response.data.enabled = true;
                  // __event.specialsAdd(response.data);
                  Notification.success('User was added');
                  $uibModalInstance.close(response.data);
                  // $scope.onClose();
                },
                function(err){
                  $scope.formLoading = false;
                  Notification.error(err.data.message);
                }
              );
          }
        }
      },

      // onClose: function() {
      //   $scope.formLoading = false;
      //   $state.go('users.organizer.specialUsers');
      // },

      handleError: function(err) {
        Notification.error(err.data.message);
      }
    });

  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerSpecialUsersController', OrganizerSpecialUsersController);
  
  OrganizerSpecialUsersController.$inject = [
    '$rootScope',
    '$scope',
    'Notification',
    '$uibModal',
    'EventService',
    'AuthService',
    'UserGroupsService'
  ];

  function OrganizerSpecialUsersController(
    $rootScope,
    $scope,
    Notification,
    $uibModal,
    __event,
    __auth,
    UserGroupsService
  ) {
    var vm = this;

    $scope.groups = [];
    vm.userGroups = [];

    $scope.userGroupsSearch = '';

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;

        UserGroupsService.getGroups(true)
          .then(function(response){
            $scope.groups = response.data;
            return __event.getSpecials()
          })
          .then(function(response){
            var result = [];
            var groups = [];
            if ( response.data.length ){
              for ( var i in response.data ){
                var user = response.data[i];
                user['userGroups'] = [];

                if ( $scope.groups.length ){
                  for ( var j in $scope.groups ){
                    var group = $scope.groups[j];
                    if ( group.userIds && group.userIds.length ){
                      if ( group.userIds.indexOf(user.id) !== -1 ){

                        if ( groups.indexOf(group) === -1 ){
                          groups.push(group);
                        }

                        if ( user['userGroups'].indexOf(group.name) == -1 ){
                          user['userGroups'].push(group.name);
                        }

                      }
                    }
                  }
                }

                result.push(user);
              }
            }
            vm.userGroups = groups;
            vm.specialUsers = __event.specials(result);
          })
          .catch(function(err){
            console.log(err);
          });
      },

      handleCreate: function(){
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/special-users/special-users.form.html',
          controller: 'OrganizerSpecialUsersFormController as vm',
          resolve: {
            resolveUser: function(){
              return null;
            }
          }
        }).result.then(
          function(result){
            __event.specialsAdd(result);
          },
          function(err){
            console.warn(err);
          }
        )
      },

      handleEdit: function(user){
        if ( user && user.id ){
          $uibModal.open({
            size: 'md',
            templateUrl: 'app/users/organizer/special-users/special-users.form.html',
            controller: 'OrganizerSpecialUsersFormController as vm',
            resolve: {
              resolveUser: function(){
                return user;
              }
            }
          }).result.then(
            function(result){
              __event.specialsUpdate(result);
            },
            function(err){
              console.warn(err);
            }
          )
        }
      },

      handleDisable: function(user) {
        if ( user ) {
          __auth.onDisable(user)
            .then(
              function(response) {
                __event.specialsUpdate(response.data);
                Notification.success('User disabled')
              },
              $scope.handleError
            );
        }
      },

      handleEnable: function(user) {
        if ( user ) {
          __auth.onEnable(user)
            .then(
              function(response) {
                __event.specialsUpdate(response.data);
                Notification.success('User enabled')
              },
              $scope.handleError
            );
        }
      },

      handleDelete: function(user) {
        if ( user ) {
          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to completely delete <b>{{user.username}}</b> ({{user.name}}/{{user.email}}) special user account?<p>It will remove all the user data and operation can`t be undone</p>\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, user, AuthService){
              $scope.user = user;
              $scope.loading = false;
              
              $scope.handleConfirm = function(){
                $scope.loading = true;
                AuthService.onDelete(user.id)
                  .then(
                    function(response){
                      $uibModalInstance.close(user);
                      $scope.loading = false;
                    },
                    function(err){
                      $uibModalInstance.dismiss('cancel');
                      $scope.loading = false;
                      Notification.error(err.data.message);
                    }
                  );
              }

              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              user: function(){
                return user;
              }
            }
          });

          modal.result
            .then(
              function(result){
                __event.specialsDelete(result);
                Notification.success('Special user was removed');
                vm.currentPage = $scope.navigatePagination(vm.specialUsers);
              },
              function() {
                console.log('Cancelled');
              }
            );
        }
      },

      handleLoginAs: function(user) {
        $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/login-as/login-as.html',
          controller: 'OrganizerLoginAsController',
          resolve: {
            loginAs: function(){
              return user;
            }
          }
        });
      },

      handleError: function(err){
        Notification.error(err.data.message);
      },

      navigatePagination: function(items) {
        var perPage = $rootScope.currentEvent.preferences.itemsPerPage.toFixed();
        var totalItems = items.length;
        var fixedPages = Math.floor(totalItems/perPage);
        var otherPages = (totalItems%perPage);

        var result = 1;

        if ( fixedPages !== 0 ) {
          if ( otherPages >= 1 ) {
            result = vm.currentPage;
          } else {
            result = fixedPages;
          }
        }
        return result;
      }
    });
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerScavengerHuntCtrl', OrganizerScavengerHuntCtrl);
  
  OrganizerScavengerHuntCtrl.$inject = [
    '$scope'
  ];
  
  function OrganizerScavengerHuntCtrl(
    $scope
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){}
    });
  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
    .controller('OrganizerReservationController', OrganizerReservationController);

  OrganizerReservationController.$inject = [
    '$scope',
    '$window',
    '$stateParams',
    '$uibModal',
    'moment',
    'Notification',
    'ReservationService'
  ];

  function OrganizerReservationController(
    $scope,
    $window,
    $stateParams,
    $uibModal,
    moment,
    Notification,
    ReservationService
  ){
    var vm = this;
    var boothID = $stateParams.id;
    
    $scope.selectedDay = null;
    $scope.loading = true;
    $scope.loadingSlot = false
    $scope.reservations = [];
    $scope.slots = [];

    angular.extend($scope, {
      moment: moment,
      onInit: function(){
        if ( !boothID ) throw new Error('Booth ID not found');
        ReservationService.getReservations(boothID)
          .then(function(response){
            $scope.loading = false;
            $scope.reservations = response.data;
          })
          .catch(function(err){
            console.error(err);
          });
      },

      goBack: function(){
        $window.history.back();
      },

      handleCreateCalendar: function(){
        var modal = $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/reservation/form.reservation.html',
          controller: 'OrganizerFormReservationController',
          controllerAs: 'vm',
          resolve: {
            $$reservation: function(){
              return null;
            },
            $$boothId: function(){
              return boothID;
            }
          }
        });
        modal.result
          .then(
            function(result){
              $scope.reservations.push(result);
              Notification.success('Calendar was created');
              if ( $scope.selectedDay !== 'null' ){
                $scope.handleSelectDay(
                  $.extend({}, $scope.selectedDay, {
                    calendarID: result.id,
                    operatingHours: result.operatingHours
                  })
                );
              }
            },
            function() {
              console.log('Cancelled');
            }
          );
      },

      handleEditCalendar: function(reservation){
        var modal = $uibModal.open({
          size: 'md',
          templateUrl: 'app/users/organizer/reservation/form.reservation.html',
          controller: 'OrganizerFormReservationController',
          controllerAs: 'vm',
          resolve: {
            $$reservation: function(){
              return reservation;
            },
            $$boothId: function(){
              return boothID;
            }
          }
        });
        modal.result
          .then(
            function(result){
              var reserv = $scope.reservations.filter(function(item){
                return item.id === result.id;
              })[0];
              var idx = $scope.reservations.indexOf(reserv);
              $scope.reservations[idx] = result;
              Notification.success('Calendar was updated');
            },
            function() {
              console.log('Cancelled');
            }
          );
      },

      handleDeleteCalendar: function(reservation){
        if ( reservation && reservation.id ){
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Are you sure you want to remove calendar?\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                <button class="btn btn-primary" type="button" ng-click="handleSubmit()">Remove</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance){
              $scope.handleSubmit = function(){
                $uibModalInstance.close();
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            }
          });
          modal.result
            .then(
              function(){
                ReservationService.deteleReservation(reservation.id)
                  .then(function(){
                    var reserv = $scope.reservations.filter(function(item){
                      return item.id === reservation.id;
                    })[0];
                    var idx = $scope.reservations.indexOf(reserv);
                    $scope.reservations.splice(idx, 1);
                    $scope.slots = [];
                    Notification.success('Calendar was removed');

                    if ( $scope.selectedDay ){
                      delete $scope.selectedDay['calendarID'];
                      delete $scope.selectedDay['operatingHours'];
                      $scope.handleSelectDay($scope.selectedDay);
                    }
                  })
                  .catch(function(err){
                    console.log(err);
                    Notification.error(err.data.message);
                  });
              },
              function(){
                console.log('Cancelled');
              }
            )
        }
      }
    });


    $scope.isSameDay = function(start, end){
      return moment(start).isSame(end, 'day')
    }

    $scope.isSameMonth = function(start, end){
      return moment(start).isSame(end, 'month')
    }

    $scope.toHours = function(time){
      return moment(moment.utc(time)).local().format('HH:mm')
    }

    $scope.getSlotCalendar = function(slot){
      return $scope.reservations.filter(function(item){
        return item.id === slot.reservationCalendarId;
      })[0];
    }

    $scope.toMonth = function(date){
      return moment(moment.utc(date)).local().format('MMM') +' '+ ordinal_suffix_of(moment(moment.utc(date)).local().format('D'));
    }

    function ordinal_suffix_of(i) {
      var j = i % 10,
          k = i % 100;
      if (j == 1 && k != 11) {
          return i + "st";
      }
      if (j == 2 && k != 12) {
          return i + "nd";
      }
      if (j == 3 && k != 13) {
          return i + "rd";
      }
      return i + "th";
    }


    $scope.errSlots = false;
    $scope.errSlotsMsg = null;

    // Handlers
    angular.extend($scope, {
      handleSelectDay: function(params){
        $scope.selectedDay = params;
        $scope.errSlots = false;
        $scope.errSlotsMsg = null;
        if ( params.day && typeof params.calendarID !== 'undefined' ) {
          $scope.loadingSlot = true;
          // var operatingHours = params.operatingHours;

          var from = moment(params.day.date).set({
            hour:0
          }).utc().format('YYYY-MM-DDTHH:mm:ss.000Z');
          var to = moment(params.day.date).set({
            hour:24
          }).utc().format('YYYY-MM-DDTHH:mm:ss.000Z');
          ReservationService.getReservationSlot(null, boothID, from, to)
            .then(function(response){
              $scope.loadingSlot = false;
              ;
              $scope.slots = response.data;
            })
            .catch(function(err){
              $scope.loadingSlot = false;
              console.error(err);
              Notification.error(err.data.message);
            })
        } else {
          // $scope.selectedDay = null;
          $scope.slots = [];
          $scope.errSlots = true;
          $scope.errSlotsMsg = 'No available slots';
          // Notification.error('Day or calendar id not present');
        }
      },

      handleEditSlot: function(slot){
        if ( slot && slot.id ){
          var modal = $uibModal.open({
            template: '\
              <form novalidate name="form" ng-init="onInit()">\
                <div class="modal-header">\
                  <h3 class="modal-title">Update slot</h3>\
                </div>\
                <div class="modal-body">\
                  <div class="form-group" ng-class="{\'has-error\': form.slotPrice.$invalid && formSubmitted }">\
                    <label for="slotPrice">Price</label>\
                    <div class="form-group form-group-sm">\
                      <div class="input-group">\
                        <div class="input-group-addon">$</div>\
                        <input type="number" class="form-control" id="slotPrice" name="slotPrice" ng-model="slot.price" min="0.000000000000000000000001" required />\
                      </div>\
                    </div>\
                    <div class="help-block" ng-if="form.slotPrice.$invalid && formSubmitted">\
                      This field is required\
                    </div>\
                  </div>\
                </div>\
                <div class="modal-footer">\
                  <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                  <button class="btn btn-primary" type="button" ng-disabled="formLoading" ng-click="handleSubmit()">Update</button>\
                </div>\
              <form>\
            ',
            controller: function($scope, $uibModalInstance, ReservationService, $$slot){
              $scope.formSubmitted = false;
              $scope.formLoading = false;

              $scope.slot = $$slot;
              $scope.handleSubmit = function(){
                $scope.formSubmitted = true;
                var form = $scope.form;
                if ( form.$valid ){
                  $scope.formLoading = true;
                  ReservationService.updateReservationSlot($scope.slot)
                    .then(function(response){
                      $uibModalInstance.close(response.data);
                    })
                    .catch(function(err){
                      $scope.formLoading = false;
                      console.log(err);
                    });
                }
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              $$slot: function(){
                return slot;
              }
            }
          });
          modal.result
            .then(
              function(result){
                var slt = $scope.slots.filter(function(item){
                  return item.id === result.id;
                })[0];
                var idx = $scope.slots.indexOf(slt);
                $scope.slots[idx] = result;
                Notification.success('Slot was updated');
              },
              function(){
                console.log('Cancelled');
              }
            )
        }
      },

      handleReserveSlot: function(slot){
        if ( slot && slot.id ){
          ReservationService.reserveSlot(slot.id)
            .then(function(response){
              var idx = $scope.slots.indexOf(slot);
              $scope.slots[idx] = response.data;
              Notification.success('Slot was reserved');
            })
            .catch(function(err){
              console.error(err);
            })
        } else {
          console.error('Slot Id not present');
        }
      },

      handleDeleteSlot: function(slot){
        if ( slot && slot.id ){
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Are you sure you want to remove slot ?\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
                <button class="btn btn-primary" type="button" ng-click="handleSubmit()">Remove</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance){
              $scope.handleSubmit = function(){
                $uibModalInstance.close();
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            }
          });
          modal.result
            .then(
              function(){
                ReservationService.deteleReservationSlot(slot.id)
                  .then(function(){
                    var slt = $scope.slots.filter(function(item){
                      return item.id === slot.id;
                    })[0];
                    var idx = $scope.slots.indexOf(slt);
                    $scope.slots.splice(idx, 1);
                    Notification.success('Slot was removed');
                  })
                  .catch(function(err){
                    console.log(err);
                  });
              },
              function(){
                console.log('Cancelled');
              }
            )
        }
      }
    });

    $scope.isSameDayC = function(from, to){
      return moment(from).isSame(moment(to).subtract(1, 'days'), 'day');
    }
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
    .controller('OrganizerFormReservationController', OrganizerFormReservationController);

  OrganizerFormReservationController.$inject = [
    '$scope',
    '$uibModalInstance',
    'moment',
    'Notification',
    'ReservationService',
    '$$reservation',
    '$$boothId'
  ];

  function OrganizerFormReservationController(
    $scope,
    $uibModalInstance,
    moment,
    Notification,
    ReservationService,
    $$reservation,
    $$boothId
  ){
    $scope.formSubmitted = false;
    $scope.formLoading = false;

    $scope.startHourIsGreaterThanEnd = false;
    $scope.loading = false;
    $scope.hours = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24];
    // var timeZoneOffset = new Date().getTimezoneOffset();
    $scope.modalLabel = $$reservation ? 'Update' : 'Create';
    $scope.reservation = $$reservation ? $$reservation : {
      operatingHours: {
        start: null,
        end: null
      },
      isValid: false,
      // timeZone: timeZoneOffset < 0 ? 'GMT+'+ (timeZoneOffset/-60) : 'GMT-'+ (timeZoneOffset/60),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timeSlotLength: 'day',
      dayOfWeekPricing: {
        sunday: 0,
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0
      }
    };

    angular.extend($scope, {
      datepickerFormat: 'MMMM dd, yyyy',
      startOptions: {
        dateDisabled: false,
        minDate: new Date(),
        formatYear: 'yy',
        startingDay: 1
      },
      endOptions: {
        dateDisabled: false,
        minDate: new Date(),
        formatYear: 'yy',
        startingDay: 1
      },
      popup1: {
        opened: false
      },
      popup2: {
        opened: false
      },
      onPopup1Open: function(){
        $scope.popup1.opened = true;
      },
      onPopup2Open: function(){
        $scope.popup2.opened = true;
      }
    });

    angular.extend($scope, {
      onInit: function(){
        if ( $scope.reservation && $scope.reservation.id ){
          $scope.reservation['isValid'] = true;
          $scope.fromDate = moment(moment($scope.reservation.from)).local().toDate();
          $scope.toDate = moment(moment($scope.reservation.to)).subtract(1, 'days').local().toDate();

          $scope.onChangeDate($scope.fromDate, $scope.toDate);
        }
      },

      handleSubmit: function(){
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( !$scope.isDisabled() && form.$valid ){
          $scope.formLoading = true;
          var operatingHours = $scope.reservation.operatingHours;
          var data = $.extend($scope.reservation, {
            from: moment($scope.fromDate).format('YYYY-MM-DD') +'T00:00:00.000Z',
            to: moment($scope.toDate).add(1, 'day').format('YYYY-MM-DD') +'T00:00:00.000Z',
            boothId: $$boothId,
            operatingHours: {
              start: Number(operatingHours.start),
              end: Number(operatingHours.end)
            }
          });
          if ( $scope.reservation && $scope.reservation.id ) {
            ReservationService.updateReservation($scope.reservation.id, data)
              .then(function(response){
                $scope.loading = false;
                $scope.dayRange = [];
                $uibModalInstance.close(response.data);
              })
              .catch(function(){
                $scope.formLoading = false;
              });
          } else {
            ReservationService.createReservation(data)
              .then(function(response){
                $scope.dayRange = [];
                $uibModalInstance.close(response.data);
              })
              .catch(function(err){
                $scope.formLoading = false;
                Notification.error(err.data.message);
              });
          }
        }
      },

      isDisabled: function(){
        var result = false;
        // if ( $scope.form.$valid ){
        //   result = false;
        // } else {
        //   return true;
        // }
        if ( $scope.reservation.isValid ){
          result = false;
        } else {
          return true;
        }
        if ( !$scope.startHourIsGreaterThanEnd ){
          result = false
        } else {
          return true;
        }
        return result;
      },

      dayRange: [],

      onChangeDate: function(from, to){
        $scope.startDateIsGreaterThanEnd = false;

        $scope.dayRange = [];

        if ( from || to ){
          if ( from && to ){
            $scope.reservation.isValid = true;
            // $scope.isRequired = false;
            if ( moment(from).isAfter(to) ){
              if ( !moment(from).isSame(to, 'day') ){
                $scope.reservation.isValid = false;
                $scope.startDateIsGreaterThanEnd = true;
              }
            }
          } else {
            // $scope.isRequired = true;
            $scope.reservation.isValid = false;
          }
        } else {
          // $scope.isRequired = false;
          $scope.reservation.isValid = true;
        }

        if ( $scope.reservation.isValid && !$scope.startDateIsGreaterThanEnd ){
          var startDate = moment(from).format('MM/DD/YYYY');
          var endDate = moment(to).format('MM/DD/YYYY');
          var start = new Date(startDate);
          var end = new Date(endDate);

          while (start <= end){
            $scope.dayRange.push(moment(start).format('dddd').toLowerCase());
            var newDate = start.setDate(start.getDate() + 1);
            start = new Date(newDate);
          }
        }
      },

      isDayPresent: function(day){
        return $scope.dayRange.indexOf(day) !== -1;
      },

      handleChange: function(start, end){
        var s = Number(start);
        var e = Number(end);
        $scope.startHourIsGreaterThanEnd = ( s > e ? true : false);
      },

      handleClose: function(){
        $uibModalInstance.dismiss('Dissmissed');
      },

      toNumber: function(num){
        return Number(num);
      }
    });
  }
})();
(function(){
  'use strict';
  
  angular
    .module('eventmap')
    .controller('OrganizerUserProfileFormController', OrganizerUserProfileFormController);

    function OrganizerUserProfileFormController(
      $scope,
      $uibModalInstance,
      AuthService,
      SettingService,
      Notification,
      USA_STATES,
      userProfile
    ){
      var vm = this;
      vm.states = USA_STATES;
      vm.loading = false;

      $scope.formSubmitted = false;
      $scope.formLoading = false;
      $scope.settingsLoading = true;

      angular.extend($scope, {
        onInit: function(){
          vm.userProfile = userProfile;

          if ( vm.userProfile.smsOptOutStatus === 'opted_out_sms' ){
            SettingService.getSettingsByGroup('phone')
              .then(function(response){
                $scope.eventPhoneNumber = response.data[0];
                $scope.settingsLoading = false;
              })
              .catch(function(err){
                console.error(err);
              });
          }

          if (
            vm.userProfile.smsOptOutStatus === 'opted_in_app' ||
            vm.userProfile.smsOptOutStatus === 'opted_in_sms'
          ){
            vm.userProfile.smsOptOutCheckbox = false;
          } else {
            vm.userProfile.smsOptOutCheckbox = true;
          }
        },

        handleSubmit: function(){
          $scope.formSubmitted = true;
          var form = $scope.form;
          if ( form.$valid ) {
            // vm.loading = true;
            $scope.formLoading = true;

            if (
              vm.userProfile.smsOptOutCheckbox
            ){
              if ( vm.userProfile.smsOptOutStatus !== 'opted_out_sms' ){
                vm.userProfile.smsOptOutStatus = 'opted_out_app'
              }
            } else {
              if ( vm.userProfile.smsOptOutStatus !== 'opted_in_sms' ){
                vm.userProfile.smsOptOutStatus = 'opted_in_app'
              }
            }

            if ( vm.userProfile.phone1 && !vm.userProfile.phone1.number ){
              delete vm.userProfile['phone1'];
            }
            if ( vm.userProfile.phone2 && !vm.userProfile.phone2.number ){
              delete vm.userProfile['phone2'];
            }

            AuthService.onUpdateUserById(vm.userProfile)
              .then(function(response){
                // vm.loading = false;
                $uibModalInstance.close(response.data)
              })
              .catch(function(err){
                $scope.formLoading = false;
                Notification.error(err.data.message);
              })
          }
        },

        onClose: function(){
          $uibModalInstance.dismiss('Dissmissed');
        }
      });
    }


})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerParticipantsController', OrganizerParticipantsController);
  
  OrganizerParticipantsController.$inject = [
    '$scope'
  ];

  function OrganizerParticipantsController(
    $scope
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){}
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ModalMessageController', ModalMessageController);
  
  ModalMessageController.$inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$state',
    '$stateParams',
    'moment',
    'Notification',
    'AuthService',
    'UserGroupsService',
    'MessagesService',
    '$uibModalInstance',
    '$message'
  ];

  function ModalMessageController(
    $rootScope,
    $scope,
    $timeout,
    $state,
    $stateParams,
    moment,
    Notification,
    __auth,
    __groups,
    __messages,
    $uibModalInstance,
    $message
  ) {
    var vm = this;
    vm.messageBodyRequired = true;
    var userSearch;

    $scope.formRecipientError = false;
    $scope.formSubmitted = false;
    $scope.formLoading = false;

    angular.extend($scope, {
      label: ( $message ? 'Update' : 'Send'),
      searchType: 'vendor,volunteer,special,volunteerCoordinator,eventCoordinator,eo',
      userTypes: [
        { type: '', name: 'Choose type' },
        { type: 'all', name: 'All' },
        { type: 'vendors', name: $rootScope.currentEvent.preferences.vendorModule.label },
        { type: 'volunteers', name: $rootScope.currentEvent.preferences.volunteerModule.label }
      ],
      userSelectors: [
        { type: '', name: 'Choose selector' },
        { type: 'all', name: 'All' },
        { type: 'accepted', name: 'Accepted' },
        { type: 'idle', name: 'Idle' }
      ],
      datepickerFormat: 'MMMM dd, yyyy',
      datepickerOptions: {
        formatYear: 'yy',
        //maxDate: new Date(2020, 5, 22),
        minDate: new Date(),
        startingDay: 1
      },
      datepickerPopup: {
        opened: false
      },
      taToolbar: [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'fontColor'],
        ['bold', 'italics', 'underline', 'strikeThrough'],
        ['ul', 'ol'],
        ['redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
        ['html', 'insertImage','insertLink']
      ]
    });

    angular.extend($scope, {
      onInit: function() {
        vm.event = $rootScope.currentEvent;
        vm.participantModule = $rootScope.currentEvent.preferences.participantModule;
        vm.sponsorModule = $rootScope.currentEvent.preferences.sponsorModule;
        vm.vendorModule = $rootScope.currentEvent.preferences.vendorModule;

        vm.message = {
          body: null,
          recipientAliases: [],
          sendToEmail: false,
          sendToSms: false
        };

        if ( vm.event.modules.indexOf('participant') > -1 ) {
          $scope.searchType += ',participant';
          $scope.userTypes.push({
            type: 'participants',
            name: vm.participantModule.label
          });
        }

        if ( vm.event.modules.indexOf('sponsor') > -1 ) {
          $scope.searchType += ',sponsor';
          $scope.userTypes.push({
            type: 'sponsors',
            name: vm.sponsorModule.label
          });
        }

        vm.startDate = moment(new Date()).local().toDate();
        vm.startTime = moment(new Date()).local();

        __groups.getGroups()
          .then(
            function(response) {
              vm.userGroups = response.data;
            },
            $scope.handleError
          );

        if ( $message ) {
          var id = parseInt($message.id);
          __messages.getMessageById(id)
            .then(
              function(response) {
                var data = response.data;
                vm.message = data;

                if ( data.scheduledDate ) {
                  vm.scheduleDate = true;
                  vm.startDate = moment(moment.utc(data.scheduledDate)).local().toDate();
                  vm.startTime = moment(moment.utc(data.scheduledDate)).local();
                }

                if ( data.recipientAliases && data.recipientAliases.length ) {
                  var types = [];
                  angular.forEach(data.recipientAliases, function(aliase){
                    for ( var i = 0; i < $scope.userTypes.length; i++ ) {
                      var type = $scope.userTypes[i];
                      if ( type.type !== '' && aliase.indexOf(type.type) > -1 ) {
                        if ( types.indexOf(type.type) !== 0 ) {
                          types.push(type.type)
                        }
                      }
                    }
                    for ( var i = 0; i < $scope.userSelectors.length; i++ ) {
                      var selector = $scope.userSelectors[i];
                      if ( selector.type !== '' && aliase.indexOf(selector.type) > -1 ) {
                        if ( selector.type === 'all' ) {
                          vm.userSelector = 'all';
                        }
                        if ( selector.type === 'accepted' ) {
                          vm.userSelector = 'accepted';
                        }
                        if ( selector.type === 'idle' ) {
                          vm.userSelector = 'idle';
                        }
                      }
                    }
                  });

                  if ( types && types.length ) {
                    if (
                      types.indexOf('all') > -1
                    ) {
                      if ( types.indexOf('vendors') > -1 ) {
                        vm.userType = 'vendors';
                      }
                      if ( types.indexOf('volunteers') > -1 ) {
                        vm.userType = 'volunteers';
                      }
                      if ( types.indexOf('participants') > -1 ) {
                        vm.userType = 'participants';
                      }
                      if ( types.indexOf('participants') > -1 ) {
                        vm.userType = 'sponsors';
                      }
                      if ( types.indexOf('vendors') > -1 && types.indexOf('volunteers') > -1 ) {
                        vm.userType = 'all';
                      }
                    }
                  }
                }

                if ( data.recipientIds.length !== 0 ) {
                  __auth.getUsersByQuery(data.recipientIds)
                    .then(
                      function(response){
                        vm.recipientIds = response.data;
                      },
                      $scope.handleError
                    );
                }

                if ( data.recipientGroupIds.length !== 0 ) {
                  __groups.getGroupsByQuery(data.recipientGroupIds)
                    .then(
                      function(response){
                        vm.recipientGroupIds = response.data;
                      },
                      $scope.handleError
                    );
                }

              },
              $scope.handleError
            );
        }
      },

      handleUsersSearch: function(query) {
        $timeout.cancel(userSearch);
        if ( query.length !== 0 ) {
          userSearch = $timeout(function(){
            __groups.searchUsers($scope.searchType, query)
              .then(
                function(response){
                  vm.usersSearch = response.data;
                },
                $scope.handleError
              );
          }, 1000);
        }
      },

      onBlurBody: function(body){
        vm.messageBodyRequired = typeof body !== 'undefined' ? false : true;
      },

      onChangeUser: function() {
        vm.message.recipientAliases = [];
        if ( vm.userType && vm.userSelector ) {
          var type = vm.userType.toLowerCase();
          var selector = vm.userSelector.toLowerCase();
          if ( type === 'all') {
            if ( selector === 'all' ) {
              vm.message.recipientAliases = [
                'all_vendors',
                'all_volunteers'
              ];
              if ( vm.event.modules.indexOf('participant') > -1 ) {
                vm.message.recipientAliases.push('all_participants');
              }
              if ( vm.event.modules.indexOf('sponsor') > -1 ) {
                vm.message.recipientAliases.push('all_sponsors');
              }
            }
            if ( selector === 'accepted' ) {
              vm.message.recipientAliases = [
                'all_accepted_vendors',
                'all_accepted_volunteers'
              ];
              if ( vm.event.modules.indexOf('participant') > -1 ) {
                vm.message.recipientAliases.push('all_accepted_participants');
              }
              if ( vm.event.modules.indexOf('sponsor') > -1 ) {
                vm.message.recipientAliases.push('all_accepted_sponsors');
              }
            }
            if ( selector === 'idle' ) {
              vm.message.recipientAliases = [
                'all_idle_vendors',
                'all_idle_volunteers'
              ];
              if ( vm.event.modules.indexOf('participant') > -1 ) {
                vm.message.recipientAliases.push('all_idle_participants');
              }
              if ( vm.event.modules.indexOf('sponsor') > -1 ) {
                vm.message.recipientAliases.push('all_idle_sponsors');
              }
            }
          }
          if ( type === 'vendors' ) {
            vm.message.recipientAliases.push(selector === 'all' ? 'all_'+ type : 'all_'+ selector +'_'+ type);
          }
          if ( type === 'volunteers' ) {
            vm.message.recipientAliases.push(selector === 'all' ? 'all_'+ type : 'all_'+ selector +'_'+ type);
          }
          if ( type === 'participants' ) {
            vm.message.recipientAliases.push(selector === 'all' ? 'all_'+ type : 'all_'+ selector +'_'+ type);
          }
          if ( type === 'sponsors' ) {
            vm.message.recipientAliases.push(selector === 'all' ? 'all_'+ type : 'all_'+ selector +'_'+ type);
          }
        }
      },

      onShortText: function(txt) {
        if ( vm.message.sendToSms ) {
          if ( txt ) {
            if ( !vm.message.subject ) {
              vm.message.subject = txt;
            }
            if ( !vm.message.body ) {
              vm.message.body = txt;
            }
          }
        }
      },

      handleSubmit: function () {
        $scope.formSubmitted = true;
        $scope.formRecipientError = false;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;

          vm.message.sendToApp = true;
          vm.message.recipientIds = [];
          vm.message.recipientGroupIds = [];
          if ( vm.scheduleDate ) {
            vm.message.scheduledDate = moment(vm.startDate).set({
              hour: moment(vm.startTime).hour(),
              minute: moment(vm.startTime).minute()
            });
          }
          if ( vm.recipientIds ) {
            angular.forEach(vm.recipientIds, function(item){
              vm.message.recipientIds.push(item.id);
            });
          }
          if ( vm.recipientGroupIds ) {
            angular.forEach(vm.recipientGroupIds, function(item){
              vm.message.recipientGroupIds.push(item.id);
            });
          }
          if (
            vm.message.recipientIds.length ||
            vm.message.recipientGroupIds.length ||
            vm.message.recipientAliases.length
          ) {
            $uibModalInstance.close(vm.message);
          } else {
            $scope.formRecipientError = true;
            // Notification.error('No recipient(s) selected');
            $scope.formLoading = false;
          }
        }
      },

      handleClose: function () {
        $uibModalInstance.dismiss('cancel');
      },

      handleDatepickerPopup: function() {
        $scope.datepickerPopup.opened = true;
      },

      // onClose: function() {
      //   // $state.go( $state.current.name.replace(( $state.params && $state.params.id ? '.update' : '.send' ), ''));
      //   $state.go('users.organizer.messages.inbox');
      // },

      handleError: function(err) {
        Notification.error(err.data.message);
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerMessagesController', OrganizerMessagesController);
  
  OrganizerMessagesController.$inject = [
    '$rootScope',
    '$scope',
    '$location',
    '$uibModal',
    'Notification',
    'MessagesService'
  ];

  function OrganizerMessagesController(
    $rootScope,
    $scope,
    $location,
    $uibModal,
    Notification,
    __messages
  ) {
    angular.extend($scope, {
      _:_
    });

    angular.extend($scope, {
      onInit: function() {},

      openModalMessage: function(){
        var modal = $uibModal.open({
          templateUrl: 'app/users/organizer/messages/messages.form.html',
          controller: 'ModalMessageController',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            $message: function(){
              return false;
            }
          }
        });

        modal.result
          .then(
            function(resolve){
              $rootScope.loadingInformation = true;
              __messages.sentMessage(resolve)
                .then(
                  function(response){
                    $rootScope.loadingInformation = false;
                    Notification.success('Message was sent');
                    if ( $location.$$path.indexOf('/organizer/messages/sent') !== -1 ){
                      __messages.add(response.data);
                    }
                  },
                  function(err){
                    $rootScope.loadingInformation = false;
                    Notification.error(err.data.messate);
                  }
                );
            },
            function(){
              console.log('Dissmissed');
            }
          );
      },

      handleError: function(err){
        console.log(err.data.message);
      }
    });
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerMapController', OrganizerMapController);

  OrganizerMapController.$inject = ['$scope'];

  function OrganizerMapController($scope) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){}
    })
  }
})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerLoginAsController', OrganizerLoginAsController);

  function OrganizerLoginAsController(
    $rootScope,
    $scope,
    $state,
    $uibModalInstance,
    Notification,
    AuthService,
    loginAs
  ) {
    var vm = this;
    $scope.formLoading = false;
    $scope.formSubmitted = false;

    angular.extend($scope, {
      asUser: {
        username: $rootScope.currentUser.username,
        password: ''
      },
      handleSubmit: function(){
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          $scope.asUser.loginAs = loginAs.id;
          AuthService.onLogin($scope.asUser)
            .then(
              function(response){
                AuthService.setCredentialAuth(response.data, true);
                AuthService.getUser()
                  .then(
                    function(response){
                      var data = response.data;
                      var portal = false;
                      AuthService.setCredentialUser(data, portal);
                      $rootScope.accessPortal = portal;

                      switch (data.type) {
                        case 'vendor':
                          $state.go('users.vendor.event');
                          AuthService.setReturnUrl('/organizer/vendors/all');
                          break;
                        case 'volunteer':
                          $state.go('users.volunteer.event');
                          AuthService.setReturnUrl('/organizer/volunteers/all');
                          break;
                        case 'participant':
                          $state.go('users.participant.event');
                          AuthService.setReturnUrl('/organizer/participants/all');
                          break;
                        case 'special':
                          $state.go('users.special.mainMap');
                          AuthService.setReturnUrl('/organizer/special-users');
                          break;
                        case 'sponsor':
                          $state.go('users.sponsor.event');
                          AuthService.setReturnUrl('/organizer/sponsors/all');
                          break;
                        default:
                          $state.go('app.home');
                      }
                      $scope.handleClose();
                    },
                    $scope.handleError
                  );
              },
              $scope.handleError
            )
        }
      },
      handleClose: function(){
        $scope.formLoading = false;
        $uibModalInstance.dismiss('cancel');
      },
      handleError: function(err){
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    })
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerEventController', OrganizerEventController);
  
  OrganizerEventController.$inject = [
    '$scope'
  ];
  
  function OrganizerEventController(
    $scope
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){}
    });
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('MessagesSentController', MessagesSentController);
  
  MessagesSentController.$inject = [
    '$scope',
    '$state',
    'MessagesService'
  ];

  function MessagesSentController(
    $scope,
    $state,
    MessagesService
  ){
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;
        vm.userState = ( $state.current.name.indexOf('.preview') !== -1 ? $state.current.name : $state.current.name + '.preview' );

        MessagesService.getSentMessages()
          .then(
            function(response){
              vm.sentMessages = MessagesService.messages(response.data);
            },
            $scope.handleError
          );
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('MessagesPreviewController', MessagesPreviewController);
  
  MessagesPreviewController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    '$uibModal',
    'moment',
    'Notification',
    'MessagesService',
    'AuthService',
    'UserGroupsService'
  ];
  
  function MessagesPreviewController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $uibModal,
    moment,
    Notification,
    __messages,
    __auth,
    __groups
  ) {
    var vm = this;
    var pref = $scope.currentEvent.preferences;
    var vendorModule = pref.vendorModule;
    var volunteerModule = pref.volunteerModule;
    var participantModule = pref.participantModule;
    var sponsorModule = pref.sponsorModule;

    vm.allowToEditMessage = false;
    vm.sendTo = [];

    vm.sentBy = null;

    angular.extend($scope, {
      onInit: function(){
        var id = parseInt($stateParams.id, 10);
        var recipientId = parseInt($stateParams.recipientId, 10);

        var type = $stateParams.type;
        var user = $stateParams.user;
        var appType = $stateParams.appType;

        if ( typeof id !== 'undefined' ) {
          if ( type === 'sent' ) {
            __messages.getMessageById(id)
              .then(
                function(response){
                  var data = response.data;
                  vm.message = data;

                  if ( user.indexOf('eo') !== -1 ){
                    if ( vm.message.createdBy === $rootScope.currentUser.id ){
                      vm.sentBy = 'Sent by me';
                    } else {
                      __auth.getUserById(data.createdBy)
                        .then(
                          function(response){
                            vm.sentBy = 'Sent by '+ response.data.name;
                          }
                        );
                    }
                  }
                  if (
                    user.indexOf('eo') !== -1 ||
                    user.indexOf('special') !== -1 ||
                    user.indexOf('volunteerCoordinator') !== -1 ||
                    user.indexOf('eventCoordinator') !== -1
                  ) {
                    if ( data.scheduledDate ) {
                      if ( moment(moment.utc(data.scheduledDate, 'YYYY-MM-DD[T]HH:mm:ss')).diff(moment()) > 0 ) {
                        vm.allowToEditMessage = true;
                      }
                    }
                    $scope.onSendTo(data);
                  }
                },
                $scope.handleError
              );
          } else if ( type === 'inbox' ) {
            // var tp = type === 'inbox' ? 'app' : 'sms_income';
             __messages.getInboxMessageById(id, recipientId, appType)
              .then(
                function(response){
                  var data = response.data;
                  vm.message = data;

                  if ( user.indexOf('eo') !== -1 && data.createdBy !== undefined) {
                    __auth.getUserById(data.createdBy)
                      .then(
                        function(response){
                          var data = response.data;
                          vm.message.fromName = data.name;
                          vm.message.fromEmail = data.email;
                          if ( data.type === 'vendor' ){
                            vm.message.fromType = vendorModule.label;
                          } else if ( data.type === 'volunteer' ){
                            vm.message.fromType = volunteerModule.label;
                          } else if ( data.type === 'participant' ){
                            vm.message.fromType = participantModule.label;
                          } else if ( data.type === 'sponsor' ){
                            vm.message.fromType = sponsorModule.label;
                          } else {
                            vm.message.fromType = data.type;
                          }
                        },
                        function(err){
                        }
                      );
                  }
                },
                $scope.handleError
              );
          }
        }
      },

      handleRemove: function(message) {
        if ( message ) {
          var modal = $uibModal.open({
            size: 'md',
            template: '\
              <div class="modal-header">\
                <h4 class="modal-title text-danger" style="text-align: center;">\
                  Are you sure you want to delete message?\
                </h4>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                  <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
                </button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance, message, MessagesService){
              $scope.loading = false;
              
              $scope.handleConfirm = function(){
                $scope.loading = true;

                MessagesService.onDelete(message.id)
                  .then(
                    function(){
                      $uibModalInstance.close(message);
                      $scope.loading = false;
                    },
                    function(err){
                      $uibModalInstance.dismiss('cancel');
                      $scope.loading = false;
                      Notification.error(err.data.message);
                    }
                  );
              }

              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            },
            resolve: {
              message: function(){
                return message;
              }
            }
          });

          modal.result
            .then(
              function(result){
                __messages.remove(result);
                Notification.success('Message was deleted');
                $state.go('users.organizer.messages.sent');
              },
              function() {
              }
            );
        }
      },

      onSendTo: function(data) {
        if ( data.recipientAliases && data.recipientAliases.length !== 0 ) {
          angular.forEach(data.recipientAliases, function(item){
            var result = capitalizeFirstLetter(item).replace(/_/g, ' ');
            vm.sendTo.push(result);
          });
        }
        if ( data.recipientGroupIds && data.recipientGroupIds.length !== 0 ) {
          __groups.getGroupsByQuery(data.recipientGroupIds)
            .then(
              function(response){
                angular.forEach(response.data, function(item){
                  vm.sendTo.push(item.name + ' User Group');
                });
              },
              $scope.handleError
            );
        }
        if ( data.recipientIds && data.recipientIds.length !== 0 ) {
          __auth.getUsersByQuery(data.recipientIds)
            .then(
              function(response){
                angular.forEach(response.data, function(item){
                  vm.sendTo.push(item.name);
                });
              },
              $scope.handleError
            ); 
        }
      },

      openModalMessage: function(id, message){
        var modal = $uibModal.open({
          templateUrl: 'app/users/organizer/messages/messages.form.html',
          controller: 'ModalMessageController',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            $message: function(){
              return message;
            }
          }
        });

        modal.result
          .then(
            function(resolve){
              __messages.onUpdate(id, resolve)
                .then(
                  function(response){
                    __messages.update(response.data);
                    Notification.success('Message was updated');
                    $state.go('users.organizer.messages.sent');
                  },
                  $scope.handleError
                );
            },
            function(){
            }
          );
      },

      handleError: function(err) {
        Notification.error(err.data.message);
      }
    });

    function capitalizeFirstLetter(string){
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('MessageModalController', MessageModalController);
  
  MessageModalController.$inject = [
    '$scope',
    '$uibModalInstance'
  ];

  function MessageModalController(
    $scope,
    $uibModalInstance
  ){
    var vm = this;

    $scope.formLoading = false;
    $scope.formSubmitted = false;

    angular.extend($scope, {
      onInit: function(){
        
      },
      handleSubmit: function () {
        // $scope.formLoading = false;
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          vm.message.sendToApp = true;
          $uibModalInstance.close(vm.message);
        }
      },
      handleClose: function () {
        $uibModalInstance.dismiss('cancel');
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('MessagesInboxController', MessagesInboxController);
  
  MessagesInboxController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    'MessagesService'
  ];

  function MessagesInboxController(
    $rootScope,
    $scope,
    $state,
    MessagesService
  ){
    var vm = this;
    vm.currentUser = $rootScope.currentUser;

    angular.extend($scope, {
      onInit: function(){
        vm.currentPage = 1;
        vm.userState = ( $state.current.name.indexOf('.preview') !== -1 ? $state.current.name : $state.current.name + '.preview' );

        var type = $rootScope.currentUser.type;

        if ( type === 'eventCoordinator' ){
          type = 'eo';
        }

        MessagesService.getInboxMessages()
          .then(function(response){
            var data = response.data;
            var dataIDs = data.map(function(item){ return item.id });
            var duplicateIDs = [];
            var messages = [];

            if ( $rootScope.currentUser.type === 'eo' ){

              dataIDs.forEach(function(item, idx){
                if ( dataIDs.indexOf(item, idx + 1) > -1 ){
                  if ( duplicateIDs.indexOf(item) === -1 ){
                    duplicateIDs.push(item);
                  }
                }
              });

              for ( var i in data ){
                var message = data[i];
                if ( duplicateIDs.indexOf(message.id) !== -1 ){
                  if ( message.recipientId === $rootScope.currentUser.id ){
                    messages.push(message);
                  } else {
                    var msg = messages.find(function(item){
                      return item.id === message.id;
                    });
                    if ( typeof msg === 'undefined' ){
                      messages.push(data.find(function(item){
                        return item.id === message.id
                      }));
                    }
                  }
                } else {
                  messages.push(message);
                }
              }

              messages.sort(function(a, b){ return a.id - b.id });
            } else {
              messages = data;
            }
            vm.inboxMessages = MessagesService.messages(messages);
          });

        MessagesService.getInboxUnreadCount()
          .then(function(response){
            $scope.$emit(type +'InboxUnreadCount', response.data);
          });
      },
      handleMarkAsRead: function(message){
        var type = $rootScope.currentUser.type;
        if ( type === 'eventCoordinator' ){
          type = 'eo';
        }
        if (
          message && message.id && message.status === 'pending' &&
          message.recipientId === vm.currentUser.id
        ){
          MessagesService.markAsRead(message.id, message.type)
            .then(
              function(response){
                var data = response.data;
                for ( var i in vm.inboxMessages ){
                  var msg = vm.inboxMessages[i];
                  if ( msg.id === data.id ){
                    var idx = vm.inboxMessages.indexOf(msg);
                    vm.inboxMessages[idx]['status'] = data.status;
                  }
                }

                MessagesService.getInboxUnreadCount()
                  .then(
                    function(response){
                      $scope.$emit(type +'InboxUnreadCount', response.data);
                    }
                  )
              },
              $scope.handleError
            );
        }
      },
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('VolunteerCoordinatorController', VolunteerCoordinatorController);
  
  VolunteerCoordinatorController.$inject = [
    '$rootScope',
    '$scope',
    '$interval',
    'MessagesService'
  ];

  function VolunteerCoordinatorController(
    $rootScope,
    $scope,
    $interval,
    MessagesService
  ) {
    var vm = this;
    $scope.unreadCountInterval = null;

    vm.currentUser = $rootScope.currentUser;
    vm.event = $rootScope.currentEvent;

    angular.extend($scope, {
      onInit: function(){
        vm.volunteerModule = vm.event.preferences.volunteerModule;

        $scope.getInboxUnreadCount();
        $scope.unreadCountInterval = $interval(function(){
          $scope.getInboxUnreadCount();
        }, 30000);
      },

      getInboxUnreadCount: function(){
        MessagesService.getInboxUnreadCount()
          .then(function(response){
            vm.inboxUnreadCount = response.data;
          });
      },

      handleError: function(err){
        console.log(err);
      }
    });

    $scope.$on('$destroy', function(){
      $interval.cancel($scope.unreadCountInterval);
    });

    $scope.$on('volunteerCoordinatorInboxUnreadCount', function(event, data){
      vm.inboxUnreadCount = data;
    });
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('VolunteerController', VolunteerController);
  
  VolunteerController.$inject = [
    '$rootScope',
    '$scope',
    '$interval',
    'MessagesService',
    'VolunteerService'
  ];

  function VolunteerController(
    $rootScope,
    $scope,
    $interval,
    MessagesService,
    VolunteerService
  ) {
    var vm = this;
    $scope.unreadCountInterval = null;

    vm.currentUser = $rootScope.currentUser;
    vm.currentEvent = $rootScope.currentEvent;

    angular.extend($scope, {
      hasAcceptedRequest: false,
      onInit: function(){
        VolunteerService.getRequestsByUserId()
          .then(function(response){
            $scope.checkAcceptedRequest(response.data);
          })
          .catch(function(err){
            console.log(err);
          });

        $scope.getInboxUnreadCount();
        $scope.unreadCountInterval = $interval(function(){
          $scope.getInboxUnreadCount();
        }, 30000);
      },

      checkAcceptedRequest: function(requests){
        if ( requests && requests.length ){
          for ( var i in requests ){
            if ( requests[i].status === 'accepted' ){
              $scope.hasAcceptedRequest = true;
              break;
            }
          }
        }
      },

      getInboxUnreadCount: function(){
        MessagesService.getInboxUnreadCount()
          .then(function(response){
            vm.inboxUnreadCount = response.data;
          });
      },

      handleError: function(err){
        console.log(err);
      }
    });

    $scope.$on('$destroy', function(){
      $interval.cancel($scope.unreadCountInterval);
    });

    $scope.$on('volunteerInboxUnreadCount', function(event, data){
      vm.inboxUnreadCount = data;
    });
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('VendorController', VendorController);
  
  VendorController.$inject = [
    '$rootScope',
    '$scope',
    '$interval',
    'MessagesService'
  ];

  function VendorController(
    $rootScope,
    $scope,
    $interval,
    MessagesService
  ) {
    var vm = this;
    $scope.unreadCountInterval = null;
    
    vm.currentUser = $rootScope.currentUser;
    vm.currentEvent = $rootScope.currentEvent;
    vm.inboxUnreadCount = 0;

    angular.extend($scope, {
      onInit: function(){
        $scope.getInboxUnreadCount();
        $scope.unreadCountInterval = $interval(function(){
          $scope.getInboxUnreadCount();
        }, 30000);
      },
      getInboxUnreadCount: function(){
        MessagesService.getInboxUnreadCount()
          .then(function(response){
            vm.inboxUnreadCount = response.data;
          });
      },
      handleError: function(err){
        console.log(err);
      }
    });

    $scope.$on('$destroy', function(){
      $interval.cancel($scope.unreadCountInterval);
    });

    $scope.$on('vendorInboxUnreadCount', function(event, data){
      vm.inboxUnreadCount = data;
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('UserScheduleController', UserScheduleController);
  
  UserScheduleController.$inject = [
    '$rootScope',
    '$scope',
    'moment',
    'ScheduleService'
  ];

  function UserScheduleController(
    $rootScope,
    $scope,
    moment,
    ScheduleService
  ){
    var vm = this;
    vm.dateRange = null;

    $scope.event = $rootScope.currentEvent;

    var minMd = 992;
    var minSm = 768;
    var minXs = 480;

    // Program
    vm.program = null;
    vm.locations = [];

    $scope.currentDate = moment();

    angular.extend($scope, {
      moment: moment,
      onInit: function(){
        vm.dateRange = $scope.buildDateArray($scope.currentDate);

        var pref = $scope.event.preferences;

        // $scope.vendorModule = pref.vendorModule;
        // $scope.volunteerModule = pref.volunteerModule;
        // $scope.participantModule = pref.participantModule;
        // $scope.sponsorModule = pref.sponsorModule;
        $scope.scheduleModule = pref.scheduleModule;

        $scope.getSchedulesByType($rootScope.currentUser.type, function(data){
          vm.schedules = data;

          $scope.buildProgram();
        });

        window.onresize = function(){
          vm.dateRange = $scope.buildDateArray($scope.currentDate);

          $scope.buildProgram();

          $scope.$apply();
        }

        var height = window.innerHeight;
        setTimeout(function(){
          var list = document.querySelectorAll('.programList');
          // var calcHeight = vm.scheduleModule.groupByLocation && vm.locations.length > 1 ? 374 : 274;
          var calcHeight = 320;
          if ( list.length ){
            for ( var i in list ){
              var item = list[i];
              if ( item && item.style ) item.style.height = height - calcHeight +'px';
            }
          }
        }, 500);
      },

      // handleClose: function(){
      //   $uibModalInstance.dismiss('Cancel')
      // },

      getSchedulesByType: function(type, cb){
        ScheduleService.getSchedules(type)
          .then(
            function(response){
              if ( cb ) cb(response.data);
            },
            function(err){
              console.error(err);
            }
          );
      },

      handlePrevSlide: function(){
        $scope.currentDate.subtract(1, 'd');

        vm.dateRange = $scope.buildDateArray($scope.currentDate);

        $scope.buildProgram();
      },

      currentDate: moment(),

      handleNextSlide: function(){
        $scope.currentDate.add(1, 'd');

        vm.dateRange = $scope.buildDateArray($scope.currentDate);

        $scope.buildProgram();
      },

      formatTime: function(date){
        return moment(date).format('hh:mm a');
      },

      buildDateArray: function(startDate){
        var result = [];
        var days = 3;

        if ( window.innerWidth <= minMd && window.innerWidth >= minSm + 1 ){
          days = 2;
        } else if ( window.innerWidth <= minSm && window.innerWidth >= minXs + 1 ){
          days = 1;
        } else if ( window.innerWidth <= minXs ) {
          days = 0;
        }

        var startDate = moment(moment.utc(startDate)).local();
        var endDate = moment(moment.utc(moment(startDate).add(days, 'days'))).local();

        while (startDate <= endDate) {
          result.push(moment(startDate).format('MMMM DD, YYYY'))
          startDate = moment(startDate).add(1, 'd');
        }
        return result;
      },

      buildProgram: function(){
        vm.locations = [];

        for ( var i in vm.schedules ){
          var schedule = vm.schedules[i];
          if ( vm.locations.indexOf(schedule.location) === -1 ){
            vm.locations.push(schedule.location);
          }
        }
        // Generate programs
        vm.program = vm.dateRange.map(function(item){
          // Programs
          var programs = [];
          for ( var j in vm.schedules ){
            var schedule = $.extend({}, vm.schedules[j], {
              start: moment(moment.utc(vm.schedules[j].start)).local(),
              end: moment(moment.utc(vm.schedules[j].end)).local()
            });
            if ( moment(item).isSame(schedule.start, 'day') ){
              programs.push(schedule);
            }
          }

          if ( $scope.scheduleModule.groupByLocation ){
            // Day locations
            var dayLocations = [];
            for ( var k in programs ){
              var program = programs[k];
              if ( dayLocations.indexOf(program.location) === -1 ){
                dayLocations.push(program.location);
              }
            }
            // Location schedule
            var locations = [];
            for ( var l in dayLocations ){
              var schedules = [];
              for ( var m in programs ){
                if ( programs[m].location === dayLocations[l] ){
                  schedules.push(programs[m]);
                }
              }
              locations.push({
                name: dayLocations[l],
                schedules: schedules
              });
            }
            return {
              date: item,
              locations: locations
            };
          } else {
            return {
              date: item,
              schedules: programs
            }
          }
        });
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .directive('textEditorGallery', textEditorGallery);

  function textEditorGallery(){
    return {
      restrict: 'E',
      templateUrl: 'app/directives/text-editor-gallery/text-editor-gallery.html',
      scope: {
        tegName: '@',
        tegLabel: '@',
        tegModel: '=',
        tegRequired: '@',
        tegForm: '=',
        tegSubmitted: '=',
        tegClick: '&'
      },
      transclude: {
        body: '?textEditorGalleryBody'
      },
      link: function(scope, element, attrs){
        

        if ( typeof scope.tegRequired !== 'undefined' ){
          scope.required = scope.tegRequired === 'true' ? true : false;
        } else {
          scope.required = false;
        }

        if ( typeof scope.tegLabel !== 'undefined' ){
          scope.label = scope.tegLabel;
        } else {
          scope.label = '';
        }

        if ( typeof scope.tegSubmitted !== 'undefined' ){
          scope.submitted = scope.tegSubmitted;
        } else {
          scope.submitted = false;
        }

        scope.$watch('tegSubmitted', function(newValue, oldValue) {
          scope.submitted = newValue;
        }, true);
      },
      controller: TextEditorGalleryController
    }
  }

  TextEditorGalleryController.$inject = [
    '$scope',
    '$uibModal'
  ];

  function TextEditorGalleryController(
    $scope,
    $uibModal
  ){
    $scope.selectedMedia = [];

    angular.extend($scope, {
      taToolbarOptions: [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'fontColor'],
        ['bold', 'italics', 'underline', 'strikeThrough'],
        ['ul', 'ol'],
        ['redo', 'undo', 'clear'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
        ['html', 'insertImage','insertLink'],
        ['insertVideoYoutube', 'insertVideoVimeo']
      ],

      onInit: function(){
      },

      openMediaDialog: function(){
        var modal = $uibModal.open({
          templateUrl: 'app/directives/text-editor-gallery/media-modal.html',
          controller: 'MediaModalController',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            boothPhotos: function(){
              return [];
            },
            isTextEditor: function(){
              return true;
            }
          }
        });

        modal.result
          .then(
            function(result){
              $scope.selectedMedia = result;
            },
            function(cancel){
            }
          );
      },

      setMediaOnCursorPosition: function() {
        if ( $scope.selectedMedia.length ) {
          var rango;
          var sel = window.getSelection();
          if ( sel.getRangeAt && sel.rangeCount ){
            var rango = sel.getRangeAt(0);
            for ( var i = 0; i < $scope.selectedMedia.length; i++ ){
              var media = $scope.selectedMedia[i];

              var img = document.createElement('img');
              var p = document.createElement('p');
              img.src = media.link;
              p.appendChild(img);

              rango.insertNode(p);
            }

            $scope.selectedMedia = [];
            return sel.getRangeAt(0);
          }
        } else {
          $scope.tegClick();
          // console.log($scope);
        }
      },
    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('MediaModalController', MediaModalController);

  function MediaModalController(
    $scope,
    $uibModal,
    $uibModalInstance,
    Notification,
    FileService,
    boothPhotos,
    isTextEditor
  ){
    $scope.isTextEditor = isTextEditor;
    $scope.boothPhotos = typeof boothPhotos !== 'undefined' ? boothPhotos : [];

    $scope.modalLoading = true;

    $scope.mediaSource = 'gallery';

    $scope.mediaList = [];
    $scope.selectedMediaList = [];

    $scope.allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg|\.ico)$/i;

    // Upload media button
    $scope.uploadMediaLoading = false;
    $scope.uploadMediaDisabled = false;

    angular.extend($scope, {
      onInit: function(){
        // Load media files
        FileService.getFiles($scope.mediaSource)
          .then(function(response){
            $scope.mediaList = response.data;
            $scope.modalLoading = false;
          })
          .catch(function(err){
            console.error(err);
          });
      },

      handleAdd: function(){
        if ( $scope.selectedMediaList.length ){
          $uibModalInstance.close($scope.selectedMediaList);
        } else {
          Notification.error('Please select media to add it to text editor');
        }
      },

      handleClose: function() {
        $uibModalInstance.dismiss('cancel');
      },

      handleUploadMedia: function(evt, type){
        var files = evt.target.files;

        var maxImage360Size = 4096;

        $scope.uploadMediaLoading = true;
        $scope.uploadMediaDisabled = true;

        angular.forEach(files, function(file, index){
          if ( !$scope.allowedExtensions.exec(file.name) ){
            Notification.error('Allowed upload only image files. Please choose another');
            $scope.uploadMediaLoading = false;
            $scope.uploadMediaDisabled = false;
            return false;
          }

          if ( type === 'image_360' ){
            var img = new Image();
            img.src = window.URL.createObjectURL(file);
            img.onload = function(){
              if ( img.naturalWidth <= maxImage360Size ){
                FileService.onAdd(file, $scope.mediaSource, type)
                  .then(function(response){
                    $scope.mediaList.push(response.data);

                    if ( index === files.length - 1 ){
                      $scope.uploadMediaLoading = false;
                      $scope.uploadMediaDisabled = false;
          
                      Notification.success('All media file(s) was uploaded');
          
                      var fileElement = angular.element('#uploadMedia');
                      angular.element(fileElement).val(null);
                    }
                  })
                  .catch(function(err){
                    Notification.error(err.data.message);
                  });
              } else {
                Notification.error('Image size is more than 4096px');
                $scope.uploadMediaLoading = false;
                $scope.uploadMediaDisabled = false;
              }
            }
          } else {
            FileService.onAdd(file, $scope.mediaSource, type)
              .then(function(response){
                $scope.mediaList.push(response.data);

                if ( index === files.length - 1 ){
                  $scope.uploadMediaLoading = false;
                  $scope.uploadMediaDisabled = false;
      
                  Notification.success('All media file(s) was uploaded');
      
                  var fileElement = angular.element('#uploadMedia');
                  angular.element(fileElement).val(null);
                }
              })
              .catch(function(err){
                Notification.error(err.data.message);
              });
          }
        })
      },

      handlePreview: function(media){
        if ( media && media.id ){
          $uibModal.open({
            templateUrl: 'app/users/organizer/event/media-gallery/360-modal.html',
            controller: 'MediaGallery360Controller as vm',
            backdrop: 'static',
            resolve: {
              resolveMedia: function(){
                return media;
              }
            }
          });
        }
      },

      handleSelectMedia: function(media){
        var idx = $scope.selectedMediaList.indexOf(media);
        if ( idx !== -1 ){
          $scope.selectedMediaList.splice(idx, 1);
        } else {
          $scope.selectedMediaList.push(media);
        }
      },

      // handleSelectMedia: function(media){
      //   $scope.selectedMediaList.push(media);
      // },

      // handleUnselectMedia: function(media){
      //   var idx = $scope.selectedMediaList.indexOf(media);
      //   $scope.selectedMediaList.splice(idx, 1);
      // },

      handleDeleteMedia: function(media){
        if ( media && media.id ){
          $scope.uploadMediaDisabled = true;
          var modal = $uibModal.open({
            template: '\
              <div class="modal-header">\
                <h3 class="modal-title" style="text-align: center;">\
                  Are you sure you want to delete media ?\
                </h3>\
              </div>\
              <div class="modal-footer">\
                <button class="btn btn-primary" type="button" ng-click="handleDelete()">Delete</button>\
                <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
              </div>\
            ',
            controller: function($scope, $uibModalInstance){
              $scope.handleDelete = function(){
                $uibModalInstance.close();
              }
              $scope.handleCancel = function(){
                $uibModalInstance.dismiss('cancel');
              }
            }
          });

          modal.result
            .then(
              function(){
                FileService.onDelete(media.id)
                  .then(function(){
                    var idx = $scope.mediaList.indexOf(media);
                    $scope.mediaList.splice(idx, 1);
                    $scope.uploadMediaDisabled = false;

                    if ( $scope.selectedMediaList.indexOf(media) > -1 ){
                      var sIDX = $scope.selectedMediaList.indexOf(media);
                      $scope.selectedMediaList.splice(sIDX, 1);
                    }

                    Notification.success('Media file was deleted');
                  })
                  .catch(function(err){
                    console.error(err);
                    $scope.uploadMediaDisabled = false;
                  });
              },
              function() {
                $scope.uploadMediaDisabled = false;
              }
            );
        } else {
          Notification.error('Cannot find media ID');
        }
      }
    });

    $scope.isMediaDisabled = function(media){
      var result = false;
      if ( $scope.boothPhotos.length === 0 ) return result;

      for ( var i in $scope.boothPhotos ){
        var boothPhoto = $scope.boothPhotos[i];
        if ( boothPhoto.id === media.id ){
          result = true;
          break;
        }
      }
      return result;
    };

    // Modal closing
    $scope.$on('modal.closing', function(event, reason, closed){
      if ( $scope.uploadMediaLoading || $scope.uploadMediaDisabled ){
        event.preventDefault();
      }
    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('SponsorAttendantController', SponsorAttendantController);
  
  function SponsorAttendantController(
    $rootScope,
    $scope,
    $uibModal,
    SponsorService,
    PageService
  ) {
    var vm = this;
    vm.sponsorsHeadline = [];
    vm.sponsorsSecondary = [];

    vm.requests = [];

    angular.extend($scope, {
      onInit: function(){

        vm.currentUser = $rootScope.currentUser;
        vm.event = $rootScope.currentEvent;
        vm.billingPreferences = vm.event.billingPreferences;
        vm.preferences = vm.event.preferences;
        vm.participantModule = vm.event.preferences.participantModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        vm.eventStartDate = moment(moment.utc(vm.event.start)).local().format('MMMM DD, YYYY');
        vm.eventStartTime = moment(moment.utc(vm.event.start)).local().format('hh:mm a');
        vm.eventEndDate = moment(moment.utc(vm.event.end)).local().format('MMMM DD, YYYY');
        vm.eventEndTime = moment(moment.utc(vm.event.end)).local().format('hh:mm a');

        if ( moment(vm.eventStartDate).isSame(vm.eventEndDate, 'day') ){
          vm.isSameDate = true;
        }

        SponsorService.getSponsors('innerPages', true, true)
          .then(
            function(response){
              var arrays = [];
              angular.forEach(response.data, function(sponsor){
                if ( sponsor.headline ) {
                  vm.sponsorsHeadline.push(sponsor);
                } else {
                  arrays.push(sponsor);
                }
              });

              for ( var i = 0; i < arrays.length; i += 2 ) {
                if ( arrays.length > 8 ){
                  vm.sponsorsSecondary.push(arrays.slice(i, i + 2));
                } else {
                  vm.sponsorsSecondary = arrays;
                }
              }

            },
            $scope.handleError
          );

        PageService.getPageByTag('fixed', 'appFormSponsorAttendant')
          .then(
            function(response) {
              vm.appFormSponsorAttendant = response.data[0];
            },
            $scope.handleError
          );

        SponsorService.getMyAttendantRequests()
          .then(function(response){
            ;
            vm.requests = response.data;
          })
          .catch(function(err){
            console.error(err);
          });
      },

      handleDonation: function() {
        $uibModal.open({
          templateUrl: 'app/donations-form/donations-form.html',
          controller: 'DonationFormController',
          controllerAs: 'vm',
          resolve: {
            relocate: function(){
              return false;
            }
          }
        });
      },

      showEventPass: function(request) {
        if ( request && request.id ) {
          var modal = $uibModal.open({
            templateUrl: 'app/users/sponsor-attendant/ep-request/ep-request.html',
            controller: 'SponsorAttendantEventPassRequestController',
            controllerAs: 'vm',
            size: 'md',
            windowClass: 'modal-event-pass-participant',
            resolve: {
              sponsorRequest: function(){
                return request;
              }
            }
          });
          modal.result
            .then(
              function(result){
                // console.log(result);
              },
              function(result) {
                // console.log(result);
                for ( var i in vm.requests ){
                  var rq = vm.requests[i];
                  if ( rq.id === result.id ){
                    var idx = vm.requests.indexOf(rq);
                    vm.requests[idx] = result;
                  }
                }
              }
            );
        }
      },
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('SponsorController', SponsorController);

  function SponsorController(
    $rootScope,
    $scope,
    $interval,
    MessagesService,
    SponsorService
  ) {
    var vm = this;
    $scope.unreadCountInterval = null;
  
    vm.currentEvent = $rootScope.currentEvent;
    vm.currentUser = $rootScope.currentUser;

    $scope.showAttendantTab = false;

    angular.extend($scope, {
      onInit: function(){

        SponsorService.resetSponsors();

        SponsorService.getMyRequests()
          .then(function(response){
            var data = response.data;

            $scope.$broadcast('sponsorRequests', SponsorService.sponsors(response.data));

            $scope.showAttendant(data);
          });

        $scope.getInboxUnreadCount();
        $scope.unreadCountInterval = $interval(function(){
          $scope.getInboxUnreadCount();
        }, 30000);
      },

      showAttendant: function(requests){
        var total = 0;
        var availablePricePackages = [];
        var acceptedMyRequests = [];

        for ( var i in requests ){
          if ( requests[i].status === 'accepted' ){
            acceptedMyRequests.push(requests[i]);
          }
        }

        for ( var i in acceptedMyRequests ){
          var req = acceptedMyRequests[i];
          if ( availablePricePackages.indexOf(req.pricePackage) === -1 ){
            availablePricePackages.push(req.pricePackage);
          }
        }

        for ( var i in availablePricePackages ){
          var pkg = availablePricePackages[i];
          if ( pkg.preferences && pkg.preferences.maxAttendants ){
            total += pkg.preferences.maxAttendants;
          }
        }

        $scope.showAttendantTab = total > 0 ? true : false;

        SponsorService.sponsors(requests)
      },

      getInboxUnreadCount: function(){
        MessagesService.getInboxUnreadCount()
          .then(function(response){
            vm.inboxUnreadCount = response.data;
          });
      },

      handleError: function(err){
        console.log(err);
      }
    });

    $scope.$on('$destroy', function(){
      $interval.cancel($scope.unreadCountInterval);
    });

    $scope.$on('sponsorInboxUnreadCount', function(event, data){
      vm.inboxUnreadCount = data;
    });

    $scope.$on('childSponsorRequests', function(event, data){
      $scope.showAttendant(data);
    });

  }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('SpecialController', SpecialController);
  
  SpecialController.$inject = [
    '$rootScope',
    '$scope',
    '$interval',
    'MessagesService'
  ];

  function SpecialController(
    $rootScope,
    $scope,
    $interval,
    MessagesService
  ) {
    var vm = this;
    $scope.unreadCountInterval = null;

    vm.currentUser = $rootScope.currentUser;

    angular.extend($scope, {
      onInit: function(){
        $scope.getInboxUnreadCount();
        $scope.unreadCountInterval = $interval(function(){
          $scope.getInboxUnreadCount();
        }, 30000);
      },
      getInboxUnreadCount: function(){
        MessagesService.getInboxUnreadCount()
          .then(function(response){
            vm.inboxUnreadCount = response.data;
          });
      },
      handleError: function(err){
        console.log(err);
      }
    });

    $scope.$on('$destroy', function(){
      $interval.cancel($scope.unreadCountInterval);
    });

    $scope.$on('specialInboxUnreadCount', function(event, data){
      vm.inboxUnreadCount = data;
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantReservationManagerController', ParticipantReservationManagerController);
  
  ParticipantReservationManagerController.$inject = [
    '$rootScope',
    '$scope',
    '$window',
    '$uibModal',
    '$stateParams',
    'Notification',
    'ReservationService',
    'RequestReservationService',
    'PaymentService'
  ];
  
  function ParticipantReservationManagerController(
    $rootScope,
    $scope,
    $window,
    $uibModal,
    $stateParams,
    Notification,
    ReservationService,
    RequestReservationService,
    PaymentService
  ) {
    var vm = this;
    vm.currentUser = $rootScope.currentUser;
    vm.currentEvent = $rootScope.currentEvent;
    vm.participantModule = vm.currentEvent.preferences.participantModule;

    $scope.loadingByCash = false;
    $scope.loadingByCard = false;

    var boothID = $stateParams.boothID;
    $scope.boothName = $stateParams.boothName && $stateParams.boothName.replace('_', ' ');
    $scope.availableFrom = $stateParams.availableFrom ? $stateParams.availableFrom : null;
    $scope.availableTo = $stateParams.availableTo ? $stateParams.availableTo : null;

    $scope.selectedDay = null;
    $scope.loading = true;
    $scope.loadingSlot = false
    $scope.reservations = [];
    $scope.slots = [];

    $scope.slotsIdsToReserved = [];
    $scope.slotsToReserved = [];

    angular.extend($scope, {
      onInit: function(){
        if ( !boothID ) throw new Error('Booth ID not found');
        if ( !$scope.boothName ) throw new Error('Booth Name not found');

        var from;
        var to;
        if ( $scope.availableFrom && $scope.availableTo ){
          from = moment($scope.availableFrom).set({
            hour: 0, minute: 0, second: 0
          }).utc().format('YYYY-MM-DDTHH:mm:ss.000Z');
          to = moment($scope.availableTo).set({
            hour: 23, minute: 59, second: 59
          }).utc().format('YYYY-MM-DDTHH:mm:ss.000Z');
        }
        ReservationService.getReservationSlot(null, boothID, from, to)
          .then(function(response){
            $scope.selectedDate = $scope.availableFrom;

            var filterData = [];
            var data = response.data;

            if ( data.length ){
              if ( vm.currentUser && vm.currentUser.type === 'participant' ){
                filterData = data.filter(function(item){
                  if ( item['state'] === 'available' ){
                    return item;
                  } else {
                    if ( item.participantId === vm.currentUser.id ){
                      return item;
                    }
                  }
                });
              } else {
                filterData = data.filter(function(item){
                  return item['state'] === 'available';
                });
              }
              if ( from && to ){
                filterData.sort(function(a, b){
                  return new Date(a.start) - new Date(b.start);
                });
                var slot = filterData.find(function(item){ return item['state'] === 'available' });
                $scope.selectedDate = moment(moment.utc(slot.start)).local().toDate();
              } else {
                $scope.selectedDate = moment().local().toDate();
              }
            } else {
              filterData = data;
            }

            $scope.availableSlots = filterData;
            return ReservationService.getReservations(boothID);
          })
          .then(function(response){
            $scope.loading = false;
            // console.log(response);
            $scope.reservations = response.data;
          })
          .catch(function(err){
            console.log(err);
          })
      },

      goBack: function(){
        $window.history.back();
      },

      existInReserved: function(id){
        return $scope.slotsIdsToReserved.indexOf(id) !== -1;
      }
    });

    $scope.errSlots = false;
    $scope.errSlotsMsg = null;

    // Handler
    angular.extend($scope, {
      handleSelectDay: function(params){
        $scope.errSlots = false;
        $scope.errSlotsMsg = null;

        var result = [];

        for ( var i in $scope.availableSlots ){
          var slot = $scope.availableSlots[i];
          var start = moment(moment.utc(slot.start)).local().toDate();
          if ( moment(start).isSame(params.day.date, 'day') ){
            result.push(slot);
          }
        }

        if ( result.length === 0 ){
          $scope.errSlots = true;
          $scope.errSlotsMsg = 'No available slots';
        }

        $scope.slots = result;
      },

      getSlotCalendar: function(slot){
        return $scope.reservations.filter(function(item){
          return item.id === slot.reservationCalendarId;
        })[0];
      },

      reassignSlots: function(slots){
        $scope.slotsIdsToReserved = [];
        $scope.slotsToReserved = [];
        for ( var i in slots ){
          var slot = slots[i];
          for ( var j in $scope.slots ){
            var slotR = $scope.slots[j];
            if ( slotR.id === slot.id ){
              var idx = $scope.slots.indexOf(slotR);
              $scope.slots[idx].state = slot.state;
            }
          }
        }
      },

      totalPrice: function(){
        var result = 0;
        if ( $scope.slotsToReserved.length ){
          for ( var i in $scope.slotsToReserved ){
            result += $scope.slotsToReserved[i].price;
          }
        }
        return result;
      },

      handleAddToReserve: function(slot){
        if ( slot && slot.id ){
          $scope.slotsToReserved.push(slot);
          $scope.slotsIdsToReserved.push(slot.id);
        } else {
          Notification.error('Slot id not available');
        }
      },

      handleRemoveFromReserve: function(slot){
        if ( slot && slot.id ){
          $scope.slotsToReserved.splice($scope.slotsToReserved.indexOf(slot), 1);
          $scope.slotsIdsToReserved.splice($scope.slotsIdsToReserved.indexOf(slot.id), 1);
        } else {
          Notification.error('Slot id not available');
        }
      }
    });

    $scope.dateNow = new Date();

    $scope.outOfCurrentDate = function(slot){
      var resultDate = false;
      var resultTime = false;
      var end = moment(moment.utc(slot.end)).local();
      if ( moment(end).isAfter($scope.dateNow)) {
        if ( !moment(end).isSame($scope.dateNow, 'day') ){
          resultDate = true;
        } else {
          if ( moment(end, 'h:mma').isAfter($scope.dateNow, 'h:mma') ){
            if ( moment(end).format('h:mma') !== moment($scope.dateNow).format('h:mma') ){
              resultTime = true;
            }
          }
        }
      }
      if ( !resultTime && resultDate ){
        return slot;
      }
      if ( !resultDate && resultTime ){
        return slot;
      }
    }

    $scope.isSameDay = function(start, end){
      return moment(start).isSame(end, 'day')
    }

    $scope.isSameMonth = function(start, end){
      return moment(start).isSame(end, 'month')
    }

    $scope.toMonth = function(date){
      return moment(moment.utc(date)).local().format('MMM D') +'th';
    }

    $scope.toHours = function(time){
      return moment(moment.utc(time)).local().format('HH:mm');
    }


    /*
      Handle payment buttons
    */
    angular.extend($scope, {
      openModalAgreement: function() {
        return $uibModal.open({
          templateUrl: 'app/users/participant/agreement/agreement.html',
          controller: 'ParticipantAgreementController',
          controllerAs: 'vm'
        });
      },

      handleCashButton: function(){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function(){
                $scope.cashRequest();
              }
            )
        } else {
          $scope.cashRequest();
        }
      },
      handlePaypalButton: function(pay) {
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.paypalRequest(pay);
              }
            )
        } else {
          $scope.paypalRequest(pay);
        }
      },
      handleTransactionButton: function(pay) {
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.transactionRequest(pay);
              }
            )
        } else {
          $scope.transactionRequest(pay);
        }
      },
      handleStripeButton: function(pay){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.stripeRequest(pay);
              }
            )
        } else {
          $scope.stripeRequest(pay);
        }
      },
      handleSquareupButton: function(pay){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.squareupRequest(pay);
              }
            )
        } else {
          $scope.squareupRequest(pay);
        }
      },
      handlePayeezyButton: function(pay){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function() {
                $scope.payeezyRequest(pay);
              }
            )
        } else {
          $scope.payeezyRequest(pay);
        }
      }
    });

    /*
      Requests
    */
    angular.extend($scope, {
      noCostRequest: function(){
        if ( vm.participantModule.waiverEnabled ) {
          var modal = $scope.openModalAgreement();
          modal.result
            .then(
              function(){
                $scope.costRequest();
              }
            )
        } else {
          $scope.costRequest();
        }
      },

      costRequest: function(){
        if ( $scope.slotsIdsToReserved.length ){
          $scope.loadingByCash = true;
          var data = {
            payCash: true,
            participantId: vm.currentUser.id,
            timeSlotIds: $scope.slotsIdsToReserved,
            boothName: $scope.boothName
          }
          RequestReservationService.createSlotReservation(data)
            .then(function(response){
              // ;
              Notification.success('Successfully reserved');
              $scope.loadingByCash = false;
              $scope.reassignSlots(response.data.timeSlots);
            })
            .catch(function(err){
              $scope.loadingByCash = false;
            });
        } else {
          Notification.error('No slots picked');
        }
      },

      cashRequest: function() {
        if ( vm.participantModule.cashPayment ) {
          if ( $scope.slotsIdsToReserved.length ){
            $scope.loadingByCash = true;
            var data = {
              payCash: true,
              participantId: vm.currentUser.id,
              timeSlotIds: $scope.slotsIdsToReserved,
              boothName: $scope.boothName
            }
            RequestReservationService.createSlotReservation(data)
              .then(function(response){
                // ;
                Notification.success('Successfully reserved');
                $scope.loadingByCash = false;
                $scope.reassignSlots(response.data.timeSlots);
              })
              .catch(function(err){
                $scope.loadingByCash = false;
              });
          } else {
            Notification.error('No slots picked');
          }
        }
      },
      paypalRequest: function(pay) {
        if ( $scope.slotsIdsToReserved.length ){
          $scope.loadingByCard = true;
          var data = {
            participantId: vm.currentUser.id,
            timeSlotIds: $scope.slotsIdsToReserved,
            boothName: $scope.boothName
          }
          RequestReservationService.createSlotReservation(data)
            .then(function(response){
              var responseData = response.data;
              $scope.loadingByCard = false;

              // $scope.reassignSlots(responseData.timeSlots);
              $scope.generatePaypalForm(pay, responseData);
            })
            .catch(function(err){
              $scope.loadingByCard = false;
            });
        } else {
          Notification.error('No slots picked');
        }
      },
      transactionRequest: function(pay) {
        if ( $scope.slotsIdsToReserved.length ){
          $scope.loadingByCard = true;
          var data = {
            participantId: vm.currentUser.id,
            timeSlotIds: $scope.slotsIdsToReserved,
            boothName: $scope.boothName
          }
          RequestReservationService.createSlotReservation(data)
            .then(function(response){
              var responseData = response.data;
              $scope.loadingByCard = false;

              $scope.reassignSlots(responseData.timeSlots);
              $scope.generateTransactionForm(pay, responseData);
            })
            .catch(function(err){
              $scope.loadingByCard = false;
            });
        } else {
          Notification.error('No slots picked');
        }
      },
      stripeRequest: function(pay){
        if ( $scope.slotsIdsToReserved.length ){
          $scope.loadingByCard = true;
          var data = {
            participantId: vm.currentUser.id,
            timeSlotIds: $scope.slotsIdsToReserved,
            boothName: $scope.boothName
          }
          RequestReservationService.createSlotReservation(data)
            .then(function(response){
              var responseData = response.data;
              $scope.loadingByCard = false;

              // $scope.reassignSlots(responseData.timeSlots);
              $scope.generateStripe(pay, responseData, responseData.timeSlots);
            })
            .catch(function(err){
              $scope.loadingByCard = false;
            });
        } else {
          Notification.error('No slots picked');
        }
      },
      squareupRequest: function(pay){
        if ( $scope.slotsIdsToReserved.length ){
          $scope.loadingByCard = true;
          var data = {
            participantId: vm.currentUser.id,
            timeSlotIds: $scope.slotsIdsToReserved,
            boothName: $scope.boothName
          }
          RequestReservationService.createSlotReservation(data)
            .then(function(response){
              var responseData = response.data;
              $scope.loadingByCard = false;

              // $scope.reassignSlots(responseData.timeSlots);
              $scope.generateSquareupForm(pay, responseData, responseData.timeSlots);
            })
            .catch(function(err){
              $scope.loadingByCard = false;
            });
        } else {
          Notification.error('No slots picked');
        }
      },
      payeezyRequest: function(pay){
        if ( $scope.slotsIdsToReserved.length ){
          $scope.loadingByCard = true;
          var data = {
            participantId: vm.currentUser.id,
            timeSlotIds: $scope.slotsIdsToReserved,
            boothName: $scope.boothName
          }
          RequestReservationService.createSlotReservation(data)
            .then(function(response){
              var responseData = response.data;
              $scope.loadingByCard = false;

              // $scope.reassignSlots(responseData.timeSlots);
              $scope.generatePayeezyForm(pay, responseData, responseData.timeSlots);
            })
            .catch(function(err){
              $scope.loadingByCard = false;
            });
        } else {
          Notification.error('No slots picked');
        }
      }
    })

    /*
      Generate forms
    */
    angular.extend($scope, {
      generatePaypalForm: function(pay, data) {
        var paymentData = {
          id: data.id,
          name: $scope.boothName,
          amount: data.price
        };

        PaymentService.paypalForm(pay, paymentData, 'err');
      },
      // Transaction
      generateTransactionForm: function(pay, data) {
        var paymentData = {
          id: data.id,
          amount: data.price
        };

        PaymentService.transactionForm(pay, paymentData, 'err');
      },
      // Stripe
      generateStripe: function(pay, data, timeSlots){
        var paymentData = {
          id: data.id,
          amount: data.price,
          name: data.participant.name,
          description: data.description,
          email: data.participant.email
        };
        PaymentService.stripeForm(pay, paymentData, 'err',
          function(){
            $scope.reassignSlots(timeSlots);
            Notification.success('Payment successfully submitted')
          },
          function(err){
            Notification.error(err.data.message);
          },
          function(){
            $scope.reassignSlots(timeSlots);
            console.log('Closed');
          }
        );
      },
      // Squareup
      generateSquareupForm: function(pay, data, timeSlots){
        var modal = $uibModal.open({
          templateUrl: 'app/squareup-form/squareup-form.html',
          controller: 'SquareupFormController',
          controllerAs: 'vm',
          size: 'sm',
          resolve: {
            dataPay: function(){
              return {
                applicationId: pay.applicationId,
                locationId: pay.locationId
              };
            },
            dataResult: function(){
              return {
                amount: data.price,
                id: data.id
              };
            },
            itemType: function(){
              return 'err';
            }
          }
        });
        modal.result
          .then(
            function(){
              $scope.reassignSlots(timeSlots);
              Notification.success('Payment successfully submitted')
            },
            function(){
              $scope.reassignSlots(timeSlots);
              console.log('Dissmissed');
            }
          );
      },
      generatePayeezyForm: function(pay, data, timeSlots){
        var modal = $uibModal.open({
          templateUrl: 'app/payeezy-form/payeezy-form.html',
          controller: 'PayeezyFormController',
          controllerAs: 'vm',
          size: 'sm',
          resolve: {
            dataPay: function(){
              return {
                apiKey: pay.apiKey,
                paymentJSUrl: pay.paymentJSUrl,
                transarmorToken: pay.transarmorToken,
                jsSecurityKey: pay.jsSecurityKey
              }
            },
            dataResult: function(){
              return {
                amount: data.price,
                id: data.id
              };
            },
            itemType: function(){
              return 'err';
            }
          }
        });
        modal.result
          .then(
            function(resolve){
              $scope.reassignSlots(timeSlots);
              Notification.success('Payment successfully submitted')
            },
            function(){
              $scope.reassignSlots(timeSlots);
              console.log('Dissmissed');
            }
          );
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }
})();

(function(){

  angular
    .module('eventmap')
    .controller('ProfileController', ProfileController);

  ProfileController.$inject = [
    '$scope',
    'Notification',
    'AuthService',
    'SettingService',
    'USA_STATES'
  ];
  
  function ProfileController(
    $scope,
    Notification,
    __auth,
    SettingService,
    STATES
  ){
    var vm = this;
    $scope.formSubmitted = false;
    $scope.formLoading = false;
    $scope.settingsLoading = true;

    angular.extend($scope, {
      onInit: function(){
        vm.states = STATES;

        __auth.getUser()
          .then(function(response){
            vm.currentUser = response.data;

            if ( vm.currentUser.smsOptOutStatus === 'opted_out_sms' ){
              SettingService.getSettingsByGroup('phone')
                .then(function(response){
                  $scope.eventPhoneNumber = response.data[0];
                  $scope.settingsLoading = false;
                })
                .catch(function(err){
                  console.error(err);
                });
            }

            if (
              vm.currentUser.smsOptOutStatus === 'opted_in_app' ||
              vm.currentUser.smsOptOutStatus === 'opted_in_sms'
            ){
              vm.currentUser.smsOptOutCheckbox = false;
            } else {
              vm.currentUser.smsOptOutCheckbox = true;
            }
          })
          .catch(function(err){
            console.log(err);
          });
      },

      removePhoto: function (argument) {
        vm.currentUser.photo = undefined;
        $scope.photoPreview = undefined;
        vm.currentUser.photoLink = undefined;
      },

      handleSubmit: function() {
        $scope.formSubmitted = true;
        var form = $scope.form;

        vm.currentUser.photo = $scope.currentUser.newPhoto;
        vm.currentUser.photoLink = vm.currentUser.photoLink;

        if ( form.$valid ) {
          $scope.formLoading = true;

          if (
            vm.currentUser.smsOptOutCheckbox
          ){
            if ( vm.currentUser.smsOptOutStatus !== 'opted_out_sms' ){
              vm.currentUser.smsOptOutStatus = 'opted_out_app'
            }
          } else {
            if ( vm.currentUser.smsOptOutStatus !== 'opted_in_sms' ){
              vm.currentUser.smsOptOutStatus = 'opted_in_app'
            }
          }

          if ( typeof vm.currentUser.rePassword !== 'undefined' ){
            vm.currentUser['password'] = vm.currentUser.rePassword;
            delete vm.currentUser['rePassword'];
          }

          if ( vm.currentUser.phone1 && !vm.currentUser.phone1.number ){
            delete vm.currentUser['phone1'];
          }
          if ( vm.currentUser.phone2 && !vm.currentUser.phone2.number ){
            delete vm.currentUser['phone2'];
          }

          __auth.onUpdate(vm.currentUser)
            .then(
              function(response){
                $scope.formLoading = false;
                Notification.success('Your profile was updated');

                var data = response.data;
                vm.currentUser = data;
                var portal = false;
                if ( data.type === 'eo' ) {
                  portal = true;
                }
                __auth.setCredentialUser(data, portal);

                $scope.formSubmitted = false;

                delete vm.currentUser['password'];
              },
              $scope.handleError
            );
        }
      },

      handleError: function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('ParticipantController', ParticipantController);
  
  ParticipantController.$inject = [
    '$rootScope',
    '$scope',
    '$interval',
    'MessagesService',
    'TeamService'
  ];

  function ParticipantController(
    $rootScope,
    $scope,
    $interval,
    MessagesService,
    TeamService
  ) {
    var vm = this;
    $scope.unreadCountInterval = null;

    vm.currentEvent = $rootScope.currentEvent;
    vm.currentUser = $rootScope.currentUser;

    angular.extend($scope, {
      onInit: function(){
        // Clear team items
        TeamService.clearMyTeams();

        TeamService.getMyTeams()
          .then(
            function(response) {
              var data = response.data;
              $scope.myTeams = TeamService.setMyTeams(data);
            },
            $scope.handleError
          );

        $scope.getInboxUnreadCount();
        $scope.unreadCountInterval = $interval(function(){
          $scope.getInboxUnreadCount();
        }, 30000);
      },

      getInboxUnreadCount: function(){
        MessagesService.getInboxUnreadCount()
          .then(function(response){
            vm.inboxUnreadCount = response.data;
          });
      },

      handleError: function(err){
        console.log(err);
      }
    });

    $scope.$on('$destroy', function(){
      $interval.cancel($scope.unreadCountInterval);
    });

    $scope.$on('participantInboxUnreadCount', function(event, data){
      vm.inboxUnreadCount = data;
    });
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('OrganizerController', OrganizerController);

  OrganizerController.$inject = [
    '$rootScope',
    '$interval',
    '$scope',
    '$state',
    'MessagesService'
  ];

  function OrganizerController(
    $rootScope,
    $interval,
    $scope,
    $state,
    MessagesService
  ) {
    var vm = this;
    $scope.unreadCountInterval = null;

    angular.extend($scope, {
      $state: $state
    });

    angular.extend($scope, {
      onInit: function(){
        vm.event = $rootScope.currentEvent;
        vm.billingPreferences = vm.event.billingPreferences;
        vm.vendorModule = vm.event.preferences.vendorModule;
        vm.volunteerModule = vm.event.preferences.volunteerModule;
        vm.participantModule = vm.event.preferences.participantModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        vm.currentUser = $rootScope.currentUser;

        $scope.getInboxUnreadCount();
        $scope.unreadCountInterval = $interval(function(){
          $scope.getInboxUnreadCount();
        }, 30000);
      },

      getInboxUnreadCount: function(){
        MessagesService.getInboxUnreadCount()
          .then(function(response){
            vm.inboxUnreadCount = response.data;
          });
      }
    });

    $scope.$on('$destroy', function(){
      $interval.cancel($scope.unreadCountInterval);
    });

    $scope.$on('eoInboxUnreadCount', function(event, data){
      vm.inboxUnreadCount = data;
    });
  }
})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('EventPassController', EventPassController);

  EventPassController.$inject = [
    '$rootScope',
    '$scope',
    '$interval',
    '$uibModalInstance',
    'MapService',
    'VendorService',
    'ParticipantService',
    'SponsorService',
    'moment',
    'resolveType',
    'resolveRequest'
  ];

  function EventPassController(
    $rootScope,
    $scope,
    $interval,
    $uibModalInstance,
    MapService,
    VendorService,
    ParticipantService,
    SponsorService,
    moment,
    resolveType,
    resolveRequest
  ) {
    var vm = this;
    $scope.modalLoading = true;
    $scope.modalTitle = '';
    $scope.currentEvent = $rootScope.currentEvent;

    var vendorModule = $scope.currentEvent.preferences.vendorModule;
    var volunteerModule = $scope.currentEvent.preferences.volunteerModule;
    var participantModule = $scope.currentEvent.preferences.participantModule;
    var sponsorModule = $scope.currentEvent.preferences.sponsorModule;

    $scope.moment = moment;

    $scope.booth = undefined;
    var stopInterval;

    $scope.userType = resolveType;
    $scope.userRequest = resolveRequest;

    angular.extend($scope, {
      onInit: function(){
        // console.log(resolveType);
        // console.log(resolveRequest);
        // Fetch vendor event pass
        $scope.fetchVendor();
        // Fetch volunteer event pass
        $scope.fetchVolunteer();
        // Fetch participant event pass
        $scope.fetchParticipant();
        // Fetch sponsor event pass
        $scope.fetchSponsor();
      },

      fetchVendor: function(){
        if ( resolveType === 'vendor' ){
          $scope.modalTitle = vendorModule.label +' event pass';

          if ( !$scope.userRequest.checkedIn ){
            stopInterval = $interval(function(){
              VendorService.getRequestById($scope.userRequest.id)
                .then(function(response){ $scope.userRequest = response.data; });
            }, 5000);
          }

          if ( $scope.currentEvent && $scope.currentEvent.domain ){
            var domain = ( $scope.currentEvent.domain !== 'localhost' ? $scope.currentEvent.domain : $scope.currentEvent.domain +':3000');
            $scope.qrURL = 'http://'+ domain +'/auto-check-in?id='+ $scope.userRequest.id;
          }

          MapService.getMapByID($scope.currentEvent.mainEventMapId, 'booths,eventZones')
            .then(function(response){
              var data = response.data;
              var booths = data.booths;
              var eventZones = data.eventZones;

              if ( booths && booths.length !== 0 ) {
                var zoneId = null;
                for ( var i in booths ) {
                  var booth = booths[i];
                  if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
                    for ( var j in booth.userCommercialAssignments ){
                      var assign = booth.userCommercialAssignments[j];
                      if ( assign.eventRequestId === $scope.userRequest.id ){
                        zoneId = booth.zoneId;
                        $scope.booth = {
                          eventName: $scope.currentEvent.name,
                          vendorName: $scope.userRequest.vendor.name,
                          description: booth.description,
                          from: assign.from ? assign.from : $scope.currentEvent.start,
                          to: assign.to ? assign.to : $scope.currentEvent.end
                        };
                      }
                    }
                  }
                }
                if ( zoneId ) {
                  if ( eventZones && eventZones.length !== 0 ) {
                    for ( var j in eventZones ) {
                      var zone = eventZones[j];
                      if ( zone.id === zoneId ) {
                        $scope.booth.color = zone.preferences.fillColor;
                      }
                    }
                  }
                }
              }

              $scope.modalLoading = false;
            })
            .catch(function(err){
              $scope.modalLoading = false;
              console.error(err);
            });
        }
      },

      fetchVolunteer: function(){
        if ( resolveType === 'volunteer' ){
          $scope.modalTitle = volunteerModule.label +' instruction';

          MapService.getRespZoneByRequestId(resolveRequest.id)
            .then(function(response){
              $scope.zones = response.data;
              $scope.modalLoading = false;
            })
            .catch(function(err){
              console.error(err);
              $scope.modalLoading = false;
            })
        }
      },

      fetchParticipant: function(){
        if ( resolveType === 'participant' ){
          $scope.modalTitle = participantModule.label +' event pass';

          setTimeout(function(){
            var qrcodeLink = document.querySelector('.qrcode-link');
            if ( qrcodeLink ){
              qrcodeLink.addEventListener('click', function(evt){
                evt.preventDefault();
                console.log('clicked');
              });
            }
          }, 500);

          if ( !$scope.userRequest.checkedIn ){
            stopInterval = $interval(function(){
              ParticipantService.getRequestById($scope.userRequest.id)
                .then(function(response){ $scope.userRequest = response.data });
            }, 5000);
          }

          if ( $scope.currentEvent && $scope.currentEvent.domain ){
            var domain = ( $scope.currentEvent.domain !== 'localhost' ? $scope.currentEvent.domain : $scope.currentEvent.domain +':3000');
            $scope.qrURL = 'http://'+ domain +'/auto-check-in?type=request&user=participant&code='+ $scope.userRequest.code;
          }

          $scope.modalLoading = false;
        }
      },

      fetchSponsor: function(){
        if ( resolveType === 'sponsor' ){
          $scope.modalTitle = sponsorModule.label +' event pass';

          setTimeout(function(){
            var qrcodeLink = document.querySelector('.qrcode-link');
            if ( qrcodeLink ){
              qrcodeLink.addEventListener('click', function(evt){
                evt.preventDefault();
                console.log('clicked');
              });
            }
          }, 500);

          if ( !$scope.userRequest.checkedIn ){
            stopInterval = $interval(function(){
              SponsorService.getRequestById($scope.userRequest.id)
                .then(function(response){ $scope.userRequest = response.data });
            }, 5000);
          }

          if ( $scope.currentEvent && $scope.currentEvent.domain ){
            var domain = ( $scope.currentEvent.domain !== 'localhost' ? $scope.currentEvent.domain : $scope.currentEvent.domain +':3000');
            $scope.qrURL = 'http://'+ domain +'/auto-check-in?type=request&user=sponsor&id='+ $scope.userRequest.id;
          }

          $scope.modalLoading = false;
        }
      },

      isSameDay: function(from, to){
        return moment(from).isSame(to, 'day');
      },

      onClose: function(){
        $uibModalInstance.dismiss($scope.userRequest);
        if ( stopInterval ) $interval.cancel(stopInterval);
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('AutoCheckInController', AutoCheckInController);
  
  AutoCheckInController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    'Notification',
    'VendorService',
    'ParticipantService',
    'RequestReservationService',
    'SponsorService'
  ];
  
  function AutoCheckInController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    Notification,
    __vendor,
    __participant,
    RequestReservationService,
    SponsorService
  ){
    var vm = this;
    vm.code = getParameterByName('code') || $stateParams.code;
    vm.id = getParameterByName('id') || $stateParams.id;
    vm.type = getParameterByName('type') || $stateParams.type;
    vm.user = getParameterByName('user') || $stateParams.user;

    vm.request = null;
    vm.errorMessage = null;

    angular.extend($scope, {
      onInit: function(){
        var isToken = localStorage.getItem('auth_token');

        if ( !isToken ){
          vm.event = $rootScope.currentEvent;
          if ( vm.event && vm.event.domain ){
            if ( vm.id ) localStorage.setItem('redirect_id', vm.id);
            if ( vm.code ) localStorage.setItem('redirect_code', vm.code);
            if ( vm.user ) localStorage.setItem('redirect_user', vm.user);
            if ( vm.type ) localStorage.setItem('redirect_type', vm.type);
            $state.go('app.auth.login');
          }
        } else {
          localStorage.removeItem('redirect_id');
          localStorage.removeItem('redirect_code');
          localStorage.removeItem('redirect_user');
          localStorage.removeItem('redirect_type');

          if ( vm.type ){
            if ( vm.type === 'reservation' ){
              RequestReservationService.autoCheckInReservationRequest(vm.code)
                .then(
                  function(response){
                    vm.request = response.data
                  },
                  function(err){
                    // Notification.error(err.data.message);
                    vm.errorMessage = err.data.message;
                  }
                );
            } else if ( vm.type === 'request' ){
              if ( vm.user === 'participant' ){
                __participant.autoCheckIn(vm.code)
                  .then(
                    function(response){
                      vm.request = response.data
                    },
                    function(err){
                      // Notification.error(err.data.message);
                      vm.errorMessage = err.data.message;
                    }
                  );
              } else if ( vm.user === 'sponsor' ){
                SponsorService.checkedIn(vm.id)
                  .then(
                    function(response){
                      vm.request = response.data
                    },
                    function(err){
                      vm.errorMessage = err.data.message;
                    }
                  );
              } else if ( vm.user === 'sponsorAttendant' ){
                SponsorService.actionCheckInAttendantRequest(vm.id)
                  .then(
                    function(response){
                      vm.request = response.data
                    },
                    function(err){
                      vm.errorMessage = err.data.message;
                    }
                  );
              }
            }
          } else {
            __vendor.onCheckIn(vm.id)
              .then(
                function(response){
                  vm.request = response.data
                },
                function(err){
                  // Notification.error(err.data.message);
                  vm.errorMessage = err.data.message;
                }
              );
          }
        }
      }
    });

    function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('Route', Route);

  function Route($window) {
    var google = google || $window.google;
    var activeInfoWindow = null;
    var infoWindow = new google.maps.InfoWindow();
    infoWindow.setZIndex(999);

    var Route = function(isInfoWindowVisible){
      this.kind = 'Route',
      this.coordinates = [];
      this.polyline = null;
      this.strokeColor = '#ff0000';
      this.strokeOpacity = 1.0;
      this.thickness = 3;
      this.isInfoWindowVisible = isInfoWindowVisible;

      this.showArrows = true;
    }
    Route.prototype.read = function(data){
      this.id = data.id;
      this.zoneId = data.zoneId;
      this.coordinates = data.coordinates;
      this.instructions = data.instructions;
      this.name = data.name;
      if ( data.preferences ){
        var pref = data.preferences;
        if ( pref.strokeColor ) {
          this.strokeColor = pref.strokeColor;
        }
        if ( pref.public ) {
          this.public = pref.public;
        }
        this.showArrows = typeof pref.showArrows !== 'undefined' ? pref.showArrows : true;
        this.thickness = typeof pref.thickness !== 'undefined' ? pref.thickness : this.thickness;
      }
    };
    Route.prototype.set = function(){
      this.coordinates = [];
      var self = this;
      this.polyline.getPath().forEach(function(element){
        self.coordinates.push(element);
      });
      var data = {
        id: this.id,
        zoneId: this.zoneId,
        coordinates: this.coordinates,
        instructions: this.instructions,
        name: this.name,
        preferences: {
          strokeColor: this.polyline.strokeColor,
          public: this.public,
          thickness: this.thickness,
          showArrows: this.showArrows
        }
      }
      return data;
    };
    Route.prototype.draw = function(map){
      if (!this.polyline) {
        this.polyline = new google.maps.Polyline({
          width: 5,
          geodesic: true,
          strokeColor: this.strokeColor,
          strokeOpacity: 1.0,
          strokeWeight: this.thickness,
          zIndex: 3
        });
      }
      this.polyline.setPath(this.coordinates);
      renderPolylineIcons(this);
      this.polyline.setMap(map);
      if ( this.isInfoWindowVisible ){
        renderInfoWindow(this, map);
      }
    };
    Route.prototype.remove = function(){
      this.polyline.setMap(null);
    };
    Route.prototype.addCoordinates = function(latLng){
      this.coordinates.push(latLng);
    },
    Route.prototype.addClickListener = function(clickListener){
      google.maps.event.addListener(this.polyline, 'click', clickListener);
    };
    Route.prototype.getPolylineDistance = function(path){
      return parseInt(google.maps.geometry.spherical.computeLength(path));
    };
    Route.prototype.show = function(){
      this.polyline.setVisible(true);
    };
    Route.prototype.hide = function(){
      this.polyline.setVisible(false);
    };
    Route.prototype.setColor = function(color) {
      this.polyline.setOptions({
        strokeColor: color
      });
    };
    Route.prototype.focus = function(){
      this.polyline.setOptions({
        editable: true,
        draggable: true
      });
    };
    Route.prototype.unfocus = function(){
      this.polyline.setOptions({
        editable: false,
        draggable: false
      });
    };
    Route.prototype.setColor = function(color) {
      this.polyline.setOptions({
        strokeColor: color
      });
    };
    Route.prototype.changeArrowVisibility = function(){
      renderPolylineIcons(this);
    };
    Route.prototype.changeThickness = function(thickness){
      if ( typeof thickness !== 'undefined' && thickness !== null ){
        this.polyline.setOptions({
          strokeWeight: thickness
        });
        renderPolylineIcons(this);
      }
    };
    return Route;

    function renderPolylineIcons(self){
      var iconParams = {}
      if ( self.showArrows ){
        iconParams['path'] = google.maps.SymbolPath.FORWARD_OPEN_ARROW;
        iconParams['strokeWeight'] = self.thickness;
        // iconParams['strokeOpacity'] = 0.75;
        iconParams['scale'] = self.thickness * 0.85;
      } else {
        // iconParams['path'] = google.maps.SymbolPath.CIRCLE;
        // iconParams['strokeWeight'] = self.thickness * 0.65;
        // iconParams['strokeOpacity'] = 0.75;
        // iconParams['scale'] = self.thickness * 0.65;
        // iconParams['fillColor'] = 'white';
        // iconParams['fillOpacity'] = 1.0;
      }
      self.polyline.set('icons', [
        {
          icon: iconParams,
          offset: '100%'
        },{
          icon: iconParams,
          offset: '50px',
          repeat: '100px'
        },{
          icon: iconParams,
          offset: '0%'
        }
      ]);
    }

    function renderInfoWindow(self, map){
      if (self.isInfoWindowVisible && self.instructions){
        google.maps.event.addDomListener(self.polyline, 'click', function(){
          var content = '<div class="infowindow">';
          content = content.concat('<p>' + self.instructions + '</p></div>');
          if ( activeInfoWindow ) {
            activeInfoWindow.close();
          }
          infoWindow.setContent(content);
          infoWindow.setPosition(self.coordinates[0]);
          infoWindow.open(map);
          activeInfoWindow = infoWindow;
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('RespZone', RespZone)

  function RespZone($window, moment, MapCommon, $rootScope){
    var google = google || $window.google;
    var activeInfoWindow = null;
    var infoWindow = new google.maps.InfoWindow();
    infoWindow.setZIndex(999);

    var RespZone = function(isInfoWindowVisible){
      this.kind = 'RespZone';
      this.description = '';
      this.defaultSize = new google.maps.Size(15,15);
      this.fillColor = MapCommon.randomHexColor();
      this.volunteerAssignments = [];
      this.isInfoWindowVisible = isInfoWindowVisible;
    }
    RespZone.prototype.read = function(data){
      this.id = data.id;
      this.zoneId = data.zoneId;
      this.name = data.name;
      this.description = data.description;
      this.coordinates = data.coordinates;
      this.volunteerAssignments = data.volunteerAssignments || [];
      if ( data.preferences ){
        var pref = data.preferences;
        if ( pref.fillColor ) {
          this.fillColor = pref.fillColor;
        }
      }
    };
    RespZone.prototype.set = function(){
      this.coordinates = [];
      var self = this;
      this.polygon.getPath().forEach(function(element){
        self.coordinates.push({ lat: element.lat(), lng: element.lng() });
      });
      return {
        id: this.id,
        zoneId: this.zoneId,
        name: this.name,
        description: this.description,
        coordinates: this.coordinates,
        volunteerAssignments: this.volunteerAssignments,
        preferences: {
          fillColor: this.polygon.fillColor
        }
      };
    };
    RespZone.prototype.draw = function(map){
      if (!this.coordinates){
        var bounds = MapCommon.calcBounds(this.latLng, this.defaultSize);
        this.coordinates = MapCommon.boundsToPath(bounds);
      }
      this.polygon = new google.maps.Polygon({
        paths: this.coordinates,
        strokeColor: '#66ccff',
        strokeOpacity: 0.6,
        strokeWeight: 1,
        fillColor: this.fillColor,
        fillOpacity: 0.5,
        zIndex: 2,
        map: map
      });
      if (this.isInfoWindowVisible){
        var lat = this.coordinates[0].lat;
        var lng = this.coordinates[0].lng;
        renderInfoWindow(this, map, lat, lng);
      }
    };
    RespZone.prototype.remove = function(){
      this.polygon.setMap(null);
    };
    RespZone.prototype.addClickListener = function(clickListener){
      google.maps.event.addListener(this.polygon, 'click', clickListener);
    };
    RespZone.prototype.hide = function(){
      this.polygon.setVisible(false);
    };
    RespZone.prototype.show = function(){
      this.polygon.setVisible(true);
    };
    RespZone.prototype.focus = function(){
      this.polygon.setOptions({
        editable: true,
        draggable: true
      });
    };
    RespZone.prototype.unfocus = function(){
      this.polygon.setOptions({
        editable: false,
        draggable: false
      });
    };
    RespZone.prototype.setColor = function(color) {
      this.polygon.setOptions({
        fillColor: color
      })
    };
    return RespZone;

    function renderInfoWindow(self, map, lat, lng){
      google.maps.event.addDomListener(self.polygon, 'click', function(e) {
        var assignmentVolunteer = [];
        var content = '<div class="infowindow">';
        if ( self.description || self.name ) {
          content += self.name ? ('<h5>'+ self.name + '</h5>') : '';
          content += self.description ? ('<p>'+ self.description + '</p>') : '';
        }
        if ( self.volunteerAssignments && self.volunteerAssignments.length !== 0 ){
          if ( self.volunteerRequestIds && self.volunteerRequestIds.length !== 0 ){
            for ( var i in self.volunteerAssignments ){
              var assign = self.volunteerAssignments[i];
              if ( self.volunteerRequestIds.indexOf(assign.volunteerRequestId) !== -1 ){
                assignmentVolunteer.push(assign);
              }
            }
          }
        }
        if ( assignmentVolunteer.length !== 0 ){
          for ( var j in assignmentVolunteer ){
            if ( assignmentVolunteer[j].from && assignmentVolunteer[j].to ){
              if ( isSameDay(assignmentVolunteer[j].from, assignmentVolunteer[j].to) ){
                content += '<p><b>'+ dateFormated(assignmentVolunteer[j].from) +'&nbsp;-&nbsp;'+ timeFormated(assignmentVolunteer[j].to) +'</b></p>';
              } else {
                content += '<p><b>'+ dateFormated(assignmentVolunteer[j].from) +'&nbsp;-&nbsp;'+ dateFormated(assignmentVolunteer[j].to) +'</b></p>';
              }
            }
          }
        }
        content += MapCommon.renderDirectionIcons(lat, lng)
        content += '</div>';
        if ( activeInfoWindow ) {
          activeInfoWindow.close();
        }
        infoWindow.setContent(content);
        infoWindow.setPosition(e.latLng);
        infoWindow.open(map);
        activeInfoWindow = infoWindow;
      });
    }

    function dateFormated(date){
      return moment(moment.utc(date)).local().format('MMMM DD, YYYY hh:mm a');
    }

    function timeFormated(date){
      return moment(moment.utc(date)).local().format('hh:mm a');
    }

    function isSameDay(start, end){
      return moment(start).isSame(end, 'day');
    }

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('MapCommon', MapCommon)

    function MapCommon($window) {
      var MapCommon = {};
      var google = google || $window.google;

      MapCommon.boundsToPath = function(bounds){
        var paths = [];
        var path = [];
        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();
        path.push(ne);
        path.push(new google.maps.LatLng(sw.lat(), ne.lng()));
        path.push(sw);
        path.push(new google.maps.LatLng(ne.lat(), sw.lng()));
        paths.push(path);
        return path;
      };

      MapCommon.calcBounds = function(center, size){
        var spherical = google.maps.geometry.spherical;
        var n = spherical.computeOffset(center, size.height / 2, 0).lat();
        var s = spherical.computeOffset(center, size.height / 2, 180).lat();
        var e = spherical.computeOffset(center, size.width / 2, 90).lng();
        var w = spherical.computeOffset(center, size.width / 2, 270).lng();
        return new google.maps.LatLngBounds(new google.maps.LatLng(s, w),
                                            new google.maps.LatLng(n, e))
      };

      MapCommon.ID = function (){
        // Math.random should be unique because of its seeding algorithm.
        // Convert it to base 36 (numbers + letters), and grab the first 9 characters
        // after the decimal.
        return '_' + Math.random().toString(36).substr(2, 9);
      };

      MapCommon.randomHexColor = function(){
        return '#'+ Math.floor(Math.random()*16777215).toString(16);
      }

      MapCommon.renderDirectionIcons = function(lat, lng){
        return '\
          <ul class="infowindow-directions">\
            <li>\
              <a href="https://maps.google.com?saddr=Current+Location&daddr='+ lat +','+ lng +'&driving" target="_blank">\
                <span>By Car</span>\
                <i class="fa fa-car"></i>\
              </a>\
            </li>\
            <li>\
              <a href="https://maps.google.com?saddr=Current+Location&daddr='+ lat +','+ lng +'" target="_blank">\
                <span>Walking</span>\
                <i class="fa fa-male"></i>\
              </a>\
            </li>\
            <li>\
              <a href="https://maps.google.com?saddr=Current+Location&daddr='+ lat +','+ lng +'&mode=bicycling" target="_blank">\
                <span>Bike</span>\
                <i class="fa fa-bicycle"></i>\
              </a>\
            </li>\
          </ul>\
        ';
      }

      return MapCommon;
    }
})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('EventZone', EventZone)

  function EventZone($window, MapCommon) {
    var google = google || $window.google;
    var EventZone = function(){
      this.kind = 'EventZone';
      this.name = '';
      this.fillColor = MapCommon.randomHexColor();
      this.defaultSize = new google.maps.Size(30,30);
    }
    EventZone.prototype.read = function(data){
      this.id = data.id;
      this.name = data.name;
      if ( data.preferences ){
        var pref = data.preferences;
        if ( pref.fillColor ) {
          this.fillColor = data.preferences.fillColor;
        }
      }
      this.coordinates = data.coordinates;
    };
    EventZone.prototype.set = function(){
      // this.coordinates = [];
      // for ( var i in this.polygon.getPath() ){
      //   this.coordinates.push(this.polygon.getPath()[i]);
      // }
      this.coordinates = [];
      var self = this;
      this.polygon.getPath().forEach(function(element){
        self.coordinates.push({ lat: element.lat(), lng: element.lng() });
      });
      var data = {
        name: this.name,
        coordinates: this.coordinates,
        id: this.id,
        preferences: {
          fillColor: this.polygon.fillColor
        }
      }
      return data;
    };
    EventZone.prototype.draw = function(map){
      if (!this.coordinates){
        var bounds = MapCommon.calcBounds(this.latLng, this.defaultSize);
        this.coordinates = MapCommon.boundsToPath(bounds);
      }
      this.polygon = new google.maps.Polygon({
        paths: this.coordinates,
        strokeColor: '#ffffe6',
        strokeOpacity: 0.6,
        strokeWeight: 4,
        fillColor: this.fillColor,
        fillOpacity: 0.3,
        zIndex: 1,
        map: map
      });
    };
    EventZone.prototype.remove = function(){
      this.polygon.setMap(null);
    };
    EventZone.prototype.addClickListener = function(clickListener){
      google.maps.event.addListener(this.polygon, 'click', clickListener);
    };
    EventZone.prototype.hide = function(){
      this.polygon.setVisible(false);
    };
    EventZone.prototype.show = function(){
      this.polygon.setVisible(true);
    };
    EventZone.prototype.focus = function(){
      this.polygon.setOptions({
        editable: true,
        draggable: true
      });
    };
    EventZone.prototype.unfocus = function(){
      this.polygon.setOptions({
        editable: false,
        draggable: false
      });
    };
    EventZone.prototype.setColor = function(color) {
      this.polygon.setOptions({
        fillColor: color
      })
    };
    // EventZone.prototype.disableClickEvent = function(){
    //   this.polygon.setOptions({
    //     clickable: false
    //   });
    // };
    // EventZone.prototype.enableClickEvent = function(){
    //   this.polygon.setOptions({
    //     clickable: true
    //   });
    // };
    return EventZone;
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('Booth', Booth)

  function Booth($rootScope, $window, $timeout, BoothOverlay, MapCommon, IWBoothContent){
    var google = google || $window.google;
    var activeInfoWindow = null;
    var infoWindow = new google.maps.InfoWindow();
    infoWindow.setZIndex(999);
    // var step = 3.28084;

    var Booth = function(isDraggable, isInfoWindowVisible){
      this.kind = 'Booth';
      this.width = 10;
      this.height = 10;
      this.fillColor = '#000000';
      this.opacity = 0;

      this.overlay = null;

      this.defaultIcon = 'assets/images/default.png';

      this.backgroundImage = {
        id: 'default',
        link: 'assets/images/default.png'
      };

      this.photos = [];

      this.isHidden = false;

      this.boothReservation = false;
      this.isDraggable = isDraggable;
      this.isInfoWindowVisible = isInfoWindowVisible;
      this.boothDegree = 0;
      this.indoorMapIds = [];

      this.routeIds = [];
      this.zoneId = null;

      this.userCommercialAssignments = [];
      this.userNonCommercialAssignments = [];
    }
    Booth.prototype.read = function(data, boothTypes, requests){
      var pref = data.preferences;

      this._type = pref._type ? pref._type : 'fixed';
      this._withHide = data.withHide;

      this.id = data.id;
      this.zoneId = data.zoneId;
      this.boothTypeId = data.boothTypeId;
      this.routeCoordinates = data.routeCoordinates;
      this.description = data.description;

      this.requests = requests || {};

      this.indoorMapIds = data.indoorMapIds || [];

      this.fillColor = pref.fillColor;
      this.opacity = pref.opacity;

      this.routeIds = data.routeIds || [];

      this.boothReservation = pref.boothReservation;

      this.photos = data.photos || [];

      if ( boothTypes ){
        for ( var i in boothTypes ){
          if ( boothTypes[i].id === this.boothTypeId ){
            this.boothType = boothTypes[i];
            if ( boothTypes[i].icon && boothTypes[i].icon.link ){
              this.backgroundImage = boothTypes[i].icon;
            }
          }
        }
      }

      this.userCommercialAssignments = data.userCommercialAssignments;
      this.userNonCommercialAssignments = data.userNonCommercialAssignments;

      if ( this._type === 'fixed' ){
        this.icon = pref.icon;
        this.width = data.width;
        this.height = data.height;
        this.boothDegree = pref.boothDegree || 0;

        this.position = new google.maps.LatLng({
          lat: data.position.lat,
          lng: data.position.lng
        });
      }
      if ( this._type === 'flexible' ){
        this.coordinates = pref.coordinates;
      }
    };
    Booth.prototype.set = function(){
      var data = {
        id: this.id,
        zoneId: this.zoneId,
        boothTypeId: this.boothTypeId,
        description: this.description,

        indoorMapIds: this.indoorMapIds,

        userCommercialAssignments: this.userCommercialAssignments,
        userNonCommercialAssignments: this.userNonCommercialAssignments,

        routeIds: this.routeIds,

        photos: this.photos,

        preferences: {
          _type: this._type,
          fillColor: this.fillColor,
          opacity: this.opacity,
          boothReservation: this.boothReservation
        }
      };
      if ( this._type === 'fixed' ){
        data['position'] = {
          lat: this.overlay.position.lat(),
          lng: this.overlay.position.lng()
        }
        data['width'] = this.width;
        data['height'] = this.height;
        data['preferences']['boothDegree'] = this.boothDegree;
      }
      if ( this._type === 'flexible' ){
        var self = this;
        this.coordinates = [];
        this.polygon.getPath().forEach(function(element){
          self.coordinates.push({ lat: element.lat(), lng: element.lng() });
        });
        data['preferences']['coordinates'] = this.coordinates;
      }
      return data;
    };
    Booth.prototype.draw = function(map){
      if ( this._type === 'fixed' ){
        this.overlay = new BoothOverlay(this, this.defaultIcon, map);
      } else {
        if ( !this.coordinates ){
          var defaultSize = new google.maps.Size(15,15);
          var bounds = MapCommon.calcBounds(this.position, defaultSize);
          this.coordinates = MapCommon.boundsToPath(bounds);
        }
        this.polygon = new google.maps.Polygon({
          paths: this.coordinates,
          strokeColor: '#000000',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: this.fillColor,
          fillOpacity: this.opacity/100,
          zIndex: 4,
          map: map
        });
      }

      if ( this._withHide ){
        var self = this;
        $timeout(function(){
          self.hide();
        }, 500);
      }
    };
    Booth.prototype.remove = function(){
      if ( this._type === 'fixed' ){
        this.overlay.setMap(null);
      } else {
        this.polygon.setMap(null);
      }
    };
    Booth.prototype.addClickListener = function(clickListener){
      // Only for flexible
      google.maps.event.addListener(this.polygon, 'click', clickListener);
    };
    // Booth.prototype.addClickListener = function(clickListener){
    //   if ( this._type === 'fixed' ){
    //     google.maps.event.addListener(this.overlay.onPolygon, 'click', clickListener);
    //   } else {
    //     google.maps.event.addListener(this.polygon, 'click', clickListener);
    //   }
    // };
    Booth.prototype.hide = function(){
      this.isHidden = true;
      if ( activeInfoWindow ) {
        activeInfoWindow.close();
      }
      if ( this._type === 'fixed'){
        if ( $rootScope.currentEvent.preferences.grayscaleBooths ){
          if ( this.backgroundImage ){
            var img = this.overlay.getImage();
            img.style.display = 'none';
          }
          this.overlay.getSpan().style.backgroundColor = '#d3d3d3';
          this.overlay.getSpan().style.opacity = '0.8';

          this.overlay.getDiv().style.pointerEvents = 'none';
        } else {
          this.overlay.getDiv().style.visibility = 'hidden';
        }
      } else {
        if ( $rootScope.currentEvent.preferences.grayscaleBooths ){
          this.polygon.setOptions({
            strokeColor: '#d3d3d3',
            fillColor: '#d3d3d3',
            fillOpacity: 0.75,
            clickable: false,
          });
        } else {
          this.polygon.setVisible(false);
        }
      }
    };
    Booth.prototype.show = function(){
      this.isHidden = false;
      if ( this._type === 'fixed'){
        // this.overlay.getDiv().style.backgroundImage = this.backgroundImage;
        if ( this.backgroundImage ){
          var img = this.overlay.getImage();
          img.style.display = 'block';
        }
        this.overlay.getSpan().style.backgroundColor = this.fillColor;
        this.overlay.getSpan().style.opacity = (this.opacity / 100);

        this.overlay.getDiv().style.visibility = 'visible';
        this.overlay.getDiv().style.opacity = '1';
        this.overlay.getDiv().style.pointerEvents = 'all';
      } else {
        this.polygon.setOptions({
          strokeColor: '#000000',
          fillColor: this.fillColor,
          fillOpacity: this.opacity/100,
          clickable: true
        });
        this.polygon.setVisible(true);

        delete this['_prevColor'];
        delete this['_prevOpacity'];
      }
    };
    Booth.prototype.focus = function(){
      if ( this._type === 'fixed'){
        this.overlay.getDiv().style.border = '3px solid #000';
      } else {
        this.polygon.setOptions({
          editable: true,
          draggable: true
        });
      }
    };
    Booth.prototype.unfocus = function(){
      if ( this._type === 'fixed' ){
        this.overlay.getDiv().style.border = '0';
      } else {
        this.polygon.setOptions({
          editable: false,
          draggable: false
        });
      }
    };
    Booth.prototype.setColor = function() {
      if ( this._type === 'fixed' ){
        this.overlay.getSpan().style.backgroundColor = this.fillColor;
        this.overlay.getSpan().style.opacity = (this.opacity / 100);
      } else {
        // console.log(color);
        this.polygon.setOptions({
          fillColor: this.fillColor,
          fillOpacity: (this.opacity / 100)
        });
      }
    };
    Booth.prototype.setImage = function() {
      if ( this._type === 'fixed' ){
        var link = this.backgroundImage.link;
        var img = this.overlay.getImage();
        img.src = link;
        if ( link.indexOf(this.defaultIcon) !== -1 ) {
          img.style.maxWidth = 'initial';
          img.style.maxHeight = 'initial';
          img.style.top = 'initial';
          img.style.left = 'initial';
          img.style.transform = 'none';

          img.style.width = '100%';
          img.style.height = '100%';
        } else {
          img.style.maxWidth = '100%';
          img.style.maxHeight = '100%';
          img.style.width = 'auto';
          img.style.height = 'auto';
          img.style.top = '50%';
          img.style.left = '50%';
          img.style.transform = 'translate(-50%, -50%)';
        }
      }
    };
    Booth.prototype.resize = function(){
      this.overlay.onResize(this.width, this.height);
    };
    // Booth.prototype.feetToMetric = function(){
    //   this.width = (this.imperialWidth / step);
    //   this.height = (this.imperialHeight / step);

    //   this.overlay.onResize(this.width, this.height);
    // };
    // Booth.prototype.opacity = function(){
    //   console.log(this.overlay);
    //   // this.overlay.onOpacity(this.bgOpacity);
    // };
    Booth.prototype.showInfowindow = function(map, indoorMaps, url){
      if ( activeInfoWindow ) {
        activeInfoWindow.close();
      }

      if ( this.isInfoWindowVisible ){
        var content = IWBoothContent.renderInfoWindowContent(this, indoorMaps, url);
        infoWindow.setContent(content);
        if ( this._type === 'fixed' ){
          infoWindow.setPosition(this.position);
        } else {
          infoWindow.setPosition(this.coordinates[0]);
        }
        infoWindow.open(map);
        activeInfoWindow = infoWindow;
      }
    };
    Booth.prototype.rotate = function(direction){
      if ( direction === 'right' ){
        this.boothDegree += 15;
      } else {
        this.boothDegree -= 15;
      }
      this.overlay.getDiv().style.transform = 'rotate('+ this.boothDegree +'deg)';
    };
    return Booth;
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('BoothOverlay', BoothOverlay)
  
  function BoothOverlay(IWBoothContent, $window, MapCommon) {
    var google = google || $window.google;
    var activeInfoWindow = null;
    var infoWindow = new google.maps.InfoWindow();
    infoWindow.setZIndex(999);

    BoothOverlay.prototype = new google.maps.OverlayView();

    function BoothOverlay(booth, defaultIcon, map){
      // Initialize all properties.
      this.booth = booth;
      this.position = booth.position;
      // this.icon = booth.icon;
      this.description = booth.description;
      this.width = booth.width;
      this.height = booth.height;
      this.color = booth.fillColor;
      this.request = booth.request;
      this.opacity = booth.opacity;
      this.isDraggable = booth.isDraggable;
      this.isInfoWindowVisible = booth.isInfoWindowVisible;
      this.boothDegree = booth.boothDegree;
      this.backgroundImage = booth.backgroundImage;

      this.defaultIcon = defaultIcon;

      // Define a property to hold the image's div. We'll
      // actually create this div upon receipt of the onAdd()
      // method so we'll leave it null for now.
      this.div = null;

      // Explicitly call setMap on this overlay.
      this.setMap(map);
    }
    BoothOverlay.prototype.onAdd = function(){
      var div = document.createElement('div');
      div.style.position = 'absolute';
      div.style.overflow = 'hidden';
      div.style.zIndex = '9999';

      // Create span which will change booth overlay color and opacity
      var span = document.createElement('span');
      span.style.position = 'absolute';
      span.style.top = 0;
      span.style.right = 0;
      span.style.bottom = 0;
      span.style.left = 0;
      span.style.backgroundColor = this.color;
      span.style.opacity = (this.opacity / 100);
      span.style.zIndex = '1';
      div.appendChild(span);

      // console.log(booth.)

      // Create the img element and attach it to the div.
      var img = document.createElement('img');
      img.src = this.backgroundImage.link;
      // img.style.width = '100%';
      // img.style.height = '100%';
      img.style.position = 'absolute';

      if ( this.backgroundImage.link.indexOf(this.defaultIcon) !== -1 ) {
        img.style.width = '100%';
        img.style.height = '100%';
      } else {
        img.style.maxWidth = '100%';
        img.style.maxHeight = '100%';
        img.style.height = 'auto';
        img.style.top = '50%';
        img.style.left = '50%';
        img.style.transform = 'translate(-50%, -50%)'; // rotate('+ this.boothDegree +'deg)';
      }
      img.style.zIndex = '2';
      div.appendChild(img);

      div.style.transform = 'rotate('+ this.boothDegree +'deg)';

      this.span = span;
      this.div = div;
      this.img = img;

      var self = this;

      // Add the element to the "overlayLayer" pane.
      // overlayLayer
      // overlayMouseTarget
      // floatPane
      this.getPanes().overlayLayer.appendChild(div);
      // if (  ){
      //   this.getPanes().overlayLayer.appendChild(div);
      // } else {
      // this.getPanes().overlayMouseTarget.appendChild(div);
      // }

      // Layout mouse eventts
      // google.maps.event.addDomListener(div, 'click', function(event) {
      //   event.stopPropagation();
      //   google.maps.event.trigger(self, 'click', event); 
      // });
      // If mouse is over booth, avoid click on eventZones ( clickable: false on EventZone )
      // google.maps.event.addDomListener(div, 'mouseover', function(event) {
      //   event.stopPropagation();
      //   google.maps.event.trigger(self, 'mouseover', event); 
      // });
      // // If mouse out reset it to default
      // google.maps.event.addDomListener(div, 'mouseout', function(event) {
      //   event.stopPropagation();
      //   google.maps.event.trigger(self, 'mouseout', event); 
      // });

      if ( this.isDraggable ) {
        this.getPanes().overlayMouseTarget.appendChild(div);
        google.maps.event.addDomListener(div, 'mousedown', function(e) {
          this.style.cursor = 'move';
          self.map.set('draggable', false);
          self.origin = e;
          self.moveHandler = google.maps.event.addDomListener(self.get('map').getDiv(), 'mousemove', function(e) {
            var origin = self.origin;
            var left = origin.clientX - e.clientX;
            var top = origin.clientY - e.clientY;
            var pos = self.getProjection().fromLatLngToDivPixel(self.position);
            var latLng = self.getProjection().fromDivPixelToLatLng(new google.maps.Point(pos.x - left, pos.y - top));
            self.origin = e;
            self.position = latLng;
            self.draw();
          });
        });
        google.maps.event.addDomListener(div, 'mouseup', function() {
          if (self.map) {
            self.map.set('draggable', true);
            this.style.cursor = 'default';
            google.maps.event.removeListener(self.moveHandler);
          }
        });
      }
    };
    BoothOverlay.prototype.draw = function() {
      // We use the south-west and north-east
      // coordinates of the overlay to peg it to the correct position and size.
      // To do this, we need to retrieve the projection from the overlay.
      var overlayProjection = this.getProjection();
      var bounds = MapCommon.calcBounds(this.position, new google.maps.Size(this.width, this.height));

      this.polygon = MapCommon.boundsToPath(bounds);
      // Retrieve the south-west and north-east coordinates of this overlay
      // in LatLngs and convert them to pixel coordinates.
      // We'll use these coordinates to resize the div.
      var sw = overlayProjection.fromLatLngToDivPixel(bounds.getSouthWest());
      var ne = overlayProjection.fromLatLngToDivPixel(bounds.getNorthEast());

      // Resize the image's div to fit the indicated dimensions.
      // var div = this.div;
      this.div.style.left = sw.x + 'px';
      this.div.style.top = ne.y + 'px';
      this.div.style.width = (ne.x - sw.x) + 'px';
      this.div.style.height = (sw.y - ne.y) + 'px';
    };
    BoothOverlay.prototype.onResize = function(width, height){
      this.width = width;
      this.height = height;
      this.draw();
    };
    BoothOverlay.prototype.onRemove = function() {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    };
    // BoothOverlay.prototype.onOpacity = function(opacity){
    //   this.opacity = opacity;
    //   this.span.style.opacity = (this.opacity / 100);
    // };
    BoothOverlay.prototype.getDiv = function(){
      return this.div;
    };
    BoothOverlay.prototype.getSpan = function(){
      return this.span;
    };
    BoothOverlay.prototype.getImage = function(){
      return this.img;
    };
    BoothOverlay.prototype.getActiveInfowindow = function(){
      return activeInfoWindow;
    };
    BoothOverlay.prototype.onShowInfowindow = function(indoorMaps, url){
      // renderInfowindow(this, indoorMaps, url)
      var content = IWBoothContent.renderInfoWindowContent(this.booth, indoorMaps, url);
      console.log(content);
      if ( activeInfoWindow ) {
        activeInfoWindow.close();
      }
      infoWindow.setContent(content);
      infoWindow.setPosition(this.position);
      infoWindow.open(this.map);
      // this.map.setCenter(this.position);
      activeInfoWindow = infoWindow;
    };
    return BoothOverlay;
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('IndoorZone', IndoorZone)

  function IndoorZone(IndoorTool, IndoorInfowindow){

    var IndoorZone = function(isDraggable){
      this.kind = null; // Can be 'EventZone' || 'RespZone'
      this.name = '';

      this.width = 100;
      this.height = 100;

      this.isDraggable = isDraggable;

      this.fillColor = IndoorTool.randomHexColor();

      this.strokeColorResp = '#121212';
      this.strokeColorEvent = '#efefef';
      this.strokeWidthResp = 1;
      this.strokeWidthEvent = 2;
    };
    IndoorZone.prototype.read = function(data){
      var pref = data.preferences;

      this.id = data.id;
      this.kind = pref.kind;
      this.name = data.name;

      this.width = pref.width;
      this.height = pref.height;

      this.x = pref.x;
      this.y = pref.y;

      this.fillColor = pref.fillColor;

      if ( pref.kind === 'RespZone' ){
        this.zoneId = data.zoneId;
        this.description = data.description;
        this.volunteerAssignments = data.volunteerAssignments;
      }
    };
    IndoorZone.prototype.set = function(){
      var data = {
        id: this.id,
        name: this.name,
        preferences: {
          width: this.width,
          height: this.height,
          kind: this.kind,
          fillColor: this.fillColor,
          x: this.x,
          y: this.y
        }
      };
      if (this.kind === 'RespZone'){
        data['zoneId'] = this.zoneId;
        data['description'] = this.description;
        data['volunteerAssignments'] = this.volunteerAssignments;
      }
      return data;
    };
    IndoorZone.prototype.draw = function(canvas, layer, fn, showInfowindow){
      var self = this;
      var rgb = hexToRGB(this.fillColor);

      this.layer = layer;
      this.shape = new canvas.Rect({
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        // fill: 'rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +',0.35)',
        stroke: this.kind === 'RespZone' ? this.strokeColorResp : this.strokeColorEvent,
        strokeWidth: this.kind === 'RespZone' ? this.strokeWidthResp : this.strokeWidthEvent,
      });
      if ( rgb ) this.shape.fill('rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +',0.35)');
      layer.add(this.shape);
      if ( this.kind === 'RespZone' ){
        this.shape.name('responsibilityZone');
        this.shape.setZIndex(3);
        if (showInfowindow) this.shape.on('click tap', function(){
          handleInfowindow(self);
        });
      }
      if ( this.kind === 'EventZone' ){
        this.shape.name('eventZone');
        this.shape.setZIndex(2);
      }
      if (fn) this.shape.on('click tap', fn);
      layer.draw();
    };
    IndoorZone.prototype.focus = function(){
      var self = this;
      if ( this.isDraggable ){
        this.shape.draggable(this.isDraggable);

        this.shape.on('dragstart', function(pos){
          // console.log('dragstart');
        });
        this.shape.on('dragend', function(pos){
          self.x = this.getAbsolutePosition().x;
          self.y = this.getAbsolutePosition().y;
        });
      }
      this.shape.strokeWidth((this.kind === 'RespZone' ? this.strokeWidthResp : this.strokeWidthEvent) * 2);
      this.layer.draw();
    };
    IndoorZone.prototype.unfocus = function(){
      this.shape.draggable(false);
      this.shape.strokeWidth(this.kind === 'RespZone' ? this.strokeWidthResp : this.strokeWidthEvent);
      this.layer.draw();
    };
    IndoorZone.prototype.show = function(){
      this.shape.show();
      this.layer.draw();
    };
    IndoorZone.prototype.hide = function(){
      this.shape.hide();
      this.layer.draw();
    };
    IndoorZone.prototype.remove = function(){
      this.shape.destroy();
      this.layer.draw();
    };
    IndoorZone.prototype.resize = function(){
      this.shape.width(this.width);
      this.shape.height(this.height);
      this.layer.draw();
    };
    IndoorZone.prototype.setColor = function(color){
      var rgb = hexToRGB(this.fillColor);
      if ( rgb ){
        this.shape.fill('rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +',0.25)');
        this.layer.draw();
      }
    };
    return IndoorZone;

    function handleInfowindow(self){
      var scale = self.shape.getAbsoluteScale().x;
      var stage = self.shape.getStage();
      var stageX = (stage.width()/2);
      var stageY = (stage.height()/2);

      self.shape.getStage().position({
        x: stageX - (self.x * scale),
        y: stageY - (self.y * scale)
      });
      self.shape.getStage().batchDraw();

      var infowindow = new IndoorInfowindow(self);
      infowindow.show();
    }

    function hexToRGB(hex){
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
      } : null;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('IndoorTool', IndoorTool)

    function IndoorTool() {
      return {
        calcCoordination: function(self){
          var w = self.width;
          var h = self.height;
          var x = self.position.posX - (w/2);
          var y = self.position.posY - (h/2);

          if ( self.kind === 'Booth' ){
            return {
              posX: x,
              posY: y
            };
          } else if ( self.kind === 'RespZone' || self.kind === 'EventZone' ){
            return [
              x,y,
              x + w,y,
              x + w, y + h,
              x, y + h
            ];
          }
        },
        randomHexColor: function(){
          return '#'+ Math.floor(Math.random()*16777215).toString(16);
        }
      }
    }
})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('IndoorStage', IndoorStage);

  function IndoorStage(){
    var Konva = window.Konva || Konva;
    var lastDist = 0;

    var IndoorStage = function(isDraggable){
      this.x = 0;
      this.y = 0;
      this.width = 700;
      this.height = 700;
      this.scale = 1.01;
      this.isDraggable = isDraggable || false;

      this.stage = null;
    };
    IndoorStage.prototype.onInit = function(data){
      var pref = data.preferences;
      this.stage = new Konva.Stage({
        container: 'map',
        x: pref && pref.stageX ? pref.stageX : this.x,
        y: pref && pref.stageY ? pref.stageY : this.y,
        width: this.width,
        height: this.height,
        draggable: this.isDraggable
      });
      if ( pref && pref.stageScale ){
        this.stage.scale({
          x: pref.stageScale,
          y: pref.stageScale
        });
      }
      return this.stage;
    };
    IndoorStage.prototype.Layer = function(){
      return new Konva.Layer();
    };
    IndoorStage.prototype.Konva = function(){
      return Konva;
    };
    IndoorStage.prototype.changeResize = function(){
      var self = this;
      fitStageIntoParentContainer(self.stage)
      window.addEventListener('resize', function(){
        fitStageIntoParentContainer(self.stage);
      });
    };
    IndoorStage.prototype.changeScale = function(overlay, fn, selectedItem){
      var self = this;

      self.stage.on('wheel', function(e){
        // if ( !selectedItem ){
          scaleStage(e.evt, self.stage, self.scale, overlay);
          if (fn) fn();
        // }
      });

      // self.stage.getContent().addEventListener('touchmove', function(evt){
      //   var touch1 = evt.touches[0];
      //   var touch2 = evt.touches[1];

      //   if (touch1 && touch2){
      //     var dist = getDistance({
      //       x: touch1.clientX,
      //       y: touch1.clientY
      //     }, {
      //       x: touch2.clientX,
      //       y: touch2.clientY
      //     });

      //     if (!lastDist) {
      //       lastDist = dist;
      //     }

      //     var scale = self.stage.getScaleX() * dist / lastDist;

      //     self.stage.scaleX(scale);
      //     self.stage.scaleY(scale);
      //     // self.stage.draw();

      //     // self.stage.scale({ x: scale, y: scale });
      //     self.stage.position({
      //       x: stage.x(),
      //       y: stage.y()
      //     });

      //     self.stage.draw();
      //     // self.stage.batchDraw();

      //     overlay.setStageScale(scale);

      //     lastDist = dist;
      //   }
      // }, false);

      // self.stage.getContent().addEventListener('touchend', function() {
      //   lastDist = 0;
      // }, false);

      // window.addEventListener('wheel', function(evt){
      //   // console.log(selectedItem);
      //   if ( !selectedItem ){
      //     scaleStage(evt, self.stage, self.scale, overlay);
      //     if (fn) fn();
      //   }
      // });
    };
    IndoorStage.prototype.drag = function(overlay){
      this.stage.on('dragstart', function(){
        removeInfowindow();
      });
      this.stage.on('dragend', function(){
        var x = this.getAbsolutePosition().x;
        var y = this.getAbsolutePosition().y;
        overlay.setStagePosition(x, y);
      });
    };
    // IndoorStage.prototype.dragStart = function(){
      
    // };
    // IndoorStage.prototype.dragEnd = function(overlay){
    //   this.stage.on('dragend', function(){
    //     var x = this.getAbsolutePosition().x;
    //     var y = this.getAbsolutePosition().y;
    //     overlay.setStagePosition(x, y);
    //   });
    // };
    IndoorStage.prototype.zoomInOut = function(overlay){
      var self = this;

      var zoomInOutGroup = document.getElementById('indoorMapZoomInOutGroup');
      var zoomIn = document.getElementById('indoorMapZoomIn');
      var zoomOut = document.getElementById('indoorMapZoomOut');

      if ( zoomIn && zoomOut && zoomInOutGroup ){

        var rect = zoomInOutGroup.getBoundingClientRect();

        setTimeout(function(){
          calculateOnScroll(window);
        }, 500);

        window.onscroll = function(){
          calculateOnScroll(this);
        };

        function calculateOnScroll(self){
          var scrollTop = self.scrollY;
          var bottom = rect.bottom + 8;
          var height = rect.height - 16;

          zoomInOutGroup.style.bottom = (bottom - self.innerHeight) + 'px';
          var calcBottom = ( bottom - self.innerHeight ) - scrollTop;
          var calcNext = self.innerHeight - (bottom + scrollTop + height);

          if ( bottom > self.innerHeight ){
            zoomInOutGroup.style.bottom = (calcBottom > 0 ? calcBottom : 0) + 'px';
          } else {
            zoomInOutGroup.style.bottom = (calcNext > 0 ? calcNext : 0) + 'px';
          }
        }

        zoomIn.addEventListener('click', function(evt){
          evt['deltaY'] = -1;
          scaleStage(evt, self.stage, self.scale, overlay, 'click')
        });
        zoomOut.addEventListener('click', function(evt){
          evt['deltaY'] = 1;
          scaleStage(evt, self.stage, self.scale, overlay, 'click');
        });
      } else {
        console.error('Cannot find buttons zoomIn/zoomOut');
      }
    }
    return IndoorStage;

    function removeInfowindow(){
      var old = document.getElementById('indoorInfowindow');
      if ( old ){
        old.parentNode.removeChild(old);
      }
    }

    // function getDistance(p1, p2) {
    //   return Math.sqrt(Math.pow((p2.x - p1.x), 2) + Math.pow((p2.y - p1.y), 2));
    // }

    function fitStageIntoParentContainer(stage){
      var wrap = document.getElementById('mapWrap');
      if ( wrap ){
        var wrapWidth = wrap.offsetWidth;
        var wrapHeight = wrap.offsetHeight;

        stage.width(wrapWidth);
        stage.height(wrapHeight);
        stage.draw();
      }
    }

    function scaleStage(evt, stage, scale, overlay, type){
      evt.preventDefault();
      var oldScale = stage.scaleX();

      var val = type && type === 'click' ? 0.05 : 0;

      var newScale = evt.deltaY > 0 ? (oldScale / scale) - val : (oldScale * scale) + val;

      stage.scale({ x: newScale, y: newScale });
      stage.position({
        x: stage.x(),
        y: stage.y()
      });
      stage.batchDraw();

      overlay.setStageScale(newScale);
      overlay.setStagePosition(stage.x(), stage.y());

      removeInfowindow();
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('IndoorRoute', IndoorRoute)

  function IndoorRoute(IndoorTool){

    var IndoorRoute = function(isDraggable){
      this.kind = 'Route'
      this.name = '';
      this.instructions = '';

      this.isDraggable = isDraggable;

      this.isDraw = false;

      this.points = [];
      this.dots = [];
      this.arrows = [];

      this.strokeColor = IndoorTool.randomHexColor();
      this.thickness = 4;
      this.showArrows = true;
    };
    IndoorRoute.prototype.read = function(data){
      var pref = data.preferences;

      this.id = data.id;
      this.name = data.name;
      this.instructions = data.instructions;

      this.zoneId = data.zoneId;
      
      this.points = pref.points;

      if ( pref && pref.strokeColor ) {
        this.strokeColor = pref.strokeColor;
      }
      if ( pref && pref.public ) {
        this.public = pref.public;
      }
      this.showArrows = typeof pref.showArrows !== 'undefined' ? pref.showArrows : true;
      this.thickness = typeof pref.thickness !== 'undefined' ? pref.thickness : this.thickness;
    };
    IndoorRoute.prototype.set = function(){
      return {
        id: this.id,
        zoneId: this.zoneId,
        instructions: this.instructions,
        name: this.name,
        preferences: {
          points: this.points,
          strokeColor: this.strokeColor,
          public: this.public,
          thickness: this.thickness,
          showArrows: this.showArrows
        }
      }
    };
    IndoorRoute.prototype.draw = function(canvas, layer, fn){
      // Destroy prev drawed dots: need only on Map Constructor
      for ( var i in this.dots ){
        var dot = this.dots[i];
        dot.destroy();
      }

      // Destroy prev drawed arrows: need only on Map Constructor
      for ( var i in this.arrows ){
        var arrow = this.arrows[i];
        if ( arrow.lineOne && arrow.lineTwo ){
          arrow.lineOne.destroy();
          arrow.lineTwo.destroy();
        }
      }

      this.dots = [];
      this.arrows = [{}];

      this.layer = layer;

      var points = [];

      if (!this.shape){
        this.shape = new canvas.Line({
          points: points,
          stroke: this.strokeColor,
          strokeWidth: this.thickness,
          lineCap: 'round',
          lineJoin: 'round'
        });
        this.layer.add(this.shape);
        this.shape.setZIndex(897);
        if (fn) this.shape.on('click tap', fn);
      }

      var fx;
      var fy;

      for (var i in this.points){
        var point = this.points[i];

        points.push(point.x);
        points.push(point.y);

        if ( i != 0 && point.x && point.y ){
          var lineOne = new canvas.Line({
            points: [point.x, point.y, lineToX(point.x, fx, point.y, fy, false), lineToY(point.x, fx, point.y, fy, false)],
            stroke: this.strokeColor,
            strokeWidth: this.thickness,
            lineCap: 'round',
            lineJoin: 'round',
            visible: this.showArrows
          });
          var lineTwo = new canvas.Line({
            points: [point.x, point.y, lineToX(point.x, fx, point.y, fy, true), lineToY(point.x, fx, point.y, fy, true)],
            stroke: this.strokeColor,
            strokeWidth: this.thickness,
            lineCap: 'round',
            lineJoin: 'round',
            visible: this.showArrows
          });

          this.arrows.push({
            lineOne: lineOne,
            lineTwo: lineTwo
          });

          this.layer.add(lineOne);
          this.layer.add(lineTwo);
        }

        var circle = new canvas.Circle({
          x: point.x,
          y: point.y,
          radius: 4,
          fill: '#ffffff',
          strokeWidth: 1,
          stroke: '#000000',
          visible: false
        });

        this.dots.push(circle);
        this.layer.add(circle);

        fx = point.x;
        fy = point.y;
      }

      this.shape.points([].concat(points));
      this.layer.draw();
    };
    IndoorRoute.prototype.setPoints = function(pos){
      this.points.push(pos);
    };
    IndoorRoute.prototype.focus = function(){
      var self = this;

      if ( this.isDraggable ){
        var scale = this.stage.scaleX();

        this.dots.forEach(function(dot, index){
          dot.show();
          dot.draggable(true);

          dot.on('dragstart', function(pos){

          });
          dot.on('dragend', function(pos){
            var points = [];
            var p = [];

            self.points[index] = {
              x: self.stage.getPointerPosition().x / scale - self.stage.x() / scale,
              y: self.stage.getPointerPosition().y / scale - self.stage.y() / scale,
            };

            for (var i in self.points){
              points.push(self.points[i].x);
              points.push(self.points[i].y);

              p.push({x: self.points[i].x, y: self.points[i].y});
            }

            for (var i = 0; i < p.length; i++){
              if ( i !== 0 ){
                var prev = p[i - 1];
                var px = prev.x;
                var py = prev.y;
                var x = p[i].x;
                var y = p[i].y;

                self.arrows[i].lineOne.points([x, y, lineToX(x, px, y, py, false), lineToY(x, px, y, py, false)]);
                self.arrows[i].lineTwo.points([x, y, lineToX(x, px, y, py, true), lineToY(x, px, y, py, true)]);
              }
            }

            self.shape.points([].concat(points));
            self.layer.draw();
          });
        });
      }
      this.shape.strokeWidth(this.thickness + 2);
      this.layer.draw();
    };
    IndoorRoute.prototype.unfocus = function(){
      // this.shape.draggable(false);
      this.dots.forEach(function(dot){
        dot.hide();
        dot.draggable(false)
      });
      this.shape.strokeWidth(this.thickness);
      this.layer.draw();
    };
    IndoorRoute.prototype.show = function(){
      this.shape.show();
      this.dots.forEach(function(dot){
        // dot.show();
        dot.opacity(1);
      });
      this.arrows.forEach(function(arrow, index){
        if ( index !== 0 ){
          arrow.lineOne.show();
          arrow.lineTwo.show();
        }
      });
      this.layer.draw();
    };
    IndoorRoute.prototype.hide = function(){
      this.shape.hide();
      this.dots.forEach(function(dot){
        // dot.hide();
        dot.opacity(0);
      });
      this.arrows.forEach(function(arrow, index){
        if ( index !== 0 ){
          arrow.lineOne.hide();
          arrow.lineTwo.hide();
        }
      });
      this.layer.draw();
    };
    IndoorRoute.prototype.remove = function(){
      this.shape.destroy();
      this.dots.forEach(function(dot){
        dot.destroy();
      });
      this.arrows.forEach(function(arrow, index){
        if ( index !== 0 ){
          arrow.lineOne.destroy();
          arrow.lineTwo.destroy();
        }
      });
      this.layer.draw();
    };
    IndoorRoute.prototype.setColor = function(color){
      this.shape.stroke(color);
      this.arrows.forEach(function(arrow, index){
        if ( index !== 0 ){
          arrow.lineOne.stroke(color);
          arrow.lineTwo.stroke(color);
        }
      });
      this.layer.draw();
    };
    IndoorRoute.prototype.changeArrowVisibility = function(visibility){
      this.arrows.forEach(function(arrow, index){
        if ( index !== 0 ){
          visibility ? arrow.lineOne.show() : arrow.lineOne.hide();
          visibility ? arrow.lineTwo.show() : arrow.lineTwo.hide();
        }
      });
      this.layer.draw();
    };
    IndoorRoute.prototype.changeThickness = function(thickness){
      if ( typeof thickness !== 'undefined' && thickness !== null ){
        this.shape.strokeWidth(thickness);
        this.arrows.forEach(function(arrow, index){
          if ( index !== 0 ){
            arrow.lineOne.strokeWidth(thickness);
            arrow.lineTwo.strokeWidth(thickness);
          }
        });
        this.layer.draw();
      }
    };
    return IndoorRoute;

    function lineToX(x, px, y, py, side){
      var size = 16;
      var angle = Math.atan2(y - py, x - px);
      return x - size * Math.cos(angle - (side === true ? (-Math.PI/6) : Math.PI/6));
    }
    function lineToY(x, px, y, py, side){
      var size = 16;
      var angle = Math.atan2(y - py, x - px);
      return y - size * Math.sin(angle - (side === true ? (-Math.PI/6) : Math.PI/6));
    }
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('IndoorOverlay', IndoorOverlay);

  function IndoorOverlay(){
    var IndoorOverlay = function(isDraggable){
      this.kind = 'Overlay';
      this.type = 'indoor';
      this.name = 'Floor 1';
      this.backgroundImage = null;

      this.x = 2;
      this.y = 2;

      this.width = 0;
      this.height = 0;

      this.fillColor = '#ffffff';
      this.opacity = 100;

      this.shape = null;
      this.canvas = null;
      this.layer = null;

      // Other pref
      this.isDraggable = isDraggable || false;
      this.strokeColor = '#121212';
      this.strokeWidth = 2;

      this.stageScale = 1.01;
    }
    IndoorOverlay.prototype.read = function(data, layer){
      var pref = data.preferences;

      this.id = data.id;
      this.name = data.name;
      this.backgroundImage = data.backgroundImage;

      this.stageX = pref && pref.stageX ? pref.stageX : this.x;
      this.stageY = pref && pref.stageY ? pref.stageY : this.y;

      this.width = pref && pref.width !== 0 ? pref.width : layer.getStage().width() - 10; // 745
      this.height = pref && pref.height !== 0 ? pref.height : layer.getStage().height() - 10; // 751

      this.fillColor = pref && pref.fillColor ? pref.fillColor : this.fillColor;
      this.opacity = pref && pref.opacity ? pref.opacity : this.opacity;

      this.stageScale = pref && pref.stageScale ? pref.stageScale : this.stageScale;
    };
    IndoorOverlay.prototype.set = function(){
      return {
        id: this.id,
        type: this.type,
        name: this.name,
        backgroundImage: this.backgroundImage,
        preferences: {
          // x: this.x,
          // y: this.y,
          width: this.width,
          height: this.height,
          fillColor: this.fillColor,
          opacity: this.opacity,
          stageScale: this.stageScale,
          stageX: this.stageX,
          stageY: this.stageY
        }
      }
    };
    IndoorOverlay.prototype.draw = function(canvas, layer){
      var self = this;
      var rgb = hexToRGB(this.fillColor);

      this.layer = layer;
      this.shape = new canvas.Image({
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        // fill: 'rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (this.opacity/100) +')',
        stroke: this.strokeColor,
        strokeWidth: this.strokeWidth,
        name: 'overlay'
      });
      if ( rgb ) this.shape.fill('rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (this.opacity/100) +')');

      layer.add(this.shape);

      this.shape.setZIndex(1);

      if ( this.backgroundImage && this.backgroundImage.link ){
        var img = new Image();
        img.onload = function(){
          self.shape.image(img);
          self.layer.draw();
        }
        img.src = this.backgroundImage.link;
      } else {
        layer.draw();
      }
    };
    IndoorOverlay.prototype.click = function(fn){
      this.shape.on('click tap', fn);
    };
    IndoorOverlay.prototype.focus = function(){
      // var self = this;
      // if ( this.isDraggable ){
        // this.shape.draggable(this.isDraggable);

        // this.shape.on('dragstart', function(){
        //   console.log('dragstart');
        // });
        // this.shape.on('dragend', function(){
        //   self.x = this.getAbsolutePosition().x;
        //   self.y = this.getAbsolutePosition().y;
        // });
      // }
      this.shape.strokeWidth(this.strokeWidth * 2);
      this.layer.draw();
    };
    IndoorOverlay.prototype.unfocus = function(){
      // this.shape.draggable(false);
      this.shape.strokeWidth(this.strokeWidth);
      this.layer.draw();
    };
    IndoorOverlay.prototype.resize = function(){
      this.shape.width(this.width);
      this.shape.height(this.height);
      this.layer.draw();
    };
    IndoorOverlay.prototype.setColor = function(){
      var rgb = hexToRGB(this.fillColor);
      if ( rgb ){
        this.shape.fill('rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (this.opacity/100) +')');
        this.layer.draw();
      }
    };
    IndoorOverlay.prototype.setImage = function(){
      if ( this.backgroundImage && this.backgroundImage.link ){
        var self = this;
        var img = new Image();
        img.onload = function(){
          self.shape.image(img);
          self.layer.draw();
        }
        img.src = this.backgroundImage.link;
      }
    };
    IndoorOverlay.prototype.removeImage = function(){
      this.backgroundImage = null;
      this.shape.image(null);
      this.layer.draw();
    };
    IndoorOverlay.prototype.setStageScale = function(scale){
      this.stageScale = scale;
    }
    IndoorOverlay.prototype.setStagePosition = function(x, y){
      this.stageX = x;
      this.stageY = y;
    }
    return IndoorOverlay;

    function hexToRGB(hex){
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
      } : null;
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('IndoorInfowindow', IndoorInfowindow);
  
  function IndoorInfowindow(IWBoothContent, $interval){
    var INDOOR_CLASS = 'indoor-infowindow';
    var INDOOR_ID = 'indoorInfowindow';
    var IndoorInfowindow = function(element){
      this.element = element;
    }
    IndoorInfowindow.prototype.show = function(){
      var old = document.getElementById(INDOOR_ID);
      if ( old ) old.parentNode.removeChild(old);

      var infowindow = buildInfowindowTemplate(this.element);

      document.getElementById('mapWrap').appendChild(infowindow);
      var infowindowRect = infowindow.getBoundingClientRect();

      var shape = this.element.shape;
      var stage = shape.getStage();
      var stageRect = stage.content.getBoundingClientRect();

      shape.on('click tap', function(e){
        e.evt.preventDefault();

        var iw = infowindowRect.width;
        var ih = infowindowRect.height;

        var pos = e.target.getStage().getPointerPosition();

        var clientX = e.type !== 'tap' ? e.evt.clientX : pos.x;
        var clientY = e.type !== 'tap' ? e.evt.clientY : pos.y;

        var top = (clientY - (e.type !== 'tap' ? stageRect.top : 0)) - ih - 4;
        var left = clientX - (iw/2);

        if ( top < 0 ){
          top = clientY - (e.type !== 'tap' ? stageRect.top : 0) + 4;
        }
        if ( left <= stageRect.left ){
          left = 2;
        }
        if ( (clientX + iw) >= (stageRect.right - stageRect.left) ){
          left = (stageRect.right - stageRect.left - iw) - 2;
        }

        infowindow.style.top = top +'px';
        infowindow.style.left = left +'px';
        infowindow.className = INDOOR_CLASS;
      });
    };
    return IndoorInfowindow;

    function buildInfowindowTemplate(element){
      var infoWindow = buildOuterDivInfoWindow();
      var infoWindowClose = buildCloseInfoWindow(element);
      var infoWindowInner = buildInnerDivInfoWindow();
      if ( element.kind === 'Booth' ){
        infoWindowInner.appendChild(IWBoothContent.renderInfoWindowContent(element));
      }
      if ( element.kind === 'RespZone' ){
        var div = document.createElement('div');
        div.innerText = element.description ? element.description : 'No instruction';
        infoWindowInner.appendChild(div);
      }
      // console.log(element);
      infoWindow.appendChild(infoWindowClose);
      infoWindow.appendChild(infoWindowInner);
      return infoWindow;
    }

    function buildInnerDivInfoWindow(){
      var div = document.createElement('div');
      div.className = INDOOR_CLASS +'-inner';
      return div;
    }

    function buildCloseInfoWindow(){
      var span = document.createElement('span');
      span.className = INDOOR_CLASS +'-close';
      span.innerText = 'x';
      span.addEventListener('click', function(){
        var old = document.getElementById(INDOOR_ID);
        if ( old ){
          old.parentNode.removeChild(old);
        }
      });
      return span;
    }

    function buildOuterDivInfoWindow(){
      var div = document.createElement('div');
      div.className = INDOOR_CLASS +' _hide';
      div.id = INDOOR_ID;
      return div;
    }

  };
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('IndoorBooth', IndoorBooth);

  function IndoorBooth($rootScope, IndoorInfowindow){
    var IndoorBooth = function(isDraggable, isInfoWindowVisible){
      this.kind = 'Booth';
      this.description = '';
      this.backgroundImage = {
        id: 'default',
        link: 'assets/images/default.png'
      };

      this._type = 'fixed';

      this.width = 25;
      this.height = 25;

      this.fillColor = '#ffffff';
      this.opacity = 0;
      this.rotateDegree = 0;

      this.userCommercialAssignments = [];
      this.userNonCommercialAssignments = [];

      this.shape = null;
      this.layer = null;

      this.routeIds = [];
      this.photos = [];

      this.points = [];
      this.dots = [];

      // Other pref
      this.isDraggable = isDraggable || false;
      this.isInfoWindowVisible = isInfoWindowVisible || false;
      this.strokeColor = '#121212';
      this.strokeWidth = 2;

      this.boothReservation = false;
    }
    IndoorBooth.prototype.read = function(data, boothTypes, requests){
      var pref = data.preferences;

      this._type = pref._type ? pref._type : 'fixed';
      this._withHide = data.withHide;

      this.id = data.id;
      this.zoneId = data.zoneId;
      this.boothTypeId = data.boothTypeId;
      this.description = data.description;

      this.width = data.width;
      this.height = data.height;

      this.fillColor = pref.fillColor;
      // this.opacity = pref.opacity || pref.bgOpacity;
      this.opacity = pref.opacity;
      this.rotateDegree = pref.rotateDegree;

      this.x = pref.x;
      this.y = pref.y;

      this.boothReservation = pref.boothReservation;

      this.userCommercialAssignments = data.userCommercialAssignments || [];
      this.userNonCommercialAssignments = data.userNonCommercialAssignments || [];

      this.requests = requests || [];

      this.routeIds = data.routeIds || [];
      this.photos = data.photos || [];

      this.points = pref.points || [];

      if ( boothTypes ){
        for ( var i in boothTypes ){
          if ( boothTypes[i].id === this.boothTypeId ){
            this.boothType = boothTypes[i];
            if ( boothTypes[i].icon && boothTypes[i].icon.link ){
              this.backgroundImage = boothTypes[i].icon;
            }
          }
        }
      }
    };
    IndoorBooth.prototype.set = function(){
      var data = {
        id: this.id,
        zoneId: this.zoneId,
        boothTypeId: this.boothTypeId,
        description: this.description,
        // width: this.width,
        // height: this.height,

        userCommercialAssignments: this.userCommercialAssignments,
        userNonCommercialAssignments: this.userNonCommercialAssignments,

        routeIds: this.routeIds,
        photos: this.photos,

        preferences: {
          _type: this._type,
          x: this.x,
          y: this.y,
          fillColor: this.fillColor,
          opacity: this.opacity,
          // rotateDegree: this.rotateDegree,
          boothReservation: this.boothReservation,

          points: this.points
        }
      }
      if ( this._type === 'fixed' ){
        data['width'] = this.width;
        data['height'] = this.height;
        data['preferences']['rotateDegree'] = this.rotateDegree;
      }
      if ( this._type === 'flexible' ){
        data['preferences']['points'] = this.points;
      }
      return data;
    };
    IndoorBooth.prototype.draw = function(canvas, layer, fn, showInfowindow){
      this.layer = layer;
      this.canvas = canvas;

      if ( this._type === 'fixed' ) createFixedBooth(this, fn, showInfowindow);
      if ( this._type === 'flexible' ) createFlexibleBooth(this, fn, showInfowindow);

      if ( this._withHide ) this.hide();
    };
    IndoorBooth.prototype.focus = function(){
      var self = this;
      if ( self.isDraggable ){
        var scale = self.stage.scaleX();
        // var shapesLayer = new Konva.Layer();

        if ( self._type === 'fixed' ){
          // ToDO: fix on flexible booth _type
          self.shape.draggable(self.isDraggable);

          self.shape.on('dragstart', function(pos){
          });
          self.shape.on('dragend', function(pos){
            var layerX = this.getLayer().getAbsolutePosition().x;
            var layerY = this.getLayer().getAbsolutePosition().y;

            var x = this.getAbsolutePosition().x;
            var y = this.getAbsolutePosition().y;

            var scale = this.getAbsoluteScale().x;

            self.x = ( x - layerX ) / scale;
            self.y = ( y - layerY ) / scale;
          });
        } else {

          if ( self.dots.length ){
            self.dots.forEach(function(dot, index){
              dot.show();
              dot.draggable(true);
    
              dot.on('dragstart', function(pos){
    
              });
              dot.on('dragend', function(pos){
                // var points = [];
                self.points[index] = {
                  x: self.stage.getPointerPosition().x / scale - self.stage.x() / scale,
                  y: self.stage.getPointerPosition().y / scale - self.stage.y() / scale,
                };
  
                self.layer.draw();
              });
            });
          }
        }
      }
      this.shape.strokeWidth(this.strokeWidth * 1.5);
      this.layer.draw();
    };
    IndoorBooth.prototype.unfocus = function(){
      this.shape.draggable(false);
      this.dots.forEach(function(dot){
        dot.hide();
        dot.draggable(false)
      });

      this.shape.strokeWidth(0);
      this.layer.draw();
    };
    IndoorBooth.prototype.resize = function(){
      this.shape.width(this.width);
      this.shape.height(this.height);
      this.layer.draw();
    };
    IndoorBooth.prototype.hide = function(){
      // console.log(isGrayscaled);
      if ( $rootScope.currentEvent.preferences.grayscaleBooths ){
        if ( this._type !== 'flexible' && this.backgroundImage ){
          this.shape.image(null);
        }
        this.shape.fill('rgba(211, 211, 211, 0.75)');
        this.shape.stroke('rgb(211, 211, 211)');
        this.shape.listening(false);
      } else {
        this.shape.hide();
      }
      this.layer.draw();

      var old = document.getElementById('indoorInfowindow');
      if ( old ) old.parentNode.removeChild(old);
    };
    IndoorBooth.prototype.show = function(){
      if ( this._type !== 'flexible' && this.backgroundImage ){
        this.setImage();
      }
      var rgb = hexToRGB(this.fillColor);
      this.shape.fill('rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (this.opacity/100) +')');
      this.shape.stroke('rgb(0, 0, 0)');
      this.shape.listening(true);

      this.shape.show();
      this.layer.draw();
    };
    IndoorBooth.prototype.remove = function(){
      this.shape.destroy();
      this.layer.draw();
    };
    IndoorBooth.prototype.rotate = function(direction){
      if ( direction === 'right' ){
        this.rotateDegree += 15;
      } else {
        this.rotateDegree -= 15;
      }
      this.shape.rotation(this.rotateDegree);
      this.layer.draw();
    };
    IndoorBooth.prototype.setColor = function(){
      var rgb = hexToRGB(this.fillColor);
      this.shape.fill('rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (this.opacity/100) +')');
      this.layer.draw();
    };
    IndoorBooth.prototype.setImage = function(){
      if ( this.backgroundImage ){
        var self = this;
        var img = new Image();
        var imgError = new Image();
        img.onload = function(){
          self.shape.image(img);
          self.layer.draw();
        }
        img.onerror = function(){
          self.shape.image(imgError);
          self.layer.draw();
        }
        img.src = this.backgroundImage.link;
        imgError.src = 'assets/images/default.png';
      }
    };
    return IndoorBooth;

    function handleInfowindow(self){
      // var scale = self.shape.getAbsoluteScale().x;
      // var stage = self.shape.getStage();
      // var stageX = (stage.width()/2);
      // var stageY = (stage.height()/2);

      // self.shape.getStage().position({
      //   x: stageX - (self.x * scale),
      //   y: stageY - (self.y * scale)
      // });
      // self.shape.getStage().batchDraw();

      // setTimeout(function(){
        var infowindow = new IndoorInfowindow(self);
        infowindow.show();
      // }, 500);
    }

    function hexToRGB(hex){
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
      } : null;
    }

    function createFlexibleBooth(self, fn, showInfowindow){
      var rgb = hexToRGB(self.fillColor);

      if ( !self.points.length ){
        self.points = [
          {x: self.x - self.width/2, y: self.y - self.height/2},
          {x: self.x + self.width/2, y: self.y - self.height/2},
          {x: self.x + self.width/2, y: self.y + self.height/2},
          {x: self.x - self.width/2, y: self.y + self.height/2}
        ];
      }

      var shape = new self.canvas.Shape({
        sceneFunc: function(ctx, shape){
          ctx.beginPath();

          for ( var i in self.points ){
            if ( i === 0 ){
              ctx.moveTo(self.points[i].x, self.points[i].y);
            } else {
              ctx.lineTo(self.points[i].x, self.points[i].y);    
            }
          }

          ctx.closePath();

          ctx.fillStrokeShape(shape);

          self.shape = shape;
        },
        fill: 'rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (self.opacity/100) +')',
        stroke: 'black',
        strokeWidth: 1
      });
      // self.shape = shape;
      if (fn) shape.on('click tap', fn);
      if (showInfowindow) shape.on('click tap', function(){
        handleInfowindow(self);
      });
      self.layer.add(shape);

      for ( var i in self.points ){
        var point = self.points[i];
        var circle = new self.canvas.Circle({
          x: point.x,
          y: point.y,
          radius: 4,
          fill: '#ffffff',
          strokeWidth: 1,
          stroke: '#000000',
          visible: false
        });
        self.dots.push(circle);
        self.layer.add(circle);
      }

      self.layer.draw();
    }

    function createFixedBooth(self, fn, showInfowindow){
      var rgb = hexToRGB(self.fillColor);
      var img = new Image();
      var imgNext = new Image();
      img.onload = function(){
        self.shape = new self.canvas.Image({
          x: self.x,
          y: self.y,
          image: img,
          width: self.width,
          height: self.height,
          // fill: 'rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (self.opacity/100) +')',
          stroke: self.strokeColor,
          strokeWidth: 0,
          name: 'booth',
          offset: {
            x: self.width/2,
            y: self.height/2
          }
        });
        if ( rgb ) self.shape.fill('rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (self.opacity/100) +')');
        self.layer.add(self.shape);
        self.shape.rotation(self.rotateDegree);
        self.shape.setZIndex(999);
        if (fn) self.shape.on('click tap', fn);
        if (showInfowindow) self.shape.on('click tap', function(){
          handleInfowindow(self);
        });
        self.layer.draw();
      }
      img.onerror = function(){
        self.shape = new self.canvas.Image({
          x: self.x,
          y: self.y,
          image: imgNext,
          width: self.width,
          height: self.height,
          // fill: 'rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (self.opacity/100) +')',
          stroke: self.strokeColor,
          strokeWidth: 0,
          name: 'booth',
          offset: {
            x: self.width/2,
            y: self.height/2
          }
        });
        if ( rgb ) self.shape.fill('rgba('+ rgb.r +','+ rgb.g +','+ rgb.b +','+ (self.opacity/100) +')');
        self.layer.add(self.shape);
        self.shape.rotation(self.rotateDegree);
        self.shape.setZIndex(999);
        if (fn) self.shape.on('click tap', fn);
        if (showInfowindow) self.shape.on('click tap', function(){
          handleInfowindow(self);
        });
        self.layer.draw();
      };
      img.src = self.backgroundImage.link;
      imgNext.src = 'assets/images/default.png';
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .directive('phoneNumber', phoneNumber)
    .controller('PhoneNumberController', PhoneNumberController);

  var countries;

  PhoneNumberController.$inject = ['COUNTRY_PHONES'];

  function PhoneNumberController(COUNTRY_PHONES){
    countries = COUNTRY_PHONES;
    this.countries = COUNTRY_PHONES;
  }
  
  function phoneNumber() {
    function link(scope, element, attrs, controllers){
      scope.phoneNumber = {
        label: 'US +1',
        code: '+1',
        number: undefined
      };

      scope.handleClickCountry = function(country){
        scope.phoneNumber['label'] = country.label;
        scope.phoneNumber['code'] = country.code;

        var num = '';
        if (
          scope.phoneNumber.number !== '' &&
          typeof scope.phoneNumber.code !== 'undefined' &&
          typeof scope.phoneNumber.number !== 'undefined'
        ){
          num = scope.phoneNumber.code + scope.phoneNumber.number;
        }

        controllers.$setViewValue(num);
      }

      scope.handlePhoneNumber = function(phoneNumber) {
        scope.phoneNumber['number'] = phoneNumber.number;
        var num = '';
        if (
          phoneNumber.number !== '' &&
          typeof phoneNumber.code !== 'undefined' &&
          typeof phoneNumber.number !== 'undefined'
        ){
          num = phoneNumber.code + phoneNumber.number;
        }
        controllers.$setViewValue(num);
      }

      controllers.$render = function() {
        var value = controllers.$viewValue;
        if ( value ){
          var country = countries.find(function(item){
            return item.code === value.substring(0, value.length - 10);
          });
          scope.phoneNumber = {
            label: country ? country.label : 'US +1',
            code: country ? country.code : '+1',
            number: value.substring(country ? country.code.length : 2, value.length + 1)
          }
        }
      }
    }

    return {
      restrict: 'E',
      templateUrl: 'app/directives/phone-number/phone-number.html',
      scope: {},
      link: link,
      controller: 'PhoneNumberController',
      controllerAs: 'vm',
      require: 'ngModel'
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .directive('navBar', Navbar)
    .controller('NavbarController', NavbarController);
  
  function Navbar() {
    return {
      restrict: 'E',
      templateUrl: 'app/directives/nav-bar/nav-bar.html'
    }
  }

  NavbarController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$location',
    'Notification',
    'AuthService',
    'APP_MANAGER'
  ];

  function NavbarController(
    $rootScope,
    $scope,
    $state,
    $timeout,
    $location,
    Notification,
    __auth,
    MANAGER
  ) {
    var vm = this;
    vm.loading = false;

    angular.extend($scope, {
      onInit: function(){
        vm.preferences = $rootScope.currentEvent.preferences;

        vm.vendorModule = vm.preferences.vendorModule;
        vm.volunteerModule = vm.preferences.volunteerModule;
        vm.participantModule = vm.preferences.participantModule;
        vm.sponsorModule = vm.preferences.sponsorModule;

        vm.managerPortalLink = MANAGER;
      },
      onLogout: function(){
        vm.loading = true;
        var token = localStorage.getItem('eo_auth_token');
        var expires = localStorage.getItem('eo_auth_expires_in');
        var returnURL = localStorage.getItem('return_url');

        var currentTime = new Date().getTime();
        var expiresTime = expires;

        // $timeout(function(){
          if ( !!token ) {
            if ( currentTime > expiresTime ) {
              __auth.clearEoCredential();
              __auth.clearCredential();
              $state.go('app.home');
            } else {
              __auth.replaceEoLoginAsCredential();
              __auth.clearReturnUrl();
            }
          } else {
            __auth.clearCredential();
          }

          if ( returnURL ) {
            $location.path(returnURL);
          } else {
            $state.go('app.home');
          }
          vm.loading = false;
        // }, 500);
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('RegisterController', RegisterController);
  
  RegisterController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    'Notification',
    'AuthService',
    'VolunteerService'
  ];

  function RegisterController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    Notification,
    __auth,
    VolunteerService
  ) {
    var vm = this;

    vm.user = {};

    $scope.formLoading = false;
    $scope.formSubmitted = false;

    angular.extend($scope, {
      onInit:function() {
        vm.event = $rootScope.currentEvent;
        vm.preferences = vm.event.preferences;

        vm.vendorModule = vm.preferences.vendorModule;
        vm.volunteerModule = vm.preferences.volunteerModule;
        vm.participantModule = vm.preferences.participantModule;
        vm.sponsorModule = vm.preferences.sponsorModule;

        if ( typeof $stateParams.userType !== 'undefined' ){
          var type = $stateParams.userType.toLowerCase();
          if ( type === 'vendor' && vm.event.modules.indexOf('vendor') > -1 && vm.vendorModule.enableRegister ) vm.user['type'] = type;
          if ( type === 'volunteer' && vm.event.modules.indexOf('volunteer') > -1 && vm.volunteerModule.enableRegister ) vm.user['type'] = type;
          if ( type === 'participant' && vm.event.modules.indexOf('participant') > -1 && vm.participantModule.enableRegister ) vm.user['type'] = type;
          if ( type === 'sponsor' && vm.event.modules.indexOf('sponsor') > -1 && vm.sponsorModule.enableRegister ) vm.user['type'] = type;
        }
      },
      handleSubmit:function(){
        $scope.formSubmitted = true;
        var form = $scope.form;

        if ( form.$valid ) {
          $scope.formLoading = true;
          $scope.loading = true;

          if ( vm.user.phone1 && !vm.user.phone1.number ){
            delete vm.user['phone1'];
          }

          __auth.onRegister(vm.user)
            .then(
              function(){
                $scope.formLoading = false;
                Notification.success('User was registered');

                var data = {
                  username: vm.user.username,
                  password: vm.user.password
                };

                __auth.onLogin(data)
                  .then(
                    function(response) {
                      __auth.setCredentialAuth(response.data);
                      __auth.getUser()
                        .then(
                          function(response){
                            var data = response.data;
                            var portal = false;
                            if ( data.type === 'eo' ) {
                              portal = true;
                            }
                            __auth.setCredentialUser(data, portal);
                            $rootScope.accessPortal = portal;
                            switch (data.type) {
                              case 'eo':
                                $state.go('users.organizer.map.main');
                                break;
                              case 'eventCoordinator':
                                $state.go('users.organizer.map.main');
                                break;
                              case 'vendor':
                                $state.go('users.vendor.event');
                                break;
                              case 'volunteer':
                                // $state.go('users.volunteer.event');
                                $scope.createVolunteerRequest(data.id);
                                break;
                              case 'participant':
                                $state.go('users.participant.event');
                                break;
                              case 'special':
                                $state.go('users.special.map');
                                break;
                              case 'sponsor':
                                $state.go('users.sponsor.event');
                                break;
                              case 'volunteerCoordinator':
                                $state.go('users.volunteerCoordinator.map');
                                break;
                              default:
                                $state.go('app.home');
                            }
                          },
                          function(err){
                            $scope.formLoading = true;
                            console.err(err);
                          }
                        );
                    },
                    function(err){
                      $scope.formLoading = true;
                      console.err(err);
                    }
                  );
              },
              function(err){
                $scope.formLoading = false;
                Notification.error(err.data.message);
              }
            );
        }
      },

      createVolunteerRequest: function(userId){
        VolunteerService.onAdd()
          .then(function(response){
            $state.go('users.volunteer.event');
          })
          .catch(function(err){
            $scope.formLoading = false;
            console.error(err);
          });
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .directive('footBar', Footbar)
    .controller('FootbarController', FootbarController);
  
  function Footbar() {
    return {
      restrict: 'E',
      templateUrl: 'app/directives/foot-bar/foot-bar.html'
    }
  }

  function FootbarController(
    $scope,
    PageService
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
        PageService.getPageByTag('fixed', 'contentFooter')
          .then(
            function(response){
              vm.contentFooter = response.data;
            },
            function(err){
            }
          );
      }
    })
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .directive('form', function() {
      return {
        restrict: 'E',
        link: function(scope, element) {
          element.on('submit', function() {
            scope.$broadcast('form:submit');
          });
        }
      };
    })
    .directive('uploadFile', UploadFile)
    .controller('UploadFileController', UploadFileController)
  
  UploadFile.$inject = [
    'Notification',
    '$parse',
    'FileService'
  ];

  function UploadFile(
    Notification,
    $parse,
    __file
  ) {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=ngModel',
        ngFiles: '@ngFiles',
        title: '@ngTitle',
        type: '@ngType',
        disabled: '=ngDisabled',
        multiple: '@ngMultiple',
        ngAccept: '@ngAccept',
        max: '@ngMaxLength',

        ufCanRemove: '@'
      },
      require: '^form',
      templateUrl: 'app/directives/file-loader/file-loader.html',
      link: function(scope, element, attrs, form){
        var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg|\.ico)$/i;

        scope.files = [];

        scope.spinerLoader = false;

        var input = element.find('input[type="file"]');
        var removed = [];

        scope.$watch('ngFiles', function(value) {
          if ( value ) {
            scope.files = JSON.parse(value);
          }
        });

        input.on('change', function(event){
          var files = event.target.files;

          scope.spinerLoader = true;

          angular.forEach(files, function(file, index){
            if (scope.ngAccept && scope.ngAccept === 'image/*'){
              if (!allowedExtensions.exec(file.name)){
                Notification.error('Allowed upload only image files. Please choose another');
                scope.spinerLoader = false;
                return false;
              }
            }

            __file.onAdd(file)
              .then(
                function(response) {
                  var data = response.data;
                  if ( scope.multiple ) {
                    scope.files.push(data);
                    scope.ngModel = scope.files;
                  } else {
                    if ( scope.files && scope.files.id ) {
                      __file.onDelete(scope.files.id)
                        .then(
                          function(){
                            scope.files = data;
                            scope.ngModel = scope.files;
                          },
                          function(){
                            scope.files = data;
                            scope.ngModel = scope.files;
                          }
                        );
                    } else {
                      scope.files = data;
                      scope.ngModel = scope.files;
                    }
                  }
                  // Remove spiner if last item is loaded
                  if ( index === files.length - 1 ) {
                    scope.spinerLoader = false;
                  }
                },
                handleError()
              );
          });
        });

        scope.handleDelete = function(file) {
          if ( file ) {
            if ( typeof scope.files === 'object' ) {
              if ( typeof scope.files.length !== 'undefined' ) {
                var idx = scope.files.indexOf(file);
                scope.files.splice( idx, 1 );
              } else {
                scope.files = [];
              }
              removed.push(file);
            }
            scope.ngModel = scope.files;
            if ( scope.multiple ) {
              scope.required = true;
            }
          }
        }

        scope.$on('form:submit', function(){
          if ( removed.length !== 0 ) {
            angular.forEach(removed, function(item){
              __file.onDelete(item.id)
                .then(
                  function(response){
                  },
                  handleError()
                )
            });
            removed = []
          }
        });

        function handleError(err){
          console.log(err);
        }

      },
      controller: 'UploadFileController',
    }
  }

  function UploadFileController(
    $scope,
    $uibModal
  ) {
    $scope.handleImageLightbox = function(file){
      var modal = $uibModal.open({
        windowTopClass: 'modal-preview',
        backdropClass: 'modal-backdrop-preview',
        template: '\
          <div class="modal-body">\
            <div class="modal-body-inner">\
              <div><img ng-click="handleClose()" ng-src="{{ file.link }}" alt="Image preview" /></div>\
            </div>\
          </div>\
          <div class="modal-footer">\
            <button class="btn btn-default" type="button" ng-click="handleClose()">Close</button>\
          </div>\
        ',
        controller: function($scope, $uibModalInstance, file){
          $scope.file = file;
          $scope.handleClose = function(){
            $uibModalInstance.dismiss('cancel');
          }
        },
        resolve: {
          file: function(){
            return file;
          }
        }
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .directive('dateRange', dateRange);
  
  function dateRange() {
    return {
      restrict: 'E',
      templateUrl: 'app/directives/date-range/date-range.html',
      scope: {
        'startDate': '=',
        'endDate': '=',
        'startTime': '=',
        'endTime': '=',
        'isValid': '=',
        'eventValidation': '='
      },
      link: function(scope, element, attrs){
        if ( typeof scope.eventValidation === 'undefined' ){
          scope.eventValidation = true;
        }
      },
      controller: DateRangeController
    }
  }

  function DateRangeController($rootScope, $scope, moment) {
    var vm = this;

    angular.extend($scope, {
      isRequired: false,
      isValid: typeof $scope.isValid !== 'undefined' ? $scope.isValid : true,
      datepickerFormat: 'MMMM dd, yyyy',
      eventStartDate: !!$scope.eventValidation && moment(moment.utc($rootScope.currentEvent.start)).local(),
      eventEndDate: !!$scope.eventValidation && moment(moment.utc($rootScope.currentEvent.end)).local(),
      startDateOptions: {
        dateDisabled: false,
        minDate: !!$scope.eventValidation ? moment(moment.utc($rootScope.currentEvent.start)).local().toDate() : new Date(),
        maxDate: !!$scope.eventValidation ? moment(moment.utc($rootScope.currentEvent.end)).local().toDate() : null,
        formatYear: 'yy',
        startingDay: 1
      },
      endDateOptions: {
        dateDisabled: false,
        minDate: !!$scope.eventValidation ? moment(moment.utc($rootScope.currentEvent.start)).local().toDate() : new Date(),
        maxDate: !!$scope.eventValidation ? moment(moment.utc($rootScope.currentEvent.end)).local().toDate() : null,
        formatYear: 'yy',
        startingDay: 1
      },
      popup1: {
        opened: false
      },
      popup2: {
        opened: false
      },
      onPopup1Open: function(){
        $scope.popup1.opened = true;
      },
      onPopup2Open: function(){
        $scope.popup2.opened = true;
      },
      startDateIsGreaterThanEnd: false,
      startTimeIsGreaterThanEnd: false,
      outOfEventDateRange: false,
      outOfEventTimeRange: false,
      startDateIsBelow: false
    });

    // Change date
    angular.extend($scope, {
      onChangeDate: function(startDate, endDate, startTime, endTime){
        $scope.startDateIsGreaterThanEnd = false;
        $scope.startTimeIsGreaterThanEnd = false;
        $scope.outOfEventDateRange = false;
        $scope.outOfEventTimeRange = false;
        $scope.startDateIsBelow = false;
        if ( startDate || endDate || startTime || endTime ){
          if ( startDate && endDate && startTime && endTime ){
            $scope.isValid = true;
            $scope.isRequired = false;
            if ( moment(startDate).isAfter(endDate) ){
              if ( !moment(startDate).isSame(endDate, 'day') ){
                $scope.isValid = false;
                $scope.startDateIsGreaterThanEnd = true;
              }
            }

            var from = moment(startDate).set({
              hour: moment(startTime).hour(),
              minute: moment(startTime).minute()
            });
            var to = moment(endDate).set({
              hour: moment(endTime).hour(),
              minute: moment(endTime).minute()
            });

            if ( !!$scope.eventValidation ){
              var resultDate = false;
              var resultTime = false;
              if ( moment(startDate).isBefore($scope.eventStartDate) ){
                if ( !moment(startDate).isSame($scope.eventStartDate, 'day') ){
                  resultDate = true;
                } else {
                  if ( moment(from, 'h:mma').isBefore($scope.eventStartDate, 'h:mma') ){
                    if ( moment(from).format('h:mma') !== moment($scope.eventStartDate).format('h:mma') ){
                      resultTime = true;
                    }
                  }
                }
              }
              if ( moment(endDate).isAfter($scope.eventEndDate)) {
                if ( !moment(endDate).isSame($scope.eventEndDate, 'day') ){
                  resultDate = true;
                } else {
                  if ( moment(to, 'h:mma').isAfter($scope.eventEndDate, 'h:mma') ){
                    if ( moment(to).format('h:mma') !== moment($scope.eventEndDate).format('h:mma') ){
                      resultTime = true;
                    }
                  }
                }
              }
              if ( resultDate ){
                $scope.isValid = false;
                $scope.outOfEventDateRange = true;
              }
              if ( resultTime ){
                $scope.isValid = false;
                $scope.outOfEventTimeRange = true;
              }
            }
            if (!$scope.startDateIsGreaterThanEnd){
              if ( !moment(from, 'h:mma').isBefore(to, 'h:mma') ){
                $scope.isValid = false;
                $scope.startTimeIsGreaterThanEnd = true;
              }
            }
          } else {
            $scope.isRequired = true;
            $scope.isValid = false;
          }
        } else {
          $scope.isRequired = false;
          $scope.isValid = true;
        }
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('CountdownFactory', CountdownFactory)
    .directive('eventCountdown', EventCountdown);

  function CountdownFactory() {
    return {
      calculateTime: function(time) {
        var timeSeconds = 1000;
        var timeMinutes = timeSeconds * 60;
        var timeHours = timeMinutes * 60;
        var timeDays = timeHours * 24;

        var days = Math.floor(time / timeDays);
        var hours = Math.floor((time % timeDays) / timeHours );
        var minutes = Math.floor((time % timeHours) / timeMinutes );
        var seconds = Math.floor((time % timeMinutes) / timeSeconds );
        return [
          '<div><span class="value">'+ days + '</span>days</div>',
          '<div><span class="value">'+ hours + '</span>hours</div>',
          '<div><span class="value">'+ minutes + '</span>minutes</div>',
          '<div><span class="value">'+ seconds + '</span>seconds</div>'
        ];
      }
    };
  }

  EventCountdown.$inject = [
    '$interval',
    'CountdownFactory'
  ];

  function EventCountdown (
    $interval,
    CountdownFactory
  ) {
    return {
      restrict: 'E',
      scope: {
        date: '@'
      },
      link: function(scope, element) {
        var enddate;
        var stop;

        scope.$watch(function(){
          enddate = new Date(scope.date);
          return enddate;
        }, function(){
        }, true);

        stop = $interval(function(){
          var diff = Math.floor(enddate.getTime() - new Date().getTime());

          if ( diff <= 0 ) {
            $interval.cancel(stop)
            stop = undefined;
            element[0].style.display = 'none';
          } else {
            return element.html(
              CountdownFactory.calculateTime(diff)
            );
          }
        }, 1000);
      }
    }
  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .directive('calendarReservation', calendarReservation);

  function calendarReservation(){
    return {
      restrict: 'E',
      templateUrl: 'app/directives/calendar-reservation/calendar-reservation.html',
      scope: {
        crType: '=',
        crData: '=',
        crSelectedDate: '=',
        crShowPast: '=',
        fnSelecteDay: '='
      },
      link: function(scope, element, attrs){

      },
      controller: CalendarReservationController
    }
  }

  CalendarReservationController.$inject = ['$scope', 'moment'];

  function CalendarReservationController(
    $scope,
    moment
  ){
    $scope.selectedDay = $scope.crSelectedDate ? moment($scope.crSelectedDate) : moment();
    $scope.month = $scope.selectedDay.clone();

    angular.extend($scope, {
      moment: moment,
      onInit: function(){
        var start = $scope.selectedDay.clone();

        start.date(1);

        $scope.removeTime(start.day(0));
        $scope.buildMonth(start, $scope.month);

        if ( $scope.crSelectedDate ){
          $scope.fnSelecteDay({day: { date: $scope.selectedDay }});
        }
      },

      selectDay: function(day){
        $scope.selectedDay = day.date;
        var params = { day: day };
        if ( $scope.crType !== 'slots' ){
          params['calendarID'] = $scope._has(day).id;
          params['operatingHours'] = $scope._has(day).operatingHours;
        }

        $scope.fnSelecteDay(params)
      },

      next: function(){
        var next = $scope.month.clone();
        $scope.removeTime(next.month(next.month() + 1).date(1));
        $scope.month.month($scope.month.month() + 1);
        $scope.buildMonth(next, $scope.month);
      },

      prev: function(){
        var prev = $scope.month.clone();
        $scope.removeTime(prev.month(prev.month() - 1).date(1));
        $scope.month.month($scope.month.month() - 1);
        $scope.buildMonth(prev, $scope.month);
      },

      removeTime: function(date) {
        return date.day(0).hour(0).minute(0).second(0).millisecond(0);
      },

      buildWeek: function(date, month){
        var days = [];
        for (var i = 0; i < 7; i++) {
          days.push({
            name: date.format('dd').substring(0, 1),
            number: date.date(),
            isCurrentMonth: date.month() === month.month(),
            isToday: date.isSame(new Date(), 'day'),
            date: date
          });
          date = date.clone();
          date.add(1, 'd');
        }
        return days;
      },

      buildMonth: function(start, month){
        $scope.weeks = [];
        var done = false;
        var date = start.clone();
        var monthIndex = date.month();
        var count = 0;
        while (!done) {
          $scope.weeks.push({
            days: $scope.buildWeek(date.clone(), month)
          });
          date.add(1, 'w');
          done = count++ > 2 && monthIndex !== date.month();
          monthIndex = date.month();
        }
      },

      format: 'YYYY-MM-DD',

      _has: function(day){
        var date = moment(day.date).format($scope.format);
        if ( $scope.crData.length === 0 ) return { available: false, showPast: false };
        if ( $scope.crType === 'slots' ){
          for ( var i in $scope.crData ){
            var data = $scope.crData[i];
            var from = moment(moment.utc(data.start)).local().toDate();
            if ( moment(from).isSame(date, 'day') ){
              return {
                available: true,
                showPast: $scope.crShowPast ? true : $scope.showPast(date),
              }
            }
          }
        } else {
          for ( var i in $scope.crData ){
            var data = $scope.crData[i];
            var from = moment(data.from).format($scope.format);
            var to = moment(data.to).subtract(1, 'days').format($scope.format);

            if ( moment(date).isSame(from, 'day') || moment(date).isSame(to, 'day') ){
              return {
                available: true,
                showPast: $scope.crShowPast ? true : $scope.showPast(date),
                type: data.timeSlotLength,
                id: data.id,
                operatingHours: data.operatingHours 
              };
            } else {
              if ( moment(date).isBetween(from, to, 'days') ){
                return {
                  available: true,
                  showPast: $scope.crShowPast ? true : $scope.showPast(date),
                  type: data.timeSlotLength,
                  id: data.id,
                  operatingHours: data.operatingHours
                };
              }
            }
          }
        }
      },

      dateNow: new Date(),

      showPast: function(date){
        var result = true;
        if ( moment($scope.dateNow).isAfter(date) ){
          if ( !moment($scope.dateNow).isSame(date, 'day') ){
            result = false;
          }
        }
        if ( result ){
          if ( moment($scope.dateNow, 'h:mma').isAfter(date, 'h:mma') ){
            if ( moment($scope.dateNow).format('h:mma') <= moment(date).format('h:mma') ){
              result = false;
            }
          }
        }
        return result;
      }

    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .directive('bulkUsers', bulkUsers);

  function bulkUsers(){
    return {
      restrict: 'E',
      templateUrl: 'app/directives/bulk-users/bulk-users.html',
      scope: {
        'userType': '@'
      },
      link: function(scope, element, attrs){

      },
      controller: 'BulkUsersController'
    }
  }

})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('BulkUsersController', BulkUsersController);
  
  BulkUsersController.$inject = [
    '$scope',
    'Notification',
    'AuthService',
    'PriceService',
    'VolunteerService',
    'ParticipantService',
    'UserGroupsService',
    'ViewService'
  ];

  function BulkUsersController(
    $scope,
    Notification,
    AuthService,
    PriceService,
    VolunteerService,
    ParticipantService,
    UserGroupsService,
    ViewService
  ){
    var vm = this;
    $scope.formLoading = false;
    $scope.formSubmitted = false;

    $scope.bulkId = 1;
    $scope.bulkUsers = [];

    $scope.formLoading = false;

    $scope.automaticallyAccept = false;
    $scope.skipEmailNotification = false;
    // $scope.skipWelcomeEmailNotification = false;
    $scope.skipPackageEmailNotification = false;

    $scope.onChangeAutoAccept = function(value){
      $scope.automaticallyAccept = value;
    }

    $scope.onChangeSkipPackage = function(value){
      $scope.skipPackageEmailNotification = value;
    }

    angular.extend($scope, {
      onViewSwitch: function(type) {
        $scope.appView = type;
        ViewService.setView(type);
      },

      onInit: function(){
        console.log('Inited');
        $scope.appView = localStorage.getItem('app_view');
        // Add first user
        $scope.bulkUsers.push($scope.createUser($scope.bulkId++, false));

        UserGroupsService.getGroups()
          .then(function(response) {
            $scope.userGroups = response.data;

            if ( $scope.userType === 'participant' ){
              PriceService.getPrices()
                .then(function(response){
                  var result = [];
                  var data = response.data;
                  if ( data.length ){
                    for ( var i in data ){
                      var pkg = data[i];
                      if ( pkg.type === 'participation' && pkg.enabled ){
                        result.push(pkg);
                      }
                    }
                  }
                  $scope.pricePackages = result;
                })
                .catch(function(err){
                  console.log(err);
                })
            }
          })
          .catch(function(err){
            console.error(err);
          })
      },

      handleSubmit: function(){
        $scope.formSubmitted = true;
        var form = $scope.form;

        var allUserRegistered = true;

        var userUsernames = $scope.bulkUsers.map(function(item){ return item.username });

        var isDuplicate = userUsernames.some(function(item, idx){ 
          return userUsernames.indexOf(item) !== idx;
        });

        if ( isDuplicate ){
          Notification.error('Duplicate username found');
        } else {
          if ( form.$valid ){
            $scope.formLoading = true;
            for ( var i = 0; i < $scope.bulkUsers.length; i++ ){
              var user = $scope.bulkUsers[i];
              var groupIds = [];
              var data = {
                type: $scope.userType,
                name: user.name,
                username: user.username,
                email: user.email,
                password: user.password
              };
              if ( user.userGroups.length ){
                for ( var j in user.userGroups ){
                  groupIds.push(user.userGroups[j].id);
                }
                data['groupIds'] = groupIds;
              }
              if ( $scope.skipEmailNotification ){
                data['skipEmailNotification'] = true;
              }
              if ( user.phone1 && user.phone1.number ){
                data['phone1'] = user.phone1;
              }
              if ( !user.success ){
                if ( $scope.userType === 'vendor' || $scope.userType === 'sponsor' ){
                  $scope.registerUser(user, data, i);
                }
                if ( $scope.userType === 'volunteer' ){
                  $scope.registerVolunteer(user, data, i);
                }
                if ( $scope.userType === 'participant' ){
                  $scope.registerParticipant(user, data, i);
                }
                // if ( $scope.userType === 'sponsor' ){
                //   $scope.registerUser(user, data, i);
                // }
              }
            }

            for ( var i in $scope.bulkUsers ){
              if ( !$scope.bulkUsers[i].success ){
                allUserRegistered = false;
                break;
              }
            }

            if ( allUserRegistered ){
              $scope.formLoading = false;
              Notification.error('No new users to register');
            }
          }
        }
      }
    });

    $scope.addUser = function(){
      $scope.bulkUsers.push($scope.createUser($scope.bulkId++, true));
    }

    $scope.deleteUser = function(user){
      if ( $scope.bulkUsers.length ){
        for ( var i in $scope.bulkUsers ){
          var bulkUser = $scope.bulkUsers[i];
          if ( bulkUser.id === user.id ){
            var idx = $scope.bulkUsers.indexOf(bulkUser);
            $scope.bulkUsers.splice(idx, 1);
          }
        }
      }
    }

    $scope.createUser = function(id, canDelete){
      var data = {
        id: id,
        name: '',
        fieldName: 'name'+ id,
        username: '',
        fieldUsername: 'username'+ id,
        email: '',
        fieldEmail: 'email'+ id,
        password: '11111111',
        fieldPassword: 'password'+ id,
        userGroups: [],
        phone1: {
          type: 'cell',
          number: null
        },

        canDelete: canDelete,
        success: false,
        // error: false,
        // errorMessage: null
      };
      if ( $scope.userType === 'participant' ){
        data['packages'] = [];
        data['fieldPackages'] = 'packages'+ id;
        data['bib'] = null;
        data['fieldBib'] = 'bib'+ id;
      }
      return data;
    }


    // Register user
    $scope.registerUser = function(user, data, index){
      AuthService.onRegister(data)
        .then(function(response){
          $scope.formLoading = false;
          // user.error = false;
          user.success = true;
          user.errorMessage = null;

          if ( (index + 1) == $scope.bulkUsers.length ){
            Notification.success('All user(s) were successfully registered');
          }
        })
        .catch(function(err){
          $scope.formLoading = false;
          Notification.error(err.data.message);
        });
    };
    // Volunteer
    $scope.registerVolunteer = function(user, data, index){
      if ( $scope.automaticallyAccept ) {
        AuthService.onRegister(data)
          .then(function(response) {
            $scope.formLoading = false;
            user.success = true;
            if ((index + 1) == $scope.bulkUsers.length ) {
              Notification.success('All user(s) were successfully registered');
            }
            return VolunteerService.onParticipated(response.data.id)
          })
          .then(function(){
            if ( (index + 1) == $scope.bulkUsers.length ) {
              Notification.success('Selected package(s) were purchased');
            }
          })
          .catch(function(err){
            $scope.formLoading = false;
            Notification.error(err.data.message);
          })
      } else {
        AuthService.onRegister(data, true)
          .then(function(response) {
            $scope.formLoading = false;
            user.success = true;
            if ((index + 1) == $scope.bulkUsers.length) {
              Notification.success('All user(s) were successfully registered');
            }
          })
          .catch(function(err){
            $scope.formLoading = false;
            Notification.error(err.data.message);
          });
      }
    };
    // Participant
    $scope.registerParticipant = function(user, data, index){
      AuthService.onRegister(data)
        .then(function(response) {
          user.success = true;

          if ((index + 1) == $scope.bulkUsers.length) {
            Notification.success('All user(s) were successfully registered');

            var hasPackage = $scope.bulkUsers.filter(function(u){
              return u.packages && u.packages.length;
            });

            if ( hasPackage.length ){
              Notification.success('Selected package(s) were purchased');
            }
          }

          var items = [];
          var price = 0;

          if ( user.packages.length ){
            for ( var i in user.packages ){
              var pkg = user.packages[i];
              items.push({
                count: 1,
                participantId: response.data.id,
                pricePackage: pkg,
                pricePackageId: pkg.id
              });
              if ( pkg.price ){
                price += pkg.price;
              }
            }

            var createAndAccept = {
              bibNumber: user.bibNumber || null,
              items: items,
              participantId: response.data.id,
              price: price
            };
  
            if ($scope.skipPackageEmailNotification) {
              createAndAccept['skipEmailNotification'] = $scope.skipPackageEmailNotification;
            }
            if ( user.success ) {
              ParticipantService.createAndAcceptRequest(createAndAccept)
                .then(function(response) {
                  $scope.formLoading = false;
                  // if ((index + 1) == $scope.bulkUsers.length) {
                  // Notification.success('Selected package(s) were purchased');
                  // }
                });
            }
          } else {
            $scope.formLoading = false;
          }
      })
      .catch(function(err){
        $scope.formLoading = false;
        console.error(err);
        Notification.error(err.data.message);
      });
    }
    // Sponsor
    // $scope.registerSponsor = function(user, data, index){

    // }
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('ResetPasswordController', ResetPasswordController);
  
  ResetPasswordController.$inject = [
    '$scope',
    '$state',
    'Notification',
    'AuthService'
  ];

  function ResetPasswordController(
    $scope,
    $state,
    Notification,
    __auth
  ) {
    var vm = this;

    $scope.formLoading = false;
    $scope.formSubmitted = false;

    angular.extend($scope, {
      handleSubmit:function() {
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          __auth.onResetPassword(vm.user)
            .then(
              function(){
                __auth.onLogout();
                Notification.success("Password was reset. Check both inbox and spam folders.");
                $state.go('app.auth.login');

                $scope.formLoading = false;
              },
              $scope.handleError
            );
        }
      },
      handleError:function(err) {
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('LoginController', LoginController);
  
  LoginController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    'Notification',
    'AuthService'
  ];

  function LoginController(
    $rootScope,
    $scope,
    $state,
    Notification,
    __auth
  ) {
    var vm = this;

    $scope.formLoading = false;
    $scope.formSubmitted = false;

    angular.extend($scope, {
      handleSubmit: function(){
        $scope.formSubmitted = true;
        var form = $scope.form;
        if ( form.$valid ) {
          $scope.formLoading = true;
          __auth.onLogin( vm.user )
            .then(
              function(response) {
                __auth.setCredentialAuth(response.data, false);
                __auth.getUser()
                  .then(
                    function(response){
                      var data = response.data;

                      var portal = data.type === 'eo' ? true : false;
                      __auth.setCredentialUser(data, portal);

                      $rootScope.accessPortal = portal;

                      var rcode = localStorage.getItem('redirect_code');
                      var rid = localStorage.getItem('redirect_id');
                      var ruser = localStorage.getItem('redirect_user');
                      var rtype = localStorage.getItem('redirect_type');

                      var rstate = {}

                      if ( rid ) rstate['id'] = rid;
                      if ( rcode ) rstate['code'] = rcode;
                      if ( ruser ) rstate['user'] = ruser;
                      if ( rtype ) rstate['type'] = rtype;

                      switch (data.type) {
                        case 'eo':
                          if ( rid || rcode ){
                            $state.go('autoCheckIn', rstate);
                          } else {
                            $state.go('users.organizer.map.main');
                          }
                          break;
                        case 'eventCoordinator':
                          if ( rid || rcode ){
                            $state.go('autoCheckIn', rstate);
                          } else {
                            $state.go('users.organizer.map.main');
                          }
                          break;
                        case 'vendor':
                          $state.go('users.vendor.event');
                          break;
                        case 'volunteer':
                          $state.go('users.volunteer.event');
                          break;
                        case 'participant':
                          $state.go('users.participant.event');
                          break;
                        case 'special':
                          $state.go('users.special.mainMap');
                          break;
                        case 'sponsor':
                          $state.go('users.sponsor.event');
                          break;
                        case 'volunteerCoordinator':
                          $state.go('users.volunteerCoordinator.map');
                          break;
                        case 'sponsorAttendant':
                          $state.go('users.sponsorAttendant');
                          break;
                        default:
                          $state.go('app.home');
                      }

                      // $scope.formSubmitted = false;
                    },
                    $scope.handleError
                  );
              },
              $scope.handleError
            );
        }
      },
      handleError: function(err){
        // $scope.formSubmitted = false;
        $scope.formLoading = false;
        Notification.error(err.data.message);
      }
    })
  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('UserController', UserController)

  UserController.$inject = ['$rootScope', '$scope', 'AuthService'];

  function UserController($rootScope, $scope, __auth) {
    var vm = this;

    // $rootScope.rootLoading = true;

    angular.extend($scope, {
      onInit: function(){

        // __auth.getUser()
        //   .then(
        //     function(response){
        //       var data = response.data;
              // $rootScope.currentUser = data;
              var user = $rootScope.currentUser;
              // $rootScope.accessPortal = user.type === 'eo' ? true : false;
              if ( user && user.type === 'eo' ) {
                __auth.getSubscriptions()
                  .then(function(response){
                    $scope.currentSubscription = response.data.filter(function(item){
                      return item.status === 'active';
                    })[0];
                    return __auth.getEoQuota();
                  }).then(function(response){
                    var data = response.data;
                    vm.quota = data;
                    if ( data ) {
                      $rootScope.quoEvent =  $scope.countLimites(data.numberOfEvents, data.maxNumberOfEvents);
                      $rootScope.quoMembers = $scope.countLimites(data.numberOfMembers, data.maxNumberOfMembers);
                      $rootScope.quoText = $scope.countLimites(data.numberOfTextMessages, data.maxNumberOfTextMessages);
                      $rootScope.quoEmail = $scope.countLimites(data.numberOfEmailMessages, data.maxNumberOfEmailMessages);
                    }
                    // $rootScope.rootLoading = false;
                  }).catch(function(err){
                    console.log(err);
                  });
              } else {
                // $rootScope.rootLoading = false;
              }
            // },
            // function(err) {
            //   console.log(err);
            // }
          // );

      },

      countLimites: function(quo, sub){
        return ( quo > sub ? true : false );
      }
    })

  }

})();

(function(){

  angular
    .module('eventmap')
    .factory('VolunteerService', VolunteerService)
  
  VolunteerService.$inject = ['$rootScope', '$http', 'API_PATH', 'EVENT_ID'];
  
  function VolunteerService($rootScope, $http, API, EVENT_ID) {
    var REQUESTS;

    function requests(requests) {
      REQUESTS = [];
      angular.forEach(requests, function(request){
        REQUESTS.push(request);
      });
      return REQUESTS;
    }

    function add(request) {
      REQUESTS.push(request);
    }

    function update(request) {
      angular.forEach(REQUESTS, function(item){
        if ( item.id === request.id ) {
          var index = REQUESTS.indexOf(item);
          REQUESTS[index] = request;
        }
      });
    }

    function remove(request){
      var index = REQUESTS.indexOf(request);
      REQUESTS.splice(index, 1);
    }






    function getRequests(includeResponsibilityZones) {
      var params = {
        eventId: EVENT_ID,
        includeResponsibilityZones: includeResponsibilityZones || false
      };
      return $http.get(API + '/volunteerRequests', { params: params });
    }

    function getRequestsByUserId() {
      var params = { eventId: EVENT_ID, volunteerId: $rootScope.currentUser.id };
      return $http.get(API + '/volunteerRequests', { params: params });
    }

    function getRequestByStatus(status) {
      var params = { eventId: EVENT_ID, status: status };
      return $http.get(API + '/volunteerRequests', { params: params });
    }



    function getRequestsByName(query) {
      var params = {
        eventId: EVENT_ID,
        status: 'accepted',
        volunteerName: query
      };
      return $http.get(API + '/volunteerRequests', { params: params });
    }



    function onAdd(volunteerId) {
      var params = { eventId: EVENT_ID };
      if ( volunteerId ) params['volunteerId'] = volunteerId;
      return $http.post(API + '/volunteerRequests', params);
    }

    function onParticipated(id) {
      var params = { eventId: EVENT_ID, volunteerId: id };
      return $http.post(API + '/volunteerRequests/actions/createAndAccept', params);
    }

    function onAccept(id) {
      var params = { eventId: EVENT_ID };
      return $http.post(API + '/volunteerRequests/' + id + '/actions/accept', params);
    }

    function onCancel(id) {
      var params = { eventId: EVENT_ID };
      return $http.post(API + '/volunteerRequests/' + id + '/actions/cancel', params);
    }

    function onDecline(id) {
      var params = { eventId: EVENT_ID };
      return $http.post(API + '/volunteerRequests/' + id + '/actions/decline', params);
    }

    function checkIn(id, data){
      return $http.post(API + '/volunteerRequests/'+ id +'/actions/checkIn', data);
    }

    function checkOut(id, data){
      return $http.post(API + '/volunteerRequests/'+ id +'/actions/checkOut', data);
    }

    function checkOutAll(data){
      data['eventId'] = EVENT_ID;
      return $http.post(API +'/volunteerRequests/actions/checkOut', data);
    }

    // function showLogs(userId, eventRequestId, eventRequestType, name){
    //   var params = {
    //     eventId: EVENT_ID,
    //     userId: userId,
    //     eventRequestId: eventRequestId,
    //     eventRequestType: eventRequestType
    //   };
    //   if ( name ) params['name'] = name;
    //   return $http.get(API +'/activityLogs', { params: params });
    // }

    // function createActivityLog(data){
    //   data['eventId'] = EVENT_ID;
    //   return $http.post(API +'/volunteerRequests/activityLog', data);
    // }

    // function updateActivityLog(data){
    //   data['eventId'] = EVENT_ID;
    //   return $http.put(API +'/volunteerRequests/activityLog/'+ data.id, data);
    // }

    return {
      getRequests: getRequests,
      getRequestsByUserId: getRequestsByUserId,
      getRequestByStatus: getRequestByStatus,
      getRequestsByName: getRequestsByName,

      onAdd: onAdd,
      onParticipated: onParticipated,
      onAccept: onAccept,
      onDecline: onDecline,
      onCancel: onCancel,

      checkIn: checkIn,
      checkOut: checkOut,
      checkOutAll: checkOutAll,

      // showLogs: showLogs,
      // createActivityLog: createActivityLog,
      // updateActivityLog: updateActivityLog,

      requests: requests,
      add: add,
      update: update,
      remove: remove,

      // activityReport: function(){
      //   var params = { eventId: EVENT_ID }
      //   return $http.get(API +'/volunteerRequests/activityReport', { params: params });
      // },
      // activityReportExport: function(ids){
      //   var params = { eventId: EVENT_ID }
      //   if ( ids ) params['ids'] = ids;
      //   params['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      //   return $http.get(API +'/volunteerRequests/activityReportExport', { params: params });
      // }
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ViewService', ViewService);

  ViewService.$inject = [];

  function ViewService() {
    var VIEW = 'app_view';
    var VIEW_TYPE = 'grid';

    function isStorageSupport() {
      try {
        return 'localStorage' in window && window['localStorage'] !== null;
      } catch(e) {
        return false;
      }
    }

    function getView() {
      return VIEW_TYPE;
    }

    function isView() {
      return ( isStorageSupport ? localStorage.getItem(VIEW) : '' );
    }

    function setView(type) {
      VIEW_TYPE = type;
      isStorageSupport && localStorage.setItem(VIEW, type);
    }

    return {
      isView: isView(),
      getView: getView(),
      setView: setView
    }
  }
})();
(function(){

  angular
    .module('eventmap')
    .factory('VendorService', VendorService);
  
  VendorService.$inject = ['$rootScope', '$http', 'API_PATH', 'EVENT_ID'];
  
  function VendorService($rootScope, $http, API, EVENT_ID) {
    var REQUESTS;

    function requests(requests) {
      REQUESTS = [];
      angular.forEach(requests, function(request){
        REQUESTS.push(request);
      });
      return REQUESTS;
    }

    function pushRequest(request) {
      REQUESTS.push(request);
    }

    function updateRequest(request) {
      angular.forEach(REQUESTS, function(item){
        if ( item.id === request.id ) {
          var index = REQUESTS.indexOf(item);
          REQUESTS[index] = request;
        }
      });
    }

    function spliceRequest(request){
      var index = REQUESTS.indexOf(request);
      REQUESTS.splice(index, 1);
    }

    // function updateVendorInRequest(vendor){
    //   angular.forEach(REQUESTS, function(item){
    //     if ( item.id === vendor.id ) {
    //       var index = REQUESTS.indexOf(item);
    //       REQUESTS[index] = vendor;
    //     }
    //   });
    // }



    function getMyRequests(){
      return $http.get(API + '/vendorRequests/my');
    }

    function getPublishedRequests(){
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/vendorRequests/published', { params: params })
    }

    function getRequests() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/vendorRequests', { params: params });
    }

    function getRequestsWithBooth() {
      var params = { eventId: EVENT_ID, includeBooths: true };
      return $http.get(API + '/vendorRequests', { params: params });
    }

    function getRequestsByName(query) {
      var params = { eventId: EVENT_ID, status: 'accepted', vendorName: query };
      return $http.get(API + '/vendorRequests', { params: params });
    }

    // function getRequestsByUserId() {
    //   var params = { eventId: EVENT_ID, vendorId: $rootScope.currentUser.id };
    //   return $http.get(API + '/vendorRequests/', { params: params });
    // }

    function getRequestById(id) {
      // var params = { vendorId: $rootScope.currentUser.id };
      return $http.get(API + '/vendorRequests/' + id);
    }

    function getRequestByStatus(status) {
      var params = { eventId: EVENT_ID, status: status }
      return $http.get(API + '/vendorRequests', { params: params });
    }

    function onAdd(request) {
      request['goodsCategoryId'] = request.goodsCategory.id;
      request['eventId'] = EVENT_ID;
      return $http.post(API + '/vendorRequests', request );
    }

    function onUpdate(request){
      request['goodsCategoryId'] = request.goodsCategory.id;
      request['eventId'] = EVENT_ID;
      return $http.put(API + '/vendorRequests/' + request.id, request);
    }

    function onSubmit(id) {
      var params = { eventId: EVENT_ID };
      return $http.post(API + '/vendorRequests/' + id + '/actions/submit', params);
    }

    function onAccept(id) {
      var params = { eventId: EVENT_ID };
      return $http.post(API + '/vendorRequests/' + id + '/actions/accept', params);
    }

    // MarkPaid
    // int id;
    function markPaid(id){
      return $http.post(API +'/vendorRequests/'+ id +'/actions/markPaid');
    }

    function onInvoice(id) {
      return $http.post(API + '/vendorRequests/'+ id +'/actions/invoice');
    }

    function onCancel(id) {
      var params = { eventId: EVENT_ID };
      return $http.post(API + '/vendorRequests/' + id + '/actions/cancel', params);
    }

    function onDecline(id) {
      var params = { eventId: EVENT_ID };
      return $http.post(API + '/vendorRequests/'+ id +'/actions/decline', params);
    }

    function onDelete(id) {
      var params = { eventId: EVENT_ID };
      return $http.delete(API + '/vendorRequests/'+ id, params);
    }

    function onReset(id) {
      var params = { eventId: EVENT_ID };
      return $http.post(API + '/vendorRequests/'+ id +'/actions/reset', params);
    }

    // Check In
    function onCheckIn(id) {
      // var params = { eventId: EVENT_ID };
      return $http.post(API + '/vendorRequests/'+ id +'/actions/checkIn');
    }

    // CVS
    function getRequestCsv(ids) {
      var params = { eventId: EVENT_ID };
      if ( ids ) params['ids'] = ids;
      params['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return $http.get(API + '/vendorRequests/export', { params: params });
    }

    return {
      getRequests: getRequests,
      getRequestById: getRequestById,
      getRequestsWithBooth: getRequestsWithBooth,
      // getRequestsByUserId: getRequestsByUserId,
      getMyRequests: getMyRequests,
      getPublishedRequests: getPublishedRequests,
      getRequestByStatus: getRequestByStatus,
      getRequestsByName: getRequestsByName,

      onAdd: onAdd,
      onUpdate: onUpdate,
      onSubmit: onSubmit,
      onAccept: onAccept,
      onInvoice: onInvoice,
      onCancel: onCancel,
      onDecline: onDecline,
      onDelete: onDelete,
      onReset: onReset,

      markPaid: markPaid,

      // Check In
      onCheckIn: onCheckIn,

      requests: requests,
      pushRequest: pushRequest,
      updateRequest: updateRequest,
      spliceRequest: spliceRequest,
      getRequestCsv: getRequestCsv
      // updateVendorInRequest: updateVendorInRequest
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('UserGroupsService', UserGroupsService);
  
  UserGroupsService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function UserGroupsService($http, API, EVENT_ID) {
    var GROUPS;

    function groups(groups) {
      GROUPS = [];
      angular.forEach(groups, function(item){
        GROUPS.push(item);
      });
      return GROUPS;
    }

    function add(group) {
      GROUPS.push(group);
    }

    function update(group) {
      angular.forEach(GROUPS, function(item){
        if ( item.id === group.id ) {
          var index = GROUPS.indexOf(item);
          GROUPS[index] = group;
        }
      });
    }

    function remove(group){
      var index = GROUPS.indexOf(group);
      GROUPS.splice(index, 1);
    }



    function getGroups(includeUsers) {
      var params = { eventId: EVENT_ID };
      if ( includeUsers ) params['includeUsers'] = true;
      return $http.get(API + '/userGroups', { params: params });
    }

    function getGroupById(id) {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/userGroups/' + id, { params: params });
    }

    function getGroupsByQuery(ids) {
      var params = { eventId: EVENT_ID, ids: ids };
      return $http.get(API + '/userGroups/list', { params: params });
    }

    function addGroup(group) {
      group['eventId'] = EVENT_ID;
      return $http.post(API + '/userGroups', group);
    }

    function deleteGroup(id) {
      return $http.delete(API + '/userGroups/' + id);
    }

    function updateGroup(id, group) {
      group['eventId'] = EVENT_ID;
      return $http.put(API + '/userGroups/' + id, group);
    }

    function searchUsers(type, name) {
      var params = { eventId: EVENT_ID, type: type, name: name};
      return $http.get(API + '/users/search', { params: params });
    }

    function exportGroup(id, ids){
      var params = {};
      if ( ids ) params['ids'] = ids;
      return $http.get(API +'/userGroups/'+ id +'/export', { params: params })
    }

    return {
      getGroups: getGroups,
      getGroupById: getGroupById,
      getGroupsByQuery: getGroupsByQuery,
      addGroup: addGroup,
      deleteGroup: deleteGroup,
      updateGroup: updateGroup,
      exportGroup: exportGroup,

      searchUsers: searchUsers,


      groups: groups,
      add: add,
      update: update,
      remove: remove
    };

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('TransactionService', TransactionService);
  
  TransactionService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function TransactionService($http, API, EVENT_ID){

    function getTransactions(itemType, id){
      return $http.get(API + '/paymentTransactions?eventId='+ EVENT_ID +'&itemType='+ itemType +'&eventRequestId='+ id);
    }

    function paymentTransaction(data){
      data['eventId'] = EVENT_ID;
      return $http.post(API + '/paymentTransactions', data);
    }

    function refundTransaction(transaction){
      var data = {
        eventId: EVENT_ID,
        transactionId: transaction.id,
        service: transaction.service,
        amount: transaction.amount
      }
      return $http.post(API + '/paymentTransactions/actions/refund', data);
    }

    return {
      getTransactions: getTransactions,
      paymentTransaction: paymentTransaction,
      refundTransaction: refundTransaction
    }

  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('TemplateService', TemplateService);
  
  TemplateService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function TemplateService($http, API, ID){

    function getTemplates(){
      var params = { eventId: ID };
      return $http.get(API + '/templates', { params: params });
    }

    function getTemplateByName(name){
      return $http.get(API + '/templates/eventId='+ ID +';name='+ name);
    }

    function updateTemplateByName(name, data){
      return $http.put(API + '/templates/eventId='+ ID +';name='+ name, data);
    }

    function sendTestMail(name, email){
      return $http.get(API + '/templates/eventId='+ ID +';name='+ name +'/sendTestEmail', { params: { email: email } })
    }

    return {
      getTemplates: getTemplates,
      getTemplateByName: getTemplateByName,
      updateTemplateByName: updateTemplateByName,
      sendTestMail: sendTestMail
    }

  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('TeamService', TeamService);
  
  TeamService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function TeamService($http, API, EVENT_ID) {
    var TEAMS;
    var MY_TEAMS = [];

    // My teams
    function clearMyTeams() {
      MY_TEAMS = [];
    }
    function setMyTeams(data) {
      angular.forEach(data, function(item){
        MY_TEAMS.push(item);
      });
      return MY_TEAMS;
    }
    function myTeams() {
      return MY_TEAMS;
    }


    function teams(teams) {
      TEAMS = [];
      angular.forEach(teams, function(item){
        TEAMS.push(item);
      });
      return TEAMS;
    }
    function add(team) {
      TEAMS.push(team);
    }
    function update(team) {
      angular.forEach(TEAMS, function(item){
        if ( item.id === team.id ) {
          var index = TEAMS.indexOf(item);
          TEAMS[index] = team;
        }
      });
    }
    function remove(team){
      var index = TEAMS.indexOf(team);
      TEAMS.splice(index, 1);
    }


    function getTeams() {
      var params = { eventId: EVENT_ID };
      return $http.get(API +'/teams', { params: params });
    }

    function getTeamById(id) {
      var params = { eventId: EVENT_ID };
      return $http.get(API +'/teams/'+ id, { params: params });
    }

    function addTeam(team) {
      team['eventId'] = EVENT_ID;
      return $http.post(API +'/teams', team);
    }

    function updateTeam(id, team) {
      team['eventId'] = EVENT_ID;
      return $http.put(API +'/teams/'+ id, team);
    }

    function deleteTeam(id) {
      return $http.delete(API +'/teams/'+ id);
    }

    function getMyTeams() {
      return $http.get(API +'/teams/my');
    }
    function getMyTeamMembers(id) {
      return $http.get(API +'/teams/'+ id +'/members');
    }

    return {
      getTeams: getTeams,
      getTeamById: getTeamById,
      addTeam: addTeam,
      updateTeam: updateTeam,
      deleteTeam: deleteTeam,

      getMyTeams: getMyTeams,
      getMyTeamMembers: getMyTeamMembers,

      teams: teams,
      add: add,
      update: update,
      remove: remove,

      clearMyTeams: clearMyTeams,
      setMyTeams: setMyTeams,
      myTeams: myTeams
    };

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('SponsorService', SponsorService);
  
  SponsorService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function SponsorService($http, API, EVENT_ID) {
    var SPONSORS;

    // function resetSponsors(){
    //   SPONSORS = [];
    // }

    // function getS(){
    //   return SPONSORS;
    // }

    function sponsors(sponsors) {
      SPONSORS = [];
      angular.forEach(sponsors, function(item){
        SPONSORS.push(item);
      });
      return SPONSORS;
    }
    function add(sponsor) {
      SPONSORS.push(sponsor);
    }
    function update(sponsor) {
      angular.forEach(SPONSORS, function(item){
        if ( item.id === sponsor.id ) {
          var index = SPONSORS.indexOf(item);
          SPONSORS[index] = sponsor;
        }
      });
    }
    function remove(sponsor){
      angular.forEach(SPONSORS, function(item){
        if ( item.id === sponsor.id ) {
          var index = SPONSORS.indexOf(item);
          SPONSORS.splice(index, 1);
        }
      });
    }



    function getSponsors(page, enabled, validOnly) {
      // validOnly=true&enabled=true&landingPage=true
      var params = { eventId: EVENT_ID };
      if ( page === 'landingPage' ){
        params['landingPage'] = true;
      } else if ( page === 'innerPages' ){
        params['innerPages'] = true;
      }
      if ( enabled ){
        params['enabled'] = true;
      }
      if ( validOnly ){
        params['validOnly'] = true;
      }
      return $http.get(API + '/sponsors', { params: params });
    }

    function getSponsorById(id) {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/sponsors/' + id, { params: params });
    }

    function onAdd(sponsor) {
      sponsor['eventId'] = EVENT_ID;
      return $http.post(API + '/sponsors', sponsor);
    }

    function onUpdate(id, sponsor) {
      sponsor['eventId'] = EVENT_ID;
      return $http.put(API + '/sponsors/' + id, sponsor);
    }

    function onDelete(id) {
      return $http.delete(API + '/sponsors/' + id);
    }

    // Sponsor Request
    function getRequests(status) {
      var params = { eventId: EVENT_ID };
      if ( status ) params['status'] = status;
      return $http.get(API + '/sponsorRequests', { params: params });
    }
    function getRequestById(id) {
      // var params = { eventId: EVENT_ID };
      return $http.get(API + '/sponsorRequests/'+ id);
    }
    function getMyRequests() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/sponsorRequests/my', { params: params });
    }
    function getPublishedRequests(){
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/sponsorRequests/published', { params: params });
    }
    function addRequest(data) {
      data['eventId'] = EVENT_ID;
      return $http.post(API + '/sponsorRequests', data);
    }
    function updateRequest(id, data){
      return $http.put(API +'/sponsorRequests/'+ id, data);
    }
    function deleteRequest(id){
      return $http.delete(API +'/sponsorRequests/'+ id);
    }

    function requestMarkPaid(request) {
      return $http.post(API + '/sponsorRequests/'+ request.id + '/actions/markPaid');
    }

    function checkedIn(id){
      return $http.post(API +'/sponsorRequests/'+ id +'/actions/checkIn');
    }

    // Attendants
    function getAttendantRequests(){
      var params = { eventId: EVENT_ID };
      return $http.get(API +'/sponsorAttendantRequests', { params: params });
    }
    function getMyAttendantRequests(){
      var params = { eventId: EVENT_ID };
      return $http.get(API +'/sponsorAttendantRequests/my', { params: params });
    }
    function actionCheckInAttendantRequest(id){
      return $http.post(API +'/sponsorAttendantRequests/'+ id +'/actions/checkIn');
    }

    return {
      getSponsors: getSponsors,
      getSponsorById: getSponsorById,
      onAdd: onAdd,
      onUpdate: onUpdate,
      onDelete: onDelete,
      // Requests
      getRequests: getRequests,
      getRequestById: getRequestById,
      getMyRequests: getMyRequests,
      getPublishedRequests: getPublishedRequests,
      addRequest: addRequest,
      updateRequest: updateRequest,
      deleteRequest: deleteRequest,
      requestMarkPaid: requestMarkPaid,

      checkedIn: checkedIn,

      resetSponsors: function(){
        SPONSORS = [];
      },
      getS: function(){
        return SPONSORS
      },
      sponsors: sponsors,
      add: add,
      update: update,
      remove: remove,

      getAttendantRequests: getAttendantRequests,
      getMyAttendantRequests: getMyAttendantRequests,
      actionCheckInAttendantRequest: actionCheckInAttendantRequest
    }

  }

})();
(function(){

  angular
    .module('eventmap')
    .factory('SettingService', SettingService);
  
  SettingService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function SettingService($http, API, EVENT_ID) {

    function getSettingsByGroup(group) {
      var params = { eventId: EVENT_ID };
      if ( group ) params['group'] = group;
      return $http.get(API + '/settings', { params: params });
    }

    function updateSettings(data) {
      // data['eventId'] = EVENT_ID;
      return $http.put(API + '/settings/eventId='+ EVENT_ID, data);
    }

    // function updateAllSettings(data) {
    //   return $http.put(API + '/settings/eventId='+ EVENT_ID, data);
    // }

    return {
      getSettingsByGroup: getSettingsByGroup,
      updateSettings: updateSettings
      // updateAllSettings: updateAllSettings
    }
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ScheduleService', ScheduleService);

  ScheduleService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function ScheduleService($http, API, EVENT_ID) {
    var SCHEDULES;

    function schedules(schedules) {
      SCHEDULES = [];
      angular.forEach(schedules, function(schedule){
        SCHEDULES.push(schedule);
      });
      return SCHEDULES;
    }
    function add(schedule) {
      SCHEDULES.push(schedule);
    }
    function update(schedule) {
      angular.forEach(SCHEDULES, function(item){
        if ( item.id === schedule.id ) {
          var index = SCHEDULES.indexOf(item);
          SCHEDULES[index] = schedule;
        }
      });
    }
    function remove(schedule){
      var index = SCHEDULES.indexOf(schedule);
      SCHEDULES.splice(index, 1);
    }



    function getSchedules(type){
      var params = { eventId: EVENT_ID };
      if ( type ) params['userType'] = type;
      return $http.get(API +'/schedules', { params: params });
    }
    function addSchedule(data){
      data['eventId'] = EVENT_ID;
      return $http.post(API +'/schedules', data);
    }
    function updateSchedule(data){
      data['eventId'] = EVENT_ID;
      return $http.put(API +'/schedules/'+ data.id, data);
    }
    function removeSchedule(id){
      return $http.delete(API +'/schedules/'+ id);
    }

    return {
      getSchedules: getSchedules,
      addSchedule: addSchedule,
      updateSchedule: updateSchedule,
      removeSchedule: removeSchedule,

      schedules: schedules,
      add: add,
      update: update,
      remove: remove
    }
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .factory('ScavengerHuntService', ScavengerHuntService);

  ScavengerHuntService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function ScavengerHuntService($http, API_PATH, EVENT_ID){
    var checkinUrl = API_PATH +'/shunt/checkin-points';
    var recordsUrl = API_PATH +'/shunt/checkin-records';
    return {
      getPoints: function(){
        var params = { eventId: EVENT_ID };
        return $http.get(checkinUrl, { params: params });
      },
      getPoint: function(id){
        var params = { eventId: EVENT_ID };
        return $http.get(checkinUrl +'/'+ id, { params: params });
      },
      createPoint: function(data){
        data['eventId'] = EVENT_ID;
        return $http.post(checkinUrl, data);
      },
      updatePoint: function(data){
        return $http.put(checkinUrl +'/'+ data.id, data);
      },
      deletePoint: function(id){
        return $http.delete(checkinUrl +'/'+ id);
      },

      getLeaderboard: function(){
        var params = { eventId: EVENT_ID };
        return $http.get(checkinUrl +'/leaderboard', { params: params });
      },
      exportLeaderboard: function(){
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $http.post(checkinUrl +'/leaderboard/exports?eventId='+ EVENT_ID +'&timeZone='+ timeZone);
      },

      createCheckin: function(data){
        data['eventId'] = EVENT_ID;
        return $http.post(recordsUrl, data);
      },
      approveCheckin: function(id){
        var params = { eventId: EVENT_ID };
        return $http.post(recordsUrl +'/'+ id +'/actions/approve', { params: params });
      },
      rejectCheckin: function(id){
        var params = { eventId: EVENT_ID };
        return $http.post(recordsUrl +'/'+ id +'/actions/reject', { params: params });
      },
      getMy: function(){
        var params = { eventId: EVENT_ID };
        return $http.get(recordsUrl +'/my', { params: params });
      }
    }
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
    .factory('ReservationService', ReservationService);

  ReservationService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function ReservationService($http, API, EVENT_ID){
    return {
      // Get reservation calendars
      // boothId: string
      getReservations: function(boothId){
        var params = { eventId: EVENT_ID };
        if ( boothId ) params['boothId'] = boothId
        return $http.get(API +'/reservationCalendars', { params: params });
      },
      // Create reservation calendar
      // data: Object
      createReservation: function(data){
        data['eventId'] = EVENT_ID;
        return $http.post(API +'/reservationCalendars', data);
      },
      // Update reservation calendar
      // id: number
      // data: Object
      updateReservation: function(id, data){
        return $http.put(API +'/reservationCalendars/'+ id, data);
      },
      // Get reservation by id
      // id: integer
      getReservationByID: function(id){
        return $http.get(API +'/reservationCalendars/'+ id);
      },
      // Delete reservation by id
      // id: integer
      deteleReservation: function(id){
        return $http.delete(API +'/reservationCalendars/'+ id);
      },
      // Get reservation slot
      // eventId: integer
      // reservationCalendarId: integer
      // boothId: string
      // start: string
      // end: string
      getReservationSlot: function(reservationCalendarId, boothId, start, end, state){
        var params = { eventId: EVENT_ID };
        if ( reservationCalendarId ) params['reservationCalendarId'] = reservationCalendarId;
        if ( boothId ) params['boothId'] = boothId;
        if ( state ) params['state'] = state;
        if ( start ) params['start'] = start;
        if ( end ) params['end'] = end;
        return $http.get(API +'/reservationCalendars/timeSlots', { params: params });
      },
      // Update slot reservation
      // id: integer
      // data: Object
      updateReservationSlot: function(slot){
        var data = { price: Number(slot.price) };
        return $http.put(API +'/reservationCalendars/timeSlots/'+ slot.id, data);
      },
      // Delete slot reservation by id
      // id: integer
      deteleReservationSlot: function(id){
        return $http.delete(API +'/reservationCalendars/timeSlots/'+ id);
      },

      // id: integer
      reserveSlot: function(id){
        return $http.post(API +'/reservationCalendars/timeSlots/reservation/reserve/'+ id);
      }
    }
  }

})();
(function(){

  angular.module('eventmap')
    .factory('RequestReservationService', RequestReservationService);

  RequestReservationService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function RequestReservationService($http, API, EVENT_ID){
    return {
      // Get reservations
      // GET
      // participantId: integer
      // status: string
      getReservationRequests: function(participantId, status){
        var params = { eventId: EVENT_ID }
        if ( participantId ) params['participantId'] = participantId;
        if ( status ) params['status'] = status;
        return $http.get(API +'/reservationRequests', { params: params });
      },
      // Take request by id
      // GET
      // id: integer
      getReservationRequestById: function(id){
        return $http.get(API +'/reservationRequests/'+ id);
      },
      // Create slot reservation
      // POST
      /* data: {
        participantId: integer,
        timeSlotIds: [integer]
      }
      */
      createSlotReservation: function(data){
        return $http.post(API +'/reservationRequests', data);
      },
      // Cancel reservation request
      // POST
      // id: integer
      cancelReservationRequest: function(id){
        return $http.post(API +'/reservationRequests/'+ id +'/actions/cancel');
      },
      // Mark as paid reservation request
      // POST
      // id: integer
      markAsPaidReservationRequest: function(id){
        return $http.post(API +'/reservationRequests/'+ id +'/actions/markPaid');
      },
      // Check In
      // POST
      // id: integer
      checkInReservationRequest: function(id){
        return $http.post(API +'/reservationRequests/'+ id +'/actions/checkIn')
      },
      // Auto check in
      // POST
      // code: string
      autoCheckInReservationRequest: function(code){
        return $http.post(API +'/reservationRequests/actions/autoCheckIn?eventId='+ EVENT_ID +'&code='+ code)
      },
      // Create and accept reservation slot request
      // POST
      /* data: {
          participantId: integer,
          timeSlotIds: [integer]
        }
      */
      createAndAcceptSlotReservation: function(data){
        return $http.post(API +'/reservationRequests/actions/createAndAccept', data);
      },
      // Get my reservation requests
      // GET
      getMyReservationRequests: function(){
        var params = { eventId: EVENT_ID };
        return $http.get(API +'/reservationRequests/my', { params: params });
      }
    }
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ReportService', ReportService);

  ReportService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function ReportService($http, API, EVENT_ID) {
    function getReport(){
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/reports/revenue', { params: params });
    }

    return {
      getReport: getReport
    }

  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('PriceService', PriceService);

  PriceService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function PriceService($http, API, EVENT_ID) {
    var PRICES = [];

    function prices(prices) {
      PRICES = [];
      angular.forEach(prices, function(item){
        PRICES.push(item);
      });
      return PRICES;
    }

    function add(price) {
      PRICES.push(price);
    }

    function update(price) {
      angular.forEach(PRICES, function(item){
        if ( item.id === price.id ) {
          var index = PRICES.indexOf(item);
          PRICES[index] = price;
        }
      });
    }

    function remove(price){
      var index = PRICES.indexOf(price);
      PRICES.splice(index, 1);
    }




    function getPrices(enable, type, promocode) {
      var params = { eventId: EVENT_ID, type: type};
      if ( enable ){
        params.enable = enable;
      }
      if ( promocode ){
        params.promoCode = promocode;
      }
      return $http.get(API + '/pricePackages', { params: params });
    }

    function onAdd(price) {
      price['eventId'] = EVENT_ID;
      return $http.post(API + '/pricePackages', price);
    }

    function onUpdate(id, price) {
      price['eventId'] = EVENT_ID;
      return $http.put(API + '/pricePackages/' + id, price)
    }

    function onRemove(id) {
      return $http.delete(API + '/pricePackages/' + id);
    }

    return {
      prices: prices,
      add: add,
      update: update,
      remove: remove,

      getPrices: getPrices,
      onAdd: onAdd,
      onUpdate: onUpdate,
      onRemove: onRemove
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('PaymentService', PaymentService);

  PaymentService.$inject = ['$rootScope', 'TransactionService', 'APP_PATH', 'EVENT_ID'];

  function PaymentService($rootScope, TransactionService, APP_PATH, EVENT_ID) {
    var currentEvent = $rootScope.currentEvent;

    return {
      paypalForm: paypalForm,
      transactionForm: transactionForm,
      stripeForm: stripeForm,
      squareupForm: squareupForm,
      // payeezyForm: payeezyForm
    }

    // Paypal
    function paypalForm(pay, result, kind) {
      var scriptUrl = 'scripts/paypal-button.min.js?merchant=' + pay.paypalMerchantId;
      var scriptElem = angular.element(document.createElement('script'));
      var origin = window.location.origin;
      scriptElem.attr('src', scriptUrl);
  
      scriptElem.attr('data-button', 'buynow');
      scriptElem.attr('data-name', currentEvent.name +' event participation fee for '+ result.name + 'x1');
      scriptElem.attr('data-custom', kind +'-'+ EVENT_ID +'-'+ result.id);
      scriptElem.attr('data-amount', parseFloat(result.amount).toFixed(2));
      scriptElem.attr('data-currency', 'USD');
      scriptElem.attr('data-shipping', '0');
      scriptElem.attr('data-tax', '0');
      if (pay.paypalMode === 'sandbox') {
        scriptElem.attr('data-env', pay.paypalMode);
      }
      scriptElem.attr('data-callback', APP_PATH +'/paypal/ipn');
      scriptElem.attr('data-return', origin +'/' + pay.paypalCallback);
      scriptElem.attr('data-cancel_return', origin +'/' + pay.paypalCallback);
      scriptElem.attr('data-rm', '1');
      $('body').append(scriptElem);
      $('.paypal-button').click();
    }

    // Transaction
    function transactionForm(pay, result, kind) {
      var origin = window.location.origin;
      var inputGroup = [
        { name: 'HostedKey', value: pay.hostedKey },
        { name: 'Gateway_ID', value: pay.gatewayId },
        { name: 'IndustryCode', value: 1 },
        { name: 'Amount', value: parseFloat(result.amount).toFixed(2) },
        { name: 'RecurringType', value: 'N' },
        { name: 'RecurringAmount', value: '' },
        { name: 'RURL', value: APP_PATH + '/transactionexpress/callback/success?redirect='+ origin +'/' + pay.callback },
        { name: 'CURL', value: origin +'/' + pay.callback },
        { name: 'AVSRequired', value: 'N' },
        { name: 'CVV2Required', value: 'Y' },
        { name: 'EmailRequired', value: 'N' },
        { name: 'PostRspMsg', value: 'Y' },
        { name: 'SECCode', value: '2' },
        { name: 'Descriptor', value: 'ACH Test' },
        { name: 'CustRefID', value: kind +'-'+ EVENT_ID +'-'+ result.id }
      ];
      // Create form
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = pay.hostedPageUrl;
  
      angular.forEach(inputGroup, function(item){
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = item.name;
        input.value = item.value;
        form.appendChild(input);
      });
  
      document.body.appendChild(form);
      form.submit();
    }

    // Stripe
    function stripeForm(pay, result, kind, cbSuccess, cbError, cbClose){
      var StripeCheckout = StripeCheckout || window.StripeCheckout;
      var closedAuto = false;
      var handler = StripeCheckout.configure({
        key: pay.publishableKey,
        image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
        locale: 'auto',
        token: function(token) {
          closedAuto = true;
          var data = {
            'amount': result.amount,
            'eventRequestId': result.id,
            'itemType': kind,
            'token': token.id,
            'service': 'stripe'
          };
          TransactionService.paymentTransaction(data)
            .then(cbSuccess, cbError);
        },
        closed: function(){
          if ( !closedAuto && cbClose ) cbClose();
        }
      });

      handler.open({
        name: result.name,
        description: result.description || '',
        zipCode: false,
        email: result.email
      });
    }

    // Squareup
    function squareupForm(pay, result, kind){
      // Create and initialize a payment form object
      var paymentForm = new SqPaymentForm({
        // Initialize the payment form elements
        applicationId: pay.applicationId,
        locationId: pay.locationId,
        inputClass: 'sq-input',
        // Initialize the credit card placeholders
        cardNumber: {
          elementId: 'sq-card-number',
          placeholder: '•••• •••• •••• ••••'
        },
        cvv: {
          elementId: 'sq-cvv',
          placeholder: 'CVV'
        },
        expirationDate: {
          elementId: 'sq-expiration-date',
          placeholder: 'MM/YY'
        },
        postalCode: {
          elementId: 'sq-postal-code'
        },
        // SqPaymentForm callback functions
        callbacks: {
          cardNonceResponseReceived: function(errors, nonce, cardData, billingContact, shippingContact) {
            if (errors) {
              // Log errors from nonce generation to the Javascript console
              // console.log("Encountered errors:");
              errors.forEach(function(error) {
                console.log('  ' + error.message);
              });

              return;
            }
            alert('Nonce received: ' + nonce); /* FOR TESTING ONLY */
            // Assign the nonce value to the hidden form field
            document.getElementById('card-nonce').value = nonce;
            // POST the nonce form to the payment processing page
            document.getElementById('nonce-form').submit();
          }
        }
      });

      function requestCardNonce(event) {
        // Don't submit the form until SqPaymentForm returns with a nonce
        event.preventDefault();
        // Request a nonce from the SqPaymentForm object
        paymentForm.requestCardNonce();
      }

      paymentForm.build();
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ParticipantService', ParticipantService);
  
  ParticipantService.$inject = [
    '$http',
    'API_PATH',
    'EVENT_ID'
  ];

  function ParticipantService(
    $http,
    API,
    EVENT_ID
  ) {
    var PARTICIPANTS;

    function participants(participants) {
      PARTICIPANTS = [];
      angular.forEach(participants, function(item){
        PARTICIPANTS.push(item);
      });
      return PARTICIPANTS;
    }

    function add(participant) {
      PARTICIPANTS.push(participant);
    }

    function update(participant) {
      angular.forEach(PARTICIPANTS, function(item){
        if ( item.id === participant.id ) {
          var index = PARTICIPANTS.indexOf(item);
          PARTICIPANTS[index] = participant;
        }
      });
    }

    function remove(participant){
      var index = PARTICIPANTS.indexOf(participant);
      PARTICIPANTS.splice(index, 1);
    }



    function getRequests(status) {
      var params = { eventId: EVENT_ID };
      if ( status ){ params['status'] = status }
      return $http.get(API + '/participantRequests', { params: params });
    }

    function getRequestById(id) {
      // var params = { vendorId: $rootScope.currentUser.id };
      return $http.get(API + '/participantRequests/' + id);
    }

    function onAdd(participant) {
      participant['eventId'] = EVENT_ID;
      return $http.post(API + '/participantRequests', participant);
    }

    function onDelete(id){
      return $http.delete(API +'/participantRequests/'+ id);
    }

    function onCancel(id){
      return $http.post(API +'/participantRequests/'+ id +'/actions/cancel');
    }

    function onUpdate(id, data){
      return $http.put(API +'/participantRequests/'+ id, data);
    }

    function getMyRequests() {
      var params = { eventId: EVENT_ID };
      return $http.get(API +'/participantRequests/my', { params: params });
    }

    function requestMarkPaid(request) {
      return $http.post(API +'/participantRequests/'+ request.id + '/actions/markPaid');
    }

    function setRequestBibNumber(id, bibNumber) {
      return $http({
        url: API + '/participantRequests/'+ id +'/actions/setBibNumber',
        method: 'POST',
        params: {
          bibNumber: bibNumber || ''
        }
      });
    }

    function createAndAcceptRequest(request) {
      request['eventId'] = EVENT_ID;
      return $http.post(API + '/participantRequests/actions/createAndAccept', request)
    }

    function checkedInRequest(id) {
      return $http.post(API + '/participantRequests/'+ id +'/actions/checkIn')
    }

    function autoCheckIn(code) {
      // var params = { eventId: EVENT_ID, code: code };
      return $http.post(API + '/participantRequests/actions/autoCheckIn?eventId='+ EVENT_ID +'&code='+ code);
    }

    function getRequestCsv(ids){
      var params = { eventId: EVENT_ID };
      if ( ids ) params['ids'] = ids;
      params['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return $http.get(API + '/participantRequests/export', { params: params });
    }

    return {
      getRequests: getRequests,
      getRequestById: getRequestById,
      getMyRequests: getMyRequests,
      onAdd: onAdd,
      onDelete: onDelete,
      onUpdate: onUpdate,
      onCancel: onCancel,

      participants: participants,
      add: add,
      update: update,
      remove: remove,
      requestMarkPaid: requestMarkPaid,
      setRequestBibNumber: setRequestBibNumber,
      createAndAcceptRequest: createAndAcceptRequest,
      checkedInRequest: checkedInRequest,
      autoCheckIn: autoCheckIn,
      getRequestCsv: getRequestCsv
    }
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('PageService', PageService);

  function PageService(
    $http,
    API_PATH,
    EVENT_ID
  ) {
    return {
      getPages: function(type){
        var params = { eventId: EVENT_ID, type: type };
        return $http.get(API_PATH +'/pageContents', { params: params });
      },
      createPage: function(data){
        data['eventId'] = EVENT_ID;
        return $http.post(API_PATH +'/pageContents', data);
      },
      updatePage: function(data){
        return $http.put(API_PATH +'/pageContents/'+ data.id, data);
      },
      deletePage: function(id){
        var params = { eventId: EVENT_ID };
        return $http.delete(API_PATH +'/pageContents/'+ id, { params: params });
      },

      getPageByTag: function(type, tag){
        var params = { eventId: EVENT_ID, type: type, tag: tag };
        return $http.get(API_PATH +'/pageContents/getByTag', { params: params });
      }
    }
  }

})();
(function(){

  angular
    .module('eventmap')
    .factory('OrganizerService', OrganizerService);
  
  OrganizerService.$inject = [];
  
  function OrganizerService() {

    return {
      
    }

  }

})();
(function(){

  angular
    .module('eventmap')
    .factory('MessagesService', MessagesService);
  
  MessagesService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function MessagesService($http, API, EVENT_ID){
    var MESSAGES;

    function messages(messages) {
      MESSAGES = [];
      angular.forEach(messages, function(item){
        MESSAGES.push(item);
      });
      return MESSAGES;
    }

    function add(message) {
      MESSAGES.push(message);
    }

    function update(message) {
      angular.forEach(MESSAGES, function(item){
        if ( item.id === message.id ) {
          var index = MESSAGES.indexOf(item);
          MESSAGES[index] = message;
        }
      });
    }

    function remove(message){
      angular.forEach(MESSAGES, function(item){
        if ( item.id === message.id ) {
          var index = MESSAGES.indexOf(item);
          MESSAGES.splice(index, 1);
        }
      });
      // var index = MESSAGES.indexOf(message);
      // MESSAGES.splice(index, 1);
    }




    function getInboxMessages() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/messages/inbox', { params: params });
    }

    function getInboxMessageById(id, recipientId, type) {
      var params = { eventId: EVENT_ID };
      if ( recipientId ) params['recipientId'] = recipientId
      if ( type ) params['type'] = type;
      return $http.get(API + '/messages/inbox/' + id, { params: params });
    }

    function getInboxUnreadCount(){
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/messages/inbox/unreadCount', { params: params });
    }

    function getMessageById(id) {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/messages/' + id, { params: params });
    }

    function getSentMessages() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/messages/sent', { params: params });
    }

    function sentMessage(message) {
      message['eventId'] = EVENT_ID;
      return $http.post(API + '/messages', message);
    }

    function sentMessageBackOffice(message) {
      message['eventId'] = EVENT_ID;
      return $http.post(API + '/messages/backoffice', message);
    }

    function markAsRead(id, type) {
      return $http.post(API + '/messages/' + id + '/actions/markAsRead?type='+ type);
    }

    function onUpdate(id, message) {
      message['eventId'] = EVENT_ID;
      return $http.put(API + '/messages/' + id, message);
    }

    function onDelete(id) {
      return $http.delete(API + '/messages/' + id);
    }

    return {
      getInboxMessages: getInboxMessages,
      getInboxMessageById: getInboxMessageById,
      getInboxUnreadCount: getInboxUnreadCount,

      getSentMessages: getSentMessages,
      getMessageById: getMessageById,
      sentMessage: sentMessage,
      sentMessageBackOffice: sentMessageBackOffice,
      markAsRead: markAsRead,
      onUpdate: onUpdate,
      onDelete: onDelete,

      messages: messages,
      add: add,
      update: update,
      remove: remove
    };

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('MapService', MapService);
  
  MapService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function MapService(
    $http,
    API,
    EVENT_ID
  ) {

    return {
      getMaps: function(ids, fields, type){
        var params = { eventId: EVENT_ID };
        if ( ids ) params['ids'] = ids;
        if ( fields ) params['fields'] = fields;
        if ( type ) params['type'] = type;
        return $http.get(API +'/maps', { params: params });
      },

      getBoothById: function(id){
        return $http.get(API +'/maps/booths/'+ id);
      },
      getLinkedBoothToMap: function(mapId){
        return $http.get(API +'/maps/booths/linked/'+ mapId);
      },

      getMapByID: function(id, fields){
        var params = { eventId: EVENT_ID };
        if ( fields ) params['fields'] = fields;
        return $http.get(API +'/maps/'+ id, { params: params });
      },
      createMap: function(data){
        data['eventId'] = EVENT_ID;
        return $http.post(API +'/maps', data);
      },
      updateMap: function(id, data){
        data['eventId'] = EVENT_ID;
        return $http.put(API +'/maps/'+ id, data);
      },
      deleteMap: function(id){
        return $http.delete(API +'/maps/'+ id);
      },

      getResponsibilityZones: function(){
        var params = { eventId: EVENT_ID };
        return $http.get(API +'/maps/responsibilityZones', { params: params });
      },
      updateResponsibilityZone: function(data){
        data['eventId'] = EVENT_ID;
        return $http.put(API +'/maps/responsibilityZones/'+ data.id, data);
      },
      // 
      getRespZoneByRequestId: function(id){
        var params = { eventId: EVENT_ID, volunteerRequestId: id };
        return $http.get(API +'/maps/responsibilityZones', { params: params });
      },

      getBoothIdsWithAvailableReservations: function(eventMapId, start, end){
        var params = { eventMapId: eventMapId, start: start, end: end };
        return $http.get(API +'/maps/booths/getBoothIdsWithAvailableReservations', { params: params });
      }
    };

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('MapItemsService', MapItemsService);
  
  MapItemsService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function MapItemsService($http, API, EVENT_ID) {
    // Get volunteer zone assignments
    function getVolunteerZoneAssignments(volunteerId, me) {
      var params = { eventId: EVENT_ID };
      if ( volunteerId ){ params.volunteerId = volunteerId; }
      if ( me ){ params.me = me; }
      return $http.get(API + '/volunteerZoneAssignments', { params: params });
    }

    return {
      getVolunteerZoneAssignments: getVolunteerZoneAssignments
    };

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('K2Service', K2Service);
  
  K2Service.$inject = ['$http', 'APP_PATH'];

  function K2Service($http, APP_PATH) {
    var apiPath = APP_PATH +'/k2/notification';

    return {
      fetchTemplates: function(page, size){
        var params = {};
        if ( page ) params['page'] = page;
        if ( size ) params['size'] = size;
        return $http.get(apiPath +'/templates', { params: params });
      },
      fetchVariables: function(){
        return $http.get(apiPath +'/template/variables');
      },
      fetchUsers: function(startDate, endDate){
        var params = {};
        if ( startDate ) params['startDate'] = startDate;
        if ( endDate ) params['endDate'] = endDate;
        return $http.get(apiPath +'/users', { params: params });
      },
      sendOneTime: function(data){
        return $http.post(apiPath +'/send', data);
      },
      createTemplate: function(data){
        return $http.post(apiPath +'/template', data);
      },
      updateTemplate: function(data){
        return $http.put(apiPath +'/template/'+ data.id, data);
      },
      deleteTemplate: function(id){
        return $http.delete(apiPath +'/template/'+ id);
      }
    };
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('InventoryService', InventoryService);
  
  InventoryService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function InventoryService(
    $http,
    API,
    EVENT_ID
  ) {
    var INVENTORIES;
    function inventories(inventory) {
      INVENTORIES = [];
      angular.forEach(inventory, function(item){
        INVENTORIES.push(item);
      });
      return INVENTORIES;
    }
    function add(inventory) {
      INVENTORIES.push(inventory);
    }
    function update(inventory) {
      angular.forEach(INVENTORIES, function(item){
        if ( item.id === inventory.id ) {
          var index = INVENTORIES.indexOf(item);
          INVENTORIES[index] = inventory;
        }
      });
    }
    function remove(inventory){
      var index = INVENTORIES.indexOf(inventory);
      INVENTORIES.splice(index, 1);
    }




    function getInventories() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/inventories', { params: params });
    }

    function getInventoryById(id) {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/inventories/' + id, { params: params });
    }

    function onAdd(inventory) {
      inventory['eventId'] = EVENT_ID;
      return $http.post(API + '/inventories', inventory);
    }

    function onUpdate(inventory) {
      inventory['eventId'] = EVENT_ID;
      return $http.put(API + '/inventories/' + inventory.id, inventory);
    }

    function onRemove(id){
      return $http.delete(API + '/inventories/' + id);
    }

    return {
      getInventories: getInventories,
      getInventoryById: getInventoryById,
      onAdd: onAdd,
      onUpdate: onUpdate,
      onRemove: onRemove,

      inventories: inventories,
      add: add,
      update: update,
      remove: remove
    };
  }

})();
(function(){

  angular
    .module('eventmap')
    .factory('FileService', FileService);
  
  FileService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function FileService($http, API, EVENT_ID) {
    function getFiles(source, type) {
      var params = { eventId: EVENT_ID };
      if ( source ) params['source'] = source;
      if ( type ) params['type'] = type;
      return $http.get(API + '/files', { params: params });
    }

    function getFileById(id) {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/files/' + id, { params: params });
    }

    function onAdd(file, source, type) {
      var formdata = new FormData();
      var metadata = { eventId: EVENT_ID };
      if ( source ) metadata['source'] = source;
      if ( type ) metadata['type'] = type;
      formdata.append('file', file);
      formdata.append('metadata', new Blob([JSON.stringify(metadata)], {
        type: 'application/json'
      }));
      return $http.post(API + '/files', formdata, {
        headers: {
          'Content-Type': undefined
        },
        transformRequest: angular.identity
      });
    }

    function onUpdate(file) {
      file['eventId'] = EVENT_ID;
      return $http.put(API + '/files/' + file.id, file);
    }

    function onDelete(id) {
      return $http.delete(API + '/files/' + id);
    }

    return {
      getFiles: getFiles,
      getFileById: getFileById,
      onAdd: onAdd,
      onUpdate: onUpdate,
      onDelete: onDelete
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('EventService', EventService)
  
  EventService.$inject = ['$http', 'API_PATH', 'APP_PATH', 'EVENT_ID'];

  function EventService($http, API, APP, EVENT_ID) {
    var SPECIAL_USERS;
    var EVENTS;

    // Special Users
    function specials(users) {
      SPECIAL_USERS = [];
      angular.forEach(users, function(item){
        SPECIAL_USERS.push(item);
      });
      return SPECIAL_USERS;
    }

    function specialsAdd(user) {
      SPECIAL_USERS.push(user);
    }

    function specialsUpdate(user) {
      angular.forEach(SPECIAL_USERS, function(item){
        if ( item.id === user.id ) {
          var index = SPECIAL_USERS.indexOf(item);
          SPECIAL_USERS[index] = user;
        }
      });
    }

    function specialsDelete(user) {
      var index = SPECIAL_USERS.indexOf(user);
      SPECIAL_USERS.splice(index, 1);
    }


    // Events
    function events(events) {
      EVENTS = [];
      angular.forEach(events, function(item){
        EVENTS.push(item);
      });
      return EVENTS;
    }

    function eventsAdd(event) {
      EVENTS.push(event);
    }

    function eventsUpdate(event) {
      angular.forEach(EVENTS, function(item){
        if ( item.id === event.id ) {
          var index = EVENTS.indexOf(item);
          EVENTS[index] = event;
        }
      });
    }



    // EVENTS
    function getEvents() {
      return $http.get(API + '/events');
    }

    function getEventById(eventID) {
      var id = eventID || EVENT_ID;
      return $http.get(API + '/events/' + id);
    }

    function onAdd(event) {
      return $http.post(API + '/events', event);
    }

    function onUpdate(event) {
      return $http.put(API + '/events/' + event.id, event);
    }

    function onArchive(event) {
      return $http.put(API + '/events/' + event.id + '/archive');
    }

    function onUnarchive(event) {
      return $http.put(API + '/events/' + event.id + '/unarchive');
    }

    function onPublish(event) {
      return $http.put(API + '/events/' + event.id + '/publish', event);
    }

    function onUnpublish(event) {
      return $http.put(API + '/events/' + event.id + '/unpublish', event);
    }

    function onClone(event) {
      return $http.post(API + '/events/' + event.id + '/clone', event);
    }


    // EVENT USERS
    function getVendors() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/events/vendors', { params: params });
    }

    function getVolunteers() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/events/volunteers', { params: params });
    }

    function getParticipants() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/events/participants', { params: params });
    }

    function getSpecials(type) {
      var params = { eventId: EVENT_ID, type: type || 'special,volunteerCoordinator,eventCoordinator' };
      return $http.get(API + '/events/specialUsers', { params: params });
    }

    function getSponsors() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/events/sponsors', { params: params });
    }


    // MAP
    // @params: id - map id
    function assignMainMap(id){
      return $http.post(API +'/events/'+ EVENT_ID +'/assignMainMap?eventMapId='+ id);
    }
    // function getMap(fields) {
    //   var params;
    //   if ( fields ){
    //     params = { fields: fields };
    //   }
    //   return $http.get(API + '/events/' + EVENT_ID + '/map', {params: params});
    // }

    // function onUpdateMapPreferences(preferences){
    //   // var params = { preferences: preferences }
    //   return $http.put(API + '/events/' + EVENT_ID + '/mapPreferences', preferences);
    // }

    // function onSaveMap(map) {
    //   return $http.put(API + '/events/' + EVENT_ID + '/map', map);
    // }


    // CVS
    function getCsvId(type, ids) {
      var params = { eventId: EVENT_ID, type: type };
      if ( ids ) params['ids'] = ids;
      params['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return $http.get(API + '/events/usersExport', { params: params });
    }

    function getCsvFile(id) {
      return $http.get(APP + '/downloads/' + id);
    }

    // Lock/Unlock
    function lockMap(){
      return $http.post(API + '/events/'+ EVENT_ID +'/lock');
    }

    function unlockMap(){
      return $http.post(API + '/events/'+ EVENT_ID +'/unlock');
    }


    return {
      getEvents: getEvents,
      getEventById: getEventById,
      onAdd: onAdd,
      onUpdate: onUpdate,
      onArchive: onArchive,
      onUnarchive: onUnarchive,
      onPublish: onPublish,
      onUnpublish: onUnpublish,
      onClone: onClone,

      getVendors: getVendors,
      getVolunteers: getVolunteers,
      getParticipants: getParticipants,
      getSpecials: getSpecials,
      getSponsors: getSponsors,

      // getMap: getMap,
      // onUpdateMapPreferences: onUpdateMapPreferences,
      // onSaveMap: onSaveMap,
      assignMainMap: assignMainMap,

      events: events,
      eventsAdd: eventsAdd,
      eventsUpdate: eventsUpdate,

      specials: specials,
      specialsAdd: specialsAdd,
      specialsUpdate: specialsUpdate,
      specialsDelete: specialsDelete,

      getCsvId: getCsvId,
      getCsvFile: getCsvFile,

      lockMap:lockMap,
      unlockMap:unlockMap
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('DonationsService', DonationsService);
  
  DonationsService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function DonationsService($http, API, EVENT_ID) {
    var DONATIONS;

    function donations(groups) {
      DONATIONS = [];
      angular.forEach(groups, function(item){
        DONATIONS.push(item);
      });
      return DONATIONS;
    }

    function add(group) {
      DONATIONS.push(group);
    }

    function exportDonations(){
      var params = { eventId: EVENT_ID };
      params['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return $http.get(API +'/donations/donationsExport', { params: params })
    }

    function getDonations() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/donations', { params: params });
    }

    function addDonation(data) {
      data['eventId'] = EVENT_ID;
      return $http.post(API + '/donations', data);
    }

    return {
      exportDonations: exportDonations,
      getDonations: getDonations,
      addDonation: addDonation,

      donations: donations,
      add: add
    };

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('CategoryService', CategoryService);

  CategoryService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function CategoryService($http, API, EVENT_ID) {
    var CATEGORIES;

    function categories(categories) {
      CATEGORIES = [];
      angular.forEach(categories, function(category){
        CATEGORIES.push(category);
      });
      return CATEGORIES;
    }

    function pushCategory(category) {
      CATEGORIES.push(category);
    }

    function updateCategory(category) {
      angular.forEach(CATEGORIES, function(item){
        if ( item.id === category.id ) {
          var index = CATEGORIES.indexOf(item);
          CATEGORIES[index] = category;
        }
      });
    }

    function spliceCategory(category){
      var index = CATEGORIES.indexOf(category);
      CATEGORIES.splice(index, 1);
    }

    function getCategories() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/goodsCategories', { params: params });
    }

    function getCategoryById(id) {
      return $http.get(API + '/goodsCategories/' + id);
    }

    function onAdd(category) {
      category['eventId'] = EVENT_ID;
      return $http.post(API + '/goodsCategories', category);
    }

    function onUpdate(id, category) {
      category['eventId'] = EVENT_ID;
      return $http.put(API + '/goodsCategories/' + id, category);
    }

    function onDelete(id) {
      return $http.delete(API + '/goodsCategories/' + id);
    }

    return {
      getCategories: getCategories,
      getCategoryById: getCategoryById,
      onAdd: onAdd,
      onUpdate: onUpdate,
      onDelete: onDelete,

      categories: categories,
      pushCategory: pushCategory,
      updateCategory: updateCategory,
      spliceCategory: spliceCategory
    }

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('BoothTypeService', BoothTypeService);
  
  BoothTypeService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];

  function BoothTypeService($http, API, EVENT_ID) {
    var BOOTHS;

    function booths(booths) {
      BOOTHS = [];
      angular.forEach(booths, function(item){
        BOOTHS.push(item);
      });
      return BOOTHS;
    }

    function pushBooth(booth) {
      BOOTHS.push(booth);
    }

    function updateBooth(booth) {
      angular.forEach(BOOTHS, function(item){
        if ( item.id === booth.id ) {
          var index = BOOTHS.indexOf(item);
          BOOTHS[index] = booth;
        }
      });
    }

    function spliceBooth(booth){
      var index = BOOTHS.indexOf(booth);
      BOOTHS.splice(index, 1);
    }


    function getBooths() {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/boothTypes', { params: params });
    }

    function getBoothById(id) {
      return $http.get(API + '/boothTypes/' + id);
    }

    // Booths
    function onAdd(booth) {
      booth['eventId'] = EVENT_ID;
      return $http.post(API + '/boothTypes', booth);
    }

    function onUpdate(id, booth) {
      booth['eventId'] = EVENT_ID;
      return $http.put(API + '/boothTypes/' + id, booth);
    }

    function onDelete(id){
      return $http.delete(API + '/boothTypes/' + id);
    }

    return {
      getBooths: getBooths,
      getBoothById: getBoothById,
      onAdd: onAdd,
      onUpdate: onUpdate,
      onDelete: onDelete,

      booths: booths,
      pushBooth: pushBooth,
      updateBooth: updateBooth,
      spliceBooth: spliceBooth
    };

  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('AuthService', AuthService);
  
  AuthService.$inject = [
    '$rootScope',
    '$http',
    '$timeout',
    '$q',
    'API_PATH',
    'EVENT_ID'
  ];

  function AuthService(
    $rootScope,
    $http,
    $timeout,
    $q,
    API,
    EVENT_ID
  ) {
    var AUTH_TOKEN = 'auth_token';
    var AUTH_EXPIRESIN = 'auth_expires_in';
    var CURRENT_USER = 'current_user';
    var CAN_ACCESS_PORTAL = 'portal_access';
    var RETURN_URL = 'return_url';

    var EO_AUTH_TOKEN = 'eo_auth_token';
    var EO_AUTH_EXPIRESIN = 'eo_auth_expires_in';
    var EO_CURRENT_USER = 'eo_current_user';
    var EO_CAN_ACCESS_PORTAL = 'eo_portal_access';

    function isStorageSupport() {
      try {
        return 'localStorage' in window && window['localStorage'] !== null;
      } catch(e) {
        return false;
      }
    }

    // Login as user
    function eoToken() {
      return ( isStorageSupport ? localStorage.getItem(EO_AUTH_TOKEN) : '' );
    }
    function eoExpires() {
      return ( isStorageSupport ? parseInt(localStorage.getItem(EO_AUTH_EXPIRESIN)) : '' );
    }
    function eoUser() {
      return ( isStorageSupport ? angular.fromJson(localStorage.getItem(EO_CURRENT_USER)) : '' );
    }
    function eoAccessPortal() {
      return ( isStorageSupport ? localStorage.getItem(EO_CAN_ACCESS_PORTAL) : '' );
    }

    // Default user 
    function token() {
      return ( isStorageSupport ? localStorage.getItem(AUTH_TOKEN) : '' );
    }
    function expires() {
      return ( isStorageSupport ? parseInt(localStorage.getItem(AUTH_EXPIRESIN)) : '' );
    }
    function user() {
      return ( isStorageSupport ? angular.fromJson(localStorage.getItem(CURRENT_USER)) : '' );
    }
    function accessPortal() {
      return ( isStorageSupport ? localStorage.getItem(CAN_ACCESS_PORTAL) : '' );
    }
    function returnUrl() {
      return ( isStorageSupport ? localStorage.getItem(RETURN_URL) : 'app.home' );
    }


    function setCredentialAuth(auth, loginAs){
      if ( loginAs ) {
        setEoLoginAsCredential();
      }
      localStorage.setItem(AUTH_TOKEN, auth.token);
      if ( auth.expiresIn ) {
        if ( auth.eo ) {
          localStorage.setItem(AUTH_EXPIRESIN, auth.expiresIn);
        } else {
          var date = new Date();
          localStorage.setItem(AUTH_EXPIRESIN, date.setSeconds(date.getSeconds() + auth.expiresIn));
        }
      }
    }

    function setEoLoginAsCredential() {
      localStorage.setItem(EO_AUTH_TOKEN, token());
      localStorage.setItem(EO_AUTH_EXPIRESIN, expires());
      localStorage.setItem(EO_CURRENT_USER, angular.toJson(user()));
      localStorage.setItem(EO_CAN_ACCESS_PORTAL, accessPortal());
      $rootScope.loginAs = true;
    }

    function setReturnUrl(url) {
      localStorage.setItem(RETURN_URL, url);
    }

    function setCredentialUser(user, portal){
      localStorage.setItem(CURRENT_USER, angular.toJson(user));
      localStorage.setItem(CAN_ACCESS_PORTAL, portal);
      $rootScope.currentUser = user;
    }

    function replaceEoLoginAsCredential() {
      setCredentialAuth({
        token: eoToken(),
        expiresIn: eoExpires(),
        eo: true
      }, false);
      setCredentialUser(
        eoUser(),
        eoAccessPortal()
      );
      $rootScope.accessPortal = eoAccessPortal();
      clearEoCredential();
    }

    function clearReturnUrl(){
      localStorage.removeItem(RETURN_URL);
    }

    function clearEoCredential() {
      localStorage.removeItem(EO_AUTH_TOKEN);
      localStorage.removeItem(EO_AUTH_EXPIRESIN);
      localStorage.removeItem(EO_CURRENT_USER);
      localStorage.removeItem(EO_CAN_ACCESS_PORTAL);
    }

    function clearCredential() {
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem(AUTH_EXPIRESIN);
      localStorage.removeItem(CURRENT_USER)
      localStorage.removeItem(CAN_ACCESS_PORTAL);
      $rootScope.currentUser = null;
    }

    function getSubscriptions(){
      return $http.get(API + '/subscriptions?user=me&status=active,pending');
    }

    function getUser() {
      return $http.get(API + '/users/me', null, {
        'headers': {
          'X-Auth-Token': token()
        }
      });
    }

    function getUserById(id) {
      var params = { eventId: EVENT_ID };
      return $http.get(API + '/users/' + id, { params: params });
    }

    function getUsersByQuery(ids) {
      var params = { eventId: EVENT_ID, ids: ids };
      return $http.get(API + '/users/list', { params: params });
    }

    function onUpdateUserById(user) {
      user['eventId'] = EVENT_ID;
      var transform = function(data){
        var formData = new FormData();
        var metaBlob = new Blob(
          [ angular.toJson(data.user) ],
          { type: 'application/json' }
        );
        formData.append('data', metaBlob);
        formData.append('photo', data.photo);
        return formData;
      }
      return $http.put(API + '/users/' + user.id, { user: user, photo: user.photo }, {
        headers: {
          'X-Auth-Token': token(),
          'Content-Type': undefined
        },
        transformRequest: transform
      });
    }

    function onLogin(data){
      data['eventId'] = EVENT_ID;
      return $http.post(API + '/login', data);
    }

    function onRegister(user, createVolunteerRequest){
      user['eventId'] = EVENT_ID;
      var transform = function(data){
        var metaBlob = new Blob(
          [ angular.toJson(data.user) ],
          { type: 'application/json' }
        );
        var formData = new FormData();
        formData.append('data', metaBlob);
        formData.append('photo', data.photo);
        return formData;
      };
      var params = {};
      if ( createVolunteerRequest ) params['createVolunteerRequest'] = true;
      return $http.post(API + '/users', { user: user, photo: user.photo }, {
        headers: {
          'Content-Type': undefined
        },
        transformRequest: transform,
        params: params
      });
    }

    function onResetPassword(user) {
      user['eventId'] = EVENT_ID;
      return $http.get(API + '/users/resetPassword', { params: user });
    }

    function onUpdate(user){
      user['eventId'] = EVENT_ID;
      var transform = function(data){
        var formData = new FormData();
        var metaBlob = new Blob(
          [ angular.toJson(data.data) ],
          { type: 'application/json' }
        );
        formData.append('data', metaBlob);
        formData.append('photo', data.photo);
        return formData;
      }
      return $http.put(API + '/users/' + user.id, { data: user, photo: user.photo }, {
        headers: {
          'X-Auth-Token': token(),
          'Content-Type': undefined
        },
        transformRequest: transform
      });
    }

    function onDelete(id){
      return $http.delete(API + '/users/' + id);
    }

    function onLogout(){
      var deferred = $q.defer();
      deferred.resolve('Logout');
      // return $timeout(function(){
        return deferred.promise;
      // }, 500);
    }

    function onDisable(user) {
      return $http.post(API + '/users/' + user.id + '/disable',  user);
    }

    function onEnable(user) {
      return $http.post(API + '/users/' + user.id + '/enable',  user);
    }


    function getEoQuota(){
      return $http.get(API + '/users/me/quota');
    }

    function getEoSubscription(){
      return $http.get(API + '/users/me/subscription');
    }

    return {
      onLogin: onLogin,
      onLogout: onLogout,
      onResetPassword: onResetPassword,
      onRegister: onRegister,
      onUpdate: onUpdate,
      onDelete: onDelete,

      onDisable: onDisable,
      onEnable: onEnable,

      getSubscriptions:getSubscriptions,
      getUser: getUser,
      getUserById: getUserById,
      getUsersByQuery: getUsersByQuery,
      onUpdateUserById: onUpdateUserById,

      setCredentialAuth: setCredentialAuth,
      setCredentialUser: setCredentialUser,

      setReturnUrl: setReturnUrl,
      clearReturnUrl: clearReturnUrl,

      clearEoCredential: clearEoCredential,
      clearCredential: clearCredential,
      replaceEoLoginAsCredential: replaceEoLoginAsCredential,

      getEoQuota: getEoQuota,
      getEoSubscription: getEoSubscription,

      isEOToken: eoToken(),
      isEOExpires: eoExpires(),

      isToken: token(),
      isExpires: expires(),
      isUser: user(),
      isReturnUrl: returnUrl(),

      accessPortal: accessPortal()
    }
  }

})();
(function(){
  'use strict';

  angular.module('eventmap')
         .factory('ApproveService', ApproveService);

  ApproveService.$inject = ['$uibModal'];

  function ApproveService(
    $uibModal
  ){
    return function(msg, confirmLabel, service, cancelLabel){
      if ( !cancelLabel || typeof cancelLabel === 'undefined' ) cancelLabel = 'Cancel';
      return $uibModal.open({
        size: 'md',
        template: [
          '<div class="modal-header">',
            '<h4 class="modal-title text-danger" style="text-align: center;">',
              msg,
            '</h4>',
          '</div>',
          '<div class="modal-footer">',
            '<button class="btn btn-default btn-sm" type="button" ng-click="handleCancel()">',
              cancelLabel,
            '</button>',
            '<button class="btn btn-primary btn-sm" type="button" ng-click="handleConfirm()" ng-disabled="loading">',
              '<i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>',
              confirmLabel,
            '</button>',
          '</div>'
        ].join(''),
        controller: function($scope, $uibModalInstance){
          $scope.loading = false;
          $scope.handleConfirm = function(){
            $scope.loading = true;
            service().then(
              function(response){
                $uibModalInstance.close(response)
              },
              function(err){
                // console.log(err);
                $scope.handleCancel(err);
                $scope.loading = false;
              }
            )
          }
          $scope.handleCancel = function(err){
            if ( err && err.data ){
              $uibModalInstance.dismiss(err);
            } else {
              $uibModalInstance.dismiss('cancel');
            }
          }
        }
      })
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('ActivityLogService', ActivityLogService);
  
  ActivityLogService.$inject = ['$http', 'API_PATH', 'EVENT_ID'];
  
  function ActivityLogService($http, API_PATH, EVENT_ID) {
    var params = { eventId: EVENT_ID };
    var apiPath = API_PATH +'/volunteerRequests/activityLogs';
    return {
      fetchAll: function(userId, eventRequestId){
        if ( userId ) params['userId'] = userId;
        if ( eventRequestId ) params['eventRequestId'] = eventRequestId;
        return $http.get(apiPath, { params: params });
      },
      create: function(data){
        return $http.post(apiPath, data);
      },
      update: function(data){
        return $http.put(apiPath +'/'+ data.id, data);
      },
      delete: function(id){
        return $http.delete(apiPath +'/'+ id);
      },

      confirm: function(id){
        return $http.put(apiPath +'/'+ id +'/confirm');
      },
      decline: function(id){
        return $http.put(apiPath +'/'+ id +'/decline');
      },

      fetchReport: function(){
        return $http.get(apiPath +'/report', { params: params });
      },
      exportReport: function(ids){
        if ( ids ) params['ids'] = ids;
        params['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $http.get(apiPath +'/report/export', { params: params });
      },
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('StaticPageController', StaticPageController);

  function StaticPageController(
    $scope,
    $state,
    PageService
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){

        var currentURL = $state.current.url ? $state.current.url.replace('/', '') : '';

        if ( currentURL === 'contact' ){
          PageService.getPageByTag('fixed', 'contact')
            .then(
              function(response){
                vm.pageContact = response.data;
              },
              $scope.handleError
            );
        } else if ( currentURL === 'about' ){
          PageService.getPageByTag('fixed', 'about')
            .then(
              function(response){
                vm.pageAbout = response.data;
              },
              $scope.handleError
            );
        } else {
          console.error('No URL found');
        }

      },

      handleError: function(err) {
        console.error(err);
      }
    });

  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('SquareupFormController', SquareupFormController);

  function SquareupFormController(
    $scope,
    $uibModalInstance,
    Notification,
    TransactionService,
    dataPay,
    dataResult,
    itemType
  ) {
    $scope.card = null;
    $scope.isLoading = false

    $scope.onInit = function(){
      iniializeForm();
    }

    $scope.onClick = function(){
      $scope.card.tokenize()
        .then(function(res){
          if ( res.status !== 'OK' ){
            var errorMessage = 'Tokenization failed-status:'+ res.status;
            if ( res.errors ) errorMessage += ' and errors:'+ JSON.stringify(res.errors);
            throw new Error(errorMessage);
          }
          var data = {
            amount: dataResult.amount,
            cardNonce: res.token,
            eventRequestId: dataResult.id,
            itemType: itemType,
            service: 'squareup'
          };
          $scope.isLoading = true;
          TransactionService.paymentTransaction(data)
            .then(
              function(response){
                $scope.isLoading = false;
                $uibModalInstance.close()
              },
              function(err){
                $scope.isLoading = false;
                Notification.error(err.data.message);
              }
            );
        })
    }


    function iniializeForm(){
      if ( !window.Square ) throw new Error('Square.js failed to load properly');
      var payments = window.Square.payments(dataPay.applicationId, dataPay.locationId);
      payments.card()
        .then(function(card){
          card.attach('#card-container')
            .then(function(){
              $scope.card = card;
            })
        })
        .catch(function(e){
          console.error('Initializing Card failed', e);
        });
    }

    $scope.handleCancel = function(){
      $uibModalInstance.dismiss('cancel');
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('ScheduleController', ScheduleController);
  
  ScheduleController.$inject = [
    '$rootScope',
    '$scope',
    'moment',
    'ScheduleService',
    'SponsorService'
  ];
  
  function ScheduleController(
    $rootScope,
    $scope,
    moment,
    __schedule,
    __sponsor
  ) {
    var vm = this;
    vm.dateRange = null;
    vm.event = $rootScope.currentEvent;

    vm.sponsorsHeadline = [];
    vm.sponsorsSecondary = [];

    // Program
    vm.program = null;
    vm.locations = [];

    angular.extend($scope, {
      moment: moment,
      slickConfig: {
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },{
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },{
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      onInit: function(){
        vm.dateRange = $scope.buildDateArray(vm.event.start, vm.event.end);
        vm.preferences = vm.event.preferences;

        vm.scheduleModule = vm.preferences.scheduleModule;
        vm.sponsorModule = vm.event.preferences.sponsorModule;

        __sponsor.getSponsors('landingPage', true, true)
          .then(function(response){
            var arrays = [];
            angular.forEach(response.data, function(sponsor){
              if ( sponsor.headline ) {
                vm.sponsorsHeadline.push(sponsor);
              } else {
                arrays.push(sponsor);
              }
            });

            for ( var i = 0; i < arrays.length; i += 2 ) {
              if ( arrays.length > 8 ){
                vm.sponsorsSecondary.push(arrays.slice(i, i + 2));
              } else {
                vm.sponsorsSecondary = arrays;
              }
            }

            return __schedule.getSchedules();
          })
          .then(function(response){
            vm.schedules = __schedule.schedules(response.data);
            vm.program = $scope.buildProgram();

            $scope.slickConfigSchedule = initSlickConfig(vm.program);

            var height = window.innerHeight;
            setTimeout(function(){
              var list = document.querySelectorAll('.programList');
              // var calcHeight = vm.scheduleModule.groupByLocation && vm.locations.length > 1 ? 374 : 274;
              var calcHeight = 360;
              if ( list.length ){
                for ( var i in list ){
                  var item = list[i];
                  if ( item && item.style ) item.style.height = height - calcHeight +'px';
                }
              }
            }, 500);
          })
          .catch(function(err){
            console.error(err);
          });
      },

      buildDateArray: function(start, end){
        var result = [];
        var startDate = moment(moment.utc(start)).local();
        var endDate = moment(moment.utc(end)).local();

        var currentDate = new Date();

        while (startDate <= endDate) {
          if (
            moment(startDate).isSame(currentDate, 'day') ||
            moment(startDate).isAfter(currentDate)
          ) {
            result.push(moment(startDate).format('MMMM DD, YYYY'))
          }
          startDate = moment(startDate).add(1, 'd');
        }
        return result;
      },

      buildProgram: function(){
        // Generate stages
        // for ( var i in vm.schedules ){
        //   var schedule = vm.schedules[i];
        //   var schedule = $.extend({}, vm.schedules[j], {
        //     start: moment(moment.utc(vm.schedules[j].start)).local(),
        //     end: moment(moment.utc(vm.schedules[j].end)).local()
        //   });
        //   if ( moment(item).isSame(schedule.start, 'day') ){
        //     if (
        //       vm.locations.indexOf(schedule.location) === -1 && schedule.location
        //     ){
        //       vm.locations.push(schedule.location);
        //     }
        //   }
        // }

        // Generate programs
        // vm.programs
        var programs = vm.dateRange.map(function(item){
          // Programs
          var programs = [];
          for ( var j in vm.schedules ){
            var schedule = $.extend({}, vm.schedules[j], {
              start: moment(moment.utc(vm.schedules[j].start)).local(),
              end: moment(moment.utc(vm.schedules[j].end)).local()
            });
            if ( moment(item).isSame(schedule.start, 'day') ){
              programs.push(schedule);

              if ( vm.locations.indexOf(schedule.location) === -1 && schedule.location ){
                vm.locations.push(schedule.location);
              }
            }
          }

          if ( vm.scheduleModule.groupByLocation ){
            // Day locations
            var dayLocations = [];
            for ( var k in programs ){
              var program = programs[k];
              if ( dayLocations.indexOf(program.location) === -1 ){
                dayLocations.push(program.location);
              }
            }

            // Location schedule
            var locations = [];
            for ( var l in dayLocations ){
              var schedules = [];
              for ( var m in programs ){
                if ( programs[m].location === dayLocations[l] ){
                  schedules.push(programs[m]);
                }
              }
              locations.push({
                name: dayLocations[l],
                schedules: schedules
              });
            }

            return {
              date: item,
              locations: locations
            };
          } else {
            return {
              date: item,
              schedules: programs
            }
          }
        });

        var result = [];

        if ( vm.scheduleModule.groupByLocation ){
          for ( var i in programs ){
            var program = programs[i];
            if ( program.locations && program.locations.length !== 0 ){
              result.push(program);
            }
          }
        } else {
          for ( var i in programs ){
            var program = programs[i];
            if ( program.schedules && program.schedules.length !== 0 ){
              result.push(program);
            }
          }
        }

        return result;
      },

      formatTime: function(date){
        return moment(date).format('hh:mm a');
      },

      isSameDay: function(date){
        var currentDate = new Date();
        return moment(date).isSame(currentDate, 'day');
      },

      handleChangeLocation: function(location){
        $scope.filterLocation = location;
      },

      filterScheduleLocation: function(prog){
        if ( $scope.filterLocation && $scope.filterLocation !== '' ) {
          if ( vm.scheduleModule.groupByLocation ){
            return prog.name === $scope.filterLocation;
          } else {
            return prog.location === $scope.filterLocation
          }
        }
        return prog;
      }
    });

    function slidesToShow(programRange){
      return programRange.length >= 4 ? 4 : programRange.length;
    }

    function slidesToShowResponse(programRange, dec){
      var result = dec;
      if ( slidesToShow(programRange) < 4 ){
        if ( slidesToShow(programRange) === 3 ){
          result = dec;
        }
        if ( slidesToShow(programRange) === 2 ){
          result = dec === 3 ? 2 : dec;
        }
        if ( slidesToShow(programRange) === 1 ){
          result = 1;
        }
      }
      return result;
    }

    function initSlickConfig(programRange){
      return {
        slidesToShow: slidesToShow(programRange),
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: slidesToShowResponse(programRange, 3),
              slidesToScroll: 1
            }
          },{
            breakpoint: 768,
            settings: {
              slidesToShow: slidesToShowResponse(programRange, 2),
              slidesToScroll: 1
            }
          },{
            breakpoint: 540,
            settings: {
              slidesToShow: slidesToShowResponse(programRange, 1),
              slidesToScroll: 1
            }
          }
        ]
      }
    }

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('PublicMapController', PublicMapController);
  
  function PublicMapController(
    $rootScope,
    $scope,
    $stateParams,
    $timeout,
    $uibModal,
    $location,

    Notification,

    MapService,
    CategoryService,
    VendorService,
    SponsorService,
    BoothTypeService,

    Route,
    Booth,

    IndoorRoute,
    IndoorBooth,

    IndoorService,
    OutdoorService,

    ToolsBooth
  ) {
    var vm = this;

    $scope.currentEvent = $rootScope.currentEvent;

    $scope.boothGoods = [];
    $scope.boothTypes = [];

    $scope.boothCategories = [];

    $scope.userNonCommercialAssignments = [];
    $scope.userCommercialAssignments = [];

    // Only for indoor
    $scope.boothID = null;
    $scope.indoorIndoorMaps = [];

    // Indoor booths: only for outdoor map
    $scope.indoorBooths = [];

    angular.extend($scope, {
      showBoothIndoorMaps: false,

      showPosition: false,
      currentPosition: null,
      mapFields: {
        search: '',
        boothCategory: {}
      },
      onInit: function(){
        OutdoorService.resetOutdoorData();
        IndoorService.resetIndoorData();

        CategoryService.getCategories()
          .then(function(response){
            $scope.boothGoods = response.data;

            return BoothTypeService.getBooths();
          })
          .then(function(response){
            var data = response.data;
            $scope.boothTypes = data;

            $scope.fetchRequests();
          })
          .catch(function(err){
            console.error(err);
          });
      },

      getAvailable: false,
      allBooths: [],

      availableFrom: null,
      availableTo: null,

      handleShowAvailable: function(){
        if ( !$scope.getAvailable ){
          $uibModal.open({
            templateUrl: 'app/public-map/available-booth.html',
            controller: 'AvailableBoothsController as vm',
            resolve: {
              resolveEventMapId: function(){
                return $scope.eventMapId;
              },
              resolveAvailable: function(){
                return null;
              }
            }
          }).result.then(
            function(result){
              $scope.getAvailable = true;

              $scope.filterBooths(result);
            },
            function(err){
              console.log(err);
            }
          )
        } else {
          $scope.getAvailable = false;
          for ( var i in $scope.allBooths ){
            $scope.allBooths[i].show();
            $scope.allBooths[i].availableFrom = null;
            $scope.allBooths[i].availableTo = null;
          }
          $scope.booths = $scope.allBooths;
          $scope.allBooths = [];
        }
      },

      handleEditAvailable: function(){
        $uibModal.open({
          templateUrl: 'app/public-map/available-booth.html',
          controller: 'AvailableBoothsController as vm',
          resolve: {
            resolveEventMapId: function(){
              return $scope.eventMapId;
            },
            resolveAvailable: function(){
              return {
                from: $scope.availableFrom,
                to: $scope.availableTo
              }
            }
          }
        }).result.then(
          function(result){
            for ( var i in $scope.allBooths ){
              $scope.allBooths[i].show();
            }
            $scope.booths = $scope.allBooths;
            $scope.allBooths = [];

            // $timeout(function(){
              $scope.filterBooths(result);
              // $scope.$apply();
            // }, 300);
          },
          function(err){
            console.log(err);
          }
        )
      },

      filterBooths: function(result){
        $scope.allBooths = $scope.booths;

        var booths = [];

        for ( var i in $scope.booths ){
          var booth = $scope.booths[i];
          booth.availableFrom = moment(result.availableFrom).format('MM-DD-YYYY');
          booth.availableTo = moment(result.availableTo).format('MM-DD-YYYY');
          if ( result.data.indexOf(booth.id) !== -1 ){
            booth.show();
            booths.push(booth);
          } else {
            booth.hide();
          }
        }

        $scope.availableFrom = result.availableFrom;
        $scope.availableTo = result.availableTo;

        $scope.booths = booths;

        $scope.handleMapSearch({ search: $scope.mapFields.search, boothCategory: $scope.mapFields.boothCategory });
      },

      fetchRequests: function(){

        if ( $scope.currentEvent.status === 'published' ){
          VendorService.getPublishedRequests()
            .then(function(response){
              var data = response.data;
              for ( var i in data ){
                var item = data[i];
                // Commercial Assignments
                var user = item.vendor;
                user['type'] = 'vendor';
                delete item['vendor'];
                $scope.userCommercialAssignments.push($.extend({}, item, {
                  user: user
                }));
                // Non commercial assignments
                setUserNonCommercialAssignments(user);
              }

              // Check if sponsor enabled
              if ( $scope.currentEvent.modules.indexOf('sponsor') > -1 ){
                SponsorService.getPublishedRequests()
                  .then(function(response){
                    var data = response.data;
                    for ( var i in data ){
                      var item = data[i];
                      // Commercial Assignments
                      var user = item.sponsor;
                      user['type'] = 'sponsor';
                      delete item['sponsor'];
                      $scope.userCommercialAssignments.push($.extend({}, item, {
                        user: user
                      }));
                      // Non commercial assignments
                      setUserNonCommercialAssignments(user);
                    }
                    $scope.checkMapID();
                  })
                  .catch(function(err){
                    console.error(err);
                  });
              } else {
                $scope.checkMapID();
              }
            })
            .catch(function(err){
              console.error(err);
            })
        } else {
          $scope.checkMapID();
        }

      },

      checkMapID: function(){
        if ( typeof $stateParams.id !== 'undefined' ){
          $scope.fetchMap(parseInt($stateParams.id, 10));
        } else if ( typeof $stateParams.id === 'undefined' && $scope.currentEvent && $scope.currentEvent.mainEventMapId ){
          $scope.fetchMap($scope.currentEvent.mainEventMapId);
        } else {
          console.error('No map ID present');
        }
      },

      eventMapId: null,

      fetchMap: function(id){
        $scope.eventMapId = id;
        MapService.getMapByID(id)
          .then(function(response){
            var data = response.data;
            if ( data.type === 'outdoor' ){
              // Only for outdoor
              $scope.renderOutdoorMapItems(function(){
                $scope.map = OutdoorService;
                $scope.map.initMap(data, null, 'app.publicMapIndoor');
                $scope.initMapItems(data, $scope.map);

                // $scope.$watch('currentPosition', function(){
                if ( $location.$$path.indexOf('/event-map') !== -1 ){
                  if (
                    $scope.currentPosition &&
                    $scope.currentPosition.coords
                  ) {
                    OutdoorService.showMeOnMapButton($scope.currentPosition);
                  } else {
                    Notification.warning('Reload page and grant access for your location to use option "Show me on map"');
                  }
                }
                // });

              });
            } else if ( data.type === 'indoor' ){
              $scope.renderIndoorMapItems(function(){

                $scope.map = IndoorService;
                $scope.map.initMap(data);
                $scope.initMapItems(data, $scope.map);

              });
            } else {
              console.error('Map type not present');
            }
          })
          .catch(function(err){
            console.error(err);
          })
      },

      // Only for outdoor map
      renderOutdoorMapItems: function(cb){
        // Set navigator if is outdoor map
        $scope.showPosition = true;
        if ( navigator.geolocation ){
          navigator.geolocation.getCurrentPosition(function(position){
            $scope.$apply(function(){
              $scope.currentPosition = position;
            });
          });
        }

        MapService.getMaps(null, 'name,booths', 'indoor')
          .then(function(response){
            var data = response.data;
            $scope.indoorMaps = data;
            if ( data.length ){
              for ( var i in data ){
                if ( data[i].booths && data[i].booths.length ){
                  for ( var j in data[i].booths ){
                    var booth = new IndoorBooth(false, false);
                    booth.read(data[i].booths[j], null, $scope.userCommercialAssignments);
                    $scope.indoorBooths.push($.extend({}, booth, {
                      boothMapID: data[i].id
                    }));
                  }
                }
              }
            }

            cb();
          })
          .catch(function(err){
            console.error('err');
          });
      },

      // Only for indoor map
      renderIndoorMapItems: function(cb){

        if ( typeof $stateParams.boothID !== 'undefined' ){
          $scope.showBoothIndoorMaps = true;
          $scope.boothID = $stateParams.boothID;
          MapService.getBoothById($stateParams.boothID)
            .then(function(response){
              return MapService.getMaps(response.data.indoorMapIds, 'name, id', 'indoor');
            })
            .then(function(response){
              $scope.indoorIndoorMaps = response.data;
              cb();
            })
            .catch(function(err){
              console.error(err);
            });
        } else {
          cb();
        }

      },

      currentIndoorMapName: function(maps){
        return maps.filter(function(item){
          return item.id === parseInt($stateParams.id, 10);
        })[0];
      },

      initMapItems: function(data, map){
        $scope.mapData = data;

        var boothRequests = [];
        var boothRequestAssignments = [];
        var boothGoodsIds = [];

        // Booths
        if ( data.booths && data.booths.length ){
          for ( var i in data.booths ){
            var booth = data.booths[i];
            $scope.drawBooth(data.type, booth, map);

            for ( var j in $scope.boothTypes ){
              var boothType = $scope.boothTypes[j];
              var pref = boothType.preferences;
              if ( booth.boothTypeId === boothType.id ){

                var exist = false;

                if ( $scope.boothCategories.length ){
                  for ( var k in $scope.boothCategories ){
                    var boothCategory = $scope.boothCategories[k];
                    if (
                      boothCategory.name === boothType.type &&
                      boothCategory.value === boothType.id
                    ){
                      exist = true;
                      break;
                    }
                  }
                }
                if (!exist && (!pref || pref['private'] === undefined || (pref && pref.private === false))){
                  $scope.boothCategories.push({
                    type: 'Services',
                    name: boothType.type,
                    value: boothType.id
                  });
                }
              }
            }

            if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
              for ( var j in booth.userCommercialAssignments ){
                var assign = booth.userCommercialAssignments[j];
                var exist = false;
                for ( var k in boothRequestAssignments ){
                  var assignBooth = boothRequestAssignments[k];
                  if ( 
                    assignBooth.eventRequestId === assign.eventRequestId &&
                    assignBooth.userType === assign.userType
                  ){
                    exist = true;
                    break;
                  }
                }
                if ( !exist ){
                  boothRequestAssignments.push(assign);
                }
              }
            }
          }
        }
        // Route
        if ( data.routes && data.routes.length ){
          for ( var i in data.routes ){
            var routeData = data.routes[i];
            var pref = routeData.preferences;
            if ( pref && pref.public ){
              var route = data.type === 'outdoor' ? new Route(true) : new IndoorRoute();
              route.read(routeData);
              map.drawRoute(route);
            }
          }
        }

        for ( var i in $scope.userCommercialAssignments ){
          var exist = false;
          var request = $scope.userCommercialAssignments[i];
          for ( var j in boothRequestAssignments ){
            var requestBooth = boothRequestAssignments[j];
            if (
              request.id === requestBooth.eventRequestId &&
              request.user.type === requestBooth.userType
            ){
              exist = true;
              break;
            }
          }
          if ( exist ){
            boothRequests.push(request);
          }
        }

        for ( var i in boothRequests ){
          var request = boothRequests[i];
          if ( request.goodsCategory ){
            var good = request.goodsCategory;
            var exist = false;
            for ( var j in boothGoodsIds ){
              var goodNext = boothGoodsIds[j];
              if (
                goodNext &&
                goodNext.name.toLowerCase() === good.name.toLowerCase()
              ){
                exist = true;
                break;
              }
            }
            if ( !exist ){
              boothGoodsIds.push(good);
            }
          }
        }

        for ( var i in $scope.boothGoods ){
          var good = $scope.boothGoods[i];
          var exist = false;
          for ( var j in boothGoodsIds ){
            var goodNext = boothGoodsIds[j];
            if (
              goodNext.name.toLowerCase() === good.name.toLowerCase()
            ){
              exist = true;
              break;
            }
          }
          if ( exist ){
            $scope.boothCategories.push({
              type: 'Goods',
              name: good.name,
              value: good.id
            });
          }
        }

        if ( typeof $stateParams.search !== 'undefined' ){
          $scope.mapFields['search'] = $stateParams.search;
          $scope.mapFields['boothCategory'] = {};
          $timeout(function(){
            $scope.handleMapSearch($scope.mapFields);
          }, 300);
        }

        $scope.booths = map.fetchBooths();
        $scope.routes = map.fetchRoutes();

        // Remove it in feature
        window.googleMap = data.type === 'outdoor' ? map.getMap() : null;
        window.booths = $scope.booths;
        window.routes = $scope.routes;
      },

      // Draw booth based on private boothType
      drawBooth: function(mapType, boothData, map){
        var draw = false;

        if ( $scope.boothTypes && $scope.boothTypes.length ){
          for ( var i in $scope.boothTypes ){
            var type = $scope.boothTypes[i];
            var pref = type.preferences;
            if ( boothData.boothTypeId === type.id ){
              if ( pref && pref.private ){
                break;
              } else {
                if ( $scope.currentEvent.status === 'published' ){
                  draw = true;
                  break;
                } else {
                  if ( !type.commercial ){
                    draw = true;
                    break;
                  }
                }
              }
            }
          }
        }

        if ( draw ){
          var booth = mapType === 'outdoor' ? new Booth(false, true) : new IndoorBooth(false, true);
          booth.read(boothData, $scope.boothTypes, $scope.userCommercialAssignments);
          map.drawBooth(booth);
        }
      }
    });

    function setUserNonCommercialAssignments(item){
      var exist = false;
      for ( var i in $scope.userNonCommercialAssignments ){
        var nonCommercial = $scope.userNonCommercialAssignments[i];
        if ( nonCommercial.id === item.id ){
          exist = true;
          break;
        }
      }
      if ( !exist ){
        $scope.userNonCommercialAssignments.push(item);
      }
    }

    $scope.foundBooths = [];
    $scope.foundIndoorBooths = [];
    $scope.indoorQuery = '';

    // Search booths
    $scope.handleMapSearch = function(newVal){
      $scope.foundBooths = [];
      $scope.foundIndoorBooths = [];

      $scope.indoorQuery = '';

      var search = newVal.search;
      var boothCategory = newVal.boothCategory;

      var bounds = $scope.mapData.type === 'outdoor' ? new google.maps.LatLngBounds() : null;

      if (
        search.length === 0 &&
        (
          boothCategory === null || (boothCategory && typeof boothCategory.type === 'undefined')
        )
      ) {
        for ( var i in $scope.booths ){
          $scope.booths[i].show();

          if ( $scope.mapData.type === 'outdoor' ){
            $scope.map.getMap().setCenter($scope.map.getCenter());
            $scope.map.getMap().setZoom($scope.map.getZoom());
          }
        }
      } else {
        for ( var i in $scope.booths ){
          var booth = $scope.booths[i];

          //Filter all booths by booths type
          if ( boothCategory !== null && typeof boothCategory.type !== 'undefined' ){
            if ( boothCategory.type === 'Services' && booth.boothTypeId !== boothCategory.value ){
              booth.hide();
              continue;
            }
            //Filter commercial booths by goods category.
            if ( boothCategory.type === 'Goods' ){
              //Hide non-commercial booths
              if ( booth.boothType.commercial === false ){
                booth.hide();
                continue;
              } else {
                //Hide commercial booths whos assignments don't match choosen goods category
                var matched = false;
                if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length > 0 ){
                  for ( var j in booth.userCommercialAssignments ){
                    var boothAssignment = booth.userCommercialAssignments[j];
                    for ( var k in $scope.userCommercialAssignments ){
                      var request = $scope.userCommercialAssignments[k];
                      if ( request.id === boothAssignment.eventRequestId && request.goodsCategory){
                        //TODO - Serhiy, reimplement to match by goods category id
                        matched = boothCategory.name.toLowerCase() === request.goodsCategory.name.toLowerCase();
                        if ( matched ) break;
                      }
                    }
                    if ( matched ) break;
                  }
                }
                //If not matched then go to next booth
                if ( !matched ){
                  booth.hide();
                  continue;
                }
              }
            }
          }

          //Filter all booths by search keyword
          if ( search && search.length !== 0 ){
            var s = search.toLowerCase();
            //Match by booth name
            var matchSearch = booth.description && booth.description.toLowerCase().indexOf(s) > -1 ;
            //If not matched  and booth is commercial try match by vendor related details
            if ( !matchSearch && booth.boothType && booth.boothType.commercial ){
              if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length > 0 ){
                for ( var j in booth.userCommercialAssignments ){
                  var boothAssignment = booth.userCommercialAssignments[j];
                  for ( var k in $scope.userCommercialAssignments ){
                    var request = $scope.userCommercialAssignments[k];
                    var visibility = request.profileVisibility;
                    if ( request.id === boothAssignment.eventRequestId ){
                      matchSearch = 
                        ( request.description && request.description.toLowerCase().indexOf(s) > -1 ) ||
                        (
                          typeof visibility !== 'undefined' && visibility.length && visibility.indexOf('categories') !== -1 &&
                          request.individualFeaturedItems && request.individualFeaturedItems.toLowerCase().indexOf(s) > -1
                        ) || (
                          typeof visibility !== 'undefined' && visibility.length && visibility.indexOf('name') !== -1 &&
                          request.user.name.toLowerCase().indexOf(s) > -1
                        ) || (
                          typeof visibility !== 'undefined' && visibility.length && visibility.indexOf('company') !== -1 &&
                          request.user.description && request.user.description.toLowerCase().indexOf(s) > -1
                        );
                      if ( matchSearch ) break;
                    }
                  }
                  if (matchSearch){
                    break;
                  }
                }
              }
            }
            //If not matched then go to next booth
            if ( !matchSearch ){
              booth.hide();
              continue;
            }
          }

          booth.show();
          $scope.foundBooths.push(booth);

          // console.log($scope.foundBooths);

          // if ( $scope.mapData.type === 'outdoor' ){
          //   var latLng;
          //   if ( booth.position ){
          //     latLng = new google.maps.LatLng(booth.position.lat(), booth.position.lng());
          //     bounds.extend(latLng);
          //   } else {
          //     if ( booth.coordinates.length ){
          //       for ( var j in booth.coordinates ){
          //         var coord = booth.coordinates[j];
          //         latLng = new google.maps.LatLng(coord.lat, coord.lng);
          //         bounds.extend(latLng);
          //       }
          //     }
          //   }
          // }
        }

        if ( $scope.mapData.type === 'outdoor' && $scope.foundBooths && $scope.foundBooths.length > 0 ){
          var latLng;
          for ( var i in $scope.foundBooths ){
            var booth = $scope.foundBooths[i];
            if ( booth.position && booth.width < 100 ){
              latLng = new google.maps.LatLng(booth.position.lat(), booth.position.lng());
              bounds.extend(latLng);
            } else {
              if ( booth.coordinates && booth.coordinates.length > 0 ){
                for ( var j in booth.coordinates ){
                  var coord = booth.coordinates[j];
                  latLng = new google.maps.LatLng(coord.lat, coord.lng);
                  bounds.extend(latLng);
                }
              }
            }
          }
          $scope.map.getMap().fitBounds(bounds);
        }

        var resultCommercial = commercialSearch($scope.userCommercialAssignments, search, boothCategory);
        var resultNonCommercialIndoor = nonCommercialSearch($scope.indoorBooths, search, boothCategory);
        // Check in indoor maps booths
        if ( $scope.indoorBooths.length ){
          for ( var i in $scope.indoorBooths ){
            var booth = $scope.indoorBooths[i];
            if (
              hasSome(resultCommercial, ToolsBooth.requestsForBooth($scope.userCommercialAssignments, booth)) ||
              resultNonCommercialIndoor.indexOf(booth) !== -1
            ){
              $scope.indoorQuery = search;
              for ( var i in $scope.indoorMaps ){
                var indoor = $scope.indoorMaps[i];
                if ( booth.boothMapID === indoor.id ){
                  if ( $scope.foundIndoorBooths.indexOf(indoor) === -1 ){
                    $scope.foundIndoorBooths.push(indoor);
                  }
                }
              }
            }
          }
        }
      }
    }

    function hasSome(filtered, requests){
      var result = false;
      if (
        filtered && filtered.length &&
        requests && requests.length
      ){
        for ( var i in requests ){
          var request = requests[i];
          if ( filtered.indexOf(request) !== -1 ){
            result = true;
          }
        }
      }
      return result;
    }

    // NonCommercial
    function nonCommercialSearch(booths, search, type){
      var result = [];
      if ( search.length !== 0 || (type !== null && typeof type.type !== 'undefined') ){
        var s = search.toLowerCase();
        for ( var i in booths ){
          var booth = booths[i];
          var matchSearch = !s || (
            ( booth.description && booth.description.toLowerCase().indexOf(s) > -1 )
          );
          var matchType = (!type || typeof type.type === 'undefined') || (
            ( type.type === 'Services' && booth.boothTypeId === type.value )
          );
          if ( matchSearch && matchType ){
            result.push(booth);
          }
        }
        return result;
      }
      return result;
    }
    // Commercial
    function commercialSearch(requests, search, type){
      var result = [];
      if ( search.length !== 0 || (type !== null && typeof type.type !== 'undefined') ){
        var s = search.toLowerCase();
        for ( var i in requests ){
          var request = requests[i];
          var matchSearch = s === '' || (
            ( request.description && request.description.toLowerCase().indexOf(s) > -1 ) ||
            ( request.individualFeaturedItems && request.individualFeaturedItems.toLowerCase().indexOf(s) > -1 ) ||
            ( request.user.name.toLowerCase().indexOf(s) > -1 ) ||
            ( request.user.description && request.user.description.toLowerCase().indexOf(s) > -1 )
          );
          var matchType = (!type || typeof type.type === 'undefined') || (
            type.type === 'Goods' && request.goodsCategory &&
            type.name.toLowerCase() === request.goodsCategory.name.toLowerCase()
          );
          if ( matchSearch && matchType ) {
            result.push(request);
          }
        }
        return result;
      }
      return result;
    }
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('AvailableBoothsController', AvailableBoothsController);
  
  AvailableBoothsController.$inject = ['$scope', '$uibModalInstance', 'moment', 'MapService', 'resolveEventMapId', 'resolveAvailable'];

  function AvailableBoothsController(
    $scope,
    $uibModalInstance,
    moment,
    MapService,
    resolveEventMapId,
    resolveAvailable
  ) {
    var vm = this;
    $scope.formLoading = false;

    angular.extend($scope, {
      datepickerFormat: 'MMMM dd, yyyy',
      datepickerOptions: {
        dateDisabled: false,
        minDate: new Date(),
        formatYear: 'yy',
        startingDay: 1
      },
      popup1: {
        opened: false
      },
      popup2: {
        opened: false
      },
      onPopup1Open: function(){
        $scope.popup1.opened = true;
      },
      onPopup2Open: function(){
        $scope.popup2.opened = true;
      },
      onInit: function(){
        if ( resolveAvailable && resolveAvailable.from && resolveAvailable.to ){
          vm.availableFromDate = moment(resolveAvailable.from).toDate();
          vm.availableFrom = moment(resolveAvailable.from).toDate();
          vm.availableToDate = moment(resolveAvailable.to).toDate();
          vm.availableTo = moment(resolveAvailable.to).toDate();
        }
      },

      handleSubmit: function(){
        var date = new Date();
        var form = $scope.form;

        if ( form.$valid ){
          $scope.formLoading = true;

          var availableFrom = moment(vm.availableFromDate).set({
            hour: moment(vm.availableFromDate).isSame(date, 'day') ? moment(date).hour() : 0,
            minute: moment(vm.availableFromDate).isSame(date, 'day') ? moment(date).minute() : 0,
            second: moment(vm.availableFromDate).isSame(date, 'day') ? moment(date).second() : 0
          }).utc().format('YYYY-MM-DDTHH:mm:ss.000Z');

          var availableTo = moment(vm.availableToDate).set({
            hour: 23,
            minute: 59,
            second: 59
          }).utc().format('YYYY-MM-DDTHH:mm:ss.000Z');

          MapService.getBoothIdsWithAvailableReservations(
            resolveEventMapId,
            availableFrom,
            availableTo
          )
            .then(function(response){
              $uibModalInstance.close({
                data: response.data,
                availableFrom: moment(vm.availableFrom).local(),
                availableTo: moment(vm.availableTo).local()
              });
            })
            .catch(function(err){
              $scope.formLoading = false;
              console.log(err);
            });

        }
      },

      handleCancel: function(){
        $uibModalInstance.dismiss('cancel');
      }
    });
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('PayeezyFormController', PayeezyFormController);

  function PayeezyFormController(
    $scope,
    $document,
    $timeout,
    $uibModalInstance,
    Notification,
    TransactionService,
    dataPay,
    dataResult,
    itemType
  ) {
    $scope.isLoading = false

    var receiver = null;
    var btn = null;
    var fdc = new PaymentJS(dataPay.apiKey, dataPay.jsSecurityKey, dataPay.transarmorToken, 'FDToken');
    fdc.dsg();

    $scope.onInit = function(){
      receiver = $document[0].getElementById('myFrame').contentWindow;
      btn = $document[0].getElementById('submitForm');

      btn.addEventListener('click', function(e){
        e.preventDefault();

        $scope.isLoading = true;
        $scope.$apply();

        var fe = $document[0].getElementById('order_form').elements;
        var n = fe.name.value;
        var c = fe.cardNumber.value;
        var x = fe.expirationDateMM.value + fe.expirationDateYY.value;
        var v = fe.cvv.value;

        var msg = {'name':n, 'cc': c.trim().replace(/ /g, ''), 'exp_date':x, 'cvv':v};

        var endpointURL = new URL(dataPay.paymentJSUrl);
        receiver.postMessage(msg, 'https://' + endpointURL.host);
      });
    }

    $scope.handleCancel = function(){
      $uibModalInstance.dismiss('Close');
    }

    var token;
    function receiveMessage(evt){
      if ( evt.data !== '' ) token = evt.data;

      if ( $scope.isJSON(token) ){
        var data = JSON.parse(token);
        var results = data.results;
        if ( results.status === 'failed' ){
          if ( results.Error.messages ){
            for ( var i in results.Error.messages ){
              var msg = results.Error.messages[i];
              Notification.error(msg.description);
            }
          }
          $timeout(function(){
            $scope.isLoading = false;
            $scope.$apply();
          }, 500);
        }
        if ( results.status === 'success' ){
          var paymentData = {
            amount: dataResult.amount,
            eventRequestId: dataResult.id,
            itemType: itemType,
            service: 'payeezy',
            payeezy:{
              cardToken: {
                value: results.token.value,
                name: results.token.cardholder_name,
                type: results.token.type,
                expireDate: results.token.exp_date,
              }
            }
          };
          TransactionService.paymentTransaction(paymentData)
            .then(
              function(){
                window.removeEventListener('message', receiveMessage, false);

                $scope.isLoading = false;
                $uibModalInstance.close();
              },
              function(err){
                $scope.isLoading = false;
                Notification.error(err.data.message);
                $scope.$apply();
              }
            );
        }
      }
    }

    window.addEventListener('message', receiveMessage, false);

    $scope.isJSON = function(query){
      try {
        JSON.parse(query);
      } catch(e) {
        return false;
      }
      return true;
    }

    // Modal closing
    $scope.$on('modal.closing', function(event, reason, closed){
      if ( $scope.isLoading ){
        event.preventDefault();
      } else {
        window.removeEventListener('message', receiveMessage, false);
      }
    });
  }

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('IWBoothContent', IWBoothContent);

  function IWBoothContent($rootScope, $timeout, $state, $uibModal, moment, COUNTRY_PHONES){
    var directionIcons = [
      {label: 'By Car', icon: 'fa fa-car', mode: 'driving'},
      {label: 'Bike', icon: 'fa fa-bicycle', mode: 'bicycling'},
      {label: 'Walking', icon: 'fa fa-male', mode: 'walking'}
    ];

    return {
      renderInfoWindowContent: function(booth, indoorMaps, url){
        var div = document.createElement('div');
        div.className = 'infowindow-content';

        var requests = [];

        if ( booth.photos.length ){
          div.appendChild(this.buildPhotos(booth));
        }

        if ( booth.userCommercialAssignments && booth.userCommercialAssignments.length ){
          for ( var i in booth.userCommercialAssignments ){
            var assign = booth.userCommercialAssignments[i];
            if ( booth.requests && booth.requests.length ){
              for ( var j in booth.requests ){
                var request = booth.requests[j];
                if ( request.id === assign.eventRequestId && request.user.type === assign.userType ){
                  requests.push({
                    request: request,
                    from: assign.from ? assign.from : $rootScope.currentEvent.start,
                    to: assign.to ? assign.to : $rootScope.currentEvent.end 
                  });
                }
              }
            }
          }

          var sortedRequests = requests.sort(function(a, b){
            return moment(a.from).format('X') - moment(b.from).format('X')
          });
          if ( sortedRequests && sortedRequests.length ){
            var divCarousel = document.createElement('div');
            divCarousel.className = 'infowindow-carousel';
            for ( var k in sortedRequests ){
              var request = sortedRequests[k];
              var divCarouselItem = document.createElement('div');
              divCarouselItem.className = 'infowindow-carousel-item';
              divCarouselItem.appendChild(this.buildVendorRequestContent(request.request));
              if ( request.from && request.to ){
                if ( isSameDay(request.from, request.to) ){
                  divCarouselItem.appendChild(createElement('p', 'infowindow-date-range', dateFormated(request.from) +' - '+ timeFormated(request.to)));
                } else {
                  divCarouselItem.appendChild(createElement('p', 'infowindow-date-range', dateFormated(request.from) +' - '+ dateFormated(request.to)));
                }
              }
              divCarousel.appendChild(divCarouselItem);
            }
            div.appendChild(divCarousel);
            $timeout(function(){
              $('.infowindow-carousel').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>'
              });
            }, 250);
          }
        }

        if ( booth.description ){
          div.appendChild(createElement('span', 'infowindow-description', booth.description));
        }

        if (
          (!$rootScope.currentUser || ($rootScope.currentUser && $rootScope.currentUser.type === 'participant')) &&
          ($rootScope.currentEvent.modules.indexOf('reservations') > -1) &&
          booth.boothReservation
        ) {
          var divReservation = document.createElement('div');
          divReservation.style.marginTop = '8px';
          var aReservation = document.createElement('a');
          aReservation.className = 'btn btn-primary btn-sm';
          aReservation.text = 'Reservation';
          var boothName = '';
          if ( !booth.description || booth.description.length === 0 ){
            boothName = 'No-Booth-Name';
          } else {
            boothName = booth.description.replace(' ', '_');
          }
          var param = {
            boothID: booth.id, boothName: boothName
          }
          if ( booth.availableFrom && booth.availableTo ){
            param['availableFrom'] = booth.availableFrom;
            param['availableTo'] = booth.availableTo;
          }
          aReservation.href = $state.href('app.reservation_manager', param);
          divReservation.appendChild(aReservation);
          div.appendChild(divReservation);
        }

        if ( indoorMaps && indoorMaps.length ){
          div.appendChild(this.buildIndoorMapLinks(booth, indoorMaps, url));
        }
        if (
          booth.coordinates ||
          (booth.position && booth.position.lat && booth.position.lng) ){
          div.appendChild(this.buildDirectionIcons(booth));
        }

        return div;
      },

      buildVendorRequestContent: function(request){
        var user = request.user;
        var visibility = request.profileVisibility;
        var div = document.createElement('div');
        div.className ='infowindow-request-content';

        // if ( user && user.photoLink ){
        //   var divImg = document.createElement('div');
        //   divImg.className = '_image';
        //   var img = document.createElement('img');
        //   img.src = user.photoLink;
        //   img.style.maxWidth = '50%';
        //   divImg.appendChild(img)
        //   div.appendChild(divImg);
        // }

        if ( typeof visibility !== 'undefined' ){
          var showName = visibility.indexOf('name') !== -1 ? true : false;
          var showCompany = visibility.indexOf('company') !== -1 ? true : false;
          var showCategories = visibility.indexOf('categories') !== -1 ? true : false;
          var showLocation = visibility.indexOf('location') !== -1 ? true : false;
          var showContacts = visibility.indexOf('contact') !== -1 ? true : false;
          if (
            typeof request.profileVisibility === 'undefined' ||
            (
              typeof request.profileVisibility !== 'undefined' &&
              request.profileVisibility.length
            )
          ) {
            if ( showCompany ){
              if ( user && user.company ){
                div.appendChild(createElement('b', '_company f16', user.company));
              }
            }
            if ( showName ){
              if ( user && user.name ){
                div.appendChild(createElement('h3', '_name', user.name));
              }
            }
            if ( showCompany ){
              if ( user && user.description ){
                div.appendChild(createElement('span', '_description', user.description));
              }
            }
            if ( showCategories && request.goodsCategory ){
              var goods = request.goodsCategory
              if ( goods.description ){
                div.appendChild(createElement('span', '_description', goods.description));
              }
              if ( request.individualFeaturedItems ){
                div.appendChild(createElement('span', '_featuredItems', request.individualFeaturedItems));
              }
            }
            if ( showLocation && ( user && (user.address || user.city || user.state || user.zipCode) ) ){
              var location = createElement('div', '_address');
              if ( user && user.address ){
                location.appendChild(createElement('span', null, user.address));
              }
              if ( user && user.city ){
                location.appendChild(createElement('span', null, ', '+ user.city));
              }
              if ( user && user.state ){
                location.appendChild(createElement('span', null, ', '+ user.state));
              }
              if ( user && user.zipCode ){
                location.appendChild(createElement('span', null, ', '+ user.zipCode));
              }
              div.appendChild(location);
            }
            if ( showContacts ){
              var contacts = createElement('div', '_contacts');
              if ( user && user.email ){
                var uEmail = createElement('div', null, null);
                var uEmailLabel = createElement('b', null, 'E-mail: ');
                var uEmailValue = createElement('a', null, user.email);
                uEmailValue.href = 'mailto:'+ user.email;
                uEmail.appendChild(uEmailLabel);
                uEmail.appendChild(uEmailValue);
                contacts.appendChild(uEmail);
              }
              if ( user && user.phone1 && user.phone1.number ){
                var uPhone = createElement('div', null, null);
                var uPhoneLabel = createElement('b', null, user.phone1.type +': ');
                var uPhoneValue = createElement('span', null, formatPhoneNumber(user.phone1.number));
                uPhone.appendChild(uPhoneLabel);
                uPhone.appendChild(uPhoneValue);
                contacts.appendChild(uPhone);
              }
              if ( user && user.phone2 && user.phone2.number ){
                var uPhone = createElement('div', null, null);
                var uPhoneLabel = createElement('b', null, user.phone2.type +': ');
                var uPhoneValue = createElement('span', null, formatPhoneNumber(user.phone2.number));
                uPhone.appendChild(uPhoneLabel);
                uPhone.appendChild(uPhoneValue);
                contacts.appendChild(uPhone);
              }
              div.appendChild(contacts);
            }
          }
        }
        return div;
      },
      // Photos
      buildPhotos: function(booth){
        var photos = booth.photos;
        var ul = document.createElement('ul');
        ul.className = 'list-booth-photos';
        if ( photos.length === 1 ) ul.className += ' _single';
        if ( photos.length === 2 ) ul.className += ' _double';
        for ( var i in photos ){
          var photo = photos[i];
          var li = document.createElement('li');
          var img = document.createElement('img');
          img.src = photo.type === 'image' ? photo.link : 'assets/images/360-icon.png';

          if ( photo.type === 'image_360' ){
            // var view = document.createElement('button');
            // view.className = 'btn btn-default btn-sm';
            // view.innerHTML = '<i class="fa fa-eye" style="pointer-events: none;" aria-hidden="true"></i>';
            img.className = '_image360';
            img.attrPhoto = JSON.stringify(photo);
            img.onclick = function(evt){
              var attr = evt.target.attrPhoto;
              var p = JSON.parse(attr);
              if ( p && p.id && p.type === 'image_360' ){
                $uibModal.open({
                  templateUrl: 'app/users/organizer/event/media-gallery/360-modal.html',
                  controller: 'MediaGallery360Controller as vm',
                  backdrop: 'static',
                  resolve: {
                    resolveMedia: function(){
                      return p;
                    }
                  }
                });
              }
            }
            // li.appendChild(view);
          }

          li.appendChild(img);
          ul.appendChild(li);
        }
        return ul;
      },
      // Indoor map links
      buildIndoorMapLinks: function(booth, indoorMaps, url){
        var ul = document.createElement('ul');
        ul.className = 'list-indoorMapLinks';
        var liHead = document.createElement('li');
        liHead.className = '_head';
        liHead.innerText = 'Indoor map(s):'
        ul.appendChild(liHead);
        for ( var i in indoorMaps ){
          var map = indoorMaps[i];
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.innerText = map.name;
          a.href = $state.href(url, {id: map.id, boothID: booth.id});
          li.appendChild(a);
          ul.appendChild(li);
        }
        return ul;
      },
      // Direction links
      buildDirectionIcons: function(booth){
        var coord = null;
        if ( booth && booth.routeCoordinates ) {
          coord = '';
          for ( var i = 0; i < booth.routeCoordinates.length; i++ ) {
            var latlng = booth.routeCoordinates[i];
            if ( i === 0 ) {
              coord += '&waypoints='+ latlng.lat +','+ latlng.lng;
            } else if ( (i+1) === booth.routeCoordinates.length ) {
              coord += '&destination='+ latlng.lat +','+ latlng.lng;
            } else {
              coord += '|'+ latlng.lat +','+ latlng.lng;
            }
          }
        } else {
          if ( booth.position ){
            coord = '&destination='+ booth.position.lat() +','+ booth.position.lng();
          }
          if ( booth.coordinates ){
            coord = '&destination='+ booth.coordinates[0].lat +','+ booth.coordinates[0].lng;
          }
        }

        // Create elements
        var ul = document.createElement('ul');
        ul.className = 'list-directionIcons';

        for ( var i in directionIcons ){
          var item = directionIcons[i];

          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = 'https://www.google.com/maps/dir/?api=1&origin=Current+Location'+ coord +'&travelmode='+ item.mode;
          a.target = '_blank';
          var span = document.createElement('span');
          span.innerText = item.label;
          var icon = document.createElement('i');
          icon.className = item.icon;
          icon.setAttribute('aria-hidden', 'true');

          // Inser
          a.appendChild(icon);
          a.appendChild(span);
          li.appendChild(a);
          ul.appendChild(li);
        }
        return ul;
      }
    }

    function createElement(type, classes, text){
      var elem = document.createElement(type);
      if ( classes ) elem.className = classes;
      if ( text ) elem.innerText = text;
      return elem;
    }

    function dateFormated(date){
      return moment(moment.utc(date)).local().format('MMMM DD, YYYY hh:mm a');
    }

    function timeFormated(date){
      return moment(moment.utc(date)).local().format('hh:mm a');
    }

    function isSameDay(start, end){
      return moment(start).isSame(end, 'day');
    }

    function formatPhoneNumber(value) {
      var country = COUNTRY_PHONES.find(function(item){
        return item.code === value.substring(0, value.length - 10);
      });
      var i = 0;
      var phone = value.toString();
      return country.pattern.replace(/#/g, function (_) {
        return phone[i++];
      });
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .factory('GenerateUUID', GenerateUUID);

  function GenerateUUID(){
    return {
      uuid: function(){
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });
        return uuid;
      },
      replaceDuplicateID: function(inputArray){
        var self = this;

        var hasDuplicate = false;
        var testObj = {};

        var outputArray = inputArray.map(function(item) {
          var prop = item['id'];
          if (prop in testObj) {
            testObj[prop].duplicate = true;
            item.duplicate = true;
            hasDuplicate = true;
          } else {
            testObj[prop] = item;
            delete item.duplicate;
          }
          if ( hasDuplicate ){
            item.id = self.uuid();
          }
          return item;
        });

        return outputArray;
      }
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('HomeController', HomeController);

  HomeController.$inject = [
    '$rootScope',
    '$scope',
    '$stateParams',
    'Notification',
    'moment',
    'EventService',
    'SponsorService',
    'PageService'
  ];

  function HomeController(
    $rootScope,
    $scope,
    $stateParams,
    Notification,
    moment,
    __event,
    __sponsor,
    PageService
  ) {
    var vm = this;
    vm.sponsorsHeadline = [];
    vm.sponsorsSecondary = [];

    vm.isSameDate = false;

    // View constructor
    $scope.donationSuccess = (typeof $stateParams.donationSuccess !== 'undefined' && $stateParams.donationSuccess === 'true' ? true : false);
    $scope.showConstructorResult = (typeof $stateParams.showConstructorResult !== 'undefined' && $stateParams.showConstructorResult === 'show' ? $stateParams.showConstructorResult : null);
    $scope.staticHtmlContent = '<!-- Html -->';
    $scope.staticCssContent = '/* Css */';
    // $scope.staticJsContent = '// Javascript';
    $scope.staticPages = [
      { tag: 'staticHtml', content: 'staticHtmlContent' },
      { tag: 'staticCss', content: 'staticCssContent' },
      // { id: 'staticJs', content: 'staticJsContent' },
    ];

    angular.extend($scope, {
      slickConfig: {
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },{
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },{
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      }
    });

    angular.extend($scope, {
      onInit: function() {

        vm.event = $rootScope.currentEvent;
        vm.billingPreferences = vm.event.billingPreferences;
        vm.preferences = vm.event.preferences;
        vm.vendorModule = vm.preferences.vendorModule;
        vm.sponsorModule = vm.preferences.sponsorModule;
        vm.scheduleModule = vm.preferences.scheduleModule;
        vm.homePageButtonsModule = vm.preferences.homePageButtonsModule;

        vm.showCustomHomePage = vm.preferences.showCustomHomePage;

        if ( $scope.donationSuccess ){
          Notification.success('Donation was added');
        }

        if ( $scope.showConstructorResult || vm.showCustomHomePage ){
          angular.forEach($scope.staticPages, function(item){
            PageService.getPageByTag('fixed', item.tag)
              .then(function(response){
                var data = response.data;
                if ( data && data.content ) $scope[item.content] = data.content;
              })
              .catch(function(err){
                console.error(err);
              });
          })
        } else {

          vm.eventStartDate = moment(moment.utc(vm.event.start)).local().format('MMMM DD, YYYY');
          vm.eventStartTime = moment(moment.utc(vm.event.start)).local().format('hh:mm a');
          vm.eventEndDate = moment(moment.utc(vm.event.end)).local().format('MMMM DD, YYYY');
          vm.eventEndTime = moment(moment.utc(vm.event.end)).local().format('hh:mm a');

          if ( moment(vm.eventStartDate).isSame(vm.eventEndDate, 'day') ){
            vm.isSameDate = true;
          }

          vm.countdownDate = moment(moment.utc(vm.event.start)).local().format('MMMM DD, YYYY hh:mm a');

          __sponsor.getSponsors('landingPage', true, true)
            .then(
              function(response){
                var arrays = [];
                angular.forEach(response.data, function(sponsor){
                  if ( sponsor.headline ) {
                    vm.sponsorsHeadline.push(sponsor);
                  } else {
                    arrays.push(sponsor);
                  }
                });

                for ( var i = 0; i < arrays.length; i += 2 ) {
                  if ( arrays.length > 8 ){
                    vm.sponsorsSecondary.push(arrays.slice(i, i + 2));
                  } else {
                    vm.sponsorsSecondary = arrays;
                  }
                }

              },
              $scope.handleError
            );

        }
      },

      handleError: function(err){
      }
    });

    moment.createFromInputFallback = function(config) { config._d = new Date(config._i); };
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('EventVendorController', EventVendorController);
  
  EventVendorController.$inject = [
    '$scope',
    'VendorService'
  ];
  
  function EventVendorController(
    $scope,
    __vendor
  ) {
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
        __vendor.getPublishedRequests()
          .then(
            function(response){
              vm.requests = response.data;
            },
            $scope.handleError
          );
      },
      handleError: function(err) {
      }
    });

    vm.blockVisibility = function(options, type){
      return options === undefined || options.indexOf(type) > -1;
    }

    vm.lightOrDark = function(a){
      var r,b,g,hsp;
      if (a.match(/^rgb/)) {
        a = a.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = a[1];
        g = a[2];
        b = a[3];
      } else {
        a = +('0x' + a.slice(1).replace(a.length < 5 && /./g, '$&$&'));
        r = a >> 16;
        g = a >> 8 & 255;
        b = a & 255;
      }
      hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
      if (hsp > 127.5) {
        return 'light';
      } else {
        return 'dark';
      }
    }
  }

})();

(function(){
  'use strict';

  angular.module('eventmap')
         .controller('DonationsPageController', DonationsPageController)
  
  function DonationsPageController(
    $scope,
    $uibModal
  ){
    var vm = this;

    angular.extend($scope, {
      onInit: function(){
        $uibModal.open({
          templateUrl: 'app/donations-form/donations-form.html',
          controller: 'DonationFormController',
          controllerAs: 'vm',
          backdrop: 'static',
          resolve: {
            relocate: function(){
              return true;
            }
          }
        });
      }
    })
  }
})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('DonationFormController', DonationFormController);

  function DonationFormController(
    $rootScope,
    $scope,
    $state,
    $uibModal,
    $uibModalInstance,
    Notification,
    DonationsService,
    PaymentService,
    relocate
  ) {
    var vm = this;

    $scope.formSubmitted = false;
    $scope.formLoading = false;

    vm.donation = {
      name: '',
      email: '',
      phone: {
        type: 'work',
        number: ''
      }
    }

    angular.extend($scope, {
      onInit: function(){
        vm.event = $rootScope.currentEvent;
        vm.currentUser = $rootScope.currentUser;
        vm.homePageButtonsModule = vm.event.preferences.homePageButtonsModule;

        if ( vm.currentUser ){
          if (vm.currentUser.type !== 'eo' && vm.currentUser.type !== 'eventCoordinator'){
            vm.donation['name'] = vm.currentUser.name;
            vm.donation['email'] = vm.currentUser.email;
          } else {
            vm.donation['payCash'] = true;
          }
        }
      },

      confirmPayCash: function(donation){
        return $uibModal.open({
          size: 'md',
          template: '\
            <div class="modal-header">\
              <h4 class="modal-title text-danger" style="text-align: center;">\
                Please confirm you are donating <b>{{donation.amount}}</b> USD\
              </h4>\
            </div>\
            <div class="modal-footer">\
              <button class="btn btn-primary" type="button" ng-click="handleConfirm()" ng-disabled="loading">\
                <i ng-if="loading" class="fa fa-spinner fa-spin" style="margin-right: 8px;"></i>Confirm\
              </button>\
              <button class="btn btn-default" type="button" ng-click="handleCancel()">Cancel</button>\
            </div>\
          ',
          controller: function($scope, $uibModalInstance, $$donation){
            $scope.donation = $$donation;
            $scope.handleConfirm = function(){
              $uibModalInstance.close();
            }
            $scope.handleCancel = function(){
              $uibModalInstance.dismiss('cancel');
            }
          },
          resolve: {
            $$donation: function(){
              return donation;
            }
          }
        });
      },

      handleSubmit: function(){
        $scope.formSubmitted = true;
        var form = $scope.form;
        var data = new Object();
        if ( form.$valid ) {
          $scope.formLoading = true;
          data['name'] = vm.donation.name;
          data['email'] = vm.donation.email;
          data['amount'] = vm.donation.amount;
          if ( vm.donation.phone.number && vm.donation.phone.number !== ''){
            data['phone'] = {
              type: vm.donation.phone.type,
              number: vm.donation.phone.number
            };
          }
          if ( vm.donation.payCash === true ) data['payCash'] = true;
          if ( data.payCash ){
            var modal = $scope.confirmPayCash(data);
            modal.result
              .then(
                function(){
                  $scope.handleDonationService(data)
                },
                function(err) {
                  $scope.formLoading = false;
                }
              );
          } else {
            $scope.handleDonationService(data);
          }
        }
      },

      handleDonationService: function(donation){
        DonationsService.addDonation(donation)
          .then(
            function(response){
              var data = response.data;
              var itemType = 'edr';
              if ( !vm.currentUser || (vm.currentUser && vm.currentUser.type !== 'eo' )){
                if ( vm.event.billingPreferences ) {
                  var pref = vm.event.billingPreferences;
                  if ( pref.serviceType == 'transactionexpress' ){
                    PaymentService.transactionForm({
                      hostedKey: pref.hostedKey,
                      gatewayId: pref.gatewayId,
                      hostedPageUrl: pref.hostedPageUrl,
                      priceValue: data.amount,
                      callback: '?donationSuccess=true'
                    }, data, itemType);
                  } else if ( pref.serviceType === 'paypal' ){
                    PaymentService.paypalForm({
                      paypalMerchantId: pref.merchantId,
                      paypalCallback: '?donationSuccess=true',
                      paypalMode: pref.mode,
                      paypalButtonType: 'donate'
                    }, data, itemType);
                  } else if ( pref.serviceType === 'stripe' ){
                    PaymentService.stripeForm({publishableKey: pref.publishableKey}, data, itemType,
                      function(){
                        $uibModalInstance.dismiss();
                        Notification.success('Donation was added');
                        if ( typeof relocate !== 'undefined' && relocate === true ){
                          $scope.path = '';
                          $state.go('app.home');
                        }
                        $scope.formLoading = false;
                      },
                      function(err){
                        Notification.error(err.data.message);
                        $scope.formLoading = false;
                      },
                      function(){
                        $scope.formLoading = false;
                        $scope.$apply();
                      }
                    );
                  } else if ( pref.serviceType === 'squareup' ){
                    $scope.formLoading = false;
                    var modal = $uibModal.open({
                      templateUrl: 'app/squareup-form/squareup-form.html',
                      controller: 'SquareupFormController',
                      controllerAs: 'vm',
                      size: 'sm',
                      resolve: {
                        dataPay: function(){
                          return {
                            applicationId: pref.applicationId,
                            locationId: pref.locationId
                          };
                        },
                        dataResult: function(){
                          return data;
                        },
                        itemType: function(){
                          return itemType;
                        }
                      }
                    });
                    modal.result
                      .then(
                        function(resolve){
                          Notification.success('Donation was added');
                          if ( typeof relocate !== 'undefined' && relocate === true ){
                            $scope.path = '';
                            $state.go('app.home');
                          }
                          $uibModalInstance.close();
                        },
                        function(){
                        }
                      );
                  } else if ( pref.serviceType === 'payeezy' ){
                    $scope.formLoading = false;
                    var modal = $uibModal.open({
                      templateUrl: 'app/payeezy-form/payeezy-form.html',
                      controller: 'PayeezyFormController',
                      controllerAs: 'vm',
                      size: 'sm',
                      resolve: {
                        dataPay: function(){
                          return pref;
                        },
                        dataResult: function(){
                          return data;
                        },
                        itemType: function(){
                          return itemType;
                        }
                      }
                    });
                    modal.result
                      .then(
                        function(resolve){
                          Notification.success('Donation was added');
                          if ( typeof relocate !== 'undefined' && relocate === true ){
                            $scope.path = '';
                            $state.go('app.home');
                          }
                          $uibModalInstance.close();
                        },
                        function(){
                        }
                      );
                  }
                } else {
                  Notification.error('No billing preferences');
                  if ( typeof relocate !== 'undefined' && relocate === true ){
                    $scope.path = '';
                    $state.go('app.home');
                  }
                  $uibModalInstance.dismiss();
                }
              } else {
                Notification.success('Donation was added');
                if ( typeof relocate !== 'undefined' && relocate === true ){
                  $scope.path = '';
                  $state.go('app.home');
                }
                $uibModalInstance.close(data);
              }
            },
            function(err) {
              $scope.formLoading = false;
            }
          );
      },

      handleClose: function(){
        if ( typeof relocate !== 'undefined' && relocate === true ){
          $scope.path = '';
          $state.go('app.home');
        }
        $uibModalInstance.dismiss('cancel');
      }
    });

  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .directive('onFileChanged', function(){
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var onChangeHandler = scope.$eval(attrs.onFileChanged);
          element.on('change', onChangeHandler);
          element.on('$destroy', function() {
            element.off();
          });
        }
      };
    });

})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .directive('mapCalculate', MapCalculate);

  MapCalculate.$inject = [
    '$rootScope',
    '$window',
    '$location'
  ];

  function MapCalculate(
    $rootScope,
    $window,
    $location
  ){
    return {
      restrict: 'A',
      scope: {
        mapCalculateSpace: '@'
      },
      link: function(scope, element, attrs){
        var windowHeight = $window.innerHeight;
        var windowWidth = $window.innerWidth;

        var path = $location.$$path;
        var publicFrame = path.indexOf('/frame-public-map') !== -1;
        if ( publicFrame ){
          document.body.className += ' frame-body';
        }

        element[0].style.height = calculateHeight(windowWidth, windowHeight, scope, publicFrame, $rootScope.currentEvent);

        angular.element($window).bind('resize', function(){
          var windowResizeHeight = $window.innerHeight;
          var windowResizeWidth = $window.innerWidth;

          element[0].style.height = calculateHeight(windowResizeWidth, windowResizeHeight, scope, publicFrame, $rootScope.currentEvent );

          scope.$digest();
        });
      }
    }
  }

  function calculateHeight(width, height, scope, publicFrame, evt) {
    var headerHeight = 60;
    var footerHeight = publicFrame ? -42 : 49;
    var areaPadding = 16;
    var contentPadding = 32;
    var navHeight = 56;

    var total = headerHeight + areaPadding + contentPadding + navHeight;

    if ( scope && scope.mapCalculateSpace ) {
      total -= parseInt(scope.mapCalculateSpace);
    }

    if ( isDesktopScreenSize(width) ) {
      total += footerHeight;
    } else {
      total -= 56;
    }

    if ( !evt.preferences.enableReservationAvailability ){
      total -= 44;
    }

    return height - total + 'px';
  }

  function isDesktopScreenSize(width) {
    var result = false;
    var breakpoint = 992
    if ( width >= breakpoint ) {
      result = true;
    }
    return result;
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .directive('fileModel', FileModel);

  FileModel.$inject = ['$parse', '$timeout'];

  function FileModel(
    $parse,
    $timeout
  ) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;
        element.bind('change', function(){
          scope.$apply(function(){
            modelSetter(scope, element[0].files[0]);
          });
          var fileReader = new FileReader();
          fileReader.readAsDataURL(element[0].files[0]);
          fileReader.onload = function(e) {
            $timeout(function(){
              scope.photoPreview = e.target.result;
            });
          }
        });
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .controller('ContentPageController', ContentPageController);

  function ContentPageController(
    $scope,
    $stateParams,
    PageService
  ) {
    var vm = this;
    $scope.contentPage = null;

    $scope.errMessage = null;

    angular.extend($scope, {
      onInit: function() {

        if ( typeof $stateParams.tag !== 'undefined' ){
          PageService.getPageByTag('dynamic', $stateParams.tag)
            .then(function(response){
              $scope.contentPage = response.data;
            })
            .catch(function(err){
              console.error(err);
              $scope.errMessage = err.data.message;
            });
        } else {
          console.error('Tag not present in url')
        }

      }
    });

  }

})();

(function(){
  'use strict';

  angular
    .module('eventmap')
    .controller('AuthController', AuthController);

  AuthController.$inject = [
    '$rootScope',
    '$scope',
    'EventService',
    'SponsorService'
  ];

  function AuthController(
    $rootScope,
    $scope,
    __event,
    __sponsor
  ) {
    var vm = this;
    vm.sponsorsHeadline = [];
    vm.sponsorsSecondary = [];

    angular.extend($scope, {
      slickConfig: {
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },{
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },{
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      }
    })

    angular.extend($scope, {
      onInit: function() {
        vm.event = $rootScope.currentEvent;
        vm.preferences = vm.event.preferences;

        vm.sponsorModule = vm.event.preferences.sponsorModule;

        __sponsor.getSponsors('landingPage', true, true)
          .then(
            function(response){
              var arrays = [];
              angular.forEach(response.data, function(sponsor){
                if ( sponsor.headline ) {
                  vm.sponsorsHeadline.push(sponsor);
                } else {
                  arrays.push(sponsor);
                }
              });

              for ( var i = 0; i < arrays.length; i += 2 ) {
                if ( arrays.length > 8 ){
                  vm.sponsorsSecondary.push(arrays.slice(i, i + 2));
                } else {
                  vm.sponsorsSecondary = arrays;
                }
              }

            },
            $scope.handleError
          );
      },

      handleError: function(err){
        Notification.error(err.data.message);
      }
    });
  }
})();
(function(){
  'use strict';

  angular.module('eventmap')
         .controller('ConstructorLandingController', ConstructorLandingController);
  
  function ConstructorLandingController(
    $scope,
    Notification,
    PageService
  ) {
    var vm = this;

    $scope.cursorsPosition = -1;

    $scope.htmlEditor = null;
    $scope.cssEditor = null;
    // $scope.jsEditor = null;

    $scope.htmlContent = '<div>\n<!-- Put your content here -->\n</div>';
    $scope.cssContent = '/* Put your styles here */\ndiv { color: #121212; text-align: center; font-style: italic; }';
    // $scope.staticJsContent = '// Javascript';

    $scope.staticPages = [
      { tag: 'staticHtml', content: 'staticHtmlContent' },
      { tag: 'staticCss', content: 'staticCssContent' },
      // { id: 'staticJs', content: 'staticJsContent' },
    ];

    angular.extend($scope, {
      onInit: function(){

        angular.forEach($scope.staticPages, function(item){
          $scope.fetchPages(item.tag, item.content);
        });

      },

      // HTML
      aceHtmlLoaded: function(_editor){
        $scope.htmlEditor = _editor;
        // _editor.setValue($scope.staticHtmlContent);
      },

      aceHtmlChanged: function(_editor){
        $scope.staticHtmlContent['content'] = _editor[1].getSession().getValue();
      },

      // CSS
      aceCssLoaded: function(_editor){
        $scope.cssEditor = _editor;
        // _editor.setValue($scope.staticCssContent);
      },

      aceCssChanged: function(_editor){
        $scope.staticCssContent['content'] = _editor[1].getSession().getValue();
      },

      // JS
      // aceJsLoaded: function(_editor){
      //   $scope.jsEditor = _editor;
      //   // _editor.setValue($scope.staticJsContent);
      // },

      // aceJsChanged: function(_editor){
      //   $scope.staticJsContent = _editor[1].getSession().getValue();
      // },

      handleSavePages: function(){
        angular.forEach($scope.staticPages, function(item, index){
          $scope.updatePages($scope[item.content], index);
        });
      },

      // Fetch pages
      fetchPages: function(tag, content){
        PageService.getPageByTag('fixed', tag)
          .then(function(response){
            var data = response.data;

            if ( data.id && data.tag ){
              $scope[content] = data;
            } else {
              $scope[content] = {
                tag: tag,
                name: content,
                content: tag === 'staticHtml' ? $scope.htmlContent : $scope.cssContent
              };
            }

            if ( tag === 'staticHtml' ) $scope.htmlEditor.setValue($scope[content].content, $scope.cursorsPosition);
            if ( tag === 'staticCss' ) $scope.cssEditor.setValue($scope[content].content, $scope.cursorsPosition);
            // if ( id === 'staticJs' ) $scope.jsEditor.setValue($scope[content], $scope.cursorsPosition);
          })
          .catch(function(err){
            // console.error(err);
            Notification.error(err.data.message);
          })
      },

      // Update pages
      updatePages: function(page, index, cb){
        if ( page && page.id ){
          delete page['name'];
          PageService.updatePage(page)
            .then(function(){
              if ( $scope.staticPages.length - 1 === index ){
                Notification.success('Constructor was saved');

                if ( cb ) cb();
              }
            })
            .catch(function(err){
              if ( $scope.staticPages.length - 1 === index ){
                Notification.error(err.data.message);
              }
            })
        } else {
          page['type'] = 'fixed';
          PageService.createPage(page)
            .then(function(response){
              if ( $scope.staticPages.length - 1 === index ){
                Notification.success('Constructor was saved');

                $scope[page.name] = response.data;

                if ( cb ) cb();
              }
            })
            .catch(function(err){
              if ( $scope.staticPages.length - 1 === index ){
                Notification.error(err.data.message);
              }
            })
        }
      },

      onPreview: function(){
        angular.forEach($scope.staticPages, function(item, index){
          $scope.updatePages($scope[item.content], index, function(){

            window.open('?showConstructorResult=show', '_blank');

          });
        });
      }
    });
  }
})();
(function(){
  'use strict';

  angular
    .module('eventmap')
    .config(['$translateProvider', function($translateProvider){

      $translateProvider.useSanitizeValueStrategy(false);

      $translateProvider.translations('en', {
        'BUTTON': {
          // new
          'checkIn': 'Check in',
          'checkOut': 'Check out',
          'checkOutAll': 'Check out all',
          'log': 'Log',
          'accept': 'Accept',
          'decline': 'Decline',
          'registerAll': 'Register all',
          'addMore': 'Add more',
          'loginAs': 'Login as',
          'editProfile': 'Edit profile',
          'delete': 'Delete',
          'add': 'Add',
          'downloadCsv': 'Download CSV',
          'pay': 'Pay',
          'markPaid': 'Mark paid',
          'edit': 'Edit',
          'preview': 'Preview',
          'invoice': 'Invoice',
          'reset': 'Reset',
          'cancel': 'Cancel',
          'close': 'Close',
          'login': 'Login',
          'logout': 'Logout',
          'register': 'Register',
          'transactions': 'Transactions',
          'create': 'Create',
          'refund': 'Refund',
          'notes': 'Notes',
          'profileVisibility': 'Profile visibility',
          'update': 'Update',
          'addSponsorAd': 'Add sponsor ad',
          'addBoothType': 'Add booth type',
          'addCategory': 'Add category',
          'getCashDonation': 'Get Cash Donation',
          'addPage': 'Add page',
          'addInventory': 'Add inventory',
          'testMailSending': 'Test mail sending',
          'save': 'Save',
          'addSchedule': 'Add schedule',
          'schedule': 'Schedule',
          'manageReservation': 'Manage reservation',
          'addPricePackage': 'Add price package',
          'generate': 'Generate',
          'addTeam': 'Add team',
          'setBib': 'Set bib',
          'back': 'Back',
          'createCalendar': 'Create calendar',
          'reserve': 'Reserve',
          'details': 'Details',
          'insert': 'Insert',
          'createLog': 'Create log',
          'forgotPassword': 'Forgot password',
          'resetPassword': 'Reset password',
          'event': 'Event',
          'constructor': 'Constructor',
          'eventPortal': 'Event portal',
          'profile': 'Profile',
          'donate': 'Donate',
          'submit': 'Submit',
          'confirm': 'Confirm',
          'embed': 'Embed',

          'FOOTER': {
            'ABOUT': 'About',
            'CONTACT': 'Contact'
          },
          // 'DONATE': 'Donate',
          'EVENT_MAP': 'Event Map',
          'EVENT_VENDOR': 'Event',
          'SCHEDULE': 'Schedule',
          'ASSIGNMENTS': 'Assignments',
          'NEW_EVENT_REQUEST': 'New event request',
          'DIALOG': {
            'CLOSE': 'Close',
            'CANCEL': 'Cancel',
            'SEND': 'Send'
          },
          'LOGIN_AS': 'Login as',
          'MAIN_MAP': 'Main map',
          'ALSO_FOUND_AT': 'Also found at ...',
          'PAY': 'Pay',
          'SAVE': 'Save',
          'PREVIEW': 'Preview',
          'SAVE_PREVIEW': 'Save & Preview',
          'CANCEL': 'Cancel',
          'EDIT': 'Edit',
          'DELETE': 'Delete',
          'REMOVE': 'Remove',
          'UPDATE': 'Update',
          'ADD': 'Add',
          'CHOOSE_PHOTO': 'Choose photo',
          'UPDATE_PHOTO': 'Update photo',
          'DELETE_PHOTO': 'Delete photo',
          'BACK_TO_MAP': 'Back to map',
          'NO_COST_PURCHASE': 'No cost purchase',
          'PAY_CREDIT_CARD': 'Pay credit card',
          'PAY_CASH_CHECK': 'Pay cash/check',
          'SEND_MESSAGE': 'Send message',
          'MESSAGE_EVENT_ORGANIZER': 'Message Event Organizer',
          'ACCEPT': 'Accept',
          'DECLINE': 'Decline',
          'INSTRUCTION': 'Instruction',
          'CONFIRMATION_DOCUMENT': 'Confirmation document',
          'RESERVATION_MANAGER': 'Reservation manager',

          'REGISTER_ALL': 'Register all',

          'CREATE_SPECIAL_USER': 'Create special user',

          'DISABLE': 'Disable',
          'ENABLE': 'Enable',

          'SUBMIT': 'Submit',

          'EVENT_PASS': 'Event pass',
          'NOTES': 'Notes',

          'EDIT_PROFILE': 'Edit profile',
          'VISIBILITY_PROFILE': 'Profile visibility',

          'CONFIRM_PARTICIPATION': 'Confirm participation',

          'PUBLISH_MAP': 'Publish map',
          'UNPUBLISH_MAP': 'Unpublish map',
          'LOCK_MAP': 'Lock map',
          'UNLOCK_MAP': 'Unlock map',

          'APPLY_PROMOCODE': 'Apply promocode',

          'SHOW_TEAM_MEMBERS': 'Show team members',

          'SELECT': 'Select',
          'SELECTED': 'Selected',

          'CREATE_MAP': 'Create map',
          'SET_MAIN': 'Set main',

          'ADD_BG_IMAGE': 'Add background image',
          'REPLACE_BG_IMAGE': 'Replace background image',
          'DELETE_BG_IMAGE': 'Delete background image',
        },
        'FORM': {
          // New
          'label': {
            'zones': 'Zone(s)',
            'status': 'Status',
            'checkedIn': 'Checked in',
            'name': 'Name',
            'username': 'Username',
            'email': 'E-mail',
            'password': 'Password',
            'rePassword': 'Re-Password',
            'phone': 'Phone',
            'search': 'Search',
            'description': 'Description',
            'gooodsCategories': 'Goods categories',
            'categories': 'Categories',
            'booth': 'Booth',
            'category': 'Category',
            'date': 'Date',
            'price': 'Price',
            'invoiceDueDate': 'Invoice due date',
            'paymentStatus': 'Payment status',
            'individualFeaturedItems': 'Individual featured items',
            'bib': 'Bib',
            'comment': 'Comment',
            'users': 'Users',
            'type': 'Type',
            'paymentType': 'Payment type',
            'profileVisibility': 'Profile visibility',
            'featured': 'Featured',
            'enabled': 'Enabled',
            'order': 'Order',
            'validFrom': 'Valid from',
            'validTo': 'Valid to',
            'website': 'Website',
            'width': 'Width',
            'height': 'Height',
            'color': 'Color',
            'commercial': 'Commercial',
            'image': 'Image',
            'amount': 'Amount',
            'link': 'Link',
            'tag': 'Tag',
            'eventZone': 'Event zone',
            'responsibilityZone': 'Responsibility zone',
            'userGroups': 'User groups',
            'emailTemplate': 'E-mail templates',
            'subject': 'Subject',
            'body': 'Body',
            'macros': 'Macros',
            'sendTestEmail': 'Send test email',
            'startTime': 'Start time',
            'endTime': 'End time',
            'dateRange': 'Date range',
            'mapName': 'Map name',
            'boothName': 'Booth name',
            'reservationType': 'Reservation type',
            'operatingHours': 'Operating hours',
            'showUnsoldCount': 'Show unsold count',
            'maxAvailable': 'Max available',
            'maxAttendants': 'Max attendants',
            'dueDate': 'Due date',
            'promocode': 'Promocode',
            'soldout': 'Soldout',
            'paymentDueDate': 'Payment due date',
            'time': 'Time',
            'eventInfoBoxSize': 'Event info box size on home page',
            'domainName': 'Domain name',
            'itemsPerPage': 'Items per page',
            'logo': 'Logo',
            'favicon': 'Favicon',
            'backgroundImage': 'Background image',
            'eventColorScheme': 'Event color scheme',
            'title': 'Title',
            'keywords': 'Keywords',
            'boothDescription': 'Booth description',
            'code': 'Code',
            'slots': 'Slots',
            'package': 'Package(s)',
            'bibNumber': 'Bib number',
            'number': 'Number',
            'address': 'Address',
            'state': 'State',
            'city': 'City',
            'zipCode': 'Zip code',
            'company': 'Company',
            'priceDailyBreakdown': 'Price daily breakdown',
            'fromDate': 'From date',
            'toDate': 'To date',
            'frequency': 'Frequency',
            'businessHours': 'Business hours',
            'start': 'Start',
            'end': 'End',
            'location': 'Location',
            'availableHours': 'Available hours',
            'paymentDate': 'Payment date',
            'measurementSystem': 'Measurement System',
            'checkInDate': 'Check-in date',
            'checkOutDate': 'Check-out date',
            'userType': 'User type',
            'message': 'Message'
          },
          'placeholder': {
            'zones': 'Zone(s)',
            'name': 'Name',
            'username': 'Username',
            'email': 'E-mail',
            'password': 'Password',
            'rePassword': 'Re-Password',
            'phone': 'Phone',
            'search': 'Search',
            'searchUsers': 'Search users',
            'bib': 'Bib',
            'order': 'Order',
            'website': 'http:// or https://',
            'width': 'Width',
            'height': 'Height',
            'color': 'Color',
            'type': 'Type',
            'placeholder': 'Description',
            'users': 'Search users',
            'userGroups': 'Search user groups',
            'description': 'Description',
            'subject': 'Subject',
            'body': 'Body',
            'sendTestEmail': 'Send test email',
            'startTime': 'Start time',
            'endTime': 'End time',
            'chooseOrAddLocation': 'Choose or add location',
            'price': 'Price',
            'maxAttendants': 'Max attendants',
            'address': 'Address',
            'domainName': 'Domain name',
            'itemsPerPage': 'Items per page',
            'title': 'Title',
            'keywords': 'Keywords',
            'number': 'Number',
            'state': 'State',
            'city': 'City',
            'zipCode': 'Zip code',
            'company': 'Company',
            'amount': 'Amount',
            'message': 'Message',
            'tag': 'Tag'
          },
          'value': {
            'all': 'All',
            'yes': 'Yes',
            'no': 'No',
            'phoneType': {
              'cell': 'Cell',
              'work': 'Work',
              'home': 'Home'
            },
            'stopReceivingEmail': 'Stop receiving email(s)',
            'stopReceivingText': 'Stop receiving text(s)',
            'chooseFilterOptions': 'Choose filter options',
            'day': 'Day',
            'hour': 'Hour',
            'commercial': 'Commercial',
            'private': 'Private',
            'booth': 'Booth',
            'landingPage': 'Public pages',
            'innerPages': 'Inner pages',
            'chooseUser': 'Choose user',
            'choosePackage': 'Choose package',
            'chooseZone': 'Choose zone',
            'chooseType': 'Choose type',
            'chooseState': 'Choose state',
            'userGroups': 'Search user groups',
            'skipEmailNotification': 'Skip e-mail notification',
            'showIdleOnly': 'Show idle only',
            'showAssignedToBoothOnly': 'Show assigned to booth only',
            'skipWelcomeEmailNotification': 'Skip Welcome Email Notification',
            'skipPackageEmailNotification': 'Skip Package Email Notification',
            'automaticallyAccept': 'Automatically accept',
            'mapFullAccess': 'Map full access',
            'allowSendMessages': 'Allow send messages',
            'allowBulkMailSend': 'Allow bulk mail send',
            'small': 'Small (320px)',
            'medium': 'Medium (548px)',
            'large': 'Large (768px)',
            'showCustomHomePage': 'Show custom home page',
            'disableContentSanitize': 'Disable content sanitize for all rich text editors',
            'searchEnginePrivacy': 'Search Engine Privacy Settings',
            'enableBoothReservation': 'Enable booth reservation',
            'enableEventDonations': 'Enable event donations',
            'enableSchedule': 'Enable schedule',
            'groupScheduleByLocation': 'Group schedule by location',
            'eventCountdown': 'Event countdown clock',
            'showEventStartEndDate': 'Show event start/end date',
            'imperial': 'Imperial ( feet )',
            'metrics': 'Metrics ( meters )',
            'showOnlyMyZones': 'Show only my zone(s)',
            'showEventZones': 'Show event zone(s)'
          },
          'validation': {
            'required': 'This field is required',
            'numeric': 'This field should be numeric',
            'integer': 'Allow only integer number',
            'invalidEmail': 'E-mail is not valid',
            'date': 'Date is not correct',
            'time': 'Time is not correct',
            'minLength': 'Min length 6',
            'donationAmount': 'Donation amount cannot be set to 0',
            'notMatchPassword': 'Passwords do not match',
            'startTimeGreaterThanEnd': 'Start time is greater than end time',
            'startDateGreaterThanEnd': 'Start date is greater than end date',
            'exceedTransactionValue': 'Refund amount can’t exceed transaction value',
            'onlyCharacters': 'Allow only "a-z, A-Z, 0-9, -, _" characters',
            'scheduleCantBeMoreOrLessThanEvent': 'Schedule date can`t be more or less than event start/end date',
            'exceedEventDateTIme': 'Schedule item exceed event date/time range'
          },

          // Old
          'AUTH': {
            'USERNAME': 'Username',
            'PASSWORD': 'Password',
            'RE_PASSWORD': 'Re-password',
            'TYPE': 'Type',
            'NAME': 'Name',
            'EMAIL': 'E-mail',
            'PHONE': 'Phone',
            'PHONE_TYPE': {
              'CELL': 'Cell',
              'WORK': 'Work',
              'HOME': 'Home'
            },
            'PHONE_LABEL': 'Choose cell phone option to receive event text`s'
          },
          'PROFILE': {
            'DESCRIPTION': 'Description',
            'ADDRESS': 'Address',
            'STATE': 'State',
            'CHOOSE_STATE': 'Choose state',
            'CITY': 'City',
            'ZIP_CODE': 'Zip code',
            'COMPANY_NAME': 'Company name',
            'PHOTO_LABEL': '(Profile image is optional. This is only for your profile image, not your booth images)',
          },
          'REQUEST_PREVIEW': {
            'GOODS_CATEGORY': 'Goods categories',
            'DESCRIPTION': 'Description',
            'INDIVIDUAL_FEATURED_ITEMS': 'Individual featured items',
            'PROFILE_VISIBILITY': 'Profile visiblity',
            'PRICE_PACKAGE': 'Price package',
            'PRICE': 'Price',
            'DUE_DATE': 'Due date',
            'BOOTH_PHOTOS': 'Booth photos'
          },
          'DONATION': {
            'AMOUNT': 'Amount'
          },
          'SQUAREUP': {
            'CARD_NUMBER': 'Card number',
            'CVV': 'Cvv',
            'EXPIRATION_DATE': 'Expiration Date',
            'POSTAL_CODE': 'Postal Code'
          },
          'MESSAGE': {
            'SUBJECT': 'Subject',
            'MESSAGE': 'Message',
            'SEND_TO': 'Send to',
            'ALIASES': 'Aliases',
            'USERS': 'Users',
            'INCLUDE_EMAIL_NOTIFICATION': 'Include e-mail notification',
            'INCLUDE_TEXT_MESSAGE': 'Include text message',
            'TEXT_MESSAGE': 'Text message',
            'SCHEDULE_DATE': 'Schedule date',
            'DATE': 'Date',
            'START_TIME': 'Start time',
            'USER_TYPE': 'User type',
            'USER_SELECTOR': 'User selector',
            'USER_GROUPS': 'User groups'
          },
          'MAP_CONSTRUCTOR': {
            'NAME': 'Name',
            'EVENT_ZONE': 'Event zone',
            'INSTRUCTIONS': 'Instructions',
            'COLOR': 'Color',
            'WIDTH': 'Width',
            'HEIGHT': 'Height',
            'VOLUNTEER': 'Volunteer',
            'OPACITY': 'Opacity',
            'BOOTH_TYPE': 'Booth type',
            'DESCRIPTION': 'Description',
            'ROTATE_BOOTH': 'Rotate booth',
            'ROUTES': 'Routes',
            'EVENT_USERS': 'Event users',
            'NOTES': 'Notes',
            'INDOOR_MAPS': 'Indoor maps',
            'ACCEPTED_REQUESTS': 'Accepted requests'
          },
          'SEARCH': 'Search',
          'FILTER': 'Filter',
          'SPECIAL_NOTES': 'Special requests or notes',
          'PACKAGE': 'Package',
          'ALL': 'All',
          'CHOOSE_PACKAGE': 'Choose package',
          'CHOOSE_BOOTH_TYPE': 'Choose booth type',
          'CHOOSE_EVENT_ZONE': 'Choose event zone',
          'AGREE': 'I agree to the above terms *',

          'NO_REQUEST_SUBMITTED': 'No request submitted',
          'NO_RESPONSIBILITY_ZONE_SET': 'No responsibility zone set',
          'AUTOMATICALLY_ACCEPT': 'Automatically Accept',

          'VALIDATION': {
            'REQUIRED': 'This field is required',
            'INVALID_EMAIL': 'E-mail is not valid',
            'MIN_LENGTH': 'Min length 6',
            'AMOUNT_DONATION': 'Donation amount cannot be set to 0',
            'NOT_MATCH_PASSWORD': 'Passwords do not match',
            'NUMERIC': 'This field should be numeric',
            'INVALID_DATE': 'Date is not valid',
            'INVALID_TIME': 'Time is not valid',
            'START_TIME_IS_GREATER_THAN_END': 'Start time is greater than end time'
          },
        },
        'DIALOG': {
          'TITLE': {
            'ADD_DONATION': 'Please donate',
            'SQUAREUP_PAYMENT': 'Squareup payment',
            'MESSAGE_EVENT_ORGANIZER': 'Message Event Organizer',
            'REQUEST_PREVIEW': 'Request preview',
            'SEND_MESSAGE': 'Send message',
            'ASSIGNMENTS': 'Assignments',
            'WAIVER_AGREEMENT': 'Waiver agreement',
            'LOGIN_AS': 'Re-Authenticate'
          }
        },

        'HELP': {
          'boothTypeCommercialSet': '( Booth type commercial could be set only once and can`t be changed anymore )',
          'pricePackageTypeSet': '( Package type could be set only once and can`t be changed anymore )',
          'visibleOnlyFor': 'Visible only for Event Organizer, Coordinators and linked users',
          'chouldBeSetOnlyOnce': '( Tag could be set only once and can`t be changed anymore )',
          'saveTemplatePrior': '(Save template prior to test email sending)',
          'insertSelectedMacros': 'Click on text editor position to insert selected macros',
          'zeroNotAllowedAttendants': '( If zero then attendants not allowed )',
          'zeroMeansUnlimited': 'Zero means unlimited',
          'defaultPerPage': '( Default: 5 per page )',
          'reloadAfterSave': '(After "Save" settings, you should reload page to apply this config)',
          'supportImageFormat': 'Support image format *.png. Size 16x16, 32x32, 48x48, 64x64, 128x128',
          'discourageSearch': 'Discourage search engines from indexing this site'
        },

        'TEXT': {
          // New
          'loading': 'Loading ...',

          'noLogs': 'No logs',
          'noAssignments': 'No assignments',
          'noAttendantRequests': 'No attendant requests',
          'noPages': 'No pages',
          'noMedia': 'No media',
          'noPageSelected': 'No page selected',
          'noReservations': 'No reservations',
          'noTransactions': 'No transactions',
          'noBoothTypes': 'No booth types',



          // Old

          'SHOW_ME_ON_MAP': 'Notice: Reload page and grant access for your location to use option "Show me on map"',
          'WAITING_FOR_TRANSACTION': 'Waiting for transactions to be refreshed',
          'REMAINING_INVITES': 'Remaining invites',

          'SAVE_BEFORE_SWITCHING': 'Save map before switching to reservation manage',
          'SAVE_TO_APPLY': 'Save map to apply this parameter',

          'ALLOW_TO_RESERVE': 'Allow reservation for booth',

          'NO_SCHEDULES': 'No schedules',
          'NO_MESSAGES': 'No messages',
          'NO_MESSAGE_SELECTED': 'No message selected',
          'NO_ASSIGNMENTS': 'No assignments',
          'NO_RESERVATIONS': 'No reservations',
          'NO_ATTENDANT_REQUESTS': 'No attendant requests',
          'NO_LINKED_BOOTH': 'No linked booth(s)',
          'NO_MAP': 'No map(s)',

          'ONE_BOOTH_PHOTO_REQUIRED': 'At least one booth photo is required',

          'SHOULD_BE_LOGGED_IN_AS': 'You should be logged-in as ',
          'RESERVE_THEM_ALL': '(Pick available slot and than reserve them all)',
          'UPDATE_SUBSCRIPTION_PACKAGE': 'Please update subscription package',

          'TOTAL_LOGGED_TIME': 'Total logged time',

          'SHOW_IDLE_ONLY': 'Show idle only',
          'SHOW_ONLY_MY_ZONES': 'Show only my zone(s)',
          'SHOW_ONLY_MY_BOOTHS': 'Show only my booth(s)',

          'CHECKED': 'Checked',
          'BOOTH': 'BOOTH',
          'PUBLIC': 'Public'
        },
        'LABEL': {
          'ADDRESS': 'Address',
          'FEATURED_ITEMS': 'Featured items',
          'EMAIL': 'E-mail',
          'PACKAGE': 'Package(s)',
          'SEARCH': 'Search',
          'SCHEDULED': 'Scheduled',
          'TEXT_MESSAGE': 'Text message',
          'FROM': 'From',
          'TO': 'To',
          'AVAILABLE_HOURS': 'Available hours',
          'OPERATING_HOURS': 'Operating hours',
          'PRICE': 'Price',
          'STATE': 'State',
          'BOOTH_NAME': 'Booth name',
          'DATE': 'Date',
          'TIME': 'Time',
          'STATUS': 'Status',
          'DESCRIPTION': 'Description',
          'CHECKED_IN': 'Checked In',
          'INSTRUCTION': 'Instruction',
          'START_TIME': 'Start time',
          'END_TIME': 'End time',
          'MEMO': 'Memo',
          'ACTION': 'Action',
          'CODE': 'Code',
          'NOTES': 'Notes',
          'BIB': 'Bib number',
          'PAYMENT_TYPE': 'Payment type',
          'PAYMENT_DATE': 'Payment date',
          'TICKETS_LEFT': 'Tickets left',
          'TEAM_NAME': 'Team name',
          'MEMBERS': 'Members',
          'SLOTS': 'Slots',
          'BOOTH_DESCRIPTION': 'Booth description',
          'MAX_ATTENDANTS': 'Max attendants',
          'BOOTH_PHOTOS': 'Booth photos',
          'INVOICE_DUE_DATE': 'Invoice due date',
          'CATEGORY': 'Category',
          'TYPE': 'Type',
          'WIDTH': 'Width',
          'HEIGHT': 'Height',
          'COLOR': 'Color',
          'IMAGE': 'Image',
          'WORKLOG': 'Worklog',
          'ENABLED': 'Enabled',
          'RESPONSIBILITY_ZONE': 'Responsibility zone'
        },
        'MESSAGE': {
          'NO_ACTIVE_SUBSCRIPTION': 'No active subscription! Please subscribe to one of available plans on Event Portal.',
          'SUCCESS': {
            'CHECKED_IN': 'successfully checked-in'
          },
          'EXCEEDED': {
            'EVENT': 'Events exceeded max allowed limit of ',
            'MEMBER': 'Members exceeded max allowed limit of ',
            'MESSAGE': 'Text messages exceeded max allowed limit of ',
            'EMAIL': 'Email messages exceeded max allowed limit of '
          }
        },
        'TITLE': {
          'dialogAssignments': 'Assignments',
          'dialogProfileVisibility': 'Profile visibility',
          'dialogSetBib': 'Set bib',
          'dialogUpdateProfile': 'Update profile',

          'financialReport': 'Financial Report',

          'CHOOSE_SLOTS': 'Choose slots',
          'MY_TEAM': 'My team(s)'
        },
        'TAB': {
          'event': 'Event',
          'map': 'Map',
          'main': 'Main',
          'settings': 'Settings',
          'goodsCategories': 'Goods categories',
          'boothTypes': 'Booth types',
          'inventory': 'Inventory',
          'pricePackages': 'Price packages',
          'staticPages': 'Main Web pages',
          'dynamicPages': 'Extra Web pages',
          'emailTemplates': 'E-mail templates',
          'ownSMTPServer': 'Own SMTP server',
          'donations': 'Donations',
          'financialReport': 'Financial report',
          'schedule': 'Schedule',
          'all': 'All',
          'requests': 'Requests',
          'bulkRegister': 'Bulk register',
          'reservations': 'Reservations',
          'sponsorAds': 'Sponsor ADs',
          'messages': 'Messages',
          'inbox': 'Inbox',
          'sent': 'Sent',
          'timeLog': 'Time log',
          'myTeam': 'My team',
          'reservation': 'Reservation',
          'attendants': 'Attendants',
          'userGroups': 'User groups',
          'specialUsers': 'Special users',
          'teams': 'Teams',
          'reservationCalendars': 'Reservation calendars',
          'zone': 'Zone',
          'volunteers': 'Volunteers',
          'preferences': 'Preferences',
          'lookAndFeel': 'Look & feel',
          'metaTags': 'Meta tags',
          'userSettings': 'User settings',
          'logBook': 'Log book',
          'mediaGallery': 'Media gallery',
          'assignments': 'Assignments'
        },
        'TABLE': {
          'comment': 'Comment',
          'checkInOut': 'Check-in/out',
          'user': 'User',
          'status': 'Status',
          'actions': 'Actions',
          'vendor': 'Vendor',
          'volunteer': 'Volunteer',
          'contacts': 'Contacts',
          'info': 'Info',
          'sponsor': 'Sponsor',
          'zone': 'Zone',
          'booth': 'Booth',
          'date': 'Date',
          'time': 'Time',
          'memo': 'Memo',
          'payment': 'Payment',
          'userName': 'User name',
          'checkIn': 'Check-In',
          'checkOut': 'Check-Out',
          'timeSpent': 'Time spent',
          'group': 'Group',
          'typeStatus': 'Type/Status',
          'amount': 'Amount',
          'name': 'Name',
          'description': 'Description'
        },
        'MAP_CONSTRUCTOR': {
          'EVENT_ZONE': 'Event zone',
          'RESPONSIBILITY_ZONE': 'Volunteer zone',
          'ROUTE': 'Route',
          'BOOTH': 'Booth',
          'OVERLAY': 'Overlay',
          'SHOW_ROUTES': 'Show routes',
          'HIDE_ROUTES': 'Hide routes',
          'ONLY_UNASSIGNED_BOOTHS': 'Only unassigned booths',
          'ONLY_UNASSIGNED_RESPONSIBILITY_ZONE': 'Only unassigned volunteer zone',
          'LOCKED_BY': 'Locked by',
          'EXPIRED_ON': 'Expired on',
          'ROUTE_DISTANCE': 'Route distance'
        }
      });

      $translateProvider.preferredLanguage('en');

    }]);
})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .run(AuthenticatedRunConfig);

  AuthenticatedRunConfig.$inject = [
    '$rootScope',
    '$state',
    '$window',
    '$location',
    'Notification',
    'AuthService',
    'ViewService',
    'CurrentEvent'
  ];

  function AuthenticatedRunConfig(
    $rootScope,
    $state,
    $window,
    $location,
    Notification,
    __auth,
    __view,
    CurrentEvent
  ){
    $rootScope.loginAs = __auth.eoToken || false;

    $rootScope.currentUser = __auth.isUser || null;

    $rootScope.accessPortal = __auth.accessPortal;

    $rootScope.currentEvent = CurrentEvent || [];
    $rootScope.eventStatus = CurrentEvent.status !== 'archived' ? true : false;

    $rootScope.loadingInformation = false;

    var dataLayer = $window.dataLayer = $window.dataLayer || [];
    var isRouteChange = false;

    if (CurrentEvent.billingPreferences && CurrentEvent.billingPreferences.serviceType === 'stripe') {
      var scriptUrl = 'https://checkout.stripe.com/checkout.js';
      var scriptElem = angular.element(document.createElement('script'))
      scriptElem.attr('src', scriptUrl);
      $('body').append(scriptElem);
    }

    if (CurrentEvent.billingPreferences && CurrentEvent.billingPreferences.serviceType === 'squareup') {
      var scriptUrl = CurrentEvent.billingPreferences.sandbox ? 'https://sandbox.web.squarecdn.com/v1/square.js' : 'https://web.squarecdn.com/v1/square.js';
      var scriptElem = angular.element(document.createElement('script'))
      scriptElem.attr('src', scriptUrl);
      $('body').append(scriptElem);
    }

    if (CurrentEvent.billingPreferences && CurrentEvent.billingPreferences.serviceType === 'payeezy') {
      var scriptUrl = CurrentEvent.billingPreferences.paymentJSUrl;
      var scriptElem = angular.element(document.createElement('script'))
      scriptElem.attr('src', scriptUrl);
      $('body').append(scriptElem);
    }

    // Set view type
    if ( !__view.isView && __view.isView === '' ) {
      __view.setView('grid');
    }

    var currentTime = new Date().getTime();

    var token = __auth.isToken;
    var expiresTime = __auth.isExpires;

    var eoToken = __auth.isEOToken;
    var eoExpiresTime = __auth.isEOExpires;

    if ( eoToken && currentTime > eoExpiresTime ){
      Notification.error('Organizer session expired');
      __auth.clearEoCredential();
      __auth.clearReturnUrl();
    } else if ( token && currentTime > expiresTime ){
      Notification.error('Session expired');
      __auth.clearCredential();
    }

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
      var user = $rootScope.currentUser;
      if ( toState.authenticated ){
        if ( !user || toState.userType.indexOf(user.type) === -1 ){
          if ( toState.name !== 'app.home' ){
            event.preventDefault();
            $state.go('app.home');
          }
        }
      }
    });

    $rootScope.$on('$stateChangeSuccess', function(){
      if ( !$rootScope.eventStatus ){
        $location.search('event_id', $rootScope.currentEvent.id);
      }
      if ( $window.pageYOffset > 0 ) {
        $window.scrollTo(0, 0);
      }
      if (isRouteChange == false){
        isRouteChange = true;
      } else {
        dataLayer.push({
          event: 'ngRouteChange',
          attributes: {
            route: $location.path()
          }
        });
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .config(RouterConfig);
  
  RouterConfig.$inject = ['$stateProvider', '$urlRouterProvider', 'EVENT_STATUS'];

  function RouterConfig($stateProvider, $urlRouterProvider, EVENT_STATUS){

    $urlRouterProvider.otherwise('/');
    $urlRouterProvider.when('/organizer/user-groups', '/organizer/user-groups/list');

    var archived = EVENT_STATUS === 'archived' ? true : false;

    $stateProvider
      .state('framePublicMap', {
        url: '/frame-public-map',
        templateUrl: 'app/public-map/public-map.html'
      })
      .state('app', {
        abstract: true,
        url: '',
        templateUrl: 'app/app.html'
      })
        .state('app.auth', {
          abstract: 'true',
          url: '/auth',
          templateUrl: 'app/auth/auth.html'
        })
          .state('app.auth.login', {
            url: '/login',
            templateUrl: 'app/auth/login/login.html'
          })
          .state('app.auth.register', {
            url: '/register?=:userType',
            templateUrl: 'app/auth/register/register.html',
            archived: archived
          })
          .state('app.auth.resetPassword', {
            url: '/reset-password',
            templateUrl: 'app/auth/reset-password/reset-password.html'
          })
        .state('autoCheckIn', {
          url: '/auto-check-in?=:id&=:user&=:type&=:code',
          templateUrl: 'app/users/auto-check-in/auto-check-in.html',
          authenticated: false,
          params: {
            code: null
          }
        })
        .state('app.home', {
          url: '/?=:showConstructorResult&=:donationSuccess',
          templateUrl: 'app/home/home.html'
        })
          .state('app.home.donations', {
            url: 'donations',
            views: {
              'modal': {
                templateUrl: 'app/donations/donations.html'
              }
            }
          })
        // Private
        .state('app.constructorLandingPage', {
          url: '/constructor-landing-page',
          templateUrl: 'app/_constructor-landing/_constructor-landing.html',
          authenticated: true,
          userType: ['eo', 'eventCoordinator']
        })
        // Content page
        .state('app.contentPage', {
          url: '/content-page/{tag}',
          templateUrl: 'app/content-page/content-page.html'
        })
        .state('app.eventVendor', {
          url: '/event-vendor',
          templateUrl: 'app/event-vendor/event-vendor.html'
        })
        .state('app.publicMapMain', {
          url: '/event-map',
          templateUrl: 'app/public-map/public-map.html'
        })
        .state('app.publicMapIndoor', {
          url: '/indoor-map/:id?=:boothID&=:search',
          templateUrl: 'app/public-map/public-map.html'
        })
        .state('app.about', {
          url: '/about',
          templateUrl: 'app/static/about.html'
        })
        .state('app.contact', {
          url: '/contact',
          templateUrl: 'app/static/contact.html'
        })
        .state('app.schedule', {
          url: '/schedule',
          templateUrl: 'app/schedule/schedule.html'
        })
        // Reservation manager
        .state('app.reservation_manager', {
          url: '/reservation/:boothID?=:boothName?=:availableFrom?=:availableTo',
          templateUrl: 'app/users/reservation-manager/reservation-manager.html'
        })
  }

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
      $httpProvider.interceptors.push('AuthInterceptor');
    });

  AuthInterceptor.$inject = ['$q', '$location'];
  
  function AuthInterceptor($q, $location){
    return {
      request: function (config) {
        config.headers = config.headers || {};

        var currentTime = new Date().getTime();

        var token = localStorage.getItem('auth_token');
        var expiresTime = localStorage.getItem('auth_expires_in');

        if ( token && currentTime < expiresTime ) {
          config.headers['X-Auth-Token'] = token;
        }
        return config;
      },
      responseError: function (response){
        if ( response.status === 401 || response.status === -1 ){
          // $location.path('/auth/login');
        }
        return $q.reject(response);
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('eventmap')
    .filter('FilterUISelect', FilterUISelect)
    .filter('FilterUISelectRequest', FilterUISelectRequest)
    .filter('FilterPagination', FilterPagination)
    .filter('FilterVolunteerSearch', FilterVolunteerSearch)
    .filter('FilterOnlyVolunteer', FilterOnlyVolunteer)
    .filter('FilterVendorSearch', FilterVendorSearch)
    .filter('FilterSponsorSearch', FilterSponsorSearch)
    .filter('FilterParticipantSearch', FilterParticipantSearch)
    .filter('FilterRequestParticipant', FilterRequestParticipant)
    // BoothType
    .filter('FilterSearchByType', FilterSearchByType)
    .filter('FilterMessageSearch', FilterMessageSearch)
    .filter('FilterUserGroups', FilterUserGroups)
    .filter('FilterIdleUsers', FilterIdleUsers)
    .filter('FilterMapSearch', FilterMapSearch);

  function FilterRequestParticipant(){
    return function(items, userRequestSearch, requests){
      if ( userRequestSearch === 'all' ) return items;
      if ( userRequestSearch === 'noRequest' ){
        return items.filter(function(user){
          return !requests.some(function(request){
            return request.participantId === user.id;
          })
        });
      }
      if ( userRequestSearch === 'noAcceptedRequest' ){
        return items.filter(function(user){
          return requests.some(function(request){
            return request.participantId === user.id && request.status !== 'accepted';
          })
        });
      }
    }
  }

  function FilterIdleUsers(){
    return function(items, idleUsers, requests){
      if ( items ){
        if ( idleUsers ){
          return items.filter(function(user){
            return !requests.some(function(request){
              return user.id === request.vendor.id
            })
          });
        }
      }
      return items;
    }
  }

  function FilterUserGroups(){
    return function(items, userGroupName){
      if ( items ){
        if ( userGroupName !== '' && userGroupName !== 'all' ){
          return items.filter(function(item){
            return item.userGroups && item.userGroups.indexOf(userGroupName) !== -1;
          });
        }
      }
      return items;
    }
  }
  
  function FilterMapSearch(){
    return function(items, value){
      if ( items ){
        if ( value && value !== '' ){
          return items.filter(function(item){
            return item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
          });
        }
      }
      return items;
    }
  }

  function FilterSearchByType(){
    return function(items, value){
      if ( items ){
        if ( value && value !== '' ){
          return items.filter(function(item){
            return item.type.toLowerCase().indexOf(value.toLowerCase()) > -1
          });
        }
      }
      return items;
    }
  }
  
  function FilterMessageSearch(){
    return function(items, value){
      // Filter By: subject, body, sendTo/received
      if ( items ){
        if ( value && value !== '' ){
          return items.filter(function(item){
            return (
              item.subject && item.subject.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.body && item.body.toLowerCase().indexOf(value.toLowerCase()) > -1
            );
          });
        }
      }
      return items;
    }
  }

  function FilterUISelect() {
    return function(items, exists) {
      if ( items ) {
        angular.forEach(exists, function(exist){
          var qq = items.filter(function(item){
            return item.id === exist.id;
          })[0];
          if ( items.indexOf(qq) !== -1 ) {
            items.splice(qq, 1)
          }
        });
        return items;
      }
      return items;
    }
  }

  function FilterUISelectRequest() {
    return function(items, exists) {
      if ( items ) {
        angular.forEach(exists, function(exist){
          var qq = items.filter(function(item){
            return item.id === exist;
          })[0];
          if ( items.indexOf(qq) !== -1 ) {
            items.splice(qq, 1);
          }
        });
        return items;
      }
      return items;
    }
  }

  function FilterPagination() {
    return function(items, current, per) {
      if ( items ) {
        return items.slice((current - 1) * per, current * per)
      }
      return items;
    }
  }

  function FilterVolunteerSearch() {
    return function(items, value) {
      if ( items ) {
        if ( value && value !== '' ) {
          return items.filter(function(item){
            return (
              item.description && item.description.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.username.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.email.toLowerCase().indexOf(value.toLowerCase()) > -1
            );
          });
        }
      }
      return items;
    }
  }

  function FilterSponsorSearch() {
    return function(items, value) {
      if ( items ) {
        if ( value && value !== '' ) {
          return items.filter(function(item){
            return (
              item.description && item.description.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.username.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.email.toLowerCase().indexOf(value.toLowerCase()) > -1
            );
          });
        }
      }
      return items;
    }
  }

  function FilterVendorSearch() {
    return function(items, value) {
      if ( items ) {
        if ( value && value !== '' ) {
          return items.filter(function(item){
            return (
              item.description && item.description.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.company && item.company.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.username.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.email.toLowerCase().indexOf(value.toLowerCase()) > -1
            );
          });
        }
      }
      return items;
    }
  }

  function FilterParticipantSearch() {
    return function(items, value) {
      if ( items ) {
        if ( value && value !== '' ) {
          return items.filter(function(item){
            return (
              item.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
              item.email.toLowerCase().indexOf(value.toLowerCase()) > -1
            );
          });
        }
      }
      return items;
    }
  }

  function FilterOnlyVolunteer() {
    return function(items, query, requests, zones) {
      if ( query ){
        if ( query === 'all' ){
          return items;
        }
        if ( query === 'idleOnly' ){
          return items.filter(function(user){
            return !requests.some(function(request){
              return request.volunteer.id === user.id;
            });
          });
        }
        if ( query === 'unassignedOnly' ){
          var users = [];
          var assignedRequestIds = [];

          for ( var i in zones ){
            var zone = zones[i];
            if ( zone.volunteerAssignments && zone.volunteerAssignments.length ){
              for ( var j in zone.volunteerAssignments ){
                var assign = zone.volunteerAssignments[j];
                if ( assignedRequestIds.indexOf(assign.volunteerRequestId) === -1 ){
                  assignedRequestIds.push(assign.volunteerRequestId);
                }
              }
            }
          }
          if ( assignedRequestIds.length ){
            for ( var i in requests ){
              var request = requests[i];
              for ( var j in items ){
                var user = items[j];

                if ( request.status === 'accepted' && request.volunteer.id === user.id ){
                  if ( assignedRequestIds.indexOf(request.id) === -1 && users.indexOf(user) === -1 ){
                    users.push(user);
                  }
                }
              }
            }
            return users;
          } else {
            return items;
          }
        }
      }
      return items;
    }
  }

  angular.module('eventmap')
         .filter('formatPhone', function(COUNTRY_PHONES){
            return function(value) {
              var country = COUNTRY_PHONES.find(function(item){
                return item.code === value.substring(0, value.length - 10);
              });
              var i = 0;
              var phone = value.toString();
              return country ? country.pattern.replace(/#/g, function (_) {
                return phone[i++];
              }) : value;
            }
         })


  angular
    .module('eventmap')
    .filter('strippedHTML', function() {
      return function(str) {
        if ( str ){
          return str.replace(/<\/?[^>]+(>|$)/g, '')
                    .replace(/&nbsp;/g, ' ')
                    .replace(/&amp;/g, '&')
                    .replace(/&quot;/g, '"')
                    .replace(/&#34;/g, '"');
        }
      };
    })

  angular
    .module('eventmap')
    .filter('decimalNumber', function() {
      return function(string) {
        return string && string.split(' ').map(function(item){
          if ( item.replace(/^\D+/g, '') ){
            if ( item.indexOf('$') !== -1 ){
              return '$'+ new Number(item).toFixed(2);
            } else {
              return item;
            }
          } else {
            return item;
          }
        }).join(' ');
      };
    })

  angular
    .module('eventmap')
    .filter('range', function() {
      return function(input, total) {
        total = parseInt(total);

        for (var i=0; i<total; i++) {
          input.push(i);
        }

        return input;
      };
    })

  angular
    .module('eventmap')
    .filter('trusted', function($sce){
      return function(html) {
        return $sce.trustAsHtml(html);
      }
    })

  angular
    .module('eventmap')
    .filter('capitalize', function() {
      return function(input) {
        return (input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '');
      }
    })
  
  angular
    .module('eventmap')
    .filter('dateFormated', function(moment){
      return function(date) {
        return moment(moment.utc(date)).local().format('MMMM DD, YYYY hh:mm a');
      }
    })

  angular
    .module('eventmap')
    .filter('dateFormatedOnly', function(moment){
      return function(date) {
        return moment(date).local().format('MMMM DD, YYYY');
      }
    })

  angular
    .module('eventmap')
    .filter('dateFormatedOnlyM', function(moment){
      return function(date) {
        return moment(moment.utc(date)).local().format('MMMM DD');
      }
    })

  angular
    .module('eventmap')
    .filter('timeFormated', function(moment){
      return function(date) {
        return moment(moment.utc(date)).local().format('hh:mm a');
      }
    })

  angular
    .module('eventmap')
    .filter('include', function(_) {
      return function(input, alias) {
        var out = [];
        angular.forEach(input, function(item) {
          if (_.contains(item.recipientAliases, alias) || alias == undefined) {
            out.push(item)
          }
        })
        return out;
      }
    });

  angular
    .module('eventmap')
    .filter('reverse', function() {
      return function(items) {
        var collections = [];
        if (items) {
          collections = items.slice().reverse();
        }
        return collections;
      };
    });

  angular
    .module('eventmap')
    .filter('userCommercialRequestFilter', function() {
      return function(requests, search, boothType){
        var result = [];
        var query;
        if ( search ) {
          query = search.toLowerCase();
        }
        angular.forEach(requests, function(request){
          var matchSearch = !query || (
            ( request.description && request.description.toLowerCase().indexOf(query) != -1 ) ||
            ( request.individualFeaturedItems && request.individualFeaturedItems.toLowerCase().indexOf(query) != -1 ) ||
            ( request.user.name.toLowerCase().indexOf(query) != -1 ) ||
            ( request.user.description && request.user.description.toLowerCase().indexOf(query) != -1 )
          );
          var matchBoothType = !boothType || (
            boothType.type === 'Goods' &&
            request.goodsCategory &&
            boothType.name.toLowerCase() === request.goodsCategory.name.toLowerCase()
          );

          if ( matchSearch && matchBoothType ) {
            result.push(request);
          }
        });
        return result;
      };
    });

    angular
      .module('eventmap')
      .filter('boothDescribeSearch', function() {
        return function(booths, search, boothType){
          var result = [];
          angular.forEach(booths, function(booth){
            if (
              !search || (booth.description && booth.description.toLowerCase().indexOf(search.toLowerCase()) != -1)
            ) {
              if (
                !boothType ||
                (boothType && boothType.value === booth.boothTypeId)
              ) {
                result.push(booth);
              }
            }
          });
          return result;
        };
      });


    angular
      .module('eventmap')
      .filter('boothDescribeSearchNonVendor', function() {
        return function(booths, search, boothType){
          var result = [];
          angular.forEach(booths, function(booth){
            if (
              booth.type !== 'default' && booth.type !== 0 &&
              (
                ( booth.description && booth.description.toLowerCase().indexOf(search.toLowerCase()) != -1 ) ||
                ( boothType && boothType.type !== '' )
              )
            ) {
              if ( boothType && boothType.type === 'Services' ) {
                if ( boothType.value === booth.type ) {
                  result.push(booth);
                }
              } else {
                result.push(booth);
              }
            }
          });
          return result;
        };
      });

  angular
    .module('eventmap')
    .filter('organizerRequestFilter', function(_, $filter) {
      return function(requests){
        var filteredRequests = $filter('orderBy')(requests, "createdOn", true);
        var accepted  = _.where(filteredRequests, {status: "accepted"});
        var pending   = _.where(filteredRequests, {status: "pending"});
        var declined  = _.where(filteredRequests, {status: "declined"});
        var cancelled = _.where(filteredRequests, {status: "cancelled"});
        var result = _.compact(_.flatten([pending, accepted, cancelled, declined]));
        return result;
      };
    });

  angular
    .module('eventmap')
    .filter('phonenumber', function(){
      return function (number) {
        if (!number) { return ''; }

        number = String(number);

        var formattedNumber = number;

        var c = (number[0] == '1') ? '1 ' : '';
        number = number[0] == '1' ? number.slice(1) : number;

        var area = number.substring(0,3);
        var front = number.substring(3, 6);
        var end = number.substring(6, 10);

        if (front) {
            formattedNumber = (c + "(" + area + ") " + front);
        }
        if (end) {
            formattedNumber += ("-" + end);
        }
        return formattedNumber;
      };
    })

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .constant('moment', moment)
    .constant('PROFILE_VISIBILITY', [
      {
        name: 'Profile User Name',
        value: 'name'
      },{
        name: 'Company Name and Profile Description',
        value: 'company'
      },{
        name: 'Location (Address, City, State, Zip)',
        value: 'location'
      },{
        name: 'Contact (email, phones)',
        value: 'contact'
      },{
        name: 'Goods categories & Individual featured items',
        value: 'categories'
      }
    ])
    .constant('STATUSES', {
      'vendor': ['draft','pending','invoiced','accepted','declined','cancelled'],
      'volunteer': ['pending','accepted','declined','cancelled'],
      'participant': ['pending', 'accepted', 'declined', 'cancelled'],
      'sponsor': ['pending', 'accepted', 'declined', 'cancelled']
    })
    .constant('USA_STATES', [
      { code: 'AL', name: 'Alabama' },
      { code: 'AK', name: 'Alaska' },
      { code: 'AZ', name: 'Arizona' },
      { code: 'AR', name: 'Arkansas' },
      { code: 'CA', name: 'California' },
      { code: 'CO', name: 'Colorado' },
      { code: 'CT', name: 'Connecticut' },
      { code: 'DE', name: 'Delaware' },
      { code: 'DC', name: 'District Of Columbia' },
      { code: 'FL', name: 'Florida' },
      { code: 'GA', name: 'Georgia' },
      { code: 'HI', name: 'Hawaii' },
      { code: 'ID', name: 'Idaho' },
      { code: 'IL', name: 'Illinois' },
      { code: 'IN', name: 'Indiana' },
      { code: 'IA', name: 'Iowa' },
      { code: 'KS', name: 'Kansas' },
      { code: 'KY', name: 'Kentucky' },
      { code: 'LA', name: 'Louisiana' },
      { code: 'ME', name: 'Maine' },
      { code: 'MD', name: 'Maryland' },
      { code: 'MA', name: 'Massachusetts' },
      { code: 'MI', name: 'Michigan' },
      { code: 'MN', name: 'Minnesota' },
      { code: 'MS', name: 'Mississippi' },
      { code: 'MO', name: 'Missouri' },
      { code: 'MT', name: 'Montana' },
      { code: 'NE', name: 'Nebraska' },
      { code: 'NV', name: 'Nevada' },
      { code: 'NH', name: 'New Hampshire' },
      { code: 'NJ', name: 'New Jersey' },
      { code: 'NM', name: 'New Mexico' },
      { code: 'NY', name: 'New York' },
      { code: 'NC', name: 'North Carolina' },
      { code: 'ND', name: 'North Dakota' },
      { code: 'OH', name: 'Ohio' },
      { code: 'OK', name: 'Oklahoma' },
      { code: 'OR', name: 'Oregon' },
      { code: 'PA', name: 'Pennsylvania' },
      { code: 'RI', name: 'Rhode Island' },
      { code: 'SC', name: 'South Carolina' },
      { code: 'SD', name: 'South Dakota' },
      { code: 'TN', name: 'Tennessee' },
      { code: 'TX', name: 'Texas' },
      { code: 'UT', name: 'Utah' },
      { code: 'VT', name: 'Vermont' },
      { code: 'VA', name: 'Virginia' },
      { code: 'WA', name: 'Washington' },
      { code: 'WV', name: 'West Virginia' },
      { code: 'WI', name: 'Wisconsin' },
      { code: 'WY', name: 'Wyoming' }
    ])
    .constant('APP_COLORS', [
      { id: 1, name: 'kumquat', hexCode: '#B25500' },
      { id: 2, name: 'offroad', hexCode: '#484545' },
      { id: 3, name: 'red', hexCode: '#f44336' },
      { id: 4, name: 'pink', hexCode: '#ba2332' },
      { id: 5, name: 'purple', hexCode: '#9C27B0' },
      { id: 6, name: 'deep-purple', hexCode: '#673AB7' },
      { id: 7, name: 'indigo', hexCode: '#3F51B5' },
      { id: 8, name: 'blue', hexCode: '#2196F3' },
      { id: 9, name: 'light-blue', hexCode: '#03A9F4' },
      { id: 10, name: 'cyan', hexCode: '#00BCD4' },
      { id: 11, name: 'teal', hexCode: '#009688' },
      { id: 12, name: 'green', hexCode: '#4CAF50' },
      { id: 13, name: 'light-green', hexCode: '#8BC34A' },
      { id: 14, name: 'lime', hexCode: '#CDDC39' },
      { id: 15, name: 'yellow', hexCode: '#FFEB3B' },
      { id: 16, name: 'amber', hexCode: '#FFC107' },
      { id: 17, name: 'orange', hexCode: '#FF9800' },
      { id: 18, name: 'deep-orange', hexCode: '#FF5722' },
      { id: 19, name: 'brown', hexCode: '#795548' },
      { id: 20, name: 'grey', hexCode: '#9E9E9E' },
      { id: 21, name: 'blue-grey', hexCode: '#607D8B' }
    ]);

})();

(function() {
  'use strict';

  angular
    .module('eventmap')
    .config(ConfigProvider)
    .config(ColorProvider)
    .config(TextAngularProvider);

  function ConfigProvider($logProvider, $locationProvider, localStorageServiceProvider, NotificationProvider) {
    // Location provider
    $locationProvider.hashPrefix('');
    $locationProvider.html5Mode(true);
    // Enable log
    $logProvider.debugEnabled(true);

    // LocalStorage Config
    localStorageServiceProvider
      .setPrefix('eventmap')
      .setStorageType('localStorage')
      .setNotify(true, true);
    
    // Notification
    NotificationProvider.setOptions({
      delay: 9999999,
      startTop: 16,
      startRight: 16,
      verticalSpacing: 16,
      horizontalSpacing: 16,
      positionX: 'right',
      positionY: 'top',
      // templateUrl: 'app/directives/notification.html',
      closeOnClick: true,
      maxCount: 5
    });
  }

  function ColorProvider($provide){
    $provide.decorator('ColorPickerOptions', function($delegate){
      var options = angular.copy($delegate);
      options.inputClass = 'form-control';
      options.round = false;
      options.alpha = false;
      options.format = 'hexString';
      return options;
    });
  }

  function TextAngularProvider($provide){
    $provide.decorator('taOptions', [
      'taRegisterTool', 'taToolFunctions', 'taSelection', '$delegate', '$window', 'TEXT_EDITOR_SANITIZE',
      function(taRegisterTool, taToolFunctions, taSelection, taOptions, $window, TEXT_EDITOR_SANITIZE){
        taOptions.disableSanitizer = TEXT_EDITOR_SANITIZE;
        taRegisterTool('fontColor', {
          tooltiptext: 'Font color',
          display: [
            "<button class='btn btn-default' style='padding: 0;' type='button'>",
              "<input type='color' ng-model='textAngular.fontColor' id='text-angular-font-color' style='width: 36px; height: 34px; display: block; padding: 0; border: 0; background: none;'/>",
            "</button>"
          ].join(''),
          action: function(deferred){
            var self = this;
            if ( typeof self.listener == 'undefined' ){
              self.listener = self.$watch('textAngular.fontColor', function(newValue){
                self.$editor().wrapSelection('foreColor', newValue);
              });
            }
            return false;
          }
        })
        // Insert video: youtube
        taRegisterTool('insertVideoYoutube', {
          iconclass: 'fa fa-youtube-play',
          tooltiptext: 'Insert video from Youtube',
          action: function(){
            var urlPrompt = $window.prompt('Please enter a youtube URL to embed', 'https://');
            if (!blockJavascript(urlPrompt)) {
              if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {
                var videoId = taToolFunctions.extractYoutubeVideoId(urlPrompt);
                if (videoId) {
                  var urlLink = 'https://www.youtube.com/embed/' + videoId;
                  var embed = '<div class="iframe-wrap"><img class="ta-insert-video" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" ta-insert-video="' + urlLink + '" alt="youtubeFrame" contenteditable="false" allowfullscreen="true" frameborder="0" /></div>';
                  if (
                    taSelection.getSelectionElement().tagName &&
                    taSelection.getSelectionElement().tagName.toLowerCase() === 'a'
                  ) {
                    taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
                  }
                  return this.$editor().wrapSelection('insertHTML', embed, true);
                }
              }
            }
          },
          onElementSelect: {
            element: 'img',
            onlyWithAttrs: ['ta-insert-video'],
            action: taToolFunctions.imgOnSelectAction
          }
        });
        // Insert video: vimeo
        taRegisterTool('insertVideoVimeo', {
          iconclass: 'fa fa-vimeo-square',
          tooltiptext: 'Insert video from Vimeo',
          action: function(){
            var urlPrompt = $window.prompt('Please enter a vimeo URL to embed. ( Need some time to load thumbnail )', 'https://');
            var self = this;
            if (!blockJavascript(urlPrompt)) {
              if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {
                var videoId = extractVimeoVideoId(urlPrompt);
                if (videoId) {
                  var urlLink = 'https://player.vimeo.com/video/' + videoId;
                  $.getJSON('https://www.vimeo.com/api/v2/video/' + videoId + '.json?callback=?', {format: "json"},
                    function(response){
                      var embed = '<div class="iframe-wrap"><img class="ta-insert-video" src="'+ response[0].thumbnail_large +'" ta-insert-video="' + urlLink + '" alt="vimeoFrame" contenteditable="false" allowfullscreen="true" frameborder="0" /></div>';
                      if (
                        taSelection.getSelectionElement().tagName &&
                        taSelection.getSelectionElement().tagName.toLowerCase() === 'a'
                      ) {
                        taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
                      }
                      return self.$editor().wrapSelection('insertHTML', embed, true);
                    });
                }
              }
            }
          },
          onElementSelect: {
            element: 'img',
            onlyWithAttrs: ['ta-insert-video'],
            action: taToolFunctions.imgOnSelectAction
          }
        });

        taOptions.toolbar[1].push('fontColor');
        taOptions.toolbar[1].push('insertVideoYoutube');
        taOptions.toolbar[1].push('insertVideoVimeo');
        return taOptions;

        function extractVimeoVideoId(url){
          var re = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
          var match = url.match(re);
          return (match && match[2]) || null;
        }

        function blockJavascript(link){
          if (link && link.toLowerCase().indexOf('javascript') !== -1) {
            return true;
          }
          return false;
        }
    }]);
  }

})();


(function(){

  'use strict';

  angular
    .module('eventmap')
    .config(RouterConfig)

  RouterConfig.$inject = ['$stateProvider'];

  function RouterConfig($stateProvider){

    function stateProperty(url, templateUrl, userType, authenticated, abstract) {
      return {
        url: url,
        templateUrl: 'app/users/' + templateUrl,
        userType: userType || null,
        authenticated: authenticated || false,
        abstract: abstract || false
      }
    }

    $stateProvider
      .state('users', {
        abstract: true,
        url: '',
        templateUrl: 'app/users/users.html'
      })
        .state('users.profile', stateProperty('/profile', 'profile/profile.html', true))
        // Sponsor Attendants
        .state('users.sponsorAttendant', stateProperty('/sponsor-attendant', 'sponsor-attendant/sponsor-attendant.html', ['sponsorAttendant'], true))
        // Vendors
        .state('users.vendor', stateProperty('/vendor', 'vendor/vendor.html', ['vendor'], true, true))
          .state('users.vendor.event', stateProperty('/event', 'vendor/event/event.html', ['vendor'], true))
            .state('users.vendor.event.add', {
              url: '/add',
              userType: ['vendor'],
              authenticated: true,
              views: {
                'modal': {
                  templateUrl: 'app/users/vendor/event/event.form.html'
                }
              }
            })
            .state('users.vendor.event.update', {
              url: '/update/:id',
              userType: ['vendor'],
              authenticated: true,
              views: {
                'modal': {
                  templateUrl: 'app/users/vendor/event/event.form.html'
                }
              }
            })
          .state('users.vendor.mainMap', stateProperty('/map', 'vendor/vendor-map/vendor-map.html', ['vendor'], true))
          .state('users.vendor.indoorMap', stateProperty('/indoor-map/:id', 'vendor/vendor-map/vendor-map.html', ['vendor'], true))
          .state('users.vendor.schedule', stateProperty('/schedule', 'user-schedule/user-schedule.html', ['vendor'], true))
          .state('users.vendor.messages', stateProperty('/messages', 'vendor/messages/messages.html', ['vendor'], true))
            .state('users.vendor.messages.inbox', stateProperty('/inbox', 'messages/inbox/inbox.html', ['vendor'], true))
              .state('users.vendor.messages.inbox.preview', {
                url: '/:id?=:appType',
                userType: ['vendor'],
                authenticated: true,
                params: {
                  type: 'inbox',
                  user: ['vendor']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
            .state('users.vendor.messages.sent', stateProperty('/sent', 'messages/sent/sent.html', ['vendor'], true))
              .state('users.vendor.messages.sent.preview', {
                url: '/:id?=:appType',
                userType: ['vendor'],
                authenticated: true,
                params: {
                  type: 'sent',
                  user: ['vendor']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })

        // Volunteer
        .state('users.volunteer', stateProperty('/volunteer', 'volunteer/volunteer.html', ['volunteer'], true, true))
          .state('users.volunteer.event', stateProperty('/event', 'volunteer/event/event.html', ['volunteer'], true))
          .state('users.volunteer.mainMap', stateProperty('/map', 'volunteer/volunteer-map/volunteer-map.html', ['volunteer'], true))
          .state('users.volunteer.indoorMap', stateProperty('/indoor-map/:id', 'volunteer/volunteer-map/volunteer-map.html', ['volunteer'], true))
          .state('users.volunteer.schedule', stateProperty('/schedule', 'user-schedule/user-schedule.html', ['volunteer'], true))
          .state('users.volunteer.messages', stateProperty('/messages', 'volunteer/messages/messages.html', ['volunteer'], true))
            .state('users.volunteer.messages.inbox', stateProperty('/inbox', 'messages/inbox/inbox.html', ['volunteer'], true))
              .state('users.volunteer.messages.inbox.preview', {
                url: '/:id?=:appType',
                userType: ['volunteer'],
                authenticate: true,
                params: {
                  type: 'inbox',
                  user: ['volunteer']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
            .state('users.volunteer.messages.sent', stateProperty('/sent', 'messages/sent/sent.html', ['volunteer'], true))
              .state('users.volunteer.messages.sent.preview', {
                url: '/:id?=:appType',
                userType: ['volunteer'],
                authenticated: true,
                params: {
                  type: 'sent',
                  user: ['volunteer']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
          .state('users.volunteer.timeLog', stateProperty('/time-log', 'volunteer/time-log/time-log.html', true))
        // Participant
        .state('users.participant', stateProperty('/participant', 'participant/participant.html', ['participant'], true, true))
          .state('users.participant.event', stateProperty('/event', 'participant/event/event.html', ['participant'], true))
          .state('users.participant.mainMap', stateProperty('/map', 'participant/participant-map/participant-map.html', ['participant'], true))
          .state('users.participant.indoorMap', stateProperty('/indoor-map/:id', 'participant/participant-map/participant-map.html', ['participant'], true))
          .state('users.participant.schedule', stateProperty('/schedule', 'user-schedule/user-schedule.html', ['participant'], true))
          .state('users.participant.myTeam', stateProperty('/my-team', 'participant/my-team/my-team.html', ['participant'], true))
          .state('users.participant.scavengerHunt', stateProperty('/scavenger-hunt', 'participant/scavenger-hunt/scavenger-hunt.html', ['participant'], true))
          .state('users.participant.messages', stateProperty('/messages', 'participant/messages/messages.html', ['participant'], true))
            .state('users.participant.messages.inbox', stateProperty('/inbox', 'messages/inbox/inbox.html', ['participant'], true))
              .state('users.participant.messages.inbox.preview', {
                url: '/:id?=:appType',
                userType: ['participant'],
                authenticated: true,
                params: {
                  type: 'inbox',
                  user: ['participant']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
            .state('users.participant.messages.sent', stateProperty('/sent', 'messages/sent/sent.html', ['participant'], true))
              .state('users.participant.messages.sent.preview', {
                url: '/:id?=:appType',
                userType: ['participant'],
                authenticated: true,
                params: {
                  type: 'sent',
                  user: ['participant']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
            //#ParticipantReservation
            .state('users.participant.reservation', stateProperty('/reservation', 'participant/reservation/reservation.html', ['participant'], true))
        // Special
        .state('users.special', stateProperty('/special', 'special/special.html', ['special'], true, true))
          .state('users.special.mainMap', stateProperty('/map', 'special/special-map/special-map.html', ['special'], true))
          .state('users.special.indoorMap', stateProperty('/indoor-map/:id', 'special/special-map/special-map.html', ['special'], true))
          .state('users.special.messages', stateProperty('/messages', 'special/messages/messages.html', ['special'], true))
            .state('users.special.messages.inbox', stateProperty('/inbox', 'messages/inbox/inbox.html', ['special'], true))
              .state('users.special.messages.inbox.preview', {
                url: '/:id?=:appType',
                userType: ['special'],
                authenticated: true,
                params: {
                  type: 'inbox',
                  user: ['special']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
            .state('users.special.messages.sent', stateProperty('/sent', 'messages/sent/sent.html', ['special'], true))
              .state('users.special.messages.sent.preview', {
                url: '/:id?=:appType',
                userType: ['special'],
                authenticated: true,
                params: {
                  type: 'sent',
                  user: ['special']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
            .state('users.special.messages.send', {
              url: '/send',
              userType: ['special'],
              authenticated: true,
              views: {
                'modal': {
                  templateUrl: 'app/users/special/messages/messages.form.html'
                }
              }
            })
        // Volunteer Coordinator
        .state('users.volunteerCoordinator', stateProperty('/volunteer-coordinator', 'volunteerCoordinator/volunteer-coordinator.html', ['volunteerCoordinator'], true, true))
          .state('users.volunteerCoordinator.map', stateProperty('/map', 'volunteerCoordinator/volunteer-coordinator-map/volunteer-coordinator-map.html', ['volunteerCoordinator'], true))
          .state('users.volunteerCoordinator.volunteers', stateProperty('/volunteers', 'organizer/volunteers/volunteers.html', ['volunteerCoordinator'], true))
            .state('users.volunteerCoordinator.volunteers.all', stateProperty('/all', 'organizer/volunteers/all/all.html', ['volunteerCoordinator'], true))
            .state('users.volunteerCoordinator.volunteers.requests', stateProperty('/requests', 'organizer/volunteers/requests/requests.html', ['volunteerCoordinator'], true))
            .state('users.volunteerCoordinator.volunteers.bulk', stateProperty('/bulk', 'organizer/volunteers/bulk/bulk.html', ['volunteerCoordinator'], true))
            .state('users.volunteerCoordinator.volunteers.logBook', stateProperty('/log-book', 'organizer/volunteers/log-book/log-book.html', ['volunteerCoordinator'], true))
            .state('users.volunteerCoordinator.volunteers.assignments', stateProperty('/assignments', 'organizer/volunteers/volunteer-assignments/volunteer-assignments.html', ['volunteerCoordinator'], true))
          .state('users.volunteerCoordinator.messages', stateProperty('/messages', 'volunteerCoordinator/messages/messages.html', ['volunteerCoordinator'], true))
            .state('users.volunteerCoordinator.messages.inbox', stateProperty('/inbox', 'messages/inbox/inbox.html', ['volunteerCoordinator'], true))
              .state('users.volunteerCoordinator.messages.inbox.preview', {
                url: '/:id?=:appType',
                userType: ['volunteerCoordinator'],
                authenticated: true,
                params: {
                  type: 'inbox',
                  user: ['volunteerCoordinator']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
            .state('users.volunteerCoordinator.messages.sent', stateProperty('/sent', 'messages/sent/sent.html', ['volunteerCoordinator'], true))
              .state('users.volunteerCoordinator.messages.sent.preview', {
                url: '/:id?=:appType',
                userType: ['volunteerCoordinator'],
                authenticated: true,
                params: {
                  type: 'sent',
                  user: ['volunteerCoordinator']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
          .state('users.volunteerCoordinator.schedule', stateProperty('/schedule', 'organizer/event/schedule/schedule.html', ['volunteerCoordinator'], true))
        // Sponsor
        .state('users.sponsor', stateProperty('/sponsor', 'sponsor/sponsor.html', ['sponsor'], true, true))
          .state('users.sponsor.event', stateProperty('/event', 'sponsor/event/event.html', ['sponsor'], true))
          .state('users.sponsor.mainMap', stateProperty('/map', 'sponsor/sponsor-map/sponsor-map.html', ['sponsor'], true))
          .state('users.sponsor.indoorMap', stateProperty('/indoor-map/:id', 'sponsor/sponsor-map/sponsor-map.html', ['sponsor'], true))
          .state('users.sponsor.schedule', stateProperty('/schedule', 'user-schedule/user-schedule.html', ['sponsor'], true))
          .state('users.sponsor.messages', stateProperty('/messages', 'sponsor/messages/messages.html', ['sponsor'], true))
            .state('users.sponsor.messages.inbox', stateProperty('/inbox', 'messages/inbox/inbox.html', ['sponsor'], true))
              .state('users.sponsor.messages.inbox.preview', {
                url: '/:id?=:appType',
                userType: ['sponsor'],
                authenticated: true,
                params: {
                  type: 'inbox',
                  user: ['sponsor']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
            .state('users.sponsor.messages.sent', stateProperty('/sent', 'messages/sent/sent.html', ['sponsor'], true))
              .state('users.sponsor.messages.sent.preview', {
                url: '/:id?=:appType',
                userType: ['sponsor'],
                authenticated: true,
                params: {
                  type: 'sent',
                  user: ['sponsor']
                },
                views: {
                  'message': {
                    templateUrl: 'app/users/messages/preview/preview.html'
                  }
                }
              })
          .state('users.sponsor.attendants', stateProperty('/attendants', 'sponsor/attendants/attendants.html', ['sponsor'], true))
        // Organizer
        .state('users.organizer', stateProperty('/organizer', 'organizer/organizer.html', ['eo', 'eventCoordinator'], true, true))
        // Reservation
        .state('users.organizer.reservation_manager', stateProperty('/reservation/manager/:id', 'organizer/reservation/reservation.html', ['eo', 'eventCoordinator'], true))
        .state('users.organizer.map', stateProperty('/map', 'organizer/map/map.html', ['eo', 'eventCoordinator'], true, true))
          .state('users.organizer.map.main', stateProperty('/main', 'organizer/map/constructor/constructor.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.map.all', stateProperty('/all', 'organizer/map/all/all.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.map.constructor', stateProperty('/constructor/:id', 'organizer/map/constructor/constructor.html', ['eo', 'eventCoordinator'], true))
        // End indoor
        .state('users.organizer.event', stateProperty('/event', 'organizer/event/event.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.settings', stateProperty('/settings', 'organizer/event/settings/settings.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.categories', stateProperty('/categories', 'organizer/event/categories/categories.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.booths', stateProperty('/booths', 'organizer/event/booths/booths.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.inventory', stateProperty('/inventory', 'organizer/event/inventory/inventory.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.prices', stateProperty('/prices', 'organizer/event/prices/prices.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.staticPages', stateProperty('/static-pages', 'organizer/event/static-pages/static-pages.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.dynamicPages', stateProperty('/dynamic-pages', 'organizer/event/dynamic-pages/dynamic-pages.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.mailTemplate', stateProperty('/mail-template', 'organizer/event/mail-template/mail-template.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.smtpServer', stateProperty('/smtp-server', 'organizer/event/smtp-server/smtp-server.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.donations', stateProperty('/dontations', 'organizer/event/donations/donations.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.financialReport', stateProperty('/financial-report', 'organizer/event/financial-report/financial-report.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.schedule', stateProperty('/schedule', 'organizer/event/schedule/schedule.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.reservationCalendars', stateProperty('/reservation-calendars', 'organizer/event/reservation-calendars/reservation-calendars.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.mediaGallery', stateProperty('/media-gallery', 'organizer/event/media-gallery/media-gallery.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.event.k2_notifications', stateProperty('/k2-notifications', 'organizer/event/k2-templates/k2-templates.html', ['eo', 'eventCoordinator'], true))

        .state('users.organizer.vendors', stateProperty('/vendors', 'organizer/vendors/vendors.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.vendors.all', stateProperty('/all', 'organizer/vendors/all/all.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.vendors.requests', stateProperty('/requests', 'organizer/vendors/requests/requests.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.vendors.bulk', stateProperty('/bulk', 'organizer/vendors/bulk/bulk.html', ['eo', 'eventCoordinator'], true))
        .state('users.organizer.volunteers', stateProperty('/volunteers', 'organizer/volunteers/volunteers.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.volunteers.all', stateProperty('/all', 'organizer/volunteers/all/all.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.volunteers.requests', stateProperty('/requests', 'organizer/volunteers/requests/requests.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.volunteers.bulk', stateProperty('/bulk', 'organizer/volunteers/bulk/bulk.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.volunteers.logBook', stateProperty('/log-book', 'organizer/volunteers/log-book/log-book.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.volunteers.assignments', stateProperty('/assignments', 'organizer/volunteers/volunteer-assignments/volunteer-assignments.html', ['eo', 'eventCoordinator'], true))
        .state('users.organizer.participants', stateProperty('/participants', 'organizer/participants/participants.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.participants.all', stateProperty('/all', 'organizer/participants/all/all.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.participants.requests', stateProperty('/requests', 'organizer/participants/requests/requests.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.participants.teams', stateProperty('/teams', 'organizer/participants/teams/teams.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.participants.bulk', stateProperty('/bulk', 'organizer/participants/bulk/bulk.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.participants.reservations', stateProperty('/reservations', 'organizer/participants/reservations/reservations.html', ['eo', 'eventCoordinator'], true))

        .state('users.organizer.scavengerHunt', stateProperty('/scavenger-hunt', 'organizer/scavenger-hunt/scavenger-hunt.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.scavengerHunt.checkInPoints', stateProperty('/check-in-points', 'organizer/scavenger-hunt/check-in-points/check-in-points.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.scavengerHunt.leaderboard', stateProperty('/leaderboard', 'organizer/scavenger-hunt/leaderboard/leaderboard.html', ['eo', 'eventCoordinator'], true))

        .state('users.organizer.sponsors', stateProperty('/sponsors', 'organizer/sponsors/sponsors.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.sponsors.ads', stateProperty('/ads', 'organizer/sponsors/ads/ads.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.sponsors.all', stateProperty('/all', 'organizer/sponsors/all/all.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.sponsors.requests', stateProperty('/requests', 'organizer/sponsors/requests/requests.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.sponsors.bulk', stateProperty('/bulk', 'organizer/sponsors/bulk/bulk.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.sponsors.attendants', stateProperty('/attendants', 'organizer/sponsors/attendants/attendants.html', ['eo', 'eventCoordinator'], true))
        .state('users.organizer.messages', stateProperty('/messages', 'organizer/messages/messages.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.messages.inbox', stateProperty('/inbox', 'messages/inbox/inbox.html', ['eo', 'eventCoordinator'], true))
            .state('users.organizer.messages.inbox.preview', {
              url: '/:id/:recipientId?=:appType',
              userType: ['eo', 'eventCoordinator'],
              authenticated: true,
              params: {
                type: 'inbox',
                user: ['eo', 'eventCoordinator']
              },
              views: {
                'message': {
                  templateUrl: 'app/users/messages/preview/preview.html'
                }
              }
            })
          .state('users.organizer.messages.sent', stateProperty('/sent', 'messages/sent/sent.html', ['eo', 'eventCoordinator'], true))
            .state('users.organizer.messages.sent.preview', {
              url: '/:id?=:appType',
              userType: ['eo', 'eventCoordinator'],
              authenticated: true,
              params: {
                type: 'sent',
                user: ['eo', 'eventCoordinator']
              },
              views: {
                'message': {
                  templateUrl: 'app/users/messages/preview/preview.html'
                }
              }
            })

        .state('users.organizer.userGroups', stateProperty('/user-groups', 'organizer/user-groups/user-groups.html', ['eo', 'eventCoordinator'], true, true))
          .state('users.organizer.userGroups.list', stateProperty('/list', 'organizer/user-groups/list/list.html', ['eo', 'eventCoordinator'], true))
          .state('users.organizer.userGroups.details', stateProperty('/:id', 'organizer/user-groups/details/details.html', ['eo', 'eventCoordinator'], true))
        .state('users.organizer.specialUsers', stateProperty('/special-users', 'organizer/special-users/special-users.html', ['eo', 'eventCoordinator'], true))

  }

})();
angular.module("eventmap").run(["$templateCache", function($templateCache) {$templateCache.put("app/_constructor-landing/_constructor-landing.html","<div class=\"area area-page area-page-static\" role=main ng-controller=\"ConstructorLandingController as vm\" ng-init=onInit()><div class=container><div class=area-content><div class=form-group><uib-tabset active=constructorActive><uib-tab index=0 heading=HTML><div ui-ace=\"{\n              useWrapMode: false,\n              showGutter: true,\n              theme: \'xcode\',\n              mode: \'html\',\n              firstLineNumber: 1,\n              onLoad: aceHtmlLoaded,\n              onChange: aceHtmlChanged\n            }\" style=\"min-height: 640px\"></div></uib-tab><uib-tab index=1 heading=CSS><div ui-ace=\"{\n              useWrapMode: false,\n              showGutter: true,\n              theme: \'xcode\',\n              mode: \'css\',\n              firstLineNumber: 1,\n              onLoad: aceCssLoaded,\n              onChange: aceCssChanged\n            }\" style=\"min-height: 640px\"></div></uib-tab><!-- <uib-tab index=\"2\" heading=\"JavaScript\">\n            <div ui-ace=\"{\n              useWrapMode: false,\n              showGutter: true,\n              theme: \'xcode\',\n              mode: \'javascript\',\n              firstLineNumber: 1,\n              onLoad: aceJsLoaded,\n              onChange: aceJsChanged\n            }\" style=\"min-height: 640px;\"></div>\n          </uib-tab> --></uib-tabset></div><div><button class=\"btn btn-primary btn-sm\" type=button ng-click=handleSavePages() ng-bind=\"\'BUTTON.SAVE\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" ng-click=onPreview() ng-bind=\"\'BUTTON.SAVE_PREVIEW\' | translate\"></button></div></div></div></div>");
$templateCache.put("app/auth/auth.html","<div class=\"main-inner full-height\" ng-controller=\"AuthController as vm\" ng-init=onInit()><div class=\"area area-auth\" role=main><div class=area-background-image ng-if=\"currentEvent.preferences.backgroundImage && currentEvent.preferences.backgroundImage.link != \'\'\" ng-style=\"{\'background-image\': \'url(\\\'{{ currentEvent.preferences.backgroundImage.link }}\\\')\'}\"></div><div class=container style=\"width: 100%\"><div class=area-content><div ui-view></div></div></div></div><div class=\"area area-sponsor-primary\" ng-if=\"vm.event.modules.indexOf(\'sponsor\') !== -1 && vm.sponsorsHeadline.length != 0\"><div class=container-fluid><div class=area-head ng-if=\"vm.sponsorModule.primaryLabel != \'\'\"><h2 class=area-title role=heading aria-level=2 ng-bind=vm.sponsorModule.primaryLabel></h2></div><div class=area-content><div class=sponsor-group><a class=sponsor-item role=link ng-repeat=\"sponsor in vm.sponsorsHeadline | orderBy: \'order\' \" ng-href=\"{{ sponsor.website }}\" target=_blank><img role=img ng-if=\"sponsor.logo && sponsor.logo.link\" ng-src=\"{{ sponsor.logo.link }}\" alt={{sponsor.name}}> <span ng-if=\"!sponsor.logo && !sponsor.logo.link\" style=\"width: 100%; display: block; text-align: center\" ng-bind=sponsor.name></span></a></div></div></div></div><div class=\"area area-sponsor-secondary\" ng-if=\"vm.event.modules.indexOf(\'sponsor\') !== -1 && vm.sponsorsSecondary.length != 0\"><div class=container-fluid><div class=area-head ng-if=\"vm.sponsorModule.secondaryLabel != \'\'\"><h2 class=area-title role=heading aria-level=2 ng-bind=vm.sponsorModule.secondaryLabel></h2></div><div class=area-content><slick role=slider settings=slickConfig class=sponsor-carousel ng-if=vm.sponsorsSecondary.length><div class=sponsor-carousel-item ng-repeat=\"sponsors in vm.sponsorsSecondary | orderBy: \'order\' \"><div ng-if=sponsors.length><a role=link ng-repeat=\"sponsor in sponsors | orderBy: \'order\' \" ng-href=\"{{ sponsor.website }}\" target=_blank><img role=img ng-src=\"{{ sponsor.logo.link }}\" alt=\"{{ sponsor.name }}\"></a></div><a role=link ng-if=!sponsors.length ng-href=\"{{ sponsors.website }}\" target=_blank><img role=img ng-src=\"{{ sponsors.logo.link }}\" alt=\"{{ sponsors.name }}\"></a></div></slick></div></div></div></div>");
$templateCache.put("app/donations/donations.html","<div ng-controller=DonationsPageController ng-init=onInit()></div>");
$templateCache.put("app/donations-form/donations-form.html","<div ng-init=onInit()><form novalidate name=form autocomplete=off ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"vm.homePageButtonsModule.labelDonate || \'Please donate\'\"></h3></div><div class=modal-body><div class=form-group><label for=name ng-bind=\"\'FORM.label.name\' | translate\"></label><input class=form-control id=name type=text name=name placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.donation.name></div><div class=form-group ng-class=\"{ \'has-error\': form.email.$invalid && formSubmitted }\"><label for=email ng-bind=\"\'FORM.label.email\' | translate\"></label><input class=form-control id=email type=email placeholder=\"{{\'FORM.placeholder.email\' | translate}}\" ng-model=vm.donation.email name=email><div class=help-block ng-if=formSubmitted ng-messages=form.email.$error role=alert><div ng-message=email ng-bind=\"\'FORM.validation.invalidEmail\' | translate\"></div></div></div><div class=form-group><label ng-bind=\"\'FORM.label.phone\' | translate\"></label><div class=row><div class=col-xs-5><select class=form-control ng-model=vm.donation.phone.type><option value=cell ng-bind=\"\'FORM.value.phoneType.cell\' | translate\"></option><option value=work ng-bind=\"\'FORM.value.phoneType.work\' | translate\"></option><option value=home ng-bind=\"\'FORM.value.phoneType.home\' | translate\"></option></select></div><div class=col-xs-7><phone-number ng-model=vm.donation.phone.number></phone-number></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.amount.$invalid && formSubmitted }\"><label for=amount>{{\'FORM.label.amount\' | translate}}<span>&nbsp;*</span></label><div class=input-group><div class=input-group-addon>&#36;</div><input class=form-control id=amount name=amount type=number placeholder=\"{{\'FORM.placeholder.amount\' | translate}}\" min=0.000000000000001 ng-model=vm.donation.amount required></div><div class=help-block ng-if=formSubmitted ng-messages=form.amount.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div><div ng-message=min ng-bind=\"\'FORM.validation.donationAmount\' | translate\"></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> {{\'BUTTON.donate\' | translate}}</button></div></form></div>");
$templateCache.put("app/content-page/content-page.html","<div class=\"area area-page area-page-static\" role=main ng-controller=\"ContentPageController as vm\" ng-init=onInit()><div class=container><div class=area-content ng-if=errMessage><div class=not-found-404><h1>404</h1><p ng-bind=errMessage></p></div></div><div class=area-content ng-if=!errMessage ng-bind-html=\"contentPage.content | trusted\"></div></div></div>");
$templateCache.put("app/event-vendor/event-vendor.html","<div class=\"area area-page\" role=main ng-controller=\"EventVendorController as vm\" ng-init=onInit()><div class=container><div class=area-content><div class=\"row row-flex row-16\" role=row><div class=\"col-xs-12 col-md-6\" ng-repeat=\"request in vm.requests | orderBy: \'goodsCategory.name\'\" ng-show=\"request.profileVisibility == undefined || request.profileVisibility.length\"><div class=\"card card-vendor\" ng-class=vm.lightOrDark(request.goodsCategory.preferences.color)><div class=card-left ng-style=\"{\'background-color\': request.goodsCategory.preferences.color || \'#ededed\' }\"><div class=card-category ng-if=\"vm.blockVisibility(request.profileVisibility, \'categories\')\"><span class=_category ng-bind=request.goodsCategory.name></span> <span class=_description ng-bind=request.goodsCategory.description></span></div></div><div class=card-body><div class=\"card card-default\"><div class=card-head ng-if=\"vm.blockVisibility(request.profileVisibility, \'name\')\"><h2 class=card-title role=heading aria-level=2 style=\"white-space: normal\" ng-bind=request.vendor.name></h2><h4 class=card-subtitle role=heading aria-level=4 style=\"white-space: normal\" ng-bind=request.vendor.company></h4><h4 class=card-subtitle role=heading aria-level=4 style=\"white-space: normal\" ng-bind=request.vendor.description></h4></div><div class=card-body><div class=card-group ng-if=\"vm.blockVisibility(request.profileVisibility, \'location\')\"><span class=card-group-label ng-bind=\"\'LABEL.ADDRESS\' | translate\"></span><div class=card-group-value><span class=_address ng-if=request.vendor.address ng-bind=request.vendor.address></span> <span class=_city ng-if=request.vendor.city ng-bind=\"\', \'+ request.vendor.city\"></span> <span class=_state ng-if=request.vendor.state ng-bind=\"\', \'+ request.vendor.state\"></span> <span class=_zipCode ng-if=request.vendor.zipCode ng-bind=\"\', \'+ request.vendor.zipCode\"></span></div></div><div class=card-group ng-if=request.individualFeaturedItems><span class=card-group-label ng-bind=\"\'LABEL.FEATURED_ITEMS\' | translate\"></span><div class=card-group-value ng-bind=request.individualFeaturedItems></div></div><div class=card-group ng-if=\"\n                        vm.blockVisibility(request.profileVisibility, \'contact\') &&\n                        request.vendor.email\n                       \"><span class=card-group-label ng-bind=\"\'LABEL.EMAIL\' | translate\"></span><div class=card-group-value ng-bind=request.vendor.email></div></div><div class=card-group ng-if=\"\n                        vm.blockVisibility(request.profileVisibility, \'contact\') &&\n                        request.vendor.phone1 && request.vendor.phone1.number\n                       \"><span class=card-group-label ng-bind=\"request.vendor.phone1.type +\':\'\"></span><div class=card-group-value ng-bind=\"request.vendor.phone1.number | formatPhone\"></div></div><div class=card-group ng-if=\"\n                        vm.blockVisibility(request.profileVisibility, \'contact\') &&\n                        request.vendor.phone2 && request.vendor.phone2.number\n                       \"><span class=card-group-label ng-bind=\"request.vendor.phone2.type +\':\'\"></span><div class=card-group-value ng-bind=\"request.vendor.phone2.number | formatPhone\"></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/home/home.html","<div ng-controller=\"HomeController as vm\" class=\"main-inner full-height\" ng-init=onInit()><div ng-if=\"showConstructorResult || vm.showCustomHomePage\" class=custom-wrap><style type=text/css ng-bind=staticCssContent></style><!-- style --><div class=custom-wrap-inner ng-bind-html=\"staticHtmlContent | trusted\"></div></div><div class=\"area area-event\" ng-if=\"!showConstructorResult && !vm.showCustomHomePage\" role=main><div class=area-background-image ng-if=\"vm.preferences.backgroundImage && vm.preferences.backgroundImage.link != \'\'\" ng-style=\"{\'background-image\': \'url(\\\'{{ vm.preferences.backgroundImage.link }}\\\')\'}\"></div><div class=container><div class=\"card card-event\" ng-class=\"\'-\'+ vm.preferences.eventBoxSize\"><div class=card-head><h1 class=card-title role=heading aria-level=1 ng-bind-html=\"vm.event.name | trusted\"></h1><h3 class=card-subtitle role=heading aria-level=3><i class=\"fa fa-map-marker\"></i> <span ng-bind=vm.event.address></span></h3></div><div class=card-body><div class=card-group ng-if=vm.preferences.showEventStartEndDate><div class=card-group-value ng-if=vm.isSameDate><span ng-bind=vm.eventStartDate></span></div><div class=card-group-value ng-if=!vm.isSameDate><span ng-bind=vm.eventStartDate></span> - <span ng-bind=vm.eventEndDate></span></div><div class=card-group-value><span ng-bind=vm.eventStartTime></span> - <span ng-bind=vm.eventEndTime></span></div></div><div class=card-group><div class=card-group-value role=text ta-bind ng-model=vm.event.description></div></div></div><div class=card-foot ng-if=\"\n                vm.homePageButtonsModule.enableEventMap ||\n                vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType) ||\n                vm.scheduleModule.enabled ||\n                vm.vendorModule.button && vm.event.status === \'published\'\n             \"><a class=\"btn btn-default\" ng-if=vm.homePageButtonsModule.enableEventMap ui-sref=app.publicMapMain role=link ng-bind=\"vm.homePageButtonsModule.labelEventMap || \'Event map\'\"></a> <a class=\"btn btn-info btn-sm\" role=link ng-if=\"vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)\" ui-sref=app.home.donations ng-bind=\"vm.homePageButtonsModule.labelDonate || \'Donate\'\"></a> <a class=\"btn btn-default btn-sm\" role=link ng-if=vm.scheduleModule.enabled ui-sref=app.schedule ng-bind=\"vm.homePageButtonsModule.labelSchedule || \'Schedule\'\"></a> <a class=\"btn btn-default btn-sm\" role=link ng-if=\"vm.vendorModule.button && vm.event.status === \'published\'\" ui-sref=app.eventVendor><span ng-bind=\"vm.vendorModule.buttonLabel || \'Event vendor\'\"></span></a></div></div><event-countdown role=timer ng-if=vm.preferences.countdownClock date=\"{{ vm.countdownDate }}\" class=event-countdown></div></div><div class=\"area area-sponsor-primary\" ng-if=\"vm.event.modules.indexOf(\'sponsor\') > -1 && !showConstructorResult && !vm.showCustomHomePage && vm.sponsorsHeadline.length != 0\"><div class=container-fluid><div class=area-head ng-if=\"vm.sponsorModule.primaryLabel != \'\'\"><h2 class=area-title role=heading aria-level=2 ng-bind=vm.sponsorModule.primaryLabel></h2></div><div class=area-content><div class=sponsor-group><a class=sponsor-item role=link ng-repeat=\"sponsor in vm.sponsorsHeadline | orderBy: \'order\' \" ng-href=\"{{ sponsor.website }}\" target=_blank><img role=img ng-if=\"sponsor.logo && sponsor.logo.link\" ng-src=\"{{ sponsor.logo.link }}\" alt={{sponsor.name}}> <span ng-if=\"!sponsor.logo && !sponsor.logo.link\" style=\"width: 100%; display: block; text-align: center\" ng-bind=sponsor.name></span></a></div></div></div></div><div class=\"area area-sponsor-secondary\" ng-if=\"vm.event.modules.indexOf(\'sponsor\') > -1 && !showConstructorResult && !vm.showCustomHomePage && vm.sponsorsSecondary.length != 0\"><div class=container-fluid><div class=area-head ng-if=\"vm.sponsorModule.secondaryLabel != \'\'\"><h2 class=area-title role=heading aria-level=2 ng-bind=vm.sponsorModule.secondaryLabel></h2></div><div class=area-content><slick role=slider settings=slickConfig class=sponsor-carousel ng-if=vm.sponsorsSecondary.length><div class=sponsor-carousel-item ng-repeat=\"sponsors in vm.sponsorsSecondary | orderBy: \'order\' \"><div ng-if=sponsors.length><a role=link ng-repeat=\"sponsor in sponsors | orderBy: \'order\' \" ng-href=\"{{ sponsor.website }}\" target=_blank><img role=img ng-if=\"sponsor.logo && sponsor.logo.link\" ng-src=\"{{ sponsor.logo.link }}\" alt={{sponsor.name}}> <span ng-if=\"!sponsor.logo && !sponsor.logo.link\" style=\"width: 100%; display: block; text-align: center\" ng-bind=sponsor.name></span></a></div><a target=_blank role=link ng-if=!sponsors.length ng-href=\"{{ sponsors.website }}\"><img role=img ng-if=\"sponsors.logo && sponsors.logo.link\" ng-src=\"{{ sponsors.logo.link }}\" alt={{sponsor.name}}> <span ng-if=\"!sponsors.logo && !sponsors.logo.link\" ng-bind=sponsors.name></span></a></div></slick></div></div></div></div><div ui-view=modal></div>");
$templateCache.put("app/payeezy-form/payeezy-form.html","<div ng-init=onInit()><div class=modal-header><h3 class=modal-title ng-bind=\"\'Payeezy form\'\"></h3></div><div class=modal-body><form id=order_form name=form><div class=form-group><label for=cardName>Name</label><input type=text class=form-control name=name id=cardName placeholder=Name></div><div class=form-group><label for=cardNumber>Card number</label><input class=form-control id=cardNumber type=text name=cardNumber ng-model=cardNumber ui-mask=\"9999 9999 9999 9999\" ui-mask-placeholder required><!-- <div class=\"row row-8\">\n          <div class=\"col-xs-3\">\n            <input type=\"text\" class=\"form-control\" name=\"cc1\"\n                   maxlength=\"4\" placeholder=\"9999\" />\n          </div>\n          <div class=\"col-xs-3\">\n            <input type=\"text\" class=\"form-control\" name=\"cc2\"\n                   maxlength=\"4\" placeholder=\"9999\" />\n          </div>\n          <div class=\"col-xs-3\">\n            <input type=\"text\" class=\"form-control\" name=\"cc3\"\n                   maxlength=\"4\" placeholder=\"9999\" />\n          </div>\n          <div class=\"col-xs-3\">\n            <input type=\"text\" class=\"form-control\" name=\"cc4\"\n                   maxlength=\"4\" placeholder=\"9999\" />\n          </div>\n        </div> --></div><div class=form-group><div class=\"row row-16\"><div class=col-xs-7><label for=cardExpirationDate>Expiration Date</label><div class=\"row row-8\"><div class=col-xs-6><input type=text class=form-control name=expirationDateMM maxlength=2 placeholder=MM></div><div class=col-xs-6><input type=text class=form-control name=expirationDateYY maxlength=2 placeholder=YY></div></div></div><div class=col-xs-5><label for=cardCVV>CVV</label><input type=text class=form-control name=cvv id=cardCVV maxlength=3 placeholder=CVV></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary\" type=button id=submitForm ng-disabled=isLoading><i ng-if=isLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.pay\' | translate\"></span></button></div></div>");
$templateCache.put("app/public-map/available-booth.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h4 class=modal-title ng-bind=\"\'Show available booth(s)\'\"></h4></div><div class=modal-body><div class=\"row row-16\"><div class=col-xs-6><div class=form-group ng-class=\"{ \'has-error\': form.availableFrom.$invalid && form.$submitted }\"><label for=availableFrom><span ng-bind=\"\'Available from\'\"></span> <span>&nbsp;*</span></label><div class=input-group><input type=date name=availableFrom ng-model=vm.availableFrom max={{vm.availableTo}} class=hidden required> <span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=onPopup1Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=startDate ng-model=vm.availableFromDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=popup1.opened show-button-bar=false ng-change=\"vm.availableFrom = vm.availableFromDate\"></div><div class=help-block style=\"margin-bottom: -18px\" ng-if=form.$submitted ng-messages=form.availableFrom.$error role=alert><div ng-message=max ng-bind=\"\'Start date is more than end\'\"></div><div ng-message=date ng-bind=\"\'FORM.validation.invalidDate\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=col-xs-6><div class=form-group ng-class=\"{ \'has-error\': form.availableTo.$invalid && form.$submitted }\"><label for=availableTo><span ng-bind=\"\'Available to\'\"></span> <span>&nbsp;*</span></label><div class=input-group><input type=date name=availableTo ng-model=vm.availableTo class=hidden required> <span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=onPopup2Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=endDate ng-model=vm.availableToDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=popup2.opened show-button-bar=false ng-change=\"vm.availableTo = vm.availableToDate\"></div><div class=help-block style=\"margin-bottom: -18px\" ng-if=form.$submitted ng-messages=form.availableTo.$error role=alert><div ng-message=date ng-bind=\"\'FORM.validation.invalidDate\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button ng-click=handleCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.submit\' | translate\"></span></button></div></form>");
$templateCache.put("app/public-map/public-map.html","<style>.availableD { display: block; margin-bottom: 8px; padding-top: 4px; font-size: 14px; }\n\n  @media screen and (min-width: 768px){\n    .availableD { display: inline-block; margin-bottom: 0; padding-top: 0; padding-left: 4px; }\n  }</style><div class=\"area area-page area-page-volunteer\" role=main ng-controller=\"PublicMapController as vm\" ng-init=onInit()><div class=area-controller><div class=container-fluid><div class=area-content><div class=form-group style=\"margin-bottom: 8px\"><div style=\"display: inline-block; vertical-align: top\" ng-if=showBoothIndoorMaps><a class=\"btn btn-primary btn-sm\" role=button ui-sref=app.publicMapMain><i class=\"fa fa-arrow-left\" aria-hidden=true></i> {{\'BUTTON.MAIN_MAP\' | translate}}</a><div class=btn-group style=\"margin-right: 0; margin-bottom: 0\" uib-dropdown><button type=button class=\"btn btn-default btn-sm\" uib-dropdown-toggle><span ng-bind=currentIndoorMapName(indoorIndoorMaps).name></span> <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=split-button><li ng-repeat=\"indoorMap in indoorIndoorMaps\"><a ui-sref=\"app.publicMapIndoor({ id: indoorMap.id, boothID: boothID, search: \'\' })\" ng-bind=indoorMap.name></a></li></ul></div></div><button class=\"btn btn-info btn-sm\" type=button ng-if=currentEvent.preferences.enableReservationAvailability ng-click=handleShowAvailable()><span ng-bind=\"!getAvailable ? \'Show only available\' : \'Show all\'\"></span></button><div style=\"display: inline-block; vertical-align: top\" ng-if=foundIndoorBooths.length><div class=btn-group style=\"margin-bottom: 0; margin-right: 0\" uib-dropdown><button type=button class=\"btn btn-default btn-sm\" uib-dropdown-toggle><span ng-bind=\"\'BUTTON.ALSO_FOUND_AT\' | translate\"></span> <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=list aria-labelledby=split-button><li ng-repeat=\"indoor in foundIndoorBooths\" role=listitem><a role=link ui-sref=\"app.publicMapIndoor({ id: indoor.id, search: indoorQuery  })\" ng-bind=indoor.name></a></li></ul></div></div><span class=availableD ng-if=getAvailable>Available for {{availableFrom | dateFormatedOnlyM}} - {{availableTo | dateFormatedOnlyM}} </span><button class=\"btn btn-sm btn-default\" type=button ng-if=getAvailable ng-click=handleEditAvailable()><i class=\"fa fa-pencil\" aria-hidden=true></i></button></div><div class=map-wrap><div class=indoor-map-group style=\"margin-top: {{ mapData.type === \'outdoor\' ? \'40px\' : \'0px\' }}; margin-left: 12px\"><span class=map-badge-length ng-hide=\"foundBooths.length === 0 || foundBooths === booths.length\" ng-bind=foundBooths.length></span><div class=\"form-group form-group-map\"><input class=\"form-control form-control-search\" id=map-search type=text placeholder=\"Search ...\" ng-model=mapFields.search ng-change=\"handleMapSearch({ search: mapFields.search, boothCategory: mapFields.boothCategory })\" ng-model-options=\"{ debounce: 1000 }\"></div><div class=\"form-group form-group-map\"><select class=\"form-control form-control-category\" name=boothType id=map-booth-types ng-model=mapFields.boothCategory ng-change=\"handleMapSearch({ search: mapFields.search, boothCategory: mapFields.boothCategory })\" ng-options=\"booth as booth.name group by booth.type for booth in boothCategories track by booth.value\"><option value=\"\" ng-bind=\"\'FORM.value.chooseFilterOptions\' | translate\"></option></select></div></div><div ng-if=!showPosition class=\"map-btn-group _right\" id=indoorMapZoomInOutGroup><span class=\"map-btn _zoom\" id=indoorMapZoomIn><i class=\"fa fa-plus\" aria-hidden=true></i></span> <span class=\"map-btn _zoom\" id=indoorMapZoomOut><i class=\"fa fa-minus\" aria-hidden=true></i></span></div><div map-calculate map-calculate-space=48 id=mapWrap style=\"background-color: #ededed\"><div id=map style=\"width: 100%; height: 100%\"></div></div></div></div></div></div></div>");
$templateCache.put("app/schedule/schedule.html","<div class=\"main-inner full-height\" ng-controller=\"ScheduleController as vm\" ng-init=onInit()><div class=\"area area-page area-schedule\"><div class=area-background-image ng-if=\"vm.preferences.backgroundImage && vm.preferences.backgroundImage.link != \'\'\" ng-style=\"{\'background-image\': \'url(\\\'{{ vm.preferences.backgroundImage.link }}\\\')\'}\"></div><div class=container><div class=area-content><div ng-if=\"vm.program && vm.program.length !== 0\"><div class=filter style=\"border: 0\" ng-if=\"vm.locations.length > 1\"><label class=form-group><select class=form-control name=filterLocation ng-change=handleChangeLocation(filterLocation) ng-model=filterLocation><option value=\"\">All locations</option><option ng-repeat=\"location in vm.locations track by $index\" ng-value=location ng-bind=location></option></select></label></div><slick settings=slickConfigSchedule class=slick-schedule><div ng-repeat=\"program in vm.program\" ng-class=\"{\'active\': isSameDay(program.date)}\"><h3><span ng-bind=program.date></span> <span style=\"display: block; font-size: 14px; font-weight: 400; line-height: 1.2\" ng-bind=\"moment(program.date).format(\'dddd\')\"></span></h3><!-- Locations --><ul ng-if=\"program.locations && program.locations.length !== 0\" class=\"location-list programList\" style=\"overflow-y: auto\"><li ng-repeat=\"location in program.locations\n                    | filter: filterScheduleLocation\n                    | orderBy:\'name\'\n                    \"><h3 ng-if=location.name ng-bind=location.name></h3><hr ng-if=!location.name><!-- Schedules --><ul ng-if=\"location.schedules && location.schedules.length !== 0\" class=schedule-list><li ng-repeat=\"schedule in location.schedules | orderBy:\'start\'\"><p><b ng-bind=formatTime(schedule.start)></b> &nbsp;-&nbsp; <b ng-bind=formatTime(schedule.end)></b></p><p ng-bind=schedule.description></p></li></ul></li></ul><!-- Schedules --><ul ng-if=\"program.schedules && program.schedules.length !== 0\" class=\"schedule-list programList\" style=\"overflow-y: auto\"><li ng-repeat=\"\n                  schedule in program.schedules\n                  | filter: filterScheduleLocation\n                  | orderBy:\'start\'\n                 \"><p><b ng-bind=formatTime(schedule.start)></b> &nbsp;-&nbsp; <b ng-bind=formatTime(schedule.end)></b> <span ng-if=schedule.location ng-bind=\"\'(\'+ schedule.location +\')\'\"></span></p><p ng-bind=schedule.description></p></li></ul></div></slick></div><div ng-if=\"vm.program && vm.program.length === 0\"><div class=no-message><i class=\"fa fa-calendar\" aria-hidden=true></i><h3 ng-bind=\"\'TEXT.NO_SCHEDULES\' | translate\"></h3></div></div></div></div></div><div class=\"area area-sponsor-primary\" ng-if=\"vm.event.modules.indexOf(\'sponsor\') !== -1 && vm.sponsorsHeadline.length != 0\"><div class=container-fluid><div class=area-head ng-if=\"vm.sponsorModule.primaryLabel != \'\'\"><h2 class=area-title role=heading aria-level=2 ng-bind=vm.sponsorModule.primaryLabel></h2></div><div class=area-content><div class=sponsor-group><a class=sponsor-item role=link ng-repeat=\"sponsor in vm.sponsorsHeadline | orderBy: \'order\' \" ng-href=\"{{ sponsor.website }}\" target=_blank><img role=img ng-if=\"sponsor.logo && sponsor.logo.link\" ng-src=\"{{ sponsor.logo.link }}\" alt={{sponsor.name}}> <span ng-if=\"!sponsor.logo && !sponsor.logo.link\" style=\"width: 100%; display: block; text-align: center\" ng-bind=sponsor.name></span></a></div></div></div></div><div class=\"area area-sponsor-secondary\" ng-if=\"vm.event.modules.indexOf(\'sponsor\') !== -1 && vm.sponsorsSecondary.length != 0\"><div class=container-fluid><div class=area-head ng-if=\"vm.sponsorModule.secondaryLabel != \'\'\"><h2 class=area-title role=heading aria-level=2 ng-bind=vm.sponsorModule.secondaryLabel></h2></div><div class=area-content><slick role=slider settings=slickConfig class=sponsor-carousel ng-if=vm.sponsorsSecondary.length><div class=sponsor-carousel-item ng-repeat=\"sponsors in vm.sponsorsSecondary | orderBy: \'order\' \"><div ng-if=sponsors.length><a role=link ng-repeat=\"sponsor in sponsors | orderBy: \'order\' \" ng-href=\"{{ sponsor.website }}\" target=_blank><img role=img ng-src=\"{{ sponsor.logo.link }}\" alt=\"{{ sponsor.name }}\"></a></div><a role=link ng-if=!sponsors.length ng-href=\"{{ sponsors.website }}\" target=_blank><img role=img ng-src=\"{{ sponsors.logo.link }}\" alt=\"{{ sponsors.name }}\"></a></div></slick></div></div></div></div>");
$templateCache.put("app/squareup-form/squareup-form.html","<div ng-init=onInit()><form novalidate id=payment-form name=form autocomplete=off style=\"display: block\"><div class=modal-header><h3 class=modal-title ng-bind=\"\'DIALOG.TITLE.SQUAREUP_PAYMENT\' | translate\"></h3></div><div class=modal-body><div id=payment-status-container></div><div id=card-container></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleCancel() ng-bind=\"\'BUTTON.DIALOG.CANCEL\' | translate\"></button> <button class=\"btn btn-primary\" id=card-button type=submit ng-click=onClick() ng-disabled=isLoading><i ng-if=isLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> {{\'BUTTON.PAY\' | translate}}</button></div></form></div>");
$templateCache.put("app/static/about.html","<div class=\"area area-page area-page-static\" role=main ng-controller=\"StaticPageController as vm\" ng-init=onInit()><div class=area-background-image ng-if=\"currentEvent.preferences.backgroundImage && currentEvent.preferences.backgroundImage.link != \'\'\" ng-style=\"{\'background-image\': \'url(\\\'{{ currentEvent.preferences.backgroundImage.link }}\\\')\'}\"></div><div class=container><div class=area-content><div ng-bind-html=\"vm.pageAbout.content | trusted\"></div></div></div></div>");
$templateCache.put("app/static/contact.html","<div class=\"area area-page area-page-static\" role=main ng-controller=\"StaticPageController as vm\" ng-init=onInit()><div class=area-background-image ng-if=\"currentEvent.preferences.backgroundImage && currentEvent.preferences.backgroundImage.link != \'\'\" ng-style=\"{\'background-image\': \'url(\\\'{{ currentEvent.preferences.backgroundImage.link }}\\\')\'}\"></div><div class=container><div class=area-content><div ng-bind-html=\"vm.pageContact.content | trusted\"></div></div></div></div>");
$templateCache.put("app/users/request-preview.html","<div class=modal-header><h3 class=modal-title ng-bind=\"\'DIALOG.TITLE.REQUEST_PREVIEW\' | translate\"></h3></div><div class=modal-body><div class=form-group><label for=goodsCategory ng-bind=\"\'FORM.REQUEST_PREVIEW.GOODS_CATEGORY\' | translate\"></label><select class=form-control id=goodsCategory name=goodsCategory ng-options=\"category as category.name for category in categories track by category.id\" ng-model=request.goodsCategory disabled></select></div><div class=form-group><label for=description ng-bind=\"\'FORM.REQUEST_PREVIEW.DESCRIPTION\' | translate\"></label><textarea class=form-control id=description type=text name=description placeholder=\"{{\'FORM.REQUEST_PREVIEW.DESCRIPTION\' | translate }}\" ng-model=request.description disabled>\n      </textarea></div><div class=form-group><label for=individualFeaturedItems ng-bind=\"\'FORM.REQUEST_PREVIEW.INDIVIDUAL_FEATURED_ITEMS\' | translate\"></label><textarea class=form-control id=individualFeaturedItems type=text name=individualFeaturedItems placeholder=\"{{ \'FORM.REQUEST_PREVIEW.INDIVIDUAL_FEATURED_ITEMS\' | translate }}\" ng-model=request.individualFeaturedItems disabled>\n      </textarea></div><div class=form-group><label ng-bind=\"\'FORM.REQUEST_PREVIEW.PROFILE_VISIBILITY\' | translate\"></label><input type=hidden ng-model=request.profileVisibility><div class=checkbox ng-repeat=\"item in visibility track by $index\"><label><input type=checkbox value=\"{{ item.value }}\" ng-click=profileChecked(item.value) ng-checked=\"request.profileVisibility.indexOf(item.value) > -1\" disabled> <i class=label></i> <span ng-bind=item.name></span></label></div></div><div class=form-group ng-if=\"currentUser.type === \'eo\'\"><label class=package ng-bind=\"\'FORM.REQUEST_PREVIEW.PRICE_PACKAGE\' | translate\"></label><select class=form-control id=packages name=packages ng-model=vm.modelPackage ng-options=\"price as price.name for price in prices track by price.id\" ng-change=handlePricePackage() disabled><option value=\"\" ng-bind=\"\'FORM.CHOOSE_PACKAGE\' | translate\"></option></select></div><div class=row ng-if=\"currentEvent.billingPreferences && currentEvent.billingPreferences.serviceType !== \'\'\"><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=price ng-bind=\"\'FORM.REQUEST_PREVIEW.PRICE\' | translate\"></label><div class=input-group><div class=input-group-addon>&#36;</div><input class=form-control id=price name=price type=number placeholder=\"{{\'FORM.REQUEST_PREVIEW.PRICE\' | translate}}\" ng-model=modelPackage.price disabled></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label for=date ng-bind=\"\'FORM.REQUEST_PREVIEW.DUE_DATE\' | translate\"></label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button disabled><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=startDate ng-model=startDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=datepickerPopup.opened show-button-bar=false disabled></div></div></div></div><div class=form-group ng-if=request.boothPhotos.length><label ng-bind=\"\'FORM.REQUEST_PREVIEW.BOOTH_PHOTOS\' | translate\"></label><div class=photo-preview ng-if=\"request.boothPhotos && request.boothPhotos.length !== 0\"><div class=photo-preview-item ng-repeat=\"photo in request.boothPhotos track by $index\"><div class=inner><img ng-click=handlePhotoPreview(photo) ng-src=\"{{ photo.link }}\" alt=\"\"></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.DIALOG.CLOSE\' | translate\"></button></div>");
$templateCache.put("app/users/users.html","<div class=wrapper ng-controller=\"UserController as vm\" ng-init=onInit()><nav-bar></nav-bar><div class=container ng-if=rootLoading><div class=no-message><i style=\"font-size: 48px\" class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div></div><div class=container-fluid ng-if=!rootLoading><div class=\"alert alert-danger alert-dismissible\" role=alert style=\"margin-top: 16px; margin-bottom: 16px\" ng-class=\"{\'hide\': isHidden }\" ng-if=\"user.type == \'eo\' && !currentSubscription\"><button type=button class=close data-dismiss=alert aria-label=Close ng-click=\"isHidden = !isHidden\"><span aria-hidden=true>&times;</span></button><p ng-bind=\"\'MESSAGE.NO_ACTIVE_SUBSCRIPTION\' | translate\"></p></div><div class=\"alert alert-danger alert-dismissible\" role=alert style=\"margin-top: 16px; margin-bottom: 16px\" ng-class=\"{\'hide\': isHidden }\" ng-if=\"user.type == \'eo\' && (quoEvent || quoMembers || quoText || quoEmail) && currentSubscription\"><button type=button class=close data-dismiss=alert aria-label=Close ng-click=\"isHidden = !isHidden\"><span aria-hidden=true>&times;</span></button><p><strong ng-if=quoEvent><span ng-bind=\"\'MESSAGE.EXCEEDED.EVENT\' | translate\"></span><span ng-bind=vm.quota.maxNumberOfEvents></span></strong></p><p><strong ng-if=quoMembers><span ng-bind=\"\'MESSAGE.EXCEEDED.MEMBER\' | translate\"></span><span ng-bind=vm.quota.maxNumberOfMembers></span></strong></p><p><strong ng-if=quoText><span ng-bind=\"\'MESSAGE.EXCEEDED.MESSAGE\' | translate\"></span><span ng-bind=vm.quota.maxNumberOfTextMessages></span></strong></p><p><strong ng-if=quoEmail><span ng-bind=\"\'MESSAGE.EXCEEDED.EMAIL\' | translate\"></span><span ng-bind=vm.quota.maxNumberOfEmailMessages></span></strong></p><p ng-bind=\"\'TEXT.UPDATE_SUBSCRIPTION_PACKAGE\' | translate\"></p></div></div><div class=main><div ui-view ng-if=!rootLoading></div></div><foot-bar></foot-bar></div>");
$templateCache.put("app/auth/login/login.html","<div ng-controller=\"LoginController as vm\"><form novalidate role=form name=form ng-submit=handleSubmit()><div class=form-group ng-class=\"{\'has-error\': form.username.$invalid && formSubmitted}\"><label for=username>{{\'FORM.label.username\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=username type=text name=username placeholder=\"{{\'FORM.placeholder.username\' | translate}}\" ng-model=vm.user.username required><div class=help-block ng-if=formSubmitted ng-messages=form.username.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{\'has-error\': form.password.$invalid && formSubmitted}\"><label for=password>{{\'FORM.label.password\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=password type=password name=password placeholder=\"{{\'FORM.placeholder.password\' | translate}}\" ng-model=vm.user.password required><div class=help-block ng-if=formSubmitted ng-messages=form.password.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div><button class=\"btn btn-primary\" role=button type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.login\' | translate\"></span></button> <a class=\"btn btn-link\" role=link ui-sref=app.auth.resetPassword ng-bind=\"\'BUTTON.forgotPassword\' | translate\"></a></div></form></div>");
$templateCache.put("app/auth/reset-password/reset-password.html","<div ng-controller=\"ResetPasswordController as vm\"><form novalidate role=form name=form ng-submit=handleSubmit()><div class=form-group ng-class=\"{ \'has-error\': form.username.$invalid && formSubmitted }\"><label for=username>{{\'FORM.label.username\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=username type=username placeholder=\"{{\'FORM.label.username\' | translate}}\" ng-model=vm.user.username name=username required><div class=help-block ng-if=formSubmitted ng-messages=form.username.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div><button class=\"btn btn-primary\" role=button type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.resetPassword\' | translate\"></span></button></div></form></div>");
$templateCache.put("app/auth/register/register.html","<div ng-controller=\"RegisterController as vm\" ng-init=onInit()><form novalidate role=form name=form ng-submit=handleSubmit()><div class=form-group ng-if=\"\n          (vm.event.modules.indexOf(\'participant\') !== -1 && vm.participantModule.enableRegister) ||\n          (vm.event.modules.indexOf(\'sponsor\') !== -1 && vm.sponsorModule.enableRegister) ||\n          (vm.event.modules.indexOf(\'vendor\') !== -1 && vm.vendorModule.enableRegister) ||\n          (vm.event.modules.indexOf(\'volunteer\') !== -1 && vm.volunteerModule.enableRegister)\n         \" ng-class=\"{ \'has-error\': form.type.$invalid && formSubmitted }\"><label for=type>{{\'FORM.label.userType\' | translate}}<span>&nbsp;*</span></label><select class=form-control name=type ng-model=vm.user.type id=type required><option value=\"\" ng-bind=\"\'Choose user type\'\"></option><option value=vendor ng-bind=vm.vendorModule.label ng-if=\"vm.event.modules.indexOf(\'vendor\') > -1 && vm.vendorModule.enableRegister\"></option><option value=volunteer ng-bind=vm.volunteerModule.label ng-if=\"vm.event.modules.indexOf(\'volunteer\') > -1 && vm.volunteerModule.enableRegister\"></option><option value=participant ng-bind=vm.participantModule.label ng-if=\"vm.event.modules.indexOf(\'participant\') > -1 && vm.participantModule.enableRegister\"></option><option value=sponsor ng-bind=vm.sponsorModule.label ng-if=\"vm.event.modules.indexOf(\'sponsor\') > -1 && vm.sponsorModule.enableRegister\"></option></select><div class=help-block ng-if=formSubmitted ng-messages=form.type.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.username.$invalid && formSubmitted }\"><label for=username>{{\'FORM.label.username\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=username type=text placeholder=\"{{\'FORM.placeholder.username\' | translate}}\" ng-model=vm.user.username name=username required><div class=help-block ng-if=formSubmitted ng-messages=form.username.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name>{{\'FORM.label.name\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=name type=text placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.user.name name=name required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.email.$invalid && formSubmitted }\"><label for=email>{{\'FORM.label.email\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=email type=email placeholder=\"{{\'FORM.placeholder.email\' | translate}}\" ng-model=vm.user.email name=email required><div class=help-block ng-if=formSubmitted ng-messages=form.email.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=email ng-bind=\"\'FORM.validation.invalidEmail\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.password.$invalid && formSubmitted }\"><label for=password>{{\'FORM.label.password\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=password type=password placeholder=\"{{\'FORM.placeholder.password\' | translate}}\" ng-model=vm.user.password name=password ng-minlength=6 required><div class=help-block ng-if=formSubmitted ng-messages=form.password.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=minlength ng-bind=\"\'FORM.validation.minLength\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.rePassword.$invalid && formSubmitted }\"><label for=rePassword>{{\'FORM.label.rePassword\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=rePassword type=password placeholder=\"{{\'FORM.placeholder.rePassword\' | translate}}\" ng-model=vm.user.rePassword name=rePassword ng-minlength=6 match=vm.user.password required><div class=help-block ng-if=formSubmitted ng-messages=form.rePassword.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=minlength ng-bind=\"\'FORM.validation.minLength\' | translate\"></div><div ng-message=match ng-bind=\"\'FORM.validation.notMatchPassword\' | translate\"></div></div></div><div class=form-group style=\"margin-bottom: 20px\"><label ng-bind=\"\'FORM.label.phone\' | translate\"></label><div class=row role=row><div class=col-md-12><div class=\"row row-8\"><div class=col-xs-5><select class=\"form-control input-sm\" id=phoneType name=phoneType ng-init=\"vm.user.phone1.type = \'cell\'\" ng-model=vm.user.phone1.type><option value=cell ng-bind=\"\'FORM.value.phoneType.cell\' | translate\"></option><option value=work ng-bind=\"\'FORM.value.phoneType.work\' | translate\"></option><option value=home ng-bind=\"\'FORM.value.phoneType.home\' | translate\"></option></select></div><div class=col-xs-7><phone-number ng-model=vm.user.phone1.number></phone-number></div></div></div></div><p class=\"help-block help-block-default\" ng-bind=\"\'FORM.AUTH.PHONE_LABEL\' | translate\"></p></div><div ng-if=\"\n      (vm.event.modules.indexOf(\'participant\') !== -1 && vm.participantModule.enableRegister) ||\n      (vm.event.modules.indexOf(\'sponsor\') !== -1 && vm.sponsorModule.enableRegister) ||\n      (vm.event.modules.indexOf(\'vendor\') !== -1 && vm.vendorModule.enableRegister) ||\n      (vm.event.modules.indexOf(\'volunteer\') !== -1 && vm.volunteerModule.enableRegister)\n    \"><button class=\"btn btn-primary\" role=button type=submit><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.register\' | translate\"></span></button></div></form></div>");
$templateCache.put("app/directives/calendar-reservation/calendar-reservation.html","<div class=calendar-reservation ng-init=onInit()><div class=calendar-reservation-head><button class=calendar-reservation-head-btn ng-click=prev()><i class=\"fa fa-angle-left\"></i></button> <span class=calendar-reservation-head-title>{{month.format(\'MMMM, YYYY\')}}</span> <button class=calendar-reservation-head-btn ng-click=next()><i class=\"fa fa-angle-right\"></i></button></div><div class=calendar-reservation-body><div class=week><div class=week-head><span>Sun</span> <span>Mon</span> <span>Tue</span> <span>Wed</span> <span>Thu</span> <span>Fri</span> <span>Sat</span></div><div class=week-body><div class=week-row ng-repeat=\"week in weeks\"><span class=week-day ng-repeat=\"day in week.days\" ng-class=\"{\n                  \'today\': day.isToday,\n                  \'different-month\': !day.isCurrentMonth,\n                  \'selected\': day.date.isSame(selectedDay, \'day\')\n                }\" ng-click=selectDay(day)><i ng-if=\"_has(day).available && _has(day).showPast\" class=_circle style=\"background-color: #5cb85c\"></i> <span ng-bind=day.number></span></span></div></div></div></div><div class=calendar-reservation-foot *ngif=selectedDay><b>{{selectedDay.format(\'DD MMMM, YYYY\')}}</b></div></div>");
$templateCache.put("app/directives/bulk-users/bulk-users.html","<div ng-init=onInit()><div class=form-group><button class=\"btn btn-info btn-sm\" type=button ng-click=addUser() ng-bind=\"\'BUTTON.addMore\' | translate\"></button></div><div class=form-group ng-if=\"userType === \'volunteer\'\"><div class=checkbox><label><input type=checkbox name=automaticallyAccept ng-model=automaticallyAccept ng-change=onChangeAutoAccept(automaticallyAccept)> <span ng-bind=\"\'FORM.value.automaticallyAccept\' | translate\"></span></label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=skipEmailNotification ng-model=skipEmailNotification> <span ng-bind=\"\'FORM.value.skipEmailNotification\' | translate\"></span></label></div></div><div class=form-group ng-if=\"userType === \'participant\'\"><div class=checkbox><label><input type=checkbox name=skipPackageEmailNotification ng-model=skipPackageEmailNotification ng-change=onChangeSkipPackage(skipPackageEmailNotification)> <span ng-bind=\"\'FORM.value.skipPackageEmailNotification\' | translate\"></span></label></div></div><div class=\"form-group clearfix\" ng-if=bulkUsers.length><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (appView ? (appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (appView ? (appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><form novalidate name=form><table class=\"table table-request\" ng-class=\"\'table-\'+ (appView ? appView : \'grid\')\"><thead><tr><th ng-bind=\"\'Name/Username\'\"></th><th ng-bind=\"\'E-mail/Password\'\"></th><th ng-bind=\"\'User groups\'\"></th><th ng-bind=\"\'Phone\'\" ng-if=\"userType === \'vendor\' || userType === \'volunteer\' || userType === \'sponsor\'\"></th><th ng-bind=\"\'Package/Bib\'\" ng-if=\"userType === \'participant\'\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"user in bulkUsers track by $index\"><td><!-- <div class=\"row row-8\">\n              <div class=\"col-xs-12 col-sm-6\"> --><div class=form-group ng-class=\"{\'has-error\': form[user.fieldName].$invalid && formSubmitted, \'has-success\': user.success }\"><label for=bulkUserName><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span ng-bind=\"\'&nbsp;*\'\"></span></label><input class=\"form-control input-sm\" type=text name={{user.fieldName}} placeholder=\"{{\'FORM.label.name\' | translate}}\" ng-model=user.name ng-disabled=user.success required><div class=help-block role=alert ng-if=formSubmitted ng-messages=form[user.fieldName].$error><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><!-- </div>\n              <div class=\"col-xs-12 col-sm-6\"> --><div class=form-group ng-class=\"{\'has-error\': form[user.fieldUsername].$invalid && formSubmitted, \'has-success\': user.success }\"><label for=bulkUserUsername><span ng-bind=\"\'FORM.label.username\' | translate\"></span> <span ng-bind=\"\'&nbsp;*\'\"></span></label><input class=\"form-control input-sm\" type=text name=\"{{ user.fieldUsername }}\" placeholder=\"{{\'FORM.label.username\' | translate}}\" ng-model=user.username ng-disabled=user.success required><div class=help-block role=alert ng-if=formSubmitted ng-messages=form[user.fieldUsername].$error><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><!-- </div>\n            </div> --></td><td><div class=form-group ng-class=\"{\'has-error\': form[user.fieldEmail].$invalid && formSubmitted, \'has-success\': user.success }\"><label for=bulkUserEmail><span ng-bind=\"\'FORM.label.email\' | translate\"></span> <span ng-bind=\"\'&nbsp;*\'\"></span></label><input class=\"form-control input-sm\" type=email name={{user.fieldEmail}} placeholder=\"{{\'FORM.label.name\' | translate}}\" ng-model=user.email ng-disabled=user.success required><div class=help-block ng-if=formSubmitted ng-messages=form[user.fieldEmail].$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=email ng-bind=\"\'FORM.validation.invalidEmail\' | translate\"></div></div></div><div class=form-group ng-class=\"{\'has-error\': form[user.fieldPassword].$invalid && formSubmitted, \'has-success\': user.success }\"><label for=bulkUserPassword><span ng-bind=\"\'FORM.label.password\' | translate\"></span> <span ng-bind=\"\'&nbsp;*\'\"></span></label><input class=\"form-control input-sm\" type=text name=\"{{ user.fieldPassword }}\" placeholder=\"{{\'FORM.label.password\' | translate}}\" ng-model=user.password ng-disabled=user.success required><div class=help-block role=alert ng-if=formSubmitted ng-messages=form[user.fieldPassword].$error><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></td><td class=_user-group><div class=form-group ng-class=\"{\'has-success\': user.success}\"><label for=groups ng-bind=\"\'FORM.label.userGroups\' | translate\"></label><ui-select ng-model=user.userGroups ng-disabled=user.success class=input-sm multiple style=\"min-height: 33px\"><ui-select-match placeholder=\"{{ \'FORM.label.userGroups\' | translate }}\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices repeat=\"group in userGroups | filter: { name: $select.search }\"><span ng-bind=group.name></span></ui-select-choices></ui-select><div class=\"help-block help-block-default\">Choose from existing groups</div></div></td><td><div class=form-group ng-class=\"{\'has-success\': user.success}\"><label ng-bind=\"\'FORM.label.phone\' | translate\"></label><div class=\"row row-8\"><div class=col-xs-3><select class=\"form-control input-sm\" ng-model=user.phone1.type ng-disabled=user.success><option value=cell ng-bind=\"\'FORM.value.phoneType.cell\' | translate\"></option><option value=work ng-bind=\"\'FORM.value.phoneType.work\' | translate\"></option><option value=home ng-bind=\"\'FORM.value.phoneType.home\' | translate\"></option></select></div><div class=col-xs-9><phone-number ng-model=user.phone1.number></phone-number></div></div></div></td><!-- Price package && bib: visible for participant --><td ng-if=\"userType === \'participant\'\"><div class=\"row row-8\"><div class=col-xs-8><div class=form-group ng-class=\"{\'has-success\': user.success}\"><label for={{user.fieldPackages}}><span ng-bind=\"\'FORM.label.package\' | translate\"></span></label><input type=hidden name={{user.fieldPackages}} ng-model=user.packages><ui-select ng-model=user.packages ng-disabled=user.success class=input-sm multiple style=\"min-height: 33px\"><ui-select-match placeholder=\"{{ \'FORM.value.choosePackage\' | translate }}\"><span ng-bind=$item.name></span> <span ng-bind=\"\'&nbsp;($\'+ $item.price +\')\'\"></span></ui-select-match><ui-select-choices repeat=\"pkg in pricePackages | filter: { name: $select.search }\"><span ng-bind=pkg.name></span> <span ng-bind=\"\'&nbsp;($\'+ pkg.price +\')\'\"></span></ui-select-choices></ui-select><!-- <div class=\"help-block\"  role=\"alert\" ng-if=\"formSubmitted\" ng-messages=\"form[user.fieldPackages].$error\">\n                    <div ng-message=\"required\" ng-bind=\"\'FORM.validation.required\' | translate\"></div>\n                  </div> --></div></div><div class=col-xs-4><div class=form-group ng-class=\"{\'has-error\': form[user.fieldBib].$invalid && formSubmitted, \'has-success\': user.success}\"><label for={{user.fieldBib}} ng-bind=\"\'FORM.label.bib\' | translate\"></label><input class=\"form-control input-sm\" id={{user.fieldBib}} type=number name=\"{{ user.fieldBib }}\" placeholder=\"{{\'FORM.placeholder.bib\' | translate}}\" ng-model=user.bibNumber ng-disabled=user.success><div class=help-block role=alert ng-if=formSubmitted ng-messages=form[user.fieldBib].$error><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div></div></td><td class=-actions><div class=form-group><label for=\"\">&nbsp;</label><button class=\"btn btn-danger btn-sm\" type=button ng-if=\"!user.success && user.canDelete\" ng-click=deleteUser(user) ng-bind=\"\'BUTTON.delete\' | translate\"></button> <button class=\"btn btn-success btn-block btn-sm\" type=button ng-if=user.success><i class=\"fa fa-check\" aria-hidden=true></i></button></div></td></tr></tbody></table><div class=form-group><button class=\"btn btn-primary btn-sm\" type=button ng-disabled=formLoading ng-click=handleSubmit()><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> {{\'BUTTON.registerAll\' | translate}}</button></div></form></div>");
$templateCache.put("app/directives/date-range/date-range.html","<div class=\"row row-8\"><div class=col-xs-6><div class=\"form-group form-group-datepicker\" ng-class=\"{\'has-error\': (!startDate && isRequired) || startDateIsGreaterThanEnd || outOfEventDateRange || startDateIsBelow}\"><label for=startDate>Start date</label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default btn-sm\" type=button ng-click=onPopup1Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=\"form-control input-sm\" type=text name=startDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=startDate ng-change=\"onChangeDate(startDate, endDate, startTime, endTime)\" is-open=popup1.opened datepicker-options=startDateOptions show-button-bar=false></div><div class=help-block ng-if=\"!startDate && isRequired\">This field is required</div><!-- <div class=\"help-block\"  ng-if=\"startDateIsBelow\">\n        Start date is before now\n      </div> --></div></div><div class=col-xs-6><div class=\"form-group form-group-datepicker\" ng-class=\"{\'has-error\': (!endDate && isRequired) || startDateIsGreaterThanEnd || outOfEventDateRange}\"><label for=endDate>End date</label><div class=\"input-group input-group-right\"><span class=\"input-group-btn date\"><button class=\"btn btn-default btn-sm\" type=button ng-click=onPopup2Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=\"form-control input-sm\" type=text name=endDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=endDate ng-change=\"onChangeDate(startDate, endDate, startTime, endTime)\" is-open=popup2.opened datepicker-options=endDateOptions show-button-bar=false></div><div class=help-block ng-if=\"!endDate && isRequired\">This field is required</div></div></div></div><div class=text-danger style=\"font-size: 12px; margin-bottom: 12px\" ng-if=startDateIsGreaterThanEnd>Start date is greater than end date</div><div class=text-danger style=\"font-size: 12px; margin-bottom: 12px\" ng-if=outOfEventDateRange>Out of event date range</div><div class=\"row row-8\"><div class=col-xs-6><div class=form-group ng-class=\"{\'has-error\': (!startTime && isRequired) || startTimeIsGreaterThanEnd || outOfEventTimeRange}\"><label for=startTime>Start time</label><div uib-timepicker class=timepicker-sm name=startTime ng-model=startTime ng-change=\"onChangeDate(startDate, endDate, startTime, endTime)\" show-meridian=true></div><div class=help-block ng-if=\"!startTime && isRequired\">This field is required</div></div></div><div class=col-xs-6><div class=form-group ng-class=\"{\'has-error\': (!endTime && isRequired) || startTimeIsGreaterThanEnd || outOfEventTimeRange}\"><label for=endTime>End time</label><div uib-timepicker class=timepicker-sm name=endTime ng-model=endTime ng-change=\"onChangeDate(startDate, endDate, startTime, endTime)\" show-meridian=true></div><div class=help-block ng-if=\"!endTime && isRequired\">This field is required</div></div></div></div><div class=text-danger style=\"font-size: 12px; margin-bottom: 12px\" ng-if=startTimeIsGreaterThanEnd>Start time is greater than end time</div><div class=text-danger style=\"font-size: 12px; margin-bottom: 12px\" ng-if=outOfEventTimeRange>Out of event time range</div>");
$templateCache.put("app/directives/file-loader/file-loader.html","<div><label class=\"btn btn-outline-primary btn-upload\" ng-hide=\"files.length >= max\" ng-disabled=disabled><input type=file name=fileLoader id=fileLoader ng-disabled=disabled multiple accept={{ngAccept}}> <i class=\"glyphicon glyphicon-download-alt\"></i> <span ng-bind=\"title || \'Upload image\'\"></span></label><div ng-if=spinerLoader style=\"width: 100%; margin-bottom: 8px; margin-top: 8px\"><div class=spiner></div></div><ul class=file-preview ng-if=\"type == \'file\'\"><li class=file-preview-item ng-if=\"files.length != 0 && !multiple\"><a ng-href=\"{{ files.link }}\" target=_blank ng-bind=title></a> <button ng-if=ufCanRemove class=\"btn btn-danger\" ng-click=handleDelete(files) type=button><i class=\"glyphicon glyphicon-trash\"></i></button></li></ul><div class=photo-preview ng-if=\"type != \'file\'\"><div class=photo-preview-item ng-class=\"{\'photo-preview-item-single\': !multiple}\" ng-if=\"!multiple && files.length != 0\"><div class=inner><img ng-src=\"{{ files.link }}\" alt=\"\"> <button ng-if=ufCanRemove class=\"btn btn-danger\" ng-click=handleDelete(files) type=button><i class=\"glyphicon glyphicon-trash\"></i></button></div></div><div class=photo-preview-item ng-repeat=\"file in files track by $index\" ng-if=\"multiple && files\"><div class=inner><img ng-click=handleImageLightbox(file) ng-src=\"{{ file.link }}\" alt=\"\"> <button class=\"btn btn-danger\" ng-click=handleDelete(file) type=button><i class=\"glyphicon glyphicon-trash\"></i></button></div></div></div></div>");
$templateCache.put("app/directives/foot-bar/foot-bar.html","<div class=footer role=contentinfo ng-controller=\"FootbarController as vm\" ng-init=onInit()><div class=container-fluid><div class=footer-content><div ng-bind-html=\"vm.contentFooter.content | trusted\" role=text></div></div><div class=footer-btn><a class=\"btn btn-link\" role=link ui-sref=app.about ng-bind=\"\'BUTTON.FOOTER.ABOUT\' | translate\"></a> <a class=\"btn btn-link\" role=link ui-sref=app.contact ng-bind=\"\'BUTTON.FOOTER.CONTACT\' | translate\"></a></div></div></div>");
$templateCache.put("app/directives/nav-bar/nav-bar.html","<div class=header ng-controller=\"NavbarController as vm\" ng-init=onInit()><div class=navbar><div class=container-fluid><div class=navbar-header><a class=navbar-brand ui-sref=app.home role=link aria-label=Brand><img ng-if=\"vm.preferences.logo && vm.preferences.logo.link\" ng-src=\"{{ vm.preferences.logo.link }}\" alt={{vm.preferences.name}}></a></div><ul class=\"nav navbar-nav navbar-profile\" role=navigation><li class=nav-item-btn ng-show=!currentUser><a class=\"btn btn-link\" ui-sref=app.auth.login role=link ng-bind=\"\'BUTTON.login\' | translate\"></a></li><li class=nav-item-btn ng-if=\"\n          !currentUser &&\n          eventStatus &&\n          (\n            (currentEvent.modules.indexOf(\'participant\') > -1 && vm.participantModule.enableRegister) ||\n            (currentEvent.modules.indexOf(\'sponsor\') > -1 && vm.sponsorModule.enableRegister) ||\n            (currentEvent.modules.indexOf(\'vendor\') > -1 && vm.vendorModule.enableRegister) ||\n            (currentEvent.modules.indexOf(\'volunteer\') > -1 && vm.volunteerModule.enableRegister)\n          )\n        \"><a class=\"btn btn-primary\" role=link ui-sref=app.auth.register ng-bind=\"\'BUTTON.register\' | translate\"></a></li><li uib-dropdown class=dropdown-profile ng-show=currentUser><a uib-dropdown-toggle href=javascript:void(0);><div class=dropdown-image><i ng-if=!currentUser.photoLink class=\"glyphicon glyphicon-camera\"></i> <img role=img ng-if=currentUser.photoLink ng-src={{currentUser.photoLink}} alt={{currentUser.name}}></div><span class=dropdown-name ng-bind=currentUser.username></span> <span class=caret></span></a><ul uib-dropdown-menu class=dropdown-menu-right><li ui-sref-active=active><a role=link ng-if=\"currentUser.type == \'eo\' || currentUser.type == \'eventCoordinator\'\" ui-sref=users.organizer.map.main ng-bind=\"\'BUTTON.event\' | translate\"></a> <a role=link ng-if=\"currentUser.type == \'vendor\'\" ui-sref=users.vendor.event ng-bind=\"\'BUTTON.event\' | translate\"></a> <a role=link ng-if=\"currentUser.type == \'volunteer\'\" ui-sref=users.volunteer.event ng-bind=\"\'BUTTON.event\' | translate\"></a> <a role=link ng-if=\"currentUser.type == \'participant\'\" ui-sref=users.participant.event ng-bind=\"\'BUTTON.event\' | translate\"></a> <a role=link ng-if=\"currentUser.type == \'special\'\" ui-sref=users.special.mainMap ng-bind=\"\'BUTTON.event\' | translate\"></a> <a role=link ng-if=\"currentUser.type == \'sponsor\'\" ui-sref=users.sponsor.event ng-bind=\"\'BUTTON.event\' | translate\"></a> <a role=link ng-if=\"currentUser.type == \'volunteerCoordinator\'\" ui-sref=users.volunteerCoordinator.map ng-bind=\"\'BUTTON.event\' | translate\"></a> <a role=link ng-if=\"currentUser.type == \'sponsorAttendant\'\" ui-sref=users.sponsorAttendant ng-bind=\"\'BUTTON.event\' | translate\"></a></li><li ui-sref-active=active><a role=link ui-sref=users.profile ng-bind=\"\'BUTTON.profile\' | translate\"></a></li><li role=separator class=divider></li><li ui-sref-active=active ng-if=accessPortal><a role=link href=\"{{ vm.managerPortalLink }}\" target=_blank ng-bind=\"\'BUTTON.eventPortal\' | translate\"></a></li><li role=separator class=divider ng-if=\"vm.preferences.showCustomHomePage && (currentUser.type == \'eo\' || currentUser.type == \'eventCoordinator\')\"></li><li ui-sref-active=active ng-if=\"vm.preferences.showCustomHomePage && (currentUser.type == \'eo\' || currentUser.type == \'eventCoordinator\')\"><a role=link ui-sref=app.constructorLandingPage target=_blank ng-bind=\"\'BUTTON.constructor\' | translate\"></a></li><li role=link ng-if=accessPortal role=separator class=divider></li><li><button role=button type=button ng-disabled=vm.loading ng-click=onLogout() ng-bind=\"\'BUTTON.logout\' | translate\"></button></li></ul></li></ul></div></div></div>");
$templateCache.put("app/directives/phone-number/phone-number.html","<div class=input-group><span class=input-group-btn><div uib-dropdown class=\"btn-group dropdown-country\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button style=\"margin-bottom: 0\"><span ng-bind=phoneNumber.label></span> <span class=caret></span></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-country-menu\" role=menu aria-labelledby=single-button><li ng-repeat=\"country in vm.countries\"><button type=button ng-click=handleClickCountry(country) ng-bind=country.label></button></li></ul></div></span><input class=\"form-control input-sm\" ng-model=phoneNumber.number ng-change=handlePhoneNumber(phoneNumber) ui-mask=(999)-999-9999 ui-mask-placeholder ui-mask-placeholder-char=-></div><style>.dropdown-country {\r\n    margin-bottom: 0 !important;\r\n  }\r\n  .dropdown-country-menu > li {\r\n\r\n  }\r\n  .dropdown-country-menu > li > button {\r\n    display: block;\r\n    width: 100%;\r\n    background: none;\r\n    border: 0;\r\n    text-align: left;\r\n\r\n    font-size: 14px;\r\n    padding: 4px 12px;\r\n  }\r\n  .dropdown-country-menu > li > button:hover {\r\n    background-color: #ededed;\r\n  }</style>");
$templateCache.put("app/directives/text-editor-gallery/media-modal.html","<div ng-init=onInit()><div class=modal-header><h3 class=modal-title>Media gallery</h3></div><div class=modal-body><div ng-if=modalLoading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!modalLoading><!-- Upload media --><div class=form-group><div class=clearfix><label class=\"btn btn-info btn-sm | btn-upload | pull-right\" ng-class=\"{\'disabled\': uploadMediaDisabled }\" ng-if=!isTextEditor><input type=file name=uploadMedia id=uploadMedia accept=image/* multiple onchange=\"angular.element(this).scope().handleUploadMedia(event, \'image_360\')\" ng-disabled=uploadMediaDisabled> <span>Upload image 360</span></label><label class=\"btn btn-info btn-sm | btn-upload | pull-right\" style=\"margin-right: 4px\" ng-class=\"{\'disabled\': uploadMediaDisabled }\"><input type=file name=uploadMedia id=uploadMedia accept=image/* multiple onchange=\"angular.element(this).scope().handleUploadMedia(event, \'image\')\" ng-disabled=uploadMediaDisabled> <span>Upload image</span></label></div><span class=\"help-block help-block-default\" style=\"position: relative; margin-bottom: 0 !important; text-align: right !important; display: block\" ng-bind=\"\'( Image 360 size shouldn`t exceed 4096px )\'\"></span></div><!-- Uploaded media list --><div class=modal-gallery ng-if=\"mediaList.length !== 0 || uploadMediaLoading\"><div class=modal-gallery-item ng-repeat=\"media in mediaList\" ng-if=\"!isTextEditor || (isTextEditor && media.type !== \'image_360\')\" ng-class=\"{\n               \'_selected\': selectedMediaList.indexOf(media) > -1,\n               \'_disabled\': isMediaDisabled(media)\n             }\"><img ng-src=\"{{media.type === \'image\' ? media.link : \'assets/images/360-icon.png\'}}\" ng-click=handleSelectMedia(media) alt=\"{{ media.originalFilename }}\"><!-- Media item actions --><div class=_actions><button class=\"btn btn-default btn-sm\" type=button ng-disabled=uploadMediaDisabled ng-click=handlePreview(media) ng-if=\"media.type === \'image_360\'\" uib-tooltip=\"Preview media\" tooltip-placement=bottom tooltip-append-to-body=true><i class=\"fa fa-eye\" aria-hidden=true></i></button><!-- Delete --> <button class=\"btn btn-danger btn-sm\" type=button ng-disabled=uploadMediaDisabled ng-click=handleDeleteMedia(media) uib-tooltip=\"Delete media\" tooltip-placement=bottom tooltip-append-to-body=true><i class=\"fa fa-trash\" aria-hidden=true></i></button></div></div><div class=modal-gallery-upload ng-if=uploadMediaLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div></div><div class=no-message ng-if=\"mediaList.length === 0 && !uploadMediaLoading\"><i class=\"fa fa-picture-o\" aria-hidden=true></i><h3 ng-bind=\"\'TEXT.noMedia\' | translate\"></h3></div></div></div><div class=modal-footer><p class=\"help-text pull-left\" style=\"font-size: 12px; font-style: italic; padding-top: 8px\" ng-bind=\"\'Click images to select then click Insert button\'\"></p><button class=\"btn btn-default btn-sm\" type=button ng-disabled=\"uploadMediaDisabled || uploadMediaLoading\" ng-click=handleClose() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=button ng-disabled=\"\n              selectedMediaList.length === 0 || (uploadMediaDisabled || uploadMediaLoading)\n            \" ng-click=handleAdd() ng-bind=\"\'BUTTON.insert\' | translate\"></button></div></div>");
$templateCache.put("app/directives/text-editor-gallery/text-editor-gallery.html","<div class=form-group ng-init=onInit() style=\"margin-bottom: 20px\" ng-class=\"{\'has-error\': required && submitted && tegForm[tegName].$invalid }\"><label for=\"{{ tegName }}\" ng-if=\"label && label.length\"><span ng-bind=label></span> <span ng-if=required>&nbsp;*</span></label><div style=\"margin-bottom: 8px\"><button class=\"btn btn-default btn-sm\" type=button ng-click=openMediaDialog()><i class=\"fa fa-file-photo-o\" aria-hidden=true></i> Add media</button></div><div class=bg-info ng-if=selectedMedia.length style=\"padding: 16px; margin-bottom: 16px\">Click on text editor position to insert selected media</div><text-angular ng-model=tegModel name={{tegName}} ng-click=setMediaOnCursorPosition() ta-toolbar=taToolbarOptions required></text-angular><div class=help-block ng-if=\"required && submitted && tegForm[tegName].$invalid\" role=alert ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-transclude=body></div></div>");
$templateCache.put("app/users/auto-check-in/auto-check-in.html","<div class=wrapper><nav-bar></nav-bar><div class=main><div class=\"area area-page\" ng-controller=\"AutoCheckInController as vm\" ng-init=onInit()><div class=container><div class=area-content><div class=\"card card-auto-check-in-error\" ng-if=\"!vm.request && vm.errorMessage\"><div class=card-head><h3 class=card-title ng-bind=vm.errorMessage></h3></div></div><div class=\"card card-auto-check-in\" ng-if=vm.request.user><div class=card-head><h3 class=card-title><b ng-bind=vm.request.user.name></b> <span ng-bind=\"\'MESSAGE.SUCCESS.CHECKED_IN\' | translate\"></span></h3></div></div><div class=\"card card-auto-check-in\" ng-if=vm.request.participant><div class=card-head><h3 class=card-title><b ng-bind=vm.request.participant.name></b> <span ng-bind=\"\'MESSAGE.SUCCESS.CHECKED_IN\' | translate\"></span></h3></div><div class=card-body><div class=card-group ng-if=\"vm.type === \'request\'\"><span class=card-group-label ng-bind=\"\'LABEL.PACKAGE\' | translate\"></span><div class=card-group ng-repeat=\"item in vm.request.items\"><div class=card-group-value ng-bind=\"item.pricePackage.name +\' X \'+ item.count\"></div><div class=card-group-label ng-if=item.participantName ng-bind=item.participantName></div><div class=card-group-label ng-if=item.participantEmail ng-bind=item.participantEmail></div></div></div></div></div><div class=\"card card-auto-check-in\" ng-if=vm.request.sponsor><div class=card-head><h3 class=card-title><b ng-bind=vm.request.sponsor.name></b> <span ng-bind=\"\'MESSAGE.SUCCESS.CHECKED_IN\' | translate\"></span></h3></div><div class=card-body><div class=card-group ng-if=vm.request.pricePackage><span class=card-group-label ng-bind=\"\'LABEL.PACKAGE\' | translate\"></span><div class=card-group-value ng-bind=vm.request.pricePackage.name></div></div></div></div><div class=\"card card-auto-check-in\" ng-if=vm.request.vendor><div class=card-head><h3 class=card-title><b ng-bind=vm.request.vendor.name></b> <span ng-bind=\"\'MESSAGE.SUCCESS.CHECKED_IN\' | translate\"></span></h3></div></div></div></div></div></div><foot-bar></foot-bar></div>");
$templateCache.put("app/users/event-pass/event-pass.html","<div class=modal-wrap ng-init=onInit()><div class=modal-backcolor ng-if=booth ng-style=\"{\'background-color\': booth.color}\"></div><button type=button class=close data-dismiss=modal aria-label=Close ng-click=onClose()><span aria-hidden=true>&times;</span> <span class=_label>Close</span></button><div class=modal-header><h3 class=\"modal-title text-center\" ng-bind=modalTitle></h3></div><div class=modal-body><div class=text-center ng-if=modalLoading><i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\"></i></div><div ng-if=!modalLoading><div ng-if=\"userType === \'vendor\'\" ng-include=\"\'app/users/event-pass/event-pass.vendor.html\'\"></div><div ng-if=\"userType === \'volunteer\'\" ng-include=\"\'app/users/event-pass/event-pass.volunteer.html\'\"></div><div ng-if=\"userType === \'participant\'\" ng-include=\"\'app/users/event-pass/event-pass.participant.html\'\"></div><div ng-if=\"userType === \'sponsor\'\" ng-include=\"\'app/users/event-pass/event-pass.sponsor.html\'\"></div></div></div></div>");
$templateCache.put("app/users/event-pass/event-pass.participant.html","<h3 class=text-center style=\"margin-top: 2px; margin-bottom: 2px\" ng-bind=currentEvent.name></h3><h3 class=text-center style=\"margin-top: 2px; margin-bottom: 2px\" ng-bind=userRequest.participant.name></h3><h5 class=text-center ng-if=userRequest.notes ng-bind=userRequest.notes></h5><div class=modal-qr ng-if=!userRequest.checkedIn><qrcode data={{qrURL}} href={{qrURL}} size=128></qrcode></div><div class=modal-qr ng-if=userRequest.checkedIn><div class=modal-qr-checkedin><span ng-bind=\"\'TEXT.CHECKED\' | translate\"></span> <i class=\"glyphicon glyphicon-ok\"></i></div></div><div class=\"card card-default -lg\" style=\"margin-bottom: 8px\"><div class=card-body><div class=card-group ng-if=userRequest.code style=\"margin-top: 0\"><span class=card-group-label ng-bind=\"\'LABEL.CODE\' | translate\"></span><p class=card-group-value ng-bind=userRequest.code></p></div><div class=card-group ng-if=userRequest.items><span class=card-group-label ng-bind=\"\'LABEL.PACKAGE\' | translate\"></span><div class=\"row row-flex\"><div class=col-xs-6 ng-repeat=\"item in userRequest.items\"><div class=card-group><span class=card-group-value ng-bind=\"item.pricePackage.name +\' X \'+ item.count\"></span><p class=card-group-label ng-if=item.participantName ng-bind=item.participantName></p><p class=card-group-label ng-if=item.participantEmail ng-bind=item.participantEmail></p></div></div></div></div></div></div>");
$templateCache.put("app/users/event-pass/event-pass.sponsor.html","<h3 class=text-center style=\"margin-top: 2px; margin-bottom: 2px\" ng-bind=currentEvent.name></h3><h3 class=text-center style=\"margin-top: 2px; margin-bottom: 2px\" ng-bind=userRequest.sponsor.name></h3><h5 class=text-center ng-if=userRequest.notes ng-bind=userRequest.notes></h5><div class=modal-qr ng-if=!userRequest.checkedIn><qrcode data={{qrURL}} href={{qrURL}} size=128></qrcode></div><div class=modal-qr ng-if=userRequest.checkedIn><div class=modal-qr-checkedin><span ng-bind=\"\'TEXT.CHECKED\' | translate\"></span> <i class=\"glyphicon glyphicon-ok\"></i></div></div><div class=\"card card-default -lg\" style=\"margin-bottom: 8px\" ng-if=userRequest.pricePackage><div class=card-body><div class=card-group style=\"margin-top: 0\"><span class=card-group-label ng-bind=\"\'LABEL.PACKAGE\' | translate\"></span> <span class=card-group-value ng-bind=userRequest.pricePackage.name></span></div></div></div>");
$templateCache.put("app/users/event-pass/event-pass.vendor.html","<div ng-if=booth><h4 class=text-center style=\"margin-top: 2px; margin-bottom: 2px\" ng-bind=booth.eventName><h3 class=text-center style=\"margin-top: 2px; margin-bottom: 2px\" ng-bind=booth.vendorName></h3><h3 class=text-center ng-if=booth.description ng-bind=booth.description></h3></h4><div class=modal-qr ng-if=!request.checkedIn><qrcode data={{qrURL}} href={{qrURL}} size=128></qrcode></div><div class=modal-qr ng-if=request.checkedIn><div class=modal-qr-checkedin><span ng-bind=\"\'TEXT.CHECKED\' | translate\"></span> <i class=\"glyphicon glyphicon-ok\"></i></div></div><div ng-if=\"booth.from && booth.to\" style=\"text-align: center\"><p ng-if=\"isSame(booth.from, booth.to)\"><b ng-bind=\"booth.from | dateFormated\"></b>&nbsp;-&nbsp;<b ng-bind=\"booth.to | timeFormated\"></b></p><p ng-if=\"!isSame(booth.from, booth.to)\"><b ng-bind=\"booth.from | dateFormated\"></b>&nbsp;-&nbsp;<b ng-bind=\"booth.to | dateFormated\"></b></p></div></div><div ng-if=!booth><h2 class=\"text-danger text-center\" style=\"margin-top: 0\"><span ng-bind=\"\'TEXT.NO_LINKED_BOOTH\' | translate\"></span></h2></div>");
$templateCache.put("app/users/event-pass/event-pass.volunteer.html","<div ng-if=\"zones && zones.length\"><div class=\"row row-flex row-8\"><div class=\"col-sm-6 col-lg-4\" style=\"margin-bottom: 8px\" ng-repeat=\"zone in zones\"><div class=\"card card-default card-event-pass\"><span class=card-aside-color ng-if=\"zone.preferences && zone.preferences.fillColor\" ng-style=\"{\'background-color\': zone.preferences.fillColor }\"></span><div class=card-head ng-if=zone.name><h3 class=card-title ng-bind=zone.name></h3></div><div class=card-body><div class=card-cell><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.INSTRUCTION\' | translate\"></span> <span class=card-group-value ng-if=zone.description ng-bind=zone.description></span></div></div></div></div></div></div></div><div ng-if=\"!zones || zones.length === 0\"><h3 class=\"text-danger text-center\"><div ng-if=currentEvent.preferences.volunteerModule.instruction ng-bind=currentEvent.preferences.volunteerModule.instruction></div><div ng-if=!currentEvent.preferences.volunteerModule.instruction ng-bind=\"\'No linked zones\'\"></div></h3></div>");
$templateCache.put("app/users/organizer/organizer.html","<div class=\"area area-page\" ng-controller=\"OrganizerController as vm\" ng-init=onInit()><div class=container-fluid><div class=\"nav nav-aside\" ng-class=\"{\'-in\': isOpened}\"><div class=text-right><button class=\"btn btn-link btn-nav-aside\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-remove-circle\"></i></button></div><ul class=nav-menu ng-click=\"isOpened = !isOpened\"><li ui-sref-active=active><a class=_placehold ui-sref=users.organizer.map ng-bind=\"\'TAB.map\' | translate\"></a> <a ui-sref=users.organizer.map.main ng-bind=\"\'TAB.map\' | translate\"></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.organizer.map.main ng-bind=\"\'TAB.main\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.map.all ng-bind=\"\'TAB.all\' | translate\"></a></li></ul></li><li class=nav-menu-item ui-sref-active=active><a class=_placehold ui-sref=users.organizer.event ng-bind=\"\'TAB.event\' | translate\"></a> <a ui-sref=users.organizer.event.settings ng-bind=\"\'TAB.event\' | translate\"></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.organizer.event.settings ng-bind=\"\'TAB.settings\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.categories ng-bind=\"\'TAB.goodsCategories\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.booths ng-bind=\"\'TAB.boothTypes\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.inventory ng-bind=\"\'TAB.inventory\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.prices ng-bind=\"\'TAB.pricePackages\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.staticPages ng-bind=\"\'TAB.staticPages\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.dynamicPages ng-bind=\"\'TAB.dynamicPages\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.mailTemplate ng-bind=\"\'TAB.emailTemplates\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.smtpServer ng-bind=\"\'TAB.ownSMTPServer\' | translate\"></a></li><li ui-sref-active=active ng-if=vm.event.preferences.enableDonations><a ui-sref=users.organizer.event.donations ng-bind=\"\'TAB.donations\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.financialReport ng-bind=\"\'TAB.financialReport\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.schedule ng-bind=\"\'TAB.schedule\' | translate\"></a></li><li ui-sref-active=active ng-if=\"vm.event.modules.indexOf(\'reservations\') > -1\"><a ui-sref=users.organizer.event.reservationCalendars ng-bind=\"\'TAB.reservationCalendars\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.event.mediaGallery ng-bind=\"\'TAB.mediaGallery\' | translate\"></a></li><li ui-sref-active=active ng-if=vm.event.externalReservationEnabled><a ui-sref=users.organizer.event.k2_notifications ng-bind=\"\'K2 notifications\'\"></a></li></ul></li><li class=nav-menu-item ui-sref-active=active ng-if=\"vm.event.modules.indexOf(\'vendor\') > -1\"><a class=_placehold ui-sref=users.organizer.vendors ng-bind=vm.vendorModule.label></a> <a ui-sref=users.organizer.vendors.all ng-bind=vm.vendorModule.label></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.organizer.vendors.all ng-bind=\"\'TAB.all\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.vendors.requests ng-bind=\"\'TAB.requests\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.vendors.bulk ng-bind=\"\'TAB.bulkRegister\' | translate\"></a></li></ul></li><li class=nav-menu-item ui-sref-active=active ng-if=\"vm.event.modules.indexOf(\'volunteer\') > -1\"><a class=_placehold ui-sref=users.organizer.volunteers ng-bind=vm.volunteerModule.label></a> <a ui-sref=users.organizer.volunteers.all ng-bind=vm.volunteerModule.label></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.organizer.volunteers.all ng-bind=\"\'TAB.all\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.volunteers.requests ng-bind=\"\'TAB.requests\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.volunteers.bulk ng-bind=\"\'TAB.bulkRegister\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.volunteers.logBook ng-bind=\"\'TAB.logBook\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.volunteers.assignments ng-bind=\"\'TAB.assignments\' | translate\"></a></li></ul></li><li ng-if=\"vm.event.modules.indexOf(\'participant\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.organizer.participants ng-bind=vm.participantModule.label></a> <a ui-sref=users.organizer.participants.all ng-bind=vm.participantModule.label></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.organizer.participants.all ng-bind=\"\'TAB.all\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.participants.requests ng-bind=\"\'TAB.requests\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.participants.teams ng-bind=\"\'TAB.teams\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.participants.bulk ng-bind=\"\'TAB.bulkRegister\' | translate\"></a></li><li ui-sref-active=active ng-if=\"vm.event.modules.indexOf(\'reservations\') > -1\"><a ui-sref=users.organizer.participants.reservations ng-bind=\"\'TAB.reservations\' | translate\"></a></li></ul></li><li ng-if=\"vm.event.modules.indexOf(\'sponsor\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.organizer.sponsors ng-bind=vm.sponsorModule.label></a> <a ui-sref=users.organizer.sponsors.all ng-bind=vm.sponsorModule.label></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.organizer.sponsors.all ng-bind=\"\'TAB.all\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.sponsors.requests ng-bind=\"\'TAB.requests\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.sponsors.bulk ng-bind=\"\'TAB.bulkRegister\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.sponsors.ads ng-bind=\"\'TAB.sponsorAds\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.sponsors.attendants ng-bind=\"\'TAB.attendants\' | translate\"></a></li></ul></li><li ng-if=\"vm.event.modules.indexOf(\'scavenger_hunt\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.organizer.scavengerHunt ng-bind=\"\'Scavenger Hunt\'\"></a> <a ui-sref=users.organizer.scavengerHunt.checkInPoints ng-bind=\"\'Scavenger Hunt\'\"></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.organizer.scavengerHunt.checkInPoints ng-bind=\"\'Check in points\'\"></a></li><li ui-sref-active=active><a ui-sref=users.organizer.scavengerHunt.leaderboard ng-bind=\"\'Leaderboard\'\"></a></li></ul></li><li class=nav-menu-item ng-if=\"vm.event.modules.indexOf(\'messaging\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.organizer.messages ng-bind=\"\'TAB.messages\' | translate\"></a> <a ui-sref=users.organizer.messages.inbox><span ng-bind=\"\'TAB.messages\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.organizer.messages.inbox><span ng-bind=\"\'TAB.inbox\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a></li><li ui-sref-active=active><a ui-sref=users.organizer.messages.sent ng-bind=\"\'TAB.sent\' | translate\"></a></li></ul></li><li class=nav-menu-item ui-sref-active=active><a ui-sref=users.organizer.userGroups.list ng-bind=\"\'TAB.userGroups\' | translate\"></a></li><li class=nav-menu-item ui-sref-active=active><a ui-sref=users.organizer.specialUsers ng-bind=\"\'TAB.specialUsers\' | translate\"></a></li></ul></div><div class=area-content><p class=area-content-btn><button class=\"btn btn-primary\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-menu-hamburger\"></i></button></p><ui-view></ui-view></div></div></div>");
$templateCache.put("app/users/participant/participant.html","<div class=\"area area-page area-page-participant\" ng-controller=\"ParticipantController as vm\" ng-init=onInit()><div class=container-fluid><div class=\"nav nav-aside\" ng-class=\"{\'-in\': isOpened}\"><div class=text-right><button class=\"btn btn-link btn-nav-aside\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-remove-circle\"></i></button></div><ul class=nav-menu ng-click=\"isOpened = !isOpened\"><li ui-sref-active=active><a ui-sref=users.participant.event ng-bind=\"\'TAB.event\' | translate\"></a></li><li ui-sref-active=active ng-if=\"\n              currentEvent.modules.indexOf(\'scavenger_hunt\') > -1 &&\n              currentEvent.preferences.participantModule.scavengerHunt\n            \"><a ui-sref=users.participant.scavengerHunt ng-bind=\"\'Scavenger Hunt\'\"></a></li><li ui-sref-active=active ng-if=!currentEvent.preferences.participantModule.hideEventMap><a ui-sref=users.participant.mainMap ng-bind=\"\'TAB.map\' | translate\"></a></li><li ui-sref-active=active ng-if=\"myTeams && myTeams.length != 0\"><a ui-sref=users.participant.myTeam ng-bind=\"\'TAB.myTeam\' | translate\"></a></li><li ui-sref-active=active ng-if=\"\n              vm.currentEvent.preferences.scheduleModule.enabled &&\n              vm.currentEvent.preferences.participantModule.enableUserTypeSchedule\n            \"><a ui-sref=users.participant.schedule ng-bind=\"\'TAB.schedule\' | translate\"></a></li><li ng-if=\"currentEvent.modules.indexOf(\'messaging\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.participant.messages ng-bind=\"\'TAB.messages\' | translate\"></a> <a ui-sref=users.participant.messages.inbox id=_userMessages><span ng-bind=\"\'TAB.messages\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.participant.messages.inbox id=_userMessagesInbox><span ng-bind=\"\'TAB.inbox\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a></li><li ui-sref-active=active><a ui-sref=users.participant.messages.sent id=_userMessagesSent ng-bind=\"\'TAB.sent\' | translate\"></a></li></ul></li><li ui-sref-active=active ng-if=\"vm.currentEvent.modules.indexOf(\'reservations\') > -1\"><a ui-sref=users.participant.reservation ng-bind=\"\'TAB.reservation\' | translate\"></a></li></ul></div><div class=area-content><p class=area-content-btn><button class=\"btn btn-primary\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-menu-hamburger\"></i></button></p><ui-view></ui-view></div></div></div>");
$templateCache.put("app/users/profile/profile.html","<div class=\"area area-page\" ng-controller=\"ProfileController as vm\" ng-init=onInit()><div class=container><div class=area-content><form novalidate autocomplete=off name=form ng-submit=handleSubmit()><div class=\"row row-16\"><div class=\"col-xs-12 col-md-4\"><div class=form-group><div class=form-image><div class=form-image-preview><img ng-show=\"photoPreview || vm.currentUser.photoLink\" ng-src=\"{{photoPreview || vm.currentUser.photoLink}}\" alt={{vm.currentUser.name}}> <i ng-if=\"!photoPreview || !vm.currentUser.photoLink\" class=\"glyphicon glyphicon-camera\"></i></div><label class=form-image-upload><input type=file id=userPhoto name=userPhoto file-model=currentUser.newPhoto> <span class=\"btn btn-primary label\"><i class=\"glyphicon glyphicon-camera\"></i> <span ng-if=!vm.currentUser.photoLink ng-bind=\"\'BUTTON.CHOOSE_PHOTO\' | translate\"></span> <span ng-if=vm.currentUser.photoLink ng-bind=\"\'BUTTON.UPDATE_PHOTO\' | translate\"></span></span></label><button class=\"btn btn-danger btn-block\" type=button ng-show=\"photoPreview || vm.currentUser.photoLink\" ng-click=removePhoto() ng-bind=\"\'BUTTON.DELETE_PHOTO\' | translate\"></button><p ng-if=\"vm.currentUser.type == \'vendor\'\" class=\"help-block help-block-default\" style=\"position: relative; text-align: center\" ng-bind=\"\'FORM.PROFILE.PHOTO_LABEL\' | translate\"></p></div></div></div><div class=\"col-xs-12 col-md-8\"><div class=\"row row-16\"><div class=col-xs-12><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name>{{\'FORM.AUTH.NAME\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=name type=text name=name placeholder=\"{{\'FORM.AUTH.NAME\' | translate}}\" ng-model=vm.currentUser.name required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=col-md-6><div class=form-group ng-class=\"{ \'has-error\': form.username.$invalid && formSubmitted }\"><label for=username>{{\'FORM.AUTH.USERNAME\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=username type=text name=username placeholder=\"{{\'FORM.AUTH.USERNAME\' | translate}}\" ng-model=vm.currentUser.username required><div class=help-block ng-if=formSubmitted ng-messages=form.username.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=col-md-6><div class=form-group ng-class=\"{\'has-error\': form.email.$invalid && formSubmitted }\"><label for=email>{{\'FORM.AUTH.EMAIL\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=email type=email name=email placeholder=\"{{\'FORM.AUTH.EMAIL\' | translate}}\" ng-model=vm.currentUser.email required><div class=help-block ng-if=formSubmitted ng-messages=form.email.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=email ng-bind=\"\'FORM.validation.invalidEmail\' | translate\"></div></div></div></div><div class=col-sm-6><div class=form-group ng-class=\"{ \'has-error\': form.password.$invalid && formSubmitted }\"><label for=password><span ng-bind=\"\'FORM.AUTH.PASSWORD\' | translate\"></span> <span ng-if=vm.currentUser.rePassword.length>&nbsp;*</span></label><input class=form-control id=password type=password name=password autocomplete=new-password placeholder=\"{{\'FORM.AUTH.PASSWORD\' | translate}}\" ng-model=vm.currentUser.password ng-required=vm.currentUser.rePassword.length><div class=help-block ng-if=formSubmitted ng-messages=form.password.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><!-- <div ng-message=\"minlength\" ng-bind=\"\'FORM.validation.minLength\' | translate\"></div> --></div></div></div><div class=col-sm-6><div class=form-group ng-class=\"{ \'has-error\': form.rePassword.$invalid && formSubmitted }\"><label for=rePassword><span ng-bind=\"\'FORM.AUTH.RE_PASSWORD\' | translate\"></span> <span ng-if=vm.currentUser.password.length>&nbsp;*</span></label><input class=form-control id=rePassword type=password name=rePassword autocomplete=new-password placeholder=\"{{\'FORM.AUTH.RE_PASSWORD\' | translate}}\" ng-model=vm.currentUser.rePassword match=vm.currentUser.password ng-required=vm.currentUser.password.length><div class=help-block ng-if=formSubmitted ng-messages=form.rePassword.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><!-- <div ng-message=\"minlength\" ng-bind=\"\'FORM.validation.minLength\' | translate\"></div> --><div ng-message=match ng-bind=\"\'FORM.validation.notMatchPassword\' | translate\"></div></div></div></div></div><div class=form-group><label for=description ng-bind=\"\'FORM.label.description\' | translate\"></label><textarea class=form-control id=description name=description placeholder=\"{{\'FORM.placeholder.description\' | translate}}\" ng-model=vm.currentUser.description rows=5>\n              </textarea></div><div class=form-group><label for=address ng-bind=\"\'FORM.label.address\' | translate\"></label><input class=form-control id=address type=text name=address placeholder=\"{{\'FORM.placeholder.address\' | translate}}\" ng-model=vm.currentUser.address></div><div class=form-group><label ng-bind=\"\'FORM.AUTH.PHONE\' | translate\"></label><div class=form-group><div class=\"row row-16\"><div class=col-xs-5><select class=\"form-control input-sm\" id=phone1Type name=phone1Type ng-model=vm.currentUser.phone1.type><option value=cell ng-bind=\"\'FORM.value.phoneType.cell\' | translate\"></option><option value=work ng-bind=\"\'FORM.value.phoneType.work\' | translate\"></option><option value=home ng-bind=\"\'FORM.value.phoneType.home\' | translate\"></option></select></div><div class=col-xs-7><phone-number ng-model=vm.currentUser.phone1.number></phone-number></div></div></div><div class=form-group><div class=\"row row-16\"><div class=col-xs-5><select class=form-control id=phone2Type name=phone2Type ng-model=vm.currentUser.phone2.type><option value=cell ng-bind=\"\'FORM.value.phoneType.cell\' | translate\"></option><option value=work ng-bind=\"\'FORM.value.phoneType.work\' | translate\"></option><option value=home ng-bind=\"\'FORM.value.phoneType.home\' | translate\"></option></select></div><div class=col-xs-7><phone-number ng-model=vm.currentUser.phone2.number></phone-number></div></div></div><p class=\"help-block help-block-default\" ng-bind=\"\'FORM.AUTH.PHONE_LABEL\' | translate\"></p></div><div class=\"row row-16\"><div class=col-md-4><div class=form-group><label for=state ng-bind=\"\'FORM.PROFILE.STATE\' | translate\"></label><select class=form-control id=state name=state ng-model=vm.currentUser.state ng-options=\"state.code as state.name for state in vm.states\"><option value=\"\" ng-bind=\"\'FORM.PROFILE.CHOOSE_STATE\' | translate\"></option></select></div></div><div class=col-md-4><div class=form-group><label for=city ng-bind=\"\'FORM.PROFILE.CITY\' | translate\"></label><input class=form-control id=city type=text name=city placeholder=\"{{\'FORM.PROFILE.CITY\' | translate}}\" ng-model=vm.currentUser.city></div></div><div class=col-md-4><div class=form-group ng-class=\"{ \'has-error\': form.zipCode.$invalid && formSubmitted }\"><label for=zipCode ng-bind=\"\'FORM.PROFILE.ZIP_CODE\' | translate\"></label><input class=form-control id=zipCode type=text name=zipCode placeholder=\"{{\'FORM.PROFILE.ZIP_CODE\' | translate}}\" ng-model=vm.currentUser.zipCode><div class=help-block ng-if=formSubmitted ng-messages=form.zipCode.$error role=alert><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div></div><div class=form-group><label for=company ng-bind=\"\'FORM.PROFILE.COMPANY_NAME\' | translate\"></label><input class=form-control id=company type=text name=company placeholder=\"{{\'FORM.PROFILE.COMPANY_NAME\' | translate}}\" ng-model=vm.currentUser.company></div><hr><div class=form-group><div class=checkbox><label for=emailOptOut><input type=checkbox id=emailOptOut name=emailOptOut ng-model=vm.currentUser.emailOptOut> <span ng-bind=\"\'FORM.value.stopReceivingEmail\' | translate\"></span></label></div><div class=checkbox><label for=smsOptOut><input type=checkbox id=smsOptOut name=smsOptOut ng-model=vm.currentUser.smsOptOutCheckbox> <span ng-bind=\"\'FORM.value.stopReceivingText\' | translate\"></span></label></div><div class=\"help-block help-block-default\" style=\"position: relative; text-align: left !important; margin-bottom: 0 !important\" ng-if=\"!settingsLoading && vm.currentUser.smsOptOutStatus === \'opted_out_sms\'\">Text START to <span ng-bind=\"eventPhoneNumber.value | formatPhone\"></span> to start receiving event alerts</div></div><button class=\"btn btn-primary\" type=submit ng-if=eventStatus ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> {{\'BUTTON.update\' | translate}}</button></div></div></form></div></div></div>");
$templateCache.put("app/users/reservation-manager/reservation-manager.html","<div class=\"area area-page\" ng-controller=\"ParticipantReservationManagerController as vm\" ng-init=onInit()><div class=container><div class=area-content><div ng-if=loading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><div ng-if=!loading><div class=clearfix ng-if=eventStatus><button class=\"btn btn-info btn-sm | pull-left\" type=button role=button ng-click=goBack() ng-bind=\"\'BUTTON.BACK_TO_MAP\' | translate\"></button></div><calendar-reservation cr-type=\"\'slots\'\" cr-data=availableSlots cr-show-past=false cr-selected-date=selectedDate fn-selecte-day=handleSelectDay></calendar-reservation><div ng-if=loadingSlot><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><div ng-if=!loadingSlot><div class=bg-info style=\"margin-bottom: 16px; padding: 16px\" ng-if=\"errSlots && !slots.length\" ng-bind=errSlotsMsg></div><div class=bg-info style=\"margin-bottom: 16px; padding: 16px\" ng-if=\"!vm.currentUser || vm.currentUser.type !== \'participant\'\"><span ng-bind=\"\'TEXT.SHOULD_BE_LOGGED_IN_AS\' | translate\"></span> <span ng-bind=vm.participantModule.label></span></div><div class=\"row row-flex row-16\" ng-if=slots.length><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2\" ng-repeat=\"slot in slots\" style=\"margin-top: 16px\" ng-if=outOfCurrentDate(slot)><div class=\"card card-default\" style=\"padding: 8px\"><div class=card-body><div class=card-group style=\"margin-top: 0\" ng-if=\"getSlotCalendar(slot).timeSlotLength !== \'day\'\"><span class=card-group-label ng-bind=\"\'LABEL.AVAILABLE_HOURS\' | translate\"></span><div class=card-group-value><span ng-bind=toHours(slot.start)></span> - <span ng-bind=toHours(slot.end)></span></div></div><div class=card-group style=\"margin-top: 0\" ng-if=\"getSlotCalendar(slot).timeSlotLength === \'day\'\"><span class=card-group-label ng-bind=\"\'LABEL.OPERATING_HOURS\' | translate\"></span><div class=card-group-value ng-bind=\"\n                            getSlotCalendar(slot).operatingHours.start +\':00 - \'+\n                            getSlotCalendar(slot).operatingHours.end +\':00\'\n                          \"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PRICE\' | translate\"></span><div class=card-group-value ng-bind=\"\'$\'+ slot.price\"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.STATE\' | translate\"></span><div class=\"card-group-value {{slot.state}}\" ng-bind=\"slot.state | capitalize\"></div></div></div><div class=card-foot ng-if=\"vm.currentUser.type === \'participant\' && !existInReserved(slot.id) && slot.state === \'available\'\"><button class=\"btn btn-success btn-block btn-sm\" type=button ng-click=handleAddToReserve(slot) ng-bind=\"\'BUTTON.ADD\' | translate\"></button></div></div></div></div><!-- Reserved slots --><div ng-if=\"vm.currentUser && vm.currentUser.type === \'participant\' && slotsToReserved.length\"><hr style=\"margin-bottom: 0\"><h4 ng-bind=\"\'TITLE.CHOOSE_SLOTS\' | translate\"></h4><div class=\"row row-flex row-16\"><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2\" ng-repeat=\"slot in slotsToReserved\" style=\"margin-top: 16px\"><div class=\"card card-default\" style=\"padding: 8px\"><div class=card-body><div class=card-group style=\"margin-top: 0\"><span class=card-group-label ng-bind=\"\'LABEL.BOOTH_NAME\' | translate\"></span><div class=card-group-value><span ng-bind=boothName></span></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=card-group-value><span ng-bind=toMonth(slot.start)></span></div></div><div class=card-group ng-if=\"getSlotCalendar(slot).timeSlotLength !== \'day\'\"><span class=card-group-label ng-bind=\"\'LABEL.AVAILABLE_HOURS\' | translate\"></span><div class=card-group-value><span ng-bind=toHours(slot.start)></span> - <span ng-bind=toHours(slot.end)></span></div></div><div class=card-group ng-if=\"getSlotCalendar(slot).timeSlotLength === \'day\'\"><span class=card-group-label ng-bind=\"\'LABEL.OPERATING_HOURS\' | translate\"></span><div class=card-group-value ng-bind=\"\n                              getSlotCalendar(slot).operatingHours.start +\':00 - \'+\n                              getSlotCalendar(slot).operatingHours.end +\':00\'\n                            \"></div></div><div class=row><div class=col-xs-4><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PRICE\' | translate\"></span><div class=card-group-value ng-bind=\"\'$\'+ slot.price\"></div></div></div></div></div><div class=card-foot ng-if=existInReserved(slot.id)><button class=\"btn btn-danger btn-block btn-sm\" type=button ng-click=handleRemoveFromReserve(slot) style=\"margin-left: 0\" ng-bind=\"\'BUTTON.REMOVE\' | translate\"></button></div></div></div></div><div class=\"form-group clearfix\"><div class=clearfix ng-if=\"totalPrice() === 0\"><button class=\"btn btn-primary btn-sm | pull-right\" type=button ng-if=\"vm.participantModule.cashPayment || vm.participantModule.cardPayment\" ng-disabled=\"slotsToReserved.length === 0 || loadingByCash || loadingByCard\" ng-click=noCostRequest()><i ng-if=loadingByCash class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> {{\'BUTTON.NO_COST_PURCHASE\' | translate}}</button></div><div class=clearfix ng-if=\"totalPrice() > 0\"><button class=\"btn btn-primary btn-sm | pull-right\" ng-disabled=\"slotsToReserved.length === 0 || loadingByCard || loadingByCash\" ng-if=\"vm.currentEvent.billingPreferences.serviceType === \'stripe\' && vm.participantModule.cardPayment\" ng-click=\"handleStripeButton({publishableKey: vm.currentEvent.billingPreferences.publishableKey})\"><i ng-if=loadingByCard class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> {{\'BUTTON.PAY_CREDIT_CARD\' | translate}}&nbsp;<span ng-bind=\"\'$\'+ totalPrice()\"></span></button> <button class=\"btn btn-primary btn-sm | pull-right\" ng-if=\"vm.currentEvent.billingPreferences.serviceType == \'transactionexpress\' && vm.participantModule.cardPayment\" ng-disabled=\"slotsToReserved.length === 0 || loadingByCard || loadingByCash\" ng-click=\"handleTransactionButton({\n                          hostedKey: vm.currentEvent.billingPreferences.hostedKey,\n                          gatewayId: vm.currentEvent.billingPreferences.gatewayId,\n                          hostedPageUrl: vm.currentEvent.billingPreferences.hostedPageUrl,\n                          callback: \'participant/event\'\n                        })\"><i ng-if=loadingByCard class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> {{\'BUTTON.PAY_CREDIT_CARD\' | translate}}&nbsp;<span ng-bind=\"\'$\'+ totalPrice()\"></span></button> <button class=\"btn btn-primary btn-sm | pull-right\" ng-if=\"vm.currentEvent.billingPreferences.serviceType == \'paypal\' && vm.participantModule.cardPayment\" ng-disabled=\"slotsToReserved.length === 0 || loadingByCard || loadingByCash\" ng-click=\"handlePaypalButton({\n                          paypalMerchantId: vm.currentEvent.billingPreferences.merchantId,\n                          paypalCallback: \'participant/event\',\n                          paypalMode: vm.currentEvent.billingPreferences.mode,\n                          paypalButtonType: \'participant\'\n                        })\"><i ng-if=loadingByCard class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> {{\'BUTTON.PAY_CREDIT_CARD\' | translate}}&nbsp;<span ng-bind=\"\'$\'+ totalPrice()\"></span></button> <button class=\"btn btn-primary btn-sm | pull-right\" ng-if=\"vm.currentEvent.billingPreferences.serviceType == \'squareup\' && vm.participantModule.cardPayment\" ng-disabled=\"slotsToReserved.length === 0 || loadingByCard || loadingByCash\" ng-click=\"handleSquareupButton({\n                          applicationId: vm.currentEvent.billingPreferences.applicationId,\n                          locationId: vm.currentEvent.billingPreferences.locationId\n                        })\"><i ng-if=loadingByCard class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> {{\'BUTTON.PAY_CREDIT_CARD\' | translate}}&nbsp;<span ng-bind=\"\'$\'+ totalPrice()\"></span></button> <button class=\"btn btn-primary btn-sm | pull-right\" ng-if=\"vm.currentEvent.billingPreferences.serviceType == \'payeezy\' && vm.participantModule.cardPayment\" ng-disabled=\"slotsToReserved.length === 0 || loadingByCard || loadingByCash\" ng-click=\"handlePayeezyButton({\n                          apiKey: vm.currentEvent.billingPreferences.apiKey,\n                          jsSecurityKey: vm.currentEvent.billingPreferences.jsSecurityKey,\n                          paymentJSUrl: vm.currentEvent.billingPreferences.paymentJSUrl,\n                          transarmorToken: vm.currentEvent.billingPreferences.transarmorToken\n                        })\"><i ng-if=loadingByCard class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> {{\'BUTTON.PAY_CREDIT_CARD\' | translate}}&nbsp;<span ng-bind=\"\'$\'+ totalPrice()\"></span></button><!-- Pay Cash --> <button class=\"btn btn-primary btn-sm | pull-right\" type=button style=\"margin-right: 8px\" ng-if=vm.participantModule.cashPayment ng-disabled=\"slotsToReserved.length === 0 || loadingByCash || loadingByCard\" ng-click=handleCashButton()><i ng-if=loadingByCash class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> {{\'BUTTON.PAY_CASH_CHECK\' | translate}}&nbsp;<span ng-bind=\"\'$\'+ totalPrice()\"></span></button></div><div class=help-text ng-bind=\"\'TEXT.RESERVE_THEM_ALL\' | translate\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/users/special/special.html","<div class=\"area area-page area-page-special\" ng-controller=\"SpecialController as vm\" ng-init=onInit()><div class=container-fluid><div class=\"nav nav-aside\" ng-class=\"{\'-in\': isOpened}\"><div class=text-right><button class=\"btn btn-link btn-nav-aside\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-remove-circle\"></i></button></div><ul class=nav-menu ng-click=\"isOpened = !isOpened\"><li ui-sref-active=active><a ui-sref=users.special.mainMap ng-bind=\"\'TAB.map\' | translate\"></a></li><li ng-if=\"currentEvent.modules.indexOf(\'messaging\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.special.messages ng-bind=\"\'TAB.messages\' | translate\"></a> <a ui-sref=users.special.messages.inbox id=_userMessages><span ng-bind=\"\'TAB.messages\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.special.messages.inbox id=_userMessagesInbox><span ng-bind=\"\'TAB.inbox\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a></li><li ui-sref-active=active><a ui-sref=users.special.messages.sent id=_userMessagesSent ng-bind=\"\'TAB.sent\' | translate\"></a></li></ul></li></ul></div><div class=area-content><p class=area-content-btn><button class=\"btn btn-primary\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-menu-hamburger\"></i></button></p><ui-view></ui-view></div></div></div>");
$templateCache.put("app/users/sponsor/sponsor.html","<div class=\"area area-page area-page-sponsor\" ng-controller=\"SponsorController as vm\" ng-init=onInit()><div class=container-fluid><div class=\"nav nav-aside\" ng-class=\"{\'-in\': isOpened}\"><div class=text-right><button class=\"btn btn-link btn-nav-aside\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-remove-circle\"></i></button></div><ul class=nav-menu ng-click=\"isOpened = !isOpened\"><li ui-sref-active=active><a ui-sref=users.sponsor.event ng-bind=\"\'TAB.event\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.sponsor.mainMap ng-bind=\"\'TAB.map\' | translate\"></a></li><li ui-sref-active=active ng-if=\"\n              vm.currentEvent.preferences.scheduleModule.enabled &&\n              vm.currentEvent.preferences.sponsorModule.enableUserTypeSchedule\n            \"><a ui-sref=users.sponsor.schedule ng-bind=\"\'TAB.schedule\' | translate\"></a></li><li ng-if=\"currentEvent.modules.indexOf(\'messaging\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.sponsor.messages ng-bind=\"\'TAB.messages\' | translate\"></a> <a ui-sref=users.sponsor.messages.inbox id=_userMessages><span ng-bind=\"\'TAB.messages\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.sponsor.messages.inbox id=_userMessagesInbox><span ng-bind=\"\'TAB.inbox\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a></li><li ui-sref-active=active><a ui-sref=users.sponsor.messages.sent id=_userMessagesSent ng-bind=\"\'TAB.sent\' | translate\"></a></li></ul></li><li ui-sref-active=active ng-if=showAttendantTab><a ui-sref=users.sponsor.attendants ng-bind=\"\'TAB.attendants\' | translate\"></a></li></ul></div><div class=area-content><p class=area-content-btn><button class=\"btn btn-primary\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-menu-hamburger\"></i></button></p><ui-view></ui-view></div></div></div>");
$templateCache.put("app/users/sponsor-attendant/sponsor-attendant.html","<div class=\"area area-page area-page-volunteer\" ng-controller=\"SponsorAttendantController as vm\" ng-init=onInit()><div class=container-fluid><div class=area-content><div class=\"row row-16\"><div class=\"col-sm-7 col-sm-push-5\"><div ng-if=\"vm.requests.length != 0\"><div class=\"row row-flex row-16\"><div class=\"col-xs-12 col-md-6\" style=\"margin-bottom: 16px\" ng-repeat=\"request in vm.requests | orderBy: \'-createdOn\' track by $index\"><div class=\"card card-default\"><div class=card-body><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=card-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=card-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.STATUS\'\"></span><div class=\"card-group-value {{request.status}}\" ng-bind=request.status></div></div></div></div></div><div class=card-foot><button class=\"btn btn-success btn-sm\" type=button ng-if=\"request.status == \'accepted\'\" ng-click=showEventPass(request) ng-bind=\"\'BUTTON.EVENT_PASS\' | translate\"></button></div></div></div></div></div></div><div class=\"col-sm-5 col-sm-pull-7\"><div class=\"panel panel-default\"><div class=panel-body ng-if=\"vm.appFormSponsorAttendant && vm.appFormSponsorAttendant.content\" ng-bind-html=\"vm.appFormSponsorAttendant.content | trusted\"></div><div class=panel-footer><button class=\"btn btn-info btn-sm\" type=button ng-if=\"vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)\" ng-click=handleDonation() ng-bind=\"\'BUTTON.donate\' | translate\"></button></div></div><!-- Include: Healine sponsor slider --><div ng-include=\"\'app/users/sponsor-inner-pages/ms-inner-pages.html\'\"></div><div class=\"panel panel-default\"><div class=panel-heading ng-bind-html=\"vm.event.name | trusted\"></div><div class=panel-body><p><span ng-bind=vm.event.address></span></p><p ng-if=vm.isSameDate><span ng-bind=vm.eventStartDate></span></p><p ng-if=!vm.isSameDate><span ng-bind=vm.eventStartDate></span> - <span ng-bind=vm.eventEndDate></span></p><p><span ng-bind=vm.eventStartTime></span> - <span ng-bind=vm.eventEndTime></span></p><div ta-bind ng-model=vm.event.description></div></div></div></div></div><!-- Include: Secondary sponsor slider --><div ng-include=\"\'app/users/sponsor-inner-pages/ss-inner-pages.html\'\"></div></div></div></div>");
$templateCache.put("app/users/sponsor-inner-pages/ms-inner-pages.html","<div class=\"panel panel-default panel-headline-sponsor\" ng-if=\"vm.sponsorsHeadline.length != 0\"><div class=panel-heading ng-bind=vm.sponsorModule.primaryLabel></div><div class=panel-body><slick settings=slickHeadlineConfig ng-if=vm.sponsorsHeadline.length><div ng-repeat=\"sponsor in vm.sponsorsHeadline | orderBy: \'order\' \"><a ng-href=\"{{ sponsor.website }}\" target=_blank><img ng-if=\"sponsor.logo && sponsor.logo.link\" ng-src=\"{{ sponsor.logo.link }}\" alt={{sponsor.name}}> <span ng-if=\"!sponsor.logo && !sponsor.logo.link\" style=\"width: 100%; display: block; text-align: center\" ng-bind=sponsor.name></span></a></div></slick></div></div>");
$templateCache.put("app/users/sponsor-inner-pages/ss-inner-pages.html","<div class=container-fluid ng-if=\"vm.sponsorsSecondary.length != 0\"><hr style=\"margin-top: 0; margin-bottom: 0\"><div class=area-content><slick settings=slickConfig class=sponsor-carousel ng-if=vm.sponsorsSecondary.length><div class=sponsor-carousel-item ng-repeat=\"sponsors in vm.sponsorsSecondary | orderBy: \'order\' \"><div ng-if=sponsors.length><a ng-repeat=\"sponsor in sponsors | orderBy: \'order\' \" ng-href=\"{{ sponsor.website }}\" target=_blank><img ng-if=\"sponsor.logo && sponsor.logo.link\" ng-src=\"{{ sponsor.logo.link }}\" alt={{sponsor.name}}> <span ng-if=\"!sponsor.logo && !sponsor.logo.link\" style=\"width: 100%; display: block; text-align: center\" ng-bind=sponsor.name></span></a></div><a ng-if=!sponsors.length ng-href=\"{{ sponsors.website }}\" target=_blank><img ng-if=\"sponsors.logo && sponsors.logo.link\" ng-src=\"{{ sponsors.logo.link }}\" alt={{sponsor.name}}> <span ng-if=\"!sponsors.logo && !sponsors.logo.link\" ng-bind=sponsors.name></span></a></div></slick></div></div>");
$templateCache.put("app/users/user-schedule/user-schedule.html","<div ng-controller=\"UserScheduleController as vm\" ng-init=onInit()><div class=eo-slick-schedule ng-if=\"vm.program && vm.program.length !== 0\"><div class=\"slick-item programList\" ng-repeat=\"program in vm.program track by $index\"><h3><span ng-bind=program.date></span> <span style=\"display: block; font-size: 14px; font-weight: 400; line-height: 1.2\" ng-bind=\"moment(program.date).format(\'dddd\')\"></span></h3><!-- Locations --><ul ng-if=\"program.locations && program.locations.length !== 0\" class=location-list style=\"overflow-y: auto\"><li ng-repeat=\"location in program.locations | orderBy:\'name\' track by $index\"><h3 ng-if=location.name ng-bind=location.name></h3><hr ng-if=!location.name><!-- Schedules --><ul ng-if=\"location.schedules && location.schedules.length !== 0\" class=schedule-list><li ng-repeat=\"schedule in location.schedules | orderBy:\'start\'\"><p><b ng-bind=formatTime(schedule.start)></b> &nbsp;-&nbsp; <b ng-bind=formatTime(schedule.end)></b></p><p ng-bind=schedule.description></p></li></ul></li></ul><!-- Schedules --><ul ng-if=\"program.schedules && program.schedules.length !== 0\" class=schedule-list style=\"overflow-y: auto\"><li ng-repeat=\"schedule in program.schedules | orderBy:\'start\' track by $index\"><p><b ng-bind=formatTime(schedule.start)></b> &nbsp;-&nbsp; <b ng-bind=formatTime(schedule.end)></b> <span ng-if=schedule.location ng-bind=\"\'(\'+ schedule.location +\')\'\"></span></p><p ng-bind=schedule.description></p></li></ul></div><button type=button class=\"slick-prev slick-arrow\" ng-click=handlePrevSlide()><i class=\"fa fa-angle-double-left\" aria-hidden=true></i></button> <button type=button class=\"slick-next slick-arrow\" ng-click=handleNextSlide()><i class=\"fa fa-angle-double-right\" aria-hidden=true></i></button></div></div>");
$templateCache.put("app/users/vendor/vendor.html","<div class=\"area area-page area-page-vendor\" ng-controller=\"VendorController as vm\" ng-init=onInit()><div class=container-fluid><div class=\"nav nav-aside\" ng-class=\"{\'-in\': isOpened}\"><div class=text-right><button class=\"btn btn-link btn-nav-aside\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-remove-circle\"></i></button></div><ul class=nav-menu ng-click=\"isOpened = !isOpened\"><li ui-sref-active=active><a ui-sref=users.vendor.event ng-bind=\"\'TAB.event\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.vendor.mainMap ng-bind=\"\'TAB.map\' | translate\"></a></li><li ui-sref-active=active ng-if=\"\n              vm.currentEvent.preferences.scheduleModule.enabled &&\n              vm.currentEvent.preferences.vendorModule.enableUserTypeSchedule\n            \"><a ui-sref=users.vendor.schedule ng-bind=\"\'TAB.schedule\' | translate\"></a></li><li ng-if=\"currentEvent.modules.indexOf(\'messaging\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.vendor.messages ng-bind=\"\'TAB.messages\' | translate\"></a> <a ui-sref=users.vendor.messages.inbox id=_userMessages><span ng-bind=\"\'TAB.messages\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.vendor.messages.inbox id=_userMessagesInbox><span ng-bind=\"\'TAB.inbox\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a></li><li ui-sref-active=active><a ui-sref=users.vendor.messages.sent id=_userMessagesSent ng-bind=\"\'TAB.sent\' | translate\"></a></li></ul></li></ul></div><div class=area-content><p class=area-content-btn><button class=\"btn btn-primary\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-menu-hamburger\"></i></button></p><ui-view></ui-view></div></div></div>");
$templateCache.put("app/users/volunteer/volunteer.html","<div class=\"area area-page area-page-volunteer\" ng-controller=\"VolunteerController as vm\" ng-init=onInit()><div class=container-fluid><div class=\"nav nav-aside\" ng-class=\"{\'-in\': isOpened}\"><div class=text-right><button class=\"btn btn-link btn-nav-aside\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-remove-circle\"></i></button></div><ul class=nav-menu ng-click=\"isOpened = !isOpened\"><li ui-sref-active=active><a ui-sref=users.volunteer.event ng-bind=\"\'TAB.event\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.volunteer.mainMap ng-bind=\"\'TAB.map\' | translate\"></a></li><li ui-sref-active=active ng-if=\"\n              vm.currentEvent.preferences.scheduleModule.enabled &&\n              vm.currentEvent.preferences.volunteerModule.enableUserTypeSchedule\n            \"><a ui-sref=users.volunteer.schedule ng-bind=\"\'TAB.schedule\' | translate\"></a></li><li ng-if=\"currentEvent.modules.indexOf(\'messaging\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.volunteer.messages ng-bind=\"\'TAB.messages\' | translate\"></a> <a ui-sref=users.volunteer.messages.inbox id=_userMessages><span ng-bind=\"\'TAB.messages\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.volunteer.messages.inbox id=_userMessagesInbox><span ng-bind=\"\'TAB.inbox\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a></li><li ui-sref-active=active><a ui-sref=users.volunteer.messages.sent id=_userMessagesSent ng-bind=\"\'TAB.sent\' | translate\"></a></li></ul></li><li ui-sref-active=active ng-if=hasAcceptedRequest><a ui-sref=users.volunteer.timeLog ng-bind=\"\'TAB.timeLog\' | translate\"></a></li></ul></div><div class=area-content><p class=area-content-btn><button class=\"btn btn-primary\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-menu-hamburger\"></i></button></p><ui-view></ui-view></div></div></div>");
$templateCache.put("app/users/volunteerCoordinator/volunteer-coordinator.html","<div class=\"area area-page\" ng-controller=\"VolunteerCoordinatorController as vm\" ng-init=onInit()><div class=container-fluid><div class=\"nav nav-aside\" ng-class=\"{\'-in\': isOpened}\"><div class=text-right><button class=\"btn btn-link btn-nav-aside\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-remove-circle\"></i></button></div><ul class=nav-menu ng-click=\"isOpened = !isOpened\"><li ui-sref-active=active><a ui-sref=users.volunteerCoordinator.map ng-bind=\"\'TAB.map\' | translate\"></a></li><li class=nav-menu-item ui-sref-active=active><a class=_placehold ui-sref=users.volunteerCoordinator.volunteers ng-bind=vm.volunteerModule.label></a> <a ui-sref=users.volunteerCoordinator.volunteers.all ng-bind=vm.volunteerModule.label></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.volunteerCoordinator.volunteers.all ng-bind=\"\'TAB.all\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.volunteerCoordinator.volunteers.requests ng-bind=\"\'TAB.requests\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.volunteerCoordinator.volunteers.bulk ng-bind=\"\'TAB.bulkRegister\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.volunteerCoordinator.volunteers.logBook ng-bind=\"\'TAB.logBook\' | translate\"></a></li><li ui-sref-active=active><a ui-sref=users.volunteerCoordinator.volunteers.assignments ng-bind=\"\'TAB.assignments\' | translate\"></a></li></ul></li><li ng-if=\"currentEvent.modules.indexOf(\'messaging\') > -1\" ui-sref-active=active><a class=_placehold ui-sref=users.volunteerCoordinator.messages ng-bind=\"\'TAB.messages\' | translate\"></a> <a ui-sref=users.volunteerCoordinator.messages.inbox id=_userMessages><span ng-bind=\"\'TAB.messages\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a><ul class=nav-menu-sub><li ui-sref-active=active><a ui-sref=users.volunteerCoordinator.messages.inbox id=_userMessagesInbox><span ng-bind=\"\'TAB.inbox\' | translate\"></span> <span class=badge ng-if=vm.inboxUnreadCount ng-bind=vm.inboxUnreadCount></span></a></li><li ui-sref-active=active><a ui-sref=users.volunteerCoordinator.messages.sent id=_userMessagesSent ng-bind=\"\'TAB.sent\' | translate\"></a></li></ul></li><li ui-sref-active=active ng-if=\"currentEvent.preferences.scheduleModule.enabled && currentEvent.preferences.scheduleModule.enableUserTypeSchedule\"><a ui-sref=users.volunteerCoordinator.schedule ng-bind=\"\'TAB.schedule\' | translate\"></a></li></ul></div><div class=area-content><p class=area-content-btn><button class=\"btn btn-primary\" ng-click=\"isOpened = !isOpened\"><i class=\"glyphicon glyphicon-menu-hamburger\"></i></button></p><ui-view></ui-view></div></div></div>");
$templateCache.put("app/users/messages/modal/modal.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"\'DIALOG.TITLE.MESSAGE_EVENT_ORGANIZER\' | translate\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.subject.$invalid && formSubmitted }\"><label for=subject>{{\'FORM.label.subject\' | translate}}<span>&nbsp;*</span></label><input class=form-control id=subject type=text name=subject placeholder=\"{{\'FORM.placeholder.subject\' | translate}}\" ng-model=vm.message.subject required><div class=help-block ng-if=formSubmitted ng-messages=form.subject.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.body.$invalid && formSubmitted }\"><label for=body>{{\'FORM.label.message\' | translate}}<span>&nbsp;*</span></label><textarea class=form-control id=body type=text name=body placeholder=\"{{\'FORM.placeholder.message\' | translate}}\" ng-model=vm.message.body rows=5 required>\n      </textarea><div class=help-block ng-if=formSubmitted ng-messages=form.body.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.DIALOG.CLOSE\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> {{\'BUTTON.DIALOG.SEND\' | translate}}</button></div></form>");
$templateCache.put("app/users/messages/inbox/inbox.html","<div ng-controller=\"MessagesInboxController as vm\" ng-init=onInit()><div class=messages ng-if=\"vm.inboxMessages.length != 0\"><div class=messages-aside><div class=filter><label class=\"form-group full\"><span class=label ng-bind=\"\'LABEL.SEARCH\' | translate\"></span> <input class=form-control type=text name=name placeholder=\"{{\'LABEL.SEARCH\' | translate }}\" ng-model=search ng-model-options=\"{debounce: 1000}\"></label></div><div class=messages-list><a class=item ng-repeat=\"message in vm.messages = (\n             vm.inboxMessages | FilterMessageSearch: search ) | orderBy: \'-createdOn\' | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\" ui-sref=\"{{ vm.userState }}({ id: message.id, recipientId: message.recipientId, appType: message.type })\" ui-sref-active=active ng-class=\"{\'unread\':  message.status === \'pending\' && vm.currentUser.id === message.recipientId}\" ng-click=handleMarkAsRead(message)><h2 class=item-title ng-bind=message.subject></h2><p class=item-date ng-bind=\"message.createdOn | dateFormated\"></p><p ng-if=message.scheduledDate class=item-date><b ng-bind=\"\'LABEL.SCHEDULED\' | translate\"></b> &nbsp;<span ng-bind=messageTime(message.scheduledDate)></span></p><p ng-if=\"message.type === \'sms_income\'\" class=item-date>Type: <b>SMS</b></p></a></div><ul ng-if=\"vm.messages.length > currentEvent.preferences.itemsPerPage && vm.messages.length != 0\" uib-pagination total-items=vm.messages.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage direction-links=false boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div><div class=messages-content ui-view=message><div class=no-message><h3 ng-bind=\"\'TEXT.NO_MESSAGE_SELECTED\' | translate\"></h3></div></div></div><div class=no-message ng-if=\"vm.inboxMessages.length == 0\"><i class=\"glyphicon glyphicon-envelope\"></i><h3 ng-bind=\"\'TEXT.NO_MESSAGES\' | translate\"></h3></div></div>");
$templateCache.put("app/users/messages/preview/preview.html","<div ng-controller=\"MessagesPreviewController as vm\" ng-init=onInit()><div class=message-preview><h2 class=message-preview-subject ng-bind=vm.message.subject></h2><div class=message-preview-date ng-if=vm.sentBy ng-bind=vm.sentBy></div><div class=message-preview-date ng-if=\"vm.sendTo && vm.sendTo.length != 0\">{{\'LABEL.TO\' | translate}}&nbsp; <span style=\"color: #121212\" ng-repeat=\"send in vm.sendTo track by $index\" ng-bind=\"send + ( vm.sendTo.length - 1 === $index ? \'\' : \', \' )\"></span></div><div class=message-preview-date ng-if=\"vm.message.fromType && vm.message.fromName\">{{\'LABEL.FROM\' | translate}} <span style=\"color: #121212\" ng-bind=vm.message.fromType></span> <span style=\"color: #121212\" ng-bind=vm.message.fromName></span> <a href=mailto:{{vm.message.fromEmail}} ng-bind=\"\'(\'+ vm.message.fromEmail +\')\'\"></a></div><p class=message-preview-date ng-bind=\"vm.message.createdOn | dateFormated\"></p><p class=message-preview-date ng-if=vm.message.scheduledDate><b ng-bind=\"\'LABEL.SCHEDULED\' | translate\"></b>&nbsp; <span ng-bind=\"vm.message.scheduledDate | dateFormated\"></span></p><div class=message-preview-content ng-bind=\"vm.message.body | strippedHTML | decimalNumber\"></div><div class=message-preview-date ng-if=vm.message.shortText><b ng-bind=\"\'LABEL.TEXT_MESSAGE\' | translate\"></b>&nbsp; <span ng-bind=vm.message.shortText></span></div><div class=message-buttons ng-if=vm.allowToEditMessage style=\"margin-top: 16px\"><a class=\"btn btn-default\" ng-click=\"openModalMessage(vm.message.id, vm.message)\" ng-bind=\"\'BUTTON.EDIT\' | translate\"></a> <button class=\"btn btn-danger\" type=button ng-click=handleRemove(vm.message) ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></div></div></div><div ui-view=modal></div>");
$templateCache.put("app/users/messages/sent/sent.html","<div ng-controller=\"MessagesSentController as vm\" ng-init=onInit()><div class=messages ng-if=\"vm.sentMessages.length != 0\"><div class=messages-aside><div class=filter><label class=\"form-group full\"><span class=label ng-bind=\"\'LABEL.SEARCH\' | translate\"></span> <input class=form-control type=text name=name placeholder=\"{{\'LABEL.SEARCH\' | translate }}\" ng-model=search ng-model-options=\"{debounce: 1000}\"></label></div><div class=messages-list><a class=item ng-repeat=\"message in vm.messages = ( vm.sentMessages | FilterMessageSearch: search ) | orderBy: \'-createdOn\' | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\" ui-sref=\"{{ vm.userState }}({ id: message.id, appType: message.type })\" ui-sref-active=active><h2 class=item-title ng-bind=message.subject></h2><p class=item-date ng-bind=\"message.createdOn | dateFormated\"></p><p ng-if=message.scheduledDate class=item-date><b ng-bind=\"\'LABEL.SCHEDULED\' | translate\"></b> &nbsp;<span ng-bind=messageTime(message.scheduledDate)></span></p></a></div><ul ng-if=\"vm.messages.length > currentEvent.preferences.itemsPerPage && vm.messages.length != 0\" uib-pagination total-items=vm.messages.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage direction-links=false boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div><div class=messages-content ui-view=message><div class=no-message><h3 ng-bind=\"\'TEXT.NO_MESSAGE_SELECTED\' | translate\"></h3></div></div></div><div class=no-message ng-if=\"vm.sentMessages.length == 0\"><i class=\"glyphicon glyphicon-envelope\"></i><h3 ng-bind=\"\'TEXT.NO_MESSAGES\' | translate\"></h3></div></div>");
$templateCache.put("app/users/organizer/event/event.html","<div ng-controller=\"OrganizerEventController as vm\" ng-init=onInit()><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/organizer/login-as/login-as.html","<form novalidate name=form ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"\'DIALOG.TITLE.LOGIN_AS\' | translate\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.username.$invalid && formSubmitted }\"><label for=username><span ng-bind=\"\'FORM.label.username\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=username type=text name=username placeholder=\"{{\'FORM.placeholder.username\' | translate}}\" ng-model=asUser.username required><div class=help-block ng-if=formSubmitted ng-messages=form.username.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.password.$invalid && formSubmitted }\"><label for=password><span ng-bind=\"\'FORM.label.password\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=password type=password name=password placeholder=\"{{\'FORM.placeholder.password\' | translate}}\" ng-model=asUser.password required><div class=help-block ng-if=formSubmitted ng-messages=form.password.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> {{\'BUTTON.login\' | translate}}</button></div></form>");
$templateCache.put("app/users/organizer/map/map.html","<div ng-controller=\"OrganizerMapController as vm\" ng-init=onInit()><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/organizer/messages/messages.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title id=modal-title><span ng-bind=label></span> message</h3></div><div class=modal-body id=modal-body><fieldset><legend>Send To</legend><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{ \'has-error\': vm.userSelector && form.userType.$invalid }\"><label class=show><span ng-bind=\"\'FORM.MESSAGE.USER_TYPE\' | translate\"></span> <span ng-if=\"vm.userType || vm.userSelector\">&nbsp;*</span><select class=form-control name=userType ng-change=onChangeUser() ng-model=vm.userType ng-required=vm.userSelector><option ng-repeat=\"item in userTypes\" ng-value=item.type ng-bind=item.name></option></select></label><div class=help-block ng-if=\"vm.userSelector && form.userType.$invalid\" ng-messages=form.userType.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{ \'has-error\': vm.userType && form.userSelector.$invalid }\"><label class=show><span ng-bind=\"\'FORM.MESSAGE.USER_SELECTOR\' | translate\"></span> <span ng-if=\"vm.userType || vm.userSelector\">&nbsp;*</span><select class=form-control name=userSelector ng-change=onChangeUser() ng-model=vm.userSelector ng-required=vm.userType><option ng-repeat=\"item in userSelectors\" ng-value=item.type ng-bind=item.name></option></select></label><div class=help-block ng-if=\"vm.userType && form.userSelector.$invalid\" ng-messages=form.userSelector.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div></div><div class=form-group><label for=users ng-bind=\"\'FORM.MESSAGE.USERS\' | translate\"></label><ui-select ng-model=vm.recipientIds multiple><ui-select-match placeholder=\"Search users\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices refresh=handleUsersSearch($select.search) refresh-delay=0 repeat=\"user in vm.usersSearch | filter: { name: $select.search }\"><span class=ui-select-title ng-bind=user.name></span> <span class=ui-select-describe ng-bind=user.email></span></ui-select-choices></ui-select></div><div class=form-group><label for=groups ng-bind=\"\'FORM.MESSAGE.USER_GROUPS\' | translate\"></label><ui-select ng-model=vm.recipientGroupIds multiple><ui-select-match placeholder=\"{{ \'FORM.MESSAGE.USER_GROUPS\' | translate }}\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices repeat=\"group in vm.userGroups | filter: { name: $select.search }\"><span ng-bind=group.name></span></ui-select-choices></ui-select></div><hr></fieldset><div class=form-group ng-class=\"{ \'has-error\': form.subject.$invalid && formSubmitted }\"><label for=subject><span ng-bind=\"\'FORM.MESSAGE.SUBJECT\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=subject type=text name=subject placeholder=\"{{\'FORM.MESSAGE.SUBJECT\' | translate}}\" ng-model=vm.message.subject ng-required=!vm.message.sentToSms><div class=help-block ng-if=formSubmitted ng-messages=form.subject.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><!-- Text editor with gallery --><text-editor-gallery teg-name=body teg-label=Message teg-model=vm.message.body teg-required=true teg-form=form teg-submitted=formSubmitted><text-editor-gallery-body><div class=\"help-block help-block-default\">Formatting will be kept only for Email messages.</div></text-editor-gallery-body></text-editor-gallery><div class=form-group><div class=checkbox><label><input type=checkbox id=sendToEmail name=sendToEmail ng-model=vm.message.sendToEmail> <span class=label></span> <span ng-bind=\"\'FORM.MESSAGE.INCLUDE_EMAIL_NOTIFICATION\' | translate\"></span></label></div><div class=checkbox><label><input type=checkbox id=sendToSms name=sendToSms ng-model=vm.message.sendToSms> <span class=label></span> <span ng-bind=\"\'FORM.MESSAGE.INCLUDE_TEXT_MESSAGE\' | translate\"></span></label></div><div class=form-group ng-if=vm.message.sendToSms ng-class=\"{ \'has-error\': form.shortText.$invalid && formSubmitted }\"><label for=shortText><span ng-bind=\"\'FORM.MESSAGE.TEXT_MESSAGE\' | translate\"></span> <span>&nbsp;*</span></label><textarea class=form-control id=shortText name=shortText placeholder=\"{{\'FORM.MESSAGE.TEXT_MESSAGE\' | translate}}\" ng-model=vm.message.shortText ng-blur=onShortText(vm.message.shortText) ng-trim=false maxlength=160 required>\n        </textarea><div class=\"help-block text-right\">{{vm.message.shortText ? 160 - vm.message.shortText.length : 160}}</div><div class=help-block ng-if=formSubmitted ng-messages=form.shortText.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=checkbox><label><input type=checkbox id=scheduleDate name=scheduleDate ng-model=vm.scheduleDate> <span class=label></span> <span ng-bind=\"\'FORM.MESSAGE.SCHEDULE_DATE\' | translate\"></span></label></div></div><div ng-if=vm.scheduleDate><div class=form-group ng-class=\"{ \'has-error\': form.startDate.$invalid && formSubmitted }\"><label for=date><span ng-bind=\"\'FORM.MESSAGE.DATE\' | translate\"></span> <span>&nbsp;*</span></label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=handleDatepickerPopup()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=startDate ng-model=vm.startDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=datepickerPopup.opened show-button-bar=false ng-required=vm.scheduleDate></div><div class=help-block ng-if=formSubmitted ng-messages=form.startDate.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=date ng-bind=\"\'FORM.validation.invalidDate\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.startTime.$invalid && formSubmitted }\"><label for=startTime><span ng-bind=\"\'FORM.MESSAGE.START_TIME\' | translate\"></span> <span>&nbsp;*</span></label><div uib-timepicker ng-model=vm.startTime name=startTime ng-change=changed() show-meridian=true ng-required=vm.scheduleDate></div><div class=help-block ng-if=formSubmitted ng-messages=form.startTime.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=time ng-bind=\"\'FORM.validation.invalidTime\' | translate\"></div></div></div></div></div><div class=modal-footer><span class=text-danger style=\"display: inline-block; padding-top: 6px; font-size: 15px; padding-right: 8px\" ng-if=formRecipientError>No recipient(s) selected</span> <button class=\"btn btn-default\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.DIALOG.CLOSE\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><span ng-if=vm.scheduleDate ng-bind=\"\'BUTTON.SCHEDULE\' | translate\"></span> <span ng-if=!vm.scheduleDate ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/organizer/messages/messages.html","<div ng-controller=OrganizerMessagesController ng-init=onInit()><div class=form-group ng-if=eventStatus><button class=\"btn btn-info\" type=button ng-click=openModalMessage() ng-bind=\"\'BUTTON.SEND_MESSAGE\' | translate\"></button></div><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div><div ui-view=modal></div>");
$templateCache.put("app/users/organizer/participants/participants.html","<div ng-controller=\"OrganizerParticipantsController as vm\" ng-init=onInit()><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/organizer/profile/profile.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title id=modal-title ng-bind=\"\'TITLE.dialogUpdateProfile\' | translate\"></h3></div><div class=modal-body><div class=\"row row-8\"><div class=col-sm-6><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=name type=text name=name placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.userProfile.name required disabled><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=col-sm-6><div class=form-group ng-class=\"{\'has-error\': form.email.$invalid && formSubmitted }\"><label for=email><span ng-bind=\"\'FORM.label.email\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=email type=email name=email placeholder=\"{{\'FORM.placeholder.email\' | translate}}\" ng-model=vm.userProfile.email required><div class=help-block ng-if=formSubmitted ng-messages=form.email.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=email ng-bind=\"\'FORM.validation.invalidEmail\' | translate\"></div></div></div></div></div><div class=form-group><label for=description ng-bind=\"\'FORM.label.description\' | translate\"></label><textarea class=form-control id=description name=description placeholder=\"{{\'FORM.placeholder.description\' | translate}}\" ng-model=vm.userProfile.description rows=5>\n      </textarea></div><div class=form-group><label for=address ng-bind=\"\'FORM.label.address\' | translate\"></label><input class=form-control id=address type=text name=address placeholder=\"{{\'FORM.placeholder.address\' | translate}}\" ng-model=vm.userProfile.address></div><div class=form-group><label ng-bind=\"\'FORM.label.phone\' | translate\"></label><div class=form-group><div class=\"row row-8\"><div class=col-xs-5><select class=\"form-control input-sm\" ng-model=vm.userProfile.phone1.type><option value=cell ng-bind=\"\'FORM.value.phoneType.cell\' | translate\"></option><option value=work ng-bind=\"\'FORM.value.phoneType.work\' | translate\"></option><option value=home ng-bind=\"\'FORM.value.phoneType.home\' | translate\"></option></select></div><div class=col-xs-7><phone-number ng-model=vm.userProfile.phone1.number></phone-number></div></div></div><div class=form-group><div class=\"row row-8\"><div class=col-xs-5><select class=\"form-control input-sm\" ng-model=vm.userProfile.phone2.type><option value=cell ng-bind=\"\'FORM.value.phoneType.cell\' | translate\"></option><option value=work ng-bind=\"\'FORM.value.phoneType.work\' | translate\"></option><option value=home ng-bind=\"\'FORM.value.phoneType.home\' | translate\"></option></select></div><div class=col-xs-7><phone-number ng-model=vm.userProfile.phone2.number></phone-number></div></div></div><p class=\"help-block help-block-default\" ng-bind=\"\'FORM.AUTH.PHONE_LABEL\' | translate\"></p></div><div class=\"row row-8\"><div class=col-md-4><div class=form-group><label for=state ng-bind=\"\'FORM.label.state\' | translate\"></label><select class=form-control id=state name=state ng-model=vm.userProfile.state ng-options=\"state.code as state.name for state in vm.states\"><option value=\"\" ng-bind=\"\'FORM.value.chooseState\' | translate\"></option></select></div></div><div class=col-md-4><div class=form-group><label for=city ng-bind=\"\'FORM.label.city\' | translate\"></label><input class=form-control id=city type=text name=city placeholder=\"{{\'FORM.placeholder.city\' | translate}}\" ng-model=vm.userProfile.city></div></div><div class=col-md-4><div class=form-group ng-class=\"{ \'has-error\': form.zipCode.$invalid && formSubmitted }\"><label for=zipCode ng-bind=\"\'FORM.label.zipCode\' | translate\"></label><input class=form-control id=zipCode type=text name=zipCode placeholder=\"{{\'FORM.placeholder.zipCode\' | translate}}\" ng-model=vm.userProfile.zipCode><div class=help-block ng-if=formSubmitted ng-messages=form.zipCode.$error role=alert><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div></div><div class=form-group><label for=company ng-bind=\"\'FORM.label.company\' | translate\"></label><input class=form-control id=company type=text name=company placeholder=\"{{\'FORM.placeholder.company\' | translate}}\" ng-model=vm.userProfile.company></div><hr><div class=form-group><div class=checkbox><label for=emailOptOut><input type=checkbox id=emailOptOut name=emailOptOut ng-model=vm.userProfile.emailOptOut> <span ng-bind=\"\'FORM.value.stopReceivingEmail\' | translate\"></span></label></div><div class=checkbox><label for=smsOptOut><input type=checkbox id=smsOptOut name=smsOptOut ng-model=vm.userProfile.smsOptOutCheckbox> <span ng-bind=\"\'FORM.value.stopReceivingText\' | translate\"></span></label></div><div class=\"help-block help-block-default\" style=\"position: relative; text-align: left !important; margin-bottom: 0 !important\" ng-if=\"!settingsLoading && vm.userProfile.smsOptOutStatus === \'opted_out_sms\'\">Text START to <span ng-bind=\"eventPhoneNumber.value | formatPhone\"></span> to start receiving event alerts</div></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button ng-click=onClose() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.update\' | translate\"></span></button></div></form>");
$templateCache.put("app/users/organizer/reservation/form.reservation.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"modalLabel +\' calendar\'\"></h3></div><div class=modal-body><div class=\"row row-8\"><div class=col-xs-6><div class=\"form-group form-group-datepicker\" ng-class=\"{\'has-error\': formSubmitted && (form.fromDate.$invalid || startDateIsGreaterThanEnd) }\"><label for=fromDate><span ng-bind=\"\'FORM.label.fromDate\' | translate\"></span> <span>&nbsp;*</span></label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default btn-sm\" type=button ng-click=onPopup1Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=\"form-control input-sm\" type=text name=fromDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=fromDate ng-change=\"onChangeDate(fromDate, toDate)\" is-open=popup1.opened datepicker-options=startOptions show-button-bar=false ng-required=true></div><div class=help-block ng-if=\"formSubmitted && form.fromDate.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=col-xs-6><div class=\"form-group form-group-datepicker\" ng-class=\"{\'has-error\': formSubmitted && (form.toDate.$invalid || startDateIsGreaterThanEnd) }\"><label for=toDate><span ng-bind=\"\'FORM.label.toDate\' | translate\"></span> <span>&nbsp;*</span></label><div class=\"input-group input-group-right\"><span class=\"input-group-btn date\"><button class=\"btn btn-default btn-sm\" type=button ng-click=onPopup2Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=\"form-control input-sm\" type=text name=toDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=toDate ng-change=\"onChangeDate(fromDate, toDate)\" is-open=popup2.opened datepicker-options=endOptions show-button-bar=false ng-required=true></div><div class=help-block ng-if=\"formSubmitted && form.toDate.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=text-danger style=\"font-size: 12px; margin-bottom: 12px\" ng-if=\"formSubmitted && startDateIsGreaterThanEnd\" ng-bind=\"\'FORM.validation.startDateGreaterThanEnd\' | translate\"></div></div><div class=form-group ng-class=\"{\'has-error\': form.reservationDescription.$invalid && formSubmitted }\"><label for=reservationDescription><span ng-bind=\"\'FORM.label.description\' | translate\"></span> <span>&nbsp;*</span></label><textarea class=form-control name=reservationDescription id=reservationDescription rows=3 ng-model=reservation.description required>\n      </textarea><div class=help-block ng-if=\"formSubmitted && form.reservationDescription.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div><div class=\"row row-8\"><div class=col-xs-12><div class=form-group><label for=reservationTimeSlot><span ng-bind=\"\'FORM.label.frequency\' | translate\"></span> <span>&nbsp;*</span></label><div class=radio><label><input type=radio value=day name=reservationFrequency ng-model=reservation.timeSlotLength ng-disabled=reservation.id> <span ng-bind=\"\'FORM.value.day\' | translate\"></span></label></div><div class=radio><label><input type=radio value=hour name=reservationFrequency ng-model=reservation.timeSlotLength ng-disabled=reservation.id> <span ng-bind=\"\'FORM.value.hour\' | translate\"></span></label></div></div></div></div><div class=form-group><label for=operatingHours ng-bind=\"\'FORM.label.businessHours\' | translate\"></label><div class=\"row row-8\"><div class=\"col-xs-6 col-sm-3\"><div class=form-group ng-class=\"{\'has-error\': formSubmitted && (form.operatingHoursStart.$invalid || startHourIsGreaterThanEnd) }\"><label for=operatingHoursStart><span ng-bind=\"\'FORM.label.start\' | translate\"></span> <span>&nbsp;*</span></label><select class=form-control name=operatingHoursStart id=operatingHoursStart ng-model=reservation.operatingHours.start required ng-change=\"handleChange(reservation.operatingHours.start, reservation.operatingHours.end)\"><option value=\"\" ng-binf=\"\'FORM.value.from\' | translate\"></option><option ng-repeat=\"hour in hours\" ng-value=hour ng-bind=hour></option></select><div class=help-block ng-if=\"formSubmitted &&  form.operatingHoursStart.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=\"col-xs-6 col-sm-3\"><div class=form-group ng-class=\"{\'has-error\': formSubmitted && (form.operatingHoursEnd.$invalid || startHourIsGreaterThanEnd) }\"><label for=operatingHoursEnd><span ng-bind=\"\'FORM.label.end\' | translate\"></span> <span>&nbsp;*</span></label><select class=form-control name=operatingHoursEnd id=operatingHoursEnd ng-model=reservation.operatingHours.end required ng-change=\"handleChange(reservation.operatingHours.start, reservation.operatingHours.end)\"><option value=\"\" ng-binf=\"\'FORM.value.to\' | translate\"></option><option ng-repeat=\"hour in hours\" ng-value=hour ng-bind=hour></option></select><div class=help-block ng-if=\"formSubmitted && form.operatingHoursEnd.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=text-danger style=\"font-size: 12px; margin-bottom: 12px\" ng-if=\"startHourIsGreaterThanEnd && formSubmitted\" ng-bind=\"\'FORM.validation.startTimeGreaterThanEnd\' | translate\"></div></div><div class=from-group ng-if=\"dayRange.length !== 0\"><label ng-bind=\"\'FORM.label.priceDailyBreakdown\' | translate\"></label><div class=\"form-group form-group-sm\"><div class=\"row row-8 row-flex flex-center\" ng-repeat=\"(key, value) in reservation.dayOfWeekPricing\" ng-if=isDayPresent(key)><div class=\"col-xs-6 col-sm-4\" ng-bind=\"key | capitalize\"></div><div class=\"col-xs-6 col-sm-4\"><div class=input-group><div class=input-group-addon>$</div><input type=number class=form-control ng-model=reservation.dayOfWeekPricing[key]></div></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=submit ng-disabled=\"isDisabled() && formLoading\"><i ng-if=loading class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=modalLabel></span></button></div></form>");
$templateCache.put("app/users/organizer/reservation/reservation.html","<div ng-controller=\"OrganizerReservationController as vm\" ng-init=onInit()><div ng-if=loading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!loading><div class=clearfix ng-if=eventStatus><button class=\"btn btn-default btn-sm | pull-left\" ng-click=goBack() ng-bind=\"\'BUTTON.back\' | translate\"></button> <button class=\"btn btn-info btn-sm | pull-right\" ng-click=handleCreateCalendar() ng-bind=\"\'BUTTON.createCalendar\' | translate\"></button></div><div class=\"row row-flex row-16\" ng-if=reservations.length><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\" style=\"margin-top: 16px\" ng-repeat=\"reserve in reservations\"><div class=\"card card-default\"><div class=card-head><div class=card-subtitle><b style=\"color: #121212\" ng-bind=\"\'FORM.label.dateRange\' | translate\"></b><div class=card-group-label><!-- <span ng-bind=\"reserve.from | dateFormatedOnly\"></span>&nbsp;-&nbsp;\n                <span ng-bind=\"moment(reserve.to).subtract(1, \'days\') | dateFormatedOnly\"></span> --> <span ng-if=\"!isSameDayC(reserve.from, reserve.to)\" ng-bind=\"reserve.from | dateFormatedOnly\"></span> <span ng-if=\"!isSameDayC(reserve.from, reserve.to)\">&nbsp;-&nbsp;</span> <span ng-if=\"!isSameDayC(reserve.from, reserve.to)\" ng-bind=\"moment(reserve.to).subtract(1, \'days\') | dateFormatedOnly\"></span> <span ng-if=\"isSameDayC(reserve.from, reserve.to)\" ng-bind=\"reserve.from | dateFormatedOnly\"></span></div></div></div><div class=card-body><div class=card-group ng-if=reserve.description><span class=card-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=card-group-value ng-bind=reserve.description></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.reservationType\' | translate\"></span><div class=card-group-value><span class=\"card-group-color {{reserve.timeSlotLength}}\"></span> <span ng-bind=\"reserve.timeSlotLength | capitalize\"></span></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.operatingHours\' | translate\"></span><div class=card-group-value ng-bind=\"\n                    reserve.operatingHours.start +\':00 - \'+\n                    reserve.operatingHours.end +\':00\'\n                   \"></div></div><div class=card-group><div class=card-group-value ng-repeat=\"(key, value) in reserve.dayOfWeekPricing\"><span ng-if=\"value !== 0 || value !== \'\'\"><b ng-bind=\"key | capitalize\"></b>:&nbsp;<i ng-bind=\"\'$\'+ value\"></i></span></div></div></div><div class=card-foot><button class=\"btn btn-default btn-sm\" type=button ng-click=handleEditCalendar(reserve) ng-bind=\"\'BUTTON.edit\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" type=button ng-click=handleDeleteCalendar(reserve) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></div></div></div><div class=no-message ng-if=\"reservations.length === 0\"><i class=\"glyphicon glyphicon-calendar\"></i><h3 ng-bind=\"\'TEXT.noReservations\' | translate\"></h3></div><calendar-reservation cr-type=\"\'reservations\'\" cr-data=reservations cr-show-past=true fn-selecte-day=handleSelectDay></calendar-reservation><div ng-if=loadingSlot ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!loadingSlot><div class=bg-info style=\"margin-bottom: 16px; padding: 16px\" ng-if=\"errSlots && !slots.length\" ng-bind=errSlotsMsg></div><div class=\"row row-flex row-16\" ng-if=slots.length><div class=\"col-xs-6 col-sm-4 col-md-3 col-lg-2\" ng-repeat=\"slot in slots\" style=\"margin-top: 16px\"><div class=\"card card-default\" style=\"padding: 8px\"><div class=card-body><div class=card-group style=\"margin-top: 0\" ng-if=\"getSlotCalendar(slot).timeSlotLength !== \'day\'\"><span class=card-group-label ng-bind=\"\'FORM.label.availableHours\' | translate\"></span><div class=card-group-value><span ng-bind=toHours(slot.start)></span> - <span ng-bind=toHours(slot.end)></span></div></div><div class=card-group style=\"margin-top: 0\" ng-if=\"getSlotCalendar(slot).timeSlotLength === \'day\'\"><span class=card-group-label ng-bind=\"\'FORM.label.operatingHours\' | translate\"></span><div class=card-group-value ng-bind=\"\n                        getSlotCalendar(slot).operatingHours.start +\':00 - \'+\n                        getSlotCalendar(slot).operatingHours.end +\':00\'\n                      \"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.price\' | translate\"></span><div class=card-group-value ng-bind=\"\'$\'+ slot.price\"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.state\' | translate\"></span><div class=card-group-value ng-bind=\"slot.state | capitalize\"></div></div></div><div class=card-foot ng-if=\"slot.state !== \'reserved\'\"><div uib-dropdown class=btn-group style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button><li role=menuitem><button type=button ng-click=handleEditSlot(slot) ng-bind=\"\'BUTTON.edit\' | translate\"></button></li><li role=menuitem><button type=button ng-click=handleReserveSlot(slot) ng-bind=\"\'BUTTON.reserve\' | translate\"></button></li><li role=menuitem><button type=button ng-click=handleDeleteSlot(slot) ng-bind=\"\'BUTTON.delete\' | translate\"></button></li></ul></div></div></div></div></div></div></div></div>");
$templateCache.put("app/users/organizer/scavenger-hunt/scavenger-hunt.html","<div ng-controller=\"OrganizerScavengerHuntCtrl as vm\" ng-init=onInit()><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/organizer/special-users/special-users.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"label +\' special user\'\"></h3></div><div class=modal-body><div class=form-group ng-if=passwordRequired ng-class=\"{ \'has-error\': form.type.$invalid && formSubmitted }\"><label for=type>{{\'FORM.label.userType\' | translate}}<span>&nbsp;*</span></label><select class=form-control name=type ng-model=vm.user.type id=type required><option value=\"\" ng-bind=\"\'Choose user type\'\"></option><option value=special ng-bind=\"\'Special\'\"></option><option value=eventCoordinator ng-bind=\"\'Event Coordinator\'\"></option><option value=volunteerCoordinator ng-bind=\"\'Volunteer Coordinator\'\"></option></select><div class=help-block ng-if=formSubmitted ng-messages=form.type.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.username.$invalid && formSubmitted }\"><label for=username><span ng-bind=\"\'FORM.label.username\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=username type=text placeholder=\"{{\'FORM.placeholder.username\' | translate}}\" ng-model=vm.user.username name=username ng-disabled=!passwordRequired required><div class=help-block ng-if=formSubmitted ng-messages=form.username.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=name type=text placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.user.name name=name required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.email.$invalid && formSubmitted }\"><label for=email><span ng-bind=\"\'FORM.label.email\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=email type=email placeholder=\"{{\'FORM.placeholder.email\' | translate}}\" ng-model=vm.user.email name=email required><div class=help-block ng-if=form.email.$touched ng-messages=form.email.$error role=alert><div ng-message=email ng-bind=\"\'FORM.validation.invalidEmail\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\'\"></div></div></div><div ng-if=passwordRequired><div class=form-group ng-class=\"{ \'has-error\': form.password.$invalid && formSubmitted }\"><label for=password><span ng-bind=\"\'FORM.label.password\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=password type=password placeholder=\"{{\'FORM.placeholder.password\' | translate}}\" ng-model=vm.user.password name=password ng-minlength=6 required><div class=help-block ng-if=formSubmitted ng-messages=form.password.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=minlength ng-bind=\"\'FORM.validation.minLength\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.rePassword.$invalid && formSubmitted }\"><label for=rePassword><span ng-bind=\"\'FORM.label.rePassword\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=rePassword type=password placeholder=\"{{\'FORM.placeholder.rePassword\' | translate}}\" ng-model=vm.user.rePassword name=rePassword ng-minlength=6 match=vm.user.password required><div class=help-block ng-if=formSubmitted ng-messages=form.rePassword.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=minlength ng-bind=\"\'FORM.validation.minLength\' | translate\"></div><div ng-message=match ng-bind=\"\'FORM.validation.notMatchPassword\' | translate\"></div></div></div></div><div class=form-group><label ng-bind=\"\'FORM.label.phone\' | translate\"></label><div class=\"row row-8\"><div class=col-xs-4><select class=\"form-control input-sm\" id=phoneType name=phoneType ng-init=\"vm.user.phone1.type = \'cell\'\" ng-model=vm.user.phone1.type><option value=cell ng-bind=\"\'FORM.value.phoneType.cell\' | translate\"></option><option value=work ng-bind=\"\'FORM.value.phoneType.work\' | translate\"></option><option value=home ng-bind=\"\'FORM.value.phoneType.home\' | translate\"></option></select></div><div class=col-xs-8><phone-number ng-model=vm.user.phone1.number></phone-number></div></div><p class=\"help-block help-block-default\" ng-bind=\"\'FORM.AUTH.PHONE_LABEL\' | translate\"></p></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button data-dismiss=modal ng-click=handleCancel() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/organizer/special-users/special-users.html","<div ng-controller=\"OrganizerSpecialUsersController as vm\" ng-init=onInit()><div class=filter><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><select class=form-control name=userGroupsSearch ng-init=\"userGroupsSearch = \'all\'\" ng-model=userGroupsSearch><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"group in vm.userGroups track by $index\" ng-value=group.name ng-bind=group.name></option></select></label></div><div class=clearfix ng-if=eventStatus><button class=\"btn btn-info btn-sm | pull-right\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.create\' | translate\"></button></div><div class=\"row row-flex row-16\" ng-if=vm.specialUsers.length><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\" style=\"margin-top: 16px\" ng-repeat=\"user in vm.filterSpecialUsers = (\n          vm.specialUsers\n          | FilterUserGroups: userGroupsSearch\n        ) | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\"><div class=\"card card-default\"><div class=card-head><h2 class=card-title ng-bind=user.name></h2><h4 class=card-subtitle ng-bind=user.username></h4></div><div class=card-body><div class=card-cell><div class=card-group ng-if=user.email><span class=card-group-label ng-bind=\"\'LABEL.EMAIL\' | translate\"></span><div class=card-group-value ng-bind=user.email></div></div><div class=card-group ng-if=user.type><span class=card-group-label ng-bind=\"\'LABEL.TYPE\' | translate\"></span><div class=card-group-value>{{user.type == \'volunteerCoordinator\' ? \'Volunteer Coordinator\': \'\'}}</div><div class=card-group-value>{{user.type == \'eventCoordinator\' ? \'Event Coordinator\': \'\'}}</div><div class=card-group-value>{{user.type == \'special\' ? \'Special\': \'\'}}</div></div><div class=card-group ng-if=user.userGroups.length><span class=card-group-label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><div class=card-group-value><span ng-repeat=\"group in user.userGroups track by $index\">{{group}}{{$last ? \'\' : \', \'}}</span></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.ENABLED\' | translate\"></span><div class=card-group-value ng-bind=\"user.enabled ? \'Yes\' : \'No\'\"></div></div></div></div><div class=card-foot><div ng-if=eventStatus><button class=\"btn btn-primary btn-sm\" type=button ng-show=\"user.type == \'special\'\" ng-click=handleLoginAs(user) ng-bind=\"\'BUTTON.LOGIN_AS\' | translate\"></button><div uib-dropdown class=btn-group style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button><li role=menuitem><button type=button ng-click=handleEdit(user) ng-bind=\"\'BUTTON.EDIT\' | translate\"></button></li><li role=menuitem ng-if=user.enabled><button type=button ng-click=handleDisable(user) ng-bind=\"\'BUTTON.DISABLE\' | translate\"></button></li><li role=menuitem ng-if=!user.enabled><button type=button ng-click=handleEnable(user) ng-bind=\"\'BUTTON.ENABLE\' | translate\"></button></li><li role=menuitem><button type=button ng-click=handleDelete(user) ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></li></ul></div></div></div></div></div></div><ul ng-if=\"vm.specialUsers.length > currentEvent.preferences.itemsPerPage && vm.specialUsers.length != 0\" uib-pagination total-items=vm.specialUsers.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage direction-links=false></ul></div>");
$templateCache.put("app/users/organizer/sponsors/sponsors.html","<div ng-controller=\"OrganizerSponsorsController as vm\" ng-init=onInit()><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/organizer/transaction/transaction.modal.html","<div ng-init=onInit()><div class=modal-header><h3 class=modal-title><span ng-bind=vm.label></span> Transaction <span ng-bind=\"noPayeezy(vm.transactions) ? \'Refund\' : \'Details\'\"></span></h3></div><div class=modal-body><div ng-if=errorExist class=\"alert alert-danger\" role=alert ng-bind=errorMessage></div><table class=table ng-if=\"vm.transactions.length != 0\"><thead><tr><th ng-bind=\"\'TABLE.date\' | translate\"></th><th ng-bind=\"\'TABLE.amount\' | translate\"></th><th ng-bind=\"\'TABLE.typeStatus\' | translate\"></th><th ng-if=\"noPayeezy(vm.transactions) || request.payCash\" ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"transaction in vm.transactions | orderBy:\'-createdOn\' | orderBy:\'type\' track by $index\" ng-class=\"{\'danger\': (calcAmount() || !transaction.amountChange && transaction.amountChange !== 0) && transaction.type !== \'refund\'}\"><td ng-bind=\"transaction.createdOn | dateFormated\"></td><td><div class=form-group style=\"margin-bottom: 0\" ng-class=\"{\'has-error\': calcAmount() || !transaction.amountChange && transaction.amountChange !== 0}\" ng-if=\"transaction.type === \'payment\' && transaction.status === \'completed\' && transaction.amount !== 0\"><div class=input-group><span class=input-group-addon ng-bind=\"\'$\'+ transaction.amount\"></span> <input class=form-control type=number min=0 ng-if=\"transaction.service !== \'payeezy\' || request.payCash\" ng-model=transaction.amountChange ng-value=transaction.amountChange onkeydown=\"return event.keyCode == 69 || event.keyCode == 101 ? false : true\"> <span class=input-group-addon ng-if=\"transaction.service !== \'payeezy\' || request.payCash\">$</span></div><div class=\"help-block help-block-default\" ng-if=calcAmount() style=\"position: relative; margin-bottom: 0 !important\" ng-bind=\"\'FORM.validation.exceedTransactionValue\' | translate\"></div><div class=\"help-block help-block-default\" ng-if=\"!transaction.amountChange && transaction.amountChange !== 0\" style=\"position: relative; margin-bottom: 0 !important\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div><span ng-if=\"transaction.type == \'refund\'\" ng-bind=\"\'$\'+ transaction.amount\"></span></td><td><p style=\"margin-bottom: 0\"><b ng-bind=\"\'FORM.label.status\' | translate\"></b>&nbsp;<span ng-bind=transaction.status></span></p><p style=\"margin-bottom: 0\"><b ng-bind=\"\'FORM.label.type\' | translate\"></b>&nbsp;<span ng-bind=transaction.type></span></p></td><td ng-if=\"transaction.service !== \'payeezy\' || request.payCash\"><button class=\"btn btn-primary\" type=button ng-if=\"transaction.type === \'payment\' && transaction.status === \'completed\' && transaction.amount !== 0\" ng-click=handleRefund(transaction) ng-disabled=\"calcAmount() || !transaction.amountChange\" ng-bind=\"\'BUTTON.refund\' | translate\"></button></td></tr></tbody></table><div class=no-message ng-if=\"vm.transactions.length == 0\"><i class=\"glyphicon glyphicon-usd\"></i><h3 ng-bind=\"\'TEXT.noTransactions\' | translate\"></h3></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button data-dismiss=modal ng-click=onClose() ng-bind=\"\'BUTTON.close\' | translate\"></button></div></div>");
$templateCache.put("app/users/organizer/user-groups/user-groups.html","<div ng-controller=\"OrganizerUserGroupsController as vm\" ng-init=onInit()><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/organizer/vendors/vendors.html","<div ng-controller=\"OrganizerVendorsController as vm\" ng-init=onInit()><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/organizer/volunteers/volunteers.html","<div ng-controller=\"OrganizerVolunteerController as vm\" ng-init=onInit()><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/participant/agreement/agreement.html","<div ng-init=onInit()><div class=modal-header><h3 class=modal-title id=modal-title ng-bind=\"\'DIALOG.TITLE.WAIVER_AGREEMENT\' | translate\"></h3></div><div class=\"modal-body modal-body-agreement\" id=modal-body ng-bind-html=\"vm.participantWaiver.content | trusted\"></div><div class=modal-footer><div class=row><div class=col-sm-6 style=\"text-align: left\"><div class=checkbox><label><input type=checkbox id=waiverAgreement name=waiverAgreement ng-model=vm.waiverAgreement> <span ng-bind=\"\'FORM.AGREE\' | translate\"></span></label></div></div><div class=col-sm-6><button class=\"btn btn-default\" type=button ng-click=handleDecline() ng-bind=\"\'BUTTON.DECLINE\' | translate\"></button> <button class=\"btn btn-primary\" type=button ng-disabled=!vm.waiverAgreement ng-click=handleAccept() ng-bind=\"\'BUTTON.ACCEPT\' | translate\"></button></div></div></div></div>");
$templateCache.put("app/users/participant/ep-reservation/ep-reservation.html","<div ng-init=onInit()><div class=modal-backcolor ng-click=onClose()></div><div class=modal-wrap><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=onClose()><span aria-hidden=true>&times;</span></button></div><div class=modal-body><div class=text-center ng-if=vm.loading><i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\"></i></div><div ng-if=!vm.loading><div class=modal-qr ng-if=!vm.request.checkedIn><qrcode data={{vm.qrURL}} href={{vm.qrURL}} size=128></qrcode></div><div class=modal-qr ng-if=vm.request.checkedIn><div class=modal-qr-checkedin><span ng-bind=\"\'TEXT.CHECKED\' | translate\"></span> <i class=\"glyphicon glyphicon-ok\"></i></div></div></div><div ng-if=!vm.loading><div class=\"card card-default -lg\" style=\"margin-bottom: 8px\"><div class=card-head><h3 class=card-title ng-bind=vm.request.participant.name></h3></div><div class=card-body><div class=card-group ng-if=vm.request.code style=\"margin-top: 0\"><span class=card-group-label ng-bind=\"\'LABEL.CODE\' | translate\"></span><p class=card-group-value ng-bind=vm.request.code></p></div><div class=card-group ng-if=vm.request.items><span class=card-group-label ng-bind=\"\'LABEL.PACKAGE\' | translate\"></span><div class=\"row row-flex\"><div class=col-xs-6 ng-repeat=\"item in vm.request.items\"><div class=card-group><span class=card-group-value ng-bind=\"item.pricePackage.name +\' X \'+ item.count\"></span><p class=card-group-label ng-if=item.participantName ng-bind=item.participantName></p><p class=card-group-label ng-if=item.participantEmail ng-bind=item.participantEmail></p></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/users/participant/event/event.html","<div ng-controller=\"ParticipantEventController as vm\" ng-init=onInit()><div class=row><div class=\"col-sm-7 col-sm-push-5\"><div class=bg-info ng-if=showInfopanel style=\"padding: 16px; margin-bottom: 16px\"><i class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'TEXT.WAITING_FOR_TRANSACTION\' | translate\"></span></div><div class=row><div class=col-sm-12 ng-if=\"vm.requests.length != 0\"><div class=\"row row-flex row-16\"><div class=\"col-xs-12 col-md-6\" style=\"margin-bottom: 16px\" ng-repeat=\"request in vm.requests | orderBy: \'-createdOn\' track by $index\"><div class=\"card card-default\"><div class=card-body><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=card-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=card-group ng-if=request.code><span class=card-group-label ng-bind=\"\'LABEL.CODE\' | translate\"></span><div class=card-group-value ng-bind=request.code></div></div><div class=card-group ng-if=\"request.bibNumber && (request.payCash && request.status == \'accepted\')\"><span class=card-group-label ng-bind=\"\'LABEL.BIB\' | translate\"></span><div class=\"card-group-value -bib\" ng-bind=request.bibNumber></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=card-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"card-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PRICE\' | translate\"></span><div class=card-group-value ng-bind=\"\'&#36;\'+ request.price\"></div></div></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PAYMENT_TYPE\' | translate\"></span> <span class=card-group-value ng-bind=\"request.payCash ? \'Cash/Check payment\' : \'Credit card payment\'\"></span></div><div class=card-group ng-if=request.items><span class=card-group-label ng-bind=\"\'LABEL.PACKAGE\' | translate\"></span><div class=\"row row-flex row-16\"><ul style=\"margin-bottom: 0; padding-left: 20px\"><li class=table-group-value ng-repeat=\"item in request.items\"><b ng-bind=\"item.pricePackage.name +\' x \'+ item.count +\' \'+ (\n                              item.participantName || item.participantEmail ? \'for:\' : \'\'\n                            )\"></b><div ng-if=item.participantName ng-bind=item.participantName></div><div ng-if=item.participantEmail ng-bind=item.participantEmail></div></li></ul></div></div></div><div class=card-foot><button class=\"btn btn-success btn-sm\" type=button ng-if=\"request.status == \'accepted\'\" ng-click=showEventPass(request) ng-bind=\"\'BUTTON.EVENT_PASS\' | translate\"></button> <button class=\"btn btn-default btn-sm\" ng-click=onShowNotes(request) ng-bind=\"\'BUTTON.NOTES\' | translate\"></button></div></div></div></div><hr style=\"margin-bottom: 38px\"></div><div class=col-sm-12><div class=form-group style=\"margin-bottom: 32px\"><div class=input-group><input type=text class=form-control name=promocode placeholder=Promocode ng-model=vm.applyPromocode> <span class=input-group-btn><button class=\"btn btn-info\" type=button ng-click=onApplyPromocode(vm.applyPromocode) ng-disabled=!vm.applyPromocode ng-bind=\"\'BUTTON.APPLY_PROMOCODE\' | translate\"></button></span></div></div><div class=\"row row-flex row-16\" ng-if=\"vm.pricePackages.length !== 0\"><div class=\"col-xs-6 col-md-4 col-lg-3\" style=\"margin-bottom: 32px\" ng-repeat=\"\n                  package in vm.pricePackages | orderBy: \'soldout\' | orderBy: \'promoCode\'\n                 \"><div class=\"card card-package\" ng-class=\"{\n                     \'soldout\': package.soldout,\n                     \'promocode\': package.promoCode\n                   }\"><div class=card-head><h2 class=card-title ng-bind=package.name></h2><span ng-if=package.soldout class=\"card-label soldout\" ng-bind=\"\'Sold Out\'\"></span> <span ng-if=package.promoCode class=\"card-label promocode\" ng-bind=\"\'Promo\'\"></span></div><div class=card-body><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PRICE\' | translate\"></span><div class=card-group-value ng-bind=\"package.price === 0 ? \'Free\' : \'&#36;\' + package.price\"></div></div><div class=card-group ng-if=\"\n                    package.maxAvailable &&\n                    (package.preferences && package.preferences.showUnsoldCount) &&\n                    package.maxAvailable - package.stats.inUse > 0\n                  \"><span class=card-group-label ng-bind=\"\'LABEL.TICKETS_LEFT\' | translate\"></span><div class=card-group-value ng-bind=\"package.maxAvailable - package.stats.inUse\"></div></div><div class=card-group ng-if=\"!package.soldout && package.limitPerPerson\"><span class=card-group-label ng-bind=\"\'Available\'\"></span><div class=card-group-value ng-bind=package.purchased></div></div></div><div class=card-foot ng-if=\"!package.soldout && (vm.participantModule.cashPayment || vm.participantModule.cardPayment)\"><div class=\"help-block help-block-default\" style=\"position: relative !important; text-align: right !important; margin-bottom: 0 !important; font-size: 10px\" ng-if=\"(package.maxAvailable && !package.limitPerPerson) && package.maxAvailable - package.stats.inUse == package.amount\">Limit reached</div><button class=\"btn btn-primary btn-sm\" type=button ng-disabled=\"package.amount == 0\" ng-click=decreaseAmount(package)><i class=\"glyphicon glyphicon-minus\"></i></button> <span ng-bind=package.amount></span> <button class=\"btn btn-primary btn-sm\" type=button ng-disabled=disableIncrease(package) ng-click=increaseAmount(package)><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div></div><div><div class=form-group ng-if=\"vm.invitedParticipants.length != 0\"><div class=\"row row-8\" style=\"margin-bottom: 8px\" ng-repeat=\"item in vm.invitedParticipants\"><div class=col-xs-3><label><span ng-bind=\"\'FORM.AUTH.NAME\' | translate\"></span> <span ng-if=!item.readonly>&nbsp;*</span></label><input class=form-control name=name ng-model=item.name type=text placeholder=\"{{\'FORM.AUTH.NAME\' | translate}}\" ng-required=item.required ng-readonly=item.readonly></div><div class=col-xs-3><label><span ng-bind=\"\'FORM.AUTH.EMAIL\' | translate\"></span> <span ng-if=!item.readonly>&nbsp;*</span></label><input class=form-control name=email ng-model=item.email type=email placeholder=\"{{\'FORM.AUTH.EMAIL\' | translate}}\" ng-required=item.required ng-readonly=item.readonly></div><div class=col-xs-5><label ng-bind=\"\'FORM.PACKAGE\' | translate\"></label><input class=form-control name=package ng-model=item.package.name type=text placeholder=\"{{\'FORM.PACKAGE\' | translate}}\" readonly></div><div class=col-xs-1><label>&nbsp;</label><button class=\"btn btn-danger btn-block\" type=button ng-click=removeSelectedInvite(item) style=\"padding-left: 0; padding-right: 0\"><i class=\"glyphicon glyphicon-trash\"></i></button></div></div></div><!-- Note --><div class=form-group ng-if=\"vm.invitedParticipants.length !== 0\"><label for=participantRequestNotes ng-bind=\"\'FORM.SPECIAL_NOTES\' | translate\"></label><textarea class=form-control name=notes id=participantRequestNotes ng-model=vm.participantRequestNotes rows=5></textarea></div></div><div class=\"form-group form-group-btn-package\" ng-if=\"totalPrice() === 0 && totalPackagesCount() !== 0\"><hr><button class=\"btn btn-primary btn-sm\" type=button ng-if=\"vm.participantModule.cashPayment || vm.participantModule.cardPayment\" ng-disabled=\"handleFieldsValidation() || vm.loadingCash\" ng-click=noCostRequest()><i ng-if=vm.loadingCash class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.participantModule.buttonLabelPayCash></span></button></div><div class=\"form-group form-group-btn-package\" ng-if=\"totalPrice() > 0 && totalPackagesCount() !== 0\"><hr><button class=\"btn btn-primary btn-sm\" type=button ng-if=vm.participantModule.cashPayment ng-disabled=\"handleFieldsValidation() || vm.loadingCash\" ng-click=handleCashButton()><i ng-if=vm.loadingCash class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.participantModule.buttonLabelPayCash></span>&nbsp;<span ng-bind=\"\'$\'+totalPriceLabel()\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-disabled=\"handleFieldsValidation() || vm.loadingBuy || vm.loadingCash\" ng-if=\"vm.event.billingPreferences.serviceType === \'stripe\' && vm.participantModule.cardPayment\" ng-click=\"handleStripeButton({publishableKey: vm.event.billingPreferences.publishableKey})\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.participantModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+totalPriceLabel()\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.event.billingPreferences.serviceType == \'transactionexpress\' && vm.participantModule.cardPayment\" ng-disabled=\"handleFieldsValidation() || vm.loadingBuy || vm.loadingCash\" ng-click=\"handleTransactionButton({\n                      hostedKey: vm.event.billingPreferences.hostedKey,\n                      gatewayId: vm.event.billingPreferences.gatewayId,\n                      hostedPageUrl: vm.event.billingPreferences.hostedPageUrl,\n                      callback: \'participant/event\'\n                    })\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.participantModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+totalPriceLabel()\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.event.billingPreferences.serviceType == \'paypal\' && vm.participantModule.cardPayment\" ng-disabled=\"handleFieldsValidation() || vm.loadingBuy || vm.loadingCash\" ng-click=\"handlePaypalButton({\n                      paypalMerchantId: vm.event.billingPreferences.merchantId,\n                      paypalCallback: \'participant/event?fetchingRequests=true\',\n                      paypalMode: vm.event.billingPreferences.mode,\n                      paypalButtonType: \'participant\'\n                    })\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.participantModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+totalPriceLabel()\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.event.billingPreferences.serviceType == \'squareup\' && vm.participantModule.cardPayment\" ng-disabled=\"handleFieldsValidation() || vm.loadingBuy || vm.loadingCash\" ng-click=\"handleSquareupButton({\n                      applicationId: vm.event.billingPreferences.applicationId,\n                      locationId: vm.event.billingPreferences.locationId\n                    })\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.participantModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+totalPriceLabel()\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.event.billingPreferences.serviceType == \'payeezy\' && vm.participantModule.cardPayment\" ng-disabled=\"handleFieldsValidation() || vm.loadingBuy || vm.loadingCash\" ng-click=\"handlePayeezyButton({\n                      apiKey: vm.event.billingPreferences.apiKey,\n                      jsSecurityKey: vm.event.billingPreferences.jsSecurityKey,\n                      paymentJSUrl: vm.event.billingPreferences.paymentJSUrl,\n                      transarmorToken: vm.event.billingPreferences.transarmorToken\n                    })\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.participantModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+totalPriceLabel()\"></span></button></div></div></div></div><div class=\"col-sm-5 col-sm-pull-7\"><div class=\"panel panel-default\" ng-if=\"\n            (vm.appFormParticipant && vm.appFormParticipant.content) ||\n            (vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)) ||\n            (vm.preferences.scheduleModule.enabled && vm.participantModule.enableUserTypeSchedule) ||\n            (vm.event.modules.indexOf(\'scavenger_hunt\') > -1 && vm.participantModule.scavengerHunt)\n           \"><div class=panel-body ng-if=\"vm.appFormParticipant && vm.appFormParticipant.content\" ng-bind-html=\"vm.appFormParticipant.content | trusted\"></div><div class=panel-footer ng-if=\"\n          (vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)) ||\n          (vm.preferences.scheduleModule.enabled && vm.participantModule.enableUserTypeSchedule) ||\n          (vm.event.modules.indexOf(\'scavenger_hunt\') > -1 && vm.participantModule.scavengerHunt)\n        \"><button class=\"btn btn-info btn-sm\" type=button ng-if=\"vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)\" ng-click=handleDonation() ng-bind=\"\'BUTTON.donate\' | translate\"></button> <a ng-if=\"\n              vm.event.modules.indexOf(\'scavenger_hunt\') > -1 &&\n              vm.participantModule.scavengerHunt\n             \" ui-sref=users.participant.scavengerHunt class=\"btn btn-info btn-sm\" role=link ng-bind=\"\'Scavenger hunt\'\"></a></div></div><!-- Include: Healine sponsor slider --><div ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" ng-include=\"\'app/users/sponsor-inner-pages/ms-inner-pages.html\'\"></div><div class=\"panel panel-default\"><div class=panel-heading ng-bind-html=\"vm.event.name | trusted\"></div><div class=panel-body><p><span ng-bind=vm.event.address></span></p><div ng-if=vm.preferences.showEventStartEndDate><p ng-if=vm.isSameDate><span ng-bind=vm.eventStartDate></span></p><p ng-if=!vm.isSameDate><span ng-bind=vm.eventStartDate></span> - <span ng-bind=vm.eventEndDate></span></p><p><span ng-bind=vm.eventStartTime></span> - <span ng-bind=vm.eventEndTime></span></p></div><div ta-bind ng-model=vm.event.description></div></div></div></div></div><!-- Include: Secondary sponsor slider --><div ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" ng-include=\"\'app/users/sponsor-inner-pages/ss-inner-pages.html\'\"></div></div>");
$templateCache.put("app/users/participant/messages/messages.html","<div ng-controller=\"ParticipantMessagesController as vm\" ng-init=onInit()><div class=form-group><button class=\"btn btn-info\" type=button ng-click=openModalMessage() ng-bind=\"\'BUTTON.MESSAGE_EVENT_ORGANIZER\' | translate\"></button></div><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/participant/my-team/my-team.html","<div ng-controller=\"ParticipantMyTeamController as vm\" ng-init=onInit()><h3 style=\"margin-top: 0; padding-bottom: 16px; margin-bottom: 16px\" ng-bind=\"\'TITLE.MY_TEAM\' | translate\"></h3><div class=\"row row-flex\" ng-if=\"vm.myTeams && vm.myTeams.length != 0\"><div class=\"col-xs-12 col-md-6 col-lg-4\" ng-repeat=\"team in vm.myTeams track by $index\"><div class=\"card card-request\"><div class=card-body><div class=card-group><span class=card-label ng-bind=\"\'LABEL.TEAM_NAME\' | translate\"></span><p class=card-value ng-bind=team.name></p></div><div ng-if=!team.members><hr><button class=\"btn btn-info\" type=button ng-click=getMyTeamMembers(team) ng-bind=\"\'BUTTON.SHOW_TEAM_MEMBERS\' | translate\"></button></div><div ng-if=\"team.members && team.members.length != 0\" class=card-group><span class=card-label ng-bind=\"\'LABEL.MEMBERS\' | translate\"></span><p class=card-value ng-repeat=\"member in team.members track by $index\">{{member.name}}</p></div></div></div></div></div></div>");
$templateCache.put("app/users/participant/participant-map/participant-map.html","<style>.availableD { display: block; margin-bottom: 8px; padding-top: 4px; font-size: 14px; }\n\n  @media screen and (min-width: 768px){\n    .availableD { display: inline-block; margin-bottom: 0; padding-top: 0; padding-left: 4px; }\n  }</style><div class=area-controller ng-controller=\"ParticipantMapController as vm\" ng-init=onInit()><!-- <div class=\"area-controller-absolute\"> --><div class=form-group style=\"margin-bottom: 4px\"><button class=\"btn btn-info btn-sm\" type=button ng-if=currentEvent.preferences.enableReservationAvailability ng-click=handleShowAvailable()><span ng-bind=\"!getAvailable ? \'Show only available\' : \'Show all\'\"></span></button> <span class=availableD ng-if=getAvailable>Available for {{availableFrom | dateFormatedOnlyM}} - {{availableTo | dateFormatedOnlyM}} </span><button class=\"btn btn-sm btn-default\" type=button style=\"margin-left: 4px\" ng-if=getAvailable ng-click=handleEditAvailable()><i class=\"fa fa-pencil\" aria-hidden=true></i></button></div><div class=form-group style=\"margin-bottom: 4px\"><label><input type=checkbox name=showOnlyMyBooths ng-model=showOnlyMyBooths ng-change=handleShowOnlyMyBooths()> <span ng-bind=\"\'TEXT.SHOW_ONLY_MY_BOOTHS\' | translate\"></span></label></div><!-- </div> --><div class=map-wrap><div ng-if=!showPosition class=\"map-btn-group _right\" id=indoorMapZoomInOutGroup><span class=\"map-btn _zoom\" id=indoorMapZoomIn><i class=\"fa fa-plus\" aria-hidden=true></i></span> <span class=\"map-btn _zoom\" id=indoorMapZoomOut><i class=\"fa fa-minus\" aria-hidden=true></i></span></div><div map-calculate id=mapWrap style=\"background-color: #ededed\"><div id=map style=\"width: 100%; height: 100%\"></div></div></div></div>");
$templateCache.put("app/users/participant/reservation/reservation.html","<div ng-controller=\"ParticipantReservationController as vm\" ng-init=onInit()><div ng-if=loading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!loading><div class=\"row row-flex row-16\" ng-if=myReservations.length><div class=\"col-xs-12 col-md-6 col-lg-4\" style=\"margin-bottom: 16px\" ng-repeat=\"request in myReservations | orderBy: \'-createdOn\' track by $index\"><div class=\"card card-default\"><div class=card-body><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=card-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=card-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div><div class=card-group ng-if=request.boothName><span class=card-group-label ng-bind=\"\'LABEL.BOOTH_DESCRIPTION\' | translate\"></span><div class=card-group-value ng-bind=request.boothName></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"card-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PRICE\' | translate\"></span><div class=card-group-value ng-bind=\"\'&#36;\'+ request.price\"></div></div></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PAYMENT_TYPE\' | translate\"></span> <span class=card-group-value ng-bind=\"request.payCash ? \'Cash/Check payment\' : \'Credit card payment\'\"></span></div><div class=card-group ng-if=request.timeSlots><span class=card-group-label ng-bind=\"\'LABEL.SLOTS\' | translate\"></span><ul style=\"margin-bottom: 0; padding-left: 20px\"><li class=card-group-value style=\"white-space: normal\" ng-repeat=\"item in request.timeSlots\"><b ng-bind=toMonth(item.start)></b>&nbsp;-&nbsp;<b ng-bind=toHours(item.end)></b> <span ng-bind=\"\' - $\'+ item.price\"></span></li></ul></div></div><div class=card-foot><button class=\"btn btn-success btn-sm\" type=button ng-if=\"request.status == \'accepted\'\" ng-click=showEventPass(request) ng-bind=\"\'BUTTON.EVENT_PASS\' | translate\"></button></div></div></div></div><div class=no-message ng-if=\"myReservations.length === 0\"><i class=\"glyphicon glyphicon-calendar\"></i><h3 ng-bind=\"\'TEXT.NO_RESERVATIONS\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/participant/scavenger-hunt/scavenger-hunt.html","<div ng-controller=\"ParticipantScavengerHunt as vm\" ng-init=onInit()><div class=\"row row-16\"><div class=\"col-xs-12 col-md-8 col-md-push-4 col-lg-6 col-lg-push-6\"><form novalidate name=form ng-submit=onSubmit()><div class=\"row row-8\"><div class=\"col-xs-12 col-sm-8\"><div class=form-group ng-class=\"{ \'has-error\': form.checkInCode.$invalid && form.$submitted }\"><label for=checkInCode>Check-in code<span>&nbsp;*</span></label><input class=\"form-control input-sm\" id=checkInCode type=text name=checkInCode ng-model=checkInCode placeholder=\"Check-in code\" required><div class=help-block ng-if=form.$submitted ng-messages=form.checkInCode.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=\"col-xs-12 col-sm-4\"><div class=form-group><label for=\"\" class=hidden-xs>&nbsp;</label><button class=\"btn btn-primary btn-sm btn-block\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> Check-in</button></div></div></div></form><div ng-if=\"points.length > 0\"><table class=table style=\"margin-top: 0; margin-bottom: 0\"><thead><tr><th>Name</th><th>Lat/Lng</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"point in points | orderBy:\'-order\'\"><td ng-bind=point.pointName></td><td><p style=\"margin-bottom: 0\"><b>Lat:&nbsp;</b><span ng-bind=point.lat></span></p><p style=\"margin-bottom: 0\"><b>Lng:&nbsp;</b><span ng-bind=point.lng></span></p></td><td><span class=\"table-group-value {{ point.status }}\" ng-bind=point.status></span></td></tr></tbody></table></div><div class=no-message ng-if=\"points.length === 0\"><i class=\"glyphicon glyphicon-map-marker\"></i><h3 ng-bind=\"\'No point(s)\'\"></h3></div><div class=\"visible-xs-block visible-sm-block\" style=\"margin-bottom: 10px\"></div></div><div class=\"col-xs-12 col-md-4 col-md-pull-8 col-lg-6 col-lg-pull-6\"><div map-calculate id=scavengerHuntMapWrap style=\"background-color: #ededed\"><div id=scavengerHuntMap style=\"width: 100%; height: 100%\"></div></div></div></div></div>");
$templateCache.put("app/users/special/messages/messages.form.html","<div class=\"modal in\" tabindex=-1 role=dialog style=\"display: block; overflow-y: auto\" ng-controller=\"SpecialMessagesFormController as vm\" ng-init=onInit()><div class=\"modal-backdrop in\" ng-click=onClose()></div><div class=\"modal-dialog modal-lg\" role=document style=\"z-index: 1041\"><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=onClose()><span aria-hidden=true>&times;</span></button><h3 class=modal-title ng-bind=\"\'DIALOG.TITLE.SEND_MESSAGE\' | translate\"></h3></div><div class=modal-body><form novalidate name=form ng-submit=handleSubmit()><div class=row ng-if=vm.allowBulkMailSend><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{ \'has-error\': vm.userSelector && form.userType.$invalid }\"><label class=show><span ng-bind=\"\'FORM.MESSAGE.USER_TYPE\' | translate\"></span> <span ng-if=\"vm.userType || vm.userSelector\">&nbsp;*</span><select class=form-control name=userType ng-change=onChangeUser() ng-model=vm.userType ng-required=vm.userSelector><option ng-repeat=\"item in userTypes\" ng-value=item.type ng-bind=item.name></option></select></label><div class=help-block ng-if=\"vm.userSelector && form.userType.$invalid\" ng-messages=form.userType.$error role=alert><div ng-message=required ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{ \'has-error\': vm.userType && form.userSelector.$invalid }\"><label class=show><span ng-bind=\"\'FORM.MESSAGE.USER_SELECTOR\' | translate\"></span> <span ng-if=\"vm.userType || vm.userSelector\">&nbsp;*</span><select class=form-control name=userSelector ng-change=onChangeUser() ng-model=vm.userSelector ng-required=vm.userType><option ng-repeat=\"item in userSelectors\" ng-value=item.type ng-bind=item.name></option></select></label><div class=help-block ng-if=\"vm.userType && form.userSelector.$invalid\" ng-messages=form.userSelector.$error role=alert><div ng-message=required ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div></div></div></div><div class=form-group><label for=groups ng-bind=\"\'FORM.MESSAGE.USER_GROUPS\' | translate\"></label><ui-select ng-model=vm.message.recipientGroupIds multiple><ui-select-match placeholder=\"{{ \'FORM.MESSAGE.USER_GROUPS\' | translate }}\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices repeat=\"group.id as group in vm.userGroups | filter: { name: $select.search }\"><span ng-bind=group.name></span></ui-select-choices></ui-select></div><div class=form-group ng-class=\"{ \'has-error\': form.subject.$touched && form.subject.$invalid }\"><label for=subject><span ng-bind=\"\'FORM.MESSAGE.SUBJECT\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=subject type=text name=subject placeholder=\"{{\'FORM.MESSAGE.SUBJECT\' | translate}}\" ng-model=vm.message.subject ng-required=!vm.message.sentToSms><div class=help-block ng-if=form.subject.$touched ng-messages=form.subject.$error role=alert><div ng-message=required ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div></div><text-editor-gallery teg-name=body teg-label=Message teg-model=vm.message.body teg-required=true teg-form=form></text-editor-gallery><div class=form-group><div class=checkbox><label><input type=checkbox name=sendToEmail ng-model=vm.message.sendToEmail> <span class=label></span> <span ng-bind=\"\'FORM.MESSAGE.INCLUDE_EMAIL_NOTIFICATION\' | translate\"></span></label></div><div class=checkbox><label><input type=checkbox name=sendToSms ng-model=vm.message.sendToSms> <span class=label></span> <span ng-bind=\"\'FORM.MESSAGE.INCLUDE_TEXT_MESSAGE\' | translate\"></span></label></div></div><div class=form-group ng-if=vm.message.sendToSms ng-class=\"{ \'has-error\': form.shortText.$touched && form.shortText.$invalid }\"><label for=shortText><span ng-bind=\"\'FORM.MESSAGE.TEXT_MESSAGE\' | translate\"></span> <span>&nbsp;*</span></label><textarea class=form-control id=shortText name=shortText placeholder=\"{{\'FORM.MESSAGE.TEXT_MESSAGE\' | translate}}\" ng-model=vm.message.shortText ng-blur=onShortText(vm.message.shortText) ng-trim=false maxlength=160 required>\n            </textarea><div class=\"help-block text-right\">{{vm.message.shortText ? 160 - vm.message.shortText.length : 160}}</div><div class=help-block ng-if=form.shortText.$touched ng-messages=form.shortText.$error role=alert><div ng-message=required ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div></div><div class=form-group><button class=\"btn btn-default\" type=button ng-click=onClose() ng-bind=\"\'BUTTON.DIALOG.CLOSE\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=!form.$valid ng-bind=\"\'BUTTON.DIALOG.SEND\' | translate\"></button></div></form></div></div></div></div>");
$templateCache.put("app/users/special/messages/messages.html","<div ng-controller=\"SpecialMessagesController as vm\" ng-init=onInit()><div class=form-group ng-if=\"vm.allowSendMessages && eventStatus\"><a class=\"btn btn-info\" ui-sref=users.special.messages.send ng-bind=\"\'BUTTON.SEND_MESSAGE\' | translate\"></a></div><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div><div ui-view=modal></div>");
$templateCache.put("app/users/special/special-map/special-map.html","<div class=area-controller ng-controller=\"SpecialMapController as vm\" ng-init=onInit()><div class=area-controller-absolute><div class=form-group><label><input type=checkbox name=showOnlyMyBooths ng-model=showOnlyMyBooths ng-change=handleShowOnlyMyBooths()> <span ng-bind=\"\'TEXT.SHOW_ONLY_MY_BOOTHS\' | translate\"></span></label></div></div><div class=map-wrap><div class=indoor-map-group style=\"margin-top: {{ mapData.type === \'outdoor\' ? \'40px\' : \'0px\' }}\"><span class=map-badge-length ng-hide=\"foundBooths.length === 0 || foundBooths === booths.length\" ng-bind=foundBooths.length></span><div class=\"form-group form-group-map\"><input class=\"form-control form-control-search\" id=map-search type=text placeholder=\"Search ...\" ng-model=mapFields.search ng-change=\"handleMapSearch({ search: mapFields.search, boothCategory: mapFields.boothCategory })\" ng-model-options=\"{ debounce: 1000 }\"></div><div class=\"form-group form-group-map\"><select class=\"form-control form-control-category\" name=boothType id=map-booth-types ng-model=mapFields.boothCategory ng-change=\"handleMapSearch({ search: mapFields.search, boothCategory: mapFields.boothCategory })\" ng-options=\"booth as booth.name group by booth.type for booth in boothCategories\"><option value=\"\" ng-bind=\"\'FORM.CHOOSE_BOOTH_TYPE\' | translate\"></option></select></div></div><div ng-if=!showPosition class=\"map-btn-group _right\" id=indoorMapZoomInOutGroup><span class=\"map-btn _zoom\" id=indoorMapZoomIn><i class=\"fa fa-plus\" aria-hidden=true></i></span> <span class=\"map-btn _zoom\" id=indoorMapZoomOut><i class=\"fa fa-minus\" aria-hidden=true></i></span></div><div map-calculate id=mapWrap style=\"background-color: #ededed\"><div id=map style=\"width: 100%; height: 100%\"></div></div></div></div>");
$templateCache.put("app/users/sponsor/attendants/attendants.html","<div class=tab-content ng-controller=\"SponsorAttendantsController as vm\" ng-init=onInit()><div ng-if=pageLoading><span ng-bind=\"\'TEXT.loading\' | translate\"></span></div><div ng-if=!pageLoading><div class=\"form-group clearfix\" ng-if=!hideForm><button class=\"btn btn-info btn-sm | pull-right\" type=button ng-disabled=\"(total - totalAvailableAttendantRequests) <= 0\" ng-click=addBulk() ng-bind=\"\'BUTTON.ADD\' | translate\"></button></div><form name=dataForm.form novalidate ng-if=!hideForm ng-submit=handleRegisterBulk()><div class=\"row row-8\" ng-repeat=\"field in bulkFields\"><div class=\"col-xs-6 col-sm-4 col-md-3\" style=\"margin-bottom: 8px\"><div class=form-group ng-class=\"{\'has-error\': dataForm.form[field.fieldName].$invalid && formSubmitted }\"><label><span ng-bind=\"\'FORM.AUTH.NAME\' | translate\"></span> <span>&nbsp;*</span></label><input class=\"form-control input-sm\" type=text name={{field.fieldName}} placeholder=\"{{\'FORM.AUTH.NAME\' | translate}}\" ng-model=field.name required ng-disabled=field.success><div class=help-block ng-if=\"dataForm.form[field.fieldName].$invalid && formSubmitted\" ng-messages=dataForm.form[field.fieldName].$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=\"col-xs-6 col-sm-4 col-md-3\" style=\"margin-bottom: 8px\"><div class=form-group ng-class=\"{\'has-error\': (dataForm.form[field.fieldUsername].$invalid && formSubmitted) || field.error }\"><label><span ng-bind=\"\'FORM.AUTH.USERNAME\' | translate\"></span> <span>&nbsp;*</span></label><input class=\"form-control input-sm\" type=text name=\"{{ field.fieldUsername }}\" placeholder=\"{{\'FORM.AUTH.USERNAME\' | translate}}\" ng-model=field.username required ng-disabled=field.success><div class=help-block ng-if=\"dataForm.form[field.fieldUsername].$invalid && formSubmitted\" ng-messages=dataForm.form[field.fieldUsername].$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div><div class=help-block ng-if=field.error role=alert ng-bind=field.errorMsg></div></div></div><div class=\"col-xs-6 col-sm-4 col-md-3\" style=\"margin-bottom: 8px\"><div class=form-group ng-class=\"{\'has-error\': dataForm.form[field.fieldEmail].$invalid && formSubmitted }\"><label><span ng-bind=\"\'FORM.AUTH.EMAIL\' | translate\"></span> <span>&nbsp;*</span></label><input class=\"form-control input-sm\" type=email name=\"{{ field.fieldEmail }}\" placeholder=\"{{\'FORM.AUTH.EMAIL\' | translate}}\" ng-model=field.email required ng-disabled=field.success><div class=help-block ng-if=\"dataForm.form[field.fieldEmail].$invalid && formSubmitted\" ng-messages=dataForm.form[field.fieldEmail].$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=email ng-bind=\"\'FORM.validation.invalidEmail\' | translate\"></div></div></div></div><div class=\"col-xs-6 col-sm-4 col-md-2\" style=\"margin-bottom: 8px\"><div class=form-group ng-class=\"{\'has-error\': dataForm.form[field.fieldPassword].$invalid && formSubmitted }\"><label><span ng-bind=\"\'FORM.AUTH.PASSWORD\' | translate\"></span> <span>&nbsp;*</span></label><input class=\"form-control input-sm\" type=text name=\"{{ field.fieldPassword }}\" placeholder=\"{{\'FORM.AUTH.PASSWORD\' | translate}}\" ng-model=field.password required ng-disabled=field.success><div class=help-block ng-if=\"dataForm.form[field.fieldPassword].$invalid && formSubmitted\" ng-messages=dataForm.form[field.fieldPassword].$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=\"col-xs-12 col-md-1\"><label>&nbsp;</label><button ng-if=\"!field.success && field.delete\" class=\"btn btn-sm btn-danger btn-block\" type=button ng-click=removeBulk(field) style=\"padding-left: 0; padding-right: 0\"><i class=\"glyphicon glyphicon-trash\"></i></button> <button ng-if=field.success class=\"btn btn-sm btn-success btn-block\" type=button style=\"padding-left: 0; padding-right: 0\"><i class=\"glyphicon glyphicon-ok\"></i></button></div></div><div class=form-group ng-if=bulkFields.length><button class=\"btn btn-primary btn-sm\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true></i> <span ng-bind=\"\'BUTTON.register\' | translate\"></span></button></div><hr></form><div class=\"form-group clearfix\" ng-if=attendantRequests.length><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><div class=form-group><p class=help-block style=\"font-size: 14px\"><span ng-bind=\"\'TEXT.REMAINING_INVITES\' | translate\"></span>&nbsp;<b id=remainingInvites>{{ showRemainingInvites() }}</b></p></div><div ng-if=attendantRequests.length><table class=\"table table-request\" ng-if=\"attendantRequests.length !== 0\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"request in attendantRequests | orderBy: \'-createdOn\' | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-if=request.user.name ng-bind=request.user.name></h3><h5 class=table-subtitle ng-bind=request.user.username></h5><div class=table-group ng-if=request.createdOn><span class=table-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=table-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=table-group ng-if=request.user.email><span class=table-group-label ng-bind=\"\'LABEL.EMAIL\' | translate\"></span><div class=table-group-value><a href=\"mailto:{{ request.user.email }}\" ng-bind=request.user.email></a></div></div></td><td><div class=table-group ng-if=request.status><span class=table-group-label ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"table-group-value {{request.status}}\" ng-bind=request.status></div></div><div class=table-group><span class=table-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=table-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-danger btn-sm\" type=button ng-click=onDeleteAttendant(request.user) ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"attendantRequests.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"attendantRequests.length > currentEvent.preferences.itemsPerPage && attendantRequests.length != 0\" uib-pagination total-items=attendantRequests.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div class=no-message ng-if=\"attendantRequests.length === 0\"><i class=\"fa fa-users\" aria-hidden=true></i><h3 ng-bind=\"\'TEXT.NO_ATTENDANT_REQUESTS\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/sponsor/event/event.html","<div ng-controller=\"SponsorEventController as vm\" ng-init=onInit()><div class=\"row row-16\"><div class=\"col-sm-7 col-sm-push-5\"><div class=bg-info ng-if=showInfopanel style=\"padding: 16px; margin-bottom: 16px\"><i class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'TEXT.WAITING_FOR_TRANSACTION\' | translate\"></span></div><div class=\"row row-16\"><div class=col-sm-12 ng-if=\"vm.requests.length != 0\"><div class=\"row row-flex row-16\"><div class=\"col-xs-12 col-md-6\" style=\"margin-bottom: 16px\" ng-repeat=\"request in vm.requests | orderBy: \'-createdOn\' track by $index\"><div class=\"card card-default\"><div class=card-body><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=card-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=card-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"card-group-value {{request.status}}\" ng-bind=request.status></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PAYMENT_TYPE\' | translate\"></span> <span class=card-group-value ng-bind=\"request.payCash ? \'Cash/Check payment\' : \'Credit card payment\'\"></span></div><div class=card-group ng-if=request.pricePackage><span class=card-group-label ng-bind=\"\'LABEL.PACKAGE\' | translate\"></span> <span class=card-group-value ng-bind=\"request.pricePackage.name +\'&nbsp;($\'+ request.pricePackage.price +\')\'\"></span></div><div class=card-group ng-if=\"request.pricePackage && request.pricePackage.preferences && request.pricePackage.preferences.maxAttendants >= 0\"><span class=card-group-label ng-bind=\"\'LABEL.MAX_ATTENDANTS\' | translate\"></span> <span class=card-group-value ng-bind=request.pricePackage.preferences.maxAttendants></span></div></div><div class=card-foot><button class=\"btn btn-success btn-sm\" type=button ng-if=\"request.status == \'accepted\'\" ng-click=showEventPass(request) ng-bind=\"\'BUTTON.EVENT_PASS\' | translate\"></button> <button class=\"btn btn-default btn-sm\" type=button ng-click=onShowNotes(request) ng-bind=\"\'BUTTON.NOTES\' | translate\"></button><div uib-dropdown class=btn-group style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button><li role=menuitem><button type=button ng-click=handleProfileVisibility(request) ng-bind=\"\'BUTTON.VISIBILITY_PROFILE\' | translate\"></button></li></ul></div></div></div></div></div><hr style=\"margin-bottom: 38px\"></div><div class=col-sm-12><div class=form-group style=\"margin-bottom: 32px\"><div class=input-group><input type=text class=form-control name=promocode placeholder=Promocode ng-model=vm.applyPromocode> <span class=input-group-btn><button class=\"btn btn-info\" type=button ng-click=onApplyPromocode(vm.applyPromocode) ng-disabled=!vm.applyPromocode ng-bind=\"\'BUTTON.APPLY_PROMOCODE\' | translate\"></button></span></div></div><div class=\"row row-flex row-16\" ng-if=\"vm.pricePackages.length !== 0\"><div class=\"col-xs-6 col-md-4 col-lg-3\" style=\"margin-bottom: 32px\" ng-repeat=\"package in vm.pricePackages | orderBy: \'soldout\' | orderBy: \'promoCode\'\"><div class=\"card card-package\" ng-class=\"{\n                     \'soldout\': package.soldout,\n                     \'promocode\': package.promoCode\n                   }\"><div class=card-head><h2 class=card-title ng-bind=package.name></h2><span ng-if=package.soldout class=\"card-label soldout\" ng-bind=\"\'Sold Out\'\"></span> <span ng-if=package.promoCode class=\"card-label promocode\" ng-bind=\"\'Promo\'\"></span></div><div class=card-body><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.PRICE\' | translate\"></span><div class=card-group-value ng-bind=\"package.price === 0 ? \'Free\' : \'&#36;\' + package.price\"></div></div><div class=card-group ng-if=\"\n                    package.maxAvailable &&\n                    (package.preferences && package.preferences.showUnsoldCount) &&\n                    package.maxAvailable - package.stats.inUse > 0\n                  \"><span class=card-group-label ng-bind=\"\'LABEL.TICKETS_LEFT\' | translate\"></span><div class=card-group-value ng-bind=\"package.maxAvailable - package.stats.inUse\"></div></div><div class=card-group ng-if=package.limitPerPerson><span class=card-group-label ng-bind=\"\'Available\'\"></span><div class=card-group-value ng-bind=package.purchased></div></div><div class=card-group ng-if=\"package.preferences.maxAttendants >= 0\"><span class=card-group-label ng-bind=\"\'LABEL.MAX_ATTENDANTS\' | translate\"></span><div class=card-group-value ng-bind=package.preferences.maxAttendants></div></div></div><div class=card-foot ng-if=\"!package.soldout && (vm.sponsorModule.cashPayment || vm.sponsorModule.cardPayment)\"><button class=\"btn btn-primary btn-block btn-sm\" type=button ng-if=\"!vm.selectedPackage || vm.selectedPackage.id != package.id\" ng-click=\"vm.selectedPackage = package\" ng-bind=\"\'BUTTON.SELECT\' | translate\"></button> <span class=\"btn btn-success btn-block btn-sm\" type=button ng-if=\"vm.selectedPackage && vm.selectedPackage.id == package.id\" ng-disabled=\"vm.selectedPackage && vm.selectedPackage.id\" ng-bind=\"\'BUTTON.SELECTED\' | translate\"></span></div></div></div></div><!-- Note --><div class=form-group ng-if=\"vm.selectedPackage && vm.selectedPackage.id\"><label for=sponsorRequestNotes ng-bind=\"\'FORM.SPECIAL_NOTES\' | translate\"></label><textarea class=form-control name=notes id=sponsorRequestNotes ng-model=vm.sponsorRequestNotes rows=5></textarea></div><div class=\"form-group form-group-btn-package\" ng-if=\"vm.selectedPackage && vm.selectedPackage.price === 0\"><hr><button class=\"btn btn-primary btn-sm\" type=button ng-if=\"vm.sponsorModule.cashPayment || vm.sponsorModule.cardPayment\" ng-disabled=\"!vm.selectedPackage || vm.loadingCash\" ng-click=handleNoCostButton()><i ng-if=vm.loadingCash class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.sponsorModule.buttonLabelPayCash></span></button></div><div class=\"form-group form-group-btn-package\" ng-if=\"vm.selectedPackage && vm.selectedPackage.price > 0\"><hr><button class=\"btn btn-primary btn-sm\" type=button ng-if=vm.sponsorModule.cashPayment ng-disabled=\"!vm.selectedPackage || vm.loadingCash\" ng-click=handleCashButton()><i ng-if=vm.loadingCash class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.sponsorModule.buttonLabelPayCash></span>&nbsp;<span ng-bind=\"\'$\'+ vm.selectedPackage.price\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-disabled=\"!vm.selectedPackage || vm.loadingBuy || vm.loadingCash\" ng-if=\"vm.event.billingPreferences.serviceType === \'stripe\' && vm.sponsorModule.cardPayment\" ng-click=\"handleStripeButton({publishableKey: vm.event.billingPreferences.publishableKey})\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.sponsorModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+ vm.selectedPackage.price\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.event.billingPreferences.serviceType === \'transactionexpress\' && vm.sponsorModule.cardPayment\" ng-disabled=\"!vm.selectedPackage || vm.loadingBuy || vm.loadingCash\" ng-click=\"handleTransactionButton({\n                      hostedKey: vm.event.billingPreferences.hostedKey,\n                      gatewayId: vm.event.billingPreferences.gatewayId,\n                      hostedPageUrl: vm.event.billingPreferences.hostedPageUrl,\n                      callback: \'sponsor/event\'\n                    })\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.sponsorModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+ vm.selectedPackage.price\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.event.billingPreferences.serviceType == \'paypal\' && vm.sponsorModule.cardPayment\" ng-disabled=\"!vm.selectedPackage || vm.loadingBuy || vm.loadingCash\" ng-click=\"handlePaypalButton({\n                      paypalMerchantId: vm.event.billingPreferences.merchantId,\n                      paypalCallback: \'sponsor/event?fetchingRequests=true\',\n                      paypalMode: vm.event.billingPreferences.mode,\n                      paypalButtonType: \'sponsor\'\n                    })\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.sponsorModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+ vm.selectedPackage.price\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.event.billingPreferences.serviceType == \'squareup\' && vm.sponsorModule.cardPayment\" ng-disabled=\"!vm.selectedPackage || vm.loadingBuy || vm.loadingCash\" ng-click=\"handleSquareButton({\n                      applicationId: vm.event.billingPreferences.applicationId,\n                      locationId: vm.event.billingPreferences.locationId\n                    })\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.sponsorModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+ vm.selectedPackage.price\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"vm.event.billingPreferences.serviceType == \'payeezy\' && vm.sponsorModule.cardPayment\" ng-disabled=\"!vm.selectedPackage || vm.loadingBuy || vm.loadingCash\" ng-click=\"handlePayeezyButton({\n                      apiKey: vm.event.billingPreferences.apiKey,\n                      jsSecurityKey: vm.event.billingPreferences.jsSecurityKey,\n                      paymentJSUrl: vm.event.billingPreferences.paymentJSUrl,\n                      transarmorToken: vm.event.billingPreferences.transarmorToken\n                    })\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=vm.sponsorModule.buttonLabelPayCard></span>&nbsp;<span ng-bind=\"\'$\'+ vm.selectedPackage.price\"></span></button></div></div></div></div><div class=\"col-sm-5 col-sm-pull-7\"><div class=\"panel panel-default\" ng-if=\"\n              (vm.appFormSponsor && vm.appFormSponsor.content) ||\n              (vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)) ||\n              (vm.preferences.scheduleModule.enabled && vm.sponsorModule.enableUserTypeSchedule)\n            \"><div class=panel-body ng-if=\"vm.appFormSponsor && vm.appFormSponsor.content\" ng-bind-html=\"vm.appFormSponsor.content | trusted\"></div><div class=panel-footer ng-if=\"\n          (vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)) ||\n          (vm.preferences.scheduleModule.enabled && vm.sponsorModule.enableUserTypeSchedule)\n        \"><button class=\"btn btn-info btn-sm\" type=button ng-click=handleDonation() ng-bind=\"\'BUTTON.donate\' | translate\"></button></div></div><!-- Include: Healine sponsor slider --><div ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" ng-include=\"\'app/users/sponsor-inner-pages/ms-inner-pages.html\'\"></div><div class=\"panel panel-default\"><div class=panel-heading ng-bind-html=\"vm.event.name | trusted\"></div><div class=panel-body><p><span ng-bind=vm.event.address></span></p><div ng-if=vm.preferences.showEventStartEndDate><p ng-if=vm.isSameDate><span ng-bind=vm.eventStartDate></span></p><p ng-if=!vm.isSameDate><span ng-bind=vm.eventStartDate></span> - <span ng-bind=vm.eventEndDate></span></p><p><span ng-bind=vm.eventStartTime></span> - <span ng-bind=vm.eventEndTime></span></p></div><div ta-bind ng-model=vm.event.description></div></div></div></div></div><!-- Include: Secondary sponsor slider --><div ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" ng-include=\"\'app/users/sponsor-inner-pages/ss-inner-pages.html\'\"></div></div>");
$templateCache.put("app/users/sponsor/messages/messages.html","<div ng-controller=\"SponsorMessagesController as vm\" ng-init=onInit()><div class=form-group><button class=\"btn btn-info\" type=button ng-click=openModalMessage() ng-bind=\"\'BUTTON.MESSAGE_EVENT_ORGANIZER\' | translate\"></button></div><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/sponsor/sponsor-map/sponsor-map.html","<div class=area-controller ng-controller=\"SponsorMapController as vm\" ng-init=onInit()><div class=map-wrap><div ng-if=!showPosition class=\"map-btn-group _right\" id=indoorMapZoomInOutGroup><span class=\"map-btn _zoom\" id=indoorMapZoomIn><i class=\"fa fa-plus\" aria-hidden=true></i></span> <span class=\"map-btn _zoom\" id=indoorMapZoomOut><i class=\"fa fa-minus\" aria-hidden=true></i></span></div><div map-calculate id=mapWrap style=\"background-color: #ededed\"><div id=map style=\"width: 100%; height: 100%\"></div></div></div></div>");
$templateCache.put("app/users/sponsor-attendant/ep-request/ep-request.html","<div ng-init=onInit()><div class=modal-backcolor ng-click=onClose()></div><div class=modal-wrap><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=onClose()><span aria-hidden=true>&times;</span></button></div><div class=modal-body><div class=text-center ng-if=vm.loading><i class=\"fa fa-spinner fa-spin\" style=\"font-size: 24px\"></i></div><div ng-if=!vm.loading><div class=modal-qr ng-if=!vm.request.checkedIn><qrcode data={{vm.qrURL}} href={{vm.qrURL}} size=128></qrcode></div><div class=modal-qr ng-if=vm.request.checkedIn><div class=modal-qr-checkedin><span ng-bind=\"\'TEXT.CHECKED\' | translate\"></span> <i class=\"glyphicon glyphicon-ok\"></i></div></div></div><div ng-if=!vm.loading><div class=\"card card-default -lg\" style=\"margin-bottom: 8px\"><div class=card-head><h3 class=card-title ng-bind=vm.request.user.name></h3></div></div></div></div></div></div>");
$templateCache.put("app/users/vendor/event/event.form.html","<div class=\"modal in\" tabindex=-1 role=dialog style=\"display: block; overflow-y: auto\" ng-controller=\"VendorEventFormController as vm\" ng-init=onInit()><div class=\"modal-backdrop in\" ng-click=onClose()></div><div class=modal-dialog role=document style=\"z-index: 1041\"><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=onClose()><span aria-hidden=true>&times;</span></button><h3 class=modal-title><span ng-bind=label></span> request</h3></div><div class=modal-body><form novalidate name=form ng-submit=handleSubmit()><div class=form-group ng-class=\"{ \'has-error\': form.goodsCategory.$invalid && formSubmitted }\"><label for=goodsCategory><span ng-bind=\"\'FORM.REQUEST_PREVIEW.GOODS_CATEGORY\' | translate\"></span> <span>&nbsp;*</span></label><select class=form-control id=goodsCategory name=goodsCategory ng-options=\"category as category.name for category in vm.categories track by category.id\" ng-model=vm.request.goodsCategory required><option value=\"\">Choose category</option></select><div class=help-block ng-if=formSubmitted ng-messages=form.goodsCategory.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.description.$invalid && formSubmitted }\"><label for=description><span ng-bind=\"\'FORM.REQUEST_PREVIEW.DESCRIPTION\' | translate\"></span> <span ng-if=vm.vendorModule.requestDescriptionRequired>&nbsp;*</span></label><textarea class=form-control id=description type=text name=description placeholder=\"{{\'FORM.REQUEST_PREVIEW.DESCRIPTION\' | translate}}\" ng-model=vm.request.description ng-required=vm.vendorModule.requestDescriptionRequired>\n            </textarea><div class=help-block ng-if=formSubmitted ng-messages=form.description.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-if=vm.request.price><label class=price ng-bind=\"\'FORM.REQUEST_PREVIEW.PRICE\' | translate\"></label><input class=form-control id=price name=price type=text placeholder=\"{{\'FORM.REQUEST_PREVIEW.PRICE\' | translate}}\" ng-model=vm.request.price readonly></div><div class=form-group ng-class=\"{ \'has-error\': form.individualFeaturedItems.$invalid && formSubmitted }\"><label for=individualFeaturedItems><span ng-bind=\"\'FORM.REQUEST_PREVIEW.INDIVIDUAL_FEATURED_ITEMS\' | translate\"></span> <span ng-if=vm.vendorModule.requestFeaturedItemsRequired>&nbsp;*</span></label><textarea class=form-control id=individualFeaturedItems type=text name=individualFeaturedItems placeholder=\"{{\'FORM.REQUEST_PREVIEW.INDIVIDUAL_FEATURED_ITEMS\' | translate}}\" ng-model=vm.request.individualFeaturedItems ng-required=vm.vendorModule.requestFeaturedItemsRequired>\n            </textarea><div class=help-block ng-if=formSubmitted ng-messages=form.individualFeaturedItems.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group><label ng-bind=\"\'FORM.REQUEST_PREVIEW.PROFILE_VISIBILITY\' | translate\"></label><input type=hidden ng-model=vm.request.profileVisibility><div class=checkbox ng-repeat=\"item in visibility track by $index\"><label><input type=checkbox value=\"{{ item.value }}\" ng-click=profileChecked(item.value) ng-checked=\"vm.request.profileVisibility.indexOf(item.value) > -1\"> <i class=label></i> {{ item.name }}</label></div></div><!--\n          <div class=\"form-group\">\n            <label>Upload Festival Application</label>\n            <upload-file ng-model=\"vm.applicationForm\"\n                         ng-files=\"{{ vm.request.applicationForm }}\"\n                         ng-title=\"Upload festival application\"\n                         ng-type=\"file\"\n                         ng-required=\"vm.requestRequired\" />\n          </div>\n          --><div class=form-group><label ng-bind=\"\'FORM.REQUEST_PREVIEW.BOOTH_PHOTOS\' | translate\"></label><upload-file ng-model=vm.files ng-files=\"{{ vm.request.boothPhotos }}\" ng-multiple=true ng-max-length=5></div><div class=form-group><button class=\"btn btn-default\" type=button data-dismiss=modal ng-click=onClose() ng-bind=\"\'BUTTON.DIALOG.CLOSE\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=label></span></button></div></form></div></div></div></div>");
$templateCache.put("app/users/vendor/event/event.html","<div ng-controller=\"VendorEventController as vm\" ng-init=onInit()><div class=\"row row-16\"><div class=\"col-sm-7 col-sm-push-5\"><div class=bg-info ng-if=showInfopanel style=\"padding: 16px; margin-bottom: 16px\"><i class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'TEXT.WAITING_FOR_TRANSACTION\' | translate\"></span></div><div class=\"row row-flex row-16\" ng-if=\"vm.requests.length != 0\"><div class=\"col-xs-12 col-md-6\" style=\"margin-bottom: 16px\" ng-repeat=\"request in vm.requests | orderBy:\'status\' | orderBy:\'-createdOn\' track by $index\"><div class=\"card card-default\"><div class=card-head><h3 class=card-title ng-bind=request.vendor.username></h3></div><div class=card-body><div class=card-group ng-show=request.createdOn><span class=card-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=card-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=card-group ng-show=request.goodsCategory.name><span class=card-group-label ng-bind=\"\'LABEL.CATEGORY\' | translate\"></span><div class=card-group-value ng-bind=request.goodsCategory.name></div></div><div class=card-group ng-show=request.description><span class=card-group-label ng-bind=\"\'LABEL.DESCRIPTION\' | translate\"></span><div class=card-group-value ng-bind=request.description></div></div><div class=card-group ng-show=request.individualFeaturedItems><span class=card-group-label ng-bind=\"\'LABEL.FEATURED_ITEMS\' | translate\"></span><div class=card-group-value ng-bind=request.individualFeaturedItems></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=card-group ng-show=request.status><span class=card-group-label ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"card-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=card-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></div></div><div class=\"row row-8\"><div class=col-xs-4 ng-if=request.price><div class=card-group ng-if=request.price><span class=card-group-label ng-bind=\"\'LABEL.PRICE\' | translate\"></span><div class=card-group-value ng-bind=\"\'&#36;\' + request.price\"></div></div></div><div class=col-xs-8 ng-if=request.invoiceDueDate><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.INVOICE_DUE_DATE\' | translate\"></span><div class=card-group-value ng-bind=\"request.invoiceDueDate | dateFormated\"></div></div></div></div><div class=\"row row-8\"><div class=col-xs-4><div class=card-group ng-if=request.invoiceStatus><span class=card-group-label ng-bind=\"\'FORM.label.paymentStatus\' | translate\"></span><div class=card-group-value ng-bind=request.invoiceStatus></div></div></div><div class=col-xs-8><div class=card-group ng-if=request.invoicePaymentDate><span class=card-group-label ng-bind=\"\'LABEL.PAYMENT_DATE\' | translate\"></span><div class=card-group-value ng-bind=\"request.invoicePaymentDate | dateFormated\"></div></div></div></div><!--\n              <div class=\"card-group\" ng-if=\"request.applicationForm\">\n                <a ng-href=\"{{ request.applicationForm.link }}\" target=\"_blank\">Application Form</a>\n              </div>\n              --><div class=card-group ng-if=\"request.status == \'accepted\' && vm.event.preferences && vm.event.preferences.confirmationDocument\"><a ng-href=\"{{ vm.event.preferences.confirmationDocument.link }}\" target=_blank ng-bind=\"\'BUTTON.CONFIRMATION_DOCUMENT\' | translate\"></a></div><div class=card-group ng-if=request.boothPhotos.length><span class=card-group-label ng-bind=\"\'LABEL.BOOTH_PHOTOS\' | translate\"></span><div class=photo-preview><div class=photo-preview-item ng-repeat=\"file in request.boothPhotos track by $index\" ng-if=file><div class=inner><img ng-src=\"{{ file.link }}\" alt=\"\" ng-click=handlePhotoPreview(file)></div></div></div></div></div><div class=card-foot ng-if=\"(request.status != \'cancelled\' || request.status != \'declined\') && eventStatus\"><span ng-if=\"(request.status == \'invoiced\' && request.price) && eventStatus && vm.event.billingPreferences\"><button class=\"btn btn-primary btn-sm\" ng-disabled=\"handleFieldsValidation() || vm.loadingBuy || vm.loadingCash\" ng-if=\"vm.event.billingPreferences.serviceType === \'stripe\'\" ng-click=\"handleStripeButton({publishableKey: vm.event.billingPreferences.publishableKey}, request)\"><i ng-if=vm.loadingBuy class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.PAY_CREDIT_CARD\' | translate\"></span>&nbsp;<span ng-bind=\"request.price +\'$\'\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-disabled=\"request.price == 0\" ng-if=\"vm.event.billingPreferences.serviceType === \'transactionexpress\'\" ng-click=\"handleTransactionButton({\n                          hostedKey: vm.event.billingPreferences.hostedKey,\n                          gatewayId: vm.event.billingPreferences.gatewayId,\n                          hostedPageUrl: vm.event.billingPreferences.hostedPageUrl,\n                          callback: \'vendor/event\'\n                        }, request)\"><span ng-bind=\"\'BUTTON.PAY_CREDIT_CARD\' | translate\"></span>&nbsp;<span ng-bind=\"request.price + \'$\'\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-disabled=\"request.price == 0\" ng-if=\"vm.event.billingPreferences.serviceType === \'paypal\'\" ng-click=\"handlePaypalButton({\n                          paypalMerchantId: vm.event.billingPreferences.merchantId,\n                          paypalCallback: \'vendor/event?fetchingRequests=true\',\n                          paypalMode: vm.event.billingPreferences.mode,\n                          paypalButtonType: \'vendor\'\n                        }, request)\"><span ng-bind=\"\'BUTTON.PAY_CREDIT_CARD\' | translate\"></span>&nbsp;<span ng-bind=\"request.price + \'$\'\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-disabled=\"request.price == 0\" ng-if=\"vm.event.billingPreferences.serviceType === \'squareup\'\" ng-click=\"handleSquareupButton({\n                          applicationId: vm.event.billingPreferences.applicationId,\n                          locationId: vm.event.billingPreferences.locationId,\n                        }, request)\"><span ng-bind=\"\'BUTTON.PAY_CREDIT_CARD\' | translate\"></span>&nbsp;<span ng-bind=\"request.price + \'$\'\"></span></button> <button class=\"btn btn-primary btn-sm\" ng-disabled=\"request.price == 0\" ng-if=\"vm.event.billingPreferences.serviceType === \'payeezy\'\" ng-click=\"handlePayeezyButton({\n                          apiKey: vm.event.billingPreferences.apiKey,\n                          jsSecurityKey: vm.event.billingPreferences.jsSecurityKey,\n                          paymentJSUrl: vm.event.billingPreferences.paymentJSUrl,\n                          transarmorToken: vm.event.billingPreferences.transarmorToken\n                        }, request)\"><span ng-bind=\"\'BUTTON.PAY_CREDIT_CARD\' | translate\"></span>&nbsp;<span ng-bind=\"\'$\'+totalPrice()\"></span></button> </span><button class=\"btn btn-info btn-sm\" ng-disabled=\"!request.boothPhotos.length && vm.vendorModule.requestImageRequired\" ng-click=handleSubmit(request) ng-if=\"(request.status == \'draft\') && eventStatus\" ng-bind=\"\'BUTTON.SUBMIT\' | translate\"></button> <button class=\"btn btn-success btn-sm\" ng-click=showEventPass(request) ng-if=\"(request.status == \'accepted\' && hasBoothLinked(request)) && eventStatus\" ng-bind=\"\'BUTTON.EVENT_PASS\' | translate\"></button><div uib-dropdown class=btn-group style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button><li role=menuitem ng-if=\"(request.status == \'draft\') && eventStatus\"><a ui-sref=\"users.vendor.event.update({id: request.id})\" ng-bind=\"\'BUTTON.EDIT\' | translate\"></a></li><li role=menuitem><button ng-click=handlePreview(request) ng-bind=\"\'BUTTON.PREVIEW\' | translate\"></button></li><li role=menuitem ng-if=\"(request.status == \'accepted\' || request.status == \'pending\' || request.status == \'invoiced\') && eventStatus\"><button ng-click=handleCancel(request) ng-bind=\"\'BUTTON.CANCEL\' | translate\"></button></li></ul></div><p ng-if=\"vm.vendorModule.requestImageRequired && request.status == \'draft\' && !request.boothPhotos.length\" class=help-text style=\"font-size: 12px; color: red; margin-bottom: 0; margin-top: 8px\" ng-bind=\"\'TEXT.ONE_BOOTH_PHOTO_REQUIRED\' | translate\"></p></div></div></div></div></div><div class=\"col-sm-5 col-sm-pull-7\"><div class=\"panel panel-default\"><div class=panel-body ng-if=\"vm.appFormVendor && vm.appFormVendor.content\" ng-bind-html=\"vm.appFormVendor.content | trusted\"></div><div class=panel-footer ng-if=eventStatus><a class=\"btn btn-primary btn-sm\" ui-sref=users.vendor.event.add ng-bind=\"\'BUTTON.NEW_EVENT_REQUEST\' | translate\"></a> <button class=\"btn btn-info btn-sm\" type=button ng-if=\"vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)\" ng-click=handleDonation() ng-bind=\"\'BUTTON.donate\' | translate\"></button></div></div><!-- Include: Healine sponsor slider --><div ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" ng-include=\"\'app/users/sponsor-inner-pages/ms-inner-pages.html\'\"></div><div class=\"panel panel-default\"><div class=panel-heading ng-bind-html=\"vm.event.name | trusted\"></div><div class=panel-body><p><span ng-bind=vm.event.address></span></p><div ng-if=vm.preferences.showEventStartEndDate><p ng-if=vm.isSameDate><span ng-bind=vm.eventStartDate></span></p><p ng-if=!vm.isSameDate><span ng-bind=vm.eventStartDate></span> - <span ng-bind=vm.eventEndDate></span></p><p><span ng-bind=vm.eventStartTime></span> - <span ng-bind=vm.eventEndTime></span></p></div><div ta-bind ng-model=vm.event.description></div></div></div></div></div><!-- Include: Secondary sponsor slider --><div ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" ng-include=\"\'app/users/sponsor-inner-pages/ss-inner-pages.html\'\"></div></div><div ui-view=modal></div><div ui-view=pass></div>");
$templateCache.put("app/users/vendor/messages/messages.html","<div ng-controller=\"VendorMessagesController as vm\" ng-init=onInit()><div class=form-group ng-if=eventStatus><button class=\"btn btn-info\" type=button ng-click=openModalMessage() ng-bind=\"\'BUTTON.MESSAGE_EVENT_ORGANIZER\' | translate\"></button></div><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/vendor/vendor-map/vendor-map.html","<div class=area-controller ng-controller=\"VendorMapController as vm\" ng-init=onInit()><div class=map-wrap><div ng-if=!showPosition class=\"map-btn-group _right\" id=indoorMapZoomInOutGroup><span class=\"map-btn _zoom\" id=indoorMapZoomIn><i class=\"fa fa-plus\" aria-hidden=true></i></span> <span class=\"map-btn _zoom\" id=indoorMapZoomOut><i class=\"fa fa-minus\" aria-hidden=true></i></span></div><div map-calculate id=mapWrap style=\"background-color: #ededed\"><div id=map style=\"width: 100%; height: 100%\"></div></div></div></div>");
$templateCache.put("app/users/volunteer/event/assignments.html","<div ng-init=onInit()><div class=modal-header><h4 class=modal-title ng-bind=\"\'DIALOG.TITLE.ASSIGNMENTS\' | translate\"></h4></div><div class=modal-body><div ng-if=vm.isLoading><span ng-bind=\"\'TEXT.loading\' | translate\"></span></div><div ng-if=!vm.isLoading><ul class=\"schedule-list ng-scope\" ng-if=\"vm.assignments && vm.assignments.length !== 0\" style=\"margin-top: 0; padding: 0\"><li ng-repeat=\"assignment in vm.assignments | orderBy:\'from\'\"><div ng-if=\"assignment.from && assignment.to\"><p ng-if=\"isSameDay(assignment.from, assignment.to)\"><b ng-bind=\"assignment.from | dateFormated\"></b> &nbsp;-&nbsp; <b ng-bind=\"assignment.to | timeFormated\"></b></p><p ng-if=\"!isSameDay(assignment.from, assignment.to)\"><b ng-bind=\"assignment.from | dateFormated\"></b> &nbsp;-&nbsp; <b ng-bind=\"assignment.to | dateFormated\"></b></p></div><p ng-bind=\"assignment.volunteerZoneName ? assignment.volunteerZoneName : \'NO ZONE NAME\'\"></p></li></ul><div class=no-message ng-if=\"vm.assignments && vm.assignments.length === 0\"><i class=\"glyphicon glyphicon-calendar\"></i><h3 ng-bind=\"\'TEXT.NO_ASSIGNMENTS\' | translate\"></h3></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button ng-click=onClose() ng-bind=\"\'BUTTON.DIALOG.CLOSE\' | translate\"></button></div></div>");
$templateCache.put("app/users/volunteer/event/event.html","<div ng-controller=\"VolunteerEventController as vm\" ng-init=onInit()><div class=\"row row-16\"><div class=\"col-sm-7 col-sm-push-5\"><div class=\"row row-flex row-16\" ng-if=\"vm.requests.length != 0\"><div class=\"col-xs-12 col-md-6\" style=\"margin-bottom: 16px\" ng-repeat=\"request in vm.requests | orderBy: \'status\' track by $index\"><div class=\"card card-default\"><div class=card-body><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=card-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=table-group ng-if=request.status><span class=table-group-label ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"table-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6><div class=table-group><span class=table-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=table-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></div></div></div><div class=card-foot ng-if=\"eventStatus && (request.status == \'accepted\' || request.status == \'pending\' )\"><button class=\"btn btn-success btn-sm\" type=button ng-if=\"request.status == \'accepted\'\" ng-click=showEventPass(request) ng-bind=\"\'BUTTON.INSTRUCTION\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" type=button ng-if=\"request.status == \'pending\' || request.status == \'accepted\'\" ng-click=handleCancel(request) ng-bind=\"\'BUTTON.CANCEL\' | translate\"></button></div></div></div></div></div><div class=\"col-sm-5 col-sm-pull-7\"><div class=\"panel panel-default\"><div class=panel-body ng-if=\"vm.appFormVolunteer && vm.appFormVolunteer.content\" ng-bind-html=\"vm.appFormVolunteer.content | trusted\"></div><div class=panel-footer><button class=\"btn btn-primary btn-sm\" type=button ng-if=\"(vm.requests.length == 0 || vm.requests[vm.requests.length - 1].status == \'declined\' || vm.requests[vm.requests.length - 1].status == \'cancelled\') && eventStatus\" ng-click=handleAdd() ng-bind=\"\'BUTTON.NEW_EVENT_REQUEST\' | translate\"></button> <button class=\"btn btn-info btn-sm\" type=button ng-if=\"vm.preferences.enableDonations && (vm.billingPreferences && vm.billingPreferences.serviceType)\" ng-click=handleDonation() ng-bind=\"\'BUTTON.donate\' | translate\"></button> <button class=\"btn btn-info btn-sm\" type=button ng-click=vm.onAssignments(volunteer) ng-bind=\"\'BUTTON.ASSIGNMENTS\' | translate\"></button></div></div><!-- Include: Healine sponsor slider --><div ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" ng-include=\"\'app/users/sponsor-inner-pages/ms-inner-pages.html\'\"></div><div class=\"panel panel-default\"><div class=panel-heading ng-bind-html=\"vm.event.name | trusted\"></div><div class=panel-body><p><span ng-bind=vm.event.address></span></p><div ng-if=vm.preferences.showEventStartEndDate><p ng-if=vm.isSameDate><span ng-bind=vm.eventStartDate></span></p><p ng-if=!vm.isSameDate><span ng-bind=vm.eventStartDate></span> - <span ng-bind=vm.eventEndDate></span></p><p><span ng-bind=vm.eventStartTime></span> - <span ng-bind=vm.eventEndTime></span></p></div><div ta-bind ng-model=vm.event.description></div></div></div></div></div><!-- Include: Secondary sponsor slider --><div ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" ng-include=\"\'app/users/sponsor-inner-pages/ss-inner-pages.html\'\"></div></div><div ui-view=pass>");
$templateCache.put("app/users/volunteer/messages/messages.html","<div ng-controller=\"VolunteerMessagesController as vm\" ng-init=onInit()><div class=form-group ng-if=eventStatus><a class=\"btn btn-info\" ng-click=openModalMessage() ng-bind=\"\'BUTTON.MESSAGE_EVENT_ORGANIZER\' | translate\"></a></div><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div>");
$templateCache.put("app/users/volunteer/time-log/time-log.html","<div ng-controller=\"VolunteerTimelogController as vm\" ng-init=onInit()><h5><span ng-bind=\"\'TEXT.TOTAL_LOGGED_TIME\' | translate\"></span> <span ng-bind=totalTimeSpent></span><hr></h5><div ng-if=loading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!loading><div class=\"form-group | clearfix\"><button class=\"btn btn-info btn-sm | pull-right\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.createLog\' | translate\"></button></div><div ng-if=logs.length><div class=\"form-group clearfix\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.info\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.checkIn\' | translate\"></th><th ng-bind=\"\'TABLE.checkOut\' | translate\"></th><th ng-bind=\"\'TABLE.timeSpent\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"log in logs | FilterPagination: currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-if=log.userName ng-bind=log.userName></h3><h5 class=table-subtitle ng-if=log.comment ng-bind=log.comment></h5></td><td><div class=table-group ng-if=log.status><span class=\"table-group-label _hide\" ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"table-group-value {{log.status}}\" ng-bind=log.status></div></div></td><td><div class=table-group><span class=\"table-group-label _hide\" ng-bind=\"\'Check-in date\'\"></span><div class=table-group-value ng-bind=\"log.checkInDate | dateFormated\"></div></div></td><td><div class=table-group ng-if=log.checkOutDate><span class=\"table-group-label _hide\" ng-bind=\"\'Check-out date\'\"></span><div class=table-group-value ng-bind=\"log.checkOutDate | dateFormated\"></div></div></td><td><div class=table-group ng-if=totalTime(log.timeSpentMin)><span class=\"table-group-label _hide\" ng-bind=\"\'Total spent time\'\"></span><div class=table-group-value ng-bind=totalTime(log.timeSpentMin)></div></div></td><td class=-actions><!-- <button ng-if=\"log.status === \'draft\'\" class=\"btn btn-default btn-sm\" type=\"button\"\n                      ng-click=\"handleEdit(log)\"\n                      ng-bind=\"\'BUTTON.edit\' | translate\"></button> --> <button class=\"btn btn-danger btn-sm\" type=button ng-if=\"log.status === \'draft\' || log.status === \'declined\'\" ng-click=handleDelete(log) ng-bind=\"\'BUTTON.delete\' | translate\"></button></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"logs.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"logs.length > currentEvent.preferences.itemsPerPage && vm.volunteers.length != 0\" uib-pagination total-items=logs.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div class=no-message ng-if=!logs.length><i class=\"glyphicon glyphicon glyphicon-th-list\"></i><h3 ng-bind=\"\'TEXT.noLogs\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/volunteer/volunteer-map/volunteer-map.html","<div class=area-controller ng-controller=\"VolunteerMapController as vm\" ng-init=onInit()><div class=area-controller-absolute><div class=form-group><label><input type=checkbox name=showOnlyMyZones ng-model=showOnlyMyZones ng-change=handleShowOnlyMyZones()> <span ng-bind=\"\'FORM.value.showOnlyMyZones\' | translate\"></span></label><label><input type=checkbox name=showEventZones ng-model=showEventZones ng-change=handleShowEventZone()> <span ng-bind=\"\'FORM.value.showEventZones\' | translate\"></span></label></div></div><div class=map-wrap><div ng-if=!showPosition class=\"map-btn-group _right\" id=indoorMapZoomInOutGroup><span class=\"map-btn _zoom\" id=indoorMapZoomIn><i class=\"fa fa-plus\" aria-hidden=true></i></span> <span class=\"map-btn _zoom\" id=indoorMapZoomOut><i class=\"fa fa-minus\" aria-hidden=true></i></span></div><div map-calculate id=mapWrap style=\"background-color: #ededed\"><div id=map style=\"width: 100%; height: 100%\"></div></div></div></div>");
$templateCache.put("app/users/volunteerCoordinator/messages/messages.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"\'DIALOG.TITLE.SEND_MESSAGE\' | translate\"></h3></div><div class=modal-body id=modal-body><fieldset><legend ng-bind=\"\'FORM.MESSAGE.SEND_TO\' | translate\"></legend><div class=form-group><label ng-bind=\"\'FORM.MESSAGE.ALIASES\' | translate\"></label><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=checkbox ng-repeat=\"send in sendTo\"><label><input type=checkbox name=checkedSend[] ng-value=send.type ng-checked=\"vm.message.recipientAliases.indexOf(send.type) > -1\" ng-click=\"toggleCheckbox(send, \'all\')\"> <span ng-bind=send.name></span></label></div></div><div class=\"col-xs-12 col-sm-6\"><div class=checkbox ng-repeat=\"send in sendToAccepted\"><label><input type=checkbox name=checkedSend[] ng-value=send.type ng-checked=\"vm.message.recipientAliases.indexOf(send.type) != -1\" ng-click=\"toggleCheckbox(send, \'allAccepted\')\"> <span ng-bind=send.name></span></label></div></div></div></div><div class=form-group><label for=users ng-bind=\"\'FORM.MESSAGE.USERS\' | translate\"></label><ui-select ng-model=vm.recipientIds multiple><ui-select-match placeholder=\"{{\'FORM.MESSAGE.USERS\' | translate}}\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices refresh=handleUsersSearch($select.search) refresh-delay=0 repeat=\"user in vm.usersSearch | filter: { name: $select.search }\"><span class=ui-select-title ng-bind=user.name></span> <span class=ui-select-describe ng-bind=user.email></span></ui-select-choices></ui-select></div><hr></fieldset><div class=form-group ng-class=\"{ \'has-error\': form.subject.$invalid && formSubmitted }\"><label for=subject><span ng-bind=\"\'FORM.MESSAGE.SUBJECT\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=subject type=text name=subject placeholder=\"{{\'FORM.MESSAGE.SUBJECT\' | translate}}\" ng-model=vm.message.subject ng-required=!vm.message.sentToSms><div class=help-block ng-if=formSubmitted ng-messages=form.subject.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><text-editor-gallery teg-name=body teg-label=\"{{ \'FORM.MESSAGE.MESSAGE\' | translate }}\" teg-model=vm.message.body teg-required=true teg-submitted=formSubmitted teg-form=form></text-editor-gallery><div class=form-group><div class=checkbox><label><input type=checkbox name=sendToEmail ng-model=vm.message.sendToEmail> <span class=label></span> <span ng-bind=\"\'FORM.MESSAGE.INCLUDE_EMAIL_NOTIFICATION\' | translate\"></span></label></div><div class=checkbox><label><input type=checkbox name=sendToEmail ng-model=vm.message.sendToSms> <span class=label></span> <span ng-bind=\"\'FORM.MESSAGE.INCLUDE_TEXT_MESSAGE\' | translate\"></span></label></div><div class=form-group ng-if=vm.message.sendToSms ng-class=\"{ \'has-error\': form.shortText.$invalid && formSubmitted }\"><label for=shortText><span ng-bind=\"\'FORM.MESSAGE.TEXT_MESSAGE\' | translate\"></span> <span>&nbsp;*</span></label><textarea class=form-control id=shortText name=shortText placeholder=\"{{ \'FORM.MESSAGE.TEXT_MESSAGE\' | translate }}\" ng-model=vm.message.shortText ng-blur=onShortText(vm.message.shortText) ng-trim=false maxlength=160 required>\n        </textarea><div class=\"help-block text-right\">{{vm.message.shortText ? 160 - vm.message.shortText.length : 160}}</div><div class=help-block ng-if=formSubmitted ng-messages=form.shortText.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=checkbox><label><input type=checkbox name=scheduleDate ng-model=vm.scheduleDate> <span class=label></span> <span ng-bind=\"\'FORM.MESSAGE.SCHEDULE_DATE\' | translate\"></span></label></div></div><div ng-if=vm.scheduleDate><div class=form-group ng-class=\"{ \'has-error\': form.startDate.$invalid && formSubmitted }\"><label for=date><span ng-bind=\"\'FORM.MESSAGE.DATE\' | translate\"></span> <span>&nbsp;*</span></label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=handleDatepickerPopup()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=startDate ng-model=vm.startDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=datepickerPopup.opened show-button-bar=false ng-required=vm.scheduleDate></div><div class=help-block ng-if=formSubmitted ng-messages=form.startDate.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=date ng-bind=\"\'FORM.validation.invalidDate\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.startTime.$invalid && formSubmitted }\"><label for=startTime><span ng-bind=\"\'FORM.MESSAGE.START_TIME\' | translate\"></span> <span>&nbsp;*</span></label><div uib-timepicker ng-model=vm.startTime name=startTime ng-change=changed() show-meridian=true ng-required=vm.scheduleDate></div><div class=help-block ng-if=formSubmitted ng-messages=form.startTime.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=time ng-bind=\"\'FORM.validation.invalidTime\' | translate\"></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.DIALOG.CLOSE\' | translate\"></button> <button class=\"btn btn-primary\" type=submit><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-if=vm.scheduleDate ng-bind=\"\'BUTTON.SCHEDULE\' | translate\"></span> <span ng-if=!vm.scheduleDate ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/volunteerCoordinator/messages/messages.html","<div ng-controller=VolunteerCoordinatorMessagesController ng-init=onInit()><div class=form-group ng-if=eventStatus><button class=\"btn btn-info\" role=button type=button ng-click=openModalMessage() ng-bind=\"\'BUTTON.SEND_MESSAGE\' | translate\"></button></div><ui-view style=\"width: 100%\"><span ng-bind=\"\'TEXT.loading\' | translate\"></span></ui-view></div><div ui-view=modal></div>");
$templateCache.put("app/users/volunteerCoordinator/volunteer-coordinator-map/volunteer-coordinator-map.html","<div ng-controller=\"VolunteerCoordinatorMapController as vm\" ng-init=onInit()><div class=\"row row-16 row-justify\"><div class=\"col-xs-12 col-md-3\"><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedBooth || onlyUnassignedRespZone}\"><label><input type=checkbox ng-disabled=\"onlyUnassignedBooth || onlyUnassignedRespZone\" name=isRespZonesVisible ng-model=isRespZonesVisible ng-change=\"onChangeMapObjectVisible(\'respZone\', isRespZonesVisible)\"> <span ng-bind=\"\'MAP_CONSTRUCTOR.RESPONSIBILITY_ZONE\' | translate\"></span></label></div><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedBooth || onlyUnassignedRespZone}\"><label><input type=checkbox ng-disabled=\"onlyUnassignedBooth || onlyUnassignedRespZone\" name=isRoutesVisible ng-model=isRoutesVisible ng-change=\"onChangeMapObjectVisible(\'route\', isRoutesVisible)\"> <span ng-bind=\"\'MAP_CONSTRUCTOR.ROUTE\' | translate\"></span></label></div><div class=route-filter style=\"margin-bottom: 16px\" ng-class=\"{\'-open\': isRoutesFilterVisible}\"><button class=\"btn btn-default btn-sm btn-block\" ng-click=\"isRoutesFilterVisible = !isRoutesFilterVisible\">{{ !isRoutesFilterVisible ? (\'MAP_CONSTRUCTOR.SHOW_ROUTES\' | translate) : (\'MAP_CONSTRUCTOR.HIDE_ROUTES\' | translate) }}</button><div class=route-filter-scroll ng-if=isRoutesFilterVisible><div class=\"checkbox checkbox-route\" ng-repeat=\"route in routes track by $index\"><span ng-click=\"onRouteClick($event, route)\" ng-if=route.checked><i class=\"glyphicon glyphicon-pencil\"></i></span><label><input type=checkbox ng-model=route.checked ng-change=\"changeRouteVisibility(route.checked, route.id)\"> <i class=circle-color ng-style=\"{\'background-color\': route.strokeColor }\"></i> <span ng-bind=\"route.name || route.id\"></span></label></div></div></div><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedBooth}\"><label><input type=checkbox ng-disabled=onlyUnassignedBooth name=onlyUnassignedRespZone ng-model=onlyUnassignedRespZone ng-change=\"onChangeOnlyUnassignedRespZone(onlyUnassignedRespZone, {\n                    isBoothsVisible: isBoothsVisible,\n                    isRoutesVisible: isRoutesVisible,\n                    isRespZonesVisible: isRespZonesVisible,\n                    isEventZonesVisible: isEventZonesVisible\n                  })\"> <span ng-bind=\"\'MAP_CONSTRUCTOR.ONLY_UNASSIGNED_RESPONSIBILITY_ZONE\' | translate\"></span></label></div><div class=form-group ng-if=\"\n            !currentEvent.lockedBy ||\n            (\n              currentEvent.lockedBy && currentEvent.lockedBy.id === currentUser.id\n            )\n            \"><button class=\"btn btn-primary btn-sm btn-block\" type=button ng-disabled=$scope.mapSaveLoading ng-click=saveMapData()><i ng-if=$scope.mapSaveLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.SAVE\' | translate\"></span></button></div></div><div class=\"col-xs-12 col-md-9\"><div class=map-wrap><div class=map-btn-group><span class=map-btn ng-class=\"{\'active\': drawModeType === drawTypeRoute }\" ng-click=handleDrawModeType(drawTypeRoute) ng-bind=\"\'MAP_CONSTRUCTOR.ROUTE\' | translate\"></span> <span class=map-btn ng-class=\"{\'active\': drawModeType === drawTypeRespZone }\" ng-click=handleDrawModeType(drawTypeRespZone) ng-bind=\"\'MAP_CONSTRUCTOR.RESPONSIBILITY_ZONE\' | translate\"></span></div><div ng-if=!showPosition class=\"map-btn-group _right\" id=indoorMapZoomInOutGroup><span class=\"map-btn _zoom\" id=indoorMapZoomIn><i class=\"fa fa-plus\" aria-hidden=true></i></span> <span class=\"map-btn _zoom\" id=indoorMapZoomOut><i class=\"fa fa-minus\" aria-hidden=true></i></span></div><div map-calculate id=mapWrap style=\"background-color: #ededed\"><div id=map style=\"width: 100%; height: 100%\"></div></div></div></div></div><div class=map-aside-new ng-if=isCreatedNewMapItem ng-click=setFieldRequired()></div><div class=map-aside ng-class=\"{\'-opened\': selectedItem && selectedItem.kind }\"><div class=map-aside-content><button class=\"btn btn-default map-aside-close\" href=# ng-click=handleMapAsideClose()><i class=\"glyphicon glyphicon-remove\"></i></button><!-- Responsibility zone --><div ng-include=\"\'app/users/organizer/map/constructor/responsibility-zone/responsibility-zone.html\'\" ng-if=\"selectedItem.kind == drawTypeRespZone\"></div><!-- Route --><div ng-include=\"\'app/users/organizer/map/constructor/route/route.html\'\" ng-if=\"selectedItem.kind == drawTypeRoute\"></div></div></div></div>");
$templateCache.put("app/users/organizer/event/booths/booths.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"label +\' booth type\'\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.type.$invalid && formSubmitted }\"><label for=type><span ng-bind=\"\'FORM.label.type\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=type type=text name=type placeholder=\"{{\'FORM.placeholder.type\' | translate}}\" ng-model=vm.boothType.type ng-readonly=\"vm.boothType.id === 0\" maxlength=128 required><div class=\"help-block help-block-default\" style=\"text-align: right !important\">{{vm.boothType.type ? vm.boothType.type.length +\'/\'+ 128 : 0 +\'/\'+ 128}}</div><div class=help-block ng-if=formSubmitted ng-messages=form.type.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=\"row row-16\"><div class=col-sm-4><div class=form-group ng-class=\"{ \'has-error\': form.width.$invalid && formSubmitted }\"><label for=width><span ng-bind=\"\'FORM.label.width\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=width type=number name=width placeholder=\"{{\'FORM.placeholder.width\' | translate}}\" ng-model=vm.boothType.width required><div class=help-block ng-if=formSubmitted ng-messages=form.width.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div><div class=col-sm-4><div class=form-group ng-class=\"{\'has-error\': form.height.$invalid && formSubmitted }\"><label for=height><span ng-bind=\"\'FORM.label.height\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=height type=number name=height placeholder=\"{{\'FORM.placeholder.height\' | translate}}\" ng-model=vm.boothType.height required><div class=help-block ng-if=formSubmitted ng-messages=form.height.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div><div class=col-sm-4><div class=form-group ng-class=\"{ \'has-error\': form.selectedColorText.$invalid && formSubmitted }\"><label for=color><span ng-bind=\"\'FORM.label.color\' | translate\"></span> <span>&nbsp;*</span></label><div class=\"input-group input-group-color\"><span class=input-group-addon><label><input type=color name=selectedColorPicker ng-model=vm.selectedColor ng-change=vm.onChangeSelectedColor(vm.selectedColor)> <span style=\"background-color: {{vm.selectedColor}}\"></span></label></span><input class=form-control type=text name=selectedColorText ng-model=vm.selectedColor placeholder=\"Hex code\" ng-change=vm.onChangeSelectedColor(vm.selectedColor) required></div><div class=help-block ng-if=formSubmitted ng-messages=form.selectedColorText.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div></div><div class=form-group style=\"margin-bottom: 20px\"><div class=checkbox><label><input type=checkbox name=commercial id=commercial ng-model=vm.boothType.commercial ng-disabled=\"vm.boothType && vm.boothType.id\"> <span ng-bind=\"\'FORM.value.commercial\' | translate\"></span></label></div><div class=\"help-block help-block-default\" ng-bind=\"\'HELP.boothTypeCommercialSet\' | translate\"></div></div><div class=form-group style=\"margin-bottom: 20px\" ng-if=!vm.boothType.commercial><div class=checkbox><label><input type=checkbox name=private id=private ng-model=vm.boothType.preferences.private> <span ng-bind=\"\'FORM.value.private\' | translate\"></span></label></div><p class=\"help-block help-block-default\" ng-bind=\"\'HELP.visibleOnlyFor\' | translate\"></p></div><div class=form-group ng-if=\"vm.boothType.id !== 0\"><label ng-bind=\"\'FORM.label.image\' | translate\"></label><upload-file ng-model=vm.boothType.icon ng-files=\"{{ vm.boothType.icon }}\" uf-can-remove=true></upload-file></div><div class=form-group ng-if=\"vm.boothType.id === 0\"><label ng-bind=\"\'FORM.label.image\' | translate\"></label><div class=photo-preview><div class=\"photo-preview-item photo-preview-item-single\"><div class=inner><img ng-src={{vm.boothType.icon.link}} alt=\"\" alt=\"Booth icon\"></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button data-dismiss=modal ng-click=handleCancel() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/organizer/event/booths/booths.html","<div ng-controller=\"OrganizerBoothsController as vm\" ng-init=onInit()><div ng-if=loading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!loading><div class=\"form-group clearfix\" ng-if=eventStatus><button class=\"btn btn-info pull-right btn-sm\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.addBoothType\' | translate\"></button></div><div ng-if=vm.boothTypes.length><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoEventBoothTypesSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" autocomplete=off ng-model=searchByType ng-model-options=\"{debounce: 1000}\"></label></div><div class=\"row row-flex row-16\" ng-if=vm.boothTypes.length style=\"margin-bottom: 16px\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-2\" style=\"margin-top: 16px\" ng-repeat=\"boothType in vm.filterBoothTypes = (\n               vm.boothTypes\n                | FilterSearchByType: searchByType\n             )\n             | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\n             \"><div class=\"card card-default card-boothType\"><div class=card-head><h2 class=card-title ng-bind=boothType.type></h2></div><div class=card-body><div class=card-group ng-if=\"boothType.icon && boothType.icon.link\"><div class=card-group-image><img ng-src=\"{{ boothType.icon.link }}\" alt=\"{{ boothType.type }}\"></div></div><div class=row><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.width\' | translate\"></span><div class=card-group-value ng-bind=\"boothType.width + \'px\'\"></div></div></div><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.height\' | translate\"></span><div class=card-group-value ng-bind=\"boothType.height + \'px\'\"></div></div></div></div><div class=row ng-if=boothType.preferences><div class=col-xs-6 ng-if=\"boothType.preferences && boothType.preferences.color\"><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.color\' | translate\"></span><div class=card-group-color ng-style=\"{\'background-color\': boothType.preferences.color}\"></div></div></div><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.status\' | translate\"></span><div class=card-group-value ng-if=!boothType.preferences.private ng-bind=\"\'Public\'\"></div><div class=card-group-value ng-if=boothType.preferences.private ng-bind=\"\'Private\'\"></div></div></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.commercial\' | translate\"></span><div class=card-group-value ng-bind=\"boothType.commercial ? \'Yes\' : \'No\'\"></div></div></div><div class=card-foot ng-if=eventStatus><button class=\"btn btn-default btn-sm\" ng-click=handleEdit(boothType) ng-bind=\"\'BUTTON.edit\' | translate\"></button> <button class=\"btn btn-danger btn-icon btn-sm\" ng-if=\"boothType.id !== 0\" ng-click=handleDelete(boothType) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></div></div></div><div class=total><div class=total-label ng-if=\"vm.filterBoothTypes.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterBoothTypes.length > currentEvent.preferences.itemsPerPage && vm.participants.length != 0\" uib-pagination total-items=vm.filterBoothTypes.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div ng-if=\"vm.boothTypes.length === 0\"><div class=no-message><i class=\"glyphicon glyphicon-home\"></i><h3 ng-bind=\"\'TEXT.noBoothTypes\' | translate\"></h3></div></div></div></div><div ui-view=modal></div>");
$templateCache.put("app/users/organizer/event/categories/categories.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"label +\' category\'\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=name type=text name=name placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.category.name required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group><label for=description ng-bind=\"\'FORM.label.description\' | translate\"></label><textarea class=form-control id=description type=text name=description placeholder=\"{{\'FORM.placeholder.description\' | translate}}\" ng-model=vm.category.description>\n      </textarea></div><div class=form-group ng-class=\"{ \'has-error\': form.color.$dirty && form.color.$invalid }\"><label for=color ng-bind=\"\'FORM.label.color\' | translate\"></label><div class=\"input-group input-group-color\"><span class=input-group-addon><label><input type=color name=selectedColorPicker ng-model=vm.selectedColor ng-change=vm.onChangeSelectedColor(vm.selectedColor)> <span style=\"background-color: {{vm.selectedColor}}\"></span></label></span><input class=form-control type=text name=selectedColorText ng-model=vm.selectedColor placeholder=\"Hex code\" ng-change=vm.onChangeSelectedColor(vm.selectedColor)></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button data-dismiss=modal ng-click=handleCancel() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/organizer/event/categories/categories.html","<div ng-controller=\"OrganizerCategoriesController as vm\" ng-init=onInit()><div class=clearfix ng-if=eventStatus><button class=\"btn btn-info pull-right\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.addCategory\' | translate\"></button></div><table class=table ng-if=\"vm.categories.length != 0\"><thead><tr><th class=cell-color></th><th ng-bind=\"\'TABLE.name\' | translate\"></th><th ng-bind=\"\'TABLE.description\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\" ng-if=eventStatus></th></tr></thead><tbody><tr ng-repeat=\"category in vm.categories | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\"><td class=cell-color><span class=color-circle ng-style=\"{\'background-color\': category.preferences.color}\"></span></td><td ng-bind=category.name></td><td ng-bind=category.description></td><td ng-if=eventStatus><button class=\"btn btn-default\" type=button ng-click=handleEdit(category) ng-bind=\"\'BUTTON.edit\' | translate\"></button> <button class=\"btn btn-danger\" type=button ng-click=handleDelete(category) ng-bind=\"\'BUTTON.delete\' | translate\"></button></td></tr></tbody></table><ul ng-if=\"vm.categories.length > currentEvent.preferences.itemsPerPage && vm.categories.length != 0\" uib-pagination total-items=vm.categories.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage direction-links=false></ul></div>");
$templateCache.put("app/users/organizer/event/donations/donations.html","<div ng-controller=\"OrganizerDontationsController as vm\" ng-init=onInit()><div class=clearfix ng-if=eventStatus style=\"margin-bottom: 16px\"><button class=\"btn btn-primary btn-sm pull-left\" type=button ng-if=vm.donations.length ng-click=handleDownload() ng-disabled=loadingFile><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button> <button class=\"btn btn-info btn-sm pull-right\" type=button ng-click=handleDonation() ng-bind=\"\'BUTTON.getCashDonation\' | translate\"></button></div><div class=\"row row-flex row-16\"><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\" style=\"margin-bottom: 16px\" ng-repeat=\"donate in vm.donations | orderBy: \'-createdOn\' track by $index\"><div class=\"card card-default\"><div class=card-head ng-if=donate.name><h3 class=card-title ng-bind=donate.name></h3></div><div class=card-body><div class=card-group ng-if=donate.email><span class=card-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=card-group-value ng-bind=donate.email title={{donate.email}}></div></div><div class=card-group ng-if=donate.createdOn><div class=card-group-value ng-bind=\"donate.createdOn | dateFormated\"></div></div><div class=card-group ng-if=\"donate.phone && donate.phone.number\"><span class=card-group-label ng-bind=\"\'FORM.label.phone\' | translate\"></span><div class=card-group-value><span ng-bind=\"donate.phone.type +\':&nbsp;\'\"></span> <span ng-bind=\"donate.phone.number | formatPhone\"></span></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.amount\' | translate\"></span><div class=card-group-value ng-bind=\"\'$\'+ donate.amount\"></div></div><div class=card-group ng-if=donate.invoiceStatus><span class=card-group-label ng-bind=\"\'FORM.label.status\' | translate\"></span><div class=card-group-value ng-class=donate.invoiceStatus ng-bind=donate.invoiceStatus></div></div></div><div class=card-foot ng-if=\"donate.invoiceStatus && donate.invoiceStatus != \'\'\"><button class=\"btn btn-info btn-sm\" type=button ng-click=handleTransaction(donate) ng-bind=\"\'BUTTON.transactions\' | translate\"></button></div></div></div></div></div>");
$templateCache.put("app/users/organizer/event/dynamic-pages/dynamic-pages.html","<div ng-controller=\"OrganizerEventDynamicPageController as vm\" ng-init=onInit() style=\"position: relative\"><div class=page-loading ng-if=pageLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><div ng-if=!pageLoading><div class=\"form-group clearfix\"><button class=\"btn btn-info btn-sm | pull-right\" type=button ng-click=handleAddPage() ng-bind=\"\'BUTTON.addPage\' | translate\"></button></div><div ng-if=dynamicPages.length><div class=ct-stacked><ul class=\"nav nav-tabs nav-stacked\"><li ng-repeat=\"page in dynamicPages\" ng-class=\"{\'active\': page === selectedPage }\" ng-if=\"page.id && page.name\" class=nav-item><a href=# class=nav-link ng-bind=page.name ng-click=handleGetPage(page)></a></li></ul><div class=tab-content><div class=no-message ng-if=!selectedPage><i class=\"glyphicon glyphicon glyphicon-file\"></i><h3 ng-bind=\"\'TEXT.noPageSelected\' | translate\"></h3></div><div ng-if=selectedPage><form name=form.formData novalidate><div class=\"row row-8\"><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-success\': copied}\"><label for=pageLink ng-bind=\"\'FORM.label.link\' | translate\"></label><div class=input-group><input type=text class=form-control name=pageLink id=pageLink ng-value=\"tagURL +\'/\'+ selectedPage.tag\" readonly><div class=input-group-btn><button class=\"btn btn-info\" type=button ng-click=onClipBoard() uib-tooltip=\"Copy to clipboard\" tooltip-append-to-body=true tooltip-placement=top><i class=\"glyphicon glyphicon-copy\"></i></button></div></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-if=copied ng-class=\"{\'has-success\': copied}\"><label>&nbsp;</label><div class=help-block style=\"font-size: 12px; padding-top: 4px\">Copied</div></div></div></div><div class=\"row row-8\"><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{\'has-error\': form.formData.pageTag.$invalid && formSubmitted }\"><label for=pageTag><span ng-bind=\"\'FORM.label.tag\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control type=text id=pageTag name=pageTag placeholder=\"{{\'FORM.placeholder.tag\' | translate}}\" ng-model=selectedPage.tag ng-readonly=selectedPage.id required ng-pattern=/^[a-zA-Z\\d\\-\\_]+$/ ><div class=help-block ng-if=formSubmitted ng-messages=form.formData.pageTag.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=pattern ng-bind=\"\'FORM.validation.onlyCharacters\' | translate\"></div></div><p class=\"help-block help-block-default\" ng-bind=\"\'HELP.chouldBeSetOnlyOnce\' | translate\"></p></div><div class=form-group ng-class=\"{\'has-error\': form.formData.pageName.$invalid && formSubmitted }\"><label for=pageName><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control type=text id=pageName name=pageName placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=selectedPage.name required><div class=help-block ng-if=formSubmitted ng-messages=form.formData.pageName.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div></div><text-editor-gallery teg-model=selectedPage.content teg-label=Content teg-required=true teg-name=pageContent teg-form=form.formData teg-submitted=formSubmitted></text-editor-gallery><!-- Create/Update/Delete --><div class=form-group><button class=\"btn btn-primary btn-sm\" type=submit ng-if=!selectedPage.id ng-disabled=formLoading ng-click=onCreatePage(selectedPage) ng-bind=\"\'BUTTON.create\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=submit ng-if=selectedPage.id ng-disabled=formLoading ng-click=onUpdatePage(selectedPage) ng-bind=\"\'BUTTON.update\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" type=button ng-if=selectedPage.id ng-click=onDeletePage(selectedPage) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></form></div></div></div></div><div class=no-message ng-if=!dynamicPages.length><i class=\"glyphicon glyphicon glyphicon-file\"></i><h3 ng-bind=\"\'TEXT.noPages\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/event/financial-report/financial-report.html","<div ng-controller=\"OrganizerFinancialReportController as vm\" ng-init=onInit()><div class=row><div class=\"col-xs-12 col-sm-4\"><h3 style=\"margin-top: 0\" ng-bind=\"\'TITLE.financialReport\' | translate\"></h3><ul class=report-list><li><b ng-bind=vm.total.label></b>:&nbsp; <span ng-bind=\"\'$\'+ vm.total.data\"></span></li><li ng-repeat=\"report in vm.reports\"><span class=color style=\"background-color: {{ report.color }}\"></span> <b ng-bind=report.label></b>:&nbsp; <span ng-bind=\"\'$\'+ report.data\"></span></li></ul></div><div class=\"col-xs-12 col-sm-6\"><canvas id=pie class=\"chart chart-pie\" chart-data=vm.data chart-labels=vm.labels chart-options=options></canvas></div></div></div>");
$templateCache.put("app/users/organizer/event/inventory/inventory.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"label +\' inventory\'\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=type><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=name type=text name=name placeholder=\"{{\'FORM.label.name\' | translate}}\" ng-model=vm.inventory.name required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group><label for=eventZone ng-bind=\"\'FORM.label.eventZone\' | translate\"></label><select class=form-control id=eventZones name=eventZones ng-init=vm.link.eventZones ng-model=vm.link.eventZones ng-options=\"zone as zone.name for zone in vm.eventZones\"><option value=\"\" ng-bind=\"\'FORM.value.chooseZone\' | translate\"></option></select></div><div class=form-group><label for=respZones ng-bind=\"\'FORM.label.responsibilityZone\' | translate\"></label><select class=form-control id=respZones name=respZones ng-init=vm.link.respZones ng-model=vm.link.respZones ng-options=\"zone as zone.description for zone in vm.respZones\"><option value=\"\" ng-bind=\"\'FORM.value.chooseZone\' | translate\"></option></select></div><div class=form-group><label for=users ng-bind=\"\'FORM.label.users\' | translate\"></label><ui-select ng-model=vm.link.users multiple><ui-select-match placeholder=\"{{\'FORM.placeholder.users\' | translate}}\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices refresh=handleUsersSearch($select.search) refresh-delay=0 repeat=\"user in vm.usersSearch | filter: { name: $select.search } | FilterUISelect: vm.link.users\"><span class=ui-select-title ng-bind=user.name></span> <span class=ui-select-describe ng-bind=user.email></span></ui-select-choices></ui-select></div><div class=form-group><label for=groups ng-bind=\"\'FORM.label.userGroups\' | translate\"></label><ui-select ng-model=vm.link.groups multiple><ui-select-match placeholder=\"{{\'FORM.placeholder.userGroups\' | translate}}\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices repeat=\"group in vm.userGroups | filter: { name: $select.search } | FilterUISelect: vm.link.groups\"><span ng-bind=group.name></span></ui-select-choices></ui-select></div><div class=form-group><label for=description ng-bind=\"\'FORM.label.description\' | translate\"></label><textarea class=form-control id=description type=text name=description placeholder=\"{{\'FORM.placeholder.description\' | translate}}\" ng-model=vm.inventory.description>\n      </textarea></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button data-dismiss=modal ng-click=handleCancel() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/organizer/event/inventory/inventory.html","<div ng-controller=\"OrganizerInventoryController as vm\" ng-init=onInit()><div class=clearfix ng-if=eventStatus><button class=\"btn btn-info pull-right\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.addInventory\' | translate\"></button></div><div class=\"row row-flex row-16\" ng-if=\"vm.inventories.length != 0\"><div class=\"col-sm-6 col-md-4 col-lg-3\" style=\"margin-top: 16px\" ng-repeat=\"inventory in vm.inventories | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\"><div class=\"card card-default\"><div class=card-head><h2 class=card-title ng-bind=inventory.name></h2></div><div class=card-body><div ng-repeat=\"link in inventory.links\" ng-if=link.note><div class=card-group ng-if=\"link.type == \'eventZones\'\"><span class=card-group-label ng-bind=\"\'FORM.label.eventZone\' | translate\"></span><div class=card-group-value ng-bind=link.note></div></div><div class=card-group ng-if=\"link.type == \'respZones\'\"><span class=card-group-label ng-bind=\"\'FORM.label.responsibilityZone\' | translate\"></span><div class=card-group-value ng-bind=link.note></div></div><div class=card-group ng-if=\"link.type == \'users\'\"><span class=card-group-label ng-bind=\"\'FORM.label.users\' | translate\"></span><div class=card-group-value ng-bind=link.note></div></div><div class=card-group ng-if=\"link.type == \'groups\'\"><span class=card-group-label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><div class=card-group-value ng-bind=link.note></div></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=card-group-value ng-bind=inventory.description></div></div></div><div class=card-foot ng-if=eventStatus><button class=\"btn btn-default btn-sm\" type=button ng-click=handleEdit(inventory) ng-bind=\"\'BUTTON.edit\' | translate\"></button> <button class=\"btn btn-danger btn-icon btn-sm\" ng-click=handleRemove(inventory) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></div></div></div><ul ng-if=\"vm.inventories.length > currentEvent.preferences.itemsPerPage && vm.inventories.length != 0\" uib-pagination total-items=vm.inventories.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage direction-links=false></ul></div>");
$templateCache.put("app/users/organizer/event/mail-template/mail-template.html","<div ng-controller=\"OrganizerMailTemplateController as vm\" ng-init=onInit()><div class=filter><label class=\"form-group full\"><span class=label ng-bind=\"\'FORM.label.emailTemplate\' | translate\"></span><select class=form-control id=templateName name=templateName ng-model=vm.templateName ng-options=\"template as template.description for template in vm.templates\" ng-change=handleTemplateNameSelect()></select></label></div><div class=row><div class=\"col-xs-12 col-sm-4 col-sm-push-8\"><div ng-if=\"vm.templateData.vars && vm.templateData.vars.length != 0\"><div class=form-group><label for=testEmail ng-bind=\"\'FORM.label.sendTestEmail\' | translate\"></label><input type=email class=form-control placeholder=\"{{\'FORM.placeholder.sendTestEmail\' | translate}}\" name=testEmail ng-model=testEmail></div><div class=form-group><button class=\"btn btn-info btn-sm\" type=button ng-disabled=\"(testEmail === \'\' || !testEmail.length)\" ng-click=handleTestMailSending(testEmail) ng-bind=\"\'BUTTON.testMailSending\' | translate\"></button><p class=\"help-block help-block-default\" style=\"position: relative; text-align: left !important\" ng-bind=\"\'HELP.saveTemplatePrior\' | translate\"></p></div><div class=bg-info ng-if=vm.macroData style=\"padding: 16px; margin-bottom: 16px\" ng-bind=\"\'HELP.insertSelectedMacros\' | translate\"></div><div class=form-group><label ng-bind=\"\'FORM.label.macros\' | translate\"></label><div class=form-group ng-repeat=\"button in vm.templateData.vars track by $index\"><button class=\"btn btn-primary btn-sm\" type=button ng-disabled=\"active === $index\" ng-bind=button.var ng-click=\"getButtonData(button.var, $index)\"></button><p class=\"help-block help-block-default\" style=\"position: relative; text-align: left !important\" ng-bind=button.description></p></div></div><button class=\"btn btn-default\" type=button ng-if=vm.macroData ng-click=clearMacros() ng-bind=\"\'BUTTON.cancel\' | translate\"></button></div></div><div class=\"col-xs-12 col-sm-8 col-sm-pull-4\"><form novalidate name=form><div class=form-group><label for=subject ng-bind=\"\'FORM.label.subject\' | translate\"></label><input class=form-control id=subject type=text name=subject placeholder=\"{{\'FORM.placeholder.subject\' | translate}}\" ng-model=vm.templateData.subject ng-focus=handleFocusElement()></div><div class=form-group><label for=template ng-bind=\"\'FORM.label.body\' | translate\"></label><text-angular ng-model=vm.templateData.template name=template ng-click=setDataOnCursorPosition() ta-toolbar=taToolbar></text-angular></div><div class=form-group ng-if=eventStatus><button class=\"btn btn-primary\" type=submit ng-disabled=!form.$valid ng-click=handleSubmit() ng-bind=\"\'BUTTON.update\' | translate\"></button></div></form></div></div></div>");
$templateCache.put("app/users/organizer/event/k2-templates/form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h4 class=modal-title>Template form</h4></div><div class=modal-body><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-9\"><div class=form-group ng-class=\"{ \'has-error\': form.notificationType.$invalid && form.$submitted }\"><label for=notificationType>Template type<span>&nbsp;*</span></label><select class=\"form-control input-sm\" name=notificationType id=notificationType ng-model=template.notificationType required><option value=\"\">Choose type</option><option value=daily>Daily</option><option value=arrival>Arrival</option><option value=departure>Departure</option></select><div class=help-block ng-if=form.$submitted ng-messages=form.notificationType.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=\"row row-8\" ng-if=\"template.notificationType && template.notificationType !== \'daily\'\"><div class=col-xs-12 ng-class=\"{\'col-sm-6\': template.notificationTimeType }\"><div class=form-group><label for=notificationTimeType>Time offset</label><select class=\"form-control input-sm\" name=notificationTimeType id=notificationTimeType ng-model=template.notificationTimeType><option value=\"\">Same day</option><option value=before>Before</option><option value=after>After</option></select></div></div><div class=col-xs-12 ng-if=template.notificationTimeType ng-class=\"{\'col-sm-6\': template.notificationTimeType }\"><div class=form-group ng-class=\"{ \'has-error\': form.daysNumber.$invalid && form.$submitted }\"><label for=daysNumber>Days<span>&nbsp;*</span></label><input type=number class=\"form-control input-sm\" name=daysNumber id=daysNumber min=1 placeholder=Days ng-model=template.daysNumber required><div class=help-block ng-if=form.$submitted ng-messages=form.daysNumber.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div><div ng-message=min ng-bind=\"\'Min value 1\'\"></div></div></div></div></div></div></div><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-9\"><div class=form-group ng-class=\"{ \'has-error\': form.smsText.$invalid && form.$submitted }\"><label for=smsText>SMS text<span>&nbsp;*</span></label><textarea class=\"form-control input-sm\" name=smsText id=smsText ng-model=template.smsText rows=5 placeholder=\"SMS text\" ng-focus=\"handleFocusControl(\'smsText\')\" required></textarea><div class=help-block ng-if=form.$submitted ng-messages=form.smsText.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><hr><div class=form-group ng-class=\"{ \'has-error\': form.emailSubject.$invalid && form.$submitted }\"><label for=emailSubject>E-mail subject<span>&nbsp;*</span></label><input type=text class=\"form-control input-sm\" name=emailSubject id=emailSubject placeholder=\"E-mail subject\" ng-model=template.emailSubject ng-focus=\"handleFocusControl(\'emailSubject\')\" required><div class=help-block ng-if=form.$submitted ng-messages=form.emailSubject.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><!-- <div class=\"form-group\"\n            ng-class=\"{ \'has-error\': form.emailBody.$invalid && form.$submitted }\">\n          <label for=\"emailBody\">E-mail body<span>&nbsp;*</span></label>\n          <textarea class=\"form-control input-sm\"\n                    name=\"emailBody\"\n                    id=\"emailBody\"\n                    ng-model=\"template.emailBody\"\n                    rows=\"5\"\n                    placeholder=\"E-mail body\"\n                    ng-focus=\"handleFocusControl(\'emailBody\')\"\n                    required></textarea>\n          <div class=\"help-block\"  ng-if=\"form.$submitted\" ng-messages=\"form.emailBody.$error\" role=\"alert\">\n            <div ng-message=\"required\" ng-bind=\"\'FORM.validation.required\' | translate\"></div>\n          </div>\n        </div> --><text-editor-gallery teg-name=emailBody teg-label=\"E-mail body\" teg-model=template.emailBody teg-required=true teg-form=form teg-submitted=form.$submitted teg-click=handleClickCursorPosition()></text-editor-gallery></div><div class=\"col-xs-12 col-sm-3\"><div class=form-group><label for=\"\" ng-bind=\"\'FORM.label.macros\' | translate\"></label><div ng-if=macroses.length><div class=bg-info style=\"padding: 8px; margin-bottom: 16px; font-size: 14px\" ng-if=vm.selectedMacrosValue ng-bind=\"\'HELP.insertSelectedMacros\' | translate\"></div><div class=form-group ng-repeat=\"macros in macroses track by $index\"><button class=\"btn btn-primary btn-sm btn-block\" type=button ng-disabled=\"vm.selectedMacrosIndex === $index\" ng-bind=macros.value ng-click=\"handleClickMacros(macros.value, $index)\"></button><p class=\"help-block help-block-default\" style=\"position: relative; text-align: left !important\" ng-bind=macros.description></p></div><button class=\"btn btn-default btn-sm\" type=button ng-if=\"vm.selectedMacrosIndex > -1 && vm.selectedMacrosValue\" ng-click=handleClickClearMacros() ng-bind=\"\'BUTTON.cancel\' | translate\"></button></div><div ng-if=\"macroses.length === 0\" ng-bind=\"\'No macros availabel\'\"></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button ng-click=handleCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.submit\' | translate\"></span></button></div></form>");
$templateCache.put("app/users/organizer/event/k2-templates/k2-templates.html","<div ng-controller=\"OrganizerEventK2TemplatesController as vm\" ng-init=onInit()><div ng-if=pageLoading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!pageLoading><div class=\"form-group clearfix\"><button class=\"btn btn-info btn-sm | pull-right\" ng-click=handleCreateTemplate()>Create template</button> <button class=\"btn btn-info btn-sm | pull-right\" style=\"margin-right: 8px\" ng-click=handleOneTimeNotification()>One time notification</button></div><div class=\"row row-flex row-16\" ng-if=templates.length><div class=\"col-sm-6 col-md-4 col-lg-3\" style=\"margin-bottom: 16px\" ng-repeat=\"template in templates\"><div class=\"card card-default\"><div class=card-body><div class=card-group style=\"margin-top: 0\"><span class=card-group-label ng-bind=\"\'Schedule\'\"></span><div ng-if=\"template.notificationType === \'daily\'\" ng-bind=\"\'Daily\'\"></div><div ng-if=\"\n                    (\n                      template.notificationType === \'arrival\' ||\n                      template.notificationType === \'departure\'\n                    ) && \n                    !template.notificationTimeType\n                   \" ng-bind=\"\'Day of \'+ template.notificationType\"></div><div ng-if=\"\n                   (\n                     template.notificationType === \'arrival\' ||\n                     template.notificationType === \'departure\'\n                   ) && \n                   template.notificationTimeType\n                  \" ng-bind=\"\n                    template.daysNumber +\' day(s) \'+ template.notificationTimeType +\' \'+ template.notificationType\n                  \"></div></div></div><div class=card-foot ng-if=eventStatus><button class=\"btn btn-default btn-sm\" ng-click=handleUpdateTemplate(template) ng-bind=\"\'BUTTON.edit\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" ng-click=handleDeleteTemplate(template) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></div></div></div><div class=no-message ng-if=\"templates.length === 0\"><i class=\"fa fa-newspaper-o\" aria-hidden=true></i><h3 ng-bind=\"\'No template(s)\'\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/event/k2-templates/one-time.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h4 class=modal-title>One time notification</h4></div><div class=modal-body><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-9\"><div class=form-group><label for=\"\">Users<span>&nbsp;*</span></label><div ng-if=usersLoading class=text-center><i class=\"fa fa-spinner fa-spin fa-2x\" aria-hidden=true></i></div><input type=hidden ng-model=template.users name=templateUsers required><div ng-if=!usersLoading><div class=\"row row-8\"><div class=col-xs-12><div class=checkbox><label for=checkAll><input type=checkbox id=checkAll ng-model=checkAll ng-click=handleCheckAll(checkAll)> <span ng-bind=\"\'Check all\'\"></span></label></div></div><div class=\"col-xs-12 col-sm-4\"><div class=\"form-group form-group-datepicker\"><label style=\"line-height: 1\" ng-bind=\"\'FORM.label.search\' | translate\"></label><input type=text class=\"form-control input-sm\" name=search ng-model=vm.filterSearch ng-change=handleChangeSearch(vm.filterSearch) ng-model-options=\"{debounce: 1000}\" placeholder=\"{{\'FORM.placeholder.search\' | translate }}\"></div></div><div class=\"col-xs-12 col-sm-3\"><label class=\"form-group form-group-datepicker\"><span class=label ng-bind=\"\'Start date\'\"></span><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default btn-sm\" type=button ng-click=onPopup1Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=\"form-control input-sm\" type=text name=startDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=vm.startDate ng-change=\"handleStartDate(vm.startDate, vm.endDate)\" is-open=popup1.opened datepicker-options=startDateOptions show-button-bar=false readonly></div></label></div><div class=\"col-xs-12 col-sm-3\"><label class=\"form-group form-group-datepicker\"><span class=label ng-bind=\"\'End date\'\"></span><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default btn-sm\" type=button ng-click=onPopup2Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=\"form-control input-sm\" type=text name=endDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=vm.endDate is-open=popup2.opened datepicker-options=endDateOptions show-button-bar=false readonly></div></label></div><div class=\"col-xs-12 col-sm-2\"><div class=form-group><label for=\"\" style=\"line-height: 1\">&nbsp;</label><button class=\"btn btn-primary btn-sm btn-block\" type=button ng-click=handleApply() ng-bind=\"\'Apply\'\"></button></div></div></div><div ng-if=users.length style=\"max-height: 200px; overflow-y: auto\"><div class=checkbox ng-repeat=\"user in users | FilterSearchBy: vm.filterSearch track by $index\"><label for=\"{{\'users\'+ user.Id}}\"><input type=checkbox id=\"{{\'users\'+ user.Id}}\" ng-click=handleUsers(user) ng-checked=user.checked> {{user.FirstName +\' \'+ user.LastName}} ({{user.Email}})</label></div></div><h4 ng-if=\"users.length === 0\" class=text-center ng-bind=\"\'No users found\'\"></h4></div><div class=form-group style=\"margin-bottom: 0\" ng-class=\"{ \'has-error\': template.users.length === 0 && form.$submitted }\"><div class=help-block style=\"position: relative\" ng-if=\"template.users.length === 0 && form.$submitted\" role=alert ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div></div><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-9\"><div class=form-group ng-class=\"{ \'has-error\': form.smsText.$invalid && form.$submitted }\"><label for=smsText>SMS text<span>&nbsp;*</span></label><textarea class=\"form-control input-sm\" name=smsText id=smsText ng-model=template.smsText rows=5 placeholder=\"SMS text\" ng-focus=\"handleFocusControl(\'smsText\')\" required></textarea><div class=help-block ng-if=form.$submitted ng-messages=form.smsText.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><hr><div class=form-group ng-class=\"{ \'has-error\': form.emailSubject.$invalid && form.$submitted }\"><label for=emailSubject>E-mail subject<span>&nbsp;*</span></label><input type=text class=\"form-control input-sm\" name=emailSubject id=emailSubject placeholder=\"E-mail subject\" ng-model=template.emailSubject ng-focus=\"handleFocusControl(\'emailSubject\')\" required><div class=help-block ng-if=form.$submitted ng-messages=form.emailSubject.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><!-- <div class=\"form-group\"\n            ng-class=\"{ \'has-error\': form.emailBody.$invalid && form.$submitted }\">\n          <label for=\"emailBody\">E-mail body<span>&nbsp;*</span></label>\n          <textarea class=\"form-control input-sm\"\n                    name=\"emailBody\"\n                    id=\"emailBody\"\n                    ng-model=\"template.emailBody\"\n                    rows=\"5\"\n                    placeholder=\"E-mail body\"\n                    ng-focus=\"handleFocusControl(\'emailBody\')\"\n                    required></textarea>\n          <div class=\"help-block\"  ng-if=\"form.$submitted\" ng-messages=\"form.emailBody.$error\" role=\"alert\">\n            <div ng-message=\"required\" ng-bind=\"\'FORM.validation.required\' | translate\"></div>\n          </div>\n        </div> --><text-editor-gallery teg-name=emailBody teg-label=\"E-mail body\" teg-model=template.emailBody teg-required=true teg-form=form teg-submitted=form.$submitted teg-click=handleClickCursorPosition()></text-editor-gallery></div><div class=\"col-xs-12 col-sm-3\"><div class=form-group><label for=\"\" ng-bind=\"\'FORM.label.macros\' | translate\"></label><div ng-if=macroses.length><div class=bg-info style=\"padding: 8px; margin-bottom: 16px; font-size: 14px\" ng-if=vm.selectedMacrosValue ng-bind=\"\'HELP.insertSelectedMacros\' | translate\"></div><div class=form-group ng-repeat=\"macros in macroses track by $index\"><button class=\"btn btn-primary btn-sm btn-block\" type=button ng-disabled=\"vm.selectedMacrosIndex === $index\" ng-bind=macros.value ng-click=\"handleClickMacros(macros.value, $index)\"></button><p class=\"help-block help-block-default\" style=\"position: relative; text-align: left !important\" ng-bind=macros.description></p></div><button class=\"btn btn-default btn-sm\" type=button ng-if=\"vm.selectedMacrosIndex > -1 && vm.selectedMacrosValue\" ng-click=handleClickClearMacros() ng-bind=\"\'BUTTON.cancel\' | translate\"></button></div><div ng-if=\"macroses.length === 0\" ng-bind=\"\'No macros availabel\'\"></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button ng-click=handleCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=submit ng-disabled=\"formLoading || usersLoading\"><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.submit\' | translate\"></span></button></div></form>");
$templateCache.put("app/users/organizer/event/media-gallery/360-modal.html","<style>#panorama {\n    width: 100%;\n    height: 400px;\n  }</style><div ng-init=onInit()><div class=modal-header style=\"padding: 4px 15px\"><button type=button class=close data-dismiss=modal aria-label=Close ng-click=handleClose()><span aria-hidden=true>&times;</span></button><h4 class=modal-title ng-bind=resolveMedia.originalFilename></h4></div><div class=modal-body><div id=panorama></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.close\' | translate\"></button></div></div>");
$templateCache.put("app/users/organizer/event/media-gallery/media-gallery.html","<div ng-controller=\"OrganizerEventMediaGalleryController as vm\" ng-init=onInit()><div ng-if=pageLoading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!pageLoading><!-- Upload media --><div class=form-group><div class=clearfix><label class=\"btn btn-info btn-sm | btn-upload | pull-right\" ng-class=\"{\'disabled\': uploadMediaDisabled }\"><input type=file name=uploadMedia id=uploadMedia accept=image/* multiple onchange=\"angular.element(this).scope().handleUploadMedia(event, \'image_360\')\" ng-disabled=uploadMediaDisabled> <span>Upload image 360</span></label><label class=\"btn btn-info btn-sm | btn-upload | pull-right\" style=\"margin-right: 4px\" ng-class=\"{\'disabled\': uploadMediaDisabled }\"><input type=file name=uploadMedia id=uploadMedia accept=image/* multiple onchange=\"angular.element(this).scope().handleUploadMedia(event, \'image\')\" ng-disabled=uploadMediaDisabled> <span>Upload image</span></label></div><span class=\"help-block help-block-default\" style=\"position: relative; margin-bottom: 0 !important; text-align: right !important; display: block\" ng-bind=\"\'( Image 360 size shouldn`t exceed 4096px )\'\"></span></div><!-- Uploaded media list --><div class=modal-gallery ng-if=\"mediaList.length !== 0 || uploadMediaLoading\"><div class=modal-gallery-item ng-repeat=\"media in mediaList\" ng-class=\"{\'_selected\': selectedMediaList.indexOf(media) > -1}\"><img ng-src=\"{{media.type === \'image\' ? media.link : \'assets/images/360-icon.png\'}}\" alt=\"{{ media.originalFilename }}\"><!-- Media item actions --><div class=_actions><button class=\"btn btn-default btn-sm\" type=button ng-disabled=uploadMediaDisabled ng-click=handlePreview(media) ng-if=\"media.type === \'image_360\'\" uib-tooltip=\"Preview image 360\" tooltip-placement=bottom tooltip-append-to-body=true><i class=\"fa fa-eye\" aria-hidden=true></i></button><!-- Delete --> <button class=\"btn btn-danger btn-sm\" type=button ng-disabled=uploadMediaDisabled ng-click=handleDeleteMedia(media) uib-tooltip=\"Delete image\" tooltip-placement=bottom tooltip-append-to-body=true><i class=\"fa fa-trash\" aria-hidden=true></i></button></div></div><div class=modal-gallery-upload ng-if=uploadMediaLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div></div><div class=no-message ng-if=\"mediaList.length === 0 && !uploadMediaLoading\"><i class=\"fa fa-picture-o\" aria-hidden=true></i><h3 ng-bind=\"\'TEXT.noMedia\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/event/prices/prices.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"label +\' price package\'\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.type.$invalid && formSubmitted }\"><label for=type><span ng-bind=\"\'FORM.label.type\' | translate\"></span> <span>&nbsp;*</span></label><select class=form-control id=type name=type ng-model=vm.price.type ng-disabled=vm.price.id required><option value=\"\" ng-bind=\"\'FORM.value.chooseType\' | translate\"></option><option value=booth ng-bind=\"\'FORM.value.booth\' | translate\"></option><option ng-if=\"currentEvent.modules.indexOf(\'participant\') > -1\" value=participation ng-bind=vm.participantModule.label></option><option ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" value=sponsor ng-bind=vm.sponsorModule.label></option></select><div class=help-block ng-if=formSubmitted ng-messages=form.type.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div><div class=\"help-block help-block-default\" ng-if=vm.price.id ng-bind=\"\'HELP.pricePackageTypeSet\' | translate\"></div></div><!-- maxAttendants --><div class=form-group ng-if=\"vm.price.type === \'sponsor\'\" ng-class=\"{ \'has-error\': form.maxAttendants.$invalid && formSubmitted }\"><label for=maxAttendants><span ng-bind=\"\'FORM.label.maxAttendants\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=maxAttendants type=number name=maxAttendants placeholder=\"{{\'FORM.placeholder.maxAttendants\' | translate}}\" ng-model=vm.price.preferences.maxAttendants min=0 ng-required=\"vm.price.type === \'sponsor\'\"><div class=help-block ng-if=formSubmitted ng-messages=form.maxAttendants.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div><div class=help-block ng-bind=\"\'HELP.zeroNotAllowedAttendants\' | translate\"></div></div><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=name type=text name=name placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.price.name required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=\"row row-8\"><div ng-class=\"{\'col-xs-3\': vm.price.type !== \'booth\', \'col-xs-6\': vm.price.type === \'booth\'}\"><div class=form-group ng-class=\"{ \'has-error\': form.price.$invalid && formSubmitted }\"><label for=price><span ng-bind=\"\'FORM.label.price\' | translate\"></span> <span>&nbsp;*</span></label><div class=input-group><div class=input-group-addon>&#36;</div><input class=form-control id=price name=price type=number placeholder=\"{{\'FORM.placeholder.price\' | translate}}\" ng-model=vm.price.price required></div><div class=help-block ng-if=formSubmitted ng-messages=form.price.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=col-xs-3 ng-if=\"vm.price.type !== \'booth\'\"><div class=form-group ng-class=\"{ \'has-error\': form.priceMaxAvailable.$invalid && formSubmitted }\"><label for=priceMaxAvailable ng-bind=\"\'FORM.label.maxAvailable\' | translate\"></label><input class=form-control id=priceMaxAvailable type=number name=priceMaxAvailable placeholder=\"Max available\" ng-model=vm.price.maxAvailable><div class=help-block style=\"color: #737373; font-size: 12px\" ng-bing=\"\'HELP.zeroMeansUnlimited\' | translate\"></div><div class=help-block ng-if=formSubmitted ng-messages=form.priceMaxAvailable.$error role=alert><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div><div class=col-xs-4 ng-if=\"vm.price.type !== \'booth\'\"><div class=form-group><label for=limitPerPerson>Limit per person</label><input class=form-control id=limitPerPerson name=limitPerPerson type=number placeholder=\"Limit per person\" ng-model=vm.price.limitPerPerson></div></div><div ng-class=\"{\'col-xs-2\': vm.price.type !== \'booth\', \'col-xs-6\': vm.price.type === \'booth\'}\"><div class=form-group><label for=order>Order</label><input class=form-control id=order name=order type=number placeholder=Order ng-model=vm.price.order></div></div></div><div class=form-group ng-if=\"vm.price.type == \'participation\' || vm.price.type == \'sponsor\'\"><label for=promocode ng-bind=\"\'FORM.label.promocode\' | translate\"></label><div class=input-group><input type=text class=form-control id=promocode name=promoCode placeholder=\"{{\'FORM.label.promocode\' | translate}}\" ng-model=vm.price.promoCode> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=onGeneratePromocode() ng-bind=\"\'BUTTON.generate\' | translate\"></button></span></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=enabled ng-model=vm.price.enabled> <span ng-bind=\"\'FORM.label.enabled\' | translate\"></span></label></div><div class=checkbox><label><input type=checkbox name=invoiceDueDate ng-model=vm.invoiceDueDate> <span ng-bind=\"\'FORM.label.paymentDueDate\' | translate\"></span></label></div></div><div ng-if=vm.invoiceDueDate><div class=form-group ng-class=\"{ \'has-error\': form.startDate.$invalid && formSubmitted }\"><label for=date><span ng-bind=\"\'FORM.label.date\' | translate\"></span> <span>&nbsp;*</span></label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=handleDatepickerPopup()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=startDate ng-model=vm.startDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=datepickerPopup.opened show-button-bar=false ng-required=vm.invoiceDueDate></div><div class=help-block ng-if=formSubmitted ng-messages=form.startDate.$error role=alert><div ng-message=date ng-bind=\"\'FORM.validation.invalidDate\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.startTime.$invalid && formSubmitted }\"><label for=startTime><span ng-bind=\"\'FORM.label.time\' | translate\"></span> <span>&nbsp;*</span></label><div uib-timepicker ng-model=vm.startTime name=startTime ng-change=changed() show-meridian=true ng-required=vm.invoiceDueDate></div><div class=help-block ng-if=formSubmitted ng-messages=form.startTime.$error role=alert><div ng-message=time ng-bind=\"\'FORM.validation.invalidTime\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><!-- <div class=\"form-group\" ng-if=\"vm.price.type !== \'booth\'\"> --><div class=checkbox ng-if=\"vm.price.type !== \'booth\'\"><label><input type=checkbox name=showUnsoldCount ng-model=vm.price.preferences.showUnsoldCount> <span ng-bind=\"\'FORM.label.showUnsoldCount\' | translate\"></span></label></div><!-- </div> --><div class=checkbox ng-if=\"vm.price.type === \'participation\'\"><label><input type=checkbox name=purchaseOnBehalfEnabled ng-model=vm.price.preferences.purchaseOnBehalfEnabled> <span ng-bind=\"\'Purchase on behalf\'\"></span></label></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button data-dismiss=modal ng-click=handleCancel() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/organizer/event/prices/prices.html","<div ng-controller=\"OrganizerPricesController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoEventPricePackageSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=pricePackageSearch ng-model-options=\"{debounce: 1000}\"></label><label class=form-group><span class=label ng-bind=\"\'FORM.label.type\' | translate\"></span><select class=form-control ng-model=searchType><option value=\"\" ng-bind=\"\'FORM.value.chooseType\' | translate\"></option><option value=booth ng-bind=\"\'FORM.value.booth\' | translate\"></option><option ng-if=\"currentEvent.modules.indexOf(\'participant\') > -1\" value=participation ng-bind=vm.participantModule.label></option><option ng-if=\"currentEvent.modules.indexOf(\'sponsor\') > -1\" value=sponsor ng-bind=vm.sponsorModule.label></option></select></label></div><div class=clearfix ng-if=eventStatus style=\"margin-bottom: 24px\"><button class=\"btn btn-info pull-right\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.addPricePackage\' | translate\"></button></div><div class=\"row row-flex row-16\" ng-if=\"vm.filterPrices.length != 0\"><div class=\"col-sm-6 col-md-4 col-lg-3\" style=\"margin-top: 32px\" ng-repeat=\"price in vm.filterPricePackages = (\n            vm.pricePackages\n            | filter: filterPricePackageSearch\n            | filter: { type: searchType }\n          )\n            | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\n          \"><div class=\"card card-default\"><div class=card-head><h3 class=card-title ng-bind=price.name></h3><span class=card-label ng-class=price.type ng-bind=\"\n                  price.type === \'participation\' ? vm.participantModule.label : price.type === \'sponsor\' ? vm.sponsorModule.label : price.type\n                | lowercase\"></span></div><div class=card-body><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-3\"><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.price\' | translate\"></span> <span class=card-group-value ng-bind=\"price.price == \'0\' ? \'Free\' : \'&#36;\' + price.price\"></span></div></div><div class=\"col-xs-12 col-sm-9\" ng-if=price.invoiceDueDate><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.dueDate\' | translate\"></span> <span class=card-group-value ng-bind=\"price.invoiceDueDate | dateFormated\"></span></div></div></div><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-6\" ng-if=\"price.order > 0\"><div class=card-group><span class=card-group-label ng-bind=\"\'Order\'\"></span><div class=card-group-value ng-bind=price.order></div></div></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.enabled\' | translate\"></span> <span class=card-group-value ng-bind=\"price.enabled ? \'Yes\' : \'No\'\"></span></div></div><div class=col-xs-6 ng-if=\"price.type === \'participation\'\"><div class=card-group><span class=card-group-label ng-bind=\"\'Purchase on behalf\'\"></span> <span class=card-group-value ng-bind=\"price.preferences.purchaseOnBehalfEnabled ? \'Yes\' : \'No\'\"></span></div></div></div><div class=\"row row-16\"><div class=col-xs-6 ng-if=\"price.type !== \'booth\' && price.maxAvailable\"><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.maxAvailable\' | translate\"></span> <span class=card-group-value ng-bind=price.maxAvailable></span></div></div><div class=col-xs-6><div class=card-group ng-if=\"price.type !== \'booth\' && price.limitPerPerson\"><span class=card-group-label ng-bind=\"\'Limit per person\'\"></span> <span class=card-group-value ng-bind=price.limitPerPerson></span></div></div></div><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-6\" ng-if=\"price.type !== \'booth\' && (price.maxAvailable !== 0 && !!price.maxAvailable)\"><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.soldout\' | translate\"></span><div class=card-group-value ng-bind=\"price.soldout ? \'Yes\' : \'No\'\"></div></div></div><div class=\"col-xs-12 col-sm-6\" ng-if=\"price.type !== \'booth\'\"><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.showUnsoldCount\' | translate\"></span><div class=card-group-value ng-bind=\"price.preferences.showUnsoldCount ? \'Yes\' : \'No\'\"></div></div></div></div><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-6\" ng-if=\"price.type === \'sponsor\' && price.preferences.maxAttendants >= 0\"><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.maxAttendants\' | translate\"></span><div class=card-group-value ng-bind=price.preferences.maxAttendants></div></div></div></div><div class=card-group ng-if=price.promoCode><span class=card-group-label ng-bind=\"\'FORM.label.promocode\' | translate\"></span> <span class=card-group-value ng-bind=price.promoCode></span></div></div><div class=card-foot ng-if=eventStatus><button class=\"btn btn-default btn-sm\" type=button ng-click=handleEdit(price) ng-bind=\"\'BUTTON.edit\' | translate\"><button class=\"btn btn-danger btn-icon btn-sm\" ng-click=handleDelete(price) ng-bind=\"\'BUTTON.delete\' | translate\"></button></button></div></div></div></div><div class=total style=\"margin-top: 16px\"><div class=total-label ng-if=\"vm.filterPricePackages.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterPricePackages.length > currentEvent.preferences.itemsPerPage && vm.filterPricePackages.length != 0\" uib-pagination total-items=vm.filterPricePackages.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div>");
$templateCache.put("app/users/organizer/event/schedule/schedule-form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"vm.label +\' record\'\"></h3></div><div class=modal-body><div class=form-group ng-if=\"currentUser.type === \'eo\'\"><label for=userType ng-bind=\"\'User type\'\"></label><select class=\"form-control input-sm\" name=userType id=userType ng-model=vm.schedule.userType><option value=\"\">Visitor</option><option ng-repeat=\"data in userTypes track by $index\" ng-value=data.type ng-bind=data.label></option></select></div><div class=form-group><label for=location ng-bind=\"\'FORM.label.location\' | translate\"></label><ui-select ng-model=vm.schedule.location><ui-select-match placeholder=\"{{\'FORM.placeholder.chooseOrAddLocation\' | translate}}\"><span>{{$select.selected.name || $select.search}}</span></ui-select-match><ui-select-choices repeat=\"location.name as location in locations\" refresh=refreshResults($select) refresh-delay=0><span ng-bind=location.name></span></ui-select-choices></ui-select></div><div class=form-group ng-class=\"{ \'has-error\': form.description.$invalid && formSubmitted }\"><label for=description><span ng-bind=\"\'FORM.label.description\' | translate\"></span> <span>&nbsp;*</span></label><textarea class=form-control id=description name=description placeholder=\"{{\'FORM.placeholder.description\' | translate}}\" rows=4 maxlength=255 ng-model=vm.schedule.description required>\n      </textarea><div class=\"help-block help-block-default\">{{(vm.schedule.description.length || 0) +\'/255\'}}</div><div class=help-block ng-if=formSubmitted ng-messages=form.description.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{\'has-error\': form.scheduleStartDate.$invalid && formSubmitted }\"><label for=scheduleStartDate><span ng-bind=\"\'FORM.label.date\' | translate\"></span> <span>&nbsp;*</span></label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=onPopup1Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=scheduleStartDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=vm.scheduleStartDate is-open=popup1.opened datepicker-options=scheduleDateOptions show-button-bar=false ng-disabled=!eventStatus ng-required=true></div><!-- <div class=\"help-block\" ng-if=\"vm.startDateError\" role=\"alert\"\n            ng-bind=\"\'FORM.validation.scheduleCantBeMoreOrLessThanEvent\' | translate\"></div> --><div class=help-block ng-if=formSubmitted ng-messages=form.scheduleStartDate.$error role=alert><div ng-message=date ng-bind=\"\'FORM.validation.date\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=row><div class=col-xs-6><div class=form-group ng-class=\"{\'has-error\': form.scheduleStartTimeC.$invalid && formSubmitted }\"><label for=scheduleStartTime><span ng-bind=\"\'FORM.label.startTime\' | translate\"></span> <span>&nbsp;*</span></label><input type=time ng-model=vm.scheduleStartTimeC name=scheduleStartTimeC max={{vm.scheduleEndTime}} required class=hidden><div uib-timepicker ng-model=vm.scheduleStartTime ng-disabled=!eventStatus name=scheduleStartTime ng-change=\"vm.scheduleStartTimeC = vm.scheduleStartTime\" show-meridian=true required></div><div class=help-block ng-if=formSubmitted ng-messages=form.scheduleStartTimeC.$error role=alert><div ng-message=time ng-bind=\"\'FORM.validation.time\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=max ng-bind=\"\'FORM.VALIDATION.START_TIME_IS_GREATER_THAN_END\' | translate\"></div></div></div></div><div class=col-xs-6><div class=form-group ng-class=\"{\'has-error\': form.scheduleEndTimeC.$invalid && formSubmitted }\"><label for=scheduleEndTime><span ng-bind=\"\'FORM.label.endTime\' | translate\"></span> <span>&nbsp;*</span></label><input type=time ng-model=vm.scheduleEndTimeC name=scheduleEndTimeC min={{vm.scheduleStartTime}} required class=hidden><div uib-timepicker ng-model=vm.scheduleEndTime ng-disabled=!eventStatus name=scheduleEndTime ng-change=\"vm.scheduleEndTimeC = vm.scheduleEndTime\" show-meridian=true required></div><div class=help-block ng-if=formSubmitted ng-messages=form.scheduleEndTimeC.$error role=alert><div ng-message=time ng-bind=\"\'FORM.validation.time\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div></div><!-- <div class=\"form-group has-error\" ng-if=\"vm.outOfEventDateRange\">\n      <div class=\"help-block\" role=\"alert\" ng-bind=\"\'FORM.validation.exceedEventDateTIme\' | translate\"></div>\n    </div> --></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=vm.loading class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.schedule\' | translate\"></span></button></div></form>");
$templateCache.put("app/users/organizer/event/schedule/schedule.html","<div ng-controller=\"OrganizerScheduleController as vm\" ng-init=onInit()><div class=\"clearfix form-group\" ng-if=eventStatus><div class=pull-left ng-if=\"currentUser.type === \'eo\'\"><select class=\"form-control input-sm\" name=filterUserType id=filterUserType ng-model=filterUserType ng-change=handleChangeUserType(filterUserType)><option value=\"\">Visitor</option><option ng-repeat=\"data in userTypes track by $index\" ng-value=data.type ng-bind=data.label></option></select></div><button class=\"btn btn-info btn-sm | pull-right\" type=button ng-click=onAddSchedule() ng-bind=\"\'Add record\'\"></button></div><div class=eo-slick-schedule ng-if=\"vm.program && vm.program.length !== 0\"><div class=\"slick-item slickItemProgram\" ng-repeat=\"program in vm.program track by $index\"><h3><span ng-bind=program.date></span> <span style=\"display: block; font-size: 14px; font-weight: 400; line-height: 1.2\" ng-bind=\"moment(program.date).format(\'dddd\')\"></span></h3><!-- Locations --><ul ng-if=\"program.locations && program.locations.length !== 0\" class=location-list style=\"overflow-y: auto\"><li ng-repeat=\"location in program.locations | orderBy:\'name\' track by $index\"><h3 ng-if=location.name ng-bind=location.name></h3><hr ng-if=!location.name><!-- Schedules --><ul ng-if=\"location.schedules && location.schedules.length !== 0\" class=schedule-list><li ng-repeat=\"schedule in location.schedules | orderBy:\'start\' track by $index\"><p><b ng-bind=formatTime(schedule.start)></b> &nbsp;-&nbsp; <b ng-bind=formatTime(schedule.end)></b></p><p ng-bind=schedule.description></p><div style=\"padding-top: 8px; text-align: right\"><button class=\"btn btn-success btn-sm\" type=button ng-click=onUpdateSchedule(schedule) uib-tooltip=\"{{\'BUTTON.edit\' | translate}}\" tooltip-placement=top><i class=\"glyphicon glyphicon-pencil\"></i></button> <button class=\"btn btn-danger btn-sm\" type=button ng-click=onRemoveSchedule(schedule) uib-tooltip=\"{{\'BUTTON.delete\' | translate}}\" tooltip-placement=top><i class=\"glyphicon glyphicon-trash\"></i></button></div></li></ul></li></ul><!-- Schedules --><ul ng-if=\"program.schedules && program.schedules.length !== 0\" class=schedule-list style=\"overflow-y: auto\"><li ng-repeat=\"schedule in program.schedules | orderBy:\'start\' track by $index\"><p><b ng-bind=formatTime(schedule.start)></b> &nbsp;-&nbsp; <b ng-bind=formatTime(schedule.end)></b> <span ng-if=schedule.location ng-bind=\"\'(\'+ schedule.location +\')\'\"></span></p><p ng-bind=schedule.description></p><div style=\"padding-top: 8px; text-align: right\"><button class=\"btn btn-success btn-sm\" type=button ng-click=onUpdateSchedule(schedule) uib-tooltip=\"{{\'BUTTON.edit\' | translate}}\" tooltip-placement=top><i class=\"glyphicon glyphicon-pencil\"></i></button> <button class=\"btn btn-danger btn-sm\" type=button ng-click=onRemoveSchedule(schedule) uib-tooltip=\"{{\'BUTTON.delete\' | translate}}\" tooltip-placement=top><i class=\"glyphicon glyphicon-trash\"></i></button></div></li></ul></div><button type=button class=\"slick-prev slick-arrow\" ng-click=handlePrevSlide()><i class=\"fa fa-angle-double-left\" aria-hidden=true></i></button> <button type=button class=\"slick-next slick-arrow\" ng-click=handleNextSlide()><i class=\"fa fa-angle-double-right\" aria-hidden=true></i></button></div></div>");
$templateCache.put("app/users/organizer/event/reservation-calendars/reservation-calendars.html","<div ng-controller=\"OrganizerReservationCalendarsController as vm\" ng-init=onInit()><div ng-if=loading ng-bind=\"\'TEXT.loading\'\"></div><div ng-if=!loading><div class=\"row row-flex row-16\" ng-if=reservations.length><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3\" style=\"margin-top: 16px\" ng-repeat=\"reserve in reservations\"><div class=\"card card-default\"><div class=card-head><div class=card-subtitle><b style=\"color: #121212\" ng-bind=\"\'FORM.label.dateRange\' | translate\"></b><!-- <span ng-bind=\"toMonth(reserve.from)\"></span>&nbsp;-&nbsp;\n              <span ng-bind=\"toMonth(moment(reserve.to).subtract(1, \'days\'))\"></span> --><div class=card-group-label><span ng-bind=\"reserve.from | dateFormatedOnly\"></span>&nbsp;-&nbsp; <span ng-bind=\"moment(reserve.to).subtract(1, \'days\') | dateFormatedOnly\"></span></div></div></div><div class=card-body><div class=card-group ng-if=reserve.mapName><span class=card-group-label ng-bind=\"\'FORM.label.mapName\' | translate\"></span><div class=card-group-value ng-bind=reserve.mapName></div></div><div class=card-group ng-if=reserve.boothName><span class=card-group-label ng-bind=\"\'FORM.label.boothName\' | translate\"></span><div class=card-group-value ng-bind=reserve.boothName></div></div><div class=card-group ng-if=reserve.description><span class=card-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=card-group-value ng-bind=reserve.description></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.reservationType\' | translate\"></span><div class=card-group-value><span class=\"card-group-color {{reserve.timeSlotLength}}\"></span> <span ng-bind=\"reserve.timeSlotLength | capitalize\"></span></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.operatingHours\' | translate\"></span><div class=card-group-value ng-bind=\"\n                    reserve.operatingHours.start +\':00 - \'+\n                    reserve.operatingHours.end +\':00\'\n                    \"></div></div><div class=card-group><div class=card-group-value ng-repeat=\"(key, value) in reserve.dayOfWeekPricing\"><span ng-if=\"value !== 0 || value !== \'\'\"><b ng-bind=\"key | capitalize\"></b>:&nbsp;<i ng-bind=\"\'$\'+ value\"></i></span></div></div></div><div class=card-foot><a class=\"btn btn-default btn-sm\" ui-sref=\"users.organizer.reservation_manager({id: reserve.boothId})\" role=link ng-bind=\"\'BUTTON.manageReservation\' | translate\"></a><div uib-dropdown class=btn-group style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button><li role=menuitem><button type=button ng-click=handleEditCalendar(reserve) ng-bind=\"\'BUTTON.edit\' | translate\"></button></li><li role=menuitem><button type=button ng-click=handleDeleteCalendar(reserve) ng-bind=\"\'BUTTON.delete\' | translate\"></button></li></ul></div></div></div></div></div><div class=no-message ng-if=\"reservations.length === 0\"><i class=\"glyphicon glyphicon-calendar\"></i><h3 ng-bind=\"\'TEXT.noReservations\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/event/settings/settings.html","<div class=tab-content ng-controller=\"OrganizerEventSettingsController as vm\" ng-init=onInit()><form novalidate name=form ng-submit=handleSubmit()><uib-tabset active=activeMain class=nav-tabs-inner><uib-tab index=0 heading=\"{{\'TAB.main\' | translate}}\"><div class=\"row row-16\"><div class=col-md-6><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=\"form-control input-sm\" id=name type=text name=name placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.event.name ng-disabled=!eventStatus required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group ng-class=\"{ \'has-error\': form.address.$invalid && formSubmitted }\"><label for=address><span ng-bind=\"\'FORM.label.address\' | translate\"></span> <span>&nbsp;*</span></label><input class=\"form-control input-sm\" id=address type=text name=address placeholder=\"{{\'FORM.placeholder.address\' | translate}}\" ng-model=vm.event.address ng-disabled=!eventStatus required><div class=help-block ng-if=formSubmitted ng-messages=form.address.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{ \'has-error\': form.domain.$invalid && formSubmitted }\"><label for=domain><span ng-bind=\"\'FORM.label.domainName\' | translate\"></span> <span>&nbsp;*</span></label><input class=\"form-control input-sm\" id=domain type=text name=domain placeholder=\"{{\'FORM.placeholder.domainName\' | translate}}\" ng-model=vm.event.domain ng-disabled=!eventStatus required><div class=help-block ng-if=formSubmitted ng-messages=form.domain.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{ \'has-error\': form.email.$invalid && formSubmitted }\"><label for=email ng-bind=\"\'FORM.label.email\' | translate\"></label><input class=\"form-control input-sm\" id=email type=email name=email placeholder=\"{{\'FORM.placeholder.email\' | translate}}\" ng-model=vm.event.email ng-disabled=!eventStatus><div class=help-block ng-if=formSubmitted ng-messages=form.email.$error role=alert><div ng-message=email ng-bind=\"\'FORM.validation.invalidEmail\' | translate\"></div></div></div></div></div></div><div class=col-md-6><div class=\"row row-16\"><div class=col-xs-12><date-range start-date=vm.eventDate.startDate end-date=vm.eventDate.endDate start-time=vm.eventDate.startTime end-time=vm.eventDate.endTime is-valid=vm.eventDate.isValid event-validation=false></date-range></div></div></div></div><text-editor-gallery teg-name=description teg-label=\"{{\'FORM.label.description\' | translate}}\" teg-model=vm.event.description teg-required=true teg-submitted=formSubmitted teg-form=form></text-editor-gallery></uib-tab><uib-tab index=1 heading=\"{{\'TAB.preferences\' | translate}}\"><div class=row><div class=\"col-xs-12 col-sm-6 col-md-4\"><div ng-if=\"vm.event.modules.indexOf(\'reservations\') > -1\"><div class=form-group><div class=checkbox><label><input type=checkbox name=enableDonations ng-model=vm.event.preferences.enableReservationAvailability ng-disabled=!eventStatus> <span ng-bind=\"\'Enable reservation availability filter\'\"></span></label></div></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=enableDonations ng-model=vm.event.preferences.enableDonations ng-disabled=!eventStatus> <span ng-bind=\"\'FORM.value.enableEventDonations\' | translate\"></span></label></div></div><!-- \n              preferences: {\n                scheduleModule: {\n                  enabled: true,\n                  enableUserTypeSchedule: false,\n                  groupByLocation: true\n                }\n              }\n            --><div class=form-group><div class=checkbox><label><input type=checkbox name=enableSchedule ng-model=vm.scheduleModule.enabled ng-disabled=!eventStatus> <span ng-bind=\"\'FORM.value.enableSchedule\' | translate\"></span></label></div></div><div class=form-group ng-if=vm.scheduleModule.enabled><div class=checkbox><label><input type=checkbox name=groupByLocation ng-model=vm.scheduleModule.groupByLocation ng-disabled=!eventStatus> <span ng-bind=\"\'FORM.value.groupScheduleByLocation\' | translate\"></span></label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=countdownClock ng-model=vm.event.preferences.countdownClock ng-disabled=!eventStatus> <span ng-bind=\"\'FORM.value.eventCountdown\' | translate\"></span><!-- Show event countdown clock on home page --></label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=showEventStartEndDate ng-model=vm.event.preferences.showEventStartEndDate ng-disabled=!eventStatus> <span ng-bind=\"\'FORM.value.showEventStartEndDate\' | translate\"></span><!-- Show event countdown clock on home page --></label></div></div><div class=form-group><label for=items ng-bind=\"\'FORM.label.itemsPerPage\' | translate\"></label><input class=form-control type=number id=items name=items placeholder=\"{{\'FORM.placeholder.itemsPerPage\' | translate}}\" ng-model=vm.event.preferences.itemsPerPage ng-disabled=!eventStatus><p class=help-block ng-bind=\"\'HELP.defaultPerPage\' | translate\"></p></div><div class=form-group><label ng-bind=\"\'FORM.label.eventInfoBoxSize\' | translate\"></label><div><div><label><input type=radio ng-model=vm.event.preferences.eventBoxSize name=eventBoxSize value=sm> <span ng-bind=\"\'FORM.value.small\' | translate\"></span></label></div><div><label><input type=radio ng-model=vm.event.preferences.eventBoxSize name=eventBoxSize value=md> <span ng-bind=\"\'FORM.value.medium\' | translate\"></span></label></div><div><label><input type=radio ng-model=vm.event.preferences.eventBoxSize name=eventBoxSize value=lg> <span ng-bind=\"\'FORM.value.large\' | translate\"></span></label></div></div></div><div class=form-group><label ng-bind=\"\'FORM.label.measurementSystem\' | translate\"></label><div><div class=radio-inline><label><input type=radio ng-model=vm.event.preferences.measurementSystem name=measurement value=imperial> <span ng-bind=\"\'FORM.value.imperial\' | translate\"></span></label></div><div class=radio-inline><label><input type=radio ng-model=vm.event.preferences.measurementSystem name=measurement value=metrics> <span ng-bind=\"\'FORM.value.metrics\' | translate\"></span></label></div></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=showCustomHomePage ng-model=vm.event.preferences.showCustomHomePage ng-disabled=!eventStatus> <span ng-bind=\"\'FORM.value.showCustomHomePage\' | translate\"></span></label></div><a ng-if=vm.event.preferences.showCustomHomePage ui-sref=app.constructorLandingPage target=_blank>Costructor page</a></div><div class=form-group><div class=checkbox><label><input type=checkbox name=disableTextEditorSanitize ng-model=vm.event.preferences.disableTextEditorSanitize ng-disabled=!eventStatus> <span ng-bind=\"\'FORM.value.disableContentSanitize\' | translate\"></span></label></div><p class=help-text style=\"font-size: 12px; font-style: italic; color: #999999\" ng-bind=\"\'HELP.reloadAfterSave\' | translate\"></p></div><div ng-if=vm.event.preferences.disableTextEditorSanitize><uib-tabset active=activeMainStyleScript class=nav-tabs-inner><uib-tab index=0 heading=Style(s)><div class=form-group><textarea class=form-control name=descriptionStyles id=descriptionStyles rows=10 placeholder=\"Style field, you don`t need <style>...</style> tag\" ng-model=vm.event.preferences.descriptionStyles></textarea></div></uib-tab><uib-tab index=1 heading=Script(s)><div class=form-group><textarea class=form-control name=descriptionScripts id=descriptionScripts rows=10 placeholder=\"Script field, you don`t need <script>...</script> tag\" ng-model=vm.event.preferences.descriptionScripts></textarea></div></uib-tab></uib-tabset></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=form-group><div class=checkbox><label><input type=checkbox name=enableEventMap ng-model=vm.homePageButtonsModule.enableEventMap ng-disabled=!eventStatus> <span ng-bind=\"\'Show `Event map` button\'\"></span></label></div></div><div class=form-group><label for=\"\">Map search mode</label><div class=radio><label><input type=radio name=grayscaleBooths ng-model=vm.event.preferences.grayscaleBooths ng-value=false> Hide nonmatching</label></div><div class=radio><label><input type=radio name=grayscaleBooths ng-model=vm.event.preferences.grayscaleBooths ng-value=true> Disable nonmatching</label></div></div><div class=form-group><label ng-bind=\"\'Home page button label `Event map`\'\"></label><input class=form-control type=text name=labelEventMap ng-model=vm.homePageButtonsModule.labelEventMap ng-disabled=!eventStatus></div><div class=form-group><label ng-bind=\"\'Home page button label `Schedule`\'\"></label><input class=form-control type=text name=labelSchedule ng-model=vm.homePageButtonsModule.labelSchedule ng-disabled=!eventStatus></div><div class=form-group><label ng-bind=\"\'Home page button label `Donate`\'\"></label><input class=form-control type=text name=labelDonate ng-model=vm.homePageButtonsModule.labelDonate ng-disabled=!eventStatus></div></div></div></uib-tab><uib-tab index=2 heading=\"{{\'TAB.lookAndFeel\' | translate}}\"><div class=\"row row-16\"><div class=\"col-xs-12 col-md-6\"><!--Event logo --><div class=form-group><label ng-bind=\"\'FORM.label.logo\' | translate\"></label><upload-file ng-model=vm.link.logo ng-files=\"{{ vm.event.preferences.logo }}\" ng-disabled=!eventStatus ng-accept=image/*></upload-file></div><!--Event brand--><div class=form-group><label ng-bind=\"\'FORM.label.favicon\' | translate\"></label><upload-file ng-model=vm.link.favicon ng-files=\"{{ vm.event.preferences.favicon }}\" ng-disabled=!eventStatus ng-accept=image/*></upload-file><span class=help-block style=\"font-size: 12px\" ng-bind=\"\'HELP.supportImageFormat\' | translate\"></span></div><!-- Event background image --><div class=form-group><label ng-bind=\"\'FORM.label.backgroundImage\' | translate\"></label><upload-file ng-model=vm.link.backgroundImage ng-files=\"{{ vm.event.preferences.backgroundImage }}\" ng-disabled=!eventStatus ng-accept=image/*></upload-file></div></div><div class=\"col-xs-12 col-md-6\"><div class=form-group><label ng-bind=\"\'FORM.label.eventColorScheme\' | translate\"></label><div class=color-scheme><div class=\"radio color-scheme-radio\" ng-repeat=\"color in vm.appColors\"><label ng-class=\"color.id == vm.event.preferences.colorScheme.id ? \'active\' : \'\'\"><input type=radio name=colorScheme ng-value=color.id ng-checked=\"color.id == vm.event.preferences.colorScheme.id\" ng-click=onChangeColorScheme(color)> <span style=\"background-color: {{color.hexCode}}\" ng-bind=color.name></span></label></div></div></div></div></div></uib-tab><uib-tab index=3 heading=\"{{\'TAB.metaTags\' | translate}}\"><div class=form-group><label ng-bind=\"\'FORM.label.title\' | translate\"></label><input class=\"form-control input-sm\" type=text placeholder=\"{{\'FORM.placeholder.title\' | translate}}\" ng-model=vm.metaTags.title ng-disabled=!eventStatus></div><div class=form-group><label ng-bind=\"\'FORM.label.description\' | translate\"></label><textarea class=\"form-control input-sm\" placeholder=\"{{\'FORM.placeholder.description\' | translate}}\" ng-model=vm.metaTags.description rows=5 ng-disabled=!eventStatus>\n          </textarea></div><div class=form-group><label ng-bind=\"\'FORM.label.keywords\' | translate\"></label><input class=\"form-control input-sm\" type=text placeholder=\"{{\'FORM.placeholder.keywords\' | translate}}\" ng-model=vm.metaTags.keywords ng-disabled=!eventStatus></div><!--\n        <div class=\"form-group\">\n          <div class=\"checkbox\">\n            <label>\n              <input type=\"checkbox\" name=\"searchEnginePrivacy\" ng-model=\"vm.metaTags.searchEnginePrivacy\" ng-disabled=\"!eventStatus\" />\n              <span ng-bind=\"\'FORM.value.searchEnginePrivacy\' | translate\"></span>\n            </label>\n          </div>\n          <div class=\"help-block\" style=\"font-size: 12px; font-style: italic;\"\n               ng-bind=\"\'HELP.discourageSearch\' | translate\"></div>\n        </div>\n      --></uib-tab><uib-tab index=4 heading=\"{{\'TAB.userSettings\' | translate}}\"><uib-tabset active=activeUser class=nav-tabs-inner><uib-tab index=0 heading={{vm.vendorModule.label}} ng-if=\"vm.event.modules.indexOf(\'vendor\') > -1\"><!--\n              preferences: {\n                vendorModule: {\n                  label: \'Vendor\',\n                  enableRegister: true,\n                  homeButton: true,\n                  requestDescriptionRequired: false,\n                  requestImageRequired: true,\n                  requestFeaturedItemsRequired: false\n                }\n              }\n            --><div class=row><div class=col-md-8><div class=form-group><label for=vendorModuleLabel><span ng-bind=vm.vendorModule.label style=\"text-transform: capitalize\"></span> label text</label><input class=\"form-control input-sm\" type=text id=vendorModuleLabel name=vendorModuleLabel ng-model=vm.vendorModule.label ng-disabled=!eventStatus></div><div class=form-group><div class=checkbox><label><input type=checkbox name=vendorModuleEnableRegister ng-model=vm.vendorModule.enableRegister ng-disabled=!eventStatus> Enable <span ng-bind=vm.vendorModule.label style=\"text-transform: lowercase\"></span> registration</label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=vendorModuleHomeButton ng-model=vm.vendorModule.button ng-disabled=!eventStatus> Show event <span ng-bind=vm.vendorModule.label style=\"text-transform: lowercase\"></span> button on home page</label></div></div><div class=checkbox><label><input type=checkbox name=enableUserTypeSchedule ng-model=vm.vendorModule.enableUserTypeSchedule ng-disabled=!eventStatus> <span ng-bind=\"\'Enable schedule\'\"></span></label></div><div class=form-group><label for=buttonLabel>Home button label</label><input class=\"form-control input-sm\" type=text id=buttonLabel name=buttonLabel ng-model=vm.vendorModule.buttonLabel ng-disabled=!eventStatus></div><div class=form-group><div class=checkbox><label><input type=checkbox name=vendorModuleRequestDescriptionRequired ng-model=vm.vendorModule.requestDescriptionRequired ng-disabled=!eventStatus> <span ng-bind=vm.vendorModule.label style=\"text-transform: capitalize\"></span> request description required</label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=vendorModuleRequestImageRequired ng-model=vm.vendorModule.requestImageRequired ng-disabled=!eventStatus> <span ng-bind=vm.vendorModule.label style=\"text-transform: capitalize\"></span> request booth photo required</label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=vendorModuleRequestFeaturedItemsRequired ng-model=vm.vendorModule.requestFeaturedItemsRequired ng-disabled=!eventStatus> <span ng-bind=vm.vendorModule.label style=\"text-transform: capitalize\"></span> request featured items required</label></div></div></div></div><div class=form-group><upload-file ng-model=vm.link.confirmationDocument ng-files=\"{{ vm.event.preferences.confirmationDocument }}\" ng-title=\"Confirmation Documents\" ng-type=file ng-disabled=!eventStatus uf-can-remove=true></upload-file><div class=\"help-block help-block-default\" style=\"position: relative\">(Shown for accepted vendor requests)</div></div></uib-tab><uib-tab index=1 heading={{vm.volunteerModule.label}} ng-if=\"vm.event.modules.indexOf(\'volunteer\') > -1\"><!--\n              preferences: {\n                volunteerModule: {\n                  label: \'Vendor\',\n                  enableRegister: true,\n                  instruction: \'\'\n                }\n              }\n            --><div class=row><div class=col-md-8><div class=form-group><label for=volunteerModuleLabel><span ng-bind=vm.volunteerModule.label style=\"text-transform: capitalize\"></span> label text</label><input class=\"form-control input-sm\" type=text id=volunteerModuleLabel name=volunteerModuleLabel ng-model=vm.volunteerModule.label ng-disabled=!eventStatus></div><div class=form-group><div class=checkbox><label><input type=checkbox name=volunteerModuleEnableRegister ng-model=vm.volunteerModule.enableRegister ng-disabled=!eventStatus> Enable <span ng-bind=vm.volunteerModule.label style=\"text-transform: lowercase\"></span> registration</label></div></div><div class=checkbox><label><input type=checkbox name=enableUserTypeSchedule ng-model=vm.volunteerModule.enableUserTypeSchedule ng-disabled=!eventStatus> <span ng-bind=\"\'Enable schedule\'\"></span></label></div><div class=form-group><label for=volunteerModuleInstruction>Instruction</label><textarea class=\"form-control input-sm\" name=volunteerModuleInstruction rows=6 ng-disabled=!eventStatus ng-model=vm.volunteerModule.instruction>\n                  </textarea></div></div></div></uib-tab><uib-tab index=2 heading={{vm.participantModule.label}} ng-if=\"vm.event.modules.indexOf(\'participant\') > -1\"><!-- \n              preferences: {\n                participantModule: {\n                  enabled: true,\n                  cashPayment: true,\n                  cardPayment: true,\n                  label: \'Participant\'\n                  waiver: \'\',\n                  buttonLabelPayCash: \'\'\n                  buttonLabelPayCard: \'\'\n                }\n              }\n             --><!-- <div class=\"form-group\">\n              <div class=\"checkbox\">\n                <label>\n                  <input type=\"checkbox\" name=\"participantModuleEnabled\" ng-model=\"vm.participantModule.enabled\" ng-disabled=\"!eventStatus\" />\n                  Enable {{vm.participantModule.label}} Module\n                </label>\n              </div>\n            </div> --><div class=row><div class=col-md-8><div class=form-group><div class=checkbox><label><input type=checkbox name=enableRegister ng-model=vm.participantModule.enableRegister ng-disabled=!eventStatus> Enable {{vm.participantModule.label}} Registration</label></div></div><div class=form-group><div class=checkbox ng-if=\"vm.event.modules.indexOf(\'scavenger_hunt\') > -1\"><label><input type=checkbox name=scavengerHunt ng-model=vm.participantModule.scavengerHunt ng-disabled=!eventStatus> <span ng-bind=\"\'Enable scavenger hunt\'\"></span></label></div></div><div class=form-group><div class=checkbox><label><input type=checkbox name=hideEventMap ng-model=vm.participantModule.hideEventMap ng-disabled=!eventStatus> <span ng-bind=\"\'Hide Event Map Menu\'\"></span></label></div></div><div class=checkbox><label><input type=checkbox name=enableUserTypeSchedule ng-model=vm.participantModule.enableUserTypeSchedule ng-disabled=!eventStatus> <span ng-bind=\"\'Enable schedule\'\"></span></label></div><div class=form-group><div class=checkbox><label><input type=checkbox name=participantModuleCashPayment ng-model=vm.participantModule.cashPayment ng-disabled=!eventStatus> Cash/Check Payment</label></div></div><div class=form-group ng-if=vm.participantModule.cashPayment><label>Cash/Check button label</label><input class=\"form-control input-sm\" type=text placeholder=\"Cash/Check button label\" name=participantButtonLabelPayCash ng-model=vm.participantModule.buttonLabelPayCash ng-disabled=!eventStatus></div><div class=form-group ng-if=vm.event.billingPreferences.serviceType><div class=checkbox><label><input type=checkbox name=participantModuleCardPayment ng-model=vm.participantModule.cardPayment ng-disabled=!eventStatus> Credit Card Payment</label></div></div><div class=form-group ng-if=vm.participantModule.cardPayment><label>Credit card button label</label><input class=\"form-control input-sm\" type=text placeholder=\"Credit card button label\" name=participantButtonLabelPayCard ng-model=vm.participantModule.buttonLabelPayCard ng-disabled=!eventStatus></div><div class=form-group><label>{{vm.participantModule.label}} Label Text</label><input class=\"form-control input-sm\" type=text placeholder=\"Participant label text\" name=participantModuleLabel ng-model=vm.participantModule.label ng-disabled=!eventStatus></div><div class=form-group><div class=checkbox><label><input type=checkbox name=participantModuleWaiverEnabled ng-model=vm.participantModule.waiverEnabled ng-disabled=!eventStatus> Waiver enabled</label></div></div><div class=form-group ng-if=vm.participantModule.waiverEnabled><text-editor-gallery teg-name=participantModuleWaiverContent teg-model=vm.participantWaiverContent teg-label=\"{{vm.participantModule.label}} waiver\" teg-submitted=formSubmitted teg-form=form></text-editor-gallery></div></div></div></uib-tab><uib-tab index=3 heading={{vm.sponsorModule.label}} ng-if=\"vm.event.modules.indexOf(\'sponsor\') > -1\"><!-- \n              preferences: {\n                sponsorModule: {\n                  label: \'Sponsor\',\n                  landingPage: false,\n                  innerPages: false,\n                  primaryLabel: \'Headline sponsors\',\n                  secondaryLabel: \'Secondary sponsors\'\n                  cashPayment: false,\n                  cardPayment: false\n                }\n              }\n             --><!-- <div class=\"form-group\">\n              <div class=\"checkbox\">\n                <label>\n                  <input type=\"checkbox\" name=\"sponsorModuleEnabled\" ng-model=\"vm.sponsorModule.enabled\" ng-disabled=\"!eventStatus\" />\n                  Enable {{vm.sponsorModule.label}} Module\n                </label>\n              </div>\n            </div> --><div class=row><div class=col-md-8><div class=form-group><div class=checkbox><label><input type=checkbox name=enableRegister ng-model=vm.sponsorModule.enableRegister ng-disabled=!eventStatus> Enable {{vm.sponsorModule.label}} Registration</label></div></div><div class=checkbox><label><input type=checkbox name=enableUserTypeSchedule ng-model=vm.sponsorModule.enableUserTypeSchedule ng-disabled=!eventStatus> <span ng-bind=\"\'Enable schedule\'\"></span></label></div><div class=form-group><div class=checkbox><label><input type=checkbox name=sponsorModuleCashPayment ng-model=vm.sponsorModule.cashPayment ng-disabled=!eventStatus> Cash/Check Payment</label></div></div><div class=form-group ng-if=vm.sponsorModule.cashPayment><label>Cash/Check button label</label><input class=\"form-control input-sm\" type=text placeholder=\"Credit card button label\" name=sponsorButtonLabelPayCard ng-model=vm.sponsorModule.buttonLabelPayCash ng-disabled=!eventStatus></div><div class=form-group ng-if=vm.event.billingPreferences.serviceType><div class=checkbox><label><input type=checkbox name=sponsorModuleCardPayment ng-model=vm.sponsorModule.cardPayment ng-disabled=!eventStatus> Credit Card Payment</label></div></div><div class=form-group ng-if=vm.sponsorModule.cardPayment><label>Credit card button label</label><input class=\"form-control input-sm\" type=text placeholder=\"Credit card button label\" name=sponsorButtonLabelPayCard ng-model=vm.sponsorModule.buttonLabelPayCard ng-disabled=!eventStatus></div><div class=form-group style=\"margin-bottom: 0\"><label>{{vm.sponsorModule.label}} label text</label><input class=\"form-control input-sm\" type=text name=sponsorModuleLabel placeholder=\"Sponsor label text\" ng-model=vm.sponsorModule.label ng-disabled=!eventStatus></div><hr><div class=form-group><label>Headlining {{vm.sponsorModule.label | lowercase}} Text</label><input class=\"form-control input-sm\" type=text name=sponsorModulePrimaryLabel placeholder=\"Headlining Sponsor Text\" ng-model=vm.sponsorModule.primaryLabel ng-disabled=!eventStatus></div><div class=form-group><label>Sponsor Text</label><input class=\"form-control input-sm\" type=text name=sponsorModuleSecondaryLabel placeholder=\"Sponsor Text\" ng-model=vm.sponsorModule.secondaryLabel ng-disabled=!eventStatus></div></div></div></uib-tab></uib-tabset></uib-tab></uib-tabset><div class=form-group ng-if=eventStatus><button class=\"btn btn-primary\" type=submit ng-disabled=\"formLoading || (formSubmitted && !vm.eventDate.isValid)\" ng-bind=\"\'BUTTON.save\' | translate\"></button></div></form></div>");
$templateCache.put("app/users/organizer/event/smtp-server/smtp-server.html","<div class=tab-content ng-controller=\"OrganizerEventSmtpController as vm\" ng-init=onInit()><form novalidate name=form ng-submit=handleSubmit()><div class=row><div class=col-sm-8 ng-if=\"vm.settings.length != 0\"><div class=form-group ng-repeat=\"setting in vm.settings\" ng-class=\"{\'has-error\': setting.name !== \'mailFromAddress\' && formSubmitted && form[setting.name].$invalid }\"><label for={{setting.name}}><span ng-bind=setting.description></span> <span ng-if=\"setting.name !== \'mailFromAddress\'\">&nbsp;*</span></label><input class=form-control id={{setting.name}} type=text name={{setting.name}} placeholder={{setting.description}} ng-model=setting.value ng-disabled=!eventStatus ng-required=\"setting.name !== \'mailFromAddress\'\" ng-pattern=\"setting.name == \'mailPort\' ? numberPattern : \'\'\"><div class=help-block ng-if=\"setting.name !== \'mailFromAddress\' && formSubmitted\" ng-messages=form[setting.name].$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div><div ng-message=pattern ng-bind=\"\'FORM.validation.integer\' | translate\"></div></div></div></div></div><div ng-if=eventStatus><button class=\"btn btn-primary btn-sm\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.save\' | translate\"></span></button> <button class=\"btn btn-danger btn-sm\" type=button ng-click=handleResetSMTP() ng-bind=\"\'BUTTON.reset\' | translate\"></button></div></form></div>");
$templateCache.put("app/users/organizer/map/all/all.html","<div ng-controller=\"OrganizerMapAllController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.SEARCH\' | translate\"></span> <input class=form-control type=text name=name placeholder=\"{{\'FORM.SEARCH\' | translate}}\" ng-model=mapAllSearch ng-model-options=\"{debounce: 1000}\"></label></div><div class=clearfix ng-if=eventStatus><button class=\"btn btn-info pull-right\" type=button ng-click=onCreateMap() ng-bind=\"\'BUTTON.CREATE_MAP\' | translate\"></button></div><div ng-if=pageLoading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!pageLoading><div class=\"row row-flex row-16\" style=\"margin-top: 16px\" ng-if=mapList.length><div class=\"col-xs-6 col-sm-4\" style=\"margin-bottom: 16px\" ng-repeat=\"map in mapList | FilterMapSearch: mapAllSearch | orderBy: \'-createdOn\'\"><div class=\"card card-default\"><div class=card-head><h2 class=card-title ng-bind=map.name></h2></div><div class=card-body><div class=card-group ng-if=\"map.backgroundImage && map.backgroundImage.link\"><span class=card-group-label ng-bind=\"\'LABEL.IMAGE\' | translate\"></span><div class=card-group-image><img ng-src=\"{{ map.backgroundImage.link }}\" alt=\"{{ map.name }}\"></div></div><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.TYPE\' | translate\"></span><div class=\"card-group-value {{map.type}}\" ng-bind=map.type></div></div><div class=row ng-if=\"map.preferences.width && map.preferences.height\"><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.WIDTH\' | translate\"></span><div class=card-group-value ng-bind=\"map.preferences.width +\'px\'\"></div></div></div><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'LABEL.HEIGHT\' | translate\"></span><div class=card-group-value ng-bind=\"map.preferences.height +\'px\'\"></div></div></div></div><div class=card-group ng-if=map.preferences.fillColor><span class=card-group-label ng-bind=\"\'LABEL.COLOR\' | translate\"></span><div class=card-group-color ng-style=\"{\'background-color\': map.preferences.fillColor}\"></div></div></div><div class=card-foot><button class=\"btn btn-default btn-sm\" type=button ng-if=\"mainEventMapId === map.id\" ng-click=handleEmbed() ng-bind=\"\'BUTTON.embed\' | translate\"></button> <button class=\"btn btn-info btn-sm\" type=button ng-if=\"mainEventMapId !== map.id\" ng-click=onAssignMainMap(map.id) ng-bind=\"\'BUTTON.SET_MAIN\' | translate\"></button> <a class=\"btn btn-primary btn-sm\" ui-sref=\"users.organizer.map.constructor({id: map.id})\" ng-bind=\"\'BUTTON.EDIT\' | translate\"></a> <button class=\"btn btn-danger btn-sm\" type=button ng-if=\"mainEventMapId !== map.id\" ng-click=onDeleteMap(map) ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></div></div></div></div><div class=no-message ng-if=\"mapList.length === 0\"><i class=\"fa fa-map\" aria-hidden=true></i><h3 ng-bind=\"\'TEXT.NO_MAP\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/event/static-pages/static-pages.html","<div ng-controller=\"OrganizerEventStaticPageController as vm\" ng-init=onInit() style=\"position: relative\"><form novalidate name=form><div class=page-loading ng-if=pageLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><uib-tabset active=active vertical=true class=ct-stacked><uib-tab index=0 heading=About><text-editor-gallery teg-name=pageAbout teg-model=vm.pageAbout.content></text-editor-gallery><div><button class=\"btn btn-primary\" type=button ng-if=eventStatus ng-click=handleSubmit(vm.pageAbout) ng-bind=\"\'BUTTON.save\' | translate\"></button></div></uib-tab><uib-tab index=1 heading=Contact><div class=form-group><text-editor-gallery teg-name=pageContact teg-model=vm.pageContact.content></text-editor-gallery></div><div><button class=\"btn btn-primary\" type=button ng-if=eventStatus ng-click=handleSubmit(vm.pageContact) ng-bind=\"\'BUTTON.save\' | translate\"></button></div></uib-tab><uib-tab index=2 heading=Footer><div class=form-group><text-editor-gallery teg-name=contentFooter teg-model=vm.contentFooter.content></text-editor-gallery></div><div><button class=\"btn btn-primary\" type=button ng-if=eventStatus ng-click=handleSubmit(vm.contentFooter) ng-bind=\"\'BUTTON.save\' | translate\"></button></div></uib-tab><uib-tab ng-if=\"event.modules.indexOf(\'vendor\') !== -1\" index=3 heading=\"{{vendorModule.label}} Home Page\"><div class=form-group><text-editor-gallery teg-name=appFormVendor teg-model=vm.appFormVendor.content></text-editor-gallery></div><div><button class=\"btn btn-primary\" type=button ng-if=eventStatus ng-click=handleSubmit(vm.appFormVendor) ng-bind=\"\'BUTTON.save\' | translate\"></button></div></uib-tab><uib-tab ng-if=\"event.modules.indexOf(\'volunteer\') !== -1\" index=4 heading=\"{{volunteerModule.label}} Home Page\"><div class=form-group><text-editor-gallery teg-name=appFormVolunteer teg-model=vm.appFormVolunteer.content></text-editor-gallery></div><div><button class=\"btn btn-primary\" type=button ng-if=eventStatus ng-click=handleSubmit(vm.appFormVolunteer) ng-bind=\"\'BUTTON.save\' | translate\"></button></div></uib-tab><uib-tab index=5 ng-if=\"event.modules.indexOf(\'participant\') !== -1\" heading=\"{{participantModule.label}} Home Page\"><div class=form-group><text-editor-gallery teg-name=appFormParticipant teg-model=vm.appFormParticipant.content></text-editor-gallery></div><div><button class=\"btn btn-primary\" type=button ng-if=eventStatus ng-click=handleSubmit(vm.appFormParticipant) ng-bind=\"\'BUTTON.save\' | translate\"></button></div></uib-tab><uib-tab index=6 ng-if=\"event.modules.indexOf(\'sponsor\') !== -1\" heading=\"{{sponsorModule.label}} Home Page\"><div class=form-group><text-editor-gallery teg-name=appFormSponsor teg-model=vm.appFormSponsor.content></text-editor-gallery></div><div><button class=\"btn btn-primary\" type=button ng-if=eventStatus ng-click=handleSubmit(vm.appFormSponsor) ng-bind=\"\'BUTTON.save\' | translate\"></button></div></uib-tab><uib-tab index=7 ng-if=\"event.modules.indexOf(\'sponsor\') !== -1\" heading=\"Attendant Home Page\"><div class=form-group><text-editor-gallery teg-name=appFormSponsorAttendant teg-model=vm.appFormSponsorAttendant.content></text-editor-gallery></div><div><button class=\"btn btn-primary\" type=button ng-if=eventStatus ng-click=handleSubmit(vm.appFormSponsorAttendant) ng-bind=\"\'BUTTON.save\' | translate\"></button></div></uib-tab></uib-tabset></form></div>");
$templateCache.put("app/users/organizer/map/constructor/constructor.html","<div ng-controller=\"OrganizerMapConstructorController as vm\" ng-init=onInit()><div class=\"row row-16 row-justify\"><div class=\"col-xs-12 col-md-3\"><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedRespZone}\"><label><input type=checkbox ng-disabled=onlyUnassignedRespZone name=isEventZonesVisible ng-model=isEventZonesVisible ng-change=\"onChangeMapObjectVisible(\'eventZone\', isEventZonesVisible)\"> <span ng-bind=\"\'MAP_CONSTRUCTOR.EVENT_ZONE\' | translate\"></span></label></div><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedRespZone}\"><label><input type=checkbox ng-disabled=onlyUnassignedRespZone name=isRespZonesVisible ng-model=isRespZonesVisible ng-change=\"onChangeMapObjectVisible(\'respZone\', isRespZonesVisible)\"> <span ng-bind=\"\'MAP_CONSTRUCTOR.RESPONSIBILITY_ZONE\' | translate\"></span></label></div><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedBooth || onlyUnassignedRespZone}\"><label><input type=checkbox ng-disabled=\"onlyUnassignedBooth ||onlyUnassignedRespZone\" name=isBoothsVisible ng-model=isBoothsVisible ng-change=\"onChangeMapObjectVisible(\'booth\', isBoothsVisible)\"> <span ng-bind=\"\'MAP_CONSTRUCTOR.BOOTH\' | translate\"></span></label></div><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedRespZone}\"><label><input type=checkbox ng-disabled=onlyUnassignedRespZone name=isRoutesVisible ng-model=isRoutesVisible ng-change=\"onChangeMapObjectVisible(\'route\', isRoutesVisible)\"> <span ng-bind=\"\'MAP_CONSTRUCTOR.ROUTE\' | translate\"></span></label></div><div class=route-filter style=\"margin-bottom: 16px\" ng-class=\"{\'-open\': isRoutesFilterVisible}\"><button class=\"btn btn-default btn-sm btn-block\" ng-click=\"isRoutesFilterVisible = !isRoutesFilterVisible\">{{ !isRoutesFilterVisible ? (\'MAP_CONSTRUCTOR.SHOW_ROUTES\' | translate) : (\'MAP_CONSTRUCTOR.HIDE_ROUTES\' | translate) }}</button><div class=route-filter-scroll ng-if=isRoutesFilterVisible><div class=\"checkbox checkbox-route\" ng-repeat=\"route in routes track by $index\"><span ng-click=\"onRouteClick($event, route)\" ng-if=route.checked><i class=\"glyphicon glyphicon-pencil\"></i></span><label><input type=checkbox ng-model=route.checked ng-change=\"changeRouteVisibility(route.checked, route.id)\"> <i class=circle-color ng-style=\"{\'background-color\': route.strokeColor }\"></i> <span ng-bind=\"route.name || route.id\"></span></label></div></div></div><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedRespZone}\"><label><input type=checkbox ng-disabled=onlyUnassignedRespZone name=onlyUnassignedBooth ng-model=onlyUnassignedBooth ng-change=\"onChangeOnlyUnassignedBooth(onlyUnassignedBooth, {\n                    isBoothsVisible: isBoothsVisible\n                  })\"><!-- ng-change=\"onChangeOnlyUnassignedBooth(onlyUnassignedBooth, {\n                    isBoothsVisible: isBoothsVisible,\n                    isRoutesVisible: isRoutesVisible,\n                    isRespZonesVisible: isRespZonesVisible,\n                    isEventZonesVisible: isEventZonesVisible\n                  })\"> --> <span ng-bind=\"\'MAP_CONSTRUCTOR.ONLY_UNASSIGNED_BOOTHS\' | translate\"></span></label></div><div class=checkbox ng-class=\"{\'disabled\': onlyUnassignedBooth}\"><label><input type=checkbox ng-disabled=onlyUnassignedBooth name=onlyUnassignedRespZone ng-model=onlyUnassignedRespZone ng-change=\"onChangeOnlyUnassignedRespZone(onlyUnassignedRespZone, {\n                    isBoothsVisible: isBoothsVisible,\n                    isRoutesVisible: isRoutesVisible,\n                    isRespZonesVisible: isRespZonesVisible,\n                    isEventZonesVisible: isEventZonesVisible\n                  })\"> <span ng-bind=\"\'MAP_CONSTRUCTOR.ONLY_UNASSIGNED_RESPONSIBILITY_ZONE\' | translate\"></span></label></div><div ng-if=\"currentEvent.mainEventMapId === currentMapID\"><div class=form-group><button class=\"btn btn-primary btn-sm btn-block\" type=button ng-if=\"currentEvent.status != \'published\' && (!currentEvent.lockedBy || (currentEvent.lockedBy && currentEvent.lockedBy.id == currentUser.id))\" ng-disabled=!eventStatus ng-click=handlePublish() ng-bind=\"\'BUTTON.PUBLISH_MAP\' | translate\"></button> <button class=\"btn btn-default btn-sm btn-block\" type=button ng-if=\"currentEvent.status == \'published\' && (!currentEvent.lockedBy || (currentEvent.lockedBy && currentEvent.lockedBy.id == currentUser.id))\" ng-disabled=!eventStatus ng-click=handleUnpublish() ng-bind=\"\'BUTTON.UNPUBLISH_MAP\' | translate\"></button></div><div class=form-group ng-if=!currentEvent.lockedBy><button class=\"btn btn-default btn-sm btn-block\" type=button ng-disabled=!eventStatus ng-click=handleLockMap() ng-bind=\"\'BUTTON.LOCK_MAP\' | translate\"></button></div><div class=form-group ng-if=\"currentEvent.lockedBy && currentEvent.lockedBy.id == currentUser.id\"><button class=\"btn btn-default btn-sm btn-block\" type=button ng-disabled=!eventStatus ng-click=handleUnlockMap() ng-bind=\"\'BUTTON.UNLOCK_MAP\' | translate\"></button></div></div><div class=form-group ng-if=\"\n            !currentEvent.lockedBy ||\n            (\n              currentEvent.lockedBy && currentEvent.lockedBy.id === currentUser.id\n            )\n            \"><button class=\"btn btn-primary btn-sm btn-block\" type=button ng-click=saveMapData()><i ng-if=$scope.mapSaveLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.SAVE\' | translate\"></span></button></div><div class=form-group ng-if=\"currentEvent.lockedBy && currentEvent.lockedBy.id\"><b ng-bind=\"\'MAP_CONSTRUCTOR.LOCKED_BY\' | translate\"></b><p style=\"word-break: break-all\"><span ng-bind=currentEvent.lockedBy.name></span>&nbsp; <b style=\"display: block\" ng-bind=\"\'(\'+ currentEvent.lockedBy.email +\')\'\"></b></p><b ng-bind=\"\'MAP_CONSTRUCTOR.EXPIRED_ON\' | translate\"></b><p ng-bind=\"currentEvent.lockExpiredOn | dateFormated\"></p></div><h4 ng-if=\"mapData.type === \'outdoor\' && selectedItemDistance > 0\" style=\"font-weight: 300\"><span ng-bind=\"\'MAP_CONSTRUCTOR.ROUTE_DISTANCE\' | translate\"></span> <span style=\"font-weight: 700\" ng-if=\"currentEvent.preferences.measurementSystem == \'metrics\'\" ng-bind=\"selectedItemDistance +\' m\'+ toKm(selectedItemDistance)\"></span> <span style=\"font-weight: 700\" ng-if=\"currentEvent.preferences.measurementSystem == \'imperial\'\" ng-bind=\"selectedItemDistance + \' feet\'+ toMls(selectedItemDistance)\"></span></h4></div><div class=\"col-xs-12 col-md-9\"><div class=map-wrap><div class=map-btn-group><div class=btn-group uib-dropdown style=\"width: 100%\"><span class=map-btn uib-dropdown-toggle role=button ng-class=\"{\'active\': drawModeType === drawTypeBooth }\">{{\'MAP_CONSTRUCTOR.BOOTH\' | translate}}<i class=caret></i></span><ul class=dropdown-menu role=menu uib-dropdown-menu><li role=menuitem><button type=button ng-click=\"handleDrawModeType(drawTypeBooth, \'fixed\')\">Fixed</button></li><li role=menuitem><button type=button ng-click=\"handleDrawModeType(drawTypeBooth, \'flexible\')\">Flexible</button></li></ul></div><span class=map-btn ng-class=\"{\'active\': drawModeType === drawTypeRoute }\" ng-click=handleDrawModeType(drawTypeRoute) ng-bind=\"\'MAP_CONSTRUCTOR.ROUTE\' | translate\"></span> <span class=map-btn ng-class=\"{\'active\': drawModeType === drawTypeRespZone }\" ng-click=handleDrawModeType(drawTypeRespZone) ng-bind=\"\'MAP_CONSTRUCTOR.RESPONSIBILITY_ZONE\' | translate\"></span> <span class=map-btn ng-class=\"{\'active\': drawModeType === drawTypeEventZone }\" ng-click=handleDrawModeType(drawTypeEventZone) ng-bind=\"\'MAP_CONSTRUCTOR.EVENT_ZONE\' | translate\"></span></div><div ng-if=showIndoorZoom class=\"map-btn-group _right\" id=indoorMapZoomInOutGroup><span class=\"map-btn _zoom\" id=indoorMapZoomIn><i class=\"fa fa-plus\" aria-hidden=true></i></span> <span class=\"map-btn _zoom\" id=indoorMapZoomOut><i class=\"fa fa-minus\" aria-hidden=true></i></span></div><div class=\"form-group form-group-map\" ng-style=\"mapData.type !== \'outdoor\' && {\'position\': \'absolute\',\'top\': \'0px\',\'left\': \'0px\',\'z-index\':\'2\',\'margin-left\':\'8px\'}\"><input class=\"form-control form-control-search\" id=map-search type=text placeholder=Booth ng-model=mapFields.search ng-change=handleMapSearch(mapFields.search) ng-model-options=\"{debounce: 1000}\"></div><div class=\"form-group form-group-map\" ng-if=\"mapData.type === \'outdoor\'\" style=\"position: absolute; top: 0; left: 0; z-index: 2\"><input class=\"form-control form-control-location\" id=map-location type=text placeholder=Location ng-model=mapFields.location ng-model-options=\"{debounce: 1000}\"></div><div map-calculate id=mapWrap style=\"background-color: #ededed\"><div id=map style=\"width: 100%; height: 100%\"></div></div></div></div></div><div class=map-aside-new ng-if=isCreatedNewMapItem ng-click=setFieldRequired()></div><div class=map-aside ng-class=\"{\'-opened\': selectedItem && selectedItem.kind }\"><div class=map-aside-content><button class=\"btn btn-default map-aside-close\" href=# ng-click=handleMapAsideClose()><i class=\"glyphicon glyphicon-remove\"></i></button><!-- Overlay --><div ng-include=\"\'app/users/organizer/map/constructor/overlay/overlay.html\'\" ng-if=\"selectedItem.kind === drawTypeOverlay\"></div><!-- Event Zone --><div ng-include=\"\'app/users/organizer/map/constructor/event-zone/event-zone.html\'\" ng-if=\"selectedItem.kind == drawTypeEventZone\"></div><!-- Resp Zone --><div ng-include=\"\'app/users/organizer/map/constructor/responsibility-zone/responsibility-zone.html\'\" ng-if=\"selectedItem.kind == drawTypeRespZone\"></div><!-- Route --><div ng-include=\"\'app/users/organizer/map/constructor/route/route.html\'\" ng-if=\"selectedItem.kind == drawTypeRoute\"></div><!-- Booth --><div ng-include=\"\'app/users/organizer/map/constructor/booth/booth.html\'\" ng-if=\"selectedItem.kind === drawTypeBooth\"></div></div></div></div>");
$templateCache.put("app/users/organizer/participants/all/all.html","<div class=tab-content ng-controller=\"OrganizerParticipantsAllController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoParticipantAllSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=participantAll ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><select class=form-control name=userGroupsSearch ng-init=\"userGroupsSearch = \'all\'\" ng-model=userGroupsSearch><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"group in vm.userGroups track by $index\" ng-value=group.name ng-bind=group.name></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'Request\'\"></span><select class=form-control name=userRequestSearch ng-init=\"userRequestSearch = \'all\'\" ng-model=userRequestSearch><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option value=noRequest ng-bind=\"\'No requests\'\"></option><option value=noAcceptedRequest ng-bind=\"\'No accepted requests\'\"></option></select></label></div><div class=form-group ng-if=\"vm.participants.length != 0\"><button class=\"btn btn-primary\" type=button ng-click=handleDownload() ng-disabled=\"loadingFile || vm.filterParticipants.length === 0\"><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button></div><div class=\"form-group clearfix\" ng-if=\"vm.requests.length != 0\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=\"vm.participants.length !== 0\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.info\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"participant in vm.filterParticipants = (\n        vm.participants\n        | FilterParticipantSearch: participantAll\n        | FilterRequestParticipant: userRequestSearch: vm.requests\n        | FilterUserGroups: userGroupsSearch\n      ) | orderBy: sortDate: true | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\"><td><h3 class=table-title ng-bind=participant.name></h3><h5 class=table-subtitle ng-bind=participant.username></h5></td><td><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value ng-bind=participant.email></div></div><div class=table-group ng-if=\"participant.phone1.type && participant.phone1.number\"><span class=table-group-label ng-bind=participant.phone1.type></span><div class=table-group-value ng-bind=\"participant.phone1.number | formatPhone\"></div></div><div class=table-group ng-if=\"participant.phone2.type && participant.phone2.number\"><span class=table-group-label ng-bind=participant.phone2.type></span><div class=table-group-value ng-bind=\"participant.phone2.number | formatPhone\"></div></div></td><td><div class=table-group ng-if=participant.userGroups.length><span class=table-group-label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><div class=table-group-value><span ng-repeat=\"group in participant.userGroups track by $index\">{{group}}{{$last ? \'\' : \', \'}}</span></div></div><div class=table-group ng-if=participant.description><span class=table-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=table-group-value ng-bind=participant.description></div></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-primary btn-sm\" ng-click=handleLoginAs(participant) ng-bind=\"\'BUTTON.loginAs\' | translate\"></button> <button class=\"btn btn-default btn-sm\" ng-click=handleEditProfile(participant) ng-bind=\"\'BUTTON.editProfile\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" ng-click=handleDeleteUser(participant) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterParticipants.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterParticipants.length > currentEvent.preferences.itemsPerPage && vm.participants.length != 0\" uib-pagination total-items=vm.filterParticipants.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div ui-view=modal></div>");
$templateCache.put("app/users/organizer/participants/bulk/bulk.html","<bulk-users user-type=participant></bulk-users>");
$templateCache.put("app/users/organizer/participants/modals/bib.modal.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSetBib()><div class=modal-header><h3 class=modal-title ng-bind=\"\'TITLE.dialogSetBib\' | translate\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{\'has-error\': form.bibNumber.$invalid && formSubmitted }\"><label for=bibNumber><span ng-bind=\"\'FORM.label.number\' | translate\"></span></label><input class=form-control id=bibNumber type=bibNumber name=bibNumber placeholder=\"{{\'FORM.placeholder.number\' | translate}}\" ng-model=bibNumber><div class=help-block ng-if=formSubmitted ng-messages=form.bibNumber.$error role=alert><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> {{\'BUTTON.setBib\' | translate}}</button></div></form>");
$templateCache.put("app/users/organizer/participants/requests/requests.html","<div class=tab-content ng-controller=\"OrganizerParticipantsRequestsController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoParticipantRequestSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=participantRequestValue ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.status\' | translate\"></span><select class=form-control name=statusRequest ng-init=\"statusRequest = \'all\'\" ng-model=statusRequest><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"status in statuses track by $index\" ng-value=status ng-bind=status></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><select class=form-control name=checkedIn ng-init=\"checkedIn = \'all\'\" ng-model=checkedIn><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option value=true ng-bind=\"\'FORM.value.yes\' | translate\"></option><option value=false ng-bind=\"\'FORM.value.no\' | translate\"></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.package\' | translate\"></span><select class=form-control name=filterPricePackageID ng-init=\"filterPricePackageID = \'all\'\" ng-model=filterPricePackageID><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"package in vm.pricePackages track by package.id\" ng-bind=package.name ng-value=package.id></option></select></label></div><div class=form-group ng-if=vm.requests.length><button class=\"btn btn-primary\" type=button ng-click=handleDownload() ng-disabled=\"loadingFile || vm.filterParticipants.length === 0\"><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button></div><div class=\"form-group clearfix\" ng-if=\"vm.requests.length != 0\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=\"vm.requests.length !== 0\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.payment\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr pagination-id=request ng-repeat=\"request in vm.filterParticipants = (\n            vm.requests |\n              filter: { status: statusRequest !== \'all\' ? statusRequest : undefined } |\n              filter: { checkedIn: checkedIn !== \'all\' ? checkedIn : undefined } |\n              filter: requestParticipant |\n              filter: filterOnPricePackages\n            ) |\n            orderBy: \'-createdOn\' |\n            FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-bind=request.participant.name></h3><h5 class=table-subtitle ng-bind=request.participant.username></h5><div class=table-group ng-if=request.createdOn><span class=table-group-label ng-bind=\"\'FORM.label.date\' | translate\"></span><div class=table-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=table-group ng-if=request.participant.email><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value><a href=\"mailto:{{ request.participant.email }}\" ng-bind=request.participant.email></a></div></div></td><td><div class=table-group ng-if=request.description><span class=table-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=table-group-value ng-bind=request.description></div></div><div class=table-group ng-if=request.code><span class=table-group-label ng-bind=\"\'FORM.label.code\' | translate\"></span><div class=table-group-value ng-bind=request.code></div></div><div class=table-group ng-if=request.bibNumber><span class=table-group-label ng-bind=\"\'FORM.label.bibNumber\' | translate\"></span><div class=\"table-group-value -bib\" ng-bind=request.bibNumber></div></div><div class=table-group ng-if=request.items><span class=table-group-label ng-bind=\"\'FORM.label.package\' | translate\"></span><ul style=\"margin-bottom: 0; padding-left: 20px\"><li class=table-group-value ng-repeat=\"item in request.items\"><b ng-bind=\"item.pricePackage.name +\' x \'+ item.count +\' \'+ (\n                    item.participantName || item.participantEmail ? \'for:\' : \'\'\n                  )\"></b><div ng-if=item.participantName ng-bind=item.participantName></div><div ng-if=item.participantEmail ng-bind=item.participantEmail></div></li></ul></div></td><td><div class=\"row row-16\"><div class=col-xs-6><div class=table-group ng-if=request.status><span class=table-group-label ng-bind=\"\'FORM.label.status\' | translate\"></span><div class=\"table-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6 ng-if=!onlyForGift(request)><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><div class=table-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></div></div></td><td><div class=\"row row-16\"><div class=col-xs-6 ng-if=request.price><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.price\' | translate\"></span><div class=table-group-value ng-bind=\"\'&#36;\' + request.price\"></div></div></div><div class=col-xs-6 ng-if=request.invoiceStatus><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.paymentStatus\' | translate\"></span><div class=table-group-value ng-bind=request.invoiceStatus></div></div></div></div><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.paymentType\' | translate\"></span> <span class=table-group-value ng-bind=\"request.payCash ? \'Cash/Check payment\' : \'Credit card payment\'\"></span></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-info btn-sm\" ng-if=\"!request.checkedIn && request.status == \'accepted\' && !onlyForGift(request)\" ng-click=handleCheckIn(request) ng-bind=\"\'BUTTON.checkIn\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"request.status == \'pending\' && request.payCash\" ng-click=handleMarkPaid(request) ng-bind=\"\'BUTTON.markPaid\' | translate\"></button><div uib-dropdown class=btn-group style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button><li role=menuitem><button type=button ng-click=handleSetBibNumber(request) ng-bind=\"\'BUTTON.setBib\' | translate\"></button></li><li role=menuitem><button type=button ng-click=onShowNotes(request) ng-bind=\"\'BUTTON.notes\' | translate\"></button></li><li role=menuitem ng-if=\"\n                                      (request.status === \'accepted\' || request.status === \'cancelled\') && \n                                      (request.invoiceStatus && request.invoiceStatus != \'\' )\n                                    \"><button type=button ng-click=handleTransaction(request) ng-bind=\"\'BUTTON.transactions\' | translate\"></button></li><li role=menuitem ng-if=\"request.status === \'accepted\'\"><button type=button ng-click=handleCancel(request) ng-bind=\"\'BUTTON.cancel\' | translate\"></button></li><li role=menuitem><button type=button ng-click=handleDelete(request) ng-bind=\"\'BUTTON.delete\' | translate\"></button></li></ul></div></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterParticipants.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterParticipants.length > currentEvent.preferences.itemsPerPage && vm.filterParticipants.length != 0\" uib-pagination total-items=vm.filterParticipants.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div>");
$templateCache.put("app/users/organizer/participants/reservations/reservations.html","<div ng-controller=\"OrganizerParticipantsReservationsController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=participantRequestValue placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=participantRequestValue ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.status\' | translate\"></span><select class=form-control name=statusRequest ng-init=\"statusRequest = \'all\'\" ng-model=statusRequest><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"status in statuses track by $index\" ng-value=status ng-bind=status></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><select class=form-control name=checkedIn ng-init=\"checkedIn = \'all\'\" ng-model=checkedIn><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option value=true ng-bind=\"\'FORM.value.yes\' | translate\"></option><option value=false ng-bind=\"\'FORM.value.no\' | translate\"></option></select></label></div><div ng-if=loading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!loading><div ng-if=reservations.length><div class=\"form-group clearfix\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.payment\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr pagination-id=request ng-repeat=\"request in vm.filterParticipants = (\n                reservations |\n                  filter: { status: statusRequest !== \'all\' ? statusRequest : undefined } |\n                  filter: { checkedIn: checkedIn !== \'all\' ? checkedIn : undefined } |\n                  filter: requestParticipant\n                ) |\n                orderBy: \'-createdOn\' |\n                FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-bind=request.participant.name></h3><h5 class=table-subtitle ng-bind=request.participant.username></h5><div class=table-group ng-if=request.createdOn><span class=table-group-label ng-bind=\"\'FORM.label.date\' | translate\"></span><div class=table-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=table-group ng-if=request.participant.email><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value><a href=\"mailto:{{ request.participant.email }}\" ng-bind=request.participant.email></a></div></div></td><td><div class=table-group ng-if=request.description><span class=table-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=table-group-value ng-bind=request.description></div></div><div class=table-group ng-if=request.boothName><span class=table-group-label ng-bind=\"\'FORM.label.boothDescription\' | translate\"></span><div class=table-group-value ng-bind=request.boothName></div></div><div class=table-group ng-if=request.code><span class=table-group-label ng-bind=\"\'FORM.label.code\' | translate\"></span><div class=table-group-value ng-bind=request.code></div></div><div class=table-group ng-if=request.timeSlots><span class=table-group-label ng-bind=\"\'FORM.label.slots\' | translate\"></span><ul style=\"margin-bottom: 0; padding-left: 20px\"><li class=table-group-value style=\"white-space: normal\" ng-repeat=\"item in request.timeSlots\"><b ng-bind=toMonth(item.start)></b>&nbsp;-&nbsp;<b ng-bind=toHours(item.end)></b> <span ng-bind=\"\' - $\'+ item.price\"></span></li></ul></div></td><td><div class=\"row row-16\"><div class=col-xs-6><div class=table-group ng-if=request.status><span class=table-group-label ng-bind=\"\'FORM.label.status\' | translate\"></span><div class=\"table-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6 ng-if=!onlyForGift(request)><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><div class=table-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></div></div></td><td><div class=\"row row-16\"><div class=col-xs-6 ng-if=request.price><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.price\' | translate\"></span><div class=table-group-value ng-bind=\"\'&#36;\' + request.price\"></div></div></div><div class=col-xs-6 ng-if=request.invoiceStatus><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.paymentStatus\' | translate\"></span><div class=table-group-value ng-bind=request.invoiceStatus></div></div></div></div><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.paymentType\' | translate\"></span> <span class=table-group-value ng-bind=\"request.payCash ? \'Cash/Check payment\' : \'Credit card payment\'\"></span></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-info btn-sm\" ng-if=\"!request.checkedIn && request.status == \'accepted\'\" ng-click=handleCheckIn(request) ng-bind=\"\'BUTTON.checkIn\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=button ng-if=\"request.status == \'pending\' && request.payCash\" ng-click=handleMarkPaid(request) ng-bind=\"\'BUTTON.markPaid\' | translate\"></button> <button class=\"btn btn-default btn-sm\" type=button ng-if=\"request.status === \'draft\' || request.status === \'pending\'\" ng-click=handleCancel(request) ng-bind=\"\'BUTTON.cancel\' | translate\"></button></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterParticipants.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterParticipants.length > currentEvent.preferences.itemsPerPage && vm.filterParticipants.length != 0\" uib-pagination total-items=vm.filterParticipants.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div class=no-message ng-if=\"reservations.length === 0\"><i class=\"glyphicon glyphicon-calendar\"></i><h3 ng-bind=\"\'TEXT.noReservations\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/participants/teams/teams.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=label></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=name type=text name=name placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.team.name required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group><label ng-bind=\"\'FORM.label.users\' | translate\"></label><ui-select ng-model=vm.usersInTeam close-on-select=false multiple><ui-select-match placeholder=\"{{\'FORM.placeholder.users\' | translate}}\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices refresh=handleUsersSearch($select.search) refresh-delay=0 repeat=\"user in vm.usersSearch | filter: { name: $select.search } | FilterUISelect: vm.usersInGroup\"><span class=ui-select-title ng-bind=user.name></span> <span class=ui-select-describe ng-bind=user.email></span></ui-select-choices></ui-select></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=onClose() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/organizer/participants/teams/teams.html","<div class=tab-content ng-controller=\"OrganizerParticipantsTeamsController as vm\" ng-init=onInit()><div class=clearfix ng-if=eventStatus><button class=\"btn btn-info pull-right\" type=button ng-click=onAdd() ng-bind=\"\'BUTTON.addTeam\' | translate\"></button></div><table class=table ng-if=\"vm.teams.length != 0\"><thead><tr><th ng-bind=\"\'TABLE.name\' | translate\"></th><th ng-if=eventStatus ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"team in vm.teams | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\"><td ng-bind=team.name></td><td ng-if=eventStatus><button class=\"btn btn-default\" ng-click=onUpdate(team) ng-bind=\"\'BUTTON.edit\' | translate\"></button> <button class=\"btn btn-danger btn-icon\" ng-click=onDelete(team) ng-bind=\"\'BUTTON.delete\' | translate\"></button></td></tr></tbody></table><ul ng-if=\"vm.teams.length > currentEvent.preferences.itemsPerPage && vm.teams.length != 0\" uib-pagination total-items=vm.teams.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage direction-links=false></ul></div>");
$templateCache.put("app/users/organizer/scavenger-hunt/check-in-points/check-in-points.html","<div class=tab-content ng-controller=\"OrganizerScavengerHuntCheckinPointsCtrl as vm\" ng-init=onInit()><div class=\"row row-16\"><div class=\"col-xs-12 col-md-4 col-lg-6\"><input class=\"form-control input-sm\" id=scavengerHuntFieldLocation type=text placeholder=Location style=\"margin-top: 10px; max-width: 160px; height: 28px\"><div map-calculate id=scavengerHuntMapWrap style=\"background-color: #ededed\"><div id=scavengerHuntMap style=\"width: 100%; height: 100%\"></div></div><div class=\"visible-xs-block visible-sm-block\" style=\"margin-bottom: 10px\"></div></div><div class=\"col-xs-12 col-md-8 col-lg-6\"><div class=\"form-group clearfix\"><button class=\"btn btn-primary btn-sm | pull-right\" type=button ng-click=onCreatePoint()>Add point</button></div><div ng-if=\"checkinPoints.length > 0\"><table class=table style=\"margin-top: 0; margin-bottom: 0\"><thead><tr><th>Name</th><th>Code</th><th>Lat/Lng</th><th>Order</th><th>Check-in radius(m)</th><th></th></tr></thead><tbody><tr ng-repeat=\"point in checkinPoints | orderBy:\'order\'\"><td ng-bind=point.name></td><td ng-bind=point.code></td><td><p style=\"margin-bottom: 0\"><b>Lat:&nbsp;</b><span ng-bind=point.lat></span></p><p style=\"margin-bottom: 0\"><b>Lng:&nbsp;</b><span ng-bind=point.lng></span></p></td><td ng-bind=point.order></td><td ng-bind=\"point.checkInRadius +\'m\'\"></td><td><button class=\"btn btn-primary btn-sm\" type=button ng-click=onEditPoint(point)>Edit</button> <button class=\"btn btn-danger btn-sm\" type=button ng-click=onDeletePoint(point)>Delete</button></td></tr></tbody></table></div><div class=no-message ng-if=\"checkinPoints.length === 0\"><i class=\"glyphicon glyphicon-map-marker\"></i><h3 ng-bind=\"\'No check-in point(s)\'\"></h3></div></div></div></div>");
$templateCache.put("app/users/organizer/scavenger-hunt/leaderboard/leaderboard.html","<div class=tab-content ng-controller=\"OrganizerScavengerHuntLeaderboardCtrl as vm\" ng-init=onInit()><div ng-if=\"leaderboard.length > 0\"><div class=\"form-group clearfix\"><button class=\"btn btn-primary btn-sm\" type=button ng-click=onExportCSV() ng-disabled=loadingFile><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button></div><div class=leaderboard><div class=leaderboard-user style=\"width: {{ (data.points.length * 320) + 225 + \'px\' }}\" ng-repeat=\"data in participants\"><span class=_user><h5>{{ data.user.name }}</h5><p class=text-muted>{{ data.user.email }}</p></span><div class=leaderboard-user-point ng-repeat=\"point in data.points\"><span class=_name>{{ point.name }}</span><div class=_record><div ng-if=point.record class=text-center><span class=text-danger ng-if=\"point.record.status === \'rejected\'\" title=Rejected><i class=\"fa fa-minus-circle\" style=\"font-size: 28px\" aria-hidden=true></i><div style=\"font-size: 14px\" ng-bind=\"point.record.createdOn | dateFormated\"></div></span><span class=text-success ng-if=\"point.record.status === \'approved\'\" title=Approved><i class=\"fa fa-check-circle\" style=\"font-size: 28px\" aria-hidden=true></i><div style=\"font-size: 14px\" ng-bind=\"point.record.createdOn | dateFormated\"></div></span><span class=text-muted ng-if=\"point.record.status === \'pending\'\" title=Pending><i class=\"fa fa-clock-o\" style=\"font-size: 28px\" aria-hidden=true></i><div style=\"font-size: 14px\" ng-bind=\"point.record.createdOn | dateFormated\"></div></span><button class=\"btn btn-primary btn-sm\" type=button ng-if=\"point.record.status === \'pending\' || point.record.status === \'rejected\'\" ng-click=onApproveCheckin(point) ng-bind=\"\'Approve\'\"></button> <button class=\"btn btn-danger btn-sm\" type=button ng-if=\"point.record.status === \'approved\' || point.record.status === \'pending\'\" ng-click=onRejectCheckin(point) ng-bind=\"\'Reject\'\"></button></div><div ng-if=!point.record class=text-center><b style=\"font-size: 28px\">-</b></div></div></div></div></div><div class=no-message ng-if=\"leaderboard.length === 0\"><i class=\"glyphicon glyphicon-stats\"></i><h3 ng-bind=\"\'No leaderboard\'\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/sponsors/ads/ads.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"label +\' sponsor\'\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.sponsorAdName.$invalid && formSubmitted }\"><label for=sponsorAdName><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=sponsorAdName type=text name=sponsorAdName placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.sponsorAd.name required><div class=help-block ng-if=formSubmitted ng-messages=form.sponsorAdName.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group><label for=sponsorAdWebsite><span ng-bind=\"\'FORM.label.website\' | translate\"></span></label><input class=form-control id=sponsorAdWebsite type=text name=sponsorAdWebsite placeholder=\"{{\'FORM.placeholder.website\' | translate}}\" ng-model=vm.sponsorAd.website></div><div class=\"row row-16\"><div class=\"col-xs-12 col-sm-6\"><label for=sponsorId ng-bind=\"\'FORM.label.users\' | translate\"></label><select class=form-control id=sponsorId name=sponsorId ng-model=vm.sponsorAd.sponsorId><option value=\"\" ng-bind=\"\'FORM.value.chooseUser\' | translate\"></option><option ng-repeat=\"sponsor in vm.sponsors\" ng-value=sponsor.id ng-bind=sponsor.username></option></select></div><div class=\"col-xs-12 col-sm-6\"><label for=order ng-bind=\"\'FORM.label.order\' | translate\"></label><input class=form-control id=order type=number name=order placeholder=\"{{\'FORM.placeholder.order\' | translate}}\" ng-model=vm.sponsorAd.order></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=checkbox><label><input type=checkbox name=enabled ng-model=vm.sponsorAd.enabled> <span ng-bind=\"\'FORM.label.enabled\' | translate\"></span></label></div></div><div class=col-xs-6><div class=checkbox><label><input type=checkbox name=headline ng-model=vm.sponsorAd.headline> <span ng-bind=\"\'FORM.label.featured\' | translate\"></span></label></div></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=checkbox><label><input type=checkbox name=ladingPage ng-model=vm.sponsorAd.landingPage> <span ng-bind=\"\'FORM.value.landingPage\' | translate\"></span></label></div></div><div class=col-xs-6><div class=checkbox><label><input type=checkbox name=innerPages ng-model=vm.sponsorAd.innerPages> <span ng-bind=\"\'FORM.value.innerPages\' | translate\"></span></label></div></div></div><!-- Valid from/to --><div class=\"row row-16\"><div class=col-xs-6><div class=form-group ng-class=\"{ \'has-error\': form.adStartDate.$invalid && formSubmitted }\"><label for=adStartDate><span ng-bind=\"\'FORM.label.validFrom\' | translate\"></span> <span ng-if=isRequired>&nbsp;*</span></label><div class=input-group><input type=date name=adStartDate ng-model=vm.adStartDate max={{vm.adEndDate}} class=hidden ng-required=isRequired> <span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=onPopup1Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=startDate ng-model=vm.startDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=popup1.opened show-button-bar=false ng-disabled=!eventStatus ng-required=isRequired ng-change=\"vm.adStartDate = vm.startDate\"></div><div class=help-block ng-if=formSubmitted ng-messages=form.adStartDate.$error role=alert><div ng-message=max ng-bind=\"\'Start date is more than end\'\"></div><div ng-message=date ng-bind=\"\'FORM.validation.invalidDate\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><!-- <div class=\"form-group\" ng-class=\"{ \'has-error\': form.startTime.$touched && form.startTime.$invalid }\">\n          <label for=\"startTime\">Valid from time</label>\n          <div uib-timepicker ng-model=\"vm.startTime\" ng-disabled=\"!eventStatus\" name=\"startTime\" ng-change=\"changed()\" show-meridian=\"true\" required></div>\n          <div class=\"help-block\"  ng-if=\"form.startTime.$touched\" ng-messages=\"form.startTime.$error\" role=\"alert\">\n            <div ng-message=\"time\">Time is not correct</div>\n            <div ng-message=\"required\" ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div>\n          </div>\n        </div> --></div><div class=col-xs-6><div class=form-group ng-class=\"{ \'has-error\': form.adEndDate.$invalid && formSubmitted }\"><label for=adEndDate><span ng-bind=\"\'FORM.label.validTo\' | translate\"></span> <span ng-if=isRequired>&nbsp;*</span></label><div class=input-group><input type=date name=adEndDate ng-model=vm.adEndDate class=hidden ng-required=isRequired> <span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=onPopup2Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=endDate ng-model=vm.endDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=popup2.opened show-button-bar=false ng-disabled=!eventStatus ng-required=isRequired ng-change=\"vm.adEndDate = vm.endDate\"></div><div class=help-block ng-if=formSubmitted ng-messages=form.adEndDate.$error role=alert><div ng-message=date ng-bind=\"\'FORM.validation.invalidDate\' | translate\"></div><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><!-- <div class=\"form-group\" ng-class=\"{ \'has-error\': form.endTime.$touched && form.endTime.$invalid }\">\n          <label for=\"endTime\">Valid to time</label>\n          <div uib-timepicker ng-model=\"vm.endTime\" ng-disabled=\"!eventStatus\" name=\"endTime\" ng-change=\"changed()\" show-meridian=\"true\" required></div>\n          <div class=\"help-block\"  ng-if=\"form.endTime.$touched\" ng-messages=\"form.endTime.$error\" role=\"alert\">\n            <div ng-message=\"time\">Time is not correct</div>\n            <div ng-message=\"required\" ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div>\n          </div>\n        </div> --></div></div><div class=form-group><label>Background Image</label><upload-file ng-model=vm.link.logo ng-files=\"{{ vm.sponsorAd.logo }}\" uf-can-remove=true ng-accept=image/*></upload-file></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button data-dismiss=modal ng-click=handleCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=label></span></button></div></form>");
$templateCache.put("app/users/organizer/sponsors/ads/ads.html","<div ng-controller=\"OrganizerSponsorsAdsController as vm\" ng-init=onInit()><div class=clearfix ng-if=eventStatus><button class=\"btn btn-info pull-right\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.addSponsorAd\' | translate\"></button></div><div class=\"row row-flex row-16\" ng-if=\"vm.sponsors.length != 0\"><div class=\"col-sm-6 col-md-4 col-lg-3\" style=\"margin-top: 16px\" ng-repeat=\"sponsor in vm.sponsors | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\"><div class=\"card card-default\"><div class=card-head><h2 class=card-title><a ng-href=\"{{ sponsor.website }}\" target=_blank ng-bind=sponsor.name></a></h2></div><div class=card-body><div class=card-cell><div class=card-group><div class=card-group-image ng-if=\"sponsor.logo && sponsor.logo.link\"><img ng-src=\"{{ sponsor.logo.link }}\" alt={{sponsor.name}}></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.enabled\' | translate\"></span> <span class=card-group-value ng-bind=\"sponsor.enabled ? \'Yes\' : \'No\'\"></span></div></div><div class=col-xs-6><div class=card-group><span class=card-group-label ng-bind=\"\'FORM.label.featured\' | translate\"></span> <span class=card-group-value ng-bind=\"sponsor.headline ? \'Yes\' : \'No\'\"></span></div></div></div><div class=card-group ng-if=sponsor.order><span class=card-group-label ng-bind=\"\'FORM.label.order\' | translate\"></span> <span class=card-group-value ng-bind=sponsor.order></span></div><div class=card-group ng-if=sponsor.validFrom><span class=card-group-label ng-bind=\"\'FORM.label.validFrom\' | translate\"></span> <span class=card-group-value ng-bind=\"sponsor.validFrom | dateFormated\"></span></div><div class=card-group ng-if=sponsor.validTo><span class=card-group-label ng-bind=\"\'FORM.label.validTo\' | translate\"></span> <span class=card-group-value ng-bind=\"sponsor.validTo | dateFormated\"></span></div></div></div><div class=card-foot ng-if=eventStatus><button class=\"btn btn-default btn-sm\" ng-click=handleEdit(sponsor) ng-bind=\"\'BUTTON.edit\' | translate\"><button class=\"btn btn-danger btn-sm\" ng-click=handleDelete(sponsor) ng-bind=\"\'BUTTON.delete\' | translate\"></button></button></div></div></div></div><ul ng-if=\"vm.sponsors.length > currentEvent.preferences.itemsPerPage && vm.sponsors.length != 0\" uib-pagination total-items=vm.sponsors.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage direction-links=false></ul></div>");
$templateCache.put("app/users/organizer/sponsors/all/all.html","<div class=tab-content ng-controller=\"OrganizerSponsorsAllController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoSponsorAllSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=sponsorAll ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><select class=form-control name=userGroupsSearch ng-init=\"userGroupsSearch = \'all\'\" ng-model=userGroupsSearch><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"group in vm.userGroups track by $index\" ng-value=group.name ng-bind=group.name></option></select></label></div><div class=form-group ng-if=vm.sponsors.length><button class=\"btn btn-primary\" type=button ng-click=handleDownload() ng-disabled=\"loadingFile || vm.filterSponsors.length === 0\"><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button></div><div class=\"form-group clearfix\" ng-if=vm.sponsors.length><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=vm.sponsors.length ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.info\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"sponsor in vm.filterSponsors = (\n        vm.sponsors\n        | FilterSponsorSearch: sponsorAll\n        | FilterUserGroups: userGroupsSearch\n      ) | orderBy: sortDate: true | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-bind=sponsor.name></h3><h5 class=table-subtitle ng-bind=sponsor.username></h5></td><td><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value ng-bind=sponsor.email></div></div><div class=table-group ng-if=\"sponsor.phone1.type && sponsor.phone1.number\"><span class=table-group-label ng-bind=sponsor.phone1.type></span><div class=table-group-value ng-bind=\"sponsor.phone1.number | formatPhone\"></div></div><div class=table-group ng-if=\"sponsor.phone2.type && sponsor.phone2.number\"><span class=table-group-label ng-bind=sponsor.phone2.type></span><div class=table-group-value ng-bind=\"sponsor.phone2.number | formatPhone\"></div></div></td><td><div class=table-group ng-if=sponsor.userGroups.length><span class=table-group-label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><div class=table-group-value><span ng-repeat=\"group in sponsor.userGroups track by $index\">{{group}}{{$last ? \'\' : \', \'}}</span></div></div><div class=table-group ng-if=sponsor.description><span class=table-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=table-group-value ng-bind=sponsor.description></div></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-primary btn-sm\" ng-click=handleLoginAs(sponsor) ng-bind=\"\'BUTTON.loginAs\' | translate\"></button> <button class=\"btn btn-default btn-sm\" ng-click=handleEditProfile(sponsor) ng-bind=\"\'BUTTON.editProfile\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" ng-click=handleDeleteUser(sponsor) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterSponsors.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterSponsors.length > currentEvent.preferences.itemsPerPage && vm.sponsors.length != 0\" uib-pagination total-items=vm.filterSponsors.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div ui-view=modal></div>");
$templateCache.put("app/users/organizer/sponsors/attendants/attendants.html","<div class=tab-content ng-controller=\"OrganizerSponsorAttendantController as vm\" ng-init=onInit()><div ng-if=pageLoading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!pageLoading><div ng-if=attendantRequests.length><div class=\"form-group clearfix\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=\"attendantRequests.length !== 0\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"request in attendantRequests | orderBy: \'-createdOn\' | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-if=request.user.name ng-bind=request.user.name></h3><h5 class=table-subtitle ng-bind=request.user.username></h5><div class=table-group ng-if=request.createdOn><span class=table-group-label ng-bind=\"\'FORM.label.date\' | translate\"></span><div class=table-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=table-group ng-if=request.user.email><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value><a href=\"mailto:{{ request.user.email }}\" ng-bind=request.user.email></a></div></div></td><td><div class=table-group ng-if=request.status><span class=table-group-label ng-bind=\"\'FORM.label.status\' | translate\"></span><div class=\"table-group-value {{request.status}}\" ng-bind=request.status></div></div><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><div class=table-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-info btn-sm\" type=button ng-if=!request.checkedIn ng-click=onCheckInAttendant(request) ng-bind=\"\'BUTTON.checkIn\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" type=button ng-click=onDeleteAttendant(request.user) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"attendantRequests.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"attendantRequests.length > currentEvent.preferences.itemsPerPage && attendantRequests.length != 0\" uib-pagination total-items=attendantRequests.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div class=no-message ng-if=\"attendantRequests.length === 0\"><i class=\"fa fa-users\" aria-hidden=true></i><h3 ng-bind=\"\'TEXT.noAttendantRequests\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/sponsors/bulk/bulk.html","<bulk-users user-type=sponsor></bulk-users>");
$templateCache.put("app/users/organizer/sponsors/requests/requests.form.html","<div ng-init=onInit()><div class=modal-header><h3 class=modal-title id=modal-title ng-bind=\"\'TITLE.dialogProfileVisibility\' | translate\"></h3></div><div class=modal-body><div class=form-group><label ng-bind=\"\'FORM.label.profileVisibility\' | translate\"></label><input type=hidden ng-model=requestData.profileVisibility><div class=checkbox ng-repeat=\"item in visibility track by $index\"><label><input type=checkbox value=\"{{ item.value }}\" ng-click=profileChecked(item.value) ng-checked=\"requestData.profileVisibility.indexOf(item.value) > -1\"> <i class=label></i> {{ item.name }}</label></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleClose() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary\" type=button ng-click=handleSubmit() ng-bind=\"\'BUTTON.update\' | translate\"></button></div></div>");
$templateCache.put("app/users/organizer/sponsors/requests/requests.html","<div class=tab-content ng-controller=\"OrganizerSponsorsRequestsController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoSponsorRequestSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=sponsorRequestValue ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.status\' | translate\"></span><select class=form-control name=statusRequest ng-init=\"statusRequest = \'all\'\" ng-model=statusRequest><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"status in vm.statuses track by $index\" ng-value=status ng-bind=status></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><select class=form-control name=checkedIn ng-init=\"checkedIn = \'all\'\" ng-model=checkedIn><option value=all ng-bind=\"\'FORM.value.all\'  | translate\"></option><option value=true ng-bind=\"\'FORM.value.yes\' | translate\"></option><option value=false ng-bind=\"\'FORM.value.no\' | translate\"></option></select></label></div><div class=\"form-group clearfix\" ng-if=\"vm.requests.length != 0\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=\"vm.requests.length !== 0\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.payment\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"request in vm.filterSponsors = (\n        vm.requests\n        | filter: { status: statusRequest !== \'all\' ? statusRequest : undefined }\n        | filter: requestSponsor\n        | filter: { checkedIn: checkedIn !== \'all\' ? checkedIn : undefined }\n      ) | orderBy: \'-createdOn\' | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-if=request.sponsor.name ng-bind=request.sponsor.name></h3><h5 class=table-subtitle ng-bind=request.sponsor.username></h5><div class=table-group ng-if=request.createdOn><span class=table-group-label ng-bind=\"\'FORM.label.date\' | translate\"></span><div class=table-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=table-group ng-if=request.sponsor.email><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value><a href=\"mailto:{{ request.sponsor.email }}\" ng-bind=request.sponsor.email></a></div></div></td><td><div class=table-group ng-if=request.pricePackage><span class=table-group-label ng-bind=\"\'FORM.label.package\' | translate\"></span><div class=table-group-value ng-bind=\"request.pricePackage.name +\'&nbsp;($\'+ request.pricePackage.price +\')\'\"></div></div></td><td><div class=\"row row-16\"><div class=col-xs-6><div class=table-group ng-if=request.status><span class=table-group-label ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"table-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6><div class=table-group><span class=table-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=table-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></div></div></td><td><div class=\"row row-16\"><div class=col-xs-4 ng-if=request.price><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.price\' | translate\"></span><div class=table-group-value ng-bind=\"\'&#36;\' + request.price\"></div></div></div><div class=col-xs-8><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.paymentType\' | translate\"></span> <span class=table-group-value ng-bind=\"request.payCash ? \'Cash/Check payment\' : \'Credit card payment\'\"></span></div></div></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-info btn-sm\" type=button ng-if=\"request.status === \'accepted\' && !request.checkedIn\" ng-click=handleCheckIn(request) ng-bind=\"\'BUTTON.checkIn\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"request.status === \'pending\' && request.payCash\" ng-click=handleMarkPaid(request) ng-disabled=vm.loadingMarkPaid><i ng-if=vm.loadingMarkPaid class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.markPaid\' | translate\"></span></button><div uib-dropdown class=btn-group style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button><li role=menuitem><button type=button ng-click=onShowNotes(request) ng-bind=\"\'BUTTON.notes\' | translate\"></button></li><li role=menuitem><button type=button ng-click=handleProfileVisibility(request) ng-bind=\"\'BUTTON.profileVisibility\' | translate\"></button></li><li role=menuitem ng-if=\"request.status == \'accepted\' && ( request.invoiceStatus && request.invoiceStatus != \'\' )\"><button type=button ng-click=handleTransaction(request) ng-bind=\"\'BUTTON.transactions\' | translate\"></button></li><li role=menuitem><button type=button ng-click=handleDelete(request) ng-bind=\"\'BUTTON.delete\' | translate\"></button></li></ul></div></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterSponsors.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterSponsors.length > currentEvent.preferences.itemsPerPage && vm.filterSponsors.length != 0\" uib-pagination total-items=vm.filterSponsors.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div>");
$templateCache.put("app/users/organizer/user-groups/details/details.html","<div ng-controller=\"OrganizerUserGroupDetailsController as vm\" ng-init=onInit()><div class=\"form-group clearfix\" ng-if=eventStatus><a ui-sref=users.organizer.userGroups.list class=\"btn btn-default btn-sm pull-left\" role=link ng-bind=\"\'BUTTON.back\' | translate\"></a></div><div ng-if=pageLoading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!pageLoading><div ng-if=users.length><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=groupUserSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=groupUserSearch ng-model-options=\"{debounce: 1000}\"></label></div><div class=\"form-group clearfix\"><button class=\"btn btn-info btn-sm pull-left\" role=button ng-click=handleDownload() ng-disabled=\"loadingFile || vm.filterSponsors.length === 0\" ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></button></div><div class=\"form-group clearfix\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><h4><span ng-bind=\"\'User group:\'\"></span>&nbsp;<b ng-bind=currentUserGroup.name></b></h4><table class=\"table table-request\" ng-if=users.length ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.info\' | translate\"></th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.filterUsers = (\n            users\n            | FilterMapSearch: groupUserSearch\n           ) | orderBy: \'-createdOn\' | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-if=user.name ng-bind=user.name></h3><h5 class=table-subtitle ng-bind=user.username></h5></td><td><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value ng-bind=user.email></div></div><div class=table-group ng-if=user.type><span class=table-group-label ng-bind=\"\'FORM.label.type\' | translate\"></span><div class=\"table-group-value {{ user.type === \'vendor\' ? \'invoiced\' : user.type === \'volunteer\' ? \'cancelled\' : user.type === \'sponsor\' ? \'declined\' : user.type === \'special\' ? \'accepted\' : user.type === \'eventCoordinator\' ? \'pending\' : user.type === \'volunteerCoordinator\' ? \'pending\' : \'pending\' }}\" ng-bind=user.type></div></div><div class=table-group ng-if=\"user.phone1.type && user.phone1.number\"><span class=table-group-label ng-bind=user.phone1.type></span><div class=table-group-value ng-bind=\"user.phone1.number | formatPhone\"></div></div><div class=table-group ng-if=\"user.phone2.type && user.phone2.number\"><span class=table-group-label ng-bind=user.phone2.type></span><div class=table-group-value ng-bind=\"user.phone2.number | formatPhone\"></div></div></td><td><div class=table-group ng-if=user.description><span class=table-group-label ng-bind=\"\'LABEL.DESCRIPTION\' | translate\"></span><div class=table-group-value ng-bind=user.description></div></div></td><td class=-actions></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"users.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"users.length > currentEvent.preferences.itemsPerPage && users.length != 0\" uib-pagination total-items=users.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div class=no-message ng-if=\"users.length === 0\"><i class=\"fa fa-users\" aria-hidden=true></i><h3 ng-bind=\"\'TEXT.noUsers\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/user-groups/form/form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title><span ng-bind=label></span> user group</h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && formSubmitted }\"><label for=name><span ng-bind=\"\'FORM.label.name\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control id=name type=text name=name placeholder=\"{{\'FORM.placeholder.name\' | translate}}\" ng-model=vm.userGroup.name required><div class=help-block ng-if=formSubmitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group><label ng-bind=\"\'FORM.label.users\' | translate\"></label><ui-select ng-model=vm.usersInGroup close-on-select=false multiple><ui-select-match placeholder=\"{{\'FORM.placeholder.searchUsers\' | translate}}\"><span ng-bind=$item.name></span></ui-select-match><ui-select-choices refresh=handleUsersSearch($select.search) refresh-delay=0 repeat=\"user in vm.usersSearch | filter: { name: $select.search } | FilterUISelect: vm.usersInGroup\"><span class=ui-select-title ng-bind=user.name></span> <span class=ui-select-describe ng-bind=user.email></span><div class=ui-select-describe><b>Type:&nbsp;</b><span ng-bind=userType(user.type)></span></div></ui-select-choices></ui-select></div><div class=form-group><div class=checkbox><label><input type=checkbox name=mapFullAccess ng-model=vm.userGroup.preferences.mapFullAccess> <span ng-bind=\"\'FORM.value.mapFullAccess\' | translate\"></span></label></div><div class=checkbox><label><input type=checkbox name=allowSendMessages ng-model=vm.userGroup.preferences.allowSendMessages> <span ng-bind=\"\'FORM.value.allowSendMessages\' | translate\"></span></label></div><div class=checkbox ng-if=vm.userGroup.preferences.allowSendMessages><label><input type=checkbox name=allowBulkMailSend ng-model=vm.userGroup.preferences.allowBulkMailSend> <span ng-bind=\"\'FORM.value.allowBulkMailSend\' | translate\"></span></label></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button data-dismiss=modal ng-click=onClose() ng-bind=\"\'BUTTON.close\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading ng-bind=label></button></div></form>");
$templateCache.put("app/users/organizer/user-groups/list/list.html","<div ng-controller=\"OrganizerUserGroupsListController as vm\" ng-init=onInit()><div class=clearfix ng-if=eventStatus><button class=\"btn btn-info btn-sm pull-right\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.create\' | translate\"></button></div><table class=table ng-if=\"vm.userGroups.length != 0\"><thead><tr><th ng-bind=\"\'TABLE.group\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"group in vm.userGroups | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\"><td ng-bind=group.name></td><td><div ng-if=eventStatus><a class=\"btn btn-default btn-sm\" ng-click=handleEdit(group) ng-bind=\"\'BUTTON.edit\' | translate\"></a> <a ui-sref=\"users.organizer.userGroups.details({id: group.id})\" class=\"btn btn-info btn-sm\" role=link ng-bind=\"\'BUTTON.details\' | translate\"></a> <button class=\"btn btn-danger btn-sm\" type=button ng-click=handleDelete(group) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></td></tr></tbody></table><!-- <ul ng-if=\"vm.userGroups.length > currentEvent.preferences.itemsPerPage && vm.userGroups.length != 0\"\n      uib-pagination\n      total-items=\"vm.userGroups.length\"\n      items-per-page=\"currentEvent.preferences.itemsPerPage\"\n      ng-model=\"vm.currentPage\"\n      direction-links=\"false\">\n  </ul> --><div class=total><div class=total-label ng-if=\"vm.userGroups.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.userGroups.length > currentEvent.preferences.itemsPerPage && vm.userGroups.length != 0\" uib-pagination total-items=vm.userGroups.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><!-- <div ui-view=\"modal\"></div> -->");
$templateCache.put("app/users/organizer/vendors/all/all.html","<div class=tab-content ng-controller=\"OrganizerVendorsAllController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoVendorAllSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=vendorAll ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><select class=form-control name=userGroupsSearch ng-init=\"userGroupsSearch = \'all\'\" ng-model=userGroupsSearch><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"group in vm.userGroups track by $index\" ng-value=group.name ng-bind=group.name></option></select></label><label class=form-group><span class=label></span> <input type=checkbox name=idleUsers ng-model=idleUsers> <span ng-bind=\"\'FORM.value.showIdleOnly\' | translate\"></span></label></div><div class=form-group ng-if=\"vm.vendors.length != 0\"><button class=\"btn btn-primary\" type=button ng-click=handleDownload() ng-disabled=\"loadingFile || vm.filterVendors.length === 0\"><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button></div><div class=\"form-group clearfix\" ng-if=\"vm.vendors.length != 0\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=\"vm.vendors.length !== 0\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.vendor\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.info\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"vendor in vm.filterVendors = (\n        vm.vendors  |\n        FilterVendorSearch: vendorAll |\n        FilterUserGroups: userGroupsSearch |\n        FilterIdleUsers: idleUsers: vm.requests\n      ) | orderBy: sortDate: true | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage\"><td><h3 class=table-title ng-bind=vendor.name></h3><h5 class=table-subtitle ng-bind=vendor.username></h5></td><td><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value ng-bind=vendor.email></div></div><div class=\"row row-16\"><div class=col-xs-12 ng-if=\"vendor.phone1.type && vendor.phone1.number\"><div class=table-group><span class=table-group-label ng-bind=vendor.phone1.type></span><div class=table-group-value ng-bind=\"vendor.phone1.number | formatPhone\"></div></div></div><div class=col-xs-12 ng-if=\"vendor.phone2.type && vendor.phone2.number\"><div class=table-group><span class=table-group-label ng-bind=vendor.phone2.type></span><div class=table-group-value ng-bind=\"vendor.phone2.number | formatPhone\"></div></div></div></div></td><td><div class=table-group ng-if=vendor.userGroups.length><span class=table-group-label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><div class=table-group-value><span ng-repeat=\"group in vendor.userGroups track by $index\">{{group}}{{$last ? \'\' : \', \'}}</span></div></div><div class=table-group ng-if=vendor.description><span class=table-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=table-group-value ng-bind=vendor.description></div></div><div class=table-group ng-if=vendor.goodsCategories><span class=table-group-label ng-bind=\"\'FORM.label.goodsCategories\' | translate\"></span><div class=table-group-value ng-bind=vendor.goodsCategories></div></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-primary btn-sm\" ng-click=handleLoginAs(vendor) ng-bind=\"\'BUTTON.loginAs\' | translate\"></button> <button class=\"btn btn-default btn-sm\" ng-click=handleEditProfile(vendor) ng-bind=\"\'BUTTON.editProfile\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" ng-click=handleDeleteUser(vendor) ng-bind=\"\'BUTTON.delete\' | translate\"></button></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterVendors.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterVendors.length > currentEvent.preferences.itemsPerPage && vm.vendors.length != 0\" uib-pagination total-items=vm.filterVendors.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div ui-view=modal></div>");
$templateCache.put("app/users/organizer/vendors/bulk/bulk.html","<bulk-users user-type=vendor></bulk-users>");
$templateCache.put("app/users/organizer/vendors/requests/requests.form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=\"label +\' request\'\"></h3></div><div class=modal-body><div class=form-group ng-class=\"{ \'has-error\': form.goodsCategory.$invalid && formSubmitted }\"><label for=goodsCategory>Goods category<span>&nbsp;*</span></label><select class=form-control id=goodsCategory name=goodsCategory ng-options=\"category as category.name for category in vm.categories track by category.id\" ng-model=vm.request.goodsCategory required></select><div class=help-block ng-if=formSubmitted ng-messages=form.goodsCategory.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group><label for=description>Description</label><textarea class=form-control id=description type=text name=description placeholder=Description ng-model=vm.request.description></textarea></div><div class=form-group><label for=individualFeaturedItems>Individual featured items</label><textarea class=form-control id=individualFeaturedItems type=text name=individualFeaturedItems placeholder=\"Individual featured items\" ng-model=vm.request.individualFeaturedItems>\n      </textarea></div><div class=form-group><label>Profile visibility</label><input type=hidden ng-model=vm.request.profileVisibility><div class=checkbox ng-repeat=\"item in visibility track by $index\"><label><input type=checkbox value=\"{{ item.value }}\" ng-click=profileChecked(item.value) ng-checked=\"vm.request.profileVisibility.indexOf(item.value) > -1\"> <i class=label></i> {{ item.name }}</label></div></div><div class=form-group><label class=package>Price package</label><select class=form-control id=packages name=packages ng-model=vm.modelPackage ng-options=\"price as price.name for price in vm.prices track by price.id\" ng-change=handlePricePackage()><option value=\"\">Choose package</option></select></div><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=form-group><label class=price>Price</label><div class=input-group ng-if=\"vm.modelPackage.price > 0\"><div class=input-group-addon>&#36;</div><input class=form-control id=price name=price type=number placeholder=Price ng-model=vm.modelPackage.price></div><p class=form-control-static ng-if=\"vm.modelPackage.price === 0\">Free</p></div></div><div class=\"col-xs-12 col-sm-6\"><div class=form-group ng-class=\"{ \'has-error\': form.startDate.$touched && form.startDate.$invalid }\"><label for=date>Due Date</label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=handleDatepickerPopup()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=startDate ng-model=vm.startDate uib-datepicker-popup=\"{{ datepickerFormat }}\" datepicker-options=datepickerOptions is-open=datepickerPopup.opened show-button-bar=false></div><div class=help-block ng-if=form.startDate.$touched ng-messages=form.startDate.$error role=alert><div ng-message=date>Date is not correct</div></div></div></div></div><div class=form-group><label>Booths Photos</label><upload-file ng-model=vm.files ng-files=\"{{ vm.request.boothPhotos }}\" ng-multiple=true ng-max-length=5></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button data-dismiss=modal ng-bind=\"\'BUTTON.close\' | translate\" ng-click=handleCancel()></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> {{label}}</button></div></form>");
$templateCache.put("app/users/organizer/vendors/requests/requests.html","<div class=tab-content ng-controller=\"OrganizerVendorsRequestsController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoVendorRequestSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=vendorRequestValue ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.status\' | translate\"></span><select class=form-control name=statusRequest ng-init=\"statusRequest = \'all\'\" ng-model=statusRequest><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"status in statuses track by $index\" ng-value=status ng-bind=status></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.categories\' | translate\"></span><select class=form-control name=categoryRequest ng-init=\"categoryRequest = \'all\'\" ng-model=categoryRequest><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"category in vm.categories track by $index\" ng-value=category.name ng-bind=category.name></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><select class=form-control name=checkedIn ng-init=\"checkedIn = \'all\'\" ng-model=checkedIn><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option value=true ng-bind=\"\'FORM.value.yes\' | translate\"></option><option value=false ng-bind=\"\'FORM.value.no\' | translate\"></option></select></label></div><div class=form-group ng-if=vm.requests.length><button class=\"btn btn-primary\" type=button ng-click=handleDownload() ng-disabled=\"loadingFile || vm.filterVendors.length === 0\"><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button></div><div class=form-group><div class=checkbox><label><input type=checkbox name=showAssignedToBooth ng-model=showAssignedToBooth> <span ng-bind=\"\'FORM.value.showAssignedToBoothOnly\' | translate\"></span></label></div></div><div class=\"form-group clearfix\" ng-if=vm.requests.length><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=vm.requests.length ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.vendor\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.booth\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.payment\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr pagination-id=request ng-repeat=\"request in vm.filterVendors = (\n            vm.requests |\n            filter: { status: statusRequest !== \'all\' ? statusRequest : undefined } |\n            filter: { checkedIn: checkedIn !== \'all\' ? checkedIn : undefined } |\n            filter: { goodsCategory: { name: categoryRequest !== \'all\' ? categoryRequest : undefined }} |\n            filter: showAssignedToBoothOnly |\n            filter: requestVendor\n            ) |\n            orderBy: \'-createdOn\' |\n            FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-bind=request.vendor.name></h3><h5 class=table-subtitle ng-bind=request.vendor.username></h5><div class=table-group ng-if=request.createdOn><span class=table-group-label ng-bind=\"\'FORM.label.date\' | translate\"></span><div class=table-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=table-group ng-if=request.vendor.email><span class=table-group-label ng-bind=\"\'FORM.label.email\' | translate\"></span><div class=table-group-value><a href=\"mailto:{{ request.vendor.email }}\" ng-bind=request.vendor.email></a></div></div></td><td><div class=table-group ng-if=request.description><span class=table-group-label ng-bind=\"\'FORM.label.description\' | translate\"></span><div class=table-group-value ng-bind=request.description></div></div><div class=table-group ng-if=request.individualFeaturedItems><span class=table-group-label ng-bind=\"\'FORM.label.individualFeaturedItems\' | translate\"></span><div class=table-group-value ng-bind=request.individualFeaturedItems></div></div></td><td><div class=\"row row-16\"><div class=col-xs-6><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.booth\' | translate\"></span><div class=table-group-value ng-bind=\"request.booth || \'Not Assigned\'\"></div></div></div><div class=col-xs-6 ng-if=request.goodsCategory.name><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.category\' | translate\"></span><div class=table-group-value ng-bind=request.goodsCategory.name></div></div></div></div></td><td><div class=\"row row-16\"><div class=col-xs-6><div class=table-group ng-show=request.status><span class=table-group-label ng-bind=\"\'FORM.label.status\' | translate\"></span><div class=\"table-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><div class=table-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></div></div></td><td><div class=\"row row-16\"><div class=col-xs-6 ng-if=request.price><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.price\' | translate\"></span><div class=table-group-value ng-bind=\"\'&#36;\' + request.price\"></div></div></div><div class=col-xs-6 ng-if=request.invoiceStatus><div class=table-group><span class=table-group-label ng-bind=\"\'FORM.label.paymentStatus\' | translate\"></span><div class=table-group-value ng-bind=request.invoiceStatus></div></div></div></div><div class=table-group ng-if=request.invoiceDueDate><span class=table-group-label ng-bind=\"\'FORM.label.invoiceDueDate\' | translate\"></span><div class=table-group-value ng-bind=\"request.invoiceDueDate | dateFormated\"></div></div><div class=table-group ng-if=request.invoiceSubmitDate><span class=table-group-label ng-bind=\"\'FORM.label.paymentDate\' | translate\"></span><div class=table-group-value ng-bind=\"request.invoiceSubmitDate | dateFormated\"></div></div></td><td class=-actions><div ng-if=eventStatus><!-- <button class=\"btn btn-success btn-sm\"\n                    ng-if=\"(request.status == \'draft\' || request.status == \'pending\' || request.status == \'invoiced\')\"\n                    ng-click=\"handleAccept(request)\">\n              Accept\n            </button> --> <button class=\"btn btn-success btn-sm\" ng-if=\"(request.status == \'draft\' || request.status == \'pending\' || request.status == \'invoiced\')\" ng-click=handleMarkPaid(request) ng-bind=\"\'BUTTON.markPaid\' | translate\"></button><div style=\"display: inline-block; margin-left: 4px; margin-right: 4px\" ng-if=\"\n                    (request.status === \'invoiced\' || request.status === \'pending\' || request.status === \'draft\') && request.price &&\n                    currentEvent.billingPreferences\n                  \"><button class=\"btn btn-info btn-sm\" ng-disabled=\"request.price === 0\" ng-if=\"currentEvent.billingPreferences.serviceType === \'stripe\'\" ng-click=\"handleStripeButton({publishableKey: currentEvent.billingPreferences.publishableKey}, request)\"><span ng-bind=\"\'BUTTON.pay\' | translate\"></span>&nbsp;<span ng-bind=\"request.price + \'$\'\"></span></button> <button class=\"btn btn-info btn-sm\" ng-disabled=\"request.price == 0\" ng-if=\"currentEvent.billingPreferences.serviceType === \'transactionexpress\'\" ng-click=\"handleTransactionButton({\n                  hostedKey: vm.event.billingPreferences.hostedKey,\n                  gatewayId: vm.event.billingPreferences.gatewayId,\n                  hostedPageUrl: vm.event.billingPreferences.hostedPageUrl,\n                  callback: \'organizer/vendors/requests\'\n                }, request)\"><span ng-bind=\"\'BUTTON.pay\' | translate\"></span>&nbsp;<span ng-bind=\"request.price + \'$\'\"></span></button> <button class=\"btn btn-info btn-sm\" ng-disabled=\"request.price == 0\" ng-if=\"currentEvent.billingPreferences.serviceType === \'paypal\'\" ng-click=\"handlePaypalButton({\n                  paypalMerchantId: vm.event.billingPreferences.merchantId,\n                  paypalCallback: \'organizer/vendors/requests\',\n                  paypalMode: vm.event.billingPreferences.mode,\n                  paypalButtonType: \'vendor\'\n                }, request)\"><span ng-bind=\"\'BUTTON.pay\' | translate\"></span>&nbsp;<span ng-bind=\"request.price + \'$\'\"></span></button> <button class=\"btn btn-info btn-sm\" ng-disabled=\"request.price == 0\" ng-if=\"currentEvent.billingPreferences.serviceType === \'squareup\'\" ng-click=\"handleSquareupButton({\n                  applicationId: vm.event.billingPreferences.applicationId,\n                  locationId: vm.event.billingPreferences.locationId,\n                }, request)\"><span ng-bind=\"\'BUTTON.pay\' | translate\"></span>&nbsp;<span ng-bind=\"request.price + \'$\'\"></span></button> <button class=\"btn btn-info btn-sm\" ng-disabled=\"request.price == 0\" ng-if=\"currentEvent.billingPreferences.serviceType === \'payeezy\'\" ng-click=\"handlePayeezyButton({\n                  apiKey: vm.event.billingPreferences.apiKey,\n                  jsSecurityKey: vm.event.billingPreferences.jsSecurityKey,\n                  paymentJSUrl: vm.event.billingPreferences.paymentJSUrl,\n                  transarmorToken: vm.event.billingPreferences.transarmorToken\n                }, request)\"><span ng-bind=\"\'BUTTON.pay\' | translate\"></span>&nbsp;<span ng-bind=\"request.price + \'$\'\"></span></button></div><button class=\"btn btn-default btn-sm\" type=button ng-if=\"(request.status == \'draft\' || request.status == \'pending\' || request.status == \'accepted\')\" ng-click=handleEdit(request) ng-bind=\"\'BUTTON.edit\' | translate\"><button class=\"btn btn-info btn-sm\" type=button ng-if=\"!request.checkedIn && request.status == \'accepted\'\" ng-click=handleCheckIn(request) ng-bind=\"\'BUTTON.checkIn\' | translate\"></button><!-- Dropdown --><div uib-dropdown class=btn-group is-open=isOpen style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button ng-click=\"isOpen = !isOpen\"><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button ng-click=\"isOpen = !isOpen\"><li role=menuitem><button type=button ng-click=handlePreview(request) ng-bind=\"\'BUTTON.preview\' | translate\"></button></li><li role=menuitem ng-if=\"\n                      currentEvent.billingPreferences && currentEvent.billingPreferences.serviceType !== \'\' &&\n                      request.status == \'pending\' && request.price && request.price > 0\n                    \"><button type=button ng-click=handleInvoice(request) ng-bind=\"\'BUTTON.invoice\' | translate\"></button></li><li role=menuitem ng-if=\"(request.status == \'cancelled\' || request.status == \'pending\')\"><button type=button ng-click=handleReset(request) ng-bind=\"\'BUTTON.reset\' | translate\"></button></li><li role=menuitem ng-if=\"(request.status !== \'declined\' && request.status !== \'cancelled\')\"><button type=button ng-click=handleDecline(request) ng-bind=\"\'BUTTON.decline\' | translate\"></button></li><li role=menuitem ng-if=\"request.status !== \'accepted\'\"><button type=button ng-click=handleDelete(request) ng-bind=\"\'BUTTON.delete\' | translate\"></button></li><li role=menuitem ng-if=\"request.status == \'accepted\' && ( request.invoiceStatus && request.invoiceStatus != \'\' )\"><button type=button ng-click=handleTransaction(request) ng-bind=\"\'BUTTON.transactions\' | translate\"></button></li></ul></div></button></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterVendors.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterVendors.length > currentEvent.preferences.itemsPerPage && vm.filterVendors.length != 0\" uib-pagination total-items=vm.filterVendors.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div>");
$templateCache.put("app/users/organizer/volunteers/all/all.html","<div class=tab-content ng-controller=\"OrganizerVolunteersAllController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.SEARCH\' | translate\"></span> <input class=form-control type=text name=eoVolunteerAllSearch placeholder=\"{{\'FORM.SEARCH\' | translate}}\" ng-model=searchVolunteer ng-model-options=\"{debounce: 1000}\"></label><label class=form-group><span class=label ng-bind=\"\'FORM.FILTER\' | translate\"></span><select class=form-control name=onlyFilter ng-model=onlyFilter ng-init=\"onlyFilter = \'all\'\"><option value=all ng-bind=\"\'FORM.ALL\' | translate\"></option><option value=idleOnly ng-bind=\"\'FORM.NO_REQUEST_SUBMITTED\' | translate\"></option><option value=unassignedOnly ng-bind=\"\'FORM.NO_RESPONSIBILITY_ZONE_SET\' | translate\"></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><select class=form-control name=userGroupsSearch ng-init=\"userGroupsSearch = \'all\'\" ng-model=userGroupsSearch><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"group in vm.userGroups track by $index\" ng-value=group.name ng-bind=group.name></option></select></label></div><div class=form-group ng-if=\"vm.volunteers.length != 0\"><button class=\"btn btn-primary\" type=button ng-click=handleDownload() ng-disabled=\"loadingFile || vm.filterVolunteers.length === 0\"><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button></div><div class=\"form-group clearfix\" ng-if=\"vm.volunteers.length != 0\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=\"vm.volunteers.length !== 0\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.contacts\' | translate\"></th><th ng-bind=\"\'TABLE.info\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"volunteer in vm.filterVolunteers = (\n            vm.volunteers \n            | FilterVolunteerSearch: searchVolunteer\n            | FilterOnlyVolunteer: onlyFilter: vm.requests: vm.respZones\n            | FilterUserGroups: userGroupsSearch\n          ) | orderBy: sortDate: true | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-if=volunteer.name ng-bind=volunteer.name></h3><h5 class=table-subtitle ng-bind=volunteer.username></h5></td><td><div class=table-group><span class=table-group-label ng-bind=\"\'LABEL.EMAIL\' | translate\"></span><div class=table-group-value ng-bind=volunteer.email></div></div><div class=table-group ng-if=\"volunteer.phone1.type && volunteer.phone1.number\"><span class=table-group-label ng-bind=volunteer.phone1.type></span><div class=table-group-value ng-bind=\"volunteer.phone1.number | formatPhone\"></div></div><div class=table-group ng-if=\"volunteer.phone2.type && volunteer.phone2.number\"><span class=table-group-label ng-bind=volunteer.phone2.type></span><div class=table-group-value ng-bind=\"volunteer.phone2.number | formatPhone\"></div></div></td><td><div class=table-group ng-if=volunteer.userGroups.length><span class=table-group-label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><div class=table-group-value><span ng-repeat=\"group in volunteer.userGroups track by $index\">{{group}}{{$last ? \'\' : \', \'}}</span></div></div><div class=table-group ng-if=volunteer.description><span class=table-group-label ng-bind=\"\'LABEL.DESCRIPTION\' | translate\"></span><div class=table-group-value ng-bind=volunteer.description></div></div><div class=table-group ng-if=volunteer.timeSpentMin><span class=table-group-label ng-bind=\"\'Total time spent\'\"></span><div class=table-group-value ng-bind=totalTime(volunteer.timeSpentMin)></div></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-primary btn-sm\" ng-click=handleLoginAs(volunteer) ng-bind=\"\'BUTTON.LOGIN_AS\' | translate\"></button> <button class=\"btn btn-default btn-sm\" ng-click=handleEditProfile(volunteer) ng-bind=\"\'BUTTON.EDIT_PROFILE\' | translate\"></button><div uib-dropdown class=btn-group is-open=isOpen style=\"margin-right: 0; margin-bottom: 0\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button ng-click=\"isOpen = !isOpen\"><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button ng-click=\"isOpen = !isOpen\"><li role=menuitem><button ng-click=vm.onAssignments(volunteer) type=button ng-bind=\"\'BUTTON.ASSIGNMENTS\' | translate\"></button></li><li role=menuitem ng-if=\"volunteer.status == \'declined\'\"><button ng-click=\"handleParticipation($event, volunteer)\" type=button ng-bind=\"\'BUTTON.CONFIRM_PARTICIPATION\' | translate\"></button></li><li role=menuitem><button ng-click=handleDeleteUser(volunteer) type=button ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></li></ul></div></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterVolunteers.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterVolunteers.length > currentEvent.preferences.itemsPerPage && vm.volunteers.length != 0\" uib-pagination total-items=vm.filterVolunteers.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div ui-view=modal></div>");
$templateCache.put("app/users/organizer/volunteers/assignments/assignments.html","<div ng-init=onInit()><div class=modal-header><h4 class=modal-title ng-bind=\"\'TITLE.dialogAssignments\' | translate\"></h4></div><div class=modal-body><div ng-if=vm.isLoading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!vm.isLoading><ul class=\"schedule-list ng-scope\" ng-if=\"vm.assignments && vm.assignments.length !== 0\" style=\"margin-top: 0; padding: 0\"><li ng-repeat=\"assignment in vm.assignments | orderBy:\'from\'\"><div ng-if=\"assignment.from && assignment.to\"><p ng-if=\"isSameDay(assignment.from, assignment.to)\"><b ng-bind=\"assignment.from | dateFormated\"></b> &nbsp;-&nbsp; <b ng-bind=\"assignment.to | timeFormated\"></b></p><p ng-if=\"!isSameDay(assignment.from, assignment.to)\"><b ng-bind=\"assignment.from | dateFormated\"></b> &nbsp;-&nbsp; <b ng-bind=\"assignment.to | dateFormated\"></b></p></div><p ng-bind=\"assignment.volunteerZoneName ? assignment.volunteerZoneName : \'NO ZONE NAME\'\"></p></li></ul><div class=no-message ng-if=\"vm.assignments && vm.assignments.length === 0\"><i class=\"glyphicon glyphicon-calendar\"></i><h3 ng-bind=\"\'TEXT.noAssignments\' | translate\"></h3></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=onClose() ng-bind=\"\'BUTTON.close\' | translate\"></button></div></div>");
$templateCache.put("app/users/organizer/volunteers/bulk/bulk.html","<bulk-users user-type=volunteer></bulk-users>");
$templateCache.put("app/users/organizer/volunteers/log-book/log-book.html","<div class=tab-content ng-controller=\"OrganizerLogBookController as vm\" ng-init=onInit()><div ng-if=loading ng-bind=\"\'TEXT.loading\' | translate\"></div><div ng-if=!loading><div class=\"form-group | clearfix\"><button class=\"btn btn-info btn-sm | pull-right\" type=button ng-click=handleCreate() ng-bind=\"\'BUTTON.createLog\' | translate\"></button></div><div ng-if=logs.length><h5><span ng-bind=\"\'TEXT.TOTAL_LOGGED_TIME\' | translate\"></span> <span ng-bind=totalTimeSpent></span><hr></h5><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoVolunteerLogBookSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=searchByVolunteerName ng-change=onChangeSearch(searchByVolunteerName) ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-datepicker\"><span class=label ng-bind=\"\'Check-In date\'\"></span><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=onPopup1Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=checkInDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=checkInDate ng-change=\"onChangeDate(checkInDate, endDate)\" is-open=popup1.opened datepicker-options=dateOptions show-button-bar=false></div></label><label class=\"form-group form-group-datepicker\"><span class=label ng-bind=\"\'Check-Out date\'\"></span><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default\" type=button ng-click=onPopup2Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=form-control type=text name=checkOutDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=checkOutDate ng-change=\"onChangeDate(checkInDate, checkOutDate)\" is-open=popup2.opened datepicker-options=dateOptions show-button-bar=false></div></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.userGroups\' | translate\"></span><select class=form-control name=userGroupsSearch ng-init=\"userGroupsSearch = \'all\'\" ng-model=userGroupsSearch><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"group in userGroups track by $index\" ng-value=group.name ng-bind=group.name></option></select></label></div><div class=\"form-group | clearfix\"><button class=\"btn btn-primary btn-sm\" type=button ng-click=handleDownload() ng-disabled=\"loadingFile || vm.filteredLogs.length === 0\"><i ng-if=loadingFile class=\"fa fa-spinner fa-spin\" style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.downloadCsv\' | translate\"></span></button></div><div class=\"form-group clearfix\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.info\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.checkIn\' | translate\"></th><th ng-bind=\"\'TABLE.checkOut\' | translate\"></th><th ng-bind=\"\'TABLE.timeSpent\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"log in vm.filterLogs = (\n                logs\n                | filter: filterVolunteerName\n                | FilterCheckInOutDate:checkInDate:checkOutDate\n                | FilterUserGroups: userGroupsSearch\n              ) | FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-if=log.userName ng-bind=log.userName></h3><h5 class=table-subtitle ng-if=log.comment ng-bind=log.comment></h5></td><td><div class=table-group ng-if=log.status><span class=\"table-group-label _hide\" ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"table-group-value {{log.status}}\" ng-bind=log.status></div></div></td><td><div class=table-group><span class=\"table-group-label _hide\" ng-bind=\"\'Check-in date\'\"></span><div class=table-group-value ng-bind=\"log.checkInDate | dateFormated\"></div></div></td><td><div class=table-group ng-if=log.checkOutDate><span class=\"table-group-label _hide\" ng-bind=\"\'Check-out date\'\"></span><div class=table-group-value ng-bind=\"log.checkOutDate | dateFormated\"></div></div></td><td><div class=table-group ng-if=totalTime(log.timeSpentMin)><span class=\"table-group-label _hide\" ng-bind=\"\'Total spent time\'\"></span><div class=table-group-value ng-bind=totalTime(log.timeSpentMin)></div></div></td><td class=\"-actions _inline\"><button ng-if=\"log.status !== \'declined\'\" class=\"btn btn-default btn-sm\" type=button ng-click=handleEdit(log) ng-bind=\"\'BUTTON.edit\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" type=button ng-click=handleDelete(log) ng-bind=\"\'BUTTON.delete\' | translate\"></button><div uib-dropdown class=btn-group style=\"margin-right: 0; margin-bottom: 0\" ng-if=\"log.status === \'draft\' || log.status === \'confirmed\'\"><button uib-dropdown-toggle class=\"btn btn-default btn-sm\" type=button><i class=\"glyphicon glyphicon-option-vertical\"></i></button><ul uib-dropdown-menu class=\"dropdown-menu dropdown-menu-right\" role=menu aria-labelledby=single-button><li role=menuitem><button type=button ng-if=\"log.status === \'draft\'\" ng-click=handleConfirm(log) ng-bind=\"\'BUTTON.confirm\' | translate\"></button></li><li><button type=button ng-if=\"log.status === \'draft\' || log.status === \'confirmed\'\" ng-click=handleDecline(log) ng-bind=\"\'BUTTON.decline\' | translate\"></button></li></ul></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterLogs.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterLogs.length > currentEvent.preferences.itemsPerPage && logs.length != 0\" uib-pagination total-items=vm.filterLogs.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div><div class=no-message ng-if=!logs.length><i class=\"glyphicon glyphicon glyphicon-th-list\"></i><h3 ng-bind=\"\'TEXT.noLogs\' | translate\"></h3></div></div></div>");
$templateCache.put("app/users/organizer/volunteers/requests/requests.html","<div class=tab-content ng-controller=\"OrganizerVolunteersRequestsController as vm\" ng-init=onInit()><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoVolunteerRequestSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=volunteerRequestValue ng-model-options=\"{debounce: 1000}\"></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.status\' | translate\"></span><select class=form-control name=statusRequest ng-init=\"statusRequest = \'all\'\" ng-model=statusRequest><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option ng-repeat=\"status in statuses track by $index\" ng-value=status ng-bind=status></option></select></label><label class=\"form-group form-group-select\"><span class=label ng-bind=\"\'FORM.label.checkedIn\' | translate\"></span><select class=form-control name=checkedIn ng-init=\"checkedIn = \'all\'\" ng-model=checkedIn><option value=all ng-bind=\"\'FORM.value.all\' | translate\"></option><option value=true ng-bind=\"\'FORM.value.yes\' | translate\"></option><option value=false ng-bind=\"\'FORM.value.no\' | translate\"></option></select></label></div><div class=\"form-group clearfix\"><button class=\"btn btn-info btn-sm | pull-left\" type=button ng-click=handleCheckOutAll() ng-bind=\"\'BUTTON.checkOutAll\' | translate\"></button></div><div class=\"form-group clearfix\" ng-if=\"vm.requests.length != 0\"><div class=\"btn-group pull-right\" role=group><button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'grid\' ? \'primary\' : \'default\') : \'primary\')\" ng-click=\"onViewSwitch(\'grid\')\"><i class=\"glyphicon glyphicon-th-large\"></i></button> <button type=button class=btn ng-class=\"\'btn-\'+ (vm.appView ? (vm.appView == \'list\' ? \'primary\' : \'default\') : \'default\')\" ng-click=\"onViewSwitch(\'list\')\"><i class=\"glyphicon glyphicon-th-list\"></i></button></div></div><table class=\"table table-request\" ng-if=\"vm.requests.length !== 0\" ng-class=\"\'table-\'+ (vm.appView ? vm.appView : \'grid\')\"><thead><tr><th ng-bind=\"\'TABLE.user\' | translate\"></th><th ng-bind=\"\'TABLE.zone\' | translate\"></th><th ng-bind=\"\'TABLE.status\' | translate\"></th><th ng-bind=\"\'TABLE.actions\' | translate\"></th></tr></thead><tbody><tr ng-repeat=\"request in vm.filterVolunteers = (\n            vm.requests |\n            filter: { status: statusRequest !== \'all\' ? statusRequest : undefined } |\n            filter: { checkedIn: checkedIn !== \'all\' ? checkedIn : undefined } |\n            filter: requestVolunteer\n          ) |\n          orderBy: \'-createdOn\' |\n          FilterPagination: vm.currentPage: currentEvent.preferences.itemsPerPage track by $index\"><td><h3 class=table-title ng-bind=request.volunteer.name></h3><h5 class=table-subtitle ng-bind=request.volunteer.username></h5><div class=table-group ng-show=request.createdOn><span class=table-group-label ng-bind=\"\'LABEL.DATE\' | translate\"></span><div class=table-group-value ng-bind=\"request.createdOn | dateFormated\"></div></div><div class=table-group ng-show=request.volunteer.email><span class=table-group-label ng-bind=\"\'LABEL.EMAIL\' | translate\"></span><div class=table-group-value><a href=\"mailto:{{ request.volunteer.email }}\" ng-bind=request.volunteer.email></a></div></div></td><td><div class=table-group ng-if=request.responsibilityZones.length><span class=table-group-label ng-bind=\"\'LABEL.RESPONSIBILITY_ZONE\' | translate\"></span><div class=table-group-value><!-- {{zone ? zone : \'NO ZONE NAME\'}}{{$last ? \'\' : \', \'}} --><div ng-repeat=\"zone in request.responsibilityZones track by $index\"><span ng-bind=zone.name></span><div ng-if=zone.volunteerAssignments.length><div ng-repeat=\"assignment in zone.volunteerAssignments\" ng-if=\"assignment.from && assignment.to\" style=\"font-size: 12px; color: grey\"><span ng-bind=\"assignment.from | dateFormated\"></span>&nbsp;-&nbsp;<span ng-bind=\"assignment.to | dateFormated\"></span></div></div></div></div></div></td><td><div class=\"row row-16\"><div class=col-xs-6><div class=table-group ng-if=request.status><span class=table-group-label ng-bind=\"\'LABEL.STATUS\' | translate\"></span><div class=\"table-group-value {{request.status}}\" ng-bind=request.status></div></div></div><div class=col-xs-6><div class=table-group><span class=table-group-label ng-bind=\"\'LABEL.CHECKED_IN\' | translate\"></span><div class=table-group-value ng-bind=\"request.checkedIn ? \'Yes\' : \'No\'\"></div></div></div></div></td><td class=-actions><div ng-if=eventStatus><button class=\"btn btn-info btn-sm\" ng-if=\"!request.checkedIn && request.status === \'accepted\'\" ng-click=handleCheckIn(request) ng-bind=\"\'BUTTON.checkIn\' | translate\"></button> <button class=\"btn btn-default btn-sm\" ng-if=\"request.checkedIn && request.status === \'accepted\'\" ng-click=handleCheckOut(request) ng-bind=\"\'BUTTON.checkOut\' | translate\"></button> <button class=\"btn btn-info btn-sm\" ng-if=\"request.status == \'accepted\'\" ng-click=handleLog(request) ng-bind=\"\'BUTTON.log\' | translate\"></button> <button class=\"btn btn-primary btn-sm\" ng-if=\"request.status == \'pending\'\" ng-click=handleAccept(request) ng-bind=\"\'BUTTON.accept\' | translate\"></button> <button class=\"btn btn-danger btn-sm\" ng-if=\"(request.status == \'pending\' || request.status == \'accepted\')\" ng-click=handleDecline(request) ng-bind=\"\'BUTTON.decline\' | translate\"></button></div></td></tr></tbody></table><div class=total><div class=total-label ng-if=\"vm.filterVolunteers.length > 0\"><span ng-bind=onChangeItemsOf()></span></div><div class=total-pagination><ul ng-if=\"vm.filterVolunteers.length > currentEvent.preferences.itemsPerPage && vm.filterVolunteers.length != 0\" uib-pagination total-items=vm.filterVolunteers.length items-per-page=currentEvent.preferences.itemsPerPage ng-model=vm.currentPage ng-change=onChangeItemsOf() boundary-link=false boundary-link-numbers=true rotate=true max-size=5></ul></div></div></div>");
$templateCache.put("app/users/organizer/volunteers/volunteer-assignments/modal.html","<div ng-init=onInit()><div class=modal-header><h3 class=modal-title ng-bind=zone.name></h3></div><div class=modal-body><h5 style=\"margin-top: 0\" ng-bind=\"\'Assignments manage\'\"></h5><date-range start-date=assignment.startDate end-date=assignment.endDate start-time=assignment.startTime end-time=assignment.endTime is-valid=assignment.isValid event-validation=true></date-range><div class=form-group><button class=\"btn btn-primary btn-sm\" type=button ng-click=handleSave()>Save</button></div><hr><h5 style=\"margin-top: 0\" ng-bind=\"\'CheckIn/CheckOut manage\'\"></h5><div class=form-group ng-if=request.checkedIn><label for=checkOut>Comment</label><textarea class=form-control name=checkOut id=checkOut ng-model=request.comment rows=5></textarea></div><div class=form-group><button class=\"btn btn-success btn-sm\" type=button ng-if=!request.checkedIn ng-click=handleCheckin()>Check in</button> <button class=\"btn btn-danger btn-sm\" type=button ng-if=request.checkedIn ng-click=handleCheckout()>Check out</button></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button role=button ng-click=handleCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button></div></div>");
$templateCache.put("app/users/organizer/volunteers/volunteer-assignments/volunteer-assignments.html","<div ng-controller=\"OrganizerEventVolunteerAssignmentsController as vm\" ng-init=onInit()><div class=schedule-assignments ng-if=zoneAssignments.length><div class=filter><label class=form-group><span class=label ng-bind=\"\'FORM.label.search\' | translate\"></span> <input class=form-control type=text name=eoVolunteerAssignmentsSearch placeholder=\"{{\'FORM.placeholder.search\' | translate}}\" ng-model=eoVolunteerAssignmentsSearch ng-model-options=\"{debounce: 1000}\"></label><label class=form-group><span class=label ng-bind=\"\'FORM.label.zones\' | translate\"></span><div uib-dropdown auto-close=outsideClick class=btn-group style=\"margin-right: 0; margin-bottom: 0; display: block\"><button uib-dropdown-toggle class=\"btn btn-default btn-block\" style=\"text-align: left\" type=button>Zone(s) <span class=caret></span></button><ul uib-dropdown-menu class=dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem ng-repeat=\"zone in responseZones\"><div style=\"padding-left: 8px; width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden\"><label><input type=checkbox ng-click=handleClickZone(zone.name)> {{zone.name}}</label></div></li></ul></div></label></div><div class=schedule-assignments-wrap><div class=schedule-assignments-item ng-repeat=\"\n            data in zoneAssignments\n            | filter: filterVolunteerAssignmentsZone\n           \" style=\"width: {{(data.days.length * 480) + 225 + data.days.length +\'px\'}}\"><div class=item-zone-name><span ng-if=data.color class=_color style=\"background-color: {{data.color}}\"></span> <span class=_name ng-bind=\"data.zone.name || \'&nbsp;\'\"></span></div><div class=item-zone-day ng-repeat=\"day in data.days\"><span ng-if=!data.id class=_day ng-bind=\"day.date | dateFormatedOnly\"></span> <span ng-if=!data.id class=_hour ng-repeat=\"hour in [2,4,6,8,10,12,14,16,18,20,22]\" style=\"left: {{hour * 20 +\'px\'}}\" ng-bind=hour></span> <span ng-if=data.id class=_hour-line ng-repeat=\"hour in [2,4,6,8,10,12,14,16,18,20,22]\" style=\"left: {{hour * 20 +\'px\'}}\"></span><div class=_volunteer-wrap ng-repeat=\"\n                v in day.volunteers\n                | FilterVolunteerAssignmentsSearch: eoVolunteerAssignmentsSearch\n                | orderBy:\'-total\'\n               \"><div class=_volunteer style=\"left: {{v.left +\'px\'}};\n                  width: {{v.width + \'px\'}};\n                  background-color: {{v.color}}\" ng-click=\"handleClick(data.zone, v.assignment)\"><span class=_checked-in style=\"background-color: {{v.request.checkedIn ? \'#4CAF50\' : \'#F44336\'}}\"></span><div><div ng-bind=v.request.volunteer.name></div><div ng-bind=v.request.volunteer.email></div><b ng-if=\"moment(v.date.from).isSame(v.date.to, \'day\')\" ng-bind=\"v.time.from +\' - \'+ v.time.to\"></b> <b style=\"display: block; white-space: nowrap\" ng-if=\"!moment(v.date.from).isSame(v.date.to, \'day\')\"><span ng-bind=\"v.date.from | dateFormatedOnly\"></span> <span ng-bind=\"\' \'+ v.time.from\"></span> &nbsp;-&nbsp; <span ng-bind=\"v.date.to | dateFormatedOnly\"></span> <span ng-bind=\"\' \'+ v.time.to\"></span></b><div><b>Checked-in:</b> <span class=\"table-group-value {{v.request.checkedIn ? \'accepted\' : \'declined\'}}\" ng-bind=\"v.request.checkedIn ? \'Yes\' : \'No\'\"></span></div></div></div></div></div></div></div></div><style>.schedule-assignments {\n    \n  }\n  .schedule-assignments-wrap {\n    display: flex;\n    flex-direction: column;\n\n    overflow-x: auto;\n\n    padding-bottom: 16px;\n    padding-top: 8px;\n  }\n  .schedule-assignments-item {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n\n    position: relative;\n  }\n  .schedule-assignments-item:last-child {\n    border-bottom: 1px solid #ededed;\n  }\n  .schedule-assignments-item + div {\n    border-top: 1px solid #ededed;\n  }\n  .schedule-assignments-item:not(:first-child) {\n    border-right: 1px solid #ededed;\n    border-left: 1px solid #ededed;\n  }\n  .schedule-assignments-item:not(:first-child) > div + div {\n    border-left: 2px solid #ededed;\n  }\n  .schedule-assignments-item > .item-zone-name,\n  .schedule-assignments-item > .item-zone-day {\n    flex-shrink: 0;\n    min-height: 25px;\n  }\n  .schedule-assignments-item > .item-zone-name {\n    position: sticky;\n    left: 0; top: 0; bottom: 0;\n    z-index: 3;\n\n    width: 225px;\n\n    background-color: #ffffff;\n\n    /* font-size: 12px; */\n\n    display: flex;\n    align-items: center;\n\n    padding: 2px 8px;\n  }\n  .schedule-assignments-item > .item-zone-name > span._color {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    margin-right: 8px;\n  }\n  .schedule-assignments-item > .item-zone-name > span._name {\n\n  }\n  .schedule-assignments-item > .item-zone-day {\n    position: relative;\n    z-index: 1;\n\n    width: 480px;\n  }\n  .schedule-assignments-item > .item-zone-day:hover {\n    z-index: 2;\n  }\n  .schedule-assignments-item > .item-zone-day > ._day {\n    display: block;\n    font-size: 14px;\n    font-weight: bold;\n\n    text-align: center;\n\n    padding-bottom: 20px;\n  }\n  .schedule-assignments-item > .item-zone-day > ._hour {\n    position: absolute;\n    z-index: 1;\n\n    bottom: 0;\n    font-size: 10px;\n    font-weight: bold;\n    margin-left: -2px;\n  }\n  .schedule-assignments-item > .item-zone-day > ._hour-line {\n    position: absolute;\n    z-index: 1;\n    top: 0; bottom: 0; width: 1px;\n    background: rgba(0,0,0,0.05);\n  }\n  ._volunteer-wrap {\n    position: relative;\n    width: 100%;\n    min-height: 25px;\n    z-index: 2;\n  }\n  ._volunteer-wrap > ._volunteer {\n    position: absolute;\n    bottom: 0; min-height: 20px;\n\n    cursor: pointer;\n\n    border: 1px solid #000000;\n  }\n\n  ._volunteer-wrap > ._volunteer > ._checked-in {\n    display: block;\n    position: absolute;\n    top: 50%;\n    left: 0;\n\n    margin-top: -6px;\n    margin-left: 2px;\n\n    width: 10px;\n    height: 10px;\n\n    border: 1px solid;\n    border-radius: 50%;\n  }\n\n  ._volunteer-wrap > ._volunteer:hover > div {\n    display: block;\n  }\n  @media screen and (max-width: 767px){\n    ._volunteer-wrap > ._volunteer:focus > div {\n      display: block;\n    }\n  }\n  ._volunteer-wrap > ._volunteer > div {\n    display: none;\n    position: absolute;\n    bottom: 50%;\n    left: 50%;\n\n    background-color: #ffffff;\n    border-radius: 4px;\n    border: 1px solid #ededed;\n    box-shadow: 0 2px 2px rgba(0,0,0,0.25);\n    padding: 2px 6px;\n\n    font-size: 12px;\n\n    line-height: 1.2;\n    transform: translateX(-50%);\n  }\n\n  /* ._volunteer-wrap > ._volunteer > .time {\n    position: absolute;\n    top: 0;\n    font-size: 12px;\n    font-weight: 700;\n\n    margin-top: -14px;\n  }\n  ._volunteer-wrap > ._volunteer > .time.from {\n    left: 0;\n    margin-left: -8px;\n  }\n  ._volunteer-wrap > ._volunteer > .time.to {\n    right: 0;\n    margin-right: -8px;\n  } */</style></div>");
$templateCache.put("app/users/organizer/map/constructor/booth/booth.html","<style>.nav-sm > .nav > .nav-item > a {\n    padding: 6px 12px;\n    font-size: 14px;\n    margin-right: 0;\n  }</style><div ng-controller=\"BoothController as vm\" ng-init=onInit()><div ng-if=boothLoading class=selectedItemLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><div ng-if=!boothLoading><h4 ng-bind=\"\'MAP_CONSTRUCTOR.BOOTH\' | translate\"></h4><uib-tabset active=activeBooth class=nav-sm><uib-tab index=0 heading=Booth><div class=form-group ng-class=\"{ \'has-error\': isFieldRequired && !selectedItem.boothType }\"><label><span ng-bind=\"\'FORM.MAP_CONSTRUCTOR.BOOTH_TYPE\' | translate\"></span> <span>&nbsp;*</span></label><select class=form-control name=selectedItemType ng-model=selectedItem.boothType required ng-options=\"booth as booth.type for booth in boothTypes\" ng-change=onChangeBoothType(selectedItem.boothType)><option value=\"\" selected ng-bind=\"\'FORM.CHOOSE_BOOTH_TYPE\' | translate\"></option></select><div class=help-block ng-if=\"isFieldRequired && !selectedItem.boothType\" role=alert ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div><div class=form-group><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.DESCRIPTION\' | translate\"></label><textarea class=form-control name=selectedItemDescription placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.DESCRIPTION\' | translate}}\" ng-model=selectedItem.description>\n          </textarea></div><div class=form-group ng-if=eventZones.length><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.EVENT_ZONE\' | translate\"></label><select class=form-control name=selectedItemZoneId ng-model=selectedItem.zoneId ng-options=\"zone.id as zone.name for zone in eventZones\"><option value=\"\" selected ng-bind=\"\'FORM.CHOOSE_EVENT_ZONE\' | translate\"></option></select></div><div class=form-group ng-if=\"selectedItem._type === \'fixed\'\"><div class=\"row row-16\"><div class=col-xs-6><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.WIDTH\' | translate\"></label><input class=form-control type=number name=selectedItemWidth min=0 ng-model=selectedItem.width ng-change=selectedItem.resize()></div><div class=col-xs-6><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.HEIGHT\' | translate\"></label><input class=form-control type=number name=selectedItemHeight min=0 ng-model=selectedItem.height ng-change=selectedItem.resize()></div></div></div><div class=form-group><div class=\"row row-16\"><div class=col-xs-8><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.COLOR\' | translate\"></label><div class=\"input-group input-group-color\"><span class=input-group-addon><label><input type=color name=selectedItemColorPicker ng-model=selectedItemColor ng-change=onChangeSelectedItemColor(selectedItemColor)> <span style=\"background-color: {{selectedItemColor}}\"></span></label></span><input class=form-control type=text name=selectedItemColorText ng-model=selectedItemColor placeholder=\"Hex code\" ng-change=onChangeSelectedItemColor(selectedItemColor)></div></div><div class=col-xs-4><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.OPACITY\' | translate\"></label><input class=form-control name=selectedItemBgOpacity type=number min=0 max=100 ng-model=selectedItem.opacity ng-change=selectedItem.setColor()> <span class=help-text style=\"font-size: 12px; font-style: italic\">(from 0 to 100)</span></div></div></div><!-- Booth rotate --><div class=form-group ng-if=\"selectedItem._type === \'fixed\'\"><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.ROTATE_BOOTH\' | translate\"></label><div class=\"row row-16\"><div class=col-xs-6><button class=\"btn btn-primary btn-block\" type=button ng-click=\"handleBoothRotate(\'left\')\"><i class=\"fa fa-rotate-left\" aria-hidden=true></i></button></div><div class=col-xs-6><button class=\"btn btn-primary btn-block\" type=button ng-click=\"handleBoothRotate(\'right\')\"><i class=\"fa fa-rotate-right\" aria-hidden=true></i></button></div></div></div><uib-tabset active=activeRoutesIndoorMap><uib-tab index=0 heading=Routes><!-- Routes --><table style=\"width: 100%; margin-bottom: 16px; table-layout: fixed\"><tr><td style=\"vertical-align: bottom\"><div class=form-group style=\"margin-bottom: 0\"><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.ROUTES\' | translate\"></label><ui-select ng-model=selectedItem.selectedRoute theme=bootstrap><ui-select-match placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.ROUTES\' | translate}}\"><span ng-style=\"{\'background-color\': $select.selected.polyline ? $select.selected.polyline.strokeColor : $select.selected.strokeColor }\" style=\"width: 16px; height: 16px; display: inline-block; top: -4px; position: relative\"></span> <span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"route in selectedItem.unlinkedRoutes | filter: $select.search\"><span ng-style=\"{\'background-color\': route.polyline ? route.polyline.strokeColor : route.strokeColor }\" style=\"width: 16px; height: 16px; display: inline-block; top: 2px; position: relative\"></span> <span ng-bind-html=\"route.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></td><td style=\"vertical-align: bottom; width: 70px; text-align: right\"><button class=\"btn btn-primary\" ng-click=onAddRoute(selectedItem) ng-disabled=!selectedItem.selectedRoute ng-bind=\"\'BUTTON.ADD\' | translate\"></button></td></tr></table><table style=\"width: 100%; margin-bottom: 16px; table-layout: fixed\" ng-if=\"selectedItem.hasRoutes && selectedItem.hasRoutes.length !== 0\"><tr ng-repeat=\"route in selectedItem.hasRoutes\" style=\"border-top: 1px solid #ededed\"><td style=\"vertical-align: middle; padding-top: 4px; padding-bottom: 4px; width: 20px\"><span ng-style=\"{\'background-color\': route.polyline ? route.polyline.strokeColor : route.strokeColor }\" style=\"width: 16px; height: 16px; display: inline-block; top: 2px; position: relative\"></span></td><td style=\"vertical-align: middle; padding-top: 4px; padding-bottom: 4px\"><button class=\"btn btn-link btn-sm btn-block\" style=\"text-align: left; white-space: normal\" ng-bind=route.name></button></td><td style=\"vertical-align: middle; padding-top: 4px; padding-bottom: 4px; width: 70px; text-align: right\"><button class=\"btn btn-danger btn-sm btn-block\" ng-click=\"onRemoveRoute(selectedItem, route)\" uib-tooltip=\"Remove route\" tooltip-placement=bottom><i class=\"glyphicon glyphicon-remove\"></i></button></td></tr></table></uib-tab><uib-tab index=1 heading=\"Indoor Maps\" ng-if=\"map.getType() !== \'indoor\'\"><!-- Indoor Maps --><table style=\"width: 100%; margin-bottom: 16px; table-layout: fixed\"><tr><td style=\"vertical-align: bottom\"><div class=form-group style=\"margin-bottom: 0\"><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.INDOOR_MAPS\' | translate\"></label><ui-select ng-model=selectedItem.selectedIndoorMap theme=bootstrap><ui-select-match placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.INDOOR_MAPS\' | translate}}\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"indoor in unlinkedIndoorMaps | filter: $select.search\"><span ng-bind-html=\"indoor.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></td><td style=\"vertical-align: bottom; width: 70px; text-align: right\"><button class=\"btn btn-primary\" ng-click=onAddIndoorMap(selectedItem) ng-disabled=!selectedItem.selectedIndoorMap ng-bind=\"\'BUTTON.ADD\' | translate\"></button></td></tr></table><table style=\"width: 100%; margin-bottom: 16px; table-layout: fixed\" ng-if=\"selectedItem.hasIndoorMaps && selectedItem.hasIndoorMaps.length !== 0\"><tr ng-repeat=\"indoor in selectedItem.hasIndoorMaps\" style=\"border-top: 1px solid #ededed\"><td style=\"vertical-align: middle; padding-top: 4px; padding-bottom: 4px\"><button class=\"btn btn-link btn-sm btn-block\" style=\"text-align: left; white-space: normal\" ng-bind=indoor.name ng-click=\"handleMapCheck(\'users.organizer.map.constructor\', indoor.id)\"></button></td><td style=\"vertical-align: middle; padding-top: 4px; padding-bottom: 4px; width: 70px; text-align: right\"><button class=\"btn btn-danger btn-sm btn-block\" ng-click=\"onRemoveIndoorMap(selectedItem, indoor)\" uib-tooltip=\"Remove indoor map\" tooltip-placement=bottom><i class=\"glyphicon glyphicon-remove\"></i></button></td></tr></table></uib-tab></uib-tabset></uib-tab><uib-tab index=1 heading=Links ng-if=selectedItem.boothTypeId><!-- Commercial --><div ng-if=\"selectedItem.boothType && selectedItem.boothType.commercial\"><div class=form-group ng-class=\"{ \'has-error\': !selectedItem.commercialData.request && isCommercialSubmitted }\"><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.ACCEPTED_REQUESTS\' | translate\"></label><ui-select ng-model=selectedItem.commercialData.request theme=bootstrap><ui-select-match placeholder=Search><span ng-style=\"{\'background-color\': $select.selected.goodsCategory.preferences.color }\" style=\"width: 10px; height: 10px; display: inline-block; border-radius: 50%; top: -6px; position: relative\"></span> <span ng-bind=$select.selected.user.name></span></ui-select-match><ui-select-choices repeat=\"request in unlinkedRequests | filter: { user: { name: $select.search }} track by $index\"><span class=ui-select-color ng-style=\"{\'background-color\': request.goodsCategory.preferences.color }\"></span> <span class=ui-select-title ng-bind=request.user.name></span> <span class=ui-select-describe ng-bind=request.user.email></span><div class=ui-select-describe><b>Type:&nbsp;</b><span ng-bind=userType(request.user.type)></span></div><div class=ui-select-describe ng-if=\"request.user.type === \'participant\' && request.items.length\" style=\"white-space: initial; display: flex; flex-wrap: wrap\"><b>Package(s):&nbsp;</b> <span ng-repeat=\"pkg in request.items\" ng-bind=\"pkg.pricePackage.name + \'&nbsp;($\' + pkg.pricePackage.price +\');&nbsp;\'\"></span></div><div ng-if=request.goodsCategory class=ui-select-describe><b>Goods Category:&nbsp;</b><span ng-bind=request.goodsCategory.name></span></div></ui-select-choices></ui-select><div class=help-block ng-if=\"!selectedItem.commercialData.request && isCommercialSubmitted\" ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div><div class=form-group><label for=commercialNotes ng-bind=\"\'FORM.MAP_CONSTRUCTOR.NOTES\' | translate\"></label><textarea class=\"form-control input-sm\" name=commercialNotes id=commercialNotes rows=3 placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.NOTES\' | translate}}\" ng-model=selectedItem.commercialData.notes></textarea></div><date-range start-date=selectedItem.commercialData.startDate end-date=selectedItem.commercialData.endDate start-time=selectedItem.commercialData.startTime end-time=selectedItem.commercialData.endTime is-valid=selectedItem.commercialData.isValid event-validation=true></date-range><div class=form-group><button class=\"btn btn-primary\" type=button ng-disabled=!selectedItem.commercialData.isValid ng-click=onAddCommercialAssignments() ng-bind=\"\'BUTTON.ADD\' | translate\"></button></div><div ng-if=\"selectedItem.commercialList && selectedItem.commercialList.length \"><ul class=list-commercial><li ng-repeat=\"commercial in selectedItem.commercialList | orderBy: \'from\'\"><div class=_left><button class=\"btn btn-danger btn-sm\" type=button ng-click=onRemoveCommercialAssignments(commercial)><i class=\"fa fa-trash\" aria-hidden=true></i></button> <button class=\"btn btn-info btn-sm\" type=button ng-click=\"onEditAssignments(commercial, selectedItem.commercialList, \'commercial\')\"><i class=\"fa fa-edit\" aria-hidden=true></i></button></div><div class=_body><h3 class=name ng-bind=commercial.request.user.name></h3><p class=email ng-bind=commercial.request.user.email></p><p class=notes><b>Type:&nbsp;</b><span ng-bind=userType(commercial.request.user.type)></span></p><p class=notes ng-if=commercial.notes ng-bind=commercial.notes></p><div ng-if=\"commercial.from && commercial.to\"><div class=date ng-if=\"isSameDay(commercial.from, commercial.to)\"><span ng-bind=\"commercial.from | dateFormated\"></span>&nbsp;-&nbsp; <span ng-bind=\"commercial.to | timeFormated\"></span></div><div class=date ng-if=\"!isSameDay(commercial.from, commercial.to)\"><span ng-bind=\"commercial.from | dateFormated\"></span>&nbsp;-&nbsp; <span ng-bind=\"commercial.to | dateFormated\"></span></div></div><div ng-if=commercial.request.goodsCategory class=notes><b>Goods Category:&nbsp;</b><span ng-bind=commercial.request.goodsCategory.name></span></div></div></li></ul></div></div><!-- Non Commercial --><div ng-if=\"selectedItem.boothType && !selectedItem.boothType.commercial\"><div class=form-group ng-class=\"{ \'has-error\': !selectedItem.nonCommercialData.user && isNonCommercialSubmitted }\"><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.EVENT_USERS\' | translate\"></label><ui-select ng-model=selectedItem.nonCommercialData.user theme=bootstrap on-select=\"onChangeNonCommercialAssignments($item, $model)\"><ui-select-match placeholder=Search><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"user in unlinkedUsers | filter: { name: $select.search }\"><span class=ui-select-title ng-bind=user.name></span> <span class=ui-select-describe ng-bind=user.email></span><div class=ui-select-describe><b>Type:&nbsp;</b><span ng-bind=userType(user.type)></span></div></ui-select-choices></ui-select><div class=help-block ng-if=\"!selectedItem.nonCommercialData.user && isNonCommercialSubmitted\" ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div><div class=form-group><label for=nonCommercialNotes ng-bind=\"\'FORM.MAP_CONSTRUCTOR.NOTES\' | translate\"></label><textarea class=\"form-control input-sm\" name=nonCommercialNotes id=nonCommercialNotes rows=3 placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.NOTES\' | translate}}\" ng-model=selectedItem.nonCommercialData.notes></textarea></div><date-range start-date=selectedItem.nonCommercialData.startDate end-date=selectedItem.nonCommercialData.endDate start-time=selectedItem.nonCommercialData.startTime end-time=selectedItem.nonCommercialData.endTime is-valid=selectedItem.nonCommercialData.isValid event-validation=true></date-range><div class=form-group><button class=\"btn btn-primary btn-sm\" type=button ng-disabled=!selectedItem.nonCommercialData.isValid ng-click=onAddNonCommercialAssignments() ng-bind=\"\'BUTTON.ADD\' | translate\"></button></div><div ng-if=\"selectedItem.nonCommercialList && selectedItem.nonCommercialList.length\"><ul class=list-commercial><li ng-repeat=\"nonCommercial in selectedItem.nonCommercialList\"><div class=_left><button class=\"btn btn-danger btn-sm\" type=button ng-click=onRemoveNonCommercialAssignments(nonCommercial)><i class=\"fa fa-trash\" aria-hidden=true></i></button> <button class=\"btn btn-info btn-sm\" type=button ng-click=\"onEditAssignments(nonCommercial, selectedItem.nonCommercialList, \'nonCommercial\')\"><i class=\"fa fa-edit\" aria-hidden=true></i></button></div><div class=_body><h3 class=name ng-bind=nonCommercial.user.name></h3><p class=email ng-bind=nonCommercial.user.email></p><p class=notes><b>Type:&nbsp;</b><span ng-bind=userType(nonCommercial.user.type)></span></p><p class=notes ng-if=nonCommercial.notes ng-bind=nonCommercial.notes></p><div ng-if=\"nonCommercial.from && nonCommercial.to\"><div class=date ng-if=\"isSameDay(nonCommercial.from, nonCommercial.to)\"><span ng-bind=\"nonCommercial.from | dateFormated\"></span>&nbsp;-&nbsp; <span ng-bind=\"nonCommercial.to | timeFormated\"></span></div><div class=date ng-if=\"!isSameDay(nonCommercial.from, nonCommercial.to)\"><span ng-bind=\"nonCommercial.from | dateFormated\"></span>&nbsp;-&nbsp; <span ng-bind=\"nonCommercial.to | dateFormated\"></span></div></div></div></li></ul></div></div></uib-tab><uib-tab index=2 heading=Reservation ng-if=\"currentEvent.modules.indexOf(\'reservations\') > -1\"><div class=form-group><div class=checkbox><label><input type=checkbox ng-model=selectedItem.boothReservation> <span ng-bind=\"\'TEXT.ALLOW_TO_RESERVE\' | translate\"></span></label><div class=help-text style=\"color: #999999; font-size: 12px; font-style: italic\" ng-bind=\"\'TEXT.SAVE_TO_APPLY\' | translate\"></div></div></div><div ng-if=selectedItem.boothReservation><div class=\"form-group clearfix\"><a class=\"btn btn-primary btn-sm\" ng-click=\"handleMapCheck(\'users.organizer.reservation_manager\', selectedItem.id)\" ng-bind=\"\'BUTTON.RESERVATION_MANAGER\' | translate\"></a><div class=help-text style=\"color: #999999; font-size: 12px; font-style: italic\" ng-bind=\"\'TEXT.SAVE_BEFORE_SWITCHING\' | translate\"></div></div><div ng-if=selectedItem.reservations.length><div class=\"card card-default\" style=\"margin-top: 8px; padding: 8px\" ng-repeat=\"reserve in selectedItem.reservations\"><div class=card-head><div class=card-subtitle style=\"white-space: normal\"><span ng-if=\"!isSameDayC(reserve.from, reserve.to)\" ng-bind=\"reserve.from | dateFormatedOnly\"></span> <span ng-if=\"!isSameDayC(reserve.from, reserve.to)\">&nbsp;-&nbsp;</span> <span ng-if=\"!isSameDayC(reserve.from, reserve.to)\" ng-bind=\"moment(reserve.to).subtract(1, \'days\') | dateFormatedOnly\"></span> <span ng-if=\"isSameDayC(reserve.from, reserve.to)\" ng-bind=\"reserve.from | dateFormatedOnly\"></span><div style=\"display: inline\"><span>from</span> <span ng-bind=\"reserve.operatingHours.start +\':00\'\"></span> <span>till</span> <span ng-bind=\"reserve.operatingHours.end +\':00\'\"></span></div></div></div><div class=card-body><div class=card-group ng-if=reserve.description><div class=card-group-value ng-bind=reserve.description></div></div><div class=card-group><div class=card-group-value><span class=\"card-group-color {{reserve.timeSlotLength}}\"></span> <span ng-bind=\"reserve.timeSlotLength | capitalize\"></span></div></div></div></div></div><div class=no-message ng-if=\"selectedItem.reservations.length === 0\"><i class=\"glyphicon glyphicon-calendar\"></i><h3 ng-bind=\"\'TEXT.NO_RESERVATIONS\' | translate\"></h3></div></div></uib-tab><uib-tab index=3 heading=Photo(s)><div class=\"form-group clearfix\"><button class=\"btn btn-info btn-sm | pull-right\" type=button ng-click=addMedia()><i class=\"fa fa-file-photo-o\" aria-hidden=true></i> Add media</button></div><div class=\"modal-gallery modal-gallery-booth\" ng-if=\"selectedItem.photos !== 0\"><div class=modal-gallery-item ng-repeat=\"photo in selectedItem.photos\"><img ng-src=\"{{photo.type === \'image\' ? photo.link : \'assets/images/360-icon.png\'}}\" alt=\"Booth media\"><!-- Media item actions --><div class=_actions><button class=\"btn btn-default btn-sm\" type=button ng-click=handlePreview(photo) ng-if=\"photo.type === \'image_360\'\" uib-tooltip=\"Preview image 360\" tooltip-placement=bottom tooltip-append-to-body=true><i class=\"fa fa-eye\" aria-hidden=true></i></button><!-- Delete --> <button class=\"btn btn-danger btn-sm\" type=button ng-click=removeMedia(photo) uib-tooltip=\"Delete photo\" tooltip-placement=bottom tooltip-append-to-body=true><i class=\"fa fa-trash\" aria-hidden=true></i></button></div></div><!-- <div class=\"modal-gallery-upload\" ng-if=\"uploadMediaLoading\">\n            <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\n          </div> --></div><div class=no-message ng-if=\"selectedItem.photos.length === 0\"><i class=\"fa fa-picture-o\" aria-hidden=true></i><h3 ng-bind=\"\'TEXT.noMedia\' | translate\"></h3></div></uib-tab></uib-tabset></div><hr><div class=clearfix><button class=\"btn btn-danger btn-sm | pull-right\" type=button ng-click=onRemoveObjectFromMap(selectedItem) ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></div></div>");
$templateCache.put("app/users/organizer/map/constructor/event-zone/event-zone.html","<div ng-controller=\"EventZoneController as vm\" ng-init=onInit()><div ng-if=zoneLoading class=selectedItemLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><div ng-if=!zoneLoading><h4 ng-bind=\"\'MAP_CONSTRUCTOR.EVENT_ZONE\' | translate\"></h4><div class=form-group ng-class=\"{ \'has-error\': isFieldRequired && !selectedItem.name }\"><label><span ng-bind=\"\'FORM.MAP_CONSTRUCTOR.NAME\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control type=text placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.NAME\' | translate}}\" name=selectedItemName required ng-model=selectedItem.name ng-change=onCheckValidation()><div class=help-block ng-if=\"isFieldRequired && !selectedItem.name\" role=alert ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div><div class=form-group ng-if=\"map.getType() === \'indoor\'\"><div class=\"row row-8\"><div class=col-xs-6><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.WIDTH\' | translate\"></label><input class=form-control type=number name=selectedItemWidth ng-model=selectedItem.width ng-change=selectedItem.resize()></div><div class=col-xs-6><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.HEIGHT\' | translate\"></label><input class=form-control type=number name=selectedItemHeight ng-model=selectedItem.height ng-change=selectedItem.resize()></div></div></div><div class=form-group><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.COLOR\' | translate\"></label><div class=\"input-group input-group-color\"><span class=input-group-addon><label><input type=color name=selectedItemColorPicker ng-model=selectedItemColor ng-change=\"onChangeSelectedItemColor(selectedItemColor, selectedItem)\"> <span style=\"background-color: {{selectedItemColor}}\"></span></label></span><input class=form-control type=text name=selectedItemColorText ng-model=selectedItemColor placeholder=\"Hex code\" ng-change=\"onChangeSelectedItemColor(selectedItemColor, selectedItem)\"></div></div><hr><div class=clearfix><button class=\"btn btn-danger btn-sm | pull-right\" type=button ng-click=\"onRemoveObjectFromMap(selectedItem, \'eventZones\')\" ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></div></div></div>");
$templateCache.put("app/users/organizer/map/constructor/overlay/overlay.html","<div ng-controller=\"OverlayController as vm\" ng-init=onInit()><div ng-if=overlayLoading class=selectedItemLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><div ng-if=!overlayLoading><h4 ng-bind=\"\'MAP_CONSTRUCTOR.OVERLAY\' | translate\"></h4><div class=form-group><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.NAME\' | translate\"></label><input class=form-control type=text name=indoorOverlayName placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.NAME\' | translate}}\" ng-model=selectedItem.name></div><div class=form-group><div class=\"row row-8\"><div class=col-xs-6><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.WIDTH\' | translate\"></label><input class=form-control type=number name=indoorOverlayWidth ng-model=selectedItem.width ng-change=selectedItem.resize()></div><div class=col-xs-6><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.HEIGHT\' | translate\"></label><input class=form-control type=number name=indoorOverlayWidth ng-model=selectedItem.height ng-change=selectedItem.resize()></div></div></div><div class=form-group><div class=\"row row-8\"><div class=col-xs-8><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.COLOR\' | translate\"></label><div class=\"input-group input-group-color\"><span class=input-group-addon><label><input type=color name=indoorOverlayColorPicker ng-model=selectedItemColor ng-change=onChangeSelectedItemColor(selectedItemColor)> <span style=\"background-color: {{selectedItemColor}}\"></span></label></span><input class=form-control type=text name=indoorOverlayColorText ng-model=selectedItemColor placeholder=\"Hex code\" readonly></div></div><div class=col-xs-4><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.OPACITY\' | translate\"></label><input class=form-control name=indoorOverlayOpacity type=number min=0 max=100 ng-model=selectedItem.opacity ng-change=selectedItem.setColor()> <span class=help-text style=\"font-size: 12px; font-style: italic\">(from 0 to 100)</span></div></div></div><div class=form-group ng-if=selectedItem.id><label class=\"btn btn-primary btn-sm\" ng-disabled=spinerLoader><input type=file name=backgroundImage id=backgroundImage ng-model=onChangeBackgroundImage on-file-changed=onChangeBackgroundImage accept=image/x-png,image/gif,image/jpeg,image/png,image/jpg,image/svg style=\"position: absolute;\n                top: -9999px; left: -9999px;\n                visibility: hidden;\n                opacity: 0\"> <span ng-if=\"!selectedItem.backgroundImage || (selectedItem.backgroundImage && selectedItem.backgroundImage.id === 0)\" ng-bind=\"\'BUTTON.ADD_BG_IMAGE\' | translate\"></span> <span ng-if=\"selectedItem.backgroundImage && selectedItem.backgroundImage.id\" ng-bind=\"\'BUTTON.REPLACE_BG_IMAGE\' | translate\"></span></label><div ng-if=spinerLoader style=\"width: 100%; margin-bottom: 8px; margin-top: 8px\"><div class=spiner></div></div><div ng-if=\"\n            selectedItem.backgroundImage &&\n            selectedItem.backgroundImage.id\n            \" style=\"margin-top: 16px;\n            position: relative\"><img style=\"display: block;\n              margin-right: auto;\n              margin-left: auto;\n              height: auto;\n              max-width:  100%\" ng-src={{selectedItem.backgroundImage.link}} alt=\"\"><!-- Remove Image --> <button class=\"btn btn-danger btn-sm\" style=\"margin-top: 16px\" ng-click=onRemoveBackgroundImage(selectedItem.backgroundImage) ng-bind=\"\'BUTTON.DELETE_BG_IMAGE\' | translate\"><!-- <i class=\"glyphicon glyphicon-trash\"></i> --></button></div></div></div></div>");
$templateCache.put("app/users/organizer/map/constructor/responsibility-zone/responsibility-zone.html","<div ng-controller=\"ResponsibilityZoneController as vm\" ng-init=onInit()><div ng-if=zoneLoading class=selectedItemLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><div ng-if=!zoneLoading><h4 ng-bind=\"\'MAP_CONSTRUCTOR.RESPONSIBILITY_ZONE\' | translate\"></h4><uib-tabset active=active><uib-tab index=0 heading=\"{{\'TAB.zone\' | translate}}\"><div class=form-group ng-class=\"{ \'has-error\': isFieldRequired && !selectedItem.name }\"><label><span ng-bind=\"\'FORM.MAP_CONSTRUCTOR.NAME\' | translate\"></span> <span>&nbsp;*</span></label><input class=form-control type=text placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.NAME\' | translate}}\" name=selectedItemName required ng-model=selectedItem.name ng-change=onCheckValidation()><div class=help-block ng-if=\"isFieldRequired && !selectedItem.name\" role=alert ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div><div class=form-group><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.EVENT_ZONE\' | translate\"></label><select class=form-control name=selectedItemZoneId ng-model=selectedItem.zoneId ng-options=\"zone.id as zone.name for zone in eventZones\"><option value=\"\" ng-bind=\"\'FORM.CHOOSE_EVENT_ZONE\' | translate\"></option></select></div><div class=form-group ng-class=\"{ \'has-error\': isFieldRequired && !selectedItem.description }\"><label><span ng-bind=\"\'FORM.MAP_CONSTRUCTOR.INSTRUCTIONS\' | translate\"></span> <span>&nbsp;*</span></label><textarea class=form-control name=selectedItemInstruction required ng-model=selectedItem.description rows=3 placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.INSTRUCTIONS\' | translate}}\" ng-change=onCheckValidation()></textarea><div class=help-block ng-if=\"isFieldRequired && !selectedItem.description\" role=alert ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div><div class=form-group ng-if=\"map.getType() === \'indoor\'\"><div class=\"row row-8\"><div class=col-xs-6><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.WIDTH\' | translate\"></label><input class=form-control type=number name=selectedItemWidth ng-model=selectedItem.width ng-change=selectedItem.resize()></div><div class=col-xs-6><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.HEIGHT\' | translate\"></label><input class=form-control type=number name=selectedItemHeight ng-model=selectedItem.height ng-change=selectedItem.resize()></div></div></div><div class=form-group><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.COLOR\' | translate\"></label><div class=\"input-group input-group-color\"><span class=input-group-addon><label><input type=color name=selectedItemColorPicker ng-model=selectedItemColor ng-change=\"onChangeSelectedItemColor(selectedItemColor, selectedItem)\"> <span style=\"background-color: {{selectedItemColor}}\"></span></label></span><input class=form-control type=text name=selectedItemColorText ng-model=selectedItemColor placeholder=\"Hex code\" ng-change=\"onChangeSelectedItemColor(selectedItemColor, selectedItem)\"></div></div></uib-tab><uib-tab index=1 heading=\"{{\'TAB.volunteers\' | translate}}\"><div class=form-group ng-class=\"{ \'has-error\': !selectedItem.volunteerData.request && isSubmited }\"><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.VOLUNTEER\' | translate\"></label><ui-select ng-model=selectedItem.volunteerData.request theme=bootstrap><ui-select-match placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.VOLUNTEER\' | translate}}\"><span ng-bind=$select.selected.volunteer.name></span></ui-select-match><ui-select-choices repeat=\"request in volunteerRequests | filter: { volunteer: { name: $select.search }} track by $index\"><span class=ui-select-title ng-bind=request.volunteer.name></span> <span class=ui-select-describe ng-bind=request.volunteer.email></span></ui-select-choices></ui-select><div class=help-block ng-if=\"!selectedItem.volunteerData.request && isSubmited\" ng-bind=\"\'FORM.VALIDATION.REQUIRED\' | translate\"></div></div><date-range start-date=selectedItem.volunteerData.startDate end-date=selectedItem.volunteerData.endDate start-time=selectedItem.volunteerData.startTime end-time=selectedItem.volunteerData.endTime is-valid=selectedItem.volunteerData.isValid event-validation=false></date-range><div class=form-group><button class=\"btn btn-primary\" type=button ng-disabled=!selectedItem.volunteerData.isValid ng-click=onAddVolunteerAssignmentsRequests() ng-bind=\"\'BUTTON.ADD\' | translate\"></button></div><div ng-if=\"selectedItem.volunteerAssignmentsRequests && selectedItem.volunteerAssignmentsRequests.length !== 0\"><ul class=list-commercial><li ng-repeat=\"data in selectedItem.volunteerAssignmentsRequests | orderBy: \'from\'\"><div class=_left><button class=\"btn btn-danger btn-sm\" type=button ng-click=onRemoveAssignmetVolunteer(data)><i class=\"fa fa-trash\" aria-hidden=true></i></button> <button class=\"btn btn-info btn-sm\" type=button ng-click=\"onEditAssignments(data, selectedItem.volunteerAssignmentsRequests)\"><i class=\"fa fa-edit\" aria-hidden=true></i></button></div><div class=_body><h3 class=name ng-bind=data.request.volunteer.name></h3><p class=email ng-bind=data.request.volunteer.email></p><div ng-if=\"data.from && data.to\"><div class=date ng-if=\"isSameDay(data.from, data.to)\"><span ng-bind=\"data.from | dateFormated\"></span>&nbsp;-&nbsp; <span ng-bind=\"data.to | timeFormated\"></span></div><div class=date ng-if=\"!isSameDay(data.from, data.to)\"><span ng-bind=\"data.from | dateFormated\"></span>&nbsp;-&nbsp; <span ng-bind=\"data.to | dateFormated\"></span></div></div></div></li></ul></div></uib-tab></uib-tabset><hr><div class=clearfix><button class=\"btn btn-danger btn-sm | pull-right\" type=button ng-click=\"onRemoveObjectFromMap(selectedItem, \'respZones\')\" ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></div></div></div>");
$templateCache.put("app/users/organizer/map/constructor/route/route.html","<div ng-controller=\"RouteController as vm\" ng-init=onInit()><div ng-if=routeLoading class=selectedItemLoading><i class=\"fa fa-spinner fa-spin\" aria-hidden=true></i></div><div ng-if=!routeLoading><h4 ng-bind=\"\'MAP_CONSTRUCTOR.ROUTE\' | translate\"></h4><div class=form-group><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.NAME\' | translate\"></label><input class=form-control type=text name=selectedItemName ng-model=selectedItem.name placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.NAME\' | translate}}\"></div><div class=form-group><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.EVENT_ZONE\' | translate\"></label><select class=form-control name=selectedItemZoneId ng-model=selectedItem.zoneId ng-options=\"zone.id as zone.name for zone in eventZones\"><option value=\"\" ng-bind=\"\'FORM.CHOOSE_EVENT_ZONE\' | translate\"></option></select></div><div class=form-group><label class=route ng-bind=\"\'FORM.MAP_CONSTRUCTOR.INSTRUCTIONS\' | translate\"></label><textarea class=form-control name=selectedItemInstruction placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.INSTRUCTIONS\' | translate}}\" ng-model=selectedItem.instructions></textarea></div><div class=\"row row-8\"><div class=col-xs-6><div class=form-group><label ng-bind=\"\'FORM.MAP_CONSTRUCTOR.COLOR\' | translate\"></label><div class=\"input-group input-group-color\"><span class=input-group-addon><label><input type=color name=selectedItemColorPicker ng-model=selectedItemColor ng-change=onChangeSelectedItemColor(selectedItemColor)> <span style=\"background-color: {{selectedItemColor}}\"></span></label></span><input class=form-control type=text name=selectedItemColorText ng-model=selectedItemColor placeholder=\"Hex code\" ng-change=onChangeSelectedItemColor(selectedItemColor)></div></div></div><div class=col-xs-6><div class=form-group><label ng-bind=\"\'Thickness\'\"></label><input class=form-control type=number name=selectedItemThickness min=0 ng-model=selectedItem.thickness ng-change=selectedItem.changeThickness(selectedItem.thickness)></div></div></div><div class=checkbox><label><input type=checkbox name=selectedItemPublic ng-model=selectedItem.public> <span ng-bind=\"\'TEXT.PUBLIC\' | translate\"></span></label></div><div class=checkbox><label><input type=checkbox name=selectedItemShowArrows ng-model=selectedItem.showArrows ng-change=selectedItem.changeArrowVisibility(selectedItem.showArrows)> <span ng-bind=\"\'Show arrow(s)\'\"></span></label></div><hr><div class=clearfix><button class=\"btn btn-danger btn-sm | pull-right\" type=button ng-click=\"onRemoveObjectFromMap(selectedItem, \'routes\')\" ng-bind=\"\'BUTTON.DELETE\' | translate\"></button></div></div></div>");
$templateCache.put("app/users/organizer/scavenger-hunt/check-in-points/form/form.html","<style>.pac-container { z-index: 9999 !important; }</style><form novalidate name=form ng-init=onInit() ng-submit=onSubmit()><div class=modal-header><h3 class=modal-title><span ng-bind=\"point.id ? \'Edit\' : \'Create\'\"></span> point</h3></div><div class=modal-body><div class=form-group><input class=\"form-control input-sm\" id=scavengerHuntFieldLocationForm type=text placeholder=Location style=\"margin-top: 10px; max-width: 160px; height: 28px\"><div id=scavengerHuntMapForm style=\"height: 300px\"></div><div class=\"help-block help-block-default\">( Click on map to set GPS data )</div></div><div class=form-group ng-class=\"{ \'has-error\': form.name.$invalid && form.$submitted }\"><label for=name>Name<span>&nbsp;*</span></label><input class=form-control type=text id=name name=name placeholder=Name required ng-model=point.name><div class=help-block ng-if=form.$submitted ng-messages=form.name.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=form-group><label for=name>Description</label><textarea maxlength=255 class=form-control type=text id=description name=description placeholder=Description ng-model=point.description></textarea></div><div class=form-group ng-class=\"{ \'has-error\': form.code.$invalid && form.$submitted }\"><label for=code>Code<span>&nbsp;*</span></label><input class=form-control type=text id=code name=code placeholder=Code required ng-model=point.code><div class=help-block ng-if=form.$submitted ng-messages=form.code.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=form-group ng-class=\"{ \'has-error\': form.lat.$invalid && form.$submitted }\"><label for=lat>Latitude<span>&nbsp;*</span></label><input class=form-control type=number id=lat name=lat placeholder=Latitude required ng-model=point.lat><div class=help-block ng-if=form.$submitted ng-messages=form.lat.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div><div class=col-xs-6><div class=form-group ng-class=\"{ \'has-error\': form.lng.$invalid && form.$submitted }\"><label for=lng>Longitude<span>&nbsp;*</span></label><input class=form-control type=number id=lng name=lng placeholder=Longitude required ng-model=point.lng><div class=help-block ng-if=form.$submitted ng-messages=form.lng.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div></div><div class=\"row row-16\"><div class=col-xs-6><div class=form-group ng-class=\"{ \'has-error\': form.checkInRadius.$invalid && form.$submitted }\"><label for=checkInRadius>Check in radius (meters) <span>&nbsp;*</span></label><input class=form-control type=number id=checkInRadius name=checkInRadius min=0 placeholder=Radius required ng-model=point.checkInRadius><div class=help-block ng-if=form.$submitted ng-messages=form.checkInRadius.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div><div class=col-xs-6><div class=form-group ng-class=\"{ \'has-error\': form.order.$invalid && form.$submitted }\"><label for=order>Order<span>&nbsp;*</span></label><input class=form-control type=number id=order name=order min=0 placeholder=Order required ng-model=point.order><div class=help-block ng-if=form.$submitted ng-messages=form.order.$error role=alert><div ng-message=required ng-bind=\"\'FORM.validation.required\' | translate\"></div><div ng-message=number ng-bind=\"\'FORM.validation.numeric\' | translate\"></div></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" type=button ng-click=onCancel()>Cancel</button> <button class=\"btn btn-primary btn-sm\" type=submit>Save</button></div></form>");
$templateCache.put("app/users/organizer/volunteers/log-book/form/form.html","<form novalidate name=form ng-init=onInit() ng-submit=handleSubmit()><div class=modal-header><h3 class=modal-title ng-bind=modalLabel></h3></div><div class=modal-body><div class=form-group ng-if=\"!resolveAcceptedRequest && (!resolveLog || (resolveLog && !resolveLog.id))\" ng-class=\"{\'has-error\': !log.volunteerRequest && formSubmitted}\"><label ng-bind=\"\'Search volunteer requests:&nbsp;*\'\"></label><ui-select ng-model=log.volunteerRequest theme=bootstrap name=volunteerRequest ng-required=true><ui-select-match placeholder=Search><span ng-bind=$select.selected.volunteer.name></span></ui-select-match><ui-select-choices repeat=\"request in volunteerRequests | filter: { volunteer: { name: $select.search }} track by $index\"><span class=ui-select-color ng-style=\"{\'background-color\': request.goodsCategory.preferences.color }\"></span> <span class=ui-select-title ng-bind=request.volunteer.name></span> <span class=ui-select-describe ng-bind=request.volunteer.email></span><!-- <div class=\"ui-select-describe\">\n            <b>Type:&nbsp;</b><span ng-bind=\"userType(request.volunteer.type)\"></span>\n          </div> --></ui-select-choices></ui-select><div class=help-block ng-if=\"!log.volunteerRequest && formSubmitted\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div><div class=\"row row-8\"><div class=col-xs-6><div class=\"form-group form-group-datepicker\" ng-class=\"{\'has-error\': formSubmitted && (form.checkInDate.$invalid || checkInDateIsGreaterThanCheckOut) }\"><label for=checkIndate>Check-In date<span ng-bind=\"\'&nbsp;*\'\"></span></label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default btn-sm\" type=button ng-click=onPopup1Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=\"form-control input-sm\" type=text name=checkInDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=log.checkInDate ng-change=\"handleCheckInOut(log.checkInDate, log.checkOutDate, log.checkInTime, log.checkOutTime)\" is-open=popup1.opened datepicker-options=checkInOutDateOptions show-button-bar=false ng-required=true></div><div class=help-block ng-if=\"formSubmitted && form.checkInDate.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div><div class=help-block ng-if=checkInDateIsGreaterThanCheckOut ng-bind=\"\'FORM.validation.startDateGreaterThanEnd\' | translate\"></div></div><div class=form-group ng-class=\"{\'has-error\': formSubmitted && (form.checkInTime.$invalid || checkInTimeIsGreaterThanCheckOut) }\"><label for=checkInTime>Check-In time<span ng-bind=\"\'&nbsp;*\'\"></span></label><div uib-timepicker class=timepicker-sm name=checkInTime ng-model=log.checkInTime ng-change=\"handleCheckInOut(log.checkInDate, log.checkOutDate, log.checkInTime, log.checkOutTime)\" ng-required=true show-meridian=true></div><div class=help-block ng-if=\"formSubmitted && form.checkInTime.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div><div class=help-block ng-if=\"formSubmitted && checkInTimeIsGreaterThanCheckOut\" ng-bind=\"\'FORM.validation.startTimeGreaterThanEnd\' | translate\"></div></div></div><div class=col-xs-6 ng-class=\"{\'has-error\': formSubmitted && (form.checkOutDate.$invalid || checkInDateIsGreaterThanCheckOut) }\"><div class=\"form-group form-group-datepicker\"><label for=checkIndate>Check-Out date<span ng-if=\"resolveRequired ? resolveRequired : log.checkOutTime\" ng-bind=\"\'&nbsp;*\'\"></span></label><div class=input-group><span class=\"input-group-btn date\"><button class=\"btn btn-default btn-sm\" type=button ng-click=onPopup2Open()><i class=\"glyphicon glyphicon-calendar\"></i></button> </span><input class=\"form-control input-sm\" type=text name=checkOutDate uib-datepicker-popup=\"{{ datepickerFormat }}\" ng-model=log.checkOutDate ng-change=\"handleCheckInOut(log.checkInDate, log.checkOutDate, log.checkInTime, log.checkOutTime)\" is-open=popup2.opened datepicker-options=checkInOutDateOptions show-button-bar=false ng-required=\"resolveRequired ? resolveRequired : log.checkOutTime\"></div><div class=help-block ng-if=\"formSubmitted && form.checkOutDate.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div><div class=form-group ng-class=\"{\'has-error\': formSubmitted && (form.checkOutTime.$invalid || checkInTimeIsGreaterThanCheckOut) }\"><label for=checkOutTime>Check-Out time<span ng-if=\"resolveRequired ? resolveRequired : log.checkOutDate\" ng-bind=\"\'&nbsp;*\'\"></span></label><div uib-timepicker class=timepicker-sm name=checkOutTime ng-model=log.checkOutTime ng-change=\"handleCheckInOut(log.checkInDate, log.checkOutDate, log.checkInTime, log.checkOutTime)\" show-meridian=true ng-required=\"resolveRequired ? resolveRequired : log.checkOutDate\"></div><div class=help-block ng-if=\"formSubmitted && form.checkOutTime.$invalid\" ng-bind=\"\'FORM.validation.required\' | translate\"></div></div></div></div><div class=form-group ng-if=\"checkCommentField(log.checkOutDate, log.checkOutTime)\"><label for=logComment>Comment</label><textarea class=form-control name=logComment id=logComment ng-model=resolveLog.comment rows=5></textarea></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=handleCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button> <button class=\"btn btn-primary\" type=submit ng-disabled=formLoading><i ng-if=formLoading class=\"fa fa-spinner fa-spin\" aria-hidden=true style=\"margin-right: 8px\"></i> <span ng-bind=\"\'BUTTON.SUBMIT\' | translate\"></span></button></div></form>");
$templateCache.put("app/users/organizer/map/constructor/booth/modal-assignments/modal-assignments.html","<div ng-init=onInit()><div class=modal-header><h3 class=modal-title ng-bind=assignment.user.name></h3><p class=modal-subtitle ng-bind=assignment.user.email></p></div><div class=modal-body><date-range start-date=assignment.startDate end-date=assignment.endDate start-time=assignment.startTime end-time=assignment.endTime is-valid=assignment.isValid event-validation=true></date-range><div class=form-group ng-if=showNotes><label for=assignmentNotes ng-bind=\"\'FORM.MAP_CONSTRUCTOR.NOTES\' | translate\"></label><textarea class=\"form-control input-sm\" name=assignmentNotes id=assignmentNotes rows=3 placeholder=\"{{\'FORM.MAP_CONSTRUCTOR.NOTES\' | translate}}\" ng-model=assignment.notes></textarea></div></div><div class=modal-footer><button class=\"btn btn-primary btn-sm\" type=button role=button ng-click=onSave() ng-bind=\"\'BUTTON.save\' | translate\" ng-disabled=!assignment.isValid></button> <button class=\"btn btn-default btn-sm\" type=button role=button ng-click=onCancel() ng-bind=\"\'BUTTON.cancel\' | translate\"></button></div></div>");
$templateCache.put("app/app.html","<div class=wrapper><nav-bar></nav-bar><div class=main ui-view></div><foot-bar></foot-bar></div>");}]);